import { T, Badge, badgeColors, Card, Btn, Modal } from "./customerPresentation/atoms";
export { BADGE_SOFT, BADGE_HEAVY } from "./customerPresentation/atoms";
import React, { useState, useCallback, useMemo, useEffect, useLayoutEffect, useRef } from "react";
import AutoRenewOffer, { AutoRenewCompletedRow } from "./AutoRenewOffer";
import AutoRenewRequestManagement, { useAutoRenewManagementCount, requestCountLabel } from "./AutoRenewRequestManagement";
import { createPortal } from "react-dom";
import {
  BarChart, Bar, PieChart, Pie, Cell,
  XAxis, YAxis, Tooltip, Legend, ResponsiveContainer,
} from "recharts";
import { fetchLatestReport, fetchScans, archiveReport, restoreReport, fetchArchivedReports, unpublishReport, fetchReviewQueue, fetchClients, fetchClientInfo, setOverride, clearOverride, fetchNotes, createNote, updateNote, deleteNote, createTicket, fetchSessionFocus, createSessionFocusItem, updateSessionFocusItem, deleteSessionFocusItem, reorderSessionFocus, fetchReviews, createReview, deleteReview, fetchPendingStatus, fetchPendingScan, fetchPendingList, publishPendingScan, rejectPendingScan, listPackages, previewPackage, applyPackage, removePackage, fetchTicketDashboard, createL3Ticket, fetchCompanyDomains, fetchAccessList, fetchUpgradeStatus, addAccessMember, setAccessRole, setAccessPrimary, setAccessExecutive, fetchMe, disableAccessMember, approveAccessRequest, denyAccessRequest, fetchAdminPendingAccess, fetchAdminAccessLifecycle, fetchAdminLoginSummary, fetchAdminScanSummary, fetchReviewOps, fetchCustomerOperationsNotes, createCustomerOperationsNote, markCustomerOperationsNoteHandled, fetchWeeklyReport, fetchCustomerManagement, fetchReviewCadence, fetchAllowanceAdjustments, previewAllowanceAdjustment, createAllowanceAdjustment, fetchAllowanceTransition, previewAllowanceTransition, createAllowanceTransition, fetchContractChangeContext, fetchContractChangeReceipt, fetchContractChangeOperations, fetchContractChangeOperationDetail, previewContractChange, confirmContractChange, fetchRenewalPreview, scheduleRenewal, activateRenewal, voidRenewal, rescindRenewal, setReviewStatus, updateScanTracking, fetchScanTrackingNotes, fetchScanPasskeys, startScanAssessment, fetchScanStartPreflight, fetchAdminScanJourney, fetchAdminScanJourneys, fetchAdminScanJourneyRecords, fetchAdminScanJourneyRecord, previewAdminScanJourneyAction, executeAdminScanJourneyAction, fetchAdminScanJourneyActionStatus, previewAdminScanJourneyRecovery, executeAdminScanJourneyRecovery, fetchScanRuns, fetchScanIncomingStatus, fetchScanResult, sendScanToScoring, startScanPrereqCheck, fetchScanStatus, fetchScanPrereqResult, resolvePrereqAckRunId, fetchCustomerScanState, requestCustomerScan, startCustomerPrereqCheck, startCustomerScan, fetchCustomerPrereqResult, fetchCustomerScanRuns, latestCompletedAssessmentUtc, classifyNoDataScanState, fetchScanAdjudication, fetchReviewCompletionContext, recordReviewCompletion, getPendingReviewCompletionDate, setSurveySent, fetchLicenseInventory, fetchCustomerLicensing, fetchReviewBooking, requestReviewBooking, requestReviewBookingAction, fetchOnboardingBooking, requestOnboardingBooking } from "../utils/api";
import { previewContractChangeCorrection, confirmContractChangeCorrection, previewContractChangePredecessor, confirmContractChangePredecessor } from "../utils/api";
import { CONTRACT_REFERENCE_FIELDS, hasRecordedSourceReference, requiredContractReferences, missingContractReferences, missingReferencesMessage, contractChangeErrorText, refreshFailureText } from "../utils/contractChangeReferences";
import usePostureComparison from "../hooks/usePostureComparison";
import FreshserviceExportControl from "./FreshserviceExportControl";
import { fetchFreshserviceGroupDiscovery, requestFreshserviceGroupDiscovery, downloadFreshserviceGroupDiscovery } from "../utils/api";
import { fmtInstant, fmtDateOnly, isDateOnlyFuture, localDateString } from "../utils/dates";
import { deriveContactRows, filterSortContactRows, contactCounts as computeContactCounts, usableContactEmails as computeUsableEmails, rowHasAnyGap } from "../utils/adminContacts";
import { filterByBucket, searchRows as searchReviewRows, cycleLabel, lastReviewLabel, workflowLabel, rangeEmptyState, typeBreakdown, completionTypeLabel, reviewTypeDisplayLabel, REVIEW_TYPE_STANDARD_LABEL, REVIEW_TYPE_RESCHEDULE_LABEL, REVIEW_TYPE_PICKER_HEADING, filterCompletions, sortCompletions, surveySentFirst, isSurveySent, takesSurvey, needsSurveyAction, awaitingSurveyCount, applySurveyWrite, engineerCards, SEVERITY_BANDS, bandRangeLabel, justPastDueRangeLabel, JUST_PAST_DUE, JUST_PAST_DUE_LABEL, horizonCards, statusOptions, statusNeedsDate, statusTakesDate, statusChangePreview, followUpWindowCopy, applyStatusWrite, BUCKET_LABELS, skipRequesterOptions, skipRequesterValue, skipSubmitBlocked, skipCostCopy, applySkipVisibility, yearFullReason, SKIP_REQUESTED_BY_MAX, SKIP_OTHER, SKIP_CAUTION, readinessPillForRow, readinessTitle, readinessScanDate, filterReadyOnly, isBlockingSuppressed, suppressedTotal, filterSuppressed, filterActionable, blockingLabel, rebookLabel, contractExpiredCount, filterContractExpired, contractCellLabel, contractCellTitle, unrecordedCount, filterUnrecorded, unrecordedBadge, unrecordedTitle, sortReviewRows, rowSortOptions, loadRowSort, saveRowSort, pendingStatusValue, statusPickUpdate, followUpProgressLabel, dayCountTitle,
  filterScheduling,
  schedulingTiming,
  workflowTone,
  workflowDateLine,
  sortSchedulingUrgency,
  sortBankedOutreach,
  filterSchedulingUniverse,
  schedulingTotal,
  schedulingUniverseTotal,
  contractDisplayLabel,
  SCHEDULING_DEFAULT_FILTER, SCHEDULING_FILTERS,
  // Scheduling filter chips (display only, 2026-08-13). Membership comes
  // from readinessPillForRow's `key` — the same call the Readiness cell
  // renders — so a chip's rows are always the rows wearing its pill.
  CHIP_GROUP_READINESS, CHIP_GROUP_METHOD, CHIP_GROUP_ALLOWANCE,
  EMPTY_SCHEDULING_CHIPS,
  schedulingChipCounts, schedulingChipCards, filterSchedulingChips,
  bookingChipCards, filterBookingChip, hasOpenRequest,
  toggleSchedulingChip, anySchedulingChipActive, readinessChipLabel,
  allowanceModelChipLabel, loadSchedulingChips, saveSchedulingChips,
  SCAN_METHOD_CHIP_UNCLASSIFIED,
  // Scan Queue (display only): the membership rule, the three pills' source
  // lists (each already oldest-first), the tab-badge sum and the refusal
  // words all live in reviewOps so this file states none of them.
  // isWithEngineers still backs the Scheduling "with engineers" chip below.
  isWithEngineers, WITH_ENGINEERS_LABEL, workflowAgeLabel,
  scanQueueBuckets, scanQueueBadgeTotal, autoScanRefusalLabel,
  // Customer Management (read-only): every predicate, the renewal state and
  // the row order are SERVER-derived; these are presentation only.
  problemRowCount, filterProblemRows, problemTags, problemTagTone,
  renewalPill, renewalTitle, renewalWorkItem, contractActionCards,
  contractActionCounts, filterContractActionRows, termRangeLabel, termTitle, autoRenewLabel,
  managementCycleLabel, managementCycleTitle, contractStatusTone, MGMT_PHASE_LABELS,
  MGMT_FACETS, MGMT_FACET_STATUS, MGMT_FACET_TIER, MGMT_FACET_AUTORENEW,
  MGMT_FACET_PHASE,
  managementFacetCounts, managementFacetCards, filterManagementFacets,
  managementSortOptions, coerceManagementSort, sortManagementRows,
  MGMT_SORT_VIEW, CUSTOMER_MANAGER_LABEL,
} from "../utils/reviewOps";
import { SCAN_RUN_KIND, SCAN_RUN_KIND_LABELS, SCAN_RUN_KIND_HINTS, scanRunKind, scanRunDisplayState, countScanRunKinds, filterScanRunsByKind } from "../utils/scanRunKind";
import useUserContext from "../auth/useUserContext";
import useCspOpportunities from "../hooks/useCspOpportunities";
import { CspOverviewPrompt, CspLicensingPanel } from "./CspCostOptimization";
import CustomerComparisonCard from "./CustomerComparisonCard";
import MaturityCard from "./MaturityCard";
import { getMaturityLevel } from "./maturity";
import ServiceInquiryModal from "./ServiceInquiryModal";
import { DownloadReportButton } from "./ExecutiveReport";
import { ExportFindingsButton } from "./FindingsExport";
import useProductAnalytics from "../analytics/useProductAnalytics";
import { ScanMethodChip, ScanMethodOptionTag } from "./ScanMethodLabel";
import { exactScoringBaseline, publicationScansMatch } from "./regressionProvenance";
import { projectReportRecommendations } from "./customerPresentation/projectRecommendations";
import { SettingDetailPanel as SharedSettingDetailPanel, RecsPage as SharedRecsPage, QueuePage as SharedQueuePage } from "./customerPresentation/Recommendations";
import { LicenseTable, licenseStatusLabel, licenseBarPct, sortLicenseProducts } from "./customerPresentation/LicenseTable";
import TicketTable from "./customerPresentation/TicketTable";
export { LICENSE_STATUS_LABELS, licenseStatusLabel, licenseBarPct, sortLicenseProducts } from "./customerPresentation/LicenseTable";
import { computeComposition, notAssessedOverriddenLine, OVERRIDE_SLICE_COLORS } from "./composition";
import { isQuickWinRating } from "./findingRatings";
import {
  countsAsOpen,
  countsAsAddressed,
} from "./overrideStatus";
import {
  SHOW_UPGRADE_TO_CUSTOMERS,
  SHOW_SCAN_CARD_TO_CUSTOMERS,
  SURFACE_TITLE,
  ENTRY_COPY,
  WIZARD_COPY,
  STEP_CONTENT,
  VALUE_COPY,
  CLEANUP_COPY,
  GUIDE_PDFS,
  GUIDE_PDF_NOTE,
  TROUBLESHOOTING_TABLE,
  SECURITY_FAQ,
  SECURITY_FAQ_INTRO,
  ROLES_ACCESS_TABLE,
  ROLES_ACCESS_PIM_NOTE,
  PATRIOT_ACCESS_TABLE,
  PATRIOT_ACCESS_TABLE_TITLE,
  PATH_CHOICE_COPY,
  WIZARD_PATHS,
  pathSteps,
  emptyUpgradeChecklist,
  completionReady,
  HELP_REASONS,
  HELP_SUBJECT,
  needHelpTicketBody,
} from "./upgradeWizardContent";

/* ═══════════════════════════════════════════════════════════════
   SecureShield 365 — Client Dashboard v7.1
   React + Recharts conversion of the v7 HTML mockup.
   6 pages: Overview, Next Session Focus, Benchmarks,
            Recommendations, Azure SecureAudit, Support & Hours
   ═══════════════════════════════════════════════════════════════ */

/* ── API ── */
// Optional observation callbacks are never allowed to alter portal actions.
const observeProductAnalytics = (callback, action) => {
  try { callback?.(action); } catch { /* analytics is observational only */ }
};

// Settings-path ticket payload — mirrors the recommendation flyout's info so
// the agent sees what the customer saw. overrideStatus is "{label} — {reason}"
// (empty when no active override); the caller resolves it from settingDetails
// since overrides don't live on the rec object.
function apiCreateTicket(rec, clientId, requesterEmail = "", notes = "", attribution = "", overrideStatus = "", settingNotes = "") {
  return createTicket({
    client_id: clientId || "acme-bank",
    requester_email: requesterEmail || "",
    // Pool tag — parity with the grouped path. Without it, single-rec
    // settings tickets carried no patriot_service in Freshservice and never
    // matched the dashboard's "SecureShield 365" pool query.
    patriot_service: "SecureShield 365",
    setting_num: rec.id,
    setting_description: rec.name,
    severity:
      rec.sev === "critical"
        ? "Critical"
        : rec.sev === "high"
        ? "High Security"
        : "Medium Security",
    workload: rec.cat,
    grouping: rec.cat,
    // Flyout's "What We Found" / "Patriot Recommends" sources — these were
    // sent as empty strings for months (the flyout had the data all along).
    current_value: rec.result_text || rec.actual_value || "",
    recommended_value: rec.recommended_value || "",
    // The rec's own Patriot recommendation text; customer note travels
    // separately in customer_notes (its own labeled section in the body).
    recommendation_text: rec.audit_recommendation || "",
    result: rec.result || "",
    security_domain: rec.category || "",
    license: rec.license || "",
    complexity: rec.difficulty || "",
    first_flagged: fmtInstant(rec.first_identified, { month: "long", day: "numeric", year: "numeric" }, ""),
    what_it_does: rec.patriot_advisor_value || "",
    where_to_change: Array.isArray(rec.remediation_steps) ? rec.remediation_steps.join(" › ") : "",
    reference_doc_url: rec.help_url || rec.remediation_url || "",
    override_status: overrideStatus || "",
    customer_notes: [notes, attribution].filter(Boolean).join("\n\n"),
    // Customer-authored setting notes, pre-formatted by the caller — a
    // snapshot at filing time (portal notes are living state).
    setting_notes: settingNotes || "",
  });
}

// Mirror api.js escapeHtml (module-local there, not exported) for building the
// grouped Settings ticket body from user/setting free-text.
function escapeHtmlLocal(s) {
  return String(s ?? "")
    .replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;").replace(/'/g, "&#39;");
}

// Severity label the backend maps to a priority via PRIORITY_MAP. MIRRORS the
// single-rec apiCreateTicket mapping exactly — do not invent a new mapping.
// (critical -> "Critical", high -> "High Security", else -> "Medium Security".)
// A group's HIGHEST severity wins.
/* Review Complete cycle warnings. The server returns a LIST — a press can
   trip more than one at once (a compressed pace AND a date past the
   contract end); a single slot dropped whichever fired second
   (ADR-0086, docs/plans/SPEC-review-cycle-term-model.md Rule 4).

   Reads `warnings` and falls back to the older single `interval_warning`.
   The fallback is not defensive habit: the frontend deploys on merge to
   main while the backend is published by hand, so the two are briefly
   out of step in BOTH directions and the dialog has to render whichever
   shape arrives. Remove the fallback once the backend carrying
   `warnings` is live. */
function cycleWarnings(result) {
  if (!result) return [];
  if (Array.isArray(result.warnings)) return result.warnings;
  return result.interval_warning ? [result.interval_warning] : [];
}

const _SEV_RANK = { critical: 3, high: 2 };
function groupHighestSeverityLabel(group) {
  let best = 0; // 0 => Medium Security bucket (the else case)
  for (const r of group) best = Math.max(best, _SEV_RANK[r.sev] || 0);
  return best === 3 ? "Critical" : best === 2 ? "High Security" : "Medium Security";
}

// Group a flat rec list by Product (r.cat, from s.workload). Empty/missing -> "Other".
// Returns an array of [product, recs[]] preserving encounter order.
function groupRecsByProduct(recs) {
  const groups = new Map();
  for (const r of recs) {
    const product = (r.cat && String(r.cat).trim()) || "Other";
    if (!groups.has(product)) groups.set(product, []);
    groups.get(product).push(r);
  }
  return Array.from(groups.entries());
}

// Scheduling All receives this compact projection from the review-ops read.
// Keep the closed shape in one place: the icon and any control which narrows
// by it must agree about what pink means.
export function normalizeOperationsNotesIcon(note) {
  if (!note || typeof note !== "object" || Array.isArray(note)) {
    return { state:"unavailable" };
  }
  const keys = Object.keys(note).sort().join(",");
  if (note.state === "unavailable" && keys === "state") {
    return { state:note.state };
  }
  if (!['gray', 'pink'].includes(note.state)
      || keys !== "state,unresolved_count"
      || !Number.isInteger(note.unresolved_count) || note.unresolved_count < 0) {
    return { state:"unavailable" };
  }
  if ((note.state === "gray" && note.unresolved_count !== 0)
      || (note.state === "pink" && note.unresolved_count < 1)) return { state:"unavailable" };
  return note;
}

export const StatusOverrideOptionButton = ({ option, active, onToggle }) => (
  <button type="button" onClick={onToggle}
    aria-pressed={active}
    style={{
      display:"block", width:"100%", textAlign:"left", padding:"10px 12px",
      marginTop:8, borderRadius:8,
      border:`1px solid ${active ? "rgba(168,85,247,0.55)" : T.border}`,
      background: active ? "rgba(168,85,247,0.18)" : "rgba(255,255,255,0.03)",
      cursor:"pointer", fontFamily:"inherit", color:T.text,
    }}>
    <div style={{ display:"flex", alignItems:"center", gap:8 }}>
      <span style={{
        width:16, height:16, borderRadius:"50%",
        border:`2px solid ${active ? "#DDD6FE" : T.muted}`,
        background: active ? "#DDD6FE" : "transparent",
        display:"inline-grid", placeItems:"center", flexShrink:0,
        color:"#1F2937", fontSize:11, fontWeight:800, lineHeight:1,
      }} aria-hidden="true">{active ? "✓" : ""}</span>
      <span style={{ fontSize:13, fontWeight:600 }}>{option.label}</span>
    </div>
    <div style={{ marginLeft:22, fontSize:11, color:T.muted, marginTop:2 }}>
      {option.helper}
    </div>
  </button>
);

/* THE ONE STATEMENT of the Readiness pill's tone→colour mapping.
 *
 * It lived inline in the Readiness cell until 2026-08-13, when the filter
 * chips needed the same answer for their dots. A chip whose dot came from a
 * second copy of this object would drift from the pill it stands for the
 * first time a tone was added — and the failure would be SILENT, because an
 * unmapped tone falls back to muted rather than throwing: the chip would
 * simply be grey. That fallback is exactly why #552 had to add `pink:` here
 * in the same commit as the Reschedule pill. One object, two readers, zero
 * new tone values: every entry is a T token that was already on screen.
 * Customer booked (2026-08-23) deliberately keeps its muted tone here for
 * the shared Booked chip; the table cell alone adds its source-only slate fill.
 *
 * Unmapped tones fall back to T.muted at the call site, exactly as before. */
const READINESS_TONE_COLOR = {
  green: T.green, blue: T.blue, yellow: T.yellow, orange: T.orange,
  red: T.red, muted: T.muted, pink: T.pink,
};
const readinessToneColor = (tone) => READINESS_TONE_COLOR[tone] || T.muted;

// Override disposition keys → human label + accent color. Matches the colors used
// by the per-setting status badges (teal = Customer Managed Solution, etc.).
const DISPOSITION_LABELS = {
  planned: "Planned",
  risk_accepted: "Risk Accepted",
  customer_managed_solution: "Customer Managed",
  customer_remediated: "Customer Remediated",
};
const DISPOSITION_COLORS = {
  planned: "#818CF8",
  risk_accepted: "#FBBF24",
  customer_managed_solution: "#14B8A6",
  customer_remediated: "#53c46d",
};
const dispositionLabel = (key) => DISPOSITION_LABELS[key] || key || "—";
const dispositionColor = (key) => DISPOSITION_COLORS[key] || "#a8bddc";

/* ── Date rendering: all formatters live in utils/dates.js. INSTANT fields
   (scan/note/login/ticket timestamps) render via fmtInstant; DATE-ONLY fields
   (reviewed_on, revisit_by, next/last audit dates — Dataverse DateOnly
   columns, returned as "YYYY-MM-DDT00:00:00Z") render via fmtDateOnly, which
   never does timezone math. Routing a field through the wrong one is the
   day-off bug (fc29838, regressed) — see utils/dates.js. ── */

// Short "May 12" formatter used by the Review History UI. reviewed_on and
// revisit_by are DATE-ONLY columns — the previous local-parts guard here
// only caught bare "YYYY-MM-DD" and let Dataverse's "…T00:00:00Z" wire shape
// fall through to new Date() (the regression).
const formatReviewDate = (value) => fmtDateOnly(value, { month: "short", day: "numeric" }, "");

// Monotonic id for optimistic provisional rows (reviews / session-focus items)
// that exist only until the server-created row replaces them. Namespaced so it
// never collides with a real Dataverse row id.
let _provisionalSeq = 0;
const nextTempId = () => `temp-${++_provisionalSeq}`;

/* ── DATA ── */
const QTR_LABELS = [
  "Y2 Q1 — May 2025",
  "Y2 Q2 — Aug 2025",
  "Y2 Q3 — Nov 2025",
  "Y2 Q4 — Feb 2026",
];
const QTR_SHORT = ["Y2Q1", "Y2Q2", "Y2Q3", "Y2Q4"];

const QD = [
  { score: 62, total: 142, high: 45, med: 97, impl: 38, defer: 8, newS: 0, crit: 6 },
  { score: 67, total: 130, high: 40, med: 90, impl: 56, defer: 5, newS: 6, crit: 5 },
  { score: 70, total: 118, high: 36, med: 82, impl: 72, defer: 3, newS: 8, crit: 4 },
  { score: 73, total: 110, high: 32, med: 79, impl: 88, defer: 2, newS: 12, crit: 4 },
];

const SCORES = [62, 67, 70, 73];
const TOTAL_RECS = [142, 130, 118, 110];
const IMPLEMENTED = [38, 56, 72, 88];

// MOCK FALLBACK — overridden by real `scansChartData` derived from /api/clients/{slug}/scans.
// Kept temporarily so the chart renders during loading state.
const TREND_MOCK_FALLBACK = QTR_SHORT.map((q, i) => ({
  q,
  Score: SCORES[i],
  Satisfied: IMPLEMENTED[i],
  Open: TOTAL_RECS[i],
}));
const TREND = TREND_MOCK_FALLBACK;

// Publication-state `scan_id` is opaque.  Keep the raw path only as the
// bounded legacy compatibility fallback while state is absent.
const scanSelectionKey = (scan) => scan?.scan_id || scan?.scored_path || null;
const newOperationRequestId = () => {
  if (!globalThis.crypto?.getRandomValues) throw new Error("A secure request ID is unavailable. Reload and try again.");
  if (globalThis.crypto.randomUUID) return globalThis.crypto.randomUUID();
  return Array.from(globalThis.crypto.getRandomValues(new Uint8Array(16)), value => value.toString(16).padStart(2, "0")).join("");
};

/**
 * PastScansDropdown — top-right header control for time-traveling between
 * historical scans. Styled to match the dashboard header date pills.
 *
 * Props:
 *   scans         — eligible scans (newest-first), each with opaque scan_id / score_pct / executed_at
 *                   (+ collection_method when known — ADR-0084 side-car / envelope)
 *   currentScanId — null = typed current; otherwise opaque scan_id
 *   onPickScan    — callback(scanIdOrNull)
 *   T             — theme colors
 *   method        — collection_method of the report being DISPLAYED (from the
 *                   report envelope, not scans[0]: a pending scan can sit at
 *                   scans[0] without being the published one). Drives the
 *                   ADR-0084 chip beside the button; absent renders nothing.
 */
const PastScansDropdown = ({ scans, currentScanId, onPickScan, T, method }) => {
  const [open, setOpen] = React.useState(false);
  const ref = React.useRef(null);

  // Close on outside click while the panel is open.
  React.useEffect(() => {
    if (!open) return;
    const handleClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, [open]);

  // This control doubles as the "Last full scan" date indicator, so it renders
  // whenever there's at least one scan (not only when time-travel is possible).
  if (!scans || scans.length === 0) return null;

  // Scan timestamps are INSTANTS — local rendering is correct.
  const fmtFullDate = (iso) => fmtInstant(iso, { month: "long", day: "numeric", year: "numeric" });
  const fmtScore = (v) => (typeof v === "number" ? `${Math.round(v)}%` : "—");

  // State ordering is chronology, not current-first: an intentionally older
  // current report must not be silently promoted ahead of eligible history.
  const current = scans.find(s => s.current) || null;
  const selected = currentScanId ? scans.find(s => scanSelectionKey(s) === currentScanId) : null;

  const buttonLabel = currentScanId == null
    ? (current ? `Last full scan: ${fmtFullDate(current.executed_at || current.scored_at)} ▼` : "Viewing scan ▼")
    : selected
      ? `Viewing scan: ${fmtFullDate(selected.executed_at || selected.scored_at)} ▼`
      : "Viewing scan ▼";

  const pick = (val) => { onPickScan && onPickScan(val); setOpen(false); };

  const rowStyle = (isSel) => ({
    display: "flex", alignItems: "center", justifyContent: "space-between", gap: 16,
    padding: "8px 12px", cursor: "pointer", fontSize: 12,
    background: isSel ? "rgba(68,166,255,0.14)" : "transparent",
    color: T.text, whiteSpace: "nowrap",
  });

  return (
    <div ref={ref} style={{ position: "relative", display: "inline-flex", flexDirection: "column", gap: 2 }}>
      <button
        onClick={() => setOpen(o => !o)}
        style={{
          fontSize: 11, color: T.muted, padding: "4px 10px", borderRadius: 6,
          border: `1px solid ${T.border}`, background: "rgba(255,255,255,0.02)",
          cursor: "pointer", fontFamily: "inherit", fontWeight: 600,
        }}
      >
        {buttonLabel}
      </button>
      {/* ADR-0084: how the DISPLAYED scan's data was collected. IN-FLOW
          below the button, deliberately (operator decision 2026-08-05):
          the previous absolute overlay landed on the Archived scans
          control at some widths. The accepted cost is the header row
          growing ~7-9px (36px logo vs the ~45px button+caption stack) —
          identical at every width, since the stack's height is fixed-px
          and independent of wrapping. The column's default stretch sizes
          the caption to the button's exact width; textAlign centers the
          copy. The open panel (top: 100% + 6px) opens below the caption.
          Absent method renders nothing and the stack collapses back to
          the bare button. See ScanMethodLabel.js. */}
      <ScanMethodChip method={method} T={T} />
      {open && (
        <div style={{
          position: "absolute", top: "calc(100% + 6px)", right: 0, zIndex: 60,
          minWidth: 260, background: T.panel, border: `1px solid ${T.border}`,
          borderRadius: 10, boxShadow: "0 12px 30px rgba(0,0,0,0.35)",
          overflow: "hidden auto", maxHeight: 360,
        }}>
          {current && <div
            onClick={() => pick(null)}
            style={{ ...rowStyle(currentScanId == null), borderBottom: `1px solid ${T.border}` }}
            onMouseEnter={e => { if (currentScanId != null) e.currentTarget.style.background = "rgba(255,255,255,0.05)"; }}
            onMouseLeave={e => { if (currentScanId != null) e.currentTarget.style.background = "transparent"; }}
          >
            <span>{currentScanId == null ? "✓ " : ""}Latest scan</span>
            <span style={{ color: T.muted, display: "inline-flex", alignItems: "center", gap: 8 }}>
              {fmtFullDate(current?.executed_at || current?.scored_at)}
              <ScanMethodOptionTag method={current?.collection_method} T={T} />
              · {fmtScore(current?.score_pct)}
            </span>
          </div>}
          {scans.map((s) => {
            const isSel = currentScanId === scanSelectionKey(s);
            return (
              <div
                key={scanSelectionKey(s)}
                onClick={() => pick(scanSelectionKey(s))}
                style={rowStyle(isSel)}
                onMouseEnter={e => { if (!isSel) e.currentTarget.style.background = "rgba(255,255,255,0.05)"; }}
                onMouseLeave={e => { if (!isSel) e.currentTarget.style.background = "transparent"; }}
              >
                <span style={{ display: "inline-flex", alignItems: "center", gap: 8 }}>
                  {isSel ? "✓ " : ""}{fmtFullDate(s.executed_at || s.scored_at)}
                  {/* ADR-0084: method beside the date; absent renders nothing */}
                  <ScanMethodOptionTag method={s.collection_method} T={T} />
                </span>
                <span style={{ color: T.muted }}>{fmtScore(s.score_pct)}</span>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

const ScanLifecycleControls = ({
  slug,
  scans,
  currentScanId,
  publishedScoredAt,
  pendingReport,
  adjustedScore,
  isPatriot,
  deliveryMode,
  onChanged,
  T,
}) => {
  const [dialog, setDialog] = useState(null);
  const [reason, setReason] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);
  const [warning, setWarning] = useState(null);
  const [operationRequestId, setOperationRequestId] = useState(null);
  const retainedOperationIds = useRef(new Map());

  if (!isPatriot || deliveryMode) return null;

  const viewedScan = pendingReport?._pending ? { ...pendingReport._pending, current: false } : currentScanId == null
    ? scans.find(scan => scan.current)
    : scans.find(scan => scanSelectionKey(scan) === currentScanId);
  const isViewingPublished = !!viewedScan && !!viewedScan.current;
  const evidence = viewedScan || {};
  const evidenceDate = evidence.executed_at || evidence.scored_at;
  const close = () => {
    if (busy) return;
    setDialog(null);
    setReason("");
    setError(null);
    setOperationRequestId(null);
  };
  const open = (mode) => {
    setDialog(mode);
    setReason("");
    setError(null);
    const key = `${slug}|${mode}|${viewedScan?.identity?.scored_path}|${viewedScan?.identity?.sha256}`;
    if (!retainedOperationIds.current.has(key)) retainedOperationIds.current.set(key, newOperationRequestId());
    setOperationRequestId(retainedOperationIds.current.get(key));
  };

  const submit = async () => {
    if (dialog === "blocked") {
      close();
      return;
    }
    setBusy(true);
    setError(null);
    try {
      const result = dialog === "archive"
        ? await archiveReport(slug, viewedScan.scored_path, reason, operationRequestId, viewedScan.identity)
        : await unpublishReport(slug, reason, operationRequestId, viewedScan?.publication_id || null, viewedScan?.identity);
      if (result.audit_recorded === false) {
        setWarning("Done, but the audit row was not recorded — note it manually or retry.");
      } else {
        setWarning(null);
      }
      setDialog(null);
      setReason("");
      retainedOperationIds.current.delete(`${slug}|${dialog}|${viewedScan?.identity?.scored_path}|${viewedScan?.identity?.sha256}`);
      setOperationRequestId(null);
      onChanged(dialog);
    } catch (err) {
      setError(err.message || "Action failed");
    } finally {
      setBusy(false);
    }
  };

  const percent = (value) => typeof value === "number"
    ? `${Math.round(value * 10) / 10}%`
    : "—";
  const evidenceBlock = (
    <div style={{ display:"grid", gap:5, padding:"10px 12px", border:`1px solid ${T.border}`, borderRadius:10, background:"rgba(255,255,255,0.03)" }}>
      <div>Date: {evidenceDate ? fmtInstant(evidenceDate, { month:"long", day:"numeric", year:"numeric" }) : "—"}</div>
      <div>SS: {percent(evidence.score_pct)} · RA: {viewedScan && typeof adjustedScore === "number" ? percent(adjustedScore) : "—"}</div>
      <div>Passed: {evidence.passed ?? "—"} · Failed: {evidence.failed ?? "—"}</div>
    </div>
  );

  return (
    <>
      <button
        disabled={!viewedScan}
        onClick={() => open(isViewingPublished ? "blocked" : "archive")}
        title={!viewedScan ? "The viewed scan could not be resolved." : undefined}
        style={{ fontSize:11, color:T.muted, padding:"4px 10px", borderRadius:6, border:`1px solid ${T.border}`, background:"rgba(255,255,255,0.02)", cursor:viewedScan ? "pointer" : "not-allowed", opacity:viewedScan ? 1 : .5, fontFamily:"inherit", fontWeight:600 }}
      >Archive</button>
      {isViewingPublished && (
        <button
          onClick={() => open("unpublish")}
          style={{ fontSize:11, color:T.red, padding:"4px 10px", borderRadius:6, border:"1px solid rgba(225,77,87,0.35)", background:"rgba(225,77,87,0.07)", cursor:"pointer", fontFamily:"inherit", fontWeight:600 }}
        >Un-publish</button>
      )}
      {warning && <span style={{ color:"#f5d98a", fontSize:11, maxWidth:260 }}>{warning}</span>}
      <Modal
        show={!!dialog}
        title={dialog === "archive" ? "Archive this scan?" : dialog === "unpublish" ? "Un-publish this scan?" : "Archive blocked"}
        onClose={close}
        onSubmit={submit}
        submitLabel={dialog === "blocked" ? "Close" : dialog === "archive" ? "Archive scan" : "Un-publish"}
        submitDisabled={busy}
      >
        {dialog === "blocked" ? (
          <p style={{ margin:0 }}>This scan is currently published. Reject or replace it first, then archive. Use Un-publish if the dashboard should have no published assessment.</p>
        ) : (
          <div style={{ display:"grid", gap:12 }}>
            {evidenceBlock}
            {dialog === "archive" && scans.length === 1 && (
              <div style={{ color:"#f5d98a" }}>This is this customer's only scan — archiving leaves their dashboard with no assessment data until a new scan lands or this one is restored.</div>
            )}
            {dialog === "unpublish" && (
              <div style={{ color:"#f5d98a" }}>The dashboard will show no assessment data until a scan is published.</div>
            )}
            <label style={{ display:"grid", gap:5 }}>
              Reason (optional)
              <textarea value={reason} onChange={event => setReason(event.target.value)} rows={3} style={{ resize:"vertical", borderRadius:8, border:`1px solid ${T.border}`, background:"rgba(255,255,255,0.04)", color:T.text, padding:9, fontFamily:"inherit" }} />
            </label>
            {error && <div style={{ color:T.red }}>{error}</div>}
          </div>
        )}
      </Modal>
    </>
  );
};

const ArchivedScansSection = ({ slug, isPatriot, deliveryMode, refreshKey, onRestored, T }) => {
  const [open, setOpen] = useState(false);
  const [items, setItems] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [warning, setWarning] = useState(null);
  const [restoring, setRestoring] = useState(null);
  const [restoreRequestIds, setRestoreRequestIds] = useState({});

  const load = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await fetchArchivedReports(slug);
      setItems(data.archived || []);
    } catch (err) {
      setError(err.message || "Could not load archived scans");
    } finally {
      setLoading(false);
    }
  }, [slug]);

  useEffect(() => {
    setItems(null);
    setOpen(false);
    setError(null);
    setWarning(null);
    setRestoreRequestIds({});
  }, [slug]);

  useEffect(() => {
    if (open) load();
  }, [open, refreshKey, load]);

  if (!isPatriot || deliveryMode) return null;

  const restore = async (fileName) => {
    const requestId = restoreRequestIds[fileName] || newOperationRequestId();
    if (!restoreRequestIds[fileName]) {
      setRestoreRequestIds(ids => ({ ...ids, [fileName]: requestId }));
    }
    setRestoring(fileName);
    setError(null);
    try {
      const result = await restoreReport(slug, fileName, requestId, items?.find(item => item.file_name === fileName)?.identity);
      setWarning(result.audit_recorded === false
        ? "Done, but the audit row was not recorded — note it manually or retry."
        : null);
      await load();
      setRestoreRequestIds(ids => {
        const next = { ...ids };
        delete next[fileName];
        return next;
      });
      onRestored();
    } catch (err) {
      setError(err.message || "Restore failed");
    } finally {
      setRestoring(null);
    }
  };

  const count = items ? ` (${items.length})` : "";
  return (
    <section style={{ margin:"4px 0 12px", border:`1px solid ${T.border}`, borderRadius:10, background:"rgba(255,255,255,0.025)" }}>
      <button onClick={() => setOpen(value => !value)} style={{ width:"100%", display:"flex", justifyContent:"space-between", padding:"9px 12px", border:0, background:"transparent", color:T.text, cursor:"pointer", fontFamily:"inherit", fontSize:12, fontWeight:700 }}>
        <span>Archived scans{count}</span><span>{open ? "▲" : "▼"}</span>
      </button>
      {open && (
        <div style={{ padding:"0 12px 12px", display:"grid", gap:8 }}>
          {loading && !items && <div style={{ color:T.muted, fontSize:12 }}>Loading archived scans…</div>}
          {error && <div style={{ color:T.red, fontSize:12 }}>{error}</div>}
          {warning && <div style={{ color:"#f5d98a", fontSize:12 }}>{warning}</div>}
          {items && items.length === 0 && <div style={{ color:T.muted, fontSize:12 }}>No archived scans.</div>}
          {(items || []).map(item => (
            <div key={item.file_name} style={{ display:"flex", alignItems:"center", justifyContent:"space-between", gap:12, padding:"9px 10px", border:`1px solid ${T.border}`, borderRadius:8 }}>
              <div style={{ minWidth:0, display:"grid", gap:3, fontSize:11 }}>
                <strong style={{ overflow:"hidden", textOverflow:"ellipsis" }}>{item.file_name}</strong>
                <span style={{ color:T.muted }}>RA at archive: {item.scan_score || "—"}</span>
                <span style={{ color:T.muted }}>Archived {item.archived_at ? fmtInstant(item.archived_at) : "—"} by {item.archived_by || "—"}</span>
                {item.reason && <span style={{ color:T.muted }}>Reason: {item.reason}</span>}
              </div>
              <button disabled={restoring === item.file_name} onClick={() => restore(item.file_name)} style={{ flexShrink:0, fontSize:11, color:T.blue, padding:"5px 10px", borderRadius:6, border:"1px solid rgba(68,166,255,0.4)", background:"rgba(68,166,255,0.1)", cursor:"pointer", fontFamily:"inherit", fontWeight:600 }}>
                {restoring === item.file_name ? "Restoring…" : "Restore"}
              </button>
            </div>
          ))}
        </div>
      )}
    </section>
  );
};

/**
 * CustomerLogo — 48×48 brand square that loads /assets/logos/{slug}.png and
 * falls back to color-hashed initials when the image is missing (404/error).
 *
 * Props: slug, customerName, T
 */
const LOGO_PALETTE = ["#2563EB", "#0891B2", "#7C3AED", "#DB2777", "#059669", "#D97706", "#DC2626", "#4F46E5"];

const customerInitials = (name) => {
  if (!name) return "?";
  const words = name.trim().split(/\s+/).filter(Boolean);
  if (words.length === 0) return "?";
  return words.slice(0, 2).map(w => w[0].toUpperCase()).join("");
};

const CustomerLogo = ({ slug, customerName, T, size = 48, logoData }) => {
  const [failed, setFailed] = React.useState(false);
  // Retry the image whenever the customer OR the logo source changes (so a logo
  // arriving on clientInfo after load, or a customer switch, re-attempts the image).
  React.useEffect(() => { setFailed(false); }, [slug, logoData]);

  const box = {
    width: size, height: size, borderRadius: Math.round(size / 6), flexShrink: 0,
    display: "flex", alignItems: "center", justifyContent: "center", overflow: "hidden",
  };

  // Source priority: pc_customerlogo data-URI (when present) → bundled
  // /assets/logos/{slug}.png → initials circle (the onError fallback below).
  // A "data:image/...;base64,..." string is a valid <img src>; a malformed one
  // triggers onError and degrades to initials, same as a missing asset.
  const logoSrc = (typeof logoData === "string" && logoData)
    ? logoData
    : (slug ? `/assets/logos/${slug}.png` : null);

  if (logoSrc && !failed) {
    return (
      <div style={{ ...box, background: "#fff" }}>
        <img
          src={logoSrc}
          alt={customerName || slug}
          style={{ width: "100%", height: "100%", objectFit: "contain" }}
          onError={() => setFailed(true)}
        />
      </div>
    );
  }

  // Initials fallback — colored circle keyed off a stable hash of the slug.
  const key = slug || customerName || "";
  let hash = 0;
  for (let i = 0; i < key.length; i++) hash = (hash * 31 + key.charCodeAt(i)) >>> 0;
  const color = LOGO_PALETTE[hash % LOGO_PALETTE.length];
  return (
    <div style={{ ...box, background: color, borderRadius: "50%" }}>
      <span style={{ color: "#fff", fontWeight: 800, fontSize: Math.round(size / 3), letterSpacing: "0.02em" }}>
        {customerInitials(customerName)}
      </span>
    </div>
  );
};

const B_ALL = [
  { s: 62, a: 64, m: 62, t: 84, p: 48 },
  { s: 67, a: 65, m: 63, t: 85, p: 58 },
  { s: 70, a: 66, m: 65, t: 87, p: 64 },
  { s: 73, a: 68, m: 66, t: 89, p: 72 },
];
const B_IND = [
  { s: 62, a: 66, m: 64, t: 86, p: 38 },
  { s: 67, a: 67, m: 66, t: 88, p: 50 },
  { s: 70, a: 69, m: 68, t: 90, p: 55 },
  { s: 73, a: 71, m: 70, t: 91, p: 62 },
];

const D_ALL = [
  [4, 12, 38, 82, 65, 34, 12],
  [3, 10, 34, 80, 70, 36, 14],
  [2, 8, 30, 76, 74, 40, 17],
  [2, 6, 26, 72, 78, 44, 19],
];
const D_IND = [
  [0, 2, 5, 12, 10, 6, 3],
  [0, 1, 4, 12, 11, 7, 3],
  [0, 1, 3, 11, 12, 7, 4],
  [0, 1, 3, 10, 13, 8, 3],
];
const D_BINS = ["30-39", "40-49", "50-59", "60-69", "70-79", "80-89", "90+"];

const CAT_NAMES = ["Auth", "Admins", "SharePoint Online", "Microsoft Teams", "Exchange Online", "Entra ID", "Defender", "Power Platform", "AI Governance"];
const CAT_YOU = [[72,76,80,85],[60,65,70,74],[55,60,65,68],[58,63,68,72],[70,74,78,82],[50,58,64,70],[45,52,60,66],[65,68,70,72],[0,30,40,55]];
const CAT_IND = [[78,79,80,82],[68,69,70,72],[62,63,65,66],[64,65,67,68],[74,75,76,78],[62,63,65,67],[56,58,62,65],[66,67,68,70],[10,25,35,48]];

const MAX_QUEUE = 10;

const AZ_TECHNICAL = [{n:"Identity & Access",v:78},{n:"Network Security",v:62},{n:"Data Protection",v:71},{n:"Compute",v:68},{n:"Logging & Monitoring",v:55},{n:"Key Management",v:74},{n:"Storage",v:59},{n:"Governance",v:82}];
const AZ_PRACTICE = [{n:"Identity & Access Mgmt",v:78},{n:"Network Security",v:62},{n:"Data Protection",v:71},{n:"Endpoint Security",v:68},{n:"Logging & Monitoring",v:55},{n:"Encryption & Key Mgmt",v:74},{n:"Storage Security",v:59},{n:"Governance & Compliance",v:82}];

/* ── HELPERS ── */
function getLevel(s) {
  return getMaturityLevel(s, T);
}

function catColor(v) { return v >= 80 ? T.green : v >= 65 ? T.yellow : T.red; }

function sevBadgeType(s) {
  const norm = (s || "").toLowerCase();
  if (norm === "critical") return "purple";
  if (norm === "high") return "red";
  if (norm === "medium") return "orange";
  if (norm === "low") return "yellow";
  if (norm === "informational" || norm === "governance") return "slate";
  return "slate";
}

// Title-case severity for badge labels. Data is lowercase (critical/high/medium/low/informational),
// but display should match Status column casing (Critical / High / Medium / Low / Informational).
function sevLabel(s) {
  const norm = (s || "").toLowerCase();
  if (norm === "informational" || norm === "governance") return "Informational";
  if (!norm) return "";
  return norm.charAt(0).toUpperCase() + norm.slice(1);
}



/* ── ATOMS ── */

const ALLOWANCE_MODEL_TAGS = {
  banked: { label: "Allowance: Banked", type: "teal" },
  legacy: { label: "Allowance: Legacy", type: "slate" },
  contract_state: { label: "Contract State", type: "teal" },
};

function allowanceModelTag(model) {
  if (!Object.prototype.hasOwnProperty.call(ALLOWANCE_MODEL_TAGS, model)) {
    return {
      label: "Allowance model unavailable",
      chipColor: T.muted,
      style: {
        color: T.muted,
        border: `1px solid ${T.border}`,
        background: "rgba(255,255,255,.04)",
      },
    };
  }
  const spec = ALLOWANCE_MODEL_TAGS[model];
  const s = badgeColors(spec.type, "soft");
  return {
    label: spec.label,
    chipColor: s.border,
    style: { color: s.c, border: `1px solid ${s.border}`, background: s.bg },
  };
}

const CADENCE_ACTIONS = {
  outreach_due: { label: "Outreach due", type: "red" },
  watch: { label: "Watch", type: "yellow" },
  on_rhythm: { label: "On rhythm", type: "green" },
  scheduled: { label: "Scheduled", type: "blue" },
  review_year_ended: { label: "Review year ended", type: "slate" },
  no_recorded_history: { label: "No recorded history", type: "slate" },
  history_recorded: { label: "History recorded", type: "slate" },
  history_incomplete: { label: "History incomplete", type: "slate" },
  contract_held: { label: "Contract change hold", type: "slate" },
  no_reviews_available: { label: "No reviews available", type: "slate" },
};

const CADENCE_EVENT_LABELS = {
  review: "Review",
  no_show: "No-show",
  skipped: "Skipped",
  redo_requested: "Redo requested",
};

const CADENCE_TIMELINE_LABELS = {
  review_year: "Review year",
  service_term: "Service term",
  recorded_history: "Recorded history",
};

const cadenceEventLabel = (event) => {
  const label = CADENCE_EVENT_LABELS[event?.kind] || "Review event";
  return event?.backfilled ? `Backfilled ${label.toLowerCase()}` : label;
};
const cadenceTimelineLabel = (kind) => CADENCE_TIMELINE_LABELS[kind] || "Recorded history";
const cadenceAction = (state) => CADENCE_ACTIONS[state]
  || { label: "History incomplete", type: "slate" };
const cadenceGapColor = (band) => ({
  green: T.green, amber: T.yellow, red: T.red,
}[band] || T.muted);
const cadencePositiveInt = (value) => {
  const n = Number(value);
  return Number.isInteger(n) && n > 0 ? n : null;
};
const CADENCE_RAIL_MIN_WIDTH = 130;
const CADENCE_MARKER_LABEL_WIDTH = 68;
const CADENCE_MARKER_LABEL_GAP = 4;
const CADENCE_MARKER_LABEL_TOP = 28;
const CADENCE_MARKER_LABEL_LANE_STEP = 18;
const CADENCE_MARKER_COLLISION_WIDTH = 520;
const cadenceShortDate = (value) => fmtDateOnly(value, { month:"short", day:"numeric" });
const cadenceFullDate = (value) => fmtDateOnly(value, { month:"short", day:"numeric", year:"numeric" });
const cadenceStartContractYear = (row, timeline) => {
  const year = cadencePositiveInt(row?.contract_year);
  if (!year) return null;
  if (timeline.kind === "review_year") return year;
  const termNumber = cadencePositiveInt(row?.term_number);
  if (timeline.kind === "service_term" && termNumber === year) return year;
  return null;
};
const cadenceStartCap = (row, timeline) => {
  const year = cadenceStartContractYear(row, timeline);
  const dateLabel = cadenceFullDate(timeline.start);
  if (year) return `Y${year} · ${dateLabel}`;
  return `${cadenceTimelineLabel(timeline.kind)} · ${dateLabel}`;
};
const cadenceMarkerLabel = (marker) => {
  const reviewNumber = cadencePositiveInt(marker?.review_number);
  if (marker?.kind === "review" && reviewNumber) {
    return marker?.backfilled ? `R${reviewNumber} · Backfilled` : `R${reviewNumber}`;
  }
  if (marker?.kind === "redo_requested") return "Redo";
  if (marker?.kind === "scheduled") return "Scheduled";
  return cadenceEventLabel(marker);
};
const cadenceMarkerColor = (kind) => {
  if (kind === "scheduled") return T.blue;
  if (kind === "no_show") return T.orange;
  if (kind === "skipped") return T.yellow;
  if (kind === "redo_requested") return T.pink;
  return T.green;
};
const cadenceClamp = (value, min, max) => Math.max(min, Math.min(max, value));
const cadenceLabelLeftForCollision = (position) => {
  const center = (cadenceClamp(position, 0, 100) / 100) * CADENCE_MARKER_COLLISION_WIDTH;
  return cadenceClamp(
    center - (CADENCE_MARKER_LABEL_WIDTH / 2),
    0, CADENCE_MARKER_COLLISION_WIDTH - CADENCE_MARKER_LABEL_WIDTH,
  );
};
const cadencePositionedMarkers = (markers, timeline) => {
  const laneRightEdges = [];
  return markers
    .map((marker, index) => ({
      ...marker,
      index,
      position: datePosition(marker.date, timeline.start, timeline.end),
      shortLabel: cadenceMarkerLabel(marker),
    }))
    .sort((a, b) => a.position - b.position || a.index - b.index)
    .map((marker) => {
      const labelLeft = cadenceLabelLeftForCollision(marker.position);
      const labelRight = labelLeft + CADENCE_MARKER_LABEL_WIDTH;
      let lane = laneRightEdges.findIndex(
        rightEdge => labelLeft >= rightEdge + CADENCE_MARKER_LABEL_GAP,
      );
      if (lane === -1) lane = laneRightEdges.length;
      laneRightEdges[lane] = labelRight;
      return { ...marker, lane };
    });
};

// The frontend deploys with the merge; the cadence API is published separately.
// Keep the prior Banked response readable during that bounded rollout window.
const cadenceTimeline = (row) => {
  const genericRail = row.timeline_start && row.timeline_end;
  const hasGenericBoundary = row.timeline_start || row.timeline_end;
  const oldBankedRail = row.allowance_model === "banked"
    && !hasGenericBoundary
    && row.review_year_start && row.review_year_end;
  return {
    kind: genericRail ? row.timeline_kind : (oldBankedRail ? "review_year" : null),
    start: genericRail ? row.timeline_start : (oldBankedRail ? row.review_year_start : null),
    end: genericRail ? row.timeline_end : (oldBankedRail ? row.review_year_end : null),
  };
};

const datePosition = (value, start, end) => {
  const startMs = Date.parse(`${start}T00:00:00Z`);
  const endMs = Date.parse(`${end}T00:00:00Z`);
  const valueMs = Date.parse(`${value}T00:00:00Z`);
  if (!Number.isFinite(startMs) || !Number.isFinite(endMs)
      || !Number.isFinite(valueMs)) return 0;
  if (endMs === startMs) return 50;
  if (endMs < startMs) return 0;
  return Math.max(0, Math.min(100, ((valueMs - startMs) / (endMs - startMs)) * 100));
};

const ReviewCadenceRail = ({ row }) => {
  const timeline = cadenceTimeline(row);
  const events = Array.isArray(row.events) ? row.events : [];
  const markers = [
    ...events.map(event => ({ ...event, label: cadenceEventLabel(event) })),
    ...(row.scheduled_date ? [{
      date: row.scheduled_date, kind: "scheduled", label: "Scheduled review",
    }] : []),
  ];
  const hasRail = timeline.start && timeline.end;
  if (!hasRail) {
    return <span style={{ fontSize:12, color:T.muted }}>
      {row.scheduled_date
        ? `No recorded review timeline · Scheduled review ${fmtDateOnly(row.scheduled_date, { month:"short", day:"numeric", year:"numeric" })}`
        : "No recorded review timeline."}
    </span>;
  }
  const gapStart = row.gap_start || timeline.start;
  const gapEnd = row.gap_end;
  const segmentStart = datePosition(gapStart, timeline.start, timeline.end);
  const segmentEnd = datePosition(gapEnd, timeline.start, timeline.end);
  const segmentLeft = Math.min(segmentStart, segmentEnd);
  const segmentWidth = Math.max(0, segmentEnd - segmentStart);
  const positionedMarkers = cadencePositionedMarkers(markers, timeline);
  const maxLane = positionedMarkers.reduce((max, marker) => Math.max(max, marker.lane), 0);
  const railHeight = 58 + maxLane * CADENCE_MARKER_LABEL_LANE_STEP;
  return (
    <div style={{ display:"grid",
                  gridTemplateColumns:`max-content minmax(${CADENCE_RAIL_MIN_WIDTH}px, 1fr) max-content`,
                  gap:10, alignItems:"start" }}>
      <div style={{ fontSize:11, color:T.muted, whiteSpace:"nowrap", paddingTop:1 }}>
        {cadenceStartCap(row, timeline)}
      </div>
      <div data-testid="cadence-rail"
           style={{ position:"relative", height:railHeight, minWidth:CADENCE_RAIL_MIN_WIDTH }}
           aria-label="Review cadence timeline">
        <div style={{ position:"absolute", left:0, right:0, top:15, height:3,
                      borderRadius:4, background:"rgba(255,255,255,.18)" }} />
        {timeline.kind === "review_year" && gapEnd && (
          <div style={{ position:"absolute", left:`${segmentLeft}%`, top:15,
                        width:`${segmentWidth}%`, height:3, borderRadius:4,
                        background:cadenceGapColor(row.gap_band) }} />
        )}
        {positionedMarkers.length === 0 && (
          <span style={{ position:"absolute", left:"50%", top:30, transform:"translateX(-50%)",
                         fontSize:11, color:T.muted, whiteSpace:"nowrap" }}>
            No review recorded
          </span>
        )}
        {positionedMarkers.map((marker) => {
          const scheduled = marker.kind === "scheduled";
          const color = cadenceMarkerColor(marker.kind);
          const dotLeft = `clamp(0px, calc(${marker.position}% - 7px), calc(100% - 14px))`;
          const labelLeft = `clamp(0px, calc(${marker.position}% - ${
            CADENCE_MARKER_LABEL_WIDTH / 2
          }px), calc(100% - ${CADENCE_MARKER_LABEL_WIDTH}px))`;
          return (
            <React.Fragment key={`${marker.kind}-${marker.date}-${marker.index}`}>
              <span
                title={`${marker.label}: ${fmtDateOnly(marker.date)}`}
                aria-label={`${marker.label}: ${fmtDateOnly(marker.date)}`}
                style={{ position:"absolute", left:dotLeft, top:8,
                  width:14, height:14, borderRadius:"50%", boxSizing:"border-box",
                  background:scheduled ? T.panel : color,
                  border:`2px solid ${color}`, boxShadow:`0 0 0 2px ${T.panel}`,
                }}
              />
              <span
                data-testid={`cadence-marker-label-${marker.index}`}
                data-lane={marker.lane}
                style={{ position:"absolute", left:labelLeft,
                  top:CADENCE_MARKER_LABEL_TOP + marker.lane * CADENCE_MARKER_LABEL_LANE_STEP,
                  width:CADENCE_MARKER_LABEL_WIDTH, textAlign:"center",
                  fontSize:10.5, lineHeight:1.12, color:T.muted, pointerEvents:"none" }}>
                <strong style={{ display:"block", color:T.text, fontWeight:700 }}>
                  {marker.shortLabel}
                </strong>
                <span>{cadenceShortDate(marker.date)}</span>
              </span>
            </React.Fragment>
          );
        })}
      </div>
      <div style={{ fontSize:11, color:T.muted, whiteSpace:"nowrap", paddingTop:1 }}>
        {cadenceFullDate(timeline.end)}
      </div>
    </div>
  );
};

const ReviewCadencePanel = ({
  error, data, search, onSearch, stateFilter, onStateFilter, rows, getCustomerHref,
  getCustomerOnClick, onRetry, showInactive, onShowInactive,
}) => {
  const customers = data?.customers || [];
  if (error) {
    return <div style={{ fontSize:13, color:T.red, padding:"12px 0" }}>
      <span>Couldn’t load review cadence.</span>
      <button onClick={onRetry}
        style={{ marginLeft:10, padding:"5px 9px", borderRadius:6, cursor:"pointer",
                 fontFamily:"inherit", fontSize:12, fontWeight:600, color:T.text,
                 border:`1px solid ${T.border}`, background:"rgba(255,255,255,.06)" }}>
        Retry
      </button>
    </div>;
  }
  if (data === null) {
    return <div style={{ fontSize:13, color:T.muted, padding:"12px 0" }}>
      Loading review cadence…
    </div>;
  }
  return (
    <>
      <div style={{ fontSize:12, color:T.muted, marginBottom:12, lineHeight:1.6 }}>
        Factual Recommendations Review history for outreach planning. This view is
        read-only: review completion and booking records remain the authority.
      </div>
      <div style={{ display:"flex", gap:10, alignItems:"center", flexWrap:"wrap", marginBottom:14 }}>
        <input
          value={search}
          onChange={(e) => onSearch(e.target.value)}
          placeholder={`Search customer or ${CUSTOMER_MANAGER_LABEL}…`}
          style={{ padding:"6px 10px", fontSize:12, borderRadius:6, minWidth:200,
                   border:`1px solid ${T.border}`, background:"rgba(0,0,0,0.25)",
                   color:T.text, fontFamily:"inherit" }}
        />
        <label style={{ fontSize:12, color:T.muted, display:"flex", alignItems:"center", gap:6 }}>
          Status
          <select value={stateFilter} onChange={(e) => onStateFilter(e.target.value)}
            style={{ padding:"5px 8px", fontSize:12, borderRadius:6,
                     fontFamily:"inherit", border:`1px solid ${T.border}`,
                     background:"rgba(0,0,0,0.25)", color:T.text }}>
            <option value="all">All</option>
            <option value="outreach_due">Outreach due</option>
            <option value="watch">Watch</option>
            <option value="on_rhythm">On rhythm</option>
            <option value="scheduled">Scheduled</option>
            <option value="review_year_ended">Review year ended</option>
            <option value="no_recorded_history">No recorded history</option>
            <option value="history_recorded">History recorded</option>
            <option value="history_incomplete">History incomplete</option>
          </select>
        </label>
        <label style={{ fontSize:12, color:T.muted, display:"flex", alignItems:"center", gap:6, cursor:"pointer" }}>
          <input
            type="checkbox"
            checked={showInactive}
            onChange={(e) => onShowInactive(e.target.checked)}
            style={{ width:14, height:14, accentColor:T.blue, cursor:"pointer" }}
          />
          Show inactive/history
        </label>
        <span style={{ fontSize:12, color:T.muted }}>{rows.length} of {customers.length}</span>
      </div>
      <div style={{ display:"flex", gap:12, flexWrap:"wrap", margin:"0 0 12px",
                    fontSize:11, color:T.muted }} aria-label="Cadence legend">
        <span><span style={{ color:T.green }}>●</span> Review</span>
        <span><span style={{ color:T.orange }}>●</span> No-show</span>
        <span><span style={{ color:T.yellow }}>●</span> Skipped</span>
        <span><span style={{ color:T.pink }}>●</span> Redo requested</span>
        <span><span style={{ color:T.blue }}>○</span> Scheduled</span>
      </div>
      {rows.length === 0 ? (
        <div style={{ fontSize:13, color:T.muted, padding:"24px 0", textAlign:"center" }}>
          {customers.length === 0 ? "No review cadence data to show."
            : "No customers match that search or status."}
        </div>
      ) : (
        <div style={{ display:"grid", gap:8 }}>
          {rows.map((row) => {
            const action = cadenceAction(row.action_state);
            const allowance = allowanceModelTag(row.allowance_model);
            const annual = row.annual;
            return (
              <div key={row.slug} data-testid={`review-cadence-${row.slug}`}
                style={{ display:"grid", gridTemplateColumns:"minmax(190px, .8fr) minmax(220px, 1.7fr) minmax(135px, .55fr)",
                         gap:16, alignItems:"center", padding:"13px 14px", borderRadius:6,
                         border:`1px solid ${T.border}`, background:"rgba(0,0,0,.12)" }}>
                <div style={{ minWidth:0 }}>
                  <a href={getCustomerHref(row.slug)}
                     onClick={getCustomerOnClick ? getCustomerOnClick(row) : undefined}
                     style={{ color:T.blue, fontWeight:700, textDecoration:"none" }}>
                    {row.customer_name || row.slug}
                  </a>
                  {row.customer_manager && (
                    <div style={{ fontSize:11, color:T.muted, marginTop:4 }}>{row.customer_manager}</div>
                  )}
                  <span style={{ display:"inline-block", marginTop:7, padding:"3px 8px", borderRadius:999,
                                 fontSize:10.5, fontWeight:600, ...allowance.style }}>
                    {allowance.label}
                  </span>
                </div>
                <ReviewCadenceRail row={row} />
                <div style={{ textAlign:"right", minWidth:0 }}>
                  <Badge type={action.type} weight="soft">{action.label}</Badge>
                  {annual && (
                    <div style={{ fontSize:11, color:T.muted, marginTop:7, lineHeight:1.45 }}>
                      {annual.included} included · {annual.used} used · {annual.remaining} remaining
                    </div>
                  )}
                  {typeof row.days_since_resetting_review === "number" && (
                    <div style={{ fontSize:11, color:T.muted, marginTop:4 }}>
                      {row.days_since_resetting_review} days since review
                    </div>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </>
  );
};

// ── Customer detail drawer (docs/plans/customer-detail-view.md) ──
// READ-ONLY. One customer's Customer Data row and Review cadence row,
// composed from the fleet payloads AdminPage already holds, opened by a
// plain click on a customer name in Customer Data, Review cadence and
// Scheduling. Modelled on SettingDetailPanel: right-side drawer, scrim,
// prev/next, Esc, ←/→.
//
// PRESENTATIONAL: AdminPage resolves the rows by slug on every render and
// passes them in with their load states, so a background refresh shows up
// here without a snapshot going stale. The one thing held locally is the
// allowance history, the only per-customer read.
//
// THE DRAWER FORMATS, IT NEVER DERIVES. Every cell below goes through the
// helper the tab already calls on the same field, so the drawer and the
// row cannot disagree (#532: one quantity, one number). Remaining lives in
// the Reviews section, from cadence; the allowance cards' own totals are
// never rendered here.
const DRAWER_ALLOWANCE_SETTLE_MS = 250;

const drawerAllowanceFailure = (e) => (
  e?.status === 409 || e?.status === 422
    ? { kind:"state", message:e?.body?.error || "" }
    : { kind:"error" }
);

export const CustomerDetailDrawer = ({
  slug, name, wideNote = false,
  mgmtRow, mgmtMeta, mgmtState, onRetryMgmt,
  cadenceRow, cadenceState, onRetryCadence,
  dashboardHref, hasPrev, hasNext, onPrev, onNext, onClose,
  returnFocusTo = null,
}) => {
  // Keyboard navigation — SettingDetailPanel's handler verbatim, editor
  // guard included, so arrow keys typed into a field never step the drawer.
  useEffect(() => {
    const handleKey = (e) => {
      if (e.key === "Escape") onClose();
      else if (e.target && typeof e.target.closest === "function" && e.target.closest('input, textarea, select, [contenteditable=""], [contenteditable="true"], [contenteditable="plaintext-only"]')) return;
      else if (e.key === "ArrowLeft" && hasPrev) onPrev();
      else if (e.key === "ArrowRight" && hasNext) onNext();
    };
    window.addEventListener("keydown", handleKey);
    return () => window.removeEventListener("keydown", handleKey);
  }, [onClose, onPrev, onNext, hasPrev, hasNext]);

  // Focus the close button on open; hand focus back to the name link that
  // opened the drawer on close, when that link is still on the page.
  const closeButtonRef = useRef(null);
  const returnFocusRef = useRef(returnFocusTo);
  useEffect(() => {
    const trigger = returnFocusRef.current;
    closeButtonRef.current?.focus();
    return () => {
      if (trigger && trigger.isConnected && typeof trigger.focus === "function") {
        trigger.focus();
      }
    };
  }, []);

  // ── Allowance history (Banked only, design §4.3a) ──
  // The gate is the row's own Allowance-button predicate, read from the
  // RESOLVED Customer Data row — never from a slug that only came from the
  // URL. The GET pair starts after the drawer settles on a customer, so
  // holding an arrow key does not fire a pair per customer passed; the
  // loadSeq guard drops a response for a customer already stepped past,
  // and the per-slug cache lives as long as the drawer does.
  const bankedHistory = !!mgmtRow && mgmtRow.allowance_model === "banked";
  const [history, setHistory] = useState(null);
  const historyCache = useRef(new Map());
  const historySeq = useRef(0);
  useEffect(() => {
    historySeq.current += 1;
    const seq = historySeq.current;
    if (!slug || !bankedHistory) {
      setHistory(null);
      return undefined;
    }
    const cached = historyCache.current.get(slug);
    if (cached) {
      setHistory(cached);
      return undefined;
    }
    setHistory({ loading:true });
    const cache = historyCache.current;
    const timer = setTimeout(() => {
      Promise.allSettled([
        fetchAllowanceAdjustments(slug),
        fetchAllowanceTransition(slug),
      ]).then(([adjustments, transition]) => {
        const result = {
          loading:false,
          adjustments: adjustments.status === "fulfilled"
            ? { kind:"ok", rows:Array.isArray(adjustments.value?.history)
                ? adjustments.value.history : [] }
            : drawerAllowanceFailure(adjustments.reason),
          transition: transition.status === "fulfilled"
            ? { kind:"ok", value:transition.value?.card?.allowance?.transition || null }
            : drawerAllowanceFailure(transition.reason),
        };
        cache.set(slug, result);
        if (historySeq.current === seq) setHistory(result);
      });
    }, DRAWER_ALLOWANCE_SETTLE_MS);
    return () => {
      clearTimeout(timer);
      historySeq.current += 1;
    };
  }, [slug, bankedHistory]);

  if (!slug) return null;

  const sectionStyle = { padding:"16px 22px", borderBottom:`1px solid ${T.border}` };
  const headingStyle = { margin:"0 0 10px", fontSize:13, fontWeight:700, color:"#fff" };
  const labelStyle = { fontSize:11, color:T.muted, textTransform:"uppercase",
                       letterSpacing:0.4, fontWeight:600 };
  const valueStyle = { fontSize:13, color:T.text };
  const mutedLine = { fontSize:12, color:T.muted };
  const navButton = (enabled) => ({
    width:30, height:30, display:"grid", placeItems:"center",
    borderRadius:8, border:`1px solid ${T.border}`,
    background:"rgba(255,255,255,.04)", color:T.text,
    cursor: enabled ? "pointer" : "not-allowed", opacity: enabled ? 1 : 0.4,
    fontFamily:"inherit", fontSize:14,
  });
  const retryButton = (onRetry) => (
    <button onClick={onRetry}
      style={{ marginLeft:10, padding:"5px 9px", borderRadius:6, cursor:"pointer",
               fontFamily:"inherit", fontSize:12, fontWeight:600, color:T.text,
               border:`1px solid ${T.border}`, background:"rgba(255,255,255,.06)" }}>
      Retry
    </button>
  );
  const field = (label, value, title) => (
    <div key={label} data-field={label}>
      <div style={labelStyle}>{label}</div>
      <div style={valueStyle} title={title}>{value}</div>
    </div>
  );
  const sectionStates = (state, onRetry, errorCopy, absentCopy) => {
    if (state === "loading") return <Skeleton height={14} width="60%" />;
    if (state === "error") {
      return <div style={{ fontSize:13, color:T.red }}>
        <span>{errorCopy}</span>{retryButton(onRetry)}
      </div>;
    }
    return <div style={mutedLine}>{absentCopy}</div>;
  };

  const r = mgmtRow;
  const tags = r ? problemTags(r, mgmtMeta) : [];
  const displayName = r?.customer_name || cadenceRow?.customer_name || name || slug;
  const manager = r?.customer_manager || cadenceRow?.customer_manager;

  const contractBody = () => {
    if (!r) {
      return sectionStates(mgmtState, onRetryMgmt,
        "Couldn’t load the contract data.",
        "No Customer Data record for this customer.");
    }
    const pill = renewalPill(r);
    const work = renewalWorkItem(r, fmtDateOnly);
    const renewalTip = renewalTitle(r, mgmtMeta, fmtDateOnly);
    const pillNode = pill.kind === "pill"
      ? <Badge type={pill.type} weight={pill.weight}>{pill.label}</Badge>
      : <span style={{ color:T.muted }}>{pill.label}</span>;
    return (
      <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill, minmax(160px, 1fr))", gap:14 }}>
        {field("Term", termRangeLabel(r, fmtDateOnly) || "—", termTitle(r, fmtDateOnly))}
        {r.contract_change_enrolled && (
          <>
            {field("Current review balance", r.governed_unavailable
              ? "Unavailable — refresh and investigate"
              : `${r.governed_balance?.available_now ?? "—"} bookable now · ${r.governed_balance?.future_unreleased ?? "—"} future`,
              r.governed_hold ? `Contract hold: ${r.governed_hold}` : undefined)}
            {r.governed_pending_effective && field(
              "Scheduled contract change", fmtDateOnly(r.governed_pending_effective))}
          </>
        )}
        <div data-field="Term end date">
          <div style={labelStyle}>Term end date</div>
          <div style={{
            ...valueStyle,
            color: r.expiration_mismatch ? T.red : T.muted,
            fontWeight: r.expiration_mismatch ? 600 : 400,
          }} title={r.expiration_mismatch
            ? `Stored ${fmtDateOnly(r.expiration_date)} against a term `
              + `deriving ${fmtDateOnly(r.term_end_display)} (or `
              + `${fmtDateOnly(r.term_end)} on the anniversary `
              + "convention) — a different day under both."
            : undefined}>
            {r.expiration_date ? fmtDateOnly(r.expiration_date) : "—"}
          </div>
        </div>
        {field("Cycle", managementCycleLabel(r) || "—", managementCycleTitle(r, mgmtMeta))}
        {field("Auto renew", autoRenewLabel(r))}
        <div data-field="Renewal">
          <div style={labelStyle}>Renewal</div>
          <div style={valueStyle}>
            {work && (
              <div style={{ marginBottom:4 }}>
                <span title={work.title}>
                  <Badge type={work.type} weight={work.weight}>{work.label}</Badge>
                </span>
              </div>
            )}
            <span title={renewalTip}>{pillNode}</span>
          </div>
        </div>
        {field("Lifecycle phase", MGMT_PHASE_LABELS[r.lifecycle_phase] || "—")}
      </div>
    );
  };

  const reviewsBody = () => {
    if (!cadenceRow) {
      return sectionStates(cadenceState, onRetryCadence,
        "Couldn’t load review cadence.",
        "No review cadence record for this customer.");
    }
    const action = cadenceAction(cadenceRow.action_state);
    const allowance = allowanceModelTag(cadenceRow.allowance_model);
    const annual = cadenceRow.annual;
    return (
      <>
        <div style={{ display:"flex", gap:8, alignItems:"center", flexWrap:"wrap", marginBottom:12 }}>
          <span style={{ display:"inline-block", padding:"3px 8px", borderRadius:999,
                         fontSize:10.5, fontWeight:600, ...allowance.style }}>
            {allowance.label}
          </span>
          <Badge type={action.type} weight="soft">{action.label}</Badge>
          {annual && (
            <span style={mutedLine}>
              {annual.included} included · {annual.used} used · {annual.remaining} remaining
            </span>
          )}
          {typeof cadenceRow.days_since_resetting_review === "number" && (
            <span style={mutedLine}>
              {cadenceRow.days_since_resetting_review} days since review
            </span>
          )}
        </div>
        <ReviewCadenceRail row={cadenceRow} />
        <div style={{ display:"flex", gap:12, flexWrap:"wrap", margin:"10px 0 0",
                      fontSize:11, color:T.muted }} aria-label="Cadence legend">
          <span><span style={{ color:T.green }}>●</span> Review</span>
          <span><span style={{ color:T.orange }}>●</span> No-show</span>
          <span><span style={{ color:T.yellow }}>●</span> Skipped</span>
          <span><span style={{ color:T.pink }}>●</span> Redo requested</span>
          <span><span style={{ color:T.blue }}>○</span> Scheduled</span>
        </div>
      </>
    );
  };

  const allowanceBody = () => {
    if (!r) {
      return mgmtState === "loading"
        ? <Skeleton height={14} width="40%" />
        : <div style={mutedLine}>—</div>;
    }
    if (r.allowance_model === "legacy") {
      return <div style={mutedLine}>Adjustment history applies to Banked customers.</div>;
    }
    if (r.allowance_model !== "banked") return <div style={mutedLine}>—</div>;
    if (!history || history.loading) return <Skeleton height={14} width="50%" />;
    const { adjustments, transition } = history;
    const failed = adjustments.kind === "error" || transition.kind === "error";
    const active = transition.kind === "ok" && transition.value?.status === "active"
      ? transition.value : null;
    const th = { textAlign:"left", padding:"6px 8px", fontSize:11, color:T.muted,
                 fontWeight:600, borderBottom:`1px solid ${T.border}` };
    const td = { padding:"6px 8px", fontSize:12, color:T.text,
                 borderBottom:`1px solid ${T.border}` };
    return (
      <>
        {failed && (
          <div style={{ fontSize:13, color:T.red, marginBottom:8 }}>
            Couldn’t load allowance history.
          </div>
        )}
        {active && (
          <div style={{ ...mutedLine, marginBottom:8 }}>
            Banked transition active since {fmtDateOnly(active.effective_date)}
            {typeof active.opening_balance === "number"
              ? ` · opening balance ${active.opening_balance}` : ""}
          </div>
        )}
        {adjustments.kind === "state" && (
          <div style={mutedLine}>{adjustments.message}</div>
        )}
        {transition.kind === "state" && (
          <div style={mutedLine}>{transition.message}</div>
        )}
        {adjustments.kind === "ok" && (adjustments.rows.length === 0 ? (
          <div style={mutedLine}>No adjustment rows in this term.</div>
        ) : (
          <TableScroll>
            <table style={{ width:"100%", borderCollapse:"collapse" }}>
              <thead><tr>
                <th style={th}>Date</th>
                <th style={th}>Reason</th>
                <th style={th}>Amount</th>
                <th style={th}>Note</th>
              </tr></thead>
              <tbody>
                {adjustments.rows.map(item => (
                  <tr key={item.adjustment_id || `${item.effective_date}-${item.reason?.key}`}>
                    <td style={td}>{fmtDateOnly(item.effective_date)}</td>
                    <td style={td}>{item.reason?.label || "Unknown"}</td>
                    <td style={td}>{allowanceMetricValue(item.amount)}</td>
                    <td style={{ ...td, color:T.muted }}>{item.note || "—"}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </TableScroll>
        ))}
      </>
    );
  };

  return (
    <>
      <div data-testid="customer-detail-scrim" onClick={onClose} style={{
        position:"fixed", top:0, left:0, width:"100vw", height:"100vh",
        background:"rgba(0,0,0,0.45)", zIndex:999, cursor:"pointer",
      }} />
      <aside role="dialog" aria-label="Customer details"
        data-testid="customer-detail-drawer" data-slug={slug} style={{
        position:"fixed", top:0, right:0, height:"100vh", width:800, maxWidth:"92vw",
        background:`linear-gradient(180deg, #0e2746, ${T.bg})`,
        borderLeft:`1px solid ${T.border}`, boxShadow:"-30px 0 60px rgba(0,0,0,0.4)",
        zIndex:1000, display:"flex", flexDirection:"column",
      }}>
        <div style={{
          padding:"18px 22px 16px", borderBottom:`1px solid ${T.border}`,
          background:"rgba(11,31,58,0.96)", backdropFilter:"blur(8px)",
        }}>
          <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:14 }}>
            <div style={{ display:"flex", gap:4 }}>
              <button onClick={onPrev} disabled={!hasPrev} title="Previous customer (←)"
                style={navButton(hasPrev)}>‹</button>
              <button onClick={onNext} disabled={!hasNext} title="Next customer (→)"
                style={navButton(hasNext)}>›</button>
            </div>
            <button ref={closeButtonRef} onClick={onClose} title="Close (Esc)"
              style={navButton(true)}>✕</button>
          </div>
          <h3 style={{ margin:"0 0 4px", fontSize:18, fontWeight:700, color:"#fff" }}>
            {displayName}
          </h3>
          {manager && (
            <div data-testid="customer-detail-manager" style={mutedLine}>{manager}</div>
          )}
          <div style={{ display:"flex", gap:8, alignItems:"center", flexWrap:"wrap", marginTop:8 }}>
            {r && (
              <span data-testid="customer-detail-tier" style={mutedLine}>{r.tier || "—"}</span>
            )}
            {r && contractDisplayLabel(r.contract_status) && (
              <Badge type={contractStatusTone(r)} weight="soft">
                {contractDisplayLabel(r.contract_status)}
              </Badge>
            )}
            <a href={dashboardHref}
               style={{ color:T.blue, fontSize:12, fontWeight:600, textDecoration:"none" }}>
              Open customer dashboard
            </a>
          </div>
          {wideNote && (
            <div style={{ ...mutedLine, marginTop:8 }}>Shown from inactive/history records.</div>
          )}
        </div>
        <div style={{ overflowY:"auto", flex:1 }}>
          {tags.length > 0 && (
            <section style={sectionStyle}>
              <h4 style={headingStyle}>Needs fixing</h4>
              <span style={{ display:"flex", gap:6, flexWrap:"wrap" }}>
                {tags.map((t, i) => (
                  <span key={t.name} title={t.fix}>
                    <Badge type={problemTagTone(t.name, i === 0)} weight="soft">
                      {t.tag}
                    </Badge>
                  </span>
                ))}
              </span>
            </section>
          )}
          <section style={sectionStyle}>
            <h4 style={headingStyle}>Contract</h4>
            {contractBody()}
          </section>
          <section style={sectionStyle}>
            <h4 style={headingStyle}>Reviews</h4>
            {reviewsBody()}
          </section>
          <section style={{ ...sectionStyle, borderBottom:0 }}>
            <h4 style={headingStyle}>Allowance history</h4>
            {allowanceBody()}
          </section>
        </div>
      </aside>
    </>
  );
};

// Skeleton placeholder used while customer-scoped data is loading. The shimmer
// keyframes are injected once at the SecureShield365 root via useEffect.
const Skeleton = ({ width = "100%", height = 16, borderRadius = 6, style = {} }) => (
  <div style={{
    width, height, borderRadius,
    background: "linear-gradient(90deg, rgba(255,255,255,.04) 0%, rgba(255,255,255,.10) 50%, rgba(255,255,255,.04) 100%)",
    backgroundSize: "200% 100%",
    animation: "ss365-skeleton-shimmer 1.5s ease-in-out infinite",
    ...style,
  }} />
);

// Donut placeholder — a ring shape using two concentric circles, matching the
// 160px CategoryDonut used in the score cards.
const SkeletonDonut = ({ size = 160 }) => (
  <div style={{ width: size, height: size, position: "relative", margin: "0 auto" }}>
    <div style={{
      width: size, height: size, borderRadius: "50%",
      background: "linear-gradient(90deg, rgba(255,255,255,.04) 0%, rgba(255,255,255,.10) 50%, rgba(255,255,255,.04) 100%)",
      backgroundSize: "200% 100%",
      animation: "ss365-skeleton-shimmer 1.5s ease-in-out infinite",
    }} />
    <div style={{
      position: "absolute", inset: `${size * 0.19}px`, borderRadius: "50%",
      background: T.panel,
    }} />
  </div>
);

// Skeleton variants for OverviewPage sub-sections. Each mirrors the real
// component's layout so the visual transition to populated data is stable.
const SkeletonScoreCard = () => (
  <Card style={{ minWidth:0 }}>
    <div className="overview-score-card-grid" style={{ display:"grid", gridTemplateColumns:"minmax(0, 1fr) minmax(0, 1fr)", gap:14, marginBottom:14 }}>
      <div style={{ display:"flex", flexDirection:"column", justifyContent:"center" }}>
        <Skeleton width={130} height={15} style={{ marginBottom:8 }} />
        <Skeleton width={150} height={42} style={{ marginBottom:8 }} />
        <Skeleton width="90%" height={10} style={{ marginBottom:14 }} />
        <Skeleton width="80%" height={11} />
        <Skeleton width="60%" height={11} style={{ marginTop:6 }} />
      </div>
      <div>
        <Skeleton width={150} height={15} style={{ marginBottom:6 }} />
        <Skeleton width={120} height={10} style={{ marginBottom:12 }} />
        <SkeletonDonut size={160} />
        <Skeleton width="80%" height={11} style={{ marginTop:14 }} />
        <Skeleton width="60%" height={11} style={{ marginTop:6 }} />
      </div>
    </div>
    <div style={{ background:"rgba(255,255,255,.04)", border:"1px solid rgba(255,255,255,.08)", borderRadius:14, padding:12, marginBottom:12 }}>
      <Skeleton width={140} height={20} style={{ marginBottom:8 }} />
      <Skeleton width="90%" height={11} style={{ marginBottom:8 }} />
      <Skeleton width="100%" height={5} borderRadius={3} />
    </div>
    <Skeleton width="100%" height={104} borderRadius={10} />
  </Card>
);

const SkeletonMetricCardsGrid = () => (
  <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit, minmax(180px, 1fr))", gap:12 }}>
    {[0,1,2,3].map(i => (
      <div key={i} style={{ borderRadius:14, padding:14, border:"1px solid rgba(255,255,255,.08)", background:"rgba(255,255,255,.04)" }}>
        <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:10 }}>
          <Skeleton width={70} height={13} />
          <Skeleton width={36} height={28} />
        </div>
        <Skeleton width="100%" height={22} style={{ marginBottom:6 }} />
        <Skeleton width="100%" height={22} style={{ marginBottom:6 }} />
        <Skeleton width="100%" height={22} />
      </div>
    ))}
  </div>
);

const SkeletonCategoryCard = () => (
  <Card>
    <Skeleton width={200} height={15} style={{ marginBottom:14 }} />
    {[0,1,2,3,4,5,6,7,8].map(i => (
      <div key={i} style={{ display:"flex", alignItems:"center", gap:10, marginBottom:8 }}>
        <Skeleton width={110} height={11} />
        <Skeleton width={`${40 + (i * 7) % 50}%`} height={16} borderRadius={4} />
      </div>
    ))}
  </Card>
);

// Skeleton for the Next Session Focus card — sits in the right column of the
// top grid alongside the four metric cards.
const SkeletonNextSessionFocus = () => (
  <div style={{
    background: T.panel,
    border: `1px solid ${T.border}`,
    borderLeft: "3px solid rgba(83,196,109,.60)",
    borderRadius: 12,
    padding: "16px 20px",
    marginTop: 16,
  }}>
    <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:10 }}>
      <Skeleton width={150} height={15} />
      <Skeleton width={50} height={11} />
    </div>
    <Skeleton width="60%" height={11} style={{ marginBottom:14 }} />
    {[0,1,2].map(i => (
      <div key={i} style={{ display:"flex", gap:10, marginBottom:8, alignItems:"center" }}>
        <Skeleton width={36} height={12} />
        <Skeleton width="60%" height={12} />
        <Skeleton width={60} height={18} borderRadius={999} />
        <Skeleton width={50} height={11} />
      </div>
    ))}
  </div>
);

// Empty state shown on customer pages when the scored report fetch returns
// no data (e.g., a brand-new customer with no completed scan). Distinct from
// the skeleton, which only renders while a fetch is in-flight. The optional
// action renders as a single primary button under the message.
const EmptyState = ({ title, message, icon = "📊", actionLabel, onAction }) => (
  <div style={{
    background: T.panel,
    border: `1px solid ${T.border}`,
    borderRadius: 12,
    padding: "48px 32px",
    textAlign: "center",
    marginBottom: 16,
  }}>
    <div style={{ fontSize: 48, marginBottom: 16, opacity: 0.5 }}>{icon}</div>
    <h3 style={{ margin: "0 0 12px", fontSize: 18, fontWeight: 700, color: T.text }}>
      {title}
    </h3>
    <p style={{ margin: 0, fontSize: 14, color: T.muted, maxWidth: 480, marginLeft: "auto", marginRight: "auto", lineHeight: 1.5 }}>
      {message}
    </p>
    {actionLabel && onAction && (
      <div style={{ marginTop: 20 }}>
        <Btn pri onClick={onAction}>{actionLabel}</Btn>
      </div>
    )}
  </div>
);

const ROSTER_INACTIVE_TITLE = "Portal access not active";
const ROSTER_INACTIVE_MESSAGE = "Your portal access for this organization isn't currently active. Please contact your Patriot team to restore access. If your access was just restored, refresh this page.";
const NO_DATA_TITLE = "No assessment data available yet";
const NO_DATA_MESSAGE = "Once your first SecureShield365 scan completes, your security posture, recommendations, and session focus will appear here. Questions? Contact your Patriot engineer.";

// Self-scan-aware no-data copy (approved 2026-08-01). The variant comes
// from classifyNoDataScanState over the customer's own engine runs,
// fetched only after the report request settles at 404. Keyed by that
// classifier's return values; anything unrecognized (including null from
// a failed runs read) falls back to the generic NO_DATA copy above.
// Deliberately silent on who reviews/publishes results — publish
// mechanics are changing (auto-publish) and this copy must survive that.
const NO_DATA_COPY = {
  no_scans: {
    icon: "🛡️",
    title: "Run your first security scan",
    message: "Your dashboard fills in after your first scan. SecureScan365 is a read-only check of your Microsoft 365 environment that you run yourself, and it takes a few minutes. Start it from your Company Profile page.",
    actionLabel: "Go to Company Profile",
  },
  scan_running: {
    icon: "⏳",
    title: "Your scan is running",
    message: "A scan of your Microsoft 365 environment is in progress — no need to start another. You can leave this page; results appear here when it finishes.",
  },
  awaiting_publish: {
    icon: "✅",
    title: "Scan complete — results on the way",
    message: "Your scan finished and the results are being processed. Nothing further is needed from you. Your security posture and recommendations will appear here shortly.",
  },
};

// Shared by the three report-backed pages (Overview, Recommendations,
// Queue) so every no-data landing tells the same story.
const NoDataEmptyState = ({ scanState, onGoToProfile }) => {
  const copy = NO_DATA_COPY[scanState];
  if (!copy) return <EmptyState title={NO_DATA_TITLE} message={NO_DATA_MESSAGE} />;
  return (
    <EmptyState
      title={copy.title}
      message={copy.message}
      icon={copy.icon}
      actionLabel={copy.actionLabel}
      onAction={copy.actionLabel ? onGoToProfile : undefined}
    />
  );
};

// Confirmation before the scan card files a support ticket, naming the
// customer it will be filed against. Exists because a Patriot user browsing a
// real customer's page filed a ticket by accident. The Company Profile Need
// Help support form names the customer inline; onboarding completion no longer
// files a ticket.
const TicketConfirmModal = ({ show, customerLabel, busy, onConfirm, onClose }) => (
  <Modal
    show={show}
    title="File a support ticket?"
    onClose={onClose}
    onSubmit={onConfirm}
    submitLabel={busy ? "Filing…" : "File ticket"}
    submitDisabled={busy}
  >
    This will create a real support ticket for{" "}
    <b style={{ color: T.text }}>{customerLabel}</b>. Continue?
  </Modal>
);

// ── Start Assessment popup (SecureScan365 admin tab) ─────────────────
// The pipeline choice, made once, in front of the operator. Two modes,
// one start route — `as_customer` is the entire switch:
//
//   AUTO-SEND (default)  {slug, as_customer:true} -> the customer path.
//     Writes the initiator marker (patriot-as-customer), so the D2 sweep
//     picks the run up within 2 minutes, quality-gates it, sends it to
//     scoring, and it lands HELD in Publishing. Never auto-publishes —
//     publish_policy holds every patriot-as-customer run unconditionally.
//     Cap-enforced, in-flight-locked, admission pre-gated. The scan
//     account is resolved server-side; upn/tags are rejected outright.
//
//   MANUAL (unchecked)   {slug, upn, tags} -> today's admin path.
//     No marker, so the sweep cannot see the run at all. Not cap-checked,
//     not in-flight-locked. The operator picks the account and clicks
//     Send to Scoring by hand afterwards.
//
// These are two different actions, not one action with a toggle, and the
// modal says so rather than implying auto-send is a bolt-on.
//
// The cap is NEVER derived here. portal_scan_start_preflight returns the
// same derivation the start route's 429 is built from; this renders what
// the backend said. A display that can disagree with enforcement is worse
// than no display.
export const SCAN_START_COPY = {
  consumesWindow:
    "This runs a real assessment against their tenant and consumes their next-scan window — their own self-service scan will be unavailable for 24 hours afterwards.",
  autoSendWhat:
    "A new Patriot-requested journey checks prerequisites, then runs the assessment. Its results are held for review. If this attaches to a customer's existing journey, that journey keeps its original publishing policy.",
  manualWhat:
    "Diagnostics only. The run is invisible to the auto-send sweep — you send it to scoring by hand from Recent Runs when you want it scored.",
  manualNotCapped:
    "The manual path is not cap-enforced, but the run still consumes their window.",
  timing:
    "A newly started Patriot journey usually reaches Publishing a few minutes after the engine finishes. An attached customer journey follows its original policy.",
};

const scanJourneyLabel = (journey) => {
  const labels = {
    idle: "No saved journey", active: "In progress", stalled: "Needs investigation",
    settled: "Settled", blocked: "Setup blocked", not_evaluated: "Not evaluated",
    capped: "Capped", abandoned: "Request closed",
    expired_unstarted: "Expired before assessment", unavailable: "Journey unavailable",
    slug_mismatch: "Saved under another customer", recovery_pending: "Recovery audit pending",
  };
  return labels[journey?.status] || "Journey status unknown";
};

const UNKNOWN_DURABLE_RESPONSE = "The saved journey response could not be interpreted. Refresh the journey before acting.";

export const scanRequestMessage = (result) => {
  switch (result?.state) {
    case "prerequisite": return "Scan request accepted; showing current progress. Checking prerequisites.";
    case "assessment": return "Scan request accepted; showing current progress. Assessment running.";
    case "adjudication": return result.phase === "held"
      ? "Scan request accepted; the saved journey is held for review."
      : result.phase === "published"
        ? "Scan request accepted; the saved journey is published."
        : result.phase === "processing"
          ? "Scan request accepted; results are processing."
          : UNKNOWN_DURABLE_RESPONSE;
    case "cap": {
      const next = fmtInstant(result.next_available_utc,
        { month: "short", day: "numeric", year: "numeric", hour: "numeric", minute: "2-digit" }, "");
      return next
        ? `The assessment window is capped until ${next}.`
        : "The assessment window is capped; the next available time was not confirmed. Refresh the saved journey.";
    }
    case "blocked":
    case "not_evaluated": return "The saved journey needs setup attention before another assessment.";
    case "stalled": return "The saved journey needs investigation. No new assessment was started.";
    default: return UNKNOWN_DURABLE_RESPONSE;
  }
};

const SCAN_BLOCK_FIX = {
  SCAN_ACCOUNT_AMBIGUOUS:
    "Set pc_designatedscanaccountupn on the tracking row, or use the manual path below and pick the account yourself.",
  SCAN_ACCOUNT_STALE:
    "The designated scan account is no longer in the engine's stored-passkey list — update it, or use the manual path below.",
  NO_PASSKEY_REGISTERED:
    "Register a stored passkey for this tenant in SecureScan365 first. The manual path can't work around this one.",
};

// NO_PASSKEY_REGISTERED blocks BOTH paths — there is no account to run
// as. The other two block only auto-send, because the manual path lets
// the operator name the account. Getting this wrong would offer a
// fallback that cannot work.
const SCAN_BLOCK_ALLOWS_MANUAL = (code) => code !== "NO_PASSKEY_REGISTERED";

export const ScanStartModal = ({
  show, customerLabel, slug, preflight, loading, error, selectedUpn,
  autoSend, onToggleAutoSend, manualArmed, onArmManual,
  starting, onStart, onClose, onViewJourney,
}) => {
  if (!show) return null;

  const cap = preflight?.cap;
  const capped = !!cap?.capped;
  const inFlight = preflight?.in_flight;
  const block = preflight?.auto_send_block;
  const siblings = preflight?.shared_tenant_with || [];
  const manualPossible = !block || SCAN_BLOCK_ALLOWS_MANUAL(block.code);

  // Active journeys are viewed through detail instead of offering a new
  // automatic start from an advisory preflight snapshot.
  const journey = preflight?.journey;
  const journeyBlocksAuto = !journey || ![
    "idle", "settled", "blocked", "not_evaluated", "capped", "expired_unstarted", "abandoned",
  ].includes(journey.status);
  const autoSendBlocked = capped || !!inFlight || !!block || journeyBlocksAuto;
  const effectiveAutoSend = autoSend && !autoSendBlocked;

  // TWO WAYS TO REACH THE MANUAL PATH, and they are not the same act:
  //   - Unchecking the box when auto-send WAS available. That is the
  //     operator choosing the manual path outright, so it needs no second
  //     confirmation — the uncheck IS the choice.
  //   - Arming it when auto-send is blocked. There the box is disabled,
  //     so there is no uncheck to make; the explicit second click is what
  //     stops a capped tenant from quietly becoming a manual run.
  const manualChosen = (!autoSend && !autoSendBlocked) || manualArmed;
  const canStart = !loading && !starting && !error && !!preflight
    && (effectiveAutoSend || (manualChosen && manualPossible && !!selectedUpn && !inFlight));

  const nextAvailable = cap?.next_available_utc
    ? fmtInstant(cap.next_available_utc, {
        month: "short", day: "numeric", hour: "numeric", minute: "2-digit" })
    : null;

  const engineEstimate = preflight?.last_run_duration_seconds
    ? `Their last assessment took ${Math.max(1, Math.round(preflight.last_run_duration_seconds / 60))} min.`
    : "";

  const note = { fontSize: 12, color: T.muted, lineHeight: 1.5, marginTop: 6 };
  const banner = (tint, borderTint) => ({
    marginTop: 12, padding: "10px 12px", borderRadius: 10,
    background: tint, border: `1px solid ${borderTint}`,
    fontSize: 12.5, color: T.text, lineHeight: 1.5,
  });

  return (
    <div onClick={onClose} style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)", zIndex: 1000, display: "flex", justifyContent: "center", alignItems: "center" }}>
      <div
        role="dialog"
        aria-modal="true"
        aria-label="Start assessment"
        onClick={e => e.stopPropagation()}
        style={{ background: T.panel, border: `1px solid ${T.border}`, borderRadius: 18, padding: 24, maxWidth: 560, width: "92%", maxHeight: "86vh", overflowY: "auto", boxShadow: "0 12px 40px rgba(0,0,0,0.4)" }}
      >
        <h3 style={{ fontSize: 16, fontWeight: 700, marginBottom: 4 }}>
          Start assessment
        </h3>
        <div style={{ fontSize: 13, color: T.muted, marginBottom: 14 }}>
          <b style={{ color: T.text }}>{customerLabel || slug}</b>
        </div>

        {loading && (
          <div style={{ fontSize: 13, color: T.muted, padding: "12px 0" }}>
            Checking this tenant…
          </div>
        )}

        {/* A preflight that failed must NOT fall through to a start —
            the whole point is not guessing the cap state. */}
        {error && (
          <div style={banner("rgba(225,77,87,.10)", "rgba(225,77,87,.35)")}>
            <b style={{ color: T.red }}>Couldn't check this tenant.</b>
            <div style={note}>{error}</div>
            <div style={note}>
              Nothing has been started. Close and retry — starting without a
              cap check would risk consuming a window you can't see.
            </div>
          </div>
        )}

        {!loading && !error && preflight && (
          <>
            <div style={banner("rgba(68,166,255,.08)", "rgba(68,166,255,.3)")}>
              <b style={{ color: T.text }}>Saved journey: {scanJourneyLabel(journey)}.</b>
              {journey?.phase && <div style={note}>Phase: {journey.phase}.</div>}
              {journey?.run_id && <div style={note}>Known run: {journey.run_id}.</div>}
              {journey?.initiated_by && <div style={note}>Original request: {journey.initiated_by === "customer" ? "customer" : "Patriot as customer"}.</div>}
              {journey?.status === "active" && <div style={note}>View the saved journey's progress before requesting another assessment.</div>}
              {journey?.status === "unavailable" && <div style={note}>The saved record could not be checked. Automatic start is unavailable.</div>}
              {journey?.status === "slug_mismatch" && <div style={note}>This tenant has a journey for a different customer slug. This selection cannot attach to or recover it.</div>}
              {journey?.status === "recovery_pending" && <div style={note}>An unresolved recovery audit keeps automatic starts locked.</div>}
              {journey?.status === "stalled" && <div style={note}>Investigate this journey before another automatic request. Manual diagnostics do not recover it.</div>}
            </div>
            {/* ── The choice ── */}
            <label style={{ display: "flex", gap: 10, alignItems: "flex-start", padding: "10px 12px", borderRadius: 10, border: `1px solid ${effectiveAutoSend ? "rgba(83,196,109,.45)" : T.border}`, background: effectiveAutoSend ? "rgba(83,196,109,.08)" : "transparent", cursor: autoSendBlocked ? "not-allowed" : "pointer", opacity: autoSendBlocked ? 0.6 : 1 }}>
              <input
                type="checkbox"
                checked={autoSend}
                disabled={autoSendBlocked}
                onChange={onToggleAutoSend}
                style={{ marginTop: 2 }}
              />
              <span>
                <span style={{ fontSize: 13, fontWeight: 700, color: T.text }}>
                  Send to scoring automatically
                </span>
                <div style={note}>{SCAN_START_COPY.autoSendWhat}</div>
                {preflight.auto_send_upn && !block && (
                  <div style={note}>Runs as {preflight.auto_send_upn}.</div>
                )}
                {/* The radio selection above the button does NOT apply to
                    auto-send: the customer path rejects a caller-supplied
                    upn and resolves the account server-side. Saying so
                    only when the two actually differ keeps the normal
                    case quiet and the surprising case loud. */}
                {preflight.auto_send_upn && !block && selectedUpn
                  && selectedUpn.toLowerCase() !== preflight.auto_send_upn.toLowerCase() && (
                  <div style={{ ...note, color: T.yellow }}>
                    Not {selectedUpn} — auto-send always uses the account
                    resolved for this customer. Use the manual path to run as
                    the account you picked.
                  </div>
                )}
              </span>
            </label>

            {/* ── Cap: always stated, capped or not ── */}
            <div style={banner("rgba(68,166,255,.08)", "rgba(68,166,255,.3)")}>
              {capped ? (
                <>
                  <b style={{ color: T.blue }}>Capped until {nextAvailable}.</b>
                  <div style={note}>
                    A scan against this tenant completed{" "}
                    {cap.last_completed_utc
                      ? fmtInstant(cap.last_completed_utc, { month: "short", day: "numeric", hour: "numeric", minute: "2-digit" })
                      : "recently"}
                    . Auto-send would be refused by the 24h cap.
                  </div>
                </>
              ) : cap.source === "no_history" ? (
                <>
                  <b style={{ color: T.text }}>Available now.</b>
                  <div style={note}>
                    No completed assessment on record for this tenant, so the
                    cap has nothing to measure from.
                  </div>
                </>
              ) : (
                <>
                  <b style={{ color: T.text }}>Available now.</b>
                  <div style={note}>
                    Last completed{" "}
                    {fmtInstant(cap.last_completed_utc, { month: "short", day: "numeric", hour: "numeric", minute: "2-digit" })}.
                  </div>
                </>
              )}
              <div style={note}>{SCAN_START_COPY.consumesWindow}</div>
            </div>

            {/* ── Shared tenant ── */}
            {siblings.length > 0 && (
              <div style={banner("rgba(243,181,63,.08)", "rgba(243,181,63,.35)")}>
                <b style={{ color: T.yellow }}>Shared Entra tenant.</b>
                <div style={note}>
                  {siblings.join(", ")} share{siblings.length === 1 ? "s" : ""} this
                  tenant. Running here consumes their window too, and vice versa.
                </div>
              </div>
            )}

            {/* ── In flight ── */}
            {inFlight && (
              <div style={banner("rgba(243,181,63,.08)", "rgba(243,181,63,.35)")}>
                <b style={{ color: T.yellow }}>
                  A {inFlight.kind === "prereq" ? "prerequisites check" : "scan"} is
                  already running for this tenant.
                </b>
                <div style={note}>
                  Run {inFlight.run_id}. The engine takes one job per tenant at a
                  time — wait for it to finish.
                </div>
              </div>
            )}

            {/* ── Auto-send blocked on setup ── */}
            {block && (
              <div style={banner("rgba(243,181,63,.08)", "rgba(243,181,63,.35)")}>
                <b style={{ color: T.yellow }}>
                  Auto-send unavailable — {block.code}
                </b>
                <div style={note}>{block.detail}</div>
                <div style={note}>{SCAN_BLOCK_FIX[block.code] || ""}</div>
              </div>
            )}

            {/* Manual chosen by unchecking, with auto-send available.
                No arming step — the uncheck was the decision — but the
                consequences still get stated, because "no marker, sweep
                can't see it" is not something to infer from a checkbox. */}
            {manualChosen && !autoSendBlocked && (
              <div style={banner("rgba(148,163,184,.10)", T.border)}>
                <b style={{ color: T.text }}>Manual run.</b>
                <div style={note}>{SCAN_START_COPY.manualWhat}</div>
                <div style={note}>
                  <b style={{ color: T.yellow }}>{SCAN_START_COPY.manualNotCapped}</b>
                </div>
                {selectedUpn && <div style={note}>Runs as {selectedUpn}.</div>}
              </div>
            )}

            {/* ── The manual fallback: explicit, two-click, never silent ──
                Offered when auto-send can't run but a manual start still
                can. Arming it unchecks auto-send in front of the operator
                so nobody walks away believing they got the sweep. */}
            {autoSendBlocked && manualPossible && (
              <div style={{ marginTop: 14, paddingTop: 14, borderTop: `1px solid ${T.border}` }}>
                {!manualArmed ? (
                  <>
                    <button
                      onClick={onArmManual}
                      disabled={!!inFlight}
                      style={{
                        padding: "7px 14px", borderRadius: 8, fontSize: 12, fontWeight: 700,
                        fontFamily: "inherit", border: `1px solid ${T.border}`,
                        background: "transparent", color: inFlight ? T.muted : T.text,
                        cursor: inFlight ? "not-allowed" : "pointer",
                      }}
                    >Run manually anyway (diagnostics)</button>
                    <div style={note}>{SCAN_START_COPY.manualWhat}</div>
                  </>
                ) : (
                  <div style={banner("rgba(148,163,184,.10)", T.border)}>
                    <b style={{ color: T.text }}>Manual run armed.</b>
                    <div style={note}>{SCAN_START_COPY.manualWhat}</div>
                    <div style={note}>
                      <b style={{ color: T.yellow }}>{SCAN_START_COPY.manualNotCapped}</b>
                      {capped && nextAvailable
                        ? ` Their next self-service scan moves out from ${nextAvailable}.`
                        : ""}
                    </div>
                  </div>
                )}
              </div>
            )}

            {/* ── Timing, only where it is true ── */}
            {effectiveAutoSend && (
              <div style={note}>
                {SCAN_START_COPY.timing} {engineEstimate}
              </div>
            )}
          </>
        )}

        <div style={{ display: "flex", gap: 8, justifyContent: "flex-end", marginTop: 18 }}>
          {journey?.status === "active" && <Btn onClick={onViewJourney}>View journey</Btn>}
          <Btn onClick={onClose}>Cancel</Btn>
          <Btn pri onClick={onStart} disabled={!canStart}>
            {starting
              ? "Starting…"
              : manualChosen && !effectiveAutoSend
                ? "Start manual run"
                : "Start assessment"}
          </Btn>
        </div>
      </div>
    </div>
  );
};

const LegacyAdminScanJourneysPanel = ({ onSelect }) => {
  const [filter, setFilter] = useState("all");
  const [rows, setRows] = useState([]);
  const [cursor, setCursor] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [asOf, setAsOf] = useState("");
  const [revision, setRevision] = useState(0);
  const [expired, setExpired] = useState(false);
  const traversal = useRef(0);

  useEffect(() => {
    const generation = ++traversal.current;
    setRows([]);
    setCursor(null);
    setError("");
    setExpired(false);
    setAsOf("");
    setLoading(true);
    fetchAdminScanJourneys({ state: filter })
      .then(data => {
        if (traversal.current !== generation) return;
        setRows(data.items || []);
        setCursor(data.next_cursor || null);
        setAsOf(data.as_of_utc || "");
      })
      .catch(() => {
        if (traversal.current === generation)
          setError("Journey listing is incomplete. Restart to try again.");
      })
      .finally(() => {
        if (traversal.current === generation) setLoading(false);
      });
    return () => {
      if (traversal.current === generation) traversal.current += 1;
    };
  }, [filter, revision]);

  const loadMore = () => {
    if (!cursor || loading) return;
    const generation = traversal.current;
    setLoading(true);
    setError("");
    fetchAdminScanJourneys({ state: filter, cursor })
      .then(data => {
        if (traversal.current !== generation) return;
        setRows(previous => {
          const seen = new Set(previous.map(row => row.reference));
          return [...previous, ...(data.items || []).filter(row => !seen.has(row.reference))];
        });
        setCursor(data.next_cursor || null);
        setAsOf(data.as_of_utc || "");
      })
      .catch(err => {
        if (traversal.current !== generation) return;
        if (err.status === 410 && err.body?.error === "cursor_expired") {
          setExpired(true);
          setCursor(null);
          setError("This listing expired or changed. Restart the listing; a full listing must finish within five minutes.");
        } else setError("The next journey page could not be loaded. This list is incomplete.");
      })
      .finally(() => {
        if (traversal.current === generation) setLoading(false);
      });
  };

  const changeFilter = next => {
    if (next === filter) return;
    traversal.current += 1;
    setFilter(next);
  };

  const refresh = () => {
    traversal.current += 1;
    setRevision(value => value + 1);
  };

  return (
    <div style={{ border:`1px solid ${T.border}`, borderRadius:10, padding:"12px 14px", marginBottom:18 }}>
      <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", gap:8 }}>
        <strong style={{ fontSize:12, color:T.text }}>Journeys</strong>
        <button onClick={refresh} style={{ fontSize:11, color:T.blue, border:"none", background:"none", cursor:"pointer" }}>{expired ? "Restart listing" : "Refresh listing"}</button>
      </div>
      <div style={{ color:T.muted, fontSize:11, marginTop:4 }}>Loaded journeys only. Records can change between pages; this is not a fleet count.</div>
      <div style={{ display:"flex", gap:5, flexWrap:"wrap", marginTop:9 }}>
        {[
          ["all", "All"], ["active", "Active"], ["stalled", "Stalled"],
          ["settled", "Settled"], ["blocked", "Blocked/capped/expired"],
          ["needs_investigation", "Needs investigation"],
        ].map(([key, label]) => (
          <button key={key} onClick={() => changeFilter(key)} style={{ fontSize:11, padding:"4px 8px", borderRadius:7, border:`1px solid ${filter === key ? T.blue : T.border}`, background:"transparent", color:filter === key ? T.blue : T.muted, cursor:"pointer" }}>{label}</button>
        ))}
      </div>
      {error && <div style={{ fontSize:11, color:T.red, marginTop:8 }}>{error}</div>}
      {rows.map(row => {
        const created = row.created_utc ? Date.parse(row.created_utc) : NaN;
        const ageHours = Number.isFinite(created) ? Math.max(0, Math.floor((Date.now() - created) / 3600000)) : null;
        return (
          <div key={row.reference} style={{ padding:"8px 0", borderTop:`1px solid ${T.border}`, marginTop:8, fontSize:11, color:T.text }}>
            <div style={{ display:"flex", justifyContent:"space-between", gap:8 }}>
              <strong>{row.customer_name || "Unattributed journey"}</strong>
              <span>{scanJourneyLabel(row)}</span>
            </div>
            <div style={{ color:T.muted, marginTop:3 }}>
              {row.phase || row.reason || "Unknown phase"}
              {row.initiated_by ? ` · ${row.initiated_by}` : ""}
              {row.run_id ? ` · run ${row.run_id}` : ""}
              {row.created_utc ? ` · created ${fmtInstant(row.created_utc)}` : ""}
              {row.updated_utc ? ` · updated ${fmtInstant(row.updated_utc)}` : ""}
              {ageHours !== null ? ` · ${ageHours}h old` : ""}
              {row.status === "recovery_pending" ? " · audit pending" : ""}
            </div>
            {row.slug ? (
              <button onClick={() => onSelect(row.slug)} style={{ marginTop:5, fontSize:11, color:T.blue, border:"none", background:"none", padding:0, cursor:"pointer" }}>View journey</button>
            ) : <div style={{ color:T.yellow, marginTop:3 }}>Investigation reference: {row.reference}</div>}
          </div>
        );
      })}
      {!rows.length && !loading && !error && <div style={{ color:T.muted, fontSize:11, marginTop:9 }}>No matching journeys in this loaded page. More pages may still contain matches.</div>}
      {cursor && <button onClick={loadMore} disabled={loading} style={{ marginTop:10, fontSize:11, color:T.blue, border:`1px solid ${T.border}`, background:"transparent", borderRadius:7, padding:"5px 10px", cursor:"pointer" }}>{loading ? "Loading…" : "Load next page"}</button>}
      {loading && !cursor && <div style={{ color:T.muted, fontSize:11, marginTop:8 }}>Loading…</div>}
      {asOf && <div style={{ color:T.muted, fontSize:10, marginTop:8 }}>Last page read {fmtInstant(asOf)}.</div>}
    </div>
  );
};

const journeyOperator = actor => actor?.user_id || "Unknown operator";

export const AdminScanJourneysPanel = ({ onSelect, selectedCustomer = "", customers = {}, onDownloadResult, getCustomerDashboardHref }) => {
  const [backendMode, setBackendMode] = useState("loading");
  const view = "current";
  const [filter, setFilter] = useState("all_open");
  const [customer, setCustomer] = useState("");
  const [rows, setRows] = useState([]);
  const [cursor, setCursor] = useState(null);
  const [asOf, setAsOf] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [revision, setRevision] = useState(0);
  const [selected, setSelected] = useState(null);
  const [detail, setDetail] = useState(null);
  const [detailError, setDetailError] = useState("");
  const [preview, setPreview] = useState(null);
  const [actionBusy, setActionBusy] = useState(false);
  const [actionMessage, setActionMessage] = useState("");
  const [pendingOperation, setPendingOperation] = useState(null);
  const listGeneration = useRef(0);
  const detailGeneration = useRef(0);

  const clearExact = () => {
    detailGeneration.current += 1;
    setSelected(null); setDetail(null); setDetailError(""); setPreview(null);
    setPendingOperation(null); setActionMessage(""); setActionBusy(false);
  };

  useEffect(() => {
    clearExact();
  }, [selectedCustomer]);

  useEffect(() => {
    const generation = ++listGeneration.current;
    setRows([]); setCursor(null); setError(""); setAsOf(""); setLoading(true);
    fetchAdminScanJourneyRecords({ view, state: filter, customer })
      .then(data => {
        if (listGeneration.current !== generation) return;
        setBackendMode("managed");
        setRows(data.items || []); setCursor(data.next_cursor || null);
        setAsOf(data.as_of_utc || "");
      })
      .catch(err => {
        if (listGeneration.current !== generation) return;
        if (err.status === 404 && err.body?.error === "management_off") {
          setBackendMode("legacy");
        } else {
          setBackendMode("managed");
          setError("Journey listing is unavailable. Restart to try again.");
        }
      })
      .finally(() => {
        if (listGeneration.current === generation) setLoading(false);
      });
    return () => { if (listGeneration.current === generation) listGeneration.current += 1; };
  }, [view, filter, customer, revision]);

  const restart = () => {
    listGeneration.current += 1;
    clearExact();
    setRevision(value => value + 1);
  };

  const loadMore = () => {
    if (!cursor || loading) return;
    const generation = listGeneration.current;
    setLoading(true); setError("");
    fetchAdminScanJourneyRecords({ view, state: filter, customer, cursor })
      .then(data => {
        if (listGeneration.current !== generation) return;
        setRows(previous => {
          const seen = new Set(previous.map(item => item.journey_id || item.reference));
          return [...previous, ...(data.items || []).filter(item => {
            const key = item.journey_id || item.reference;
            if (seen.has(key)) return false;
            seen.add(key);
            return true;
          })];
        });
        setCursor(data.next_cursor || null); setAsOf(data.as_of_utc || "");
      })
      .catch(err => {
        if (listGeneration.current !== generation) return;
        setError(err.status === 410 ? "This listing expired. Restart the listing."
          : "The next page is unavailable. This listing is incomplete.");
      })
      .finally(() => { if (listGeneration.current === generation) setLoading(false); });
  };

  const openExact = row => {
    detailGeneration.current += 1;
    const generation = detailGeneration.current;
    setSelected({ journey_id: row.journey_id, slug: row.slug });
    setDetail(null); setDetailError(""); setPreview(null);
    setPendingOperation(null); setActionMessage(""); setActionBusy(false);
    fetchAdminScanJourneyRecord(row.journey_id, row.slug)
      .then(value => {
        if (detailGeneration.current !== generation) return;
        setDetail(value);
        setPendingOperation(value.management_operation_id || null);
      })
      .catch(() => { if (detailGeneration.current === generation) setDetailError("This exact request is unavailable. Restart the listing."); });
  };

  const openDiagnostic = row => {
    detailGeneration.current += 1;
    setSelected({ diagnostic: true, reference: row.reference });
    setDetail(null); setDetailError(""); setPreview(null);
    setPendingOperation(null); setActionMessage(""); setActionBusy(false);
  };

  const refreshExact = () => {
    if (selected) openExact(selected);
  };

  const prepareAction = action => {
    if (!detail || actionBusy) return;
    const target = { journey_id: detail.journey_id, slug: detail.slug };
    const generation = detailGeneration.current;
    const boundReason = "";
    setActionBusy(true); setActionMessage(""); setPreview(null);
    previewAdminScanJourneyAction({ ...target, action, reason: boundReason })
      .then(value => {
        if (generation === detailGeneration.current)
          setPreview({
            ...value, reason: boundReason,
          });
      })
      .catch(() => {
        if (generation === detailGeneration.current)
          setActionMessage("The request changed or this action is unavailable. Refresh its details.");
      })
      .finally(() => { if (generation === detailGeneration.current) setActionBusy(false); });
  };

  const finishAction = () => {
    if (!preview || actionBusy) return;
    const generation = detailGeneration.current;
    setActionBusy(true); setActionMessage("");
    executeAdminScanJourneyAction({
      confirmation_handle: preview.confirmation_handle, reason: preview.reason,
    })
      .then(() => {
        if (generation !== detailGeneration.current) return;
        setActionMessage("Request closed.");
        setPreview(null); setPendingOperation(null);
        fetchAdminScanJourneyRecord(preview.journey_id, preview.slug)
          .then(value => {
            if (generation !== detailGeneration.current) return;
            setDetail(value);
            setPendingOperation(value.management_operation_id || null);
          })
          .catch(() => {});
        setRevision(value => value + 1);
      })
      .catch(async () => {
        if (generation !== detailGeneration.current) return;
        try {
          const status = await fetchAdminScanJourneyActionStatus(preview.operation_id, preview.journey_id, preview.slug);
          if (generation !== detailGeneration.current) return;
          if (status.status === "applied") {
            setActionMessage("Request closed.");
            setPreview(null); setRevision(value => value + 1);
          } else if (status.status === "pending_verification") {
            setPendingOperation(preview.operation_id);
            setActionMessage("Close needs verification. Verify this same operation before starting another request.");
          } else setActionMessage(status.status === "outcome_unavailable"
            ? "Request no longer current; previous outcome unavailable."
            : "The close did not apply. Refresh the request before trying again.");
        } catch {
          if (generation === detailGeneration.current) {
            setPendingOperation(preview.operation_id);
            setActionMessage("Action status is unavailable. Verify this same operation before another action.");
          }
        }
      })
      .finally(() => { if (generation === detailGeneration.current) setActionBusy(false); });
  };

  const verifyPending = () => {
    if (!pendingOperation || actionBusy) return;
    const generation = detailGeneration.current;
    setActionBusy(true);
    executeAdminScanJourneyAction({ operation_id: pendingOperation, journey_id: selected.journey_id, slug: selected.slug })
      .then(value => {
        if (generation !== detailGeneration.current) return;
        setActionMessage(value.status === "applied"
          ? (["archive", "restore"].includes(value.action) ? "Action verified." : "Request closed.")
          : value.status === "outcome_unavailable" ? "Request no longer current; previous outcome unavailable."
          : "The close did not apply. Refresh before another action.");
        setPendingOperation(null); setPreview(null); setRevision(item => item + 1);
        if (value.status === "applied") {
          fetchAdminScanJourneyRecord(selected.journey_id, selected.slug)
            .then(next => {
              if (generation !== detailGeneration.current) return;
              setDetail(next);
              setPendingOperation(next.management_operation_id || null);
            })
            .catch(() => {
              if (generation === detailGeneration.current)
                setDetailError("The action was verified. Refresh its details to see the current state.");
            });
        }
      })
      .catch(() => {
        if (generation === detailGeneration.current)
          setActionMessage("Verification remains unavailable. Keep this operation ID for investigation.");
      })
      .finally(() => { if (generation === detailGeneration.current) setActionBusy(false); });
  };

  const verifyRunTracking = target => {
    if (!detail?.run_reconciliations?.some(item =>
      item.kind === target.kind && item.run_id === target.run_id
      && item.attempt_id === target.attempt_id) || actionBusy) return;
    const generation = detailGeneration.current;
    setActionBusy(true);
    executeAdminScanJourneyAction(target)
      .then(value => {
        if (generation !== detailGeneration.current) return;
        setActionMessage(value.run_tracking === "confirmed"
          ? "Run tracking verified." : "Run tracking is still pending.");
        fetchAdminScanJourneyRecord(target.journey_id, target.slug)
          .then(next => { if (generation === detailGeneration.current) setDetail(next); })
          .catch(() => {});
      })
      .catch(() => {
        if (generation === detailGeneration.current)
          setActionMessage("Run tracking could not be verified. No new run was started.");
      })
      .finally(() => { if (generation === detailGeneration.current) setActionBusy(false); });
  };

  const lookUpOriginalRun = (kind, cursor) => {
    if (!detail || actionBusy || !detail.run_lookup_kinds?.includes(kind)) return;
    const generation = detailGeneration.current;
    const { journey_id, slug } = detail;
    setActionBusy(true); setActionMessage("");
    fetchAdminScanJourneyRecord(journey_id, slug, { kind, cursor })
      .then(value => {
        if (generation !== detailGeneration.current) return;
        setDetail(value);
        if (value.run_lookup?.status === "unknown")
          setActionMessage("The original run could not be verified. No new run was started.");
        if (value.run_lookup?.status === "conflict")
          setActionMessage("Conflicting run evidence needs investigation. No new run was started.");
      })
      .catch(() => {
        if (generation === detailGeneration.current)
          setActionMessage("Run evidence is unavailable. No new run was started.");
      })
      .finally(() => { if (generation === detailGeneration.current) setActionBusy(false); });
  };

  const isSelectedRow = row => selected && (selected.diagnostic
    ? row.diagnostic && selected.reference === row.reference
    : !row.diagnostic && selected.journey_id === row.journey_id && selected.slug === row.slug);
  const customerDashboardHref = detail?.slug ? getCustomerDashboardHref?.(detail.slug) : null;
  const renderSelectedRequest = () => <>
      {selected?.diagnostic && <div role="region" aria-label="Unavailable journey details" style={{ borderTop:`1px solid ${T.border}`, marginTop:12, paddingTop:10 }}>
        <strong>Journey unavailable</strong>
        <div style={{ marginTop:6 }}>This record could not be verified. Investigation reference {selected.reference}.</div>
        <div style={{ color:T.muted, marginTop:5 }}>No request action is available. Restart the listing after the source record is checked.</div>
      </div>}
      {selected && !selected.diagnostic && <div role="region" aria-label="Request details" style={{ borderTop:`1px solid ${T.border}`, marginTop:12, paddingTop:10 }}>
        <div style={{ display:"flex", justifyContent:"space-between" }}><strong>Request details</strong><button onClick={refreshExact}>Refresh details</button></div>
        {detailError && <div style={{ color:T.yellow }}>{detailError}</div>}
        {!detail && !detailError && <div>Loading this request…</div>}
        {detail && <>
          <div style={{ marginTop:6 }}>{detail.customer_name || customers[detail.slug] || detail.slug} · {detail.status === "action_pending_verification" ? "Close needs verification" : detail.phase === "capped" ? "Scan limit reached" : detail.phase}</div>
          <div style={{ color:T.muted, fontSize:11 }}>Requested {fmtInstant(detail.created_utc)} · updated {fmtInstant(detail.updated_utc)} · initiated by {detail.initiated_by} ({detail.started_by})</div>
          <div style={{ marginTop:5 }}>Prerequisite: {detail.prerequisite_outcome || "Unknown"}. Assessment outcome: {detail.run_outcome || "Unknown"}.</div>
          {detail.run_tracking && <div>Run tracking: {detail.run_tracking}</div>}
          {Object.entries(detail.run_tracking_by_kind || {}).map(([kind, status]) =>
            <div key={kind}>{kind === "prerequisite" ? "Prerequisite" : "Assessment"} run tracking: {status}</div>)}
          {(detail.run_reconciliations || []).map(target =>
            <button key={target.kind} onClick={() => verifyRunTracking(target)}
              disabled={actionBusy || !detail.capabilities?.writable}>
              Verify {target.kind} run tracking
            </button>)}
          {(detail.run_lookup_kinds || []).filter(kind =>
            !(detail.run_lookup?.kind === kind && detail.run_lookup?.status === "more"))
            .map(kind => <button key={kind} onClick={() => lookUpOriginalRun(kind)}
              disabled={actionBusy}>Find original {kind} run</button>)}
          {detail.run_lookup?.status === "more" && <button
            onClick={() => lookUpOriginalRun(detail.run_lookup.kind, detail.run_lookup.next_cursor)}
            disabled={actionBusy}>Continue {detail.run_lookup.kind} run lookup</button>}
          {detail.result_run_id && <button onClick={() => onDownloadResult?.(detail.result_run_id)} style={{ color:T.blue }}>Download verified result for run {detail.result_run_id}</button>}
          {!detail.result_run_id && <div style={{ color:T.muted }}>Associated result: Unknown.</div>}
          {detail.closure && <div style={{ marginTop:5 }}>Closed {fmtInstant(detail.closure.at_utc)} by operator {journeyOperator(detail.closure.actor)}. Reason: {detail.closure.reason}</div>}
          {detail.phase === "capped" && detail.next_available_utc && <div>Next available {fmtInstant(detail.next_available_utc)}.</div>}
          {detail.phase === "held" && <div>The result is held for review. Open the customer to view its review status.</div>}
          {detail.capabilities?.pending && <div style={{ color:T.yellow }}>Close needs verification. Another action is unavailable.</div>}
          {!detail.capabilities?.close && <div style={{ color:T.muted }}>Close is unavailable for this request in its current phase.</div>}
          <div style={{ display:"flex", gap:7, marginTop:8 }}>
            {detail.capabilities?.close && <button onClick={() => prepareAction("close")} disabled={actionBusy}>Close request</button>}
            {customerDashboardHref && <a href={customerDashboardHref} style={{ color:T.blue }}>Open customer</a>}
            {detail.phase === "abandoned" && !detail.capabilities?.pending && <button onClick={() => onSelect?.(detail.slug)}>Start a fresh request</button>}
          </div>
        </>}
        {preview && <div role="dialog" aria-label="Close this request?" style={{ border:`1px solid ${T.yellow}`, padding:10, marginTop:10 }}>
          <strong>Close this request?</strong>
          <div style={{ marginTop:5 }}>{customers[preview.slug] || preview.slug} · original request {fmtInstant(preview.created_utc)} · {preview.phase}</div>
          <p>This removes this request from the operations queue and stops its future portal steps. Work already started may still finish and publish normally. Published scans and results will be kept. You can submit a fresh request through the usual checks.</p>
          {!detail?.capabilities?.writable && <div style={{ color:T.yellow }}>Execution is off. This preview made no change.</div>}
          <button onClick={() => setPreview(null)} disabled={actionBusy}>Keep request</button>{" "}
          <button onClick={finishAction} disabled={actionBusy || !detail?.capabilities?.writable}>Close request</button>
        </div>}
        {pendingOperation && <button onClick={verifyPending} disabled={actionBusy || !detail?.capabilities?.writable}>Verify this close</button>}
        {actionMessage && <div style={{ marginTop:8, color:T.yellow }}>{actionMessage}</div>}
        {actionMessage === "Request closed." && detail?.phase !== "abandoned" && <button onClick={() => onSelect?.(selected.slug)}>Start a fresh request</button>}
      </div>}
  </>;

  if (backendMode === "legacy") return <LegacyAdminScanJourneysPanel onSelect={onSelect} />;
  return (
    <details style={{ border:`1px solid ${T.border}`, borderRadius:10, padding:"12px 14px", marginBottom:18, color:T.text, fontSize:12 }}>
      <summary style={{ cursor:"pointer" }}><strong>Scan requests</strong></summary>
      <div style={{ display:"flex", justifyContent:"space-between", gap:8, marginTop:4 }}>
        <div style={{ color:T.muted, fontSize:11 }}>Open requests in the loaded pages. Records can change between reads.</div>
        <button onClick={restart} style={{ border:0, background:"none", color:T.blue, cursor:"pointer" }}>Restart listing</button>
      </div>
      <div style={{ display:"flex", flexWrap:"wrap", gap:6, marginTop:9 }}>
        <select aria-label="Request status" value={filter} onChange={event => { clearExact(); setFilter(event.target.value); }}>
          <option value="all_open">All open</option><option value="in_progress">In progress</option><option value="needs_attention">Needs attention</option>
        </select>
        <select aria-label="Request customer" value={customer} onChange={event => { clearExact(); setCustomer(event.target.value); }}>
          <option value="">All customers</option>
          {Object.entries(customers).sort((a,b) => String(a[1]).localeCompare(String(b[1]))).map(([slug, label]) => <option value={slug} key={slug}>{label || slug}</option>)}
        </select>
      </div>
      {error && <div style={{ color:T.red, marginTop:8 }}>{error}</div>}
      {rows.map(row => <div key={row.journey_id || row.reference} style={{ borderTop:`1px solid ${T.border}`, padding:"8px 0", marginTop:7 }}>
        {row.diagnostic ? <>
          <span style={{ color:T.yellow }}>Unavailable journey · investigation reference {row.reference}</span>
          <button onClick={() => openDiagnostic(row)} style={{ display:"block", border:0, padding:0, marginTop:4, background:"none", color:T.blue, cursor:"pointer" }}>Inspect journey status</button>
        </> : <>
          <div><b>{row.customer_name || row.slug}</b> · {row.status === "action_pending_verification" ? "Close needs verification" : row.phase === "capped" ? "Scan limit reached" : row.phase}</div>
          <div style={{ color:T.muted, fontSize:11 }}>Requested {fmtInstant(row.created_utc)} · updated {fmtInstant(row.updated_utc)}</div>
          <button onClick={() => openExact(row)} style={{ border:0, padding:0, marginTop:4, background:"none", color:T.blue, cursor:"pointer" }}>View this request</button>
        </>}
        {isSelectedRow(row) && renderSelectedRequest()}
      </div>)}
      {!rows.length && !loading && !error && <div style={{ marginTop:9, color:T.muted }}>No matches on this page. More pages may contain matches.</div>}
      {cursor && <button onClick={loadMore} disabled={loading} style={{ marginTop:8 }}>Load more</button>}
      {loading && <div style={{ color:T.muted, marginTop:8 }}>Loading…</div>}
      {asOf && <div style={{ color:T.muted, fontSize:10, marginTop:8 }}>Last read {fmtInstant(asOf)}.</div>}
      {selected && !rows.some(isSelectedRow) && <div style={{ marginTop:12 }}>
        <div style={{ color:T.muted }}>Selected request outside the loaded list</div>
        {renderSelectedRequest()}
      </div>}
    </details>
  );
};

/* ── Compensating Control Packages (Patriot-only) ──────────────────────
 * Lets an auditor apply a pre-built package (e.g. Proofpoint = 30 settings) to a
 * customer in one action during onboarding. Flow: pick package → preview (with a
 * prominent warning for settings that already have overrides that will be
 * REPLACED) → confirm/apply → result summary → refresh the dashboard. Also lists
 * packages already applied to this customer (settings stamped with the package),
 * each with a Remove action. Mounted only for Patriot/internal users.
 */
const DispositionBadge = ({ dispKey }) => {
  const c = dispositionColor(dispKey);
  return (
    <span style={{
      fontSize: 11, fontWeight: 700, padding: "3px 9px", borderRadius: 6, whiteSpace: "nowrap",
      background: `${c}26`, color: c, border: `1px solid ${c}66`,
    }}>{dispositionLabel(dispKey)}</span>
  );
};

const CompensatingControlPackages = ({ slug, isPatriot, onChanged }) => {
  const [packages, setPackages] = useState([]);
  const [appliedCounts, setAppliedCounts] = useState({}); // {packageId: settingsAppliedCount}
  const [loading, setLoading] = useState(false);
  const [loadError, setLoadError] = useState(null);

  const [modalOpen, setModalOpen] = useState(false);
  const [step, setStep] = useState("pick"); // pick | preview | result
  const [selectedId, setSelectedId] = useState(null);
  const [preview, setPreview] = useState(null);
  const [previewLoading, setPreviewLoading] = useState(false);
  const [busy, setBusy] = useState(false); // apply/remove in flight
  const [result, setResult] = useState(null);
  const [actionError, setActionError] = useState(null);
  const [removingId, setRemovingId] = useState(null);

  // Load the active packages and, for each, how many settings are already applied
  // to THIS customer (preview.already_applied_count). Reuses the existing preview
  // endpoint — no extra backend surface. Patriot-only and a small N (handful of
  // packages), but each preview is wrapped so one failure never blocks the rest.
  const loadPackages = useCallback(async () => {
    if (!slug || !isPatriot) return;
    setLoading(true);
    setLoadError(null);
    try {
      const data = await listPackages();
      const list = (data && data.packages) || [];
      setPackages(list);
      const counts = {};
      await Promise.all(list.map(async (p) => {
        try {
          const pv = await previewPackage(p.id, slug);
          if (pv && pv.already_applied_count > 0) counts[p.id] = pv.already_applied_count;
        } catch { /* ignore per-package preview failure for the applied summary */ }
      }));
      setAppliedCounts(counts);
    } catch (err) {
      setLoadError(err.message || "Failed to load packages");
      setPackages([]);
    } finally {
      setLoading(false);
    }
  }, [slug, isPatriot]);

  useEffect(() => { loadPackages(); }, [loadPackages]);

  const openModal = () => {
    setStep("pick");
    setSelectedId(null);
    setPreview(null);
    setResult(null);
    setActionError(null);
    setModalOpen(true);
  };
  const closeModal = () => { if (!busy) setModalOpen(false); };

  const handleSelect = async (pkgId) => {
    setSelectedId(pkgId);
    setActionError(null);
    setPreviewLoading(true);
    setPreview(null);
    try {
      const pv = await previewPackage(pkgId, slug);
      setPreview(pv);
      setStep("preview");
    } catch (err) {
      setActionError(err.message || "Failed to load preview");
    } finally {
      setPreviewLoading(false);
    }
  };

  const handleApply = async () => {
    if (!selectedId || busy) return;
    setBusy(true);
    setActionError(null);
    try {
      const summary = await applyPackage(selectedId, slug);
      setResult(summary);
      setStep("result");
      await loadPackages();        // refresh the applied-packages summary
      if (onChanged) await onChanged();  // refresh dashboard overrides/scores
    } catch (err) {
      setActionError(err.message || "Failed to apply package");
    } finally {
      setBusy(false);
    }
  };

  const handleRemove = async (pkgId) => {
    if (removingId) return;
    if (!window.confirm("Remove this package's overrides from the customer? Each setting stamped with this package will be cleared (with history).")) return;
    setRemovingId(pkgId);
    setActionError(null);
    try {
      await removePackage(pkgId, slug);
      await loadPackages();
      if (onChanged) await onChanged();
    } catch (err) {
      setActionError(err.message || "Failed to remove package");
    } finally {
      setRemovingId(null);
    }
  };

  if (!isPatriot) return null;

  const selectedPkg = packages.find(p => p.id === selectedId) || null;
  const appliedList = packages.filter(p => appliedCounts[p.id] > 0);

  return (
    <div style={{ marginBottom: 12, display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap" }}>
      {/* Resting state: a single compact Patriot-tool button. The full picker /
          preview / apply flow and the applied-packages list live in the modal. */}
      <Btn onClick={openModal} style={{ display: "inline-flex", alignItems: "center", gap: 8 }}>
        Compensating Control Packages
        {appliedList.length > 0 && (
          <span style={{
            fontSize: 10, fontWeight: 800, lineHeight: 1, padding: "3px 7px", borderRadius: 999,
            background: "rgba(83,196,109,.18)", color: T.green, border: "1px solid rgba(83,196,109,.45)",
          }}>{appliedList.length} applied</span>
        )}
      </Btn>
      {(loadError || (actionError && !modalOpen)) && (
        <span style={{ fontSize: 12, color: T.red }}>{loadError || actionError}</span>
      )}

      {/* Modal: pick → preview → result */}
      {modalOpen && (
        <div onClick={closeModal} style={{
          position: "fixed", inset: 0, background: "rgba(0,0,0,0.55)", zIndex: 1000,
          display: "flex", justifyContent: "center", alignItems: "center", padding: 16,
        }}>
          <div onClick={e => e.stopPropagation()} style={{
            background: T.panel, border: `1px solid ${T.border}`, borderRadius: 18,
            width: 620, maxWidth: "94vw", maxHeight: "88vh", display: "flex", flexDirection: "column",
            boxShadow: "0 12px 40px rgba(0,0,0,0.45)",
          }}>
            {/* Header */}
            <div style={{ padding: "18px 22px 12px", borderBottom: `1px solid ${T.border}` }}>
              <h3 style={{ fontSize: 16, fontWeight: 700, color: T.text }}>
                {step === "result" ? "Package Applied" : "Apply Compensating Control Package"}
              </h3>
              <div style={{ fontSize: 12, color: T.muted, marginTop: 3 }}>
                {step === "pick" && "Select a package to apply to this customer."}
                {step === "preview" && selectedPkg && `${selectedPkg.name} · ${selectedPkg.vendor}`}
                {step === "result" && selectedPkg && selectedPkg.name}
              </div>
            </div>

            {/* Body */}
            <div style={{ padding: "16px 22px", overflowY: "auto", flex: 1 }}>
              {actionError && (
                <div style={{
                  fontSize: 12, color: T.red, background: "rgba(225,77,87,.12)",
                  border: "1px solid rgba(225,77,87,.4)", borderRadius: 8, padding: "8px 10px", marginBottom: 12,
                }}>{actionError}</div>
              )}

              {/* STEP 1 — pick */}
              {step === "pick" && (
                <div>
                  {/* Packages already applied to this customer — shown first so an
                      auditor opening the modal sees current state, with Remove. */}
                  {appliedList.length > 0 && (
                    <div style={{ marginBottom: 16, paddingBottom: 16, borderBottom: `1px solid ${T.border}` }}>
                      <div style={{ fontSize: 11, fontWeight: 700, color: T.muted, marginBottom: 6 }}>
                        Applied to this customer
                      </div>
                      <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
                        {appliedList.map(p => (
                          <div key={p.id} style={{
                            display: "flex", alignItems: "center", justifyContent: "space-between", gap: 10,
                            padding: "8px 10px", borderRadius: 8, background: "rgba(255,255,255,.03)",
                            border: `1px solid ${T.border}`,
                          }}>
                            <div style={{ minWidth: 0 }}>
                              <div style={{ fontSize: 13, fontWeight: 600, color: T.text }}>
                                {p.name} <span style={{ color: T.muted, fontWeight: 400 }}>· {p.vendor}</span>
                              </div>
                              <div style={{ fontSize: 11, color: T.muted, marginTop: 2 }}>
                                <DispositionBadge dispKey={p.default_status} />
                                <span style={{ marginLeft: 8 }}>{appliedCounts[p.id]} setting{appliedCounts[p.id] === 1 ? "" : "s"} applied</span>
                              </div>
                            </div>
                            <Btn del onClick={() => handleRemove(p.id)} disabled={!!removingId}>
                              {removingId === p.id ? "Removing…" : "Remove package"}
                            </Btn>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}

                  {/* Picker */}
                  {loading ? (
                    <div style={{ fontSize: 13, color: T.muted }}>Loading packages…</div>
                  ) : packages.length === 0 ? (
                    <div style={{ fontSize: 13, color: T.muted }}>No active packages available.</div>
                  ) : (
                    <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                      {packages.map(p => (
                        <button key={p.id} onClick={() => handleSelect(p.id)} disabled={previewLoading} style={{
                          textAlign: "left", cursor: previewLoading ? "wait" : "pointer", fontFamily: "inherit",
                          padding: "12px 14px", borderRadius: 10, background: "rgba(255,255,255,.03)",
                          border: `1px solid ${selectedId === p.id ? T.blue : T.border}`, color: T.text,
                        }}>
                          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 10 }}>
                            <div style={{ fontSize: 14, fontWeight: 700 }}>
                              {p.name} <span style={{ color: T.muted, fontWeight: 400, fontSize: 12 }}>· {p.vendor}</span>
                            </div>
                            <DispositionBadge dispKey={p.default_status} />
                          </div>
                          {p.description && (
                            <div style={{ fontSize: 12, color: T.muted, marginTop: 6, lineHeight: 1.5 }}>{p.description}</div>
                          )}
                          {appliedCounts[p.id] > 0 && (
                            <div style={{ fontSize: 11, color: T.green, marginTop: 6 }}>
                              ✓ Already applied to this customer ({appliedCounts[p.id]} settings)
                            </div>
                          )}
                        </button>
                      ))}
                      {previewLoading && <div style={{ fontSize: 12, color: T.muted }}>Loading preview…</div>}
                    </div>
                  )}
                </div>
              )}

              {/* STEP 2 — preview */}
              {step === "preview" && preview && (
                <div>
                  <div style={{ display: "flex", gap: 18, flexWrap: "wrap", marginBottom: 14 }}>
                    <div>
                      <div style={{ fontSize: 11, color: T.muted, marginBottom: 4 }}>Disposition applied to all settings</div>
                      <DispositionBadge dispKey={preview.disposition_key} />
                    </div>
                    <div>
                      <div style={{ fontSize: 11, color: T.muted, marginBottom: 4 }}>Settings</div>
                      <div style={{ fontSize: 15, fontWeight: 700, color: T.text }}>{preview.total_settings}</div>
                    </div>
                  </div>

                  {preview.default_reason && (
                    <div style={{ fontSize: 12, color: T.muted, marginBottom: 12 }}>
                      <span style={{ color: T.text, fontWeight: 600 }}>Default reason: </span>{preview.default_reason}
                    </div>
                  )}

                  {/* Prominent replace warning — the safety mechanism */}
                  {preview.already_overridden_count > 0 && (
                    <div style={{
                      display: "flex", gap: 10, alignItems: "flex-start",
                      background: "rgba(243,181,63,.12)", border: "1px solid rgba(243,181,63,.5)",
                      borderRadius: 10, padding: "12px 14px", marginBottom: 14,
                    }}>
                      <span style={{ fontSize: 18, lineHeight: 1 }}>⚠</span>
                      <div style={{ fontSize: 13, color: T.text }}>
                        <strong style={{ color: T.yellow }}>
                          {preview.already_overridden_count} setting{preview.already_overridden_count === 1 ? "" : "s"} already {preview.already_overridden_count === 1 ? "has" : "have"} an override that will be replaced.
                        </strong>
                        <div style={{ color: T.muted, marginTop: 3 }}>
                          Applying overwrites the current disposition on these settings. Existing values are shown below.
                        </div>
                      </div>
                    </div>
                  )}

                  {/* Per-setting list */}
                  <div style={{ border: `1px solid ${T.border}`, borderRadius: 10, overflow: "hidden" }}>
                    <div style={{ maxHeight: 280, overflowY: "auto" }}>
                      {preview.settings.map((s, i) => (
                        <div key={s.setting_id} style={{
                          display: "flex", alignItems: "flex-start", gap: 10, padding: "9px 12px",
                          borderTop: i === 0 ? "none" : `1px solid ${T.border}`,
                          background: s.already_overridden ? "rgba(243,181,63,.07)" : "transparent",
                        }}>
                          <div style={{ fontSize: 12, color: T.muted, fontVariantNumeric: "tabular-nums", minWidth: 52 }}>
                            #{s.setting_id}
                          </div>
                          <div style={{ flex: 1, minWidth: 0 }}>
                            <div style={{ fontSize: 12, color: T.text }}>
                              {s.reason || <span style={{ color: T.muted }}>(no reason)</span>}
                              {s.uses_setting_specific_reason && (
                                <span style={{ fontSize: 10, color: T.blue, marginLeft: 6 }}>setting-specific</span>
                              )}
                            </div>
                            {s.already_overridden && (
                              <div style={{ fontSize: 11, color: T.yellow, marginTop: 3 }}>
                                ⚠ will replace current: <strong>{dispositionLabel(s.existing_override)}</strong>
                              </div>
                            )}
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              )}

              {/* STEP 3 — result */}
              {step === "result" && result && (
                <div>
                  <div style={{ display: "flex", gap: 12, flexWrap: "wrap", marginBottom: 8 }}>
                    <div style={{ flex: 1, minWidth: 120, padding: "12px 14px", borderRadius: 10, background: "rgba(83,196,109,.1)", border: "1px solid rgba(83,196,109,.4)" }}>
                      <div style={{ fontSize: 22, fontWeight: 800, color: T.green }}>{result.applied_count}</div>
                      <div style={{ fontSize: 11, color: T.muted }}>settings applied</div>
                    </div>
                    <div style={{ flex: 1, minWidth: 120, padding: "12px 14px", borderRadius: 10, background: "rgba(243,181,63,.1)", border: "1px solid rgba(243,181,63,.4)" }}>
                      <div style={{ fontSize: 22, fontWeight: 800, color: T.yellow }}>{result.pre_existing_count}</div>
                      <div style={{ fontSize: 11, color: T.muted }}>pre-existing replaced</div>
                    </div>
                    {result.skipped_count > 0 && (
                      <div style={{ flex: 1, minWidth: 120, padding: "12px 14px", borderRadius: 10, background: "rgba(225,77,87,.1)", border: "1px solid rgba(225,77,87,.4)" }}>
                        <div style={{ fontSize: 22, fontWeight: 800, color: T.red }}>{result.skipped_count}</div>
                        <div style={{ fontSize: 11, color: T.muted }}>skipped (write failed)</div>
                      </div>
                    )}
                  </div>
                  <div style={{ fontSize: 12, color: T.muted }}>
                    The dashboard has been refreshed — these overrides now appear on the recommendations.
                  </div>
                </div>
              )}
            </div>

            {/* Footer */}
            <div style={{ padding: "12px 22px", borderTop: `1px solid ${T.border}`, display: "flex", justifyContent: "space-between", gap: 8 }}>
              <div>
                {step === "preview" && (
                  <Btn onClick={() => { setStep("pick"); setActionError(null); }} disabled={busy}>← Back</Btn>
                )}
              </div>
              <div style={{ display: "flex", gap: 8 }}>
                {step !== "result" && <Btn onClick={closeModal}>Cancel</Btn>}
                {step === "preview" && (
                  <Btn pri onClick={handleApply} disabled={busy}>
                    {busy
                      ? "Applying…"
                      : preview && preview.already_overridden_count > 0
                        ? `Apply & replace ${preview.already_overridden_count}`
                        : `Apply ${preview ? preview.total_settings : ""} settings`}
                  </Btn>
                )}
                {step === "result" && <Btn pri onClick={() => setModalOpen(false)}>Done</Btn>}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const ViewToggle = ({ options, value, onChange, size = "md" }) => {
  const sm = size === "sm";
  return (
    <div style={{ display:"inline-flex", background:"rgba(255,255,255,.06)", border:`1px solid ${T.border}`, borderRadius: sm ? 8 : 10, overflow:"hidden" }}>
      {options.map(o => (
        <button key={o.value} onClick={() => onChange(o.value)} style={{
          padding: sm ? "3px 10px" : "7px 14px", fontSize: sm ? 11 : 12, fontWeight:600,
          background: value === o.value ? (sm ? "rgba(68,166,255,.14)" : "rgba(68,166,255,.2)") : "transparent",
          border:"none", color: value === o.value ? T.blue : T.muted, cursor:"pointer", fontFamily:"inherit", transition:".15s",
        }}>{o.label}</button>
      ))}
    </div>
  );
};

const UserImpactTag = ({ level }) => {
  const map = {
    none: { bg:"rgba(83,196,109,.15)", c:T.green, label:"None" },
    low: { bg:"rgba(243,181,63,.15)", c:T.yellow, label:"Low" },
    moderate: { bg:"rgba(255,122,69,.15)", c:T.orange, label:"Moderate" },
    significant: { bg:"rgba(225,77,87,.15)", c:T.red, label:"Significant" },
  };
  const s = map[level] || map.low;
  return <span style={{ fontSize:10, fontWeight:700, padding:"3px 8px", borderRadius:6, whiteSpace:"nowrap", background:s.bg, color:s.c }}>{s.label}</span>;
};

/* ── Score Ring (CSS conic-gradient) ── */
const ScoreRing = ({ value, color, size = 160, label }) => (
  <div style={{
    width:size, height:size, margin:"8px auto 14px", borderRadius:"50%", display:"grid", placeItems:"center", position:"relative",
    background:`conic-gradient(${color} 0 ${value}%, rgba(255,255,255,.09) ${value}% 100%)`,
  }}>
    <div style={{ position:"absolute", width:"70%", height:"70%", background:"linear-gradient(180deg,#0b2340,#102b4d)", borderRadius:"50%", border:"1px solid rgba(255,255,255,.06)" }} />
    <div style={{ position:"relative", textAlign:"center", zIndex:1 }}>
      <div style={{ fontSize:42, fontWeight:800, lineHeight:1, color: color === T.blue ? T.blue : T.text }}>{value}%</div>
      <div style={{ color:T.muted, fontSize:11, marginTop:6 }}>{label}</div>
    </div>
  </div>
);

// Phase E — Multi-slice category donut.
// SVG-based pie/donut chart with click handling on slices.
// slices: [{ cat: string, gap: number, max: number }, ...] in display order
// centerLabel: text for the donut hole (e.g., "64%")
// centerSub: smaller text under the center label (e.g., "Patriot Score")
// onSliceClick: optional callback when a slice is clicked, receives the cat name
// Softer palette matching the Recommendation Status donut aesthetic.
// Muted/pastel tones — easier on the eyes than full-saturation.
const SLICE_COLORS = [
  "#F87171", // soft red
  "#FB923C", // soft orange
  "#FBBF24", // soft amber
  "#A3E635", // soft lime
  "#22D3EE", // soft cyan
  "#60A5FA", // soft blue
  "#C084FC", // soft purple
  "#F472B6", // soft pink
  "#94A3B8", // "Other" — neutral slate (unchanged)
];

// Phase E2 — Semantic palette for the Risk-Adjusted composition donut now lives
// in ./composition (OVERRIDE_SLICE_COLORS), the single source shared with the PDF
// export, and is imported at the top of this file.

const CategoryDonut = ({ slices, centerLabel, centerSub, onSliceClick, size = 200 }) => {
  if (!slices || slices.length === 0) {
    return (
      <div style={{ width: size, height: size, margin: "8px auto 14px", display: "grid", placeItems: "center", color: T.muted, fontSize: 12 }}>
        No gap detected
      </div>
    );
  }
  const total = slices.reduce((s, x) => s + (x.pts !== undefined ? x.pts : x.gap), 0);
  if (total === 0) {
    return (
      <div style={{ width: size, height: size, margin: "8px auto 14px", display: "grid", placeItems: "center", color: T.muted, fontSize: 12 }}>
        100% satisfied
      </div>
    );
  }
  const cx = size / 2;
  const cy = size / 2;
  const r = size / 2 - 6;
  const innerR = r * 0.62;
  let cumulative = 0;
  const paths = slices.map((s, i) => {
    // Phase E2 — Slices may be category (cat/gap) or composition (key/label/pts).
    // Normalize for downstream use. Computed first so sliceAngle (and downstream
    // path math) reads the right field for both slice shapes.
    const displayLabel = s.label || s.cat;
    const displayPts = s.pts !== undefined ? s.pts : s.gap;
    const displayKey = s.key || s.cat;
    const sliceAngle = (displayPts / total) * 360;
    const startAngle = cumulative;
    const endAngle = cumulative + sliceAngle;
    cumulative = endAngle;
    const sa = ((startAngle - 90) * Math.PI) / 180;
    const ea = ((endAngle - 90) * Math.PI) / 180;
    const x1 = cx + r * Math.cos(sa);
    const y1 = cy + r * Math.sin(sa);
    const x2 = cx + r * Math.cos(ea);
    const y2 = cy + r * Math.sin(ea);
    const x3 = cx + innerR * Math.cos(ea);
    const y3 = cy + innerR * Math.sin(ea);
    const x4 = cx + innerR * Math.cos(sa);
    const y4 = cy + innerR * Math.sin(sa);
    const largeArc = sliceAngle > 180 ? 1 : 0;
    const pathD = `M ${x1} ${y1} A ${r} ${r} 0 ${largeArc} 1 ${x2} ${y2} L ${x3} ${y3} A ${innerR} ${innerR} 0 ${largeArc} 0 ${x4} ${y4} Z`;
    // Phase E2 — Use semantic palette for composition slices (those with .key),
    // category palette for category slices (those with .cat).
    const color = s.key
      ? OVERRIDE_SLICE_COLORS[s.key]
      : s.cat === "Other"
        ? SLICE_COLORS[8]
        : SLICE_COLORS[i % 8];
    return {
      pathD,
      color,
      label: displayLabel,
      pts: displayPts,
      pct: Math.round(100 * displayPts / total),
      clickKey: displayKey,  // what gets passed to onSliceClick
      isComposition: !!s.key,
    };
  });
  return (
    <div style={{ width: size, height: size, margin: "8px auto 4px", position: "relative" }}>
      <svg width={size} height={size} style={{ display: "block" }}>
        {paths.map((p, i) => (
          <path
            key={i}
            d={p.pathD}
            fill={p.color}
            stroke="rgba(11,35,64,0.9)"
            strokeWidth="2"
            style={{ cursor: onSliceClick ? "pointer" : "default", transition: "opacity 120ms" }}
            onClick={onSliceClick ? () => onSliceClick(p.clickKey, p.isComposition) : undefined}
            onMouseEnter={e => e.currentTarget.style.opacity = "0.85"}
            onMouseLeave={e => e.currentTarget.style.opacity = "1"}
          >
            <title>{`${p.label}: ${p.pts} pts (${p.pct}%)`}</title>
          </path>
        ))}
      </svg>
      <div style={{ position: "absolute", inset: 0, display: "grid", placeItems: "center", textAlign: "center", pointerEvents: "none" }}>
        <div>
          <div style={{ fontSize: 26, fontWeight: 800, lineHeight: 1, color: T.text }}>{centerLabel}</div>
          {centerSub && <div style={{ color: T.muted, fontSize: 10, marginTop: 4 }}>{centerSub}</div>}
        </div>
      </div>
    </div>
  );
};

// Legend for the donut — vertical list of color swatches + category labels
const CategoryDonutLegend = ({ slices, onItemClick }) => {
  if (!slices || slices.length === 0) return null;
  const total = slices.reduce((s, x) => s + (x.pts !== undefined ? x.pts : x.gap), 0);
  if (total === 0) return null;
  return (
    <div style={{ fontSize: 11, color: T.muted, marginTop: 8 }}>
      {slices.map((s, i) => {
        const color = s.key
          ? OVERRIDE_SLICE_COLORS[s.key]
          : s.cat === "Other"
            ? SLICE_COLORS[8]
            : SLICE_COLORS[i % 8];
        const label = s.label || s.cat;
        const pts = s.pts !== undefined ? s.pts : s.gap;
        const pct = Math.round(100 * pts / total);
        const clickKey = s.key || s.cat;
        const isComposition = !!s.key;
        return (
          <div
            key={clickKey}
            onClick={onItemClick && label !== "Other" ? () => onItemClick(clickKey, isComposition) : undefined}
            style={{
              display: "flex", alignItems: "center", gap: 6, padding: "2px 0",
              cursor: onItemClick && label !== "Other" ? "pointer" : "default",
            }}
          >
            <span style={{ width: 8, height: 8, background: color, borderRadius: 2, flexShrink: 0 }} />
            <span style={{ color: T.text, flex: 1, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{label}</span>
            <span style={{ color: T.muted }}>{pct}%</span>
          </div>
        );
      })}
    </div>
  );
};

/* ── Gauge (Canvas) ── */
const Gauge = ({ used, total, color }) => {
  const ref = useRef(null);
  useEffect(() => {
    const canvas = ref.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    const dpr = window.devicePixelRatio || 1;
    canvas.width = 180 * dpr; canvas.height = 100 * dpr;
    canvas.style.width = "180px"; canvas.style.height = "100px";
    ctx.scale(dpr, dpr);
    const cx = 90, cy = 90, r = 70, sA = Math.PI, eA = 2 * Math.PI;
    const pct = Math.min(used / total, 1);
    ctx.beginPath(); ctx.arc(cx, cy, r, sA, eA); ctx.lineWidth = 18;
    ctx.strokeStyle = "rgba(255,255,255,.08)"; ctx.lineCap = "round"; ctx.stroke();
    ctx.beginPath(); ctx.arc(cx, cy, r, sA, sA + (eA - sA) * pct); ctx.lineWidth = 18;
    ctx.strokeStyle = color; ctx.lineCap = "round"; ctx.stroke();
    const nA = sA + (eA - sA) * pct;
    ctx.beginPath(); ctx.moveTo(cx, cy);
    ctx.lineTo(cx + Math.cos(nA) * (r - 8), cy + Math.sin(nA) * (r - 8));
    ctx.lineWidth = 2.5; ctx.strokeStyle = "#fff"; ctx.stroke();
    ctx.beginPath(); ctx.arc(cx, cy, 5, 0, 2 * Math.PI); ctx.fillStyle = "#fff"; ctx.fill();
    ctx.font = "600 10px DM Sans,sans-serif"; ctx.fillStyle = "#a8bddc";
    ctx.textAlign = "left"; ctx.fillText("0", cx - r - 4, cy + 14);
    ctx.textAlign = "right"; ctx.fillText(total + "h", cx + r + 4, cy + 14);
  }, [used, total, color]);
  return <canvas ref={ref} />;
};

/* ── Category Bars ──
   Real per-axis compliance bars. Each row is { name, max, earnedPatriot,
   earnedAdjusted }. The bar fills green (SecureShield / verified) to ssPct, then
   a purple segment (#8b72d6) carries it to adjPct — the risk-adjusted delta from
   accepted-risk + compensating-control overrides (adjPct >= ssPct always).
   Sorted descending by ssPct. Presentational only — no mock, no quarter index. */
const CatBars = ({ rows, onBarClick }) => {
  const computed = (rows || [])
    .map((r) => {
      const max = r.max || 0;
      const ssPct = max > 0 ? Math.round((r.earnedPatriot / max) * 100) : 0;
      const adjPct = max > 0 ? Math.round((r.earnedAdjusted / max) * 100) : 0;
      return { name: r.name, ssPct, adjPct };
    })
    // Alphabetical by name (walkthrough, July 7 2026) — was by percentage
    // desc; applies to both the Product and Security Domain lists.
    .sort((a, b) => (a.name || "").localeCompare(b.name || ""));

  if (computed.length === 0) {
    return <div style={{ fontSize:12, color:T.muted }}>No scored settings in this view.</div>;
  }

  return (
    <div>
      {computed.map((r) => {
        const lv = getLevel(r.ssPct);
        const deltaPct = Math.max(0, r.adjPct - r.ssPct);
        return (
          <div key={r.name} style={{ display:"flex", alignItems:"center", gap:8, marginBottom:8, fontSize:13 }}>
            <span onClick={onBarClick ? () => onBarClick(r.name) : undefined} title={r.name} style={{
              width:160, color: onBarClick ? T.blue : T.muted, textAlign:"right", flexShrink:0,
              cursor: onBarClick ? "pointer" : "default",
              textDecoration: onBarClick ? "underline dotted" : "none", textUnderlineOffset:3, transition:"color .15s",
              overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap",
            }}>{r.name}</span>
            <div style={{ flex:1, display:"flex", height:10, background:"rgba(255,255,255,.08)", borderRadius:999, overflow:"hidden" }}>
              <div style={{ height:"100%", width:`${r.ssPct}%`, background:T.green }} />
              {deltaPct > 0 && <div style={{ height:"100%", width:`${deltaPct}%`, background:"#8b72d6" }} />}
            </div>
            <span title="PSS = Patriot Secure Score · Adj = Risk-Adjusted Score" style={{ width:120, fontSize:11, color:T.muted, textAlign:"right", flexShrink:0 }}>
              {r.adjPct === r.ssPct ? `${r.ssPct}%` : `PSS ${r.ssPct}% · Adj ${r.adjPct}%`}
            </span>
            <span style={{ fontSize:10, fontWeight:700, padding:"2px 8px", borderRadius:6, whiteSpace:"nowrap", background:lv.bg, color:lv.tc, flexShrink:0 }}>{lv.t}</span>
          </div>
        );
      })}
    </div>
  );
};

/* ── Rank Strip ── */
const RankStrip = ({ pct }) => (
  <div>
    <div style={{ display:"flex", height:24, borderRadius:12, overflow:"hidden", margin:"10px 0 4px", position:"relative" }}>
      {[{w:40,c:"rgba(225,77,87,.25)"},{w:25,c:"rgba(243,181,63,.2)"},{w:20,c:"rgba(83,196,109,.2)"},{w:15,c:"rgba(68,166,255,.2)"}].map((z,i) =>
        <div key={i} style={{ height:"100%", width:`${z.w}%`, background:z.c }} />
      )}
      <div style={{ position:"absolute", top:-3, left:`${pct}%`, width:3, height:30, borderRadius:2, background:"#fff" }} />
    </div>
    <div style={{ display:"flex", justifyContent:"space-between", fontSize:10, color:T.muted }}>
      <span>0%</span><span>25%</span><span>50%</span><span>75%</span><span>100%</span>
    </div>
  </div>
);


const CollapsibleCategoryLegend = ({ slices, onItemClick, summaryPrefix, openLabel, closeLabel, isOpen, onToggle, filterZero }) => {
  if (!slices || slices.length === 0) return null;
  const total = slices.reduce((s, x) => s + (x.pts !== undefined ? x.pts : x.gap), 0);
  if (total === 0) return null;
  const entries = slices.map(s => {
    const label = s.label || s.cat;
    const pts = s.pts !== undefined ? s.pts : s.gap;
    return { label, pct: Math.round(100 * pts / total) };
  });
  const summary = (filterZero ? entries.filter(e => e.pct > 0) : entries)
    .slice()
    .sort((a, b) => b.pct - a.pct)
    .slice(0, 3);
  if (summary.length === 0) return null;
  return (
    <div>
      <div style={{ fontSize: 11, color: T.muted, marginTop: 8 }}>
        <span style={{ color: T.text }}>{summaryPrefix}:</span>{" "}
        {summary.map((e, i) => (
          <span key={e.label}>
            {i > 0 && <span style={{ color: T.border }}> · </span>}
            {e.label} {e.pct}%
          </span>
        ))}
      </div>
      <button
        onClick={onToggle}
        style={{
          padding: "4px 0", background: "none", border: "none",
          color: T.blue, fontSize: 11, fontWeight: 600,
          cursor: "pointer", fontFamily: "inherit", marginTop: 4,
        }}
      >
        {isOpen ? closeLabel : openLabel}
      </button>
      {isOpen && <CategoryDonutLegend slices={slices} onItemClick={onItemClick} />}
    </div>
  );
};


/* ══════════════════════════════════════════════════════════════════════
   CUSTOMER SELF-BOOK SURFACE (docs/plans/self-book-surface.md §4, §5)

   TWO SURFACES, ONE READ: the panel on the Company Profile beside Run
   Scan (D-2, D-11) and the cadence banner on the Overview page. Both
   render `portal_review_booking`'s GET and neither computes anything.

   WHAT THIS CODE MAY NEVER DO (§9 — stated here because it is the
   invariant most likely to erode under a later "quick fix"):
     - no date arithmetic on scan age, review age, expiry or term end
     - no threshold comparison against 14, 45, 76 or 90
     - no re-derivation of available_now from window detail
     - no evaluation of a suppression rule
     - no inference of `mode` from the presence or absence of other
       fields — `mode` is explicit on the payload
   Every number on screen arrives from the server, and the day counts in
   copy come from fresh_days / aging_days / cadence_days on the payload
   (the backlog_grace_days idiom), so tuning is a backend constant plus a
   publish — never an edit here.

   A LEGACY CUSTOMER receives {mode: "legacy"} and both surfaces render
   NOTHING: no panel, no button, no balance text, no banner, and no
   "coming soon" teaser. Rollout is the CS touch at flip time.
   ══════════════════════════════════════════════════════════════════════ */

// The GET, shared by both surfaces. Each mounts on a DIFFERENT PAGE, so
// they never fetch twice for one render; the hook keeps the failure
// behaviour identical between them instead of leaving each to invent it.
//
// FAILS SILENT ON PURPOSE. A booking panel that cannot load must not put
// an error on a customer's dashboard: the read is a separate route
// precisely so that its outage is invisible (D-1). null = nothing to
// render, and that is also what a Legacy customer produces.
const useReviewBookingView = (slug, { enabled = true } = {}) => {
  const [view, setView] = useState(null);
  const [refreshKey, setRefreshKey] = useState(0);
  useEffect(() => {
    if (!enabled || !slug) { setView(null); return undefined; }
    let cancelled = false;
    fetchReviewBooking(slug)
      .then(data => { if (!cancelled) setView(data || null); })
      .catch(() => { if (!cancelled) setView(null); });
    return () => { cancelled = true; };
  }, [slug, enabled, refreshKey]);
  useEffect(() => {
    if (!enabled || !slug) return undefined;
    const refetchOnFocus = () => setRefreshKey(k => k + 1);
    window.addEventListener("focus", refetchOnFocus);
    return () => window.removeEventListener("focus", refetchOnFocus);
  }, [slug, enabled]);
  return [view, () => setRefreshKey(k => k + 1)];
};

/** THE BOOKING STATUS LINE (A§2, which SUPERSEDES §4b), and the ONE
 *  function that renders it.
 *
 *  WAS (rev 1, shipped in #599 — recorded, not deleted):
 *      windowed  "{available_now} available this quarter"
 *                " — {expires_count} expires {expires_on}" when one did
 *      simple    "{available_now} available — use by {term_end}"
 *  The windowed shape carried NO DEADLINE, and because SB-3 made the
 *  confirm modal mirror this line verbatim, the confirm inherited the
 *  gap — James's BM-1. Rev 2 puts ONE SERVER-COMPUTED DEADLINE (`use_by`)
 *  on both. `banked-window-deadline` then makes that deadline the current
 *  grant window's last covered day for windowed Banked rows; simple mode
 *  still uses the term end. The entitlement-copy pass paired the
 *  plan-entitlement sentence with bookable/not-yet status copy. The
 *  allowance-adjustment customer-balance pass adds separate display
 *  lines for the customer-safe add-on remainder and exact total
 *  `available_now`, both server-supplied.
 *
 *  THE STATUS IS DERIVED FROM `available_now` AND NOTHING ELSE (BM-3,
 *  #557/#532): units spendable right now, adjustments included — never
 *  remaining-for-term, which is a whole-term number and would over-state
 *  what the button can spend.
 *
 *  The frontend still computes nothing: `use_by` arrives decided, and
 *  fmtDateOnly only formats it (§9 — no date arithmetic, no threshold
 *  comparison).
 */
export const reviewPlanLine = (view) => {
  if (!view) return "";
  if (view.reviews_per_year == null) return "";
  const perYear = view.reviews_per_year;
  return `Your plan includes ${perYear} Recommendations Reviews each review year.`;
};

export const reviewCurrentTermSummaryLine = (view) => {
  if (!view) return "";
  const remaining = view.current_term_reviews_remaining;
  if (!Number.isInteger(remaining) || remaining < 0) return "";
  const termEnd = fmtDateOnly(
    view.term_end,
    { month: "long", day: "numeric", year: "numeric" },
    "",
  );
  if (!termEnd) return "";
  const noun = remaining === 1
    ? "Recommendations Review"
    : "Recommendations Reviews";
  return `Current term: ${remaining} ${noun} remaining through ${termEnd}.`;
};

export const reviewYearSummaryLine = (view) => {
  if (!view) return "";
  if (view.current_term_reviews_remaining != null) {
    return reviewCurrentTermSummaryLine(view);
  }
  const included = view.review_year_included;
  const used = view.review_year_used;
  const remaining = view.review_year_remaining;
  if (![included, used, remaining].every((value) => (
    Number.isInteger(value) && value >= 0
  ))) return "";
  return `This review year: ${included} included · ${used} used · ${remaining} remaining`;
};

export const reviewAddOnsRemainingLine = (view) => {
  if (!view) return "";
  if (view.current_term_reviews_remaining != null) return "";
  const remaining = view.review_add_ons_remaining;
  if (!Number.isInteger(remaining) || remaining <= 0) return "";
  const noun = remaining === 1 ? "add-on" : "add-ons";
  return `Review ${noun} remaining: ${remaining}`;
};

export const reviewAvailableNowLine = (view) => {
  if (!view) return "";
  const available = view.available_now;
  if (!Number.isInteger(available) || available < 0) return "";
  return `Available now: ${available} total`;
};

const reviewDeadlineText = (view) => {
  if (!view) return "";
  const deadline = view.simple_mode ? view.term_end : view.use_by;
  return deadline ? fmtDateOnly(deadline) : "";
};

export const reviewBookableStatusLine = (view) => {
  if (!view) return "";
  if (view.booking_state === "booked" && view.booked_start) {
    return `Your next Recommendations Review is scheduled for ${fmtDateOnly(view.booked_start)}.`;
  }
  if (view.booking_state === "requested") {
    return "Your review booking request is being reviewed.";
  }
  if (view.booking_state === "link_sent") {
    return "Use the booking link from Patriot to schedule your review.";
  }
  const reviewsPerYear = view.reviews_per_year;
  if (view.all_reviews_complete) {
    return reviewsPerYear == null
      ? "You've used all Recommendations Reviews for this review year."
      : `You've used all ${reviewsPerYear} Recommendations Reviews for this review year.`;
  }
  const deadline = reviewDeadlineText(view);
  if ((view.available_now ?? 0) > 0) {
    const prefix = view.freshness_tier === "blocked"
      ? "You can book a review after running an updated scan."
      : "You can book a review now.";
    return deadline ? `${prefix} Book this review by ${deadline}.` : prefix;
  }
  if (view.next_unlock_on) {
    return `You've used the reviews currently open for booking. Your next review becomes available ${fmtDateOnly(view.next_unlock_on)}.`;
  }
  return "You've used the reviews currently open for booking.";
};

export const reviewConfirmLines = (view, { schedulingAvailable = true } = {}) => {
  if (!view) return "";
  const planLine = reviewPlanLine(view);
  const deadline = reviewDeadlineText(view);
  return [
    planLine,
    deadline ? `Book this review by ${deadline}.` : "",
    schedulingAvailable
      ? "Choosing a time reserves 1 review."
      : "Submitting this request starts the booking process.",
    "This review is counted as used after the session. A missed session may also count as used.",
    "Need help remediating a setting? Open Support & Hours instead.",
  ].filter(Boolean);
};
export const reviewConfirmSentence = (view, options) =>
  (reviewConfirmLines(view, options) || []).join(" ");

const REVIEW_HISTORY_PENDING_COPY =
  "Review history will appear here after your next recorded Recommendations Review.";
const REVIEW_BOOKING_PAUSED_COPY =
  "New booking requests are paused while this review is scheduled.";

/** THE LAST-REVIEW LINE (A§3.4), always visible on a Banked panel.
 *  Both facts come off the payload — the date and the day count name the
 *  same row server-side. A customer with no recorded completion gets
 *  non-absolute copy rather than a fabricated date or a claim that no
 *  legacy review ever happened (D-16). */
export const reviewLastReviewLine = (view) => {
  if (!view || !view.last_review_on) return REVIEW_HISTORY_PENDING_COPY;
  const days = view.days_since_review;
  return days === null || days === undefined
    ? `Last review: ${fmtDateOnly(view.last_review_on)}`
    : `Last review: ${fmtDateOnly(view.last_review_on)} — ${days} days ago`;
};

const reviewCadenceHeadline = (view, { includeFirstReview = false } = {}) => {
  if (!view || view.mode !== "banked") return "";
  if (includeFirstReview && view.nudge_suppressed_by === "no_history") {
    return "Book your first Recommendations Review";
  }
  if (!view.nudge) return "";
  return `It's been ${view.days_since_review} days since your last review — we `
    + `recommend at least one review every ${view.cadence_days} days.`;
};

const reviewCadenceSubLine = (view) => {
  if (!view) return "";
  return {
    green: `You have a scan from the last ${view.fresh_days} days — you can book now`,
    amber: "You can request a review, but your data is aging — we recommend a fresh scan before scheduling",
    blocked: "Run a fresh scan to enable the booking request button",
  }[view.freshness_tier] || "";
};

const reviewBookingReminder = (view) => {
  if (!view || view.mode !== "banked") return null;
  if (view.booking_state === "booked" && view.booked_start) {
    return {
      headline: `Your next Recommendations Review is scheduled for ${fmtDateOnly(view.booked_start)}.`,
      sub: REVIEW_BOOKING_PAUSED_COPY,
    };
  }
  return null;
};

const ReviewCadenceNotice = ({
  view, onNavProfile, includeFirstReview = false,
  includeBookingReminder = false, style,
}) => {
  const bookingReminder = includeBookingReminder ? reviewBookingReminder(view) : null;
  const headline = bookingReminder?.headline
    || reviewCadenceHeadline(view, { includeFirstReview });
  if (!headline) return null;
  const sub = bookingReminder?.sub || reviewCadenceSubLine(view);
  const linked = !bookingReminder && view.freshness_tier !== "green";
  const canBook = !bookingReminder
    && view.booking_state === "none"
    && view.freshness_tier !== "blocked"
    && (view.available_now ?? 0) > 0;

  return (
    <div data-testid="review-cadence-banner" style={{
      padding:"12px 14px", borderRadius:14,
      background:"rgba(68,166,255,0.08)", border:"1px solid rgba(68,166,255,0.28)",
      ...style,
    }}>
      <div style={{ fontSize:13, color:T.text, fontWeight:700, lineHeight:1.45 }}>
        {headline}
      </div>
      {sub && (
        <div style={{ fontSize:12, color:T.muted, marginTop:4, lineHeight:1.5 }}>
          {sub}
          {linked && onNavProfile && (
            <>
              {" "}
              <span onClick={onNavProfile} style={{ color:T.blue, cursor:"pointer" }}>
                Go to your scan page
              </span>
            </>
          )}
        </div>
      )}
      {onNavProfile && (canBook || linked) && (
        <div style={{ display:"flex", gap:8, flexWrap:"wrap", marginTop:10 }}>
          {canBook && (
            <Btn pri onClick={onNavProfile} style={{ padding:"8px 12px" }}>
              Book a Recommendations Review
            </Btn>
          )}
          {linked && (
            <Btn onClick={onNavProfile} style={{ padding:"8px 12px" }}>
              Go to scan actions
            </Btn>
          )}
        </div>
      )}
    </div>
  );
};

/* The server classifies each review window. This renderer only groups
   those supplied states into James's plain-language term summary. */
export const reviewTermSummaryLine = (view) => {
  const states = (view && view.grant_pips) || [];
  if (!states.length) return "";
  const counts = states.reduce((summary, state) => {
    if (state === "delivered") summary.completed += 1;
    if (state === "future") summary.future += 1;
    if (state === "lapsed") summary.lapsed += 1;
    return summary;
  }, { completed:0, future:0, lapsed:0 });
  const parts = [];
  if (counts.completed) parts.push(`${counts.completed} completed`);
  if (counts.future) parts.push(`${counts.future} unlocks later`);
  if (counts.lapsed) parts.push(`${counts.lapsed} expired unused`);
  return parts.length ? `This term: ${parts.join(" · ")}` : "";
};

export const ReviewGrantSummary = ({ view }) => {
  const summary = reviewTermSummaryLine(view);
  if (!summary) return null;
  return (
    <div data-testid="review-term-summary" style={{ fontSize:12, color:T.muted, marginTop:14 }}>
      {summary}
    </div>
  );
};

export const reviewPanelDefaultExpanded = (view) => {
  if (!view || view.mode !== "banked") return false;
  if (view.booking_state && view.booking_state !== "none") return true;
  if (view.all_reviews_complete) return true;
  if (view.nudge || view.nudge_suppressed_by === "no_history") return true;
  return view.freshness_tier === "blocked" && (view.available_now ?? 0) > 0;
};

// The three tiers' copy (§4c). The SERVER decides the tier; this table is
// only how each one reads. amber and blocked both tell the customer to run
// a scan — which is honest because the Run Scan card is on this very page
// and visible to customers (SHOW_SCAN_CARD_TO_CUSTOMERS).
const TIER_NOTE = {
  amber: "Your data is aging — we recommend running an updated scan first.",
  blocked: "Run an updated scan to enable booking.",
};
const APPROVED_REVIEW_BOOKING_409_MESSAGES = new Set([
  "a review request is already open",
  "a booking link has already been sent",
  "a review is already scheduled",
  "no review allowance available",
  "Run an updated scan to enable booking.",
]);
const REVIEW_BOOKING_GENERIC_POST_ERROR =
  "We couldn't submit your request right now. Please try again later.";
const REVIEW_BOOKING_REQUESTED_MESSAGE =
  "Your request is being reviewed — watch for a booking link.";
const reviewBookingPostNotice = (err) => (
  err &&
  err.status === 409 &&
  APPROVED_REVIEW_BOOKING_409_MESSAGES.has(err.message)
    ? err.message
    : REVIEW_BOOKING_GENERIC_POST_ERROR
);

const CALENDLY_WIDGET_SCRIPT =
  "https://assets.calendly.com/assets/external/widget.js";
const CALENDLY_WIDGET_CSS =
  "https://assets.calendly.com/assets/external/widget.css";
export const ONBOARDING_ASSISTANCE_BOOKING_URL =
  "https://calendly.com/d/dz56-3vc-49y/securescan365-onboarding";
export const ONBOARDING_NEW_SETUP_BOOKING_URL =
  "https://calendly.com/d/dtq8-qsx-5f7/securescan365-new-setup-session";
export const ONBOARDING_ASSISTANCE_BOOKING_URLS = {
  existing: ONBOARDING_ASSISTANCE_BOOKING_URL,
  new: ONBOARDING_NEW_SETUP_BOOKING_URL,
};

const isCalendlyHost = (host) => (
  host === "calendly.com" || host.endsWith(".calendly.com")
);

const isAllowedSchedulingUrl = (rawUrl) => {
  try {
    const url = new URL(rawUrl);
    return url.protocol === "https:" && url.port === "" &&
      isCalendlyHost(url.hostname);
  } catch {
    return false;
  }
};

const ensureCalendlyWidgetAssets = () => {
  if (window.Calendly?.initInlineWidget) return Promise.resolve();

  if (!document.querySelector(`link[href="${CALENDLY_WIDGET_CSS}"]`)) {
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = CALENDLY_WIDGET_CSS;
    document.head.appendChild(link);
  }

  let script = document.querySelector(`script[src="${CALENDLY_WIDGET_SCRIPT}"]`);
  let shouldAppend = false;
  if (!script) {
    script = document.createElement("script");
    script.src = CALENDLY_WIDGET_SCRIPT;
    script.async = true;
    shouldAppend = true;
  }

  return new Promise((resolve, reject) => {
    if (window.Calendly?.initInlineWidget) { resolve(); return; }
    const failed = () => {
      script.remove();
      reject(new Error("scheduling widget unavailable"));
    };
    const loaded = () => {
      if (window.Calendly?.initInlineWidget) resolve();
      else failed();
    };
    script.addEventListener("load", loaded, { once:true });
    script.addEventListener("error", failed, { once:true });
    if (shouldAppend) document.head.appendChild(script);
  });
};

const ReviewSchedulingModal = ({
  url,
  submitted,
  onScheduled,
  onClose,
  title = "Schedule a Recommendations Review",
  ariaLabel = title,
  closeLabel = "Close scheduling",
  modalTestId = "review-scheduling-modal",
  widgetTestId = "review-scheduling-widget",
  successTitle = "Your booking was submitted.",
  successDetail = "We’re confirming the appointment and updating this page.",
}) => {
  const hostRef = useRef(null);
  const scheduledRef = useRef(false);
  const [loadError, setLoadError] = useState(false);

  useEffect(() => { scheduledRef.current = false; }, [url]);

  useEffect(() => {
    if (!url || !isAllowedSchedulingUrl(url)) {
      setLoadError(true);
      return undefined;
    }
    let cancelled = false;
    setLoadError(false);
    ensureCalendlyWidgetAssets()
      .then(() => {
        if (cancelled || !hostRef.current) return;
        hostRef.current.replaceChildren();
        window.Calendly.initInlineWidget({
          url,
          parentElement: hostRef.current,
        });
      })
      .catch(() => { if (!cancelled) setLoadError(true); });
    return () => { cancelled = true; };
  }, [url]);

  useEffect(() => {
    const receive = (message) => {
      if (!url || !isAllowedSchedulingUrl(url)) return;
      let origin;
      try { origin = new URL(message.origin); } catch { return; }
      if (origin.protocol !== "https:" || !isCalendlyHost(origin.hostname)) return;
      if (message.data?.event !== "calendly.event_scheduled") return;
      if (scheduledRef.current) return;
      scheduledRef.current = true;
      onScheduled();
    };
    window.addEventListener("message", receive);
    return () => window.removeEventListener("message", receive);
  }, [onScheduled, url]);

  useEffect(() => {
    if (!url) return undefined;
    const closeOnEscape = (event) => {
      if (event.key === "Escape") onClose();
    };
    window.addEventListener("keydown", closeOnEscape);
    return () => window.removeEventListener("keydown", closeOnEscape);
  }, [url, onClose]);

  if (!url) return null;
  return createPortal(
    <div
      data-testid={modalTestId}
      onClick={onClose}
      style={{
        position:"fixed", inset:0, zIndex:1200, padding:12,
        display:"flex", alignItems:"center", justifyContent:"center",
        background:"rgba(0,0,0,.68)",
      }}
    >
      <div
        role="dialog"
        aria-modal="true"
        aria-label={ariaLabel}
        onClick={e => e.stopPropagation()}
        style={{
          width:"min(1040px, 96vw)", height:"min(780px, calc(100vh - 24px))",
          minHeight:"min(520px, calc(100vh - 24px))",
          display:"flex", flexDirection:"column", overflow:"hidden",
          background:T.panel, border:`1px solid ${T.border}`, borderRadius:8,
          boxShadow:"0 24px 70px rgba(0,0,0,.55)",
        }}
      >
        <div style={{
          minHeight:54, padding:"10px 14px 10px 18px", display:"flex",
          alignItems:"center", justifyContent:"space-between", gap:16,
          borderBottom:`1px solid ${T.border}`,
        }}>
          <div style={{ fontSize:15, fontWeight:700, color:T.text }}>
            {title}
          </div>
          <button
            type="button"
            aria-label={closeLabel}
            onClick={onClose}
            style={{
              width:34, height:34, padding:0, border:0, background:"transparent",
              color:T.muted, fontSize:24, lineHeight:1, cursor:"pointer",
            }}
          >×</button>
        </div>
        {submitted ? (
          <div style={{
            flex:1, display:"flex", alignItems:"center", justifyContent:"center",
            padding:28, textAlign:"center",
          }}>
            <div>
              <div style={{ fontSize:18, fontWeight:700, color:T.text }}>
                {successTitle}
              </div>
              {successDetail && (
                <div style={{ fontSize:13, color:T.muted, marginTop:8 }}>
                  {successDetail}
                </div>
              )}
            </div>
          </div>
        ) : loadError ? (
          <div style={{
            flex:1, display:"flex", alignItems:"center", justifyContent:"center",
            padding:28, color:T.muted, textAlign:"center", fontSize:13,
          }}>
            The scheduling page could not load. Close this window and try again.
          </div>
        ) : (
          <div
            ref={hostRef}
            data-testid={widgetTestId}
            style={{ flex:1, minHeight:0, width:"100%", overflow:"auto" }}
          />
        )}
      </div>
    </div>,
    document.body,
  );
};

const REVIEW_BOOKING_ACTION_ERROR =
  "We couldn't open scheduling options right now. Please try again later.";

const ReviewSchedulingActionModal = ({ action, url, onClose }) => {
  const isReschedule = action === "reschedule";
  const title = isReschedule
    ? "Reschedule a Recommendations Review"
    : "Cancel a Recommendations Review";

  useEffect(() => {
    const closeOnEscape = (event) => {
      if (event.key === "Escape") onClose();
    };
    window.addEventListener("keydown", closeOnEscape);
    return () => window.removeEventListener("keydown", closeOnEscape);
  }, [onClose]);

  return createPortal(
    <div
      data-testid="review-scheduling-action-modal"
      onClick={onClose}
      style={{
        position:"fixed", inset:0, zIndex:1200, padding:12,
        display:"flex", alignItems:"center", justifyContent:"center",
        background:"rgba(0,0,0,.68)",
      }}
    >
      <div
        role="dialog"
        aria-modal="true"
        aria-label={title}
        onClick={e => e.stopPropagation()}
        style={{
          width:"min(1040px, 96vw)", height:"min(780px, calc(100vh - 24px))",
          minHeight:"min(520px, calc(100vh - 24px))",
          display:"flex", flexDirection:"column", overflow:"hidden",
          background:T.panel, border:`1px solid ${T.border}`, borderRadius:8,
          boxShadow:"0 24px 70px rgba(0,0,0,.55)",
        }}
      >
        <div style={{
          minHeight:54, padding:"10px 14px 10px 18px", display:"flex",
          alignItems:"center", justifyContent:"space-between", gap:16,
          borderBottom:`1px solid ${T.border}`,
        }}>
          <div style={{ fontSize:15, fontWeight:700, color:T.text }}>{title}</div>
          <button
            type="button"
            aria-label={`Close ${isReschedule ? "rescheduling" : "cancellation"}`}
            onClick={onClose}
            style={{
              width:34, height:34, padding:0, border:0, background:"transparent",
              color:T.muted, fontSize:24, lineHeight:1, cursor:"pointer",
            }}
          >×</button>
        </div>
        <iframe
          data-testid="review-scheduling-action-frame"
          title={title}
          src={url}
          style={{ flex:1, minHeight:0, width:"100%", border:0, background:"#fff" }}
        />
        <div style={{
          padding:"10px 18px", borderTop:`1px solid ${T.border}`,
          fontSize:12, color:T.muted, display:"flex", justifyContent:"space-between",
          alignItems:"center", gap:16, flexWrap:"wrap",
        }}>
          <span>Close this window when you are finished. Your review details will refresh shortly.</span>
          <a
            data-testid="review-scheduling-action-fallback"
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            style={{ color:T.blue, textDecoration:"underline", textUnderlineOffset:3 }}
          >
            Having trouble with this window? Open in a new tab
          </a>
        </div>
      </div>
    </div>,
    document.body,
  );
};

const reviewScheduledDateTimeLine = (view) => (
  fmtInstant(
    view?.scheduled_review_start,
    {
      weekday:"short", month:"short", day:"numeric", year:"numeric",
      hour:"numeric", minute:"2-digit",
    },
    "",
  )
);

const ScheduledReviewDetails = ({ slug, view, refetch }) => {
  const [busyAction, setBusyAction] = useState("");
  const [actionNotice, setActionNotice] = useState("");
  const [actionModal, setActionModal] = useState(null);
  if (!view || view.booking_state !== "booked" || !view.scheduled_review_start) {
    return null;
  }
  const when = reviewScheduledDateTimeLine(view);
  const duration = Number.isInteger(view.scheduled_review_duration_minutes)
    ? `${view.scheduled_review_duration_minutes} min`
    : "";
  const openAction = (action) => {
    setBusyAction(action);
    setActionNotice("");
    requestReviewBookingAction(slug, action)
      .then((result) => {
        const url = result?.url;
        if (!isAllowedSchedulingUrl(url)) throw new Error("invalid url");
        setActionModal({ action, url });
      })
      .catch(() => {
        setActionNotice(REVIEW_BOOKING_ACTION_ERROR);
      })
      .finally(() => setBusyAction(""));
  };
  return (
    <>
      <div data-testid="scheduled-review-details" style={{
        flex:"0 1 330px", minWidth:240, padding:14, borderRadius:14,
        background:"rgba(68,166,255,.10)", border:"1px solid rgba(68,166,255,.28)",
      }}>
        <div style={{ fontSize:12, color:T.blue, fontWeight:800, textTransform:"uppercase", letterSpacing:".04em" }}>
          Scheduled review
        </div>
        <div style={{ fontSize:15, color:T.text, fontWeight:800, marginTop:8, lineHeight:1.35 }}>
          {when || fmtDateOnly(view.booked_start)}
        </div>
        {duration && (
          <div style={{ fontSize:12, color:T.muted, marginTop:4 }}>{duration}</div>
        )}
        <div style={{ display:"flex", gap:8, flexWrap:"wrap", marginTop:12 }}>
          {view.scheduled_review_can_reschedule && (
            <Btn
              onClick={() => openAction("reschedule")}
              disabled={!!busyAction}
              style={{ padding:"8px 11px" }}
            >
              {busyAction === "reschedule" ? "Opening…" : "Reschedule"}
            </Btn>
          )}
          {view.scheduled_review_can_cancel && (
            <Btn
              onClick={() => openAction("cancel")}
              disabled={!!busyAction}
              style={{ padding:"8px 11px" }}
            >
              {busyAction === "cancel" ? "Opening…" : "Cancel review"}
            </Btn>
          )}
        </div>
        <div style={{ fontSize:11, color:T.muted, lineHeight:1.45, marginTop:10 }}>
          This page updates after the change is confirmed.
        </div>
        {actionNotice && (
          <div style={{ fontSize:12, color:T.red, marginTop:8 }}>
            {actionNotice}
          </div>
        )}
      </div>
      {actionModal && (
        <ReviewSchedulingActionModal
          action={actionModal.action}
          url={actionModal.url}
          onClose={() => {
            setActionModal(null);
            refetch();
          }}
        />
      )}
    </>
  );
};

const supportHoursLinkStyle = {
  background:"none", border:0, padding:0, color:T.blue, font:"inherit",
  cursor:"pointer", textDecoration:"underline", textUnderlineOffset:3,
};

const SupportHoursInlineLink = ({ onNavSupport, beforeNavigate }) => (
  onNavSupport ? (
    <button
      type="button"
      onClick={() => {
        if (beforeNavigate) beforeNavigate();
        onNavSupport();
      }}
      style={supportHoursLinkStyle}
    >
      Open Support & Hours
    </button>
  ) : (
    <span>Open Support & Hours</span>
  )
);

const ReviewConfirmContent = ({ view, schedulingAvailable, onNavSupport, onClose }) => {
  const lines = reviewConfirmLines(view, { schedulingAvailable });
  if (!lines) return null;
  return (
    <div>
      {lines.slice(0, -1).map((line) => (
        <p key={line} style={{ margin:"0 0 10px" }}>{line}</p>
      ))}
      <p style={{ margin:0 }}>
        Need help remediating a setting?{" "}
        <SupportHoursInlineLink
          onNavSupport={onNavSupport}
          beforeNavigate={onClose}
        />{" "}
        instead.
      </p>
    </div>
  );
};

/** The self-book panel. Sits directly ABOVE CustomerScanCard (D-11): the
 *  amber and blocked tiers tell the reader to run a scan, so the card they
 *  are sent to should be the next thing they see, not something they have
 *  to scroll back to. */
export const ReviewBookingPanel = ({ slug, view: suppliedView, refetch: suppliedRefetch, onNavSupport, onProductAnalyticsAction, children }) => {
  const [hookView, hookRefetch] = useReviewBookingView(slug, { enabled: suppliedView === undefined });
  const view = suppliedView === undefined ? hookView : suppliedView;
  const refetch = suppliedRefetch || hookRefetch;
  const [confirming, setConfirming] = useState(false);
  const [busy, setBusy] = useState(false);
  const [schedulingLink, setSchedulingLink] = useState("");
  // Calendly's inline widget owns iframe/session state outside React. Each
  // open gets a fresh component key while close still destroys the iframe, so a
  // reopen cannot inherit a stale or half-torn-down widget session.
  const [schedulingSession, setSchedulingSession] = useState(0);
  const [bookingSubmitted, setBookingSubmitted] = useState(false);
  const [requestFallback, setRequestFallback] = useState(false);
  const [expandedOverride, setExpandedOverride] = useState(null);
  // Only the approved 409 guard messages are customer copy. Everything
  // else maps generic, even if a lower layer accidentally preserved
  // internal exception text.
  const [notice, setNotice] = useState("");
  const bookingState = view?.booking_state;
  const refetchRef = useRef(refetch);
  useEffect(() => { refetchRef.current = refetch; }, [refetch]);

  useEffect(() => {
    if (bookingState !== "none") {
      setSchedulingLink("");
      setBookingSubmitted(false);
    }
  }, [bookingState]);

  useEffect(() => {
    if (!bookingSubmitted || bookingState !== "none") return undefined;
    const timers = [1500, 4000, 8000].map(delay => (
      window.setTimeout(() => refetchRef.current(), delay)
    ));
    return () => timers.forEach(timer => window.clearTimeout(timer));
  }, [bookingSubmitted, bookingState]);

  useEffect(() => {
    setExpandedOverride(null);
  }, [
    slug,
    view?.booking_state,
    view?.nudge,
    view?.nudge_suppressed_by,
    view?.all_reviews_complete,
    view?.freshness_tier,
    view?.available_now,
  ]);

  // `mode` is EXPLICIT — never inferred from another field's presence.
  if (!view || view.mode !== "banked") return null;

  const locked = view.booking_state !== "none";
  const blocked = view.freshness_tier === "blocked";
  const canRequest = !locked && !blocked && view.available_now > 0;
  const schedulingAvailable = view.scheduling_available === true;
  const note = TIER_NOTE[view.freshness_tier] || "";
  const planLine = reviewPlanLine(view);
  const yearSummaryLine = reviewYearSummaryLine(view);
  const addOnsLine = reviewAddOnsRemainingLine(view);
  const availableNowLine = reviewAvailableNowLine(view);
  const expanded = expandedOverride ?? reviewPanelDefaultExpanded(view);

  const submit = () => {
    setBusy(true);
    setSchedulingLink("");
    setBookingSubmitted(false);
    setRequestFallback(false);
    requestReviewBooking(slug)
      .then((result) => {
        setNotice("");
        const url = result?.scheduling_url;
        if (schedulingAvailable && isAllowedSchedulingUrl(url)) {
          setSchedulingSession(value => value + 1);
          setSchedulingLink(url);
        } else if (schedulingAvailable && !url) {
          setRequestFallback(true);
        } else if (schedulingAvailable && url) {
          setNotice(REVIEW_BOOKING_GENERIC_POST_ERROR);
        }
      })
      .catch(err => {
        setNotice(reviewBookingPostNotice(err));
      })
      .then(() => { setBusy(false); setConfirming(false); refetch(); });
  };

  return (
    <Card style={{
      marginTop:16,
      marginBottom:16,
      border:"1px solid rgba(68,166,255,.30)",
      background:"linear-gradient(180deg,rgba(21,54,95,.98),rgba(17,43,77,.98))",
      boxShadow:"0 20px 46px rgba(0,0,0,.32)",
    }}>
      <div data-testid="review-booking-panel">
        <div style={{ display:"flex", justifyContent:"space-between", gap:18, flexWrap:"wrap", alignItems:"flex-start" }}>
          <div style={{ flex:"1 1 320px", minWidth:0 }}>
            <div style={{ fontSize:11, color:T.blue, fontWeight:800, textTransform:"uppercase", letterSpacing:".04em", marginBottom:6 }}>
              Recommendations Reviews
            </div>
            {planLine && (
              <div style={{ fontSize:13, color:T.muted, fontWeight:700, marginBottom:5 }}>
                {planLine}
              </div>
            )}
            {yearSummaryLine && (
              <div data-testid="review-year-summary" style={{ fontSize:12, color:T.muted, marginBottom:8 }}>
                {yearSummaryLine}
              </div>
            )}
            {addOnsLine && (
              <div data-testid="review-add-ons-remaining" style={{ fontSize:12, color:T.muted, marginBottom:5 }}>
                {addOnsLine}
              </div>
            )}
            {availableNowLine && (
              <div data-testid="review-available-now" style={{ fontSize:12, color:T.muted, marginBottom:8 }}>
                {availableNowLine}
              </div>
            )}
            <div style={{
              fontSize: expanded ? 24 : 17,
              lineHeight:1.25, color:T.text, fontWeight:800,
            }}>
              {reviewBookableStatusLine(view)}
            </div>
            {expanded && (
              <>
                <div style={{ fontSize:12, color:T.muted, marginTop:8, lineHeight:1.5, maxWidth:620 }}>
                  A Recommendations Review is a working session with your Patriot team to review your security settings, overall security posture, and priorities.
                </div>
                <div style={{ fontSize:12, color:T.muted, marginTop:6, lineHeight:1.5, maxWidth:620 }}>
                  Need help remediating a specific setting?{" "}
                  <SupportHoursInlineLink onNavSupport={onNavSupport} />{" "}
                  instead.
                </div>
              </>
            )}
          </div>

          {!expanded && (
            <div data-testid="review-compact-action" style={{
              flex:"0 1 200px", minWidth:180, display:"flex", justifyContent:"flex-end",
            }}>
              <Btn onClick={() => setExpandedOverride(true)} style={{ padding:"9px 12px" }}>
                View details
              </Btn>
            </div>
          )}

          {expanded && !locked && (
            <div data-testid="review-booking-action" style={{
              flex:"0 1 280px", minWidth:220, padding:12, borderRadius:14,
              background:"rgba(68,166,255,.10)", border:"1px solid rgba(68,166,255,.28)",
            }}>
              <Btn
                pri
                disabled={!canRequest || busy}
                onClick={() => setConfirming(true)}
                style={{
                  width:"100%", padding:"11px 14px", fontSize:13,
                  background:"linear-gradient(180deg,rgba(68,166,255,.34),rgba(68,166,255,.20))",
                  borderColor:"rgba(68,166,255,.55)",
                }}
              >
                Book a Recommendations Review
              </Btn>
              <div style={{ fontSize:11, color:T.muted, marginTop:8, lineHeight:1.4, textAlign:"center" }}>
                {schedulingAvailable
                  ? "Choose a time for one included review with your Patriot team."
                  : "Starts a request for one included review. Patriot will follow up with a booking link."}
              </div>
            </div>
          )}

          {expanded && locked && view.booking_state === "booked" && (
            <ScheduledReviewDetails
              slug={slug}
              view={view}
              refetch={refetch}
            />
          )}
        </div>

        {expanded && (
          <>
            <ReviewCadenceNotice
              view={view}
              includeFirstReview
              style={{ marginTop:14, marginBottom:2 }}
            />
            <div style={{ display:"flex", justifyContent:"flex-end", marginTop:10 }}>
              <Btn onClick={() => setExpandedOverride(false)} style={{ padding:"7px 10px" }}>
                Hide details
              </Btn>
            </div>
          </>
        )}

        {/* CARRYOVER EDUCATION, one sentence (A§3.2). STATIC COPY — no
            payload field and no number off the wire (D-17), so it makes
            no claim about this customer's balance that could disagree
            with the line above. The mechanism detail lives in the
            tooltip, never in a rules paragraph. */}
        {expanded && !view.simple_mode && (
          <div
            title="One unused review carries into the next review window. Anything beyond that expires when the current window ends."
            style={{ fontSize:12, color:T.muted, marginTop:8, cursor:"help" }}
          >
            Unused reviews carry forward — up to one into the next review window.
          </div>
        )}

        {/* LAST REVIEW in the expanded detail view. No recorded completion
            gets soft copy, never a fabricated date (D-16). */}
        {expanded && (
          <div data-testid="review-last-review" style={{ fontSize:12, color:T.muted, marginTop:4 }}>
            {reviewLastReviewLine(view)}
          </div>
        )}

        {/* Zero balance / term exhausted: grey the ACTIONS, not the FACTS
            (the P-017 pattern, reused rather than re-invented). The
            balance line above keeps its tone; only the button dims. */}
        {expanded && view.all_reviews_complete && (
          <div style={{ fontSize:12, color:T.muted, marginTop:4 }}>awaiting renewal</div>
        )}

        {requestFallback && view.booking_state !== "requested" && (
          <div style={{ fontSize:12, color:T.blue, marginTop:8 }}>
            {REVIEW_BOOKING_REQUESTED_MESSAGE}
          </div>
        )}
        {expanded && view.booking_state === "booked" && view.booked_start && (
          <div style={{ fontSize:12, color:T.muted, marginTop:8 }}>
            {REVIEW_BOOKING_PAUSED_COPY}
          </div>
        )}

        {expanded && !locked && note && (
          <div style={{
            fontSize:12, marginTop:8, padding:"8px 10px", borderRadius:10,
            color: blocked ? T.muted : T.yellow,
            background: blocked ? "rgba(255,255,255,0.04)" : "rgba(243,181,63,0.10)",
            border: `1px solid ${blocked ? T.border : "rgba(243,181,63,0.30)"}`,
          }}>{note}</div>
        )}

        {notice && (
          <div style={{ fontSize:12, color:T.red, marginTop:8 }}>{notice}</div>
        )}

        {children && (
          <div style={{ marginTop:18, paddingTop:16, borderTop:`1px solid ${T.border}` }}>
            {children}
          </div>
        )}
      </div>

      {/* NO PRE-FLIGHT READ (D-7/D-19): a second balance derivation at
          click time could disagree with the POST's own check, which is
          the two-sources-of-truth shape the allowance model exists to
          prevent. The route's 409s are the enforcement; this dialog is a
          convenience mirror of the same server-computed deadline in the
          visible booking status line (A§3.5, BM-1). */}
      <Modal
        show={confirming}
        title="Book a Recommendations Review"
        onClose={() => setConfirming(false)}
        onSubmit={() => { observeProductAnalytics(onProductAnalyticsAction, "review_booking_requested"); submit(); }}
        submitDisabled={busy}
        submitLabel={busy
          ? (schedulingAvailable ? "Opening…" : "Sending…")
          : (schedulingAvailable ? "Choose a time" : "Request review")}
      >
        <ReviewConfirmContent
          view={view}
          schedulingAvailable={schedulingAvailable}
          onNavSupport={onNavSupport}
          onClose={() => setConfirming(false)}
        />
      </Modal>
      <ReviewSchedulingModal
        key={`review-scheduling-${schedulingSession}`}
        url={schedulingLink}
        submitted={bookingSubmitted}
        onScheduled={() => {
          setBookingSubmitted(true);
          refetch();
        }}
        onClose={() => {
          setSchedulingLink("");
          setBookingSubmitted(false);
        }}
      />
    </Card>
  );
};

/** The cadence banner (§5). Lives on the Overview page — a nudge belongs
 *  where the customer lands — and its sub-lines link OUT to the scan
 *  surface, which is only coherent from a different page. */
export const ReviewCadenceBanner = ({ slug, onNavProfile }) => {
  const [view] = useReviewBookingView(slug);
  return <ReviewCadenceNotice view={view} onNavProfile={onNavProfile} includeFirstReview includeBookingReminder style={{ marginBottom:16 }} />;
};

/* ══════════════════════════════════════════════
   PAGE: OVERVIEW
   ══════════════════════════════════════════════ */
export const isRemediatedDrilldownCapable = (rem, report, recs, loading, error) => {
  const ids = rem?.remediated_setting_ids;
  const idSet = Array.isArray(ids) ? new Set(ids) : null;
  const scoredAt = report?.scored_at;
  return !loading && !error && !rem?.baseline
    && Number.isInteger(rem?.remediated) && rem.remediated > 0
    && Array.isArray(ids)
    && idSet.size === ids.length
    && ids.every(id => Number.isSafeInteger(id) && id > 0)
    && ids.length === rem.remediated
    && typeof scoredAt === "string" && scoredAt.length > 0
    && rem.current_scored_at === scoredAt
    && ids.every(id => {
      const matches = recs.filter(r => r.id === id);
      return matches.length === 1 && matches[0].result === "Passed";
    });
};

export const isPairDrilldownCapable = (pair, metric, report, recs) => {
  const result = pair?.[metric];
  const ids = result?.setting_ids;
  return pair?.available === true && result?.available === true && result.count > 0
    && pair.selected?.selector === report?._publication?.selector
    && pair.selected?.identity?.sha256 === report?._publication?.identity?.sha256
    && pair.selected?.identity?.scored_path === report?._publication?.identity?.scored_path
    && pair.state_generation === report?._publication?.state_generation
    && Array.isArray(ids) && ids.length === result.count && new Set(ids).size === ids.length
    && ids.every(id => Number.isSafeInteger(id) && id > 0 && recs.filter(r => r.id === id).length === 1);
};

export const olderComparisonChoices = (choices, selected) => {
  const selectedAt = Date.parse(selected?.chronology);
  if (!Number.isFinite(selectedAt)) return [];
  return choices.filter(row => row.selector !== selected.selector && row.chronology
    && Number.isFinite(Date.parse(row.chronology)) && Date.parse(row.chronology) < selectedAt);
};

export const benchmarkForReport = (report, currentScanId, previewPending) => {
  const benchmark = report?.benchmark;
  if (currentScanId != null || previewPending || report?.collection_method !== "securescan365"
      || !benchmark || Array.isArray(benchmark) || typeof benchmark !== "object"
      || Object.keys(benchmark).length !== 2
      || !Object.prototype.hasOwnProperty.call(benchmark, "aggregate_score")
      || !Object.prototype.hasOwnProperty.call(benchmark, "updated_at")
      || typeof benchmark.aggregate_score !== "number" || !Number.isFinite(benchmark.aggregate_score)
      || benchmark.aggregate_score < 0 || benchmark.aggregate_score > 100
      || typeof benchmark.updated_at !== "string"
      || !/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?Z$/.test(benchmark.updated_at)) return null;
  const instant = Date.parse(benchmark.updated_at);
  if (!Number.isFinite(instant) || instant > Date.now()
      || new Date(instant).toISOString().slice(0, 19) !== benchmark.updated_at.slice(0, 19)) return null;
  return benchmark;
};

const OverviewPage = ({ q, slug, onNavRecs, onNavRemediated, onNavPair, pairMode, setPairMode, pairScanId, setPairScanId, onNavSetting, recs, settingDetails, categoryData, report, sessionFocus, sessionFocusLoading, reviewsBySettingId, nextAuditDate, onNavQueue, onItemClick, reportLoading, reportError, noDataScanState = null, onNavProfile, scans, scansPayload, currentScanId, previewPending, setCurrentScanId, canSeeSupport = false, onNavSupport }) => {
  const [pairRetryKey, setPairRetryKey] = useState(0);
  const pairRequest = usePostureComparison({ slug, report, scansPayload, mode: pairMode,
    currentScanId, previewPending, reportLoading, comparisonScanId: pairScanId, retryKey: pairRetryKey });
  // When report is null we render skeleton placeholders for every report-derived
  // section; the QD/baseD blend below is only meaningful once report is loaded.
  const baseD = QD[q], basePrev = q > 0 ? QD[q - 1] : null;
  const d = report
    ? { ...baseD, score: Math.round(report.totals.score_pct * 10) / 10 }
    : baseD;
  // Previous score is computed from the scans list (newest-first), NEVER from
  // report.previous_totals: previous_totals is a scoring-time snapshot and
  // survives deletion of the prior scan (83-customer ghost audit, July 6
  // 2026) — the live scans list is the only trustworthy source for
  // comparisons. With <= 1 scan, prev is null and every downstream surface
  // (change pill and Posture Movement) renders its baseline state.
  const prevScoreFromScans = (() => {
    if (!Array.isArray(scans) || scans.length === 0) return null;
    // Index of the scan currently in view: the time-travel target, else newest (0).
    const prior = exactScoringBaseline(report, scans);
    return prior && typeof prior.score_pct === "number"
      ? Math.round(prior.score_pct * 10) / 10
      : null;
  })();
  const prev = prevScoreFromScans != null
    ? { ...(basePrev || baseD), score: prevScoreFromScans }
    : null;
  // Phase E — pct/adj now come from categoryData (passed as prop); locals removed.
  // The selected maturity view receives the same canonical score values below.
  const prevScore = prev ? prev.score : null;
  const [catView, setCatView] = useState("product"); // default By Product (walkthrough, July 7 2026)
  const [productLegendOpen, setProductLegendOpen] = useState(false);
  const [compositionLegendOpen, setCompositionLegendOpen] = useState(false);

  const cr = recs.filter(r => r.sev === "critical" && r.status === "open");
  const hi = recs.filter(r => r.sev === "high" && r.status === "open");
  const me = recs.filter(r => r.sev === "medium" && r.status === "open");
  const im = recs.filter(r => r.status === "implemented");

  // Disposition partitioning for the severity tiles — one classifier, shared
  // with the Critical + High Open KPI, the RecsPage Needs Action filter these
  // tiles click into, and the PDF severity breakdown (tileDisposition in
  // ./overrideStatus). Open and addressed are complements over the ASSESSED
  // rows, so the two numbers account for every row on the tile and the
  // headline equals the landed "Showing N" by construction.
  // Replaces the prior split rule (2026-08-14), which subtracted all three
  // credit overrides from the headline but counted only Risk Accepted +
  // Customer Remediated as addressed — leaving customer_managed_solution in
  // neither number — and counted never-evaluated rows in the headline.
  const ovOf = (r) => settingDetails?.[r.id]?.override || null;
  const isOpenRec = (r) => countsAsOpen(r.verdict, ovOf(r));
  const isAddressedRec = (r) => countsAsAddressed(r.verdict, ovOf(r));

  const Chips = ({ items, max, filterKey }) => {
    const show = items.slice(0, max);
    const rest = items.length - max;
    return (
      <div style={{ display:"grid", gap:4 }}>
        {show.map(r => (
          <div key={r.id} onClick={() => onNavSetting(r.id)} title={`#${r.id} ${r.name}`} style={{
            display:"flex", alignItems:"center", gap:6, padding:"6px 8px", background:"rgba(0,0,0,.2)",
            border:"1px solid rgba(255,255,255,.12)", borderRadius:8, cursor:"pointer", fontSize:11,
            color:"rgba(255,255,255,.9)", lineHeight:1.3, transition:"background .15s",
            minWidth:0, overflow:"hidden",
          }}>
            <span style={{ color:"rgba(255,255,255,.5)", fontWeight:700, fontSize:10, whiteSpace:"nowrap", flexShrink:0 }}>#{r.id}</span>
            <span style={{ overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap", flex:1, minWidth:0 }}>{r.name}</span>
          </div>
        ))}
        {rest > 0 && <div onClick={() => onNavRecs(filterKey)} style={{ fontSize:10, color:"rgba(255,255,255,.5)", padding:"4px 0", cursor:"pointer" }}>+ {rest} more →</div>}
      </div>
    );
  };

  // Severity tile. For Critical/High/Medium (`satisfied` false) the supplied `items`
  // is the full open slice for that severity; the card partitions it into the open
  // headline (still needs action) and an addressed drawer (any credit-granting
  // override, Customer Managed Solution included). Never-assessed rows fall out of
  // both. Satisfied passes `satisfied` and renders the plain count + preview unchanged.
  const MetricCard = ({ cls, bg, label, count, items, max, filterKey, satisfied }) => {
    const [addrOpen, setAddrOpen] = useState(false);

    if (satisfied) {
      return (
        <div style={{ borderRadius:14, padding:14, border:"1px solid rgba(255,255,255,.08)", display:"flex", flexDirection:"column", background:bg, minWidth:0 }}>
          <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:8 }}>
            <div style={{ fontSize:13, fontWeight:700 }}>{label}</div>
            <div style={{ fontSize:32, fontWeight:800, lineHeight:1 }}>{count}</div>
          </div>
          <Chips items={items} max={max} filterKey={filterKey} />
        </div>
      );
    }

    const open = items.filter(isOpenRec);
    const addressed = items.filter(isAddressedRec);

    return (
      <div style={{ borderRadius:14, padding:14, border:"1px solid rgba(255,255,255,.08)", display:"flex", flexDirection:"column", background:bg, minWidth:0 }}>
        <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", marginBottom:8 }}>
          <div style={{ minWidth:0 }}>
            <div style={{ fontSize:13, fontWeight:700 }}>{label}</div>
          </div>
          <div style={{ display:"flex", flexDirection:"column", alignItems:"flex-end", flexShrink:0 }}>
            <div style={{ fontSize:32, fontWeight:800, lineHeight:1 }}>{open.length}</div>
            {addressed.length > 0 && <div style={{ fontSize:10, color:"rgba(255,255,255,.7)", marginTop:2 }}>{addressed.length} addressed</div>}
          </div>
        </div>
        <Chips items={open} max={max} filterKey={filterKey} />
        {addressed.length > 0 && (
          <div style={{ marginTop:8 }}>
            <div onClick={() => setAddrOpen(o => !o)} style={{ fontSize:10, color:"rgba(255,255,255,.7)", cursor:"pointer", userSelect:"none", display:"flex", alignItems:"center", gap:4 }}>
              <span style={{ display:"inline-block", transform: addrOpen ? "rotate(90deg)" : "none", transition:"transform .15s" }}>{"▸"}</span>
              {addressed.length} addressed
            </div>
            {addrOpen && (
              <div style={{ marginTop:6 }}>
                <div style={{ fontSize:9, fontWeight:700, letterSpacing:".08em", color:"rgba(255,255,255,.45)", borderTop:"1px solid rgba(255,255,255,.15)", paddingTop:6, marginBottom:6 }}>ADDRESSED</div>
                <div style={{ display:"grid", gap:4 }}>
                  {addressed.map(r => {
                    const ov = ovOf(r);
                    const sd = settingDetails?.[r.id];
                    const rev = ov === "risk_accepted" && sd?.revisit_by ? formatReviewDate(sd.revisit_by) : "";
                    return (
                      <div key={r.id} onClick={() => onNavSetting(r.id)} title={`#${r.id} ${r.name}`} style={{
                        display:"flex", alignItems:"center", gap:6, padding:"5px 8px", background:"rgba(0,0,0,.15)",
                        border:"1px solid rgba(255,255,255,.08)", borderRadius:8, cursor:"pointer", fontSize:11,
                        color:"rgba(255,255,255,.9)", lineHeight:1.3, minWidth:0, overflow:"hidden", opacity:0.7,
                      }}>
                        <span style={{ color:"rgba(255,255,255,.5)", fontWeight:700, fontSize:10, whiteSpace:"nowrap", flexShrink:0 }}>#{r.id}</span>
                        <span style={{ overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap", flex:1, minWidth:0 }}>{r.name}</span>
                        <span style={{ fontSize:9, fontWeight:700, padding:"1px 6px", borderRadius:6, whiteSpace:"nowrap", flexShrink:0, color:dispositionColor(ov), background:"rgba(0,0,0,.25)", border:`1px solid ${dispositionColor(ov)}` }}>{dispositionLabel(ov)}</span>
                        {rev && <span style={{ fontSize:9, color:"rgba(255,255,255,.55)", whiteSpace:"nowrap", flexShrink:0 }}>rev {rev}</span>}
                      </div>
                    );
                  })}
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    );
  };

  // Support Snapshot — internal-gated live tiles from the (expensive)
  // ticket_dashboard endpoint. Mounted ONLY for gated users — the card site
  // renders the static "Coming soon" placeholder otherwise, so non-gated
  // users never trigger this fetch. Fail-soft: fetch errors — including the
  // 404 no_department_for_slug case — render "—" tiles; the Overview never
  // breaks on support data. Mirrors PostureMovement's self-fetch shape.
  const SupportSnapshot = () => {
    const [snap, setSnap] = useState(null);
    const [snapLoading, setSnapLoading] = useState(true);
    const [snapError, setSnapError] = useState(false);
    useEffect(() => {
      if (!canSeeSupport || !slug) { setSnapLoading(false); return; }
      let cancelled = false;
      setSnapLoading(true);
      setSnapError(false);
      fetchTicketDashboard(slug)
        .then(d => { if (!cancelled) { setSnap(d); setSnapLoading(false); } })
        .catch(() => { if (!cancelled) { setSnapError(true); setSnapLoading(false); } });
      return () => { cancelled = true; };
    }, [slug, canSeeSupport]);

    const sIcon = (path) => (
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">{path}</svg>
    );
    // Same tile shape as the placeholder, but full opacity + a live value.
    // small drops the value font so string values ("Not included") fit.
    const statTile = (icon, label, value, { muted = false, small = false } = {}) => (
      <div key={label} style={{ flex:"1 1 90px", minWidth:90, background:"rgba(255,255,255,.03)", border:`1px solid ${T.border}`, borderRadius:10, padding:"8px 8px" }}>
        <span style={{ display:"inline-flex", color:T.muted, marginBottom:4 }}>{icon}</span>
        <div style={{ fontSize: small ? 12 : 18, fontWeight:800, lineHeight: small ? "18px" : 1, color: muted ? T.muted : T.text }}>{value}</div>
        <div style={{ fontSize:10, color:T.muted, marginTop:3 }}>{label}</div>
      </div>
    );

    const ready = !snapLoading && !snapError && !!snap;
    const val = (live) => (snapLoading ? "…" : !ready ? "—" : live);
    const tickets = snap?.tickets || [];
    // Resolved(4)/Closed(5) count as inactive — same rule as SupportPage.
    const openCount = tickets.filter(t => t.status !== 4 && t.status !== 5).length;
    // Gauge → tile value across all shapes: settings {unlimited, used, cap?}
    // and l3 {state: unlimited|capped|upsell}. Upsell = no L3 entitlement —
    // muted "Not included", no CTA (the Support page owns the upsell pitch).
    const hoursValue = (g) => {
      if (!g) return { value: "—" };
      if (g.state === "upsell") return { value: "Not included", muted: true, small: true };
      if (g.unlimited === true || g.state === "unlimited") return { value: `${(g.used ?? 0).toFixed(1)}h` };
      if (g.cap != null) return { value: `${(g.used ?? 0).toFixed(1)} / ${g.cap}h` };
      return { value: `${(g.used ?? 0).toFixed(1)}h` };
    };
    const settingsTile = ready ? hoursValue(snap.settings) : { value: val(null) };
    const l3Tile = ready ? hoursValue(snap.l3) : { value: val(null) };

    return (
      <div
        onClick={onNavSupport}
        title="Open Support & Hours"
        style={{ cursor:"pointer" }}
        onMouseEnter={e => { e.currentTarget.style.filter = "brightness(1.08)"; }}
        onMouseLeave={e => { e.currentTarget.style.filter = "none"; }}
      >
        <Card title="Support Snapshot">
          <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit, minmax(90px, 1fr))", gap:6 }}>
            {statTile(sIcon(<><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" /></>), "Open tickets", val(openCount))}
            {statTile(sIcon(<><polyline points="22 12 16 12 14 15 10 15 8 12 2 12" /><path d="M5.45 5.11L2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z" /></>), "Total tickets", val(tickets.length))}
            {statTile(sIcon(<><circle cx="12" cy="12" r="9" /><polyline points="12 7 12 12 15 14" /></>), "Settings hours", settingsTile.value, settingsTile)}
            {statTile(sIcon(<><path d="M13 2L3 14h9l-1 8 10-12h-9z" /></>), "L3 hours", l3Tile.value, l3Tile)}
          </div>
          <div style={{ fontSize:11, color:T.blue, fontWeight:600, marginTop:10 }}>View Support →</div>
        </Card>
      </div>
    );
  };

  // Pair metrics are a read-only request-time projection. Snapshot metrics
  // below still use the selected report's effective dispositions today.
  // Render as a helper so Overview state changes retain the select DOM nodes
  // and keyboard focus rather than remounting a nested component type.
  const renderPostureMovement = () => {
    const pair = pairRequest.data;
    const pairLoading = pairRequest.loading;
    const pairError = pairRequest.error;
    const choices = pairRequest.choices;
    const chosen = choices.find(row => row.selector === pairScanId);
    const olderChoices = olderComparisonChoices(choices, pairRequest.selected);
    const scanLabel = (row) => fmtInstant(row.chronology, { month:"short", day:"numeric", year:"numeric", hour:"2-digit", minute:"2-digit", hourCycle:"h23" }, "Date unavailable");
    const metricValue = (name) => pairLoading ? "…" : pair?.available && pair[name]?.available ? pair[name].count : "—";
    const scoreDelta = pair?.score_change?.available ? pair.score_change.value : null;
    const scoreChangeValue = pairLoading ? "…" : scoreDelta == null ? "—" :
      `${scoreDelta > 0 ? "+" : scoreDelta < 0 ? "−" : ""}${Math.abs(scoreDelta).toFixed(1)} points`;
    const scoreChangeColor = scoreDelta > 0 ? T.green : scoreDelta < 0 ? T.red : T.muted;
    const canOpenRemediated = isPairDrilldownCapable(pair, "remediated", report, recs);
    const canOpenRegressed = isPairDrilldownCapable(pair, "regressed", report, recs);

    // Card 2 — Critical + High Open, disposition-aware: the same classifier
    // as the top severity cards' headline (isOpenRec → tileDisposition), so
    // the two surfaces always agree.
    // INVARIANT: A TILE'S NUMBER MUST EQUAL THE "Showing N" COUNT ITS CLICK
    // LANDS ON, and match any other surface showing the same concept. The
    // click's landed population (critical_high bridge → severityFilter +
    // needsActionFilter in RecsPage) mirrors this predicate exactly.
    const crHiOpen = [...cr, ...hi].filter(isOpenRec).length;

    // Card 4 — distinct settings carrying a credit-granting override, counted
    // on CURRENT recs ONLY — never raw settingDetails keys: settingDetails can
    // hold overrides for setting IDs no longer in the report (retired/renamed
    // settings), which silently inflate the count.
    // Same classifier as every other disposition surface, so an override on a
    // never-assessed row is not counted as a recorded decision: there was no
    // measured finding to decide about, and the landed list hides those rows.
    // INVARIANT: A TILE'S NUMBER MUST EQUAL THE "Showing N" COUNT ITS CLICK
    // LANDS ON, and match any other surface showing the same concept. This is
    // the exact predicate the any_credit landed list applies (with
    // showSatisfied forced on by the bridge so satisfied-but-overridden rows
    // stay visible — a satisfied row is assessed, so it still counts).
    const riskDecisions = recs.filter(isAddressedRec).length;

    // Card 6 — Quick Wins: OPEN, low-complexity, low user disruption
    // (None/Low), at Critical/High severity.
    const isQuickWin = (r) => r.status === "open" && isQuickWinRating(r);
    const quickWinsHigh = recs.filter(r => isQuickWin(r) && (r.sev === "critical" || r.sev === "high")).length;
    const quickWinsValue = quickWinsHigh > 0 ? quickWinsHigh : "—";

    // Subtle monochrome line icons (match the file's inline-SVG convention).
    const ic = (path) => (
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">{path}</svg>
    );
    const ICONS = {
      scoreChange:  ic(<polyline points="3 17 9 11 13 15 21 7" />),
      open:         ic(<><circle cx="12" cy="12" r="9" /><line x1="12" y1="8" x2="12" y2="12" /><line x1="12" y1="16" x2="12" y2="16" /></>),
      remediated:   ic(<polyline points="20 6 9 17 4 12" />),
      riskDecision: ic(<><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" /></>),
      regressed:    ic(<polyline points="3 7 9 13 13 9 21 17" />),
      quickWin:     ic(<polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" />),
    };

    // Compact near-square card sized for a fixed 3-col grid in the narrow right
    // column. minWidth:0 lets cells shrink so long labels don't widen columns.
    // Whole-tile click navigates to the pre-filtered Recommendations list;
    // hover affordance mirrors the Support Snapshot card (cursor + brightness).
    const kpi = (icon, label, value, valueColor, onClick) => (
      <div
        onClick={onClick}
        role={onClick ? "button" : undefined}
        tabIndex={onClick ? 0 : undefined}
        onKeyDown={onClick ? (e => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); onClick(); } }) : undefined}
        onFocus={onClick ? (e => { e.currentTarget.style.outline = `2px solid ${T.blue}`; }) : undefined}
        onBlur={onClick ? (e => { e.currentTarget.style.outline = "none"; }) : undefined}
        onMouseEnter={onClick ? (e => { e.currentTarget.style.filter = "brightness(1.08)"; }) : undefined}
        onMouseLeave={onClick ? (e => { e.currentTarget.style.filter = "none"; }) : undefined}
        style={{ minWidth:0, background:"rgba(255,255,255,.04)", border:"1px solid rgba(255,255,255,.08)", borderRadius:12, padding:"18px 12px", cursor: onClick ? "pointer" : "default", transition:"filter .15s" }}>
        <div style={{ display:"flex", alignItems:"center", gap:5, color:T.muted, marginBottom:6 }}>
          <span style={{ display:"inline-flex", opacity:.7, flexShrink:0 }}>{icon}</span>
          <span style={{ fontSize:11, textTransform:"uppercase", letterSpacing:".04em", overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }} title={label}>{label}</span>
        </div>
        <div style={{ fontSize:22, fontWeight:800, lineHeight:1, color: valueColor || T.text }}>{value}</div>
      </div>
    );

    return (
      <Card>
        <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", flexWrap:"wrap", gap:12, marginBottom:12 }}>
          <h3 style={{ margin:0, fontSize:15, fontWeight:700, color:"#fff" }}>Posture Movement</h3>
          <label style={{ fontSize:12, color:T.muted, display:"flex", alignItems:"center", flexWrap:"wrap", gap:8, marginLeft:"auto", maxWidth:"100%" }}>
            Compare with
            <select aria-label="Compare with" value={pairMode} onChange={e => setPairMode(e.target.value)}
              style={{ padding:"7px 9px", color:T.text, background:T.panel, border:`1px solid ${T.border}`, borderRadius:7, maxWidth:"100%" }}>
              <option value="baseline">Baseline</option>
              <option value="previous">Previous scan</option>
              <option value="90_days">90 days earlier</option>
              <option value="choose">Choose scan</option>
            </select>
          </label>
        </div>
        {pairMode === "choose" && <label style={{ fontSize:12, color:T.muted, display:"grid", gap:4, minWidth:200, maxWidth:"100%", marginBottom:12 }}>
            Older SecureScan365 scan
            <select aria-label="Older SecureScan365 scan" value={pairScanId || ""} onChange={e => setPairScanId(e.target.value || null)}
              style={{ padding:"7px 9px", color:T.text, background:T.panel, border:`1px solid ${T.border}`, borderRadius:7, maxWidth:"100%" }}>
              <option value="">Choose an older scan</option>
              {olderChoices.map(row => <option key={row.selector} value={row.selector}>{scanLabel(row)}</option>)}
              {pairScanId && !olderChoices.some(row => row.selector === pairScanId) &&
                <option value={pairScanId}>{chosen ? scanLabel(chosen) : "Selected scan unavailable"}</option>}
            </select>
          </label>}
        {!pair?.available && <div aria-live="polite" style={{ fontSize:11, color:T.muted, marginBottom:12, lineHeight:1.5 }}>
          {pairLoading ? "Loading comparison…" : pairError ? <span>Comparison unavailable. <button onClick={() => setPairRetryKey(k => k + 1)}>Retry</button></span>
            : pairMode === "choose" && !pairScanId ? "Choose an older scan to compare" : pair?.reason || "Comparison unavailable for this report"}
        </div>}
        <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit, minmax(150px, 1fr))", gap:12, alignItems:"stretch" }}>
          {kpi(ICONS.scoreChange, "Score Change", scoreChangeValue, scoreChangeColor)}
          {kpi(ICONS.remediated, "Settings Remediated", metricValue("remediated"), T.green,
            canOpenRemediated ? () => onNavPair(pair, "remediated") : undefined)}
          {kpi(ICONS.regressed, "Regressed", metricValue("regressed"), pair?.regressed?.count > 0 ? T.red : T.muted,
            canOpenRegressed ? () => onNavPair(pair, "regressed") : undefined)}
        </div>
        <div style={{ fontSize:11, color:T.muted, margin:"16px 0 8px" }} title="These counts describe the selected report using effective dispositions today. They are not decisions made within the comparison period.">
          Selected report · effective dispositions today
        </div>
        <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit, minmax(150px, 1fr))", gap:12, alignItems:"stretch" }}>
          {kpi(ICONS.open, "Critical + High Open", crHiOpen, crHiOpen > 0 ? T.red : T.green, () => onNavRecs("critical_high"))}
          {kpi(ICONS.riskDecision, "Risk Decisions Recorded", riskDecisions, T.text, () => onNavRecs(null, null, "any_credit"))}
          {kpi(ICONS.quickWin, "Quick Wins", quickWinsValue, quickWinsHigh > 0 ? T.green : T.muted, () => onNavRecs("quick_wins"))}
        </div>
      </Card>
    );
  };

  const donutData = [
    { name:"Satisfied", value:d.impl, color:T.green },
    { name:"Open", value:d.total - d.defer, color:T.blue },
    { name:"Deferred", value:d.defer, color:T.yellow },
    { name:"New", value:d.newS, color:"#9b59b6" },
  ];

  // Real per-axis rows from categoryData (guard the early-return shape that omits
  // these). Product axis groups on r.cat (workload); Security Domain on r.category.
  const catAxisData = catView === "product" ? categoryData.byCategory : categoryData.bySecurityDomain;
  const catRows = Object.entries(catAxisData || {}).map(([name, v]) => ({ name, ...v }));
  // Product names map onto the recs catFilter (filters by r.cat); Security Domain
  // has no recs filter path (catFilter filters r.cat only), so its bars are
  // non-navigating. See report note.
  // Both axes navigate: Product → catFilter (r.cat via PRODUCT_CAT_MAP); Security
  // Domain → categoryFilter (r.category), passed as navToRecs's 4th arg.
  const onCatBarClick = catView === "product"
    ? (name) => onNavRecs(null, name)
    : (name) => onNavRecs(null, null, null, name);

  const recById = useMemo(() => {
    const m = new Map();
    for (const r of recs || []) m.set(r.id, r);
    return m;
  }, [recs]);
  const activeSessionItems = useMemo(
    () => (sessionFocus || [])
      .filter(i => i.status === "Active")
      .sort((a, b) => (a.order_index || 0) - (b.order_index || 0)),
    [sessionFocus]
  );
  const lastReviewIso = useMemo(() => {
    if (!reviewsBySettingId) return null;
    let max = null;
    for (const list of reviewsBySettingId.values()) {
      for (const r of list) {
        const iso = r.reviewed_on || "";
        if (iso && (!max || iso > max)) max = iso;
      }
    }
    return max;
  }, [reviewsBySettingId]);
  const sfThStyle = { padding:"8px 6px", borderBottom:`1px solid ${T.border}`, textAlign:"left", fontSize:11, color:T.muted, fontWeight:600, textTransform:"uppercase", letterSpacing:".04em" };
  const sfTdStyle = { padding:"8px 6px", borderBottom:`1px solid ${T.border}`, fontSize:12.5, verticalAlign:"middle" };

  // Precedence: skeleton while loading (handled inline below via !report), then
  // EmptyState once the fetch settles with no scored data. Defensive fallback
  // covers the "not loading, no error, no report" case that shouldn't occur but
  // would otherwise leave the inline skeletons spinning forever.
  if (!reportLoading && reportError === "roster_inactive") {
    return <EmptyState title={ROSTER_INACTIVE_TITLE} message={ROSTER_INACTIVE_MESSAGE} icon="🔒" />;
  }
  if (!reportLoading && reportError === "no_data") {
    return <NoDataEmptyState scanState={noDataScanState} onGoToProfile={onNavProfile} />;
  }
  if (!reportLoading && !reportError && !report) {
    return <NoDataEmptyState scanState={noDataScanState} onGoToProfile={onNavProfile} />;
  }

  return (
    <div>
      <style>{`.overview-score-card-grid{position:relative}.overview-score-card-grid::before{content:"";position:absolute;top:0;bottom:0;left:50%;width:1px;background:rgba(255,255,255,.12);transform:translateX(-.5px);pointer-events:none}@media (max-width: 900px){.overview-score-layout{grid-template-columns:minmax(0,1fr)!important}.overview-score-layout>div:last-child{min-width:0}}@media (max-width: 540px){.overview-score-card-grid{grid-template-columns:minmax(0,1fr)!important}.overview-score-card-grid::before{display:none}.overview-score-card-grid>div{min-width:0}}`}</style>
      <div className="overview-score-layout" style={{ display:"grid", gridTemplateColumns:"minmax(0, 420px) minmax(0, 1fr)", gap:16, marginBottom:16 }}>
        {!report ? <SkeletonScoreCard /> : (
        <Card style={{ minWidth:0, alignSelf:"start" }}>
          <div className="overview-score-card-grid" style={{ display:"grid", gridTemplateColumns:"minmax(0, 1fr) minmax(0, 1fr)", gap:14, marginBottom:14 }}>
            <div style={{ minWidth:0 }}>
              <h3 style={{ margin:"0 0 4px", fontSize:15, fontWeight:700 }}>SecureShield Score</h3>
              <div style={{ fontSize:10, color:T.blue, marginBottom:8, minHeight:28 }}>Verified by Patriot</div>
              <div style={{ width:"fit-content", maxWidth:"100%" }}>
                <div data-testid="secure-shield-score" style={{ fontSize:42, lineHeight:1, fontWeight:800, margin:"18px 0 8px" }}>{d.score}%</div>
                <div aria-hidden="true" style={{ width:"100%", height:1, background:"rgba(255,255,255,.12)", marginBottom:14 }} />
              </div>
              {typeof report?.totals?.assessed_count === "number" && typeof report?.totals?.total_settings === "number" && <div style={{ color:T.muted, fontSize:10, marginBottom:18 }}>Based on {report.totals.assessed_count} of {report.totals.total_settings} settings</div>}
              <CollapsibleCategoryLegend
                slices={categoryData.patriotSlices}
                onItemClick={(cat) => onNavRecs(null, cat)}
                summaryPrefix="Top categories"
                openLabel="View all categories →"
                closeLabel="Hide categories ↓"
                isOpen={productLegendOpen}
                onToggle={() => setProductLegendOpen(o => !o)}
                filterZero={false}
              />
            </div>
            <div style={{ minWidth:0 }}>
              <h3 style={{ margin:"0 0 4px", fontSize:15, fontWeight:700 }}>Risk-Adjusted Score</h3>
              <div style={{ fontSize:10, color:T.blue, marginBottom:8, minHeight:28 }}>Customer-adjusted<div style={{ color:T.muted, marginTop:2 }}>Adjustments not verified by Patriot</div></div>
              <CategoryDonut
                slices={categoryData.riskAdjustedComposition}
                centerLabel={`${categoryData.adj}%`}
                centerSub={null}
                onSliceClick={(key, isComposition) => isComposition ? onNavRecs(null, null, key) : onNavRecs(null, key)}
                size={160}
              />
              {(!Array.isArray(categoryData.riskAdjustedComposition) || categoryData.riskAdjustedComposition.length === 0 || categoryData.riskAdjustedComposition.reduce((total, slice) => total + (slice.pts !== undefined ? slice.pts : slice.gap), 0) === 0) && <div data-testid="risk-adjusted-score" style={{ textAlign:"center", fontSize:20, fontWeight:800, marginTop:4 }}>{categoryData.adj}%</div>}
              <CollapsibleCategoryLegend
                slices={categoryData.riskAdjustedComposition}
                onItemClick={(key, isComposition) => isComposition ? onNavRecs(null, null, key) : onNavRecs(null, key)}
                summaryPrefix="Composition"
                openLabel="View composition →"
                closeLabel="Hide composition ↓"
                isOpen={compositionLegendOpen}
                onToggle={() => setCompositionLegendOpen(o => !o)}
                filterZero={true}
              />
              {(() => {
                const line = notAssessedOverriddenLine(categoryData.notAssessedOverridden);
                if (!line) return null;
                return <div data-testid="not-assessed-overridden" style={{ fontSize:10, color:T.muted, marginTop:6, lineHeight:1.4 }}>{line.prefix}<span style={{ fontWeight:700 }}>{line.counts}</span>{line.suffix}</div>;
              })()}
            </div>
          </div>
          <MaturityCard customerKey={slug} secureShieldScore={d.score} riskAdjustedScore={categoryData.adj} previousSecureShieldScore={prevScore} T={T} />
          {/* The optional server-owned aggregate is never inferred locally. */}
          <CustomerComparisonCard
            score={report?.totals?.score_pct}
            benchmark={benchmarkForReport(report, currentScanId, previewPending)}
            T={T}
          />
        </Card>
        )}
        <div style={{ display:"flex", flexDirection:"column", minWidth:0 }}>
          {!report ? <SkeletonMetricCardsGrid /> : (
          <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit, minmax(180px, 1fr))", gap:12 }}>
            {/* INVARIANT: A TILE'S NUMBER MUST EQUAL THE "Showing N" COUNT ITS
                CLICK LANDS ON, and match any other surface showing the same
                concept. Each severity card's "+N more" filterKey is the
                *_needs_action composite — severity + the same disposition the
                headline subtracts (open AND no credit-granting override) — so
                the headline equals the landed count. Bare "critical"/"high"/
                "medium" keys keep raw severity semantics for other callers.
                Satisfied keeps the plain "implemented" landing. */}
            <MetricCard bg="linear-gradient(180deg,rgba(139,92,246,.92),rgba(91,55,173,.92))" label="Critical" items={cr} max={4} filterKey="critical_needs_action" />
            <MetricCard bg="linear-gradient(180deg,rgba(239,68,68,.92),rgba(168,28,38,.92))" label="High" items={hi} max={4} filterKey="high_needs_action" />
            <MetricCard bg="linear-gradient(180deg,rgba(249,115,22,.95),rgba(122,50,9,.95))" label="Medium" items={me} max={4} filterKey="medium_needs_action" />
            <MetricCard bg="linear-gradient(180deg,rgba(83,196,109,.9),rgba(48,151,72,.9))" label="Satisfied" count={im.length} items={im} max={4} filterKey="implemented" satisfied />
          </div>
          )}
          {sessionFocusLoading ? <SkeletonNextSessionFocus /> : (
          <div style={{
            background: T.panel,
            border: `1px solid ${T.border}`,
            borderLeft: "3px solid rgba(83,196,109,.60)",
            borderRadius: 12,
            padding: "16px 20px",
            marginTop: 16,
          }}>
            <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center" }}>
              <h3 style={{ margin:0, fontSize:15, fontWeight:700 }}>Next Session Focus</h3>
              <button onClick={onNavQueue} style={{
                padding:"4px 10px", fontSize:11, fontWeight:600, borderRadius:8,
                background:"none", border:"none", color:T.blue, cursor:"pointer", fontFamily:"inherit",
              }}>Open →</button>
            </div>
            {activeSessionItems.length === 0 ? (
              <>
                <div style={{ fontSize:13, color:T.muted, marginTop:12 }}>
                  No items selected for next session yet.
                </div>
                <button onClick={() => onNavRecs && onNavRecs()} style={{
                  marginTop:10, padding:"6px 12px", fontSize:12, fontWeight:600, borderRadius:8,
                  background:"rgba(68,166,255,.12)", border:"1px solid rgba(68,166,255,.3)",
                  color:T.blue, cursor:"pointer", fontFamily:"inherit",
                }}>Browse Recommendations →</button>
              </>
            ) : (
              <>
                <div style={{ fontSize:12, color:T.muted, marginTop:4 }}>
                  {activeSessionItems.length} of {MAX_QUEUE} selected
                  {/* Only a date strictly in the FUTURE is a session the
                      customer can turn up to. A past date is a stale
                      hand-kept target, and TODAY means "Booking Sent was
                      just recorded" — the A.5 status stamps
                      pc_nextauditdate to today when a booking LINK goes
                      out, so including today would tell the customer they
                      have a session today when nothing is scheduled.
                      Both render NOTHING: no "TBD", no "being scheduled",
                      no placeholder — an empty string is the honest
                      output, and a placeholder invites a support email
                      asking what it means. */}
                  {isDateOnlyFuture(nextAuditDate)
                    ? ` · Next session: ${fmtDateOnly(nextAuditDate)}` : ""}
                </div>
                <table style={{ width:"100%", borderCollapse:"collapse", tableLayout:"fixed", marginTop:10 }}>
                  <colgroup>
                    <col style={{ width:50 }} />
                    <col />
                    <col style={{ width:100 }} />
                    <col style={{ width:90 }} />
                  </colgroup>
                  <thead>
                    <tr>
                      <th style={sfThStyle}>#</th>
                      <th style={sfThStyle}>Recommendation</th>
                      <th style={sfThStyle}>Severity</th>
                      <th style={sfThStyle}>Type</th>
                    </tr>
                  </thead>
                  <tbody>
                    {activeSessionItems.slice(0, 4).map(item => {
                      const rec = recById.get(item.setting_id);
                      const typeLabel = item.session_type === "Review" ? "Review" : "Working";
                      return (
                        <tr key={item.id}>
                          <td style={{ ...sfTdStyle, color:T.muted }}>{item.setting_id}</td>
                          <td
                            onClick={() => onItemClick && onItemClick(item)}
                            title={rec ? `#${item.setting_id} ${rec.name}` : `Setting #${item.setting_id} — details unavailable`}
                            style={{ ...sfTdStyle, cursor:"pointer", overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap", ...(rec ? {} : { color:T.muted, fontStyle:"italic" }) }}
                          >
                            {rec ? rec.name : `Setting #${item.setting_id}`}
                          </td>
                          <td style={sfTdStyle}>
                            {rec ? <Badge type={sevBadgeType(rec.sev)}>{sevLabel(rec.sev)}</Badge> : <span style={{ color:T.muted }}>—</span>}
                          </td>
                          <td style={{ ...sfTdStyle, color:T.muted, fontSize:11, fontWeight:600, textTransform:"uppercase", letterSpacing:".04em" }}>
                            {rec ? typeLabel : "—"}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
                {(activeSessionItems.length > 5 || lastReviewIso) && (
                  <div style={{ fontSize:11, color:T.muted, marginTop:10, display:"flex", gap:8, alignItems:"center" }}>
                    {activeSessionItems.length > 5 && (
                      <button onClick={onNavQueue} style={{
                        padding:0, background:"none", border:"none", color:T.blue,
                        cursor:"pointer", fontFamily:"inherit", fontSize:11, fontWeight:600,
                      }}>+ {activeSessionItems.length - 5} more</button>
                    )}
                    {activeSessionItems.length > 5 && lastReviewIso && <span>·</span>}
                    {lastReviewIso && (
                      <span>Last session: {fmtDateOnly(lastReviewIso)}</span>
                    )}
                  </div>
                )}
              </>
            )}
          </div>
          )}
          {/* Posture Movement + Support Snapshot — stacked in the right column,
              filling the space under Next Session Focus (was a standalone full-width
              row that dropped below the tall left column). */}
          {report && (
            <div style={{ display:"grid", gridTemplateColumns:"2fr 1fr", gap:16, marginTop:16, alignItems:"start" }}>
              {renderPostureMovement()}
              {canSeeSupport ? <SupportSnapshot /> : (
              <Card title="Support Snapshot">
                  <div style={{ display:"inline-flex", alignItems:"center", gap:6, fontSize:10, fontWeight:700, textTransform:"uppercase", letterSpacing:".06em", color:T.blue, background:"rgba(68,166,255,.12)", border:`1px solid ${T.border}`, borderRadius:999, padding:"3px 10px", marginBottom:10 }}>Coming soon</div>
                  <div style={{ fontSize:12.5, color:T.text, lineHeight:1.5, marginBottom:8 }}>Open tickets, response time, and recent activity at a glance.</div>
                  {(() => {
                    const sIcon = (path) => (
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">{path}</svg>
                    );
                    const statTile = (icon, label) => (
                      <div key={label} style={{ flex:"1 1 90px", minWidth:90, background:"rgba(255,255,255,.03)", border:`1px solid ${T.border}`, borderRadius:10, padding:"8px 8px", opacity:.55 }}>
                        <span style={{ display:"inline-flex", color:T.muted, marginBottom:4 }}>{icon}</span>
                        <div style={{ fontSize:18, fontWeight:800, lineHeight:1, color:T.text }}>—</div>
                        <div style={{ fontSize:10, color:T.muted, marginTop:3 }}>{label}</div>
                      </div>
                    );
                    return (
                      <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit, minmax(90px, 1fr))", gap:6 }}>
                        {statTile(sIcon(<><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" /></>), "Support tickets")}
                        {statTile(sIcon(<><circle cx="12" cy="12" r="9" /><polyline points="12 7 12 12 15 14" /></>), "Avg response")}
                        {statTile(sIcon(<polyline points="20 6 9 17 4 12" />), "Resolved · 30d")}
                        {statTile(sIcon(<><path d="M13 2L3 14h9l-1 8 10-12h-9z" /></>), "Recent activity")}
                      </div>
                    );
                  })()}
                </Card>
              )}
            </div>
          )}
        </div>
      </div>

      {!report ? <SkeletonCategoryCard /> : (
      <Card>
        <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:12 }}>
          <h3 style={{ margin:0, fontSize:15, fontWeight:700 }}>Posture by Product / Security Domain</h3>
          <ViewToggle
            options={[{ value:"product", label:"By Product" }, { value:"securitydomain", label:"By Security Domain" }]}
            value={catView} onChange={setCatView}
          />
        </div>
        <CatBars rows={catRows} onBarClick={onCatBarClick} />
      </Card>
      )}
    </div>
  );
};


/* ══════════════════════════════════════════════
   PAGE: BENCHMARKS
   ══════════════════════════════════════════════ */
const BenchmarksPage = ({ q }) => {
  const a = B_ALL[q], b = B_IND[q];
  const bucket = a.s < 40 ? 0 : a.s < 50 ? 1 : a.s < 60 ? 2 : a.s < 70 ? 3 : a.s < 80 ? 4 : a.s < 90 ? 5 : 6;

  const mkDist = (arr, color) => D_BINS.map((bin, i) => ({ bin, count: arr[q][i], fill: i === bucket ? color : (color === T.blue ? "rgba(68,166,255,.2)" : "rgba(83,196,109,.2)") }));
  const distAll = mkDist(D_ALL, T.blue);
  const distInd = mkDist(D_IND, T.green);

  const catCompData = CAT_NAMES.map((c, i) => ({ cat: c, you: CAT_YOU[i][q], avg: CAT_IND[i][q] }));

  const BenchCard = ({ title, sub, data, color, dist }) => (
    <Card>
      <h3 style={{ margin:"0 0 4px", fontSize:15, fontWeight:700 }}>{title}</h3>
      <div style={{ fontSize:11, color:T.muted }}>{sub}</div>
      <div style={{ display:"flex", alignItems:"baseline", gap:12, margin:"12px 0", flexWrap:"wrap" }}>
        <div style={{ fontSize:32, fontWeight:800, color }}>{data.s}%</div>
        <div style={{ fontSize:13, color:T.muted }}>
          <em style={{ fontStyle:"normal", fontWeight:700, color:T.text }}>{data.a}%</em> avg{" \u00B7 "}
          <em style={{ fontStyle:"normal", fontWeight:700, color:T.text }}>{data.m}%</em> median{" \u00B7 "}
          <em style={{ fontStyle:"normal", fontWeight:700, color:T.text }}>{data.t}%</em> top 10%
        </div>
      </div>
      <RankStrip pct={data.p} />
      <div style={{ fontSize:12, color:T.blue, marginTop:4, fontWeight:600 }}>{data.p}th percentile</div>
      <div style={{ height:160, marginTop:10 }}>
        <ResponsiveContainer>
          <BarChart data={dist}>
            <XAxis dataKey="bin" tick={{ fill:T.muted, fontSize:10 }} axisLine={false} />
            <YAxis tick={{ fill:T.muted, fontSize:10 }} axisLine={false} />
            <Bar dataKey="count" radius={[4,4,0,0]}>
              {dist.map((e, i) => <Cell key={i} fill={e.fill} />)}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>
    </Card>
  );

  return (
    <div>
      <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:16, marginBottom:16 }}>
        <BenchCard title="vs. all SecureShield clients" sub="Across 247 active clients" data={a} color={T.blue} dist={distAll} />
        <BenchCard title="vs. banking & financial services" sub="Across 38 clients in this vertical" data={b} color={T.green} dist={distInd} />
      </div>
      <Card title="Category comparison \u2014 you vs. banking average">
        <div style={{ height:250 }}>
          <ResponsiveContainer>
            <BarChart data={catCompData} layout="vertical">
              <XAxis type="number" domain={[0, 100]} tick={{ fill:T.muted, fontSize:10 }} tickFormatter={v => `${v}%`} />
              <YAxis type="category" dataKey="cat" tick={{ fill:T.muted, fontSize:11 }} width={110} />
              <Tooltip contentStyle={{ background:T.panel, border:`1px solid ${T.border}`, borderRadius:10, color:T.text, fontSize:12 }} />
              <Legend wrapperStyle={{ fontSize:11, color:T.muted }} />
              <Bar dataKey="you" name="Acme Bank" fill={T.blue} radius={[0,4,4,0]} barSize={12} />
              <Bar dataKey="avg" name="Banking avg" fill="rgba(83,196,109,.5)" radius={[0,4,4,0]} barSize={12} />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </Card>
    </div>
  );
};


/* ══════════════════════════════════════════════
   SETTING DETAIL PANEL — Slide-out from right
   ══════════════════════════════════════════════ */
const PillToggle = ({ options, value, onChange, disabled }) => (
  <div style={{ display:"inline-flex", background:"rgba(255,255,255,.06)", border:`1px solid ${T.border}`, borderRadius:10, overflow:"hidden", opacity: disabled ? 0.4 : 1, pointerEvents: disabled ? "none" : "auto" }}>
    {options.map(o => (
      <button key={o.value} onClick={() => onChange(o.value)} style={{
        padding:"6px 14px", fontSize:11, fontWeight:600, background: value === o.value ? "rgba(68,166,255,.2)" : "transparent",
        border:"none", color: value === o.value ? T.blue : T.muted, cursor: disabled ? "default" : "pointer", fontFamily:"inherit", transition:".15s",
      }}>
        {o.label}
        {/* Count badge — renders only when a positive count is supplied. */}
        {o.badge > 0 && (
          <span style={{
            marginLeft:6, fontSize:9, fontWeight:700, padding:"1px 6px", borderRadius:999, verticalAlign:1,
            background: value === o.value ? "rgba(68,166,255,.25)" : "rgba(255,255,255,.10)",
            color: value === o.value ? T.blue : T.muted,
          }}>{o.badge}</span>
        )}
      </button>
    ))}
  </div>
);

/* ── FilterChip — one toggleable, multi-select filter chip ────────────
 *
 * The Recommendations bar's severity segments (dot + word, tinted with the
 * segment's OWN colour when active), loosened into a wrapping row and given
 * a count. Amber asked for buttons rather than a dropdown — "readiness and
 * then also the scan method" is two clicks, and a dropdown makes it four.
 *
 * THE COLOUR IS PASSED IN, never chosen here. On the Scheduling view it is
 * the tone of the pills the rows behind this chip are wearing, resolved
 * through the one tone→colour map the Readiness cell renders with — so the
 * dot is the pill's colour by construction. The active treatment reuses the
 * pill's own alpha suffixes (`55` border, `1a` fill) rather than inventing a
 * selected state, which is what makes an active chip read as the pill it
 * gathers.
 *
 * `color` null means "no rows behind this chip" — a persisted selection whose
 * state nobody is wearing right now. It renders dimmed with a hollow dot and
 * its 0, because a colour with nothing behind it would be a claim. */
const FilterChip = ({ color, label, count, active, title, onClick }) => {
  const c = color || T.muted;
  const empty = !color;
  return (
    <button
      onClick={onClick}
      aria-pressed={active}
      title={title}
      style={{
        display:"inline-flex", alignItems:"center", gap:6, whiteSpace:"nowrap",
        padding:"5px 10px", borderRadius:999, fontFamily:"inherit",
        fontSize:11.5, fontWeight:600, cursor:"pointer", transition:".15s",
        color: active ? T.text : T.muted,
        border:`1px solid ${active ? `${c}55` : T.border}`,
        background: active ? `${c}1a` : "rgba(255,255,255,.04)",
        opacity: empty && !active ? 0.55 : 1,
      }}
    >
      <span style={{
        display:"inline-block", width:7, height:7, borderRadius:"50%",
        background: empty ? "transparent" : c,
        border: empty ? `1px solid ${T.muted}` : "none",
        opacity: active || !empty ? 1 : 0.6,
      }} />
      {label}
      <span style={{
        fontSize:10, fontWeight:700, padding:"0 5px", borderRadius:999,
        background: active ? `${c}33` : "rgba(255,255,255,.08)",
        color: active ? T.text : T.muted,
      }}>{count}</span>
    </button>
  );
};

// Live adapter: data/actions remain in the existing root. Shared presentation
// receives the same callbacks, while its preference store is explicit.
const LIVE_RECS_COLUMN_PREF_KEY = "ss365_recs_columns_v1";
const liveRecsColumnPreferences = {
  read: () => {
    try { return JSON.parse(window.localStorage.getItem(LIVE_RECS_COLUMN_PREF_KEY)); }
    catch { return null; }
  },
  write: (value) => {
    try { window.localStorage.setItem(LIVE_RECS_COLUMN_PREF_KEY, JSON.stringify(value)); }
    catch { /* unavailable preferences retain view-local state */ }
  },
};
export const SettingDetailPanel = SharedSettingDetailPanel;
export const RecsPage = (props) => <SharedRecsPage {...props} columnPreferenceAdapter={liveRecsColumnPreferences}
  reviewCompleteControl={props.isPatriot ? <ReviewCompleteButton slug={props.slug} clientName={props.clientName} isPatriot={props.isPatriot} deliveryMode={props.deliveryMode} /> : null} />;
const QueuePage = SharedQueuePage;

/* ══════════════════════════════════════════════
   PAGE: AZURE SECUREAUDIT
   ══════════════════════════════════════════════ */
const AzurePage = () => {
  const [azView, setAzView] = useState("technical");
  const cats = azView === "technical" ? AZ_TECHNICAL : AZ_PRACTICE;
  const tdStyle = { padding:"10px 8px", borderBottom:`1px solid ${T.border}`, fontSize:13 };
  const thStyle = { padding:"10px 8px", borderBottom:`1px solid ${T.border}`, textAlign:"left", fontSize:12, color:T.muted, fontWeight:600, textTransform:"uppercase", letterSpacing:".04em" };

  return (
    <div>
      <Card style={{ marginBottom:16 }}>
        <h3 style={{ margin:"0 0 4px", fontSize:15, fontWeight:700 }}>Azure SecureAudit — Subscription Security Posture</h3>
        <div style={{ color:T.muted, fontSize:13, marginBottom:16 }}>Security assessment across Azure subscriptions, resource groups, and workloads.</div>
        <div style={{ display:"grid", gridTemplateColumns:"repeat(4,1fr)", gap:12, marginBottom:20 }}>
          {[
            { bg:"linear-gradient(180deg,rgba(68,166,255,.9),rgba(40,120,200,.9))", label:"Subscriptions", val:"3", sub:"Assessed this quarter" },
            { bg:"linear-gradient(180deg,rgba(225,77,87,.92),rgba(184,46,58,.92))", label:"Critical Findings", val:"7", sub:"Across all subscriptions" },
            { bg:"linear-gradient(180deg,rgba(255,122,69,.92),rgba(219,95,47,.92))", label:"High Findings", val:"23", sub:"Resource misconfigurations" },
            { bg:"linear-gradient(180deg,rgba(83,196,109,.9),rgba(48,151,72,.9))", label:"Remediated", val:"14", sub:"This quarter" },
          ].map(m => (
            <div key={m.label} style={{ borderRadius:14, padding:14, background:m.bg, minHeight:100 }}>
              <div style={{ fontSize:13, fontWeight:700 }}>{m.label}</div>
              <div style={{ fontSize:40, fontWeight:800, lineHeight:1 }}>{m.val}</div>
              <div style={{ fontSize:11, color:"rgba(255,255,255,.7)" }}>{m.sub}</div>
            </div>
          ))}
        </div>
      </Card>

      <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:16, marginBottom:16 }}>
        <Card title="Subscription Scores">
          <table style={{ width:"100%", borderCollapse:"collapse" }}>
            <thead><tr>{["Subscription","Score","Change","Status"].map(h => <th key={h} style={thStyle}>{h}</th>)}</tr></thead>
            <tbody>
              <tr><td style={tdStyle}>Production</td><td style={{ ...tdStyle, fontWeight:800, color:T.green }}>78%</td><td style={tdStyle}><span style={{ display:"inline-flex", alignItems:"center", fontWeight:700, fontSize:11, color:T.green, background:"rgba(83,196,109,.12)", border:"1px solid rgba(83,196,109,.22)", borderRadius:999, padding:"3px 8px" }}>{"\u25B2"} +6%</span></td><td style={tdStyle}><Badge type="green">Improving</Badge></td></tr>
              <tr><td style={tdStyle}>Development</td><td style={{ ...tdStyle, fontWeight:800, color:T.yellow }}>64%</td><td style={tdStyle}><span style={{ display:"inline-flex", alignItems:"center", fontWeight:700, fontSize:11, color:T.green, background:"rgba(83,196,109,.12)", border:"1px solid rgba(83,196,109,.22)", borderRadius:999, padding:"3px 8px" }}>{"\u25B2"} +3%</span></td><td style={tdStyle}><Badge type="yellow">Needs work</Badge></td></tr>
              <tr><td style={tdStyle}>Sandbox</td><td style={{ ...tdStyle, fontWeight:800, color:T.red }}>41%</td><td style={{ ...tdStyle, color:T.muted }}>New</td><td style={tdStyle}><Badge type="red">At risk</Badge></td></tr>
            </tbody>
          </table>
        </Card>
        <Card title="Top Azure Findings">
          <table style={{ width:"100%", borderCollapse:"collapse" }}>
            <thead><tr>{["Finding","Severity","Sub"].map(h => <th key={h} style={thStyle}>{h}</th>)}</tr></thead>
            <tbody>
              {[
                ["Storage accounts allow public blob access","Critical","red","Prod"],
                ["NSGs with overly permissive rules","Critical","red","Dev"],
                ["Key Vault soft delete not enabled","High","orange","Prod"],
                ["Diagnostic settings not configured","High","orange","All"],
                ["Azure Defender for SQL not enabled","High","orange","Prod"],
                ["Resource locks not applied","High","orange","Prod"],
                ["Just-in-Time VM access not configured","Medium","yellow","Dev"],
              ].map(([finding, sev, bt, sub], i) => (
                <tr key={i}><td style={tdStyle}>{finding}</td><td style={tdStyle}><Badge type={bt}>{sev}</Badge></td><td style={tdStyle}>{sub}</td></tr>
              ))}
            </tbody>
          </table>
        </Card>
      </div>

      <Card>
        <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:12 }}>
          <h3 style={{ margin:0, fontSize:15, fontWeight:700 }}>Azure Security by Product</h3>
          <ViewToggle
            options={[{ value:"technical", label:"By Technical Area" }, { value:"practice", label:"By Practice Area" }]}
            value={azView} onChange={setAzView}
          />
        </div>
        {cats.map(c => {
          const lv = getLevel(c.v);
          return (
            <div key={c.n} style={{ display:"flex", alignItems:"center", gap:8, marginBottom:8, fontSize:13 }}>
              <span style={{ width:140, color:T.muted, textAlign:"right", flexShrink:0 }}>{c.n}</span>
              <div style={{ flex:1, height:10, background:"rgba(255,255,255,.08)", borderRadius:999, overflow:"hidden" }}>
                <div style={{ height:"100%", width:`${c.v}%`, borderRadius:999, background:catColor(c.v) }} />
              </div>
              <span style={{ width:36, fontWeight:700 }}>{c.v}%</span>
              <span style={{ fontSize:10, fontWeight:700, padding:"2px 8px", borderRadius:6, whiteSpace:"nowrap", background:lv.bg, color:lv.tc }}>{lv.t}</span>
            </div>
          );
        })}
      </Card>
    </div>
  );
};


/* ══════════════════════════════════════════════
   PAGE: SUPPORT & HOURS
   ══════════════════════════════════════════════ */
// Freshservice numeric code → { label, badge } maps. status 2/3/4/5 and
// priority 1/2/3/4 are the raw codes the ticket_dashboard payload now carries
// (the Vernon data showed status 5 = Closed). Unknown codes fall back to the
// raw value with a neutral badge.
// Verified against this instance's ticket_form_fields status choices (12 total,
// incl. custom statuses beyond the FS defaults 2-5). Short internal labels, not
// the requester_display_value. Unknown codes fall back to the raw number below,
// so a future custom status renders (as its number) rather than crashing.
const FS_STATUS = {
  2:  { label: "Open",              badge: "blue" },
  3:  { label: "Pending",           badge: "yellow" },
  4:  { label: "Resolved",          badge: "green" },
  5:  { label: "Closed",            badge: "slate" },
  6:  { label: "Working",           badge: "teal" },   // distinct from Open's blue
  7:  { label: "Meeting",           badge: "purple" }, // same family as the Working Session type badge — intentional
  8:  { label: "Escalated",         badge: "red" },
  9:  { label: "On Hold",           badge: "yellow" },
  10: { label: "Ready for testing", badge: "blue" },
  11: { label: "Assigned",          badge: "blue" },
  12: { label: "Outside Catalog",   badge: "slate" },
  13: { label: "Scheduled",         badge: "blue" },
};
const FS_PRIORITY = {
  1: { label: "Low",    badge: "slate" },
  2: { label: "Medium", badge: "yellow" },
  3: { label: "High",   badge: "orange" },
  4: { label: "Urgent", badge: "red" },
};
const fsStatus = (code) => FS_STATUS[code] || { label: String(code ?? "—"), badge: "slate" };
const fsPriority = (code) => FS_PRIORITY[code] || { label: String(code ?? "—"), badge: "slate" };

// Ticket "type" derived from the pool it was fetched under (patriot_service,
// tagged by the backend shape()) + the subject prefix for the two L3 kinds.
const FS_PORTAL_BASE = "https://support.patriotconsultingtech.com/helpdesk/tickets";
const ticketType = (t) => {
  const ps = t.patriot_service;
  if (ps === "Level 3 Support") {
    return (t.subject || "").startsWith("Working Session")
      ? { label: "Working Session", badge: "purple" }
      : { label: "Level 3", badge: "blue" };
  }
  if (ps === "SecureShield 365") return { label: "Settings", badge: "slate" };
  // Portal Support tickets. Orange — the only heavy variant not already
  // carrying ticket-type/status meaning in this table (teal=Working status,
  // green=Resolved, yellow=Pending).
  if (ps === "Portal Support") return { label: "Portal", badge: "orange" };
  return null;
};

// Ticket filings, roster requested_on, and last_login are INSTANTS
// (pc_lastlogin is DateAndTime/UserLocal) — local rendering is correct.
const fmtTicketDate = (iso) => fmtInstant(iso);

// ── On-behalf picker (internal-only) ─────────────────────────────────
// Fed by the Portal Access roster: Active members only (status_value
// 125470001 — matches PORTAL_ACCESS_STATUS["active"] on the backend; filter
// on the int, never the label string). Roster-only BY DESIGN — no free-text
// entry: on-behalf requesters must come from the curated Active list. If the
// roster can't load, on-behalf is simply unavailable (filing as yourself
// always works). Parents render this ONLY for internal users.
// value = { email, name }; email "" = file as yourself.
const ON_BEHALF_ACTIVE_STATUS = 125470001;

const OnBehalfPicker = ({ slug, value, onChange }) => {
  const [roster, setRoster] = useState(null); // null=loading | array | false=fetch failed

  const labelStyle = { display:"block", fontSize:12, color:T.muted, marginBottom:6, fontWeight:600 };
  const inputStyle = {
    width:"100%", background:"rgba(255,255,255,0.05)", border:`1px solid ${T.border}`,
    borderRadius:8, color:T.text, fontSize:13, padding:"9px 12px", fontFamily:"inherit", outline:"none",
  };

  useEffect(() => {
    let cancelled = false;
    if (!slug) { setRoster(false); return; }
    fetchAccessList(slug)
      .then(rows => {
        if (cancelled) return;
        const active = (Array.isArray(rows) ? rows : [])
          .filter(m => m.status_value === ON_BEHALF_ACTIVE_STATUS && m.email);
        setRoster(active);
      })
      .catch(() => { if (!cancelled) setRoster(false); });
    return () => { cancelled = true; };
  }, [slug]);

  const fetchFailed = roster === false;
  const emptyRoster = Array.isArray(roster) && roster.length === 0;

  const handleSelect = (e) => {
    const email = e.target.value;
    const member = (roster || []).find(m => m.email === email);
    onChange({ email, name: member?.name || "" });
  };

  return (
    <div style={{ marginBottom:12, padding:12, background:"rgba(68,166,255,0.06)", borderRadius:10, border:`1px solid ${T.border}` }}>
      <label style={labelStyle}>File on behalf of</label>
      <select value={value.email} onChange={handleSelect} style={inputStyle} disabled={fetchFailed}>
        <option value="" style={{ background:T.panel }}>
          {fetchFailed ? "File as yourself"
            : roster === null ? "File as yourself (loading list…)"
            : "File as yourself (default)"}
        </option>
        {(Array.isArray(roster) ? roster : []).map(m => (
          <option key={m.id} value={m.email} style={{ background:T.panel }}>{m.name} ({m.email})</option>
        ))}
      </select>
      {fetchFailed && (
        <p style={{ color:T.muted, fontSize:11, marginTop:6 }}>
          Couldn't load the access list — filing as yourself.
        </p>
      )}
      {emptyRoster && (
        <p style={{ color:T.muted, fontSize:11, marginTop:6 }}>
          No active portal members yet — add them on the Company Profile page.
        </p>
      )}
      {value.email.trim() && (
        <p style={{ color:T.muted, fontSize:11, marginTop:6 }}>
          The ticket will record that you (Patriot) filed it on their behalf. Validated server-side.
        </p>
      )}
    </div>
  );
};

// Shared modal for the Level 3 support / Working session / Portal Support
// Quick Actions. All create a real Freshservice ticket via createL3Ticket;
// kind drives the copy, subject shape, field set (portal_support swaps the
// technology pills for a problem select and drops the "deployed" question),
// and the patriot_service pool tag ("Level 3 Support" vs "Portal Support").
const L3_CATEGORIES = ["Intune", "Defender", "Entra ID", "Purview", "Azure", "Sentinel", "Microsoft 365 Configuration"];
// Portal Support problem categories (kind "portal_support") — single-select.
const PORTAL_CATEGORIES = ["Something isn't working", "Data looks incorrect", "Access problem", "Other"];
const L3_DEPLOYED = ["Not Sure", "Yes", "No"];
const L3_URGENCIES = ["General Question / Request", "Impacting Users", "Service Down / Security Risk"];

const L3RequestModal = ({ open, onClose, kind, slug, currentUserEmail, onSubmitted, onSubmitIntent, isInternal = false }) => {
  const [categories, setCategories] = useState([]);
  const [deployed, setDeployed] = useState("Not Sure");
  const [urgency, setUrgency] = useState("");
  const [description, setDescription] = useState("");
  const [status, setStatus] = useState(null); // null | "loading" | {ok:true} | {error}
  // Internal-only "File on behalf of" — overrides the requester. email "" =
  // file as yourself; name is set when picked from the access-list roster.
  const [onBehalf, setOnBehalf] = useState({ email: "", name: "" });

  // Reset transient state each time the modal (re)opens.
  useEffect(() => {
    if (!open) return;
    setCategories([]); setDeployed("Not Sure"); setUrgency(""); setDescription(""); setStatus(null);
    setOnBehalf({ email: "", name: "" });
  }, [open, kind]);

  if (!open) return null;

  const isSession = kind === "working_session";
  const isPortal = kind === "portal_support";
  const title = isPortal ? "Report a portal problem"
    : isSession ? "Request a working session"
    : "Submit a Level 3 request";
  // Enable submit only with a category (>=1 pill, or the portal single-select)
  // + an urgency + non-empty description.
  const canSubmit = categories.length > 0 && !!urgency && description.trim().length > 0;

  const toggleCategory = (c) =>
    setCategories(prev => prev.includes(c) ? prev.filter(x => x !== c) : [...prev, c]);

  const handleSubmit = async () => {
    if (!canSubmit) return;
    observeProductAnalytics(onSubmitIntent);
    setStatus("loading");
    try {
      // On-behalf (internal only): the picked/typed email overrides the
      // requester, and we stamp the description so the ticket records that
      // Patriot filed it — with the roster name when one was picked.
      const behalf = isInternal ? onBehalf.email.trim() : "";
      const requesterEmail = behalf || currentUserEmail;
      let fullDescription = description.trim();
      if (behalf) {
        const who = onBehalf.name ? `${onBehalf.name} (${behalf})` : behalf;
        fullDescription += `\n\nFiled by ${currentUserEmail} (Patriot) on behalf of ${who} during a review session.`;
      }
      const result = await createL3Ticket({
        slug, requesterEmail, kind,
        categories, deployed, urgency, description: fullDescription,
      });
      setStatus({ ok: true, id: result.ticket_id, url: result.ticket_url });
      onSubmitted?.();
    } catch (e) {
      setStatus({ error: e.message || "Submission failed" });
    }
  };

  const labelStyle = { display:"block", fontSize:12, color:T.muted, marginBottom:6, fontWeight:600 };
  const inputStyle = {
    width:"100%", background:"rgba(255,255,255,0.05)", border:`1px solid ${T.border}`,
    borderRadius:8, color:T.text, fontSize:13, padding:"9px 12px", fontFamily:"inherit", outline:"none",
  };

  return (
    <div onClick={onClose} style={{ position:"fixed", inset:0, background:"rgba(0,0,0,0.5)", zIndex:1000, display:"flex", justifyContent:"center", alignItems:"center" }}>
      <div onClick={e => e.stopPropagation()} style={{ background:T.panel, border:`1px solid ${T.border}`, borderRadius:18, padding:24, maxWidth:560, width:"92%", maxHeight:"90vh", overflowY:"auto", boxShadow:"0 12px 40px rgba(0,0,0,0.4)" }}>
        <h3 style={{ fontSize:16, fontWeight:700, marginBottom:isSession ? 8 : 14 }}>{title}</h3>

        {status && status.ok ? (
          <div style={{ textAlign:"center", padding:"18px 8px" }}>
            <div style={{ fontSize:34, marginBottom:8 }}>{"✓"}</div>
            <div style={{ fontSize:16, fontWeight:700, color:T.green, marginBottom:8 }}>Request submitted</div>
            <p style={{ fontSize:13, color:T.muted }}>Freshservice Ticket #{status.id} — it may take a moment to appear in your ticket list. Your Patriot team has been notified.</p>
            <div style={{ marginTop:16, display:"flex", justifyContent:"center" }}><Btn pri onClick={onClose}>Done</Btn></div>
          </div>
        ) : (
          <>
            {isSession && (
              <div style={{ fontSize:12, color:T.muted, lineHeight:1.6, marginBottom:14, padding:10, background:"rgba(255,255,255,.03)", borderRadius:10, border:`1px solid ${T.border}` }}>
                This is a request for a dedicated working session. Scheduling a dedicated specialist may
                require additional lead time; your Patriot team will coordinate timing after review.
              </div>
            )}

            {isPortal ? (
              /* Portal Support: single-select problem category (stored as a
                 one-element categories array so canSubmit/submit reuse the
                 L3 plumbing unchanged). */
              <div style={{ marginBottom:14 }}>
                <label style={labelStyle}>What's the problem?</label>
                <select
                  value={categories[0] || ""}
                  onChange={e => setCategories(e.target.value ? [e.target.value] : [])}
                  style={inputStyle}
                >
                  <option value="" style={{ background:T.panel }}>Select…</option>
                  {PORTAL_CATEGORIES.map(o => <option key={o} value={o} style={{ background:T.panel }}>{o}</option>)}
                </select>
              </div>
            ) : (
            <div style={{ marginBottom:14 }}>
              <label style={labelStyle}>Which technologies? (select all that apply)</label>
              <div style={{ display:"flex", flexWrap:"wrap", gap:8 }}>
                {L3_CATEGORIES.map(c => {
                  const on = categories.includes(c);
                  return (
                    <button
                      key={c}
                      type="button"
                      onClick={() => toggleCategory(c)}
                      // Hover brighten on unselected pills only — selected pills
                      // already carry the accent treatment. Inline-style mutation
                      // is the file's hover idiom (see SupportPage ticket rows);
                      // the click re-render resets these to the computed style.
                      onMouseEnter={e => { if (!on) { e.currentTarget.style.background = "rgba(255,255,255,0.07)"; e.currentTarget.style.borderColor = "rgba(255,255,255,0.25)"; } }}
                      onMouseLeave={e => { if (!on) { e.currentTarget.style.background = "transparent"; e.currentTarget.style.borderColor = T.border; } }}
                      style={{
                        display:"inline-flex", alignItems:"center", gap:6,
                        padding:"6px 12px", fontSize:12, fontWeight:600, borderRadius:999, cursor:"pointer", fontFamily:"inherit",
                        background: on ? "rgba(68,166,255,.28)" : "transparent",
                        color: on ? "#eaf5ff" : T.muted,
                        border:`1px solid ${on ? "rgba(68,166,255,.65)" : T.border}`,
                        transition:"background 0.15s, border-color 0.15s",
                      }}
                    >
                      <span aria-hidden="true" style={{ fontSize:12, lineHeight:1, color: on ? T.blue : T.muted }}>
                        {on ? "✓" : "○"}
                      </span>
                      {c}
                    </button>
                  );
                })}
              </div>
            </div>
            )}

            {/* Labels flex-fill equal-height grid cells so both selects
                bottom-align even when the longer label wraps to two lines
                at the modal width. Portal Support has no "deployed" question —
                the row collapses to a single full-width Urgency column. */}
            <div style={{ display:"grid", gridTemplateColumns: isPortal ? "1fr" : "1fr 1fr", gap:12, marginBottom:14 }}>
              {!isPortal && (
              <div style={{ display:"flex", flexDirection:"column" }}>
                <label style={{ ...labelStyle, flex:1 }}>Do you currently have this technology deployed?</label>
                <select value={deployed} onChange={e => setDeployed(e.target.value)} style={inputStyle}>
                  {L3_DEPLOYED.map(o => <option key={o} value={o} style={{ background:T.panel }}>{o}</option>)}
                </select>
              </div>
              )}
              <div style={{ display:"flex", flexDirection:"column" }}>
                <label style={{ ...labelStyle, flex:1 }}>Urgency</label>
                <select value={urgency} onChange={e => setUrgency(e.target.value)} style={inputStyle}>
                  <option value="" style={{ background:T.panel }}>Select…</option>
                  {L3_URGENCIES.map(o => <option key={o} value={o} style={{ background:T.panel }}>{o}</option>)}
                </select>
              </div>
            </div>

            <div style={{ marginBottom:12 }}>
              <label style={labelStyle}>Description</label>
              <textarea
                value={description}
                onChange={e => setDescription(e.target.value)}
                placeholder="Describe what you need help with…"
                rows={4}
                style={{ ...inputStyle, resize:"vertical" }}
              />
            </div>

            {/* Internal-only: file this ticket on behalf of a customer contact.
                Customers never see this. Blank = files as the logged-in user. */}
            {isInternal && (
              <OnBehalfPicker slug={slug} value={onBehalf} onChange={setOnBehalf} />
            )}

            {status && status.error && (
              <div style={{ padding:10, marginBottom:12, background:"rgba(225,77,87,0.1)", borderRadius:10, border:"1px solid rgba(225,77,87,0.3)" }}>
                <p style={{ color:T.red, fontSize:13 }}>Couldn't submit: {status.error}</p>
              </div>
            )}

            <div style={{ display:"flex", gap:8, justifyContent:"flex-end" }}>
              <Btn onClick={onClose}>Cancel</Btn>
              <Btn pri onClick={handleSubmit} disabled={!canSubmit || status === "loading"}>
                {status === "loading" ? "Submitting…" : "Submit"}
              </Btn>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

// One gauge card. Switches on its own payload discriminant — never on tier —
// so Settings and L3 render independently (e.g. capped Settings + unlimited L3).
//   capped:    { unlimited:false, used, cap, resets_in? }  -> arc gauge + reset copy
//   unlimited: { unlimited:true, used } | { state:"unlimited", used }  -> hero number, no arc
//   upsell:    { state:"upsell" }  (L3 only)  -> locked card, opens the AE inquiry modal
// period: "quarter" (settings — 6h/quarter window) | "contract" (L3 — the
// cap spans the full contract term). Only the capped branch's copy keys on it.
const HoursGaugeCard = ({ title, subtitle, data, color, onUpgrade, period = "quarter" }) => {
  const isUnlimited = data?.unlimited === true || data?.state === "unlimited";
  const isUpsell = data?.state === "upsell";
  const used = typeof data?.used === "number" ? data.used : 0;

  // Threshold coloring — capped gauges ONLY (no cap = no percentage math,
  // unlimited/upsell untouched). <75% keeps the card's own color; >=75%
  // amber; >=100% red — never rendered without the reframing copy below.
  // The arc fill clamps at full inside <Gauge>; the text shows true usage.
  const cap = data?.cap;
  const hasCap = !isUnlimited && !isUpsell && typeof cap === "number" && cap > 0;
  const pct = hasCap ? used / cap : 0;
  const gaugeColor = hasCap && pct >= 1 ? T.red
    : hasCap && pct >= 0.75 ? T.yellow
    : color;

  return (
    <Card style={{ textAlign:"center" }}>
      <h3 style={{ margin:"0 0 4px", fontSize:15, fontWeight:700 }}>{title}</h3>
      <div style={{ fontSize:11, color:T.muted, marginBottom:12 }}>{subtitle}</div>

      {isUpsell ? (
        // ── L3 upsell (no L3 entitlement) — locked card ──
        <div style={{ padding:"18px 12px" }}>
          <div style={{ fontSize:32, marginBottom:8, color:T.muted }}>
            <svg width="34" height="34" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>
          </div>
          <div style={{ fontSize:16, fontWeight:800, marginBottom:6 }}>Unlimited Level 3</div>
          <div style={{ fontSize:12, color:T.muted, lineHeight:1.6, marginBottom:14 }}>
            Advanced engineering &mdash; Intune, Defender, Entra, and Purview
            architecture and deployment &mdash; beyond settings remediation.
          </div>
          <Btn pri onClick={onUpgrade} style={{ padding:"9px 18px", borderRadius:10 }}>Upgrade</Btn>
        </div>
      ) : isUnlimited ? (
        // ── Unlimited — hero running total, no denominator/arc ──
        <div style={{ padding:"22px 12px 18px" }}>
          <div style={{ lineHeight:1 }}>
            <span style={{ color, fontSize:52, fontWeight:800 }}>{used.toFixed(1)}</span>
            <span style={{ color:T.muted, fontSize:20, fontWeight:700, marginLeft:6 }}>hrs</span>
          </div>
          <div style={{ marginTop:10, fontSize:13, fontWeight:700, color, letterSpacing:".04em", textTransform:"uppercase" }}>Unlimited</div>
          <div style={{ color:T.muted, fontSize:11, marginTop:6 }}>Logged this contract term</div>
        </div>
      ) : (
        // ── Capped — arc gauge (reuses <Gauge>, which clamps used/cap to 1) ──
        <>
          <div style={{ position:"relative", width:180, height:100, margin:"0 auto 12px" }}>
            <Gauge used={used} total={data?.cap ?? 0} color={gaugeColor} />
          </div>
          <div style={{ fontSize:14, fontWeight:700, marginBottom:8 }}>
            <span style={{ color: gaugeColor, fontSize:28 }}>{used.toFixed(1)}</span>
            <span style={{ color:T.muted }}> / {(data?.cap ?? 0).toFixed(1)} hrs this {period === "contract" ? "contract" : "quarter"}</span>
          </div>
          {typeof data?.resets_in === "number" && (
            <div style={{ color:T.muted, fontSize:11, marginTop:4 }}>Resets in {data.resets_in} day{data.resets_in === 1 ? "" : "s"}</div>
          )}
          {hasCap && pct >= 1 && (
            <div style={{ color:T.muted, fontSize:11, marginTop:4 }}>
              {period === "contract" ? "Contract" : "Quarterly"} hours used — contact your Patriot team about additional support.
            </div>
          )}
        </>
      )}
    </Card>
  );
};

const SupportPage = ({ slug, currentUserEmail, onSettingsHelp, onProductAnalyticsAction }) => {
  const [data, setData] = useState(null);
  const [error, setError] = useState(false);
  const [ticketView, setTicketView] = useState("yours"); // "yours" | "company"
  const [showResolved, setShowResolved] = useState(false); // OFF = hide Resolved/Closed
  const [inquiryOpen, setInquiryOpen] = useState(false);
  const [l3Modal, setL3Modal] = useState(null); // null | "level3" | "working_session"
  const { user } = useUserContext();

  const tdStyle = { padding:"10px 8px", borderBottom:`1px solid ${T.border}`, fontSize:13 };
  const thStyle = { padding:"10px 8px", borderBottom:`1px solid ${T.border}`, textAlign:"left", fontSize:12, color:T.muted, fontWeight:600, textTransform:"uppercase", letterSpacing:".04em" };

  // Self-fetch the live rollup (mirrors PendingReviewBanner's cancelled-guard).
  // error holds the backend's error code string when one is available
  // (domain-gate codes), else true — drives the self-explaining copy below.
  useEffect(() => {
    let cancelled = false;
    if (!slug) return;
    setData(null); setError(false);
    fetchTicketDashboard(slug)
      .then(d => { if (!cancelled) setData(d); })
      .catch(e => { if (!cancelled) setError(e?.body?.error || true); });
    return () => { cancelled = true; };
  }, [slug]);

  if (error) {
    // Internal viewers get actionable detail per gate code; customers always
    // get the generic copy. (Internal users bypass the gate server-side, so
    // live they only ever see no_department_for_slug — the other two
    // branches are kept for completeness, e.g. reading a customer's state.)
    const INTERNAL_ERROR_COPY = {
      no_department_for_slug: `This customer's Freshservice link isn't configured — set Company Identifier to "${slug}" in the FS company record.`,
      no_domains_on_file: "No email domains on file for this customer in Freshservice — add their domain(s) to the FS company record to enable the portal.",
      domain_mismatch: "Domain check failed: this user's email domain doesn't match the Freshservice company's domains — verify the Company Identifier is on the right FS company.",
      roster_inactive: "This user's portal-access roster row isn't Active — check their pc_portalaccess row for this customer in Dataverse.",
    };
    const internalDetail = user?.isInternal ? INTERNAL_ERROR_COPY[error] : null;
    return (
      <Card style={{ textAlign:"center", padding:"28px 16px" }}>
        <div style={{ fontSize:15, fontWeight:700, color:T.red, marginBottom:6 }}>Couldn't load support &amp; hours</div>
        <div style={{ fontSize:13, color:T.muted }}>
          {internalDetail || "Please refresh, or contact your Patriot team if this persists."}
        </div>
      </Card>
    );
  }
  if (!data) {
    return (
      <div>
        <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:16, marginBottom:16 }}>
          <Card><Skeleton height={140} /></Card>
          <Card><Skeleton height={140} /></Card>
        </div>
        <Card><Skeleton height={220} /></Card>
      </div>
    );
  }

  const tickets = data.tickets || [];
  // Resolved(4)/Closed(5) count as inactive.
  const isResolved = (t) => t.status === 4 || t.status === 5;
  // Header count reflects the FULL company ticket set (independent of the
  // your/company view AND the show-resolved toggle).
  const openCount = tickets.filter(t => !isResolved(t)).length;
  const totalCount = tickets.length;
  // Visible rows = (your/company filter) AND (showResolved ? all : active only).
  const scoped = ticketView === "yours" ? tickets.filter(t => t.is_yours) : tickets;
  const shown = showResolved ? scoped : scoped.filter(t => !isResolved(t));
  // For the empty-state hint: are there hidden resolved rows in the current scope?
  const hiddenResolvedInScope = !showResolved && scoped.some(isResolved);

  const ToggleTab = ({ id, label }) => (
    <button
      onClick={() => setTicketView(id)}
      style={{
        padding:"6px 14px", fontSize:12, fontWeight:600, borderRadius:8, cursor:"pointer",
        fontFamily:"inherit",
        background: ticketView === id ? "rgba(68,166,255,.18)" : "transparent",
        color: ticketView === id ? T.blue : T.muted,
        border: `1px solid ${ticketView === id ? "rgba(68,166,255,.4)" : T.border}`,
      }}
    >{label}</button>
  );

  return (
    <div>
      {/* ── Two independent gauge cards (Settings left, L3 right) ── */}
      <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:16, marginBottom:16 }}>
        <HoursGaugeCard
          title="Settings & Ticket Hours"
          subtitle="Directly related to SecureShield settings remediation"
          data={data.settings}
          color={T.green}
          period="quarter"
        />
        <HoursGaugeCard
          title="Level 3 Engineering Hours"
          subtitle="Advanced engineering — not directly tied to settings"
          data={data.l3}
          color={T.blue}
          onUpgrade={() => setInquiryOpen(true)}
          period="contract"
        />
      </div>

      {/* ── Ticket history ── */}
      <Card>
        <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:14, gap:12, flexWrap:"wrap" }}>
          <div style={{ display:"flex", alignItems:"baseline", gap:10 }}>
            <h3 style={{ margin:0, fontSize:15, fontWeight:700 }}>Support Tickets</h3>
            <span style={{ fontSize:12, color:T.muted }}>{openCount} open · {totalCount} total</span>
          </div>
          <div style={{ display:"flex", gap:6, alignItems:"center", flexWrap:"wrap" }}>
            {/* Show resolved — composes with the your/company filter (both apply). */}
            <button
              onClick={() => setShowResolved(v => !v)}
              style={{
                padding:"6px 14px", fontSize:12, fontWeight:600, borderRadius:8, cursor:"pointer", fontFamily:"inherit",
                background: showResolved ? "rgba(68,166,255,.18)" : "transparent",
                color: showResolved ? T.blue : T.muted,
                border: `1px solid ${showResolved ? "rgba(68,166,255,.4)" : T.border}`,
              }}
            >{showResolved ? "✓ " : ""}Show resolved</button>
            <span style={{ width:1, height:20, background:T.border, alignSelf:"center" }} />
            <ToggleTab id="yours" label="Your Tickets" />
            <ToggleTab id="company" label="Company Tickets" />
          </div>
        </div>
        <TicketTable headers={["Ticket","Type","Subject","Submitted by","Status","Priority","Created","Hours"]} headerStyle={thStyle}>
            {shown.length === 0 ? (
              <tr>
                <td colSpan={8} style={{ ...tdStyle, textAlign:"center", color:T.muted, padding:"22px 8px" }}>
                  {hiddenResolvedInScope
                    ? "No active tickets — turn on Show resolved to see closed tickets."
                    : ticketView === "yours"
                      ? "No tickets opened under your account."
                      : "No support tickets yet."}
                </td>
              </tr>
            ) : shown.map(t => {
              const st = fsStatus(t.status);
              const pr = fsPriority(t.priority);
              const ty = ticketType(t);
              const hasHours = typeof t.hours === "number" && t.hours > 0;
              // Whole row deep-links to the customer's Freshservice portal (new tab).
              // Deep-link only — no in-dashboard ticket-response UI.
              const openTicket = () => window.open(`${FS_PORTAL_BASE}/${t.id}`, "_blank", "noopener,noreferrer");
              return (
                <tr
                  key={t.id}
                  onClick={openTicket}
                  style={{ cursor:"pointer" }}
                  title="Open in Freshservice"
                  onMouseEnter={e => { e.currentTarget.style.background = "rgba(255,255,255,0.05)"; }}
                  onMouseLeave={e => { e.currentTarget.style.background = "transparent"; }}
                >
                  <td style={{ ...tdStyle, color:T.blue, fontWeight:700 }}>
                    <a
                      href={`${FS_PORTAL_BASE}/${t.id}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      onClick={e => e.stopPropagation()}
                      style={{ color:T.blue, textDecoration:"none", fontWeight:700 }}
                    >#{t.id}</a>
                  </td>
                  <td style={tdStyle}>{ty ? <Badge type={ty.badge}>{ty.label}</Badge> : <span style={{ color:T.muted }}>—</span>}</td>
                  <td style={tdStyle}>{t.subject}</td>
                  <td style={{ ...tdStyle, color:T.muted }}>{t.submitted_by || "—"}</td>
                  <td style={tdStyle}><Badge type={st.badge}>{st.label}</Badge></td>
                  <td style={tdStyle}><Badge type={pr.badge}>{pr.label}</Badge></td>
                  <td style={{ ...tdStyle, color:T.muted }}>{fmtTicketDate(t.created_at)}</td>
                  <td style={{ ...tdStyle, fontWeight: hasHours ? 700 : 400, color: hasHours ? T.text : T.muted }}>
                    {hasHours ? t.hours.toFixed(1) : "—"}
                  </td>
                </tr>
              );
            })}
        </TicketTable>
      </Card>

      {/* ── Quick Actions ── (order: Settings Recommendation Support, Level 3 support, Working session)
          Settings Recommendation Support navigates to Recommendations in
          bulk-select mode → grouped-by-product tickets. Level 3 support +
          Working session create real Freshservice tickets via L3RequestModal
          → createL3Ticket and show ONLY when the customer has L3
          (l3.state !== "upsell"); Silver-without-L3 sees only the settings
          card (rendered as a centered lone card). */}
      {(() => {
        const hasL3 = data.l3?.state !== "upsell";
        // Order (left→right): Settings Recommendation Support, then (if L3) Level 3 support, Working session.
        const actions = [
          // Settings Recommendation Support — navigates to Recommendations in
          // bulk-select mode (customer picks settings → grouped-by-product
          // tickets). See onSettingsHelp.
          { key:"settings", title:"Settings Recommendation Support", sub:"Get help with recommendations from your security posture review.",
            icon:<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M9 11l3 3L22 4"/><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"/></svg>,
            onClick:() => onSettingsHelp?.() },
          ...(hasL3 ? [
            { key:"level3", title:"Level 3 support", sub:"Request advanced engineering help",
              icon:<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"/></svg>,
              onClick:() => setL3Modal("level3") },
            { key:"working_session", title:"Level 3 Working Session", sub:"Book time with an engineer",
              icon:<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>,
              onClick:() => setL3Modal("working_session") },
          ] : []),
          // Portal Support — visible to ALL customers (outside the hasL3
          // gate). Files a patriot_service "Portal Support" ticket.
          { key:"portal_support", title:"Portal Support", sub:"Report a problem with this portal.",
            icon:<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><circle cx="12" cy="12" r="4"/><line x1="4.93" y1="4.93" x2="9.17" y2="9.17"/><line x1="14.83" y1="14.83" x2="19.07" y2="19.07"/><line x1="14.83" y1="9.17" x2="19.07" y2="4.93"/><line x1="4.93" y1="19.07" x2="9.17" y2="14.83"/></svg>,
            onClick:() => setL3Modal("portal_support") },
        ];
        // Keep a lone card from looking orphaned in a 3-col grid: center + cap width.
        const single = actions.length === 1;
        return (
          <div style={{ marginTop:16 }}>
            <Card title="Quick Actions">
              <div style={{
                display:"grid",
                gridTemplateColumns: single ? "minmax(0, 360px)" : `repeat(${actions.length}, 1fr)`,
                justifyContent: single ? "center" : "stretch",
                gap:10,
              }}>
                {actions.map(({ key, title, sub, icon, onClick }) => (
                  <Btn key={key} onClick={onClick} style={{ width:"100%", textAlign:"left", padding:"14px 16px", borderRadius:14 }}>
                    <div style={{ display:"flex", alignItems:"center", gap:10, marginBottom:4 }}>
                      <span style={{ color:T.blue, display:"inline-flex" }}>{icon}</span>
                      <span style={{ fontWeight:700 }}>{title}</span>
                    </div>
                    <div style={{ fontSize:12, color:T.muted, fontWeight:400 }}>{sub}</div>
                  </Btn>
                ))}
              </div>
            </Card>
          </div>
        );
      })()}

      {/* L3 / working-session request modal — both Quick Actions share it. */}
      <L3RequestModal
        open={l3Modal !== null}
        kind={l3Modal || "level3"}
        onClose={() => setL3Modal(null)}
        slug={slug}
        currentUserEmail={currentUserEmail || user?.email || ""}
        isInternal={!!user?.isInternal}
        onSubmitIntent={() => observeProductAnalytics(onProductAnalyticsAction, "support_submitted")}
        onSubmitted={() => {
          // Refresh the rollup so the new ticket appears in the table.
          // fresh=true bypasses the backend's per-instance L1 so the
          // just-injected ticket can't be hidden by another instance.
          if (slug) fetchTicketDashboard(slug, true).then(setData).catch(() => {});
        }}
      />

      {/* Reuse the existing upsell inquiry modal (same one the pill bar uses).
          Identity is derived server-side; we only preselect the service + prefill for display. */}
      <ServiceInquiryModal
        open={inquiryOpen}
        onClose={() => setInquiryOpen(false)}
        currentUser={{ name: user?.name || "", email: currentUserEmail || user?.email || "", company: user?.company || "" }}
        service="SecureShield365 Managed Services"
      />
    </div>
  );
};


/* ══════════════════════════════════════════════
   MAIN DASHBOARD
   ══════════════════════════════════════════════ */
/* The CUSTOMER's view of a held scan (2026-08-09). Before this, a customer
   who ran a scan saw the wait card's "held" copy during the poll and then
   NOTHING on any later page load — their report silently stayed on old
   data with no explanation.

   Deliberately says three things and no more: which scan, that Patriot is
   reviewing it, and that they are seeing previous results meanwhile. No
   REASON (an internal judgement about scan quality — the endpoint strips
   it server-side), and no ETA (we cannot honour one; the queue has no
   assigned owner).

   KNOWN GAP, deliberately not fixed here: reject_pending DELETES the
   pending pointer, so on rejection this banner simply disappears and the
   customer is never told. See the PR body. */
function CustomerPendingBanner({ slug, show }) {
  const [pending, setPending] = useState(null);

  useEffect(() => {
    let cancelled = false;
    if (!slug || !show) { setPending(null); return undefined; }
    fetchPendingStatus(slug)
      .then(s => { if (!cancelled) setPending(s?.pending ? s : null); })
      .catch(() => { if (!cancelled) setPending(null); })
    return () => { cancelled = true; };
  }, [slug, show]);

  if (!pending) return null;
  const when = pending.executed_at ? fmtDateOnly(pending.executed_at) : null;
  return (
    <div style={{
      marginBottom: 12, padding: "10px 14px", borderRadius: 10,
      background: "rgba(68,166,255,.08)",
      border: "1px solid rgba(68,166,255,.3)",
      color: T.text, fontSize: 13,
    }}>
      {when
        ? <>A scan from <b>{when}</b> is being reviewed by Patriot. You're seeing your previous results until it's published.</>
        : <>A recent scan is being reviewed by Patriot. You're seeing your previous results until it's published.</>}
    </div>
  );
}

/* Whole days between an instant and now, or null when it cannot be read.
   Instants only — never a DateOnly field, so no date-authority formatter
   belongs here (utils/dates owns those; this is elapsed time, not a date). */
function daysSinceInstant(iso) {
  if (!iso) return null;
  const then = Date.parse(iso);
  if (Number.isNaN(then)) return null;
  return Math.max(0, Math.floor((Date.now() - then) / 86400000));
}

/* ADR-0088 D-c — the aging signal on the Publishing tab.

   The `held` alert kind stays suppressed (SCAN_ALERT_SUPPRESSED_KINDS)
   because a held scan has an independent human surface: this queue. That
   justification only holds if someone LOOKS at the queue, and the review
   queue has no assigned owner. So the tab states, without being asked, how
   long the longest-waiting scan has been sitting.

   The OLDEST hold, deliberately — the newest would reset the clock every
   time a fresh scan landed and let a month-old backlog read as brand new. */
function QueueAgingNotice({ queue }) {
  if (!Array.isArray(queue) || queue.length === 0) return null;
  const ages = queue
    .map(p => daysSinceInstant(p.executed_at || p.scored_at))
    .filter(d => d !== null);
  if (ages.length === 0) return null;

  const days = Math.max(...ages);
  const stale = days >= 7;
  const scans = queue.length === 1 ? "1 scan is" : `${queue.length} scans are`;
  const age = days === 0 ? "today" : days === 1 ? "1 day" : `${days} days`;

  return (
    <div style={{
      marginBottom: 14, padding: "8px 12px", borderRadius: 8, fontSize: 12.5,
      background: stale ? "rgba(243,181,63,.10)" : "rgba(255,255,255,.04)",
      border: `1px solid ${stale ? "rgba(243,181,63,.35)" : "rgba(255,255,255,.10)"}`,
      color: stale ? T.yellow : T.muted,
    }}>
      {scans} waiting. Oldest held {days === 0 ? age : `${age} ago`}.
    </div>
  );
}

/* Per-row Publish / Reject for the Review Queue (ADR-0088 D-e).

   Each row acts on ITS OWN scan, carrying that row's pending_id. Before
   ADR-0088 the queue offered no actions at all — a reviewer opened the
   customer and used the banner — and a customer could only hold one scan,
   so "the held scan" was unambiguous. With N rows the action has to name
   which one, or clicking row 3 would publish row 1's scan.

   Reject confirms in place: it is destructive and unattributed (nothing
   records that a scan was rejected), so a stray click must not perform it. */
function QueueRowActions({ row, clientUrl, onResolved }) {
  const [busy, setBusy] = useState(false);
  const [confirming, setConfirming] = useState(false);
  const [error, setError] = useState(null);
  const [publishRequestId, setPublishRequestId] = useState(() => newOperationRequestId());

  const run = async (fn) => {
    setBusy(true); setError(null);
    try {
      await fn(row.slug, row.pending_id, fn === publishPendingScan ? publishRequestId : null);
      if (fn === publishPendingScan) setPublishRequestId(newOperationRequestId());
      if (onResolved) onResolved();
    } catch (e) {
      // A 409 is a REFUSAL, not a failure (D-a2): the server's message
      // names the supported way to publish an older scan on purpose
      // (un-publish first). Show it verbatim — a generic "publish failed"
      // would send the reviewer looking for a bug that isn't there.
      setError(e?.body?.message || e?.message || "Action failed");
      setBusy(false);
      setConfirming(false);
    }
  };

  const btn = (bg, extra = {}) => ({
    background: bg, color: "#fff", border: "none", borderRadius: 6,
    padding: "5px 10px", fontSize: 12, fontWeight: 600,
    cursor: busy ? "default" : "pointer", opacity: busy ? 0.6 : 1,
    whiteSpace: "nowrap", ...extra,
  });

  return (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-end", gap: 6 }}>
      <div style={{ display: "flex", gap: 6, justifyContent: "flex-end", flexWrap: "wrap" }}>
        {confirming ? (
          <>
            <span style={{ fontSize: 11.5, color: T.muted, alignSelf: "center" }}>Reject this scan?</span>
            <button onClick={() => run(rejectPendingScan)} disabled={busy} style={btn("#a3373a")}>
              {busy ? "Working…" : "Confirm"}
            </button>
            <button onClick={() => setConfirming(false)} disabled={busy}
              style={btn("transparent", { border: "1px solid rgba(255,255,255,0.25)", color: T.text })}>
              Cancel
            </button>
          </>
        ) : (
          <>
            <a href={clientUrl(row.slug)} style={{ fontSize:12, fontWeight:600, color:T.blue, textDecoration:"none", whiteSpace:"nowrap", alignSelf:"center" }}>Review →</a>
            <button onClick={() => run(publishPendingScan)} disabled={busy} style={btn("#2e8b57")}>
              {busy ? "Working…" : "Publish"}
            </button>
            <button onClick={() => setConfirming(true)} disabled={busy}
              style={btn("transparent", { border: "1px solid rgba(255,255,255,0.25)", color: T.text })}>
              Reject
            </button>
          </>
        )}
      </div>
      {error && (
        <div style={{ fontSize: 11.5, color: "#ff8a8a", maxWidth: 340, textAlign: "right" }}>{error}</div>
      )}
    </div>
  );
}

/* One held scan's review card. Extracted from PendingReviewBanner in
   ADR-0088 PR5 so the banner can render N of them; the single-hold layout
   and copy are UNCHANGED, which is what makes this safe to ship before the
   scoring writer starts producing second holds. */
function PendingHoldCard({ slug, hold, previewing, onPreview, onPublished, onRejected }) {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);
  const [confirmReject, setConfirmReject] = useState(false);
  const [publishRequestId, setPublishRequestId] = useState(() => newOperationRequestId());

  // Held-scan received timestamp — an INSTANT.
  const fmtDate = (iso) => fmtInstant(iso, { month: "long", day: "numeric", year: "numeric" }, "unknown date");

  const doPublish = async () => {
    setBusy(true); setError(null);
    try {
      await publishPendingScan(slug, hold.pending_id, publishRequestId);
      setPublishRequestId(newOperationRequestId());
      if (onPublished) onPublished();
    } catch (e) {
      // A 409 is a REFUSAL, not a failure (ADR-0088 D-a2). The server's
      // message names the supported way to publish an older scan on
      // purpose — un-publish first — so show it rather than "Publish failed".
      setError(e?.body?.message || e.message || "Publish failed");
      setBusy(false);
    }
  };

  const doReject = async () => {
    setBusy(true); setError(null);
    try {
      await rejectPendingScan(slug, hold.pending_id);
      if (onRejected) onRejected();
    } catch (e) {
      setError(e?.body?.message || e.message || "Reject failed");
      setBusy(false);
      setConfirmReject(false);
    }
  };

  const reasons = hold.hold_reasons || [];

  return (
    <div style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: 16, flexWrap: "wrap" }}>
      <div style={{ minWidth: 0 }}>
        <div style={{ fontSize: 13, fontWeight: 700, color: "#f3b53f", letterSpacing: 0.3, textTransform: "uppercase" }}>
          {previewing ? "Previewing held scan — not yet published" : "Scan held for review"}
        </div>
        <div style={{ fontSize: 13.5, color: "#e8eef6", marginTop: 4 }}>
          {previewing
            ? <>The dashboard below is showing the <strong>held scan</strong> from {fmtDate(hold.executed_at || hold.scored_at)}. Regressions and score changes are flagged as on any scan. Review it, then publish or reject. Use the scan dropdown to compare against prior published scans.</>
            : <>A new scan from <strong>{fmtDate(hold.executed_at || hold.scored_at)}</strong> is awaiting Patriot approval. The customer continues to see the previously published scan until you publish this one.</>}
        </div>
        {reasons.length > 0 && (
          <ul style={{ margin: "8px 0 0", paddingLeft: 18, color: "#cdd7e4", fontSize: 12.5 }}>
            {reasons.map((r, i) => <li key={i} style={{ marginBottom: 2 }}>{r}</li>)}
          </ul>
        )}
        {error && <div style={{ color: "#ff8a8a", fontSize: 12.5, marginTop: 8 }}>{error}</div>}
      </div>
      <div style={{ display: "flex", gap: 8, flexShrink: 0 }}>
        {!confirmReject ? (
          <>
            <button onClick={() => onPreview(hold.pending_id)} disabled={busy}
              style={{ background: previewing ? "rgba(255,255,255,0.12)" : "#44a6ff", color: "#fff", border: "none", borderRadius: 7,
                padding: "8px 16px", fontSize: 13, fontWeight: 600, cursor: busy ? "default" : "pointer", opacity: busy ? 0.6 : 1 }}>
              {previewing ? "Exit preview" : "Preview this scan"}
            </button>
            <button onClick={doPublish} disabled={busy}
              style={{ background: "#2e8b57", color: "#fff", border: "none", borderRadius: 7,
                padding: "8px 16px", fontSize: 13, fontWeight: 600, cursor: busy ? "default" : "pointer", opacity: busy ? 0.6 : 1 }}>
              {busy ? "Working…" : "Publish to customer"}
            </button>
            <button onClick={() => setConfirmReject(true)} disabled={busy}
              style={{ background: "transparent", color: "#e8eef6", border: "1px solid rgba(255,255,255,0.25)",
                borderRadius: 7, padding: "8px 16px", fontSize: 13, fontWeight: 600, cursor: busy ? "default" : "pointer" }}>
              Reject
            </button>
          </>
        ) : (
          <>
            <span style={{ alignSelf: "center", fontSize: 12.5, color: "#cdd7e4" }}>Reject this scan?</span>
            <button onClick={doReject} disabled={busy}
              style={{ background: "#c0392b", color: "#fff", border: "none", borderRadius: 7,
                padding: "8px 16px", fontSize: 13, fontWeight: 600, cursor: busy ? "default" : "pointer", opacity: busy ? 0.6 : 1 }}>
              {busy ? "Working…" : "Confirm reject"}
            </button>
            <button onClick={() => setConfirmReject(false)} disabled={busy}
              style={{ background: "transparent", color: "#e8eef6", border: "1px solid rgba(255,255,255,0.25)",
                borderRadius: 7, padding: "8px 16px", fontSize: 13, fontWeight: 600, cursor: "pointer" }}>
              Cancel
            </button>
          </>
        )}
      </div>
    </div>
  );
}

/* Patriot's held-scan review banner on a customer dashboard.

   ADR-0088: a customer can have N scans held, so this reads the whole list
   (GET /clients/{slug}/pending-list) and renders one card per scan, each
   acting on its OWN pending_id. With exactly one hold — every customer in
   production until the scoring writer ships — it renders precisely what it
   rendered before: same copy, same buttons, no count, no list chrome.

   The list, not pending-status, is the source here: pending-status answers
   the customer-facing question ("is something being reviewed") and its
   shape is a security boundary that deliberately does not grow. */
function PendingReviewBanner({ slug, isPatriot, onPublished, onRejected, previewPending, onPreview, refreshKey }) {
  const [holds, setHolds] = useState(null);

  // refreshKey is the parent's pendingRefreshKey, bumped after a publish or
  // reject. REFETCHING rather than dropping the acted-on card is the point:
  // a publish also clears the customer's SUPERSEDED holds server-side
  // (ADR-0088 D-a), so a local filter would leave cards on screen for scans
  // that no longer exist. Re-deriving which siblings died would mean a
  // second copy of the supersession rule in JS — the drift this ADR works
  // to avoid everywhere else.
  useEffect(() => {
    let cancelled = false;
    if (!slug || !isPatriot) { setHolds(null); return; }
    fetchPendingList(slug)
      .then(list => { if (!cancelled) setHolds(Array.isArray(list) ? list : []); })
      .catch(() => { if (!cancelled) setHolds([]); });
    return () => { cancelled = true; };
  }, [slug, isPatriot, refreshKey]);

  if (!isPatriot || !holds || holds.length === 0) return null;

  return (
    <div style={{
      background: "rgba(243,181,63,0.10)", border: "1px solid rgba(243,181,63,0.45)",
      borderRadius: 10, padding: "14px 16px", marginBottom: 12,
      display: "flex", flexDirection: "column", gap: 10,
    }}>
      {holds.length > 1 && (
        <div style={{ fontSize: 12.5, color: "#cdd7e4" }}>
          <strong>{holds.length} scans</strong> are held for this customer, newest first.
          Publishing one also clears any OLDER scan still held; newer ones stay for review.
        </div>
      )}
      {holds.map((hold, i) => (
        <React.Fragment key={hold.pending_id || `hold-${i}`}>
          {i > 0 && <div style={{ height: 1, background: "rgba(255,255,255,0.12)" }} />}
          <PendingHoldCard
            slug={slug}
            hold={hold}
            previewing={!!previewPending && previewPending === hold.pending_id}
            onPreview={onPreview}
            onPublished={onPublished}
            onRejected={onRejected}
          />
        </React.Fragment>
      ))}
    </div>
  );
}

/* ══════════════════════════════════════════════
   PAGE: ADMIN (Patriot-only) — Publishing | Logins | Access
   ══════════════════════════════════════════════ */
// SecureScan365 tab — run-state badge map. The runs INDEX projects
// normalized DisplayState buckets ("In progress" | "Completed" | "Failed"
// | "Cancelled"); the run-control STATUS vocabulary (Accepted → Queued →
// Running → Completed | Failed | Cancelled) can still surface via the
// status endpoint and old fallbacks, so both sets are mapped. Badge
// colors follow ACCESS_STATUS_BADGE's soft-weight idiom.
const SCAN_STATE_BADGE = {
  "Completed":   "green",
  "In progress": "yellow",
  "Running":     "yellow",
  "Queued":      "slate",
  "Accepted":    "slate",
  "Failed":      "red",
  "Cancelled":   "amber",
  "Unknown":     "slate",  // display_state fallback when the engine sends no state and no timestamps
  // ── Prereq-check verdicts (2026-08-16) ──
  // The backend maps a claim's stored verdict into display_state, so
  // these arrive as ordinary state strings. THEY MUST BE ENTRIES: without
  // them they fall through to the `|| "slate"` default below and all
  // three render grey — the change becomes invisible while every test
  // that does not assert colour still passes.
  //
  // SOFT WEIGHT IS LOAD-BEARING FOR AMBER. `amber` exists in `soft` and
  // NOT in `heavy`, so a heavy amber badge renders BLUE (documented on
  // badgeColors) — "Issue found" would become visually identical to the
  // blue "Prereq check" pill and nothing would fail. The state cell is
  // already weight="soft"; a test asserts the resolved colour by identity.
  //
  // "Not evaluated" shares slate with "Finished" DELIBERATELY: neither is
  // a pass and neither is an issue, so neither may wear green or amber.
  // They are separated by label and tooltip, not by colour.
  "Passed":        "green",
  "Issue found":   "amber",
  "Not evaluated": "slate",
};

// What a claim row's state cell explains on hover. A claim is the
// PORTAL's record of a check, not an engine index row, so every one of
// these says where the fact came from and what is not knowable from it.
// Keyed by display_state; anything unlisted (i.e. "Started") gets the
// default below, which is the honest answer for a check whose result has
// never been read.
const PREREQ_CLAIM_STATE_HINTS = {
  // A verdict exists only because a result read returned one, so all four
  // of these are "the result has been read" — the same fact "Finished"
  // has always stated.
  "Finished": "Recorded by the portal at start; its result has since been read. The engine's run index does not carry check runs, so no engine state is available here.",
  "Passed": "Recorded by the portal at start; its result has since been read. The engine's run index does not carry check runs, so no engine state is available here.",
  "Issue found": "Recorded by the portal at start; its result has since been read. The engine's run index does not carry check runs, so no engine state is available here.",
  // The one state whose tooltip carries new information, and the reason
  // "Not evaluated" is worth distinguishing from "Finished" at all: the
  // engine answered and declined to rule, rather than nobody having read
  // the result. Operator copy, verbatim.
  "Not evaluated": "The check ran but the engine could not evaluate this run (e.g. the run was stale). No verdict was recorded.",
};
const PREREQ_CLAIM_STATE_HINT_DEFAULT =
  "Recorded by the portal when the check was started. The engine's run index does not carry check runs, so whether it has since finished is not knowable from this list.";
const SCAN_TERMINAL_STATES = new Set(["Completed", "Failed", "Cancelled"]);
// Prerequisites polling adds "Stale": the engine projects it onto a run
// whose heartbeat lapsed, and (contract v1.1) the RESULT endpoint 404s for
// it — the backend maps that to couldNotEvaluate, so Stale ends the poll
// and we fetch the (empty) result like any other terminal state.
const PREREQ_TERMINAL_STATES = new Set(["Completed", "Failed", "Cancelled", "Stale"]);
// Return events often arrive in pairs (visibility followed by focus). This is
// event-gated de-duping, never a polling interval.
const REVIEW_OPS_RETURN_REFRESH_MIN_INTERVAL_MS = 1500;

// Prerequisites item Status is a four-way vocabulary — Failed is the only
// one that blocks; Unknown means "not evaluated" and carries its reason in
// Unevaluated[]. CheckIds include OPEN namespaces (Connectivity.<Service>,
// Role.<RoleName>) — render whatever arrives; never enumerate members.
// Types come from Badge's HEAVY palette (the severity palette — soft has
// no red, it silently falls back to blue).
const PREREQ_ITEM_BADGE = {
  Passed:  "green",
  Failed:  "red",
  Warning: "yellow",
  Unknown: "slate",
};
const PREREQ_OUTCOME_BADGE = {
  ready:            { type: "green", label: "Ready" },
  blocked:          { type: "red",   label: "Blocked" },
  couldNotEvaluate: { type: "slate", label: "Could not evaluate" },
};

/* ── Admin table overflow protection (two layers) ──
   Layer 1 — TableScroll: every admin table sits in its own horizontally
   scrollable container. <main> carries overflowX:hidden (deliberate — it is
   what keeps the page itself from ever scrolling sideways, see #458), so a
   table wider than the content area is otherwise CLIPPED and its rightmost
   columns become unreachable. The wrapper turns "unreachable" into "scroll
   this table", even if a future column makes it wide again.
   Layer 2 — UpnCell: cap unbreakable identifier tokens (UPNs/emails — a
   hyphen-less name@tenant.onmicrosoft.com is a single ~330px word) so the
   scroll is rarely needed at all. Ellipsised; full value in the title.
   NOTE: only use UpnCell for unbreakable tokens. Wrapping normally-wrapping
   text (customer names) in nowrap+ellipsis RAISES its min-content demand —
   measured +130px on the runs table — and makes tables wider, not narrower. */
const TableScroll = ({ children }) => (
  <div style={{ overflowX: "auto" }}>{children}</div>
);
const UpnCell = ({ value, max = 240 }) => (
  value
    ? <div style={{ maxWidth: max, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }} title={value}>{value}</div>
    : <>{"—"}</>
);

const renewalWriteFieldLabel = (field) => ({
  pc_allowancemodel: "Allowance Model",
  pc_reviewsperyear: "Reviews Per Year",
  pc_termstartdate: "Term Start Date",
  pc_termnumber: "Term Start Year",
  pc_contractyear: "Contract Year",
  pc_reviewnumber: "Review Number",
  pc_secureshieldtier: "SecureShield365 Tier",
  pc_secureshieldduration: "Duration Months",
  pc_secureshieldexpirationdate: "Stored Term End Date",
  pc_nextauditdate: "Next Review Date",
  pc_requestcredsdate: "Credentials Request Date",
  pc_autorenew: "Auto Renew",
  pc_contractstatus: "Contract Status",
  pc_secureshieldstatus: "Opportunity Status",
}[field] || field);

const RENEWAL_ALLOWANCE_MODEL_LABELS = {
  125470000: "Legacy",
  125470001: "Banked",
};
const RENEWAL_TIER_LABELS = {
  125470000: "Bronze",
  125470001: "Silver",
  125470002: "Gold",
  125470003: "Platinum",
};
const RENEWAL_CONTRACT_STATUS_LABELS = {
  125470000: "Ongoing",
  125470001: "On Hold",
  125470002: "Closed",
  125470003: "Open",
  125470004: "Expired",
  125470005: "Pending",
  125470006: "New",
};
const RENEWAL_OPPORTUNITY_STATUS_LABELS = {
  125470002: "In Progress",
  125470003: "Won",
  125470004: "Lost",
};

const renewalWriteValueLabel = (field, value) => {
  if (value === null || value === undefined) return "Clear";
  if (field === "pc_autorenew") {
    if (value === true) return "Yes";
    if (value === false) return "No";
  }
  if (field === "pc_allowancemodel") {
    const label = RENEWAL_ALLOWANCE_MODEL_LABELS[Number(value)] || "Unknown";
    return label;
  }
  if (field === "pc_secureshieldtier") {
    const label = RENEWAL_TIER_LABELS[Number(value)] || "Unknown";
    return label;
  }
  if (field === "pc_contractstatus") {
    const label = RENEWAL_CONTRACT_STATUS_LABELS[Number(value)] || "Unknown";
    return label;
  }
  if (field === "pc_secureshieldstatus") {
    const label = RENEWAL_OPPORTUNITY_STATUS_LABELS[Number(value)] || "Unknown";
    return label;
  }
  return String(value);
};

const renewalActionKey = (action) => {
  if (window.crypto?.randomUUID) return window.crypto.randomUUID();
  return `${action}-${Date.now()}-${Math.random().toString(16).slice(2)}`;
};

const renewalLifecycleParam = (lifecycleAction) => (
  lifecycleAction === "non_renewal"
    ? { lifecycleAction: "non_renewal" }
    : {}
);

const renewalLifecycleFromRow = (row) => (
  row?.renewal_work_state === "non_renewal_scheduled"
  || row?.renewal_work_state === "non_renewal_due"
    ? "non_renewal"
    : "renewal"
);

const renewalStateLabel = (status, lifecycleAction) => {
  const nonRenewal = lifecycleAction === "non_renewal";
  return ({
    none: nonRenewal ? "No scheduled non-renewal" : "No scheduled renewal",
    scheduled: nonRenewal ? "Non-renewal scheduled" : "Scheduled",
    ready: nonRenewal ? "Non-renewal due" : "Ready to activate",
    activated: nonRenewal ? "Non-renewal activated" : "Activated",
    voided: nonRenewal ? "Non-renewal voided" : "Voided",
    rescinded: "Rescinded",
  }[status] || "Unknown");
};

// Empty advanced forms; the modal resets to these on every opening.
const blankCorrectionForm = () => ({
  completionId:"", toLineage:"", reason:"",
  signedAgreementReference:"", commercialApprovalReference:"",
});
const blankPredecessorForm = () => ({
  originalServiceDate:"", reviewType:"scheduled", note:"", lineage:"",
  successorCompletionId:"", reason:"", signedAgreementReference:"",
  commercialApprovalReference:"",
});

const ContractChangeModal = ({ row, initialAction = "amend", onClose, onChanged }) => {
  const coveredThrough = exclusiveEnd => {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(exclusiveEnd || "")) return exclusiveEnd;
    const day = new Date(`${exclusiveEnd}T00:00:00Z`);
    day.setUTCDate(day.getUTCDate() - 1);
    return day.toISOString().slice(0, 10);
  };
  const exclusiveAfter = lastCovered => {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(lastCovered || "")) return "";
    const day = new Date(`${lastCovered}T00:00:00Z`);
    if (Number.isNaN(day.getTime()) || day.toISOString().slice(0, 10) !== lastCovered)
      return "";
    day.setUTCDate(day.getUTCDate() + 1);
    return day.toISOString().slice(0, 10);
  };
  // A cancellation reports whether Confirm also finalized it. The cancel is
  // recorded in every case; only finalization can still be pending.
  const finalizationMessage = result => {
    const finalization = result?.finalization;
    if (finalization?.status === "complete")
      return "Cancellation recorded and finalized";
    if (finalization?.status === "pending")
      return `Recorded; finalization pending: ${String(finalization.code ||
        "staff review needed").replace(/_/g, " ")}`;
    if (finalization?.status === "unknown")
      return "Recorded; reopen to confirm finalization";
    // Replaying a cancellation that was since withdrawn or replaced: its
    // receipt stands and nothing was finalized (backend #907, dd43eeb).
    if (finalization?.status === "superseded")
      return "Recorded; this cancellation was later withdrawn or replaced, so nothing was finalized";
    return result?.receipt?.stableResponse?.status || "Recorded";
  };
  const lotLabel = {
    plan:"Included review", purchase:"Purchased review",
    gift:"Courtesy review", extension:"Extension review",
    transition:"Transition review", legacy:"Existing review",
    source_adjustment:"Existing added reviews",
  };
  const completionLabel = {
    125470000:"Scheduled review", 125470001:"Re-review",
    125470002:"Off-cycle review", 125470003:"No-show",
    125470004:"Customer-requested skip", 125470005:"Redo requested",
  };
  const bookingLabel = {
    125470000:"Requested", 125470001:"Booked",
    125470002:"Delivered", 125470003:"Cancelled",
    125470004:"No-show",
  };
  const slug = row?.slug;
  const openingAction = initialAction || "amend";
  const [context, setContext] = useState(null);
  const [contextSelection, setContextSelection] = useState(() => ({
    slug, initialAction:openingAction, action:openingAction,
  }));
  const currentOpeningMatches = !!slug && contextSelection.slug === slug &&
    contextSelection.initialAction === openingAction;
  const contextAction = contextSelection.action;
  const [contextReload, setContextReload] = useState(0);
  const contextGeneration = useRef(0);
  const previewGeneration = useRef(0);
  const recoveryPending = useRef(false);
  const submissionPending = useRef(false);
  const [form, setForm] = useState(null);
  const [preview, setPreview] = useState(null);
  const [acknowledged, setAcknowledged] = useState(false);
  const previewVectorsReady = !!preview &&
    Array.isArray(preview.grantWindows) &&
    Array.isArray(preview.calendar) &&
    Array.isArray(preview.transferredLineages) &&
    preview.grantWindows.every(item => item &&
      typeof item.lineage === "string" && typeof item.kind === "string" &&
      Number.isSafeInteger(item.quantity) && item.quantity > 0 &&
      /^\d{4}-\d{2}-\d{2}$/.test(item.release) &&
      /^\d{4}-\d{2}-\d{2}$/.test(item.expiry)) &&
    preview.calendar.every(item => item &&
      typeof item.kind === "string" &&
      (item.kind === "zero_award" ? item.lineage === null :
        typeof item.lineage === "string" && item.lineage.length > 0) &&
      /^\d{4}-\d{2}-\d{2}$/.test(item.start) &&
      /^\d{4}-\d{2}-\d{2}$/.test(item.exclusiveEnd));
  const [busy, setBusy] = useState("");
  const [error, setError] = useState("");
  // Set by a blocked Preview change; the missing list itself stays live.
  const [referenceGuard, setReferenceGuard] = useState(false);
  const [message, setMessage] = useState("");
  const [operations, setOperations] = useState(null);
  const [uncertain, setUncertain] = useState(false);
  const [correctionForm, setCorrectionForm] = useState(blankCorrectionForm);
  const [correctionPreview, setCorrectionPreview] = useState(null);
  const [correctionAcknowledged, setCorrectionAcknowledged] = useState(false);
  const correctionRequestId = useRef(null);
  const [predecessorForm, setPredecessorForm] = useState(blankPredecessorForm);
  const [predecessorPreview, setPredecessorPreview] = useState(null);
  const [predecessorAcknowledged, setPredecessorAcknowledged] = useState(false);
  const predecessorRequestId = useRef(null);
  const requestId = useRef(null);
  // The customer this modal is open on now. A confirmation that returns after
  // the modal moved to another customer (or closed) is discarded: its outcome
  // belongs to the customer it was sent for, whose pending receipt recovers it.
  const openSlug = useRef(slug);
  openSlug.current = slug;
  const loadedSlug = useRef(slug);
  const pendingKey = slug ? `ss365-contract-change:${slug}` : null;
  useEffect(() => {
    setContextSelection({ slug, initialAction:openingAction, action:openingAction });
  }, [slug, openingAction]);
  useEffect(() => {
    if (!currentOpeningMatches) return undefined;
    let active = true;
    const generation = ++contextGeneration.current;
    ++previewGeneration.current;
    recoveryPending.current = true;
    const isCurrent = () => active && generation === contextGeneration.current;
    setContext(null); setForm(null); setPreview(null);
    setAcknowledged(false); setError(""); setMessage("");
    setOperations(null); setUncertain(false); setReferenceGuard(false);
    // Correction and historical-review previews belong to the opening they
    // were prepared for; never carry them into the next one. Their typed
    // inputs survive a same-customer reopen but never a customer change.
    setCorrectionPreview(null); setCorrectionAcknowledged(false);
    setPredecessorPreview(null); setPredecessorAcknowledged(false);
    if (loadedSlug.current !== slug) {
      setCorrectionForm(blankCorrectionForm());
      setPredecessorForm(blankPredecessorForm());
    }
    loadedSlug.current = slug;
    let saved = null;
    try {
      saved = JSON.parse(window.sessionStorage.getItem(
        `ss365-contract-change:${slug}`) || "null");
    } catch (_) { saved = null; }
    const validSaved = saved &&
      /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i
        .test(saved.requestId || "");
    requestId.current = validSaved ? saved.requestId : window.crypto.randomUUID();
    correctionRequestId.current = validSaved &&
      saved.operationKind === "correction"
      ? saved.requestId : window.crypto.randomUUID();
    predecessorRequestId.current = validSaved &&
      saved.operationKind === "predecessor_completion_reconciliation"
      ? saved.requestId : window.crypto.randomUUID();
    setBusy("context");
    const contextRequest = contextAction === "cancel"
      ? fetchContractChangeContext(slug, "cancel") : fetchContractChangeContext(slug);
    contextRequest.then(async data => {
      if (!isCurrent()) return;
      const current = data.currentAgreement;
      const history = data.agreementHistory || [];
      setContext(data);
      if (data.pendingPredecessorFact) {
        setPredecessorForm(old => ({ ...old,
          originalServiceDate:data.pendingPredecessorFact.originalServiceDate,
          reviewType:data.pendingPredecessorFact.reviewType }));
      }
      const historyResult = data.reconciliationOnly
        ? { operations:[] }
        : await fetchContractChangeOperations(slug);
      if (!isCurrent()) return;
      setOperations(historyResult.operations);
      setForm({
        changeType:contextAction,
        effectiveDate:contextAction === "renew"
          ? current.exclusiveEnd : data.asOfChicagoDate,
        signedEffectiveDate:contextAction === "renew"
          ? current.exclusiveEnd : data.asOfChicagoDate,
        newExclusiveEnd:contextAction === "cancel" ? null : current.exclusiveEnd,
        tierValue:({ Bronze:125470000, Silver:125470001,
          Gold:125470002, Platinum:125470003 })[current.tier],
        reviewsPerYear:current.reviewsPerYear,
        durationMonths:current.durationMonths,
        autoRenew:contextAction === "cancel" ? false : current.autoRenew,
        signedZeroGrantContinuation:false,
        grantCount:1, noticeReceivedDate:data.asOfChicagoDate,
        lastCoveredDate:"",
        currentSourceAgreementReference:
          history[history.length - 1]?.evidenceReference || "",
        signedAgreementReference:"", commercialApprovalReference:"",
        carriedLineages:[], approvedDispositions:[], approvedCarryTerms:[],
        additionalGrant:contextAction === "adjustment" ? {
          kind:"purchase", amount:"1",
          lastCoveredDay:coveredThrough(current.exclusiveEnd),
          grantEvidenceReference:"", grantApprovalReference:"", note:"",
        } : null,
      });
      if (validSaved && saved.operationKind) {
        const result = await fetchContractChangeReceipt(
          slug, saved.operationKind, saved.requestId);
        if (!isCurrent()) return;
        if (result.recorded) {
          setMessage(`Previously recorded: ${result.receipt?.stableResponse?.status || "Recorded"}`);
          window.sessionStorage.removeItem(`ss365-contract-change:${slug}`);
          requestId.current = window.crypto.randomUUID();
          if (saved.operationKind === "correction") {
            correctionRequestId.current = window.crypto.randomUUID();
          } else if (saved.operationKind === "predecessor_completion_reconciliation") {
            predecessorRequestId.current = window.crypto.randomUUID();
          }
        } else {
          setUncertain(true);
          setError("A prior confirmation has no verified receipt. Reconcile it before submitting another change.");
        }
      }
    }).catch(exc => {
      if (isCurrent()) {
        if (validSaved && saved.operationKind) setUncertain(true);
        setError(contractChangeErrorText(exc,
          "Contract facts or recorded operations are unavailable. Reload before making a change."));
      }
    }).finally(() => {
      if (isCurrent()) {
        recoveryPending.current = false;
        setBusy("");
      }
    });
    return () => {
      active = false;
      ++contextGeneration.current;
      ++previewGeneration.current;
    };
  }, [slug, openingAction, currentOpeningMatches, contextAction, contextReload]);
  if (!row) return null;
  const editsBlocked = () => !currentOpeningMatches || uncertain ||
    recoveryPending.current || submissionPending.current;
  const submissionBlocked = editsBlocked();
  const requiredReferences = form ? requiredContractReferences(
    form.changeType, hasRecordedSourceReference(context)) : [];
  const missingReferences = referenceGuard
    ? missingContractReferences(form, requiredReferences) : [];
  const change = (field, value) => {
    if (editsBlocked()) return;
    ++previewGeneration.current;
    setBusy(current => current === "preview" ? "" : current);
    if (field === "changeType" && (value === "cancel") !== (form.changeType === "cancel")) {
      setPreview(null); setAcknowledged(false); setMessage("");
      setContext(null); setForm(null);
      setContextSelection(current => current.slug === slug &&
        current.initialAction === openingAction ? { ...current, action:value } : current);
      setContextReload(current => current + 1);
      return;
    }
    setForm(old => {
      if (field !== "changeType") return { ...old, [field]:value };
      const { operationKind, pendingEventId, ...rest } = old;
      return { ...rest, changeType:value,
        additionalGrant:value === "adjustment" ? {
          kind:"purchase", amount:"1",
          lastCoveredDay:coveredThrough(context.currentAgreement.exclusiveEnd),
          grantEvidenceReference:"", grantApprovalReference:"", note:"",
        } : old.additionalGrant,
        signedZeroGrantContinuation:false };
    });
    setPreview(null); setAcknowledged(false); setMessage("");
  };
  const changeGrant = (field, value) => {
    if (editsBlocked()) return;
    ++previewGeneration.current;
    setBusy(current => current === "preview" ? "" : current);
    setForm(old => ({ ...old,
      additionalGrant:{ ...old.additionalGrant, [field]:value } }));
    setPreview(null); setAcknowledged(false); setMessage("");
  };
  const quantity = value => {
    const raw = String(value);
    if (!/^[1-9][0-9]*$/.test(raw)) return null;
    const parsed = Number(raw);
    return Number.isSafeInteger(parsed) && parsed <= 2147483647
      ? parsed : null;
  };
  const updateCorrection = (name, value) => {
    if (editsBlocked()) return;
    setCorrectionForm(old => ({ ...old, [name]:value,
      ...(name === "completionId" ? { toLineage:"" } : {}) }));
    setCorrectionPreview(null);
    setCorrectionAcknowledged(false);
  };
  const correctionCandidate = (context?.correctionCandidates || []).find(
    item => item.completionId === correctionForm.completionId);
  const correctionInput = () => ({
    requestId:correctionRequestId.current,
    sourceCompletionId:correctionForm.completionId,
    fromLineage:correctionCandidate?.allocatedLineage || "",
    toLineage:correctionForm.toLineage,
    reason:correctionForm.reason,
    signedAgreementReference:correctionForm.signedAgreementReference,
    commercialApprovalReference:correctionForm.commercialApprovalReference,
  });
  const loadCorrectionPreview = async () => {
    if (busy || editsBlocked() || operations === null) return;
    setBusy("correction-preview"); setError("");
    setCorrectionPreview(null); setCorrectionAcknowledged(false);
    // Bound to this opening: a response arriving after close/reopen or a
    // customer change is stale and must not undo the opening reset.
    const opening = contextGeneration.current;
    try {
      const result = await previewContractChangeCorrection(
        slug, correctionInput());
      if (opening === contextGeneration.current) setCorrectionPreview(result);
    } catch (exc) {
      if (opening === contextGeneration.current)
        setError(contractChangeErrorText(exc, "This review needs staff reconciliation."));
    } finally { if (opening === contextGeneration.current) setBusy(""); }
  };
  const confirmCorrection = async () => {
    if (busy || editsBlocked() || !correctionPreview || !correctionAcknowledged) return;
    submissionPending.current = true;
    setBusy("correction-confirm"); setError("");
    let committed = false;
    const submittedSlug = slug;
    try {
      window.sessionStorage.setItem(pendingKey, JSON.stringify({
        requestId:correctionRequestId.current, operationKind:"correction",
      }));
      const result = await confirmContractChangeCorrection(slug, {
        ...correctionInput(), previewToken:correctionPreview.previewToken,
        acknowledgement:true,
      });
      committed = true;
      if (openSlug.current !== submittedSlug) return;
      setMessage(result.receipt?.stableResponse?.status || "Allocation corrected");
      setCorrectionPreview(null); setCorrectionAcknowledged(false);
      window.sessionStorage.removeItem(pendingKey);
      correctionRequestId.current = window.crypto.randomUUID();
      // Re-check after every await: the refresh belongs to the customer the
      // confirmation was sent for, never to one opened while it was running.
      await onChanged?.();
      if (openSlug.current !== submittedSlug) return;
      const refreshedContext = await fetchContractChangeContext(slug);
      if (openSlug.current !== submittedSlug) return;
      setContext(refreshedContext);
      const refreshedOperations = await fetchContractChangeOperations(slug);
      if (openSlug.current !== submittedSlug) return;
      setOperations(refreshedOperations.operations);
    } catch (exc) {
      if (openSlug.current !== submittedSlug) return;
      setCorrectionPreview(null); setCorrectionAcknowledged(false);
      if (committed) {
        setError(refreshFailureText(exc));
      } else {
        setUncertain(true);
        setError(contractChangeErrorText(exc, "Confirmation is uncertain. Reconcile before trying again."));
      }
    } finally {
      submissionPending.current = false;
      if (openSlug.current === submittedSlug) setBusy("");
    }
  };
  const updatePredecessor = (field, value) => {
    if (editsBlocked()) return;
    setPredecessorForm(old => ({ ...old, [field]:value,
      ...(field === "lineage" ? { successorCompletionId:"" } : {}) }));
    setPredecessorPreview(null);
    setPredecessorAcknowledged(false);
  };
  const predecessorInput = () => ({
    requestId:predecessorRequestId.current,
    sourceCompletionId:context?.pendingPredecessorFact?.sourceCompletionId || null,
    originalServiceDate:context?.pendingPredecessorFact
      ? null : predecessorForm.originalServiceDate,
    reviewType:context?.pendingPredecessorFact
      ? null : predecessorForm.reviewType,
    note:context?.pendingPredecessorFact ? null : predecessorForm.note || null,
    lineage:predecessorForm.lineage,
    successorCompletionId:predecessorForm.successorCompletionId || null,
    reason:predecessorForm.reason,
    signedAgreementReference:predecessorForm.signedAgreementReference,
    commercialApprovalReference:predecessorForm.commercialApprovalReference,
  });
  const loadPredecessorPreview = async () => {
    if (busy || editsBlocked() || operations === null) return;
    setBusy("predecessor-preview"); setError("");
    setPredecessorPreview(null); setPredecessorAcknowledged(false);
    // Bound to this opening, like the correction preview above.
    const opening = contextGeneration.current;
    try {
      const result = await previewContractChangePredecessor(
        slug, predecessorInput());
      if (opening === contextGeneration.current) setPredecessorPreview(result);
    } catch (exc) {
      if (opening === contextGeneration.current)
        setError(contractChangeErrorText(exc, "This historical review needs staff reconciliation."));
    } finally { if (opening === contextGeneration.current) setBusy(""); }
  };
  const confirmPredecessor = async () => {
    if (busy || editsBlocked() || !predecessorPreview || !predecessorAcknowledged) return;
    submissionPending.current = true;
    setBusy("predecessor-confirm"); setError("");
    let committed = false;
    const submittedSlug = slug;
    try {
      window.sessionStorage.setItem(pendingKey, JSON.stringify({
        requestId:predecessorRequestId.current,
        operationKind:"predecessor_completion_reconciliation",
      }));
      const result = await confirmContractChangePredecessor(slug, {
        ...predecessorInput(),
        previewToken:predecessorPreview.previewToken,
        acknowledgement:true,
      });
      committed = true;
      if (openSlug.current !== submittedSlug) return;
      setMessage(result.receipt?.stableResponse?.status ||
        "Historical review reconciled");
      setPredecessorPreview(null); setPredecessorAcknowledged(false);
      window.sessionStorage.removeItem(pendingKey);
      predecessorRequestId.current = window.crypto.randomUUID();
      // Re-check after every await: the refresh belongs to the customer the
      // confirmation was sent for, never to one opened while it was running.
      await onChanged?.();
      if (openSlug.current !== submittedSlug) return;
      const refreshedContext = await fetchContractChangeContext(slug);
      if (openSlug.current !== submittedSlug) return;
      setContext(refreshedContext);
      const refreshedOperations = await fetchContractChangeOperations(slug);
      if (openSlug.current !== submittedSlug) return;
      setOperations(refreshedOperations.operations);
    } catch (exc) {
      if (openSlug.current !== submittedSlug) return;
      setPredecessorPreview(null); setPredecessorAcknowledged(false);
      if (committed) {
        setError(refreshFailureText(exc));
      } else {
        setUncertain(true);
        setError(contractChangeErrorText(exc, "Confirmation is uncertain. Reconcile before trying again."));
      }
    } finally {
      submissionPending.current = false;
      if (openSlug.current === submittedSlug) setBusy("");
    }
  };
  const input = () => ({
    ...form, requestId:requestId.current,
    currentSourceAgreementReference:
      form.currentSourceAgreementReference || undefined,
    newExclusiveEnd:["amend", "extension"].includes(form.changeType)
      ? form.newExclusiveEnd : undefined,
    grantCount:form.changeType === "extension"
      ? quantity(form.grantCount) : undefined,
    noticeReceivedDate:form.changeType === "cancel"
      ? form.noticeReceivedDate || null : undefined,
    lastCoveredDate:form.changeType === "cancel"
      ? form.lastCoveredDate : undefined,
    signedZeroGrantContinuation:form.changeType === "cancel"
      ? form.signedZeroGrantContinuation : false,
    reviewsPerYear:quantity(form.reviewsPerYear),
    // A due activation must send the exact scheduled template back. The
    // pending proposal already carries its computed whole-month duration (or
    // null for an exact date-only end); ordinary amend/extension previews
    // still let the server derive that value from the signed last day.
    durationMonths:form.operationKind === "activate"
      ? form.durationMonths === null ? null : quantity(form.durationMonths)
      : ["amend", "extension"].includes(form.changeType)
        ? null : form.durationMonths === null
          ? null : quantity(form.durationMonths),
    tierValue:quantity(form.tierValue),
    autoRenew:form.changeType === "cancel" ? false : form.autoRenew,
    additionalGrant: form.additionalGrant ? {
      ...form.additionalGrant,
      amount:quantity(form.additionalGrant.amount),
      expiryExclusive:exclusiveAfter(form.additionalGrant.lastCoveredDay),
      lastCoveredDay:undefined,
    } : undefined,
  });
  const loadPreview = async () => {
    if (busy || editsBlocked() || operations === null) return;
    const generation = previewGeneration.current;
    setBusy("preview"); setError(""); setPreview(null); setAcknowledged(false);
    try {
      const proposal = input();
      if (proposal.reviewsPerYear === null ||
          (["renew", "replace"].includes(form.changeType) &&
           proposal.durationMonths === null) || proposal.tierValue === null ||
          proposal.grantCount === null ||
          (proposal.additionalGrant &&
           (proposal.additionalGrant.amount === null ||
            !proposal.additionalGrant.expiryExclusive))) {
        throw new Error("Reviews, duration, tier, and grants must be whole numbers.");
      }
      // Mirrors the backend's reference rule; the request is never sent.
      if (missingContractReferences(form, requiredReferences).length) {
        setReferenceGuard(true);
        return;
      }
      setReferenceGuard(false);
      const result = await previewContractChange(slug, proposal);
      if (generation === previewGeneration.current) setPreview(result);
    } catch (exc) {
      if (generation === previewGeneration.current)
        setError(contractChangeErrorText(exc, "Review the contract terms and try again."));
    } finally { if (generation === previewGeneration.current) setBusy(""); }
  };
  const confirm = async () => {
    if (busy || editsBlocked() || !preview || !previewVectorsReady || !acknowledged) return;
    submissionPending.current = true;
    setBusy("confirm"); setError("");
    let committed = false;
    const submittedSlug = slug;
    try {
      window.sessionStorage.setItem(pendingKey, JSON.stringify({
        requestId:requestId.current, operationKind:preview.operationKind,
      }));
      const result = await confirmContractChange(slug, {
        ...input(), operationKind:preview.operationKind,
        previewToken:preview.previewToken, acknowledgement:true,
      });
      committed = true;
      if (openSlug.current !== submittedSlug) return;
      setMessage(finalizationMessage(result));
      setPreview(null); setAcknowledged(false);
      window.sessionStorage.removeItem(pendingKey);
      requestId.current = window.crypto.randomUUID();
      // Re-check after every await: the refresh belongs to the customer the
      // confirmation was sent for, never to one opened while it was running.
      await onChanged?.();
      if (openSlug.current !== submittedSlug) return;
      const refreshed = await (form.changeType === "cancel"
        ? fetchContractChangeContext(slug, "cancel") : fetchContractChangeContext(slug));
      if (openSlug.current !== submittedSlug) return;
      setContext(refreshed);
      const refreshedOperations = await fetchContractChangeOperations(slug);
      if (openSlug.current !== submittedSlug) return;
      setOperations(refreshedOperations.operations);
    } catch (exc) {
      if (openSlug.current !== submittedSlug) return;
      setPreview(null); setAcknowledged(false);
      if (committed) {
        setError(refreshFailureText(exc));
      } else {
        setUncertain(true);
        setError(contractChangeErrorText(exc, "Confirmation is uncertain. Reconcile before trying again."));
      }
    } finally {
      submissionPending.current = false;
      if (openSlug.current === submittedSlug) setBusy("");
    }
  };
  const inputStyle = {
    width:"100%", background:"rgba(255,255,255,0.05)",
    border:`1px solid ${T.border}`, borderRadius:7, color:T.text,
    fontSize:12, padding:"7px 9px", fontFamily:"inherit",
    colorScheme:"dark", boxSizing:"border-box",
  };
  const selectOptionStyle = {
    background:"#0b1f3a", color:T.text,
  };
  const labelStyle = {
    display:"block", fontSize:11, color:T.muted, marginBottom:5,
    fontWeight:700, textTransform:"uppercase", letterSpacing:".04em",
  };
  const field = (label, name, type="text", extra={}) => <label>
    <span style={labelStyle}>{label}</span>
    <input style={inputStyle} aria-label={label} type={type} value={form?.[name] ?? ""}
      disabled={submissionBlocked} {...extra}
      onChange={event => change(name, event.target.value)} />
  </label>;
  const referenceField = ({ name, label }) => {
    const required = requiredReferences.includes(name);
    const missing = missingReferences.includes(name);
    return <label key={name}>
      <span style={labelStyle}>{label}{required
        ? <span aria-hidden="true" style={{ color:T.red }}> *</span>
        : " (optional)"}</span>
      <input style={missing ? { ...inputStyle, borderColor:T.red,
        outline:`1px solid ${T.red}` } : inputStyle}
        aria-label={label} type="text" value={form?.[name] ?? ""}
        aria-required={required ? "true" : undefined}
        aria-invalid={missing ? "true" : undefined}
        aria-describedby={missing ? "contract-change-missing-references" : undefined}
        disabled={submissionBlocked}
        onChange={event => change(name, event.target.value)} />
    </label>;
  };
  const smallGrid = { display:"grid", gridTemplateColumns:
    "repeat(auto-fit, minmax(175px, 1fr))", gap:10 };
  return createPortal(
    <div onClick={onClose} style={{ position:"fixed", inset:0,
      background:"rgba(0,0,0,.6)", zIndex:1001, display:"flex",
      alignItems:"center", justifyContent:"center", padding:16 }}>
      <div role="dialog" aria-modal="true" aria-label="Contract Change"
        onClick={event => event.stopPropagation()}
        style={{ background:T.panel, color:T.text, border:`1px solid ${T.border}`,
          borderRadius:12, width:"min(960px, 100%)", maxHeight:"90vh",
          overflowY:"auto", padding:20, display:"grid", gap:14 }}>
        <div style={{ display:"flex", justifyContent:"space-between" }}>
          <h3 style={{ margin:0 }}>Contract Change — {row.customer_name || slug}</h3>
          <Btn onClick={onClose}>Close</Btn>
        </div>
        {busy === "context" && <div>Loading current contract facts…</div>}
        {error && <div role="alert" style={{ color:T.red }}>{error}</div>}
        {message && <div role="status" style={{ color:T.green }}>{message}</div>}
        {uncertain && <div role="alert" style={{ color:T.yellow }}>
          The previous confirmation may have committed. Check the recorded
          operations below and reconcile the result before another attempt.
        </div>}
        {operations && <details open={uncertain}>
          <summary>Recorded Contract Change operations ({operations.length})</summary>
          <div style={{ display:"grid", gap:6, marginTop:8 }}>
            {operations.map(item => <Btn key={item.receiptStateId}
              onClick={async () => {
                try {
                  const detail = await fetchContractChangeOperationDetail(
                    slug, item.receiptStateId);
                  setMessage(`${detail.operation.operationKind} recorded ${detail.operation.recordedUtc}: ${detail.operation.outcome}`);
                } catch (exc) {
                  setError(contractChangeErrorText(exc, "Operation receipt unavailable."));
                }
              }} style={{ textAlign:"left", fontFamily:"inherit" }}>
              {item.operationKind} · {item.recordedUtc} · {item.outcome}
            </Btn>)}
            {operations.length === 0 && <div>No verified operation is listed.
              This does not prove a previous uncertain submission rolled back.
            </div>}
          </div>
        </details>}
        {context && form && <>
          {context.reconciliationOnly && <strong style={{ color:T.yellow }}>
            A recorded review from an earlier term has no funded decision.
            Contract actions are held until staff reconcile this exact review.
          </strong>}
          {!context.reconciliationOnly && <>
          {context.sourceExplanation && <div>{context.sourceExplanation}</div>}
          {!!context.addedReviewHistory?.length && <details>
            <summary>Added review history ({context.addedReviewHistory.length})</summary>
            {context.addedReviewHistory.map((item, index) => <div key={index}>
              {item.amount} reviews · {({ 125470000:"Purchased", 125470001:"Gifted", 125470002:"Migration Seed", 125470003:"Other" })[item.reasonCode] || `Reason ${item.reasonCode}`} · {item.effectiveDate}
            </div>)}
          </details>}
          {form.changeType === "cancel" && <div>
            Unused reviews in this contract: {context.balance.availableUnspent + context.balance.futureUnreleased}.
            All unused reviews end at the confirmed service cutoff; awarded and completed history stays recorded.
          </div>}
          <div style={smallGrid}>
            <div>Current term began: {context.currentAgreement.termAnchorStart}.
              {context.currentAgreement.coveredStart !==
                context.currentAgreement.termAnchorStart &&
                ` This version took effect ${context.currentAgreement.coveredStart}.`}
              {" "}Coverage through
              {" "}{context.balance.lastCoveredDate}</div>
            <div>Usable now: {context.balance.availableUnspent}</div>
            <div>Future releases: {context.balance.futureUnreleased}</div>
            <div>Consumed: {context.balance.consumed}</div>
            <div>Forfeited: {context.balance.forfeited}</div>
            <div>Service hold: {context.hold === "provider_reconciliation"
              ? "Provider booking needs staff reconciliation"
              : context.hold || "None"}</div>
          </div>
          {["amend", "adjustment"].includes(form.changeType) && <section style={{ display:"grid", gap:8 }}>
            {form.changeType === "amend" && <label><input type="checkbox"
              checked={!!form.additionalGrant}
              onChange={event => change("additionalGrant", event.target.checked
                ? { kind:"purchase", amount:"1", lastCoveredDay:
                    coveredThrough(form.newExclusiveEnd),
                    grantEvidenceReference:"", grantApprovalReference:"", note:"" }
                : null)} />
              Add separately approved purchased or courtesy reviews to this
              immediate amendment
            </label>}
            {form.additionalGrant && <div style={smallGrid}>
              <label><span style={labelStyle}>Review type</span>
                <select style={inputStyle} aria-label="Additional review type" disabled={submissionBlocked}
                value={form.additionalGrant.kind}
                onChange={event => changeGrant("kind", event.target.value)}>
                <option style={selectOptionStyle} value="purchase">Purchased</option>
                <option style={selectOptionStyle} value="gift">Courtesy</option>
              </select></label>
              <label><span style={labelStyle}>Additional reviews</span>
                <input style={inputStyle} aria-label="Additional reviews" disabled={submissionBlocked}
                type="number" value={form.additionalGrant.amount}
                onChange={event => changeGrant("amount", event.target.value)} /></label>
              <label><span style={labelStyle}>Grant last covered day</span>
                <input style={inputStyle} aria-label="Grant last covered day" disabled={submissionBlocked}
                type="date" value={form.additionalGrant.lastCoveredDay || ""}
                onChange={event => changeGrant("lastCoveredDay", event.target.value)} /></label>
              <label><span style={labelStyle}>Grant signed evidence reference</span>
                <input style={inputStyle}
                aria-label="Grant signed evidence reference" disabled={submissionBlocked}
                value={form.additionalGrant.grantEvidenceReference}
                onChange={event => changeGrant("grantEvidenceReference", event.target.value)} /></label>
              <label><span style={labelStyle}>Grant approval reference</span>
                <input style={inputStyle}
                aria-label="Grant approval reference" disabled={submissionBlocked}
                value={form.additionalGrant.grantApprovalReference}
                onChange={event => changeGrant("grantApprovalReference", event.target.value)} /></label>
              <label><span style={labelStyle}>Grant reason</span>
                <input style={inputStyle} aria-label="Grant reason" disabled={submissionBlocked}
                value={form.additionalGrant.note}
                onChange={event => changeGrant("note", event.target.value)} /></label>
            </div>}
          </section>}
          {context.pending && <div style={{ color:T.yellow }}>
            Pending {context.pending.kind} for {context.pending.effectiveDate}.
            New service is held when this change becomes due.
            {context.pending.kind !== "cancel" &&
              context.pending.effectiveDate === context.asOfChicagoDate &&
              <Btn onClick={() => {
                if (editsBlocked()) return;
                ++previewGeneration.current;
                requestId.current = window.crypto.randomUUID();
                setForm({ ...context.pending.proposal,
                  operationKind:"activate",
                  pendingEventId:context.pending.eventId });
                setPreview(null); setAcknowledged(false);
              }} disabled={!!busy || submissionBlocked}>Review due activation</Btn>}
            {context.pending.effectiveDate > context.asOfChicagoDate &&
              <Btn onClick={() => {
                if (editsBlocked()) return;
                ++previewGeneration.current;
                requestId.current = window.crypto.randomUUID();
                setForm(old => ({ ...old, changeType:"withdraw",
                  operationKind:"withdraw",
                  pendingEventId:context.pending.eventId,
                  effectiveDate:context.asOfChicagoDate,
                  signedEffectiveDate:context.asOfChicagoDate,
                  newExclusiveEnd:null,
                  autoRenew:context.pending.kind === "cancel"
                    ? false : context.currentAgreement.autoRenew }));
                setPreview(null); setAcknowledged(false);
              }} disabled={!!busy || submissionBlocked}>Review withdrawal</Btn>}
            {context.pending.kind === "cancel" &&
              context.pending.effectiveDate <= context.asOfChicagoDate &&
              <Btn onClick={() => {
                if (editsBlocked()) return;
                ++previewGeneration.current;
                requestId.current = window.crypto.randomUUID();
                setForm(old => ({ ...old, changeType:"finalize_cancel",
                  operationKind:"finalize_cancel",
                  pendingEventId:context.pending.eventId,
                  effectiveDate:context.asOfChicagoDate,
                  signedEffectiveDate:context.asOfChicagoDate,
                  newExclusiveEnd:null, autoRenew:false }));
                setPreview(null); setAcknowledged(false);
              }} disabled={!!busy || submissionBlocked}>Review cancellation finalization</Btn>}
          </div>}
          {context.confirmedExclusiveCap && <div style={{ color:T.yellow }}>
            Confirmed service cutoff: {context.confirmedExclusiveCap} (exclusive).
          </div>}
          <div style={smallGrid}>
            <label><span style={labelStyle}>Action</span>
              <select style={inputStyle} aria-label="Contract action" value={form.changeType}
              disabled={!!busy || submissionBlocked}
              onChange={event => change("changeType", event.target.value)}>
              <option style={selectOptionStyle} value="amend" disabled={context.authorityPurpose === "cancel" && context.allowedActions?.includes("withdraw") && !context.allowedActions?.includes("amend")}>Upgrade or amend</option>
              <option style={selectOptionStyle} value="extension" disabled={context.authorityPurpose === "cancel" && context.allowedActions?.includes("withdraw") && !context.allowedActions?.includes("extension")}>Extend with approved reviews</option>
              <option style={selectOptionStyle} value="renew" disabled={context.authorityPurpose === "cancel" && context.allowedActions?.includes("withdraw") && !context.allowedActions?.includes("renew")}>Renew at current term end</option>
              <option style={selectOptionStyle} value="replace" disabled={context.authorityPurpose === "cancel" && context.allowedActions?.includes("withdraw") && !context.allowedActions?.includes("replace")}>Start a new term / renew early</option>
              <option style={selectOptionStyle} value="adjustment" disabled={context.authorityPurpose === "cancel" && context.allowedActions?.includes("withdraw") && !context.allowedActions?.includes("adjustment")}>Add purchased or courtesy reviews</option>
              <option style={selectOptionStyle} value="cancel">Cancel</option>
              {form.changeType === "withdraw" &&
                <option style={selectOptionStyle} value="withdraw">Withdraw pending change</option>}
              {form.changeType === "finalize_cancel" &&
                <option style={selectOptionStyle} value="finalize_cancel">Finalize cancellation</option>}
            </select></label>
            {form.changeType !== "cancel" &&
              field("Effective date", "effectiveDate", "date")}
            {form.changeType !== "cancel" &&
              field("Signed effective date", "signedEffectiveDate", "date",
                { max:form.effectiveDate || undefined })}
            {["amend", "extension"].includes(form.changeType) &&
              <label>
                <span style={labelStyle}>Proposed last covered day</span>
                <input style={inputStyle} aria-label="Proposed last covered day" type="date"
                  value={coveredThrough(form.newExclusiveEnd) || ""}
                  onChange={event => change("newExclusiveEnd",
                    exclusiveAfter(event.target.value))} />
              </label>}
            {form.changeType === "extension" &&
              field("Approved additional reviews", "grantCount", "number")}
            {form.changeType === "cancel" && <>
              {field("Notice received (optional)", "noticeReceivedDate", "date",
                { max:context.asOfChicagoDate })}
              {field("Last day of service", "lastCoveredDate", "date")}
              {field("Signed date", "signedEffectiveDate", "date",
                { max:context.asOfChicagoDate })}
              {form.lastCoveredDate && exclusiveAfter(form.lastCoveredDate) &&
                <div style={{ gridColumn:"1 / -1" }}>
                  {exclusiveAfter(form.lastCoveredDate) <= context.asOfChicagoDate
                    ? "Service ends now: the last day of service has passed, so Confirm also finalizes this cancellation."
                    : `Service ends on ${exclusiveAfter(form.lastCoveredDate)}; the last day of service is ${form.lastCoveredDate}.`}
                </div>}
              {form.lastCoveredDate &&
                form.lastCoveredDate >= context.currentAgreement.exclusiveEnd &&
                <label style={{ gridColumn:"1 / -1" }}>
                  <input type="checkbox"
                    checked={!!form.signedZeroGrantContinuation}
                    onChange={event => change("signedZeroGrantContinuation",
                      event.target.checked)} />
                  The signed continuation and commercial approval cover every
                  day from the current term end through this cutoff, with zero
                  new review grants. Existing review release and expiry dates
                  stay as recorded.
                </label>}
            </>}
            {form.changeType !== "cancel" && <>
              <label><span style={labelStyle}>Tier</span>
                <select style={inputStyle} aria-label="Proposed tier"
                value={form.tierValue} onChange={event => change(
                  "tierValue", Number(event.target.value))}>
                <option style={selectOptionStyle} value={125470000}>Bronze</option>
                <option style={selectOptionStyle} value={125470001}>Silver</option>
                <option style={selectOptionStyle} value={125470002}>Gold</option>
                <option style={selectOptionStyle} value={125470003}>Platinum</option>
              </select></label>
              {field("Reviews per year", "reviewsPerYear", "number")}
              {["renew", "replace"].includes(form.changeType) &&
                field("New term duration in months", "durationMonths", "number")}
              <label><input type="checkbox" checked={form.autoRenew}
                onChange={event => change("autoRenew", event.target.checked)} />
                Auto Renew</label>
            </>}
          </div>
          <div style={smallGrid}>
            {CONTRACT_REFERENCE_FIELDS.map(referenceField)}
            {form.changeType === "cancel" && <div style={{ gridColumn:"1 / -1",
              fontSize:12, color:T.muted }}>
              References are optional for a cancellation. A blank reference is
              recorded as "Not supplied".
            </div>}
          </div>
          {form.changeType === "replace" && <div>
            <div style={{ marginBottom:6 }}>Choose each old review to carry. All
              unselected remaining reviews expire under the replacement.</div>
            {(context.currentLots || []).filter(lot => lot.remaining > 0)
              .map(lot => <label key={lot.lineage} style={{ display:"block" }}>
                <input type="checkbox"
                  checked={form.carriedLineages.includes(lot.lineage)}
                  onChange={event => change("carriedLineages", event.target.checked
                    ? [...form.carriedLineages, lot.lineage]
                    : form.carriedLineages.filter(id => id !== lot.lineage))} />
                {lotLabel[lot.kind] || "Existing review"}: {lot.remaining} remaining;
                {" "}{lot.release} through {coveredThrough(lot.expiry)}
              </label>)}
          </div>}
          {form.changeType === "amend" &&
            form.newExclusiveEnd < context.currentAgreement.exclusiveEnd &&
            <div>
              <b>Reviews affected by the shorter coverage</b>
              {(context.currentLots || []).filter(lot => lot.remaining > 0 &&
                (lot.release >= form.newExclusiveEnd ||
                 lot.expiry > form.newExclusiveEnd)).map(lot =>
                <label key={lot.identity} style={{ display:"block" }}>
                  <input type="checkbox"
                    checked={form.approvedDispositions.includes(lot.identity)}
                    onChange={event => change("approvedDispositions",
                      event.target.checked
                        ? [...form.approvedDispositions, lot.identity]
                        : form.approvedDispositions.filter(id =>
                          id !== lot.identity))} />
                  I approve the disposition of this {lotLabel[lot.kind] ||
                    "existing review"} ({lot.remaining} remaining,
                  {" "}{lot.release} through {coveredThrough(lot.expiry)}).
                </label>)}
            </div>}
          {missingReferences.length > 0 &&
            <div id="contract-change-missing-references" aria-live="polite"
              style={{ color:T.red }}>
              {missingReferencesMessage(missingReferences)}
            </div>}
          <div style={{ display:"flex", gap:8 }}>
            <Btn onClick={loadPreview} disabled={!!busy || submissionBlocked ||
              operations === null || context.mode === "off"}>
              {busy === "preview" ? "Preparing…" : "Preview change"}
            </Btn>
            {context.mode === "off" && <span>Contract Change is disabled.</span>}
          </div>
          {preview && <section style={{ border:`1px solid ${T.border}`,
            borderRadius:8, padding:14, display:"grid", gap:8 }}>
            <b>{preview.changeType} — {preview.operationKind === "schedule"
              ? "scheduled for" : "effective"} {preview.effectiveDate}</b>
            <div style={smallGrid}>
              <span>Current usable: {preview.atBoundaryBefore.availableUnspent}</span>
              <span>Proposed usable: {preview.atBoundaryProposed.availableUnspent}</span>
              <span>New awards: {preview.newAwards}</span>
              <span>Proposed consumed: {preview.atBoundaryProposed.consumed}</span>
              <span>Proposed forfeited: {preview.atBoundaryProposed.forfeited}</span>
              <span>Future releases: {preview.atBoundaryProposed.futureUnreleased}</span>
            </div>
            {preview.additionalGrant && <div>
              Additional {preview.additionalGrant.kind === "purchase"
                ? "purchased" : "courtesy"} reviews: {preview.additionalGrant.amount},
              released {preview.additionalGrant.releaseDate}, through
              {" "}{coveredThrough(preview.additionalGrant.expiryExclusive)}.
              This is a separate signed grant in the same amendment.
            </div>}
            <div>Current coverage through: {coveredThrough(
              preview.currentAgreement.exclusiveEnd)}; proposed coverage through:
              {" "}{coveredThrough(preview.proposedAgreement.exclusiveEnd)}.</div>
            <div>Current tier: {preview.currentAgreement.tier}; proposed tier:
              {" "}{preview.proposedAgreement.tier}.</div>
            <div>Reviews each year: {preview.currentAgreement.reviewsPerYear} →
              {" "}{preview.proposedAgreement.reviewsPerYear}. Current term began
              {" "}{preview.currentAgreement.termAnchorStart}; proposed term began
              {" "}{preview.proposedAgreement.termAnchorStart}.
              {preview.proposedAgreement.durationMonths != null &&
                ` Proposed term is exactly ${preview.proposedAgreement.durationMonths} months.`}
              {preview.proposedAgreement.durationMonths == null &&
                " The signed last covered day controls; this term is not a whole number of months."}
            </div>
            <div>Auto Renew: {preview.currentAgreement.autoRenew ? "On" : "Off"} →
              {" "}{preview.proposedAgreement.autoRenew ? "On" : "Off"}.
              Signed effective date: {form.signedEffectiveDate}.</div>
            <div>Completed reviews stay in the factual history:
              {" "}{context.completedHistory.length} recorded.</div>
            <div>Transferred reviews: {preview.transferredLineages.length};
              expired reviews: {preview.forfeitedLineages.length}.</div>
            {previewVectorsReady ? <>
              <div><b>New review grants</b>
                {preview.grantWindows.length === 0 && <div>None.</div>}
                {preview.grantWindows.map((grant, index) =>
                  <div key={`${grant.lineage}-${index}`}>
                    {lotLabel[grant.kind] || "New review"} {index + 1}:
                    {" "}{grant.quantity} review{grant.quantity === 1 ? "" : "s"},
                    released {grant.release}; last covered day
                    {" "}{coveredThrough(grant.expiry)} (exclusive expiry
                    {" "}{grant.expiry}).
                  </div>)}
              </div>
              <div><b>Proposed review calendar</b>
                {preview.calendar.length === 0 && <div>None.</div>}
                {preview.calendar.map((window, index) =>
                  <div key={`${window.lineage}-${index}`}>
                    Review window {index + 1} ({window.kind === "zero_award" ?
                      "covered period with no review grant" :
                      preview.transferredLineages.includes(
                      window.lineage) ? "carried existing review" :
                      preview.grantWindows.some(grant =>
                        grant.lineage === window.lineage) ? "new review grant" :
                      lotLabel[window.kind] || "existing review"}):
                    {" "}{window.start} through
                    {" "}{coveredThrough(window.exclusiveEnd)} (exclusive end
                    {" "}{window.exclusiveEnd}).
                  </div>)}
              </div>
            </> : <div style={{ color:T.yellow }}>
              The review dates and grants are unavailable. Prepare a fresh preview.
            </div>}
            <div>Next review target: {preview.nextAuditDate || "None"} →
              {" "}{preview.projectedTrackingDates?.nextAuditDate || "None"};
              credential request: {preview.credentialRequestDate || "None"} →
              {" "}{preview.projectedTrackingDates?.credentialRequestDate || "None"}.
              {" "}{preview.dateDispositionReason}</div>
            {preview.confirmedExclusiveCap && <b style={{ color:T.yellow }}>
              Service ends before {preview.confirmedExclusiveCap}, even if
              status cleanup is still due.
            </b>}
            {preview.finalizesOnConfirm && <b style={{ color:T.yellow }}>
              The last day of service has passed. Confirm records this
              cancellation and finalizes it now: Contract Status Expired,
              SecureShield Status Lost, Auto Renew off
              {preview.finalizeTrackingPatch?.pc_secureshieldexpirationdate
                ? `, Term End Date ${preview.finalizeTrackingPatch.pc_secureshieldexpirationdate}`
                : ""}.
            </b>}
            {(preview.affectedBookings || []).length > 0 && <div
              style={{ color:T.yellow }}>Appointments needing staff cleanup:
              {" "}{preview.affectedBookings.length}. No provider cancellation
              is sent by this action.</div>}
            {(preview.warnings || []).map((warning, index) =>
              <div key={index} style={{ color:T.yellow }}>{warning}</div>)}
            <label><input type="checkbox" checked={acknowledged && previewVectorsReady}
              disabled={!previewVectorsReady}
              onChange={event => setAcknowledged(event.target.checked)} />
              I checked the current and proposed signed agreements, commercial
              approval, and the exact dates, tier, reviews, grants, transfers,
              forfeitures, and cutoff shown above.</label>
            <Btn pri onClick={confirm} disabled={!previewVectorsReady ||
              !acknowledged || !!busy || submissionBlocked ||
              context.mode !== "write"}>
              {busy === "confirm" ? "Recording…" : "Confirm this change"}
            </Btn>
            {context.mode === "dry_run" && <div>Preview only. Writes are disabled.</div>}
          </section>}
          {(context.correctionCandidates || []).length > 0 &&
            <details><summary>Correct which review funded an existing completion</summary>
              <div style={{ display:"grid", gap:10, marginTop:10 }}>
                <div>The completed review stays in the record. This moves its
                  funded review from one eligible source to another. Other
                  completed reviews are unchanged.</div>
                <label><span style={labelStyle}>Completed review</span>
                  <select style={inputStyle} aria-label="Review to correct"
                  value={correctionForm.completionId}
                  onChange={event => updateCorrection("completionId",
                    event.target.value)}>
                  <option style={selectOptionStyle} value="">Choose a completed review</option>
                  {context.correctionCandidates.map((item, index) =>
                    <option style={selectOptionStyle} key={item.completionId} value={item.completionId}>
                      {item.actualDate} · Review {index + 1}
                    </option>)}</select></label>
                {correctionCandidate && <label><span style={labelStyle}>Use eligible review from</span>
                  <select style={inputStyle} aria-label="Correct funded review source"
                    value={correctionForm.toLineage}
                    onChange={event => updateCorrection("toLineage",
                      event.target.value)}>
                    <option style={selectOptionStyle} value="">Choose the approved review source</option>
                    {(context.currentLots || []).filter(lot =>
                      lot.lineage !== correctionCandidate.allocatedLineage &&
                      lot.release <= correctionCandidate.actualDate &&
                      correctionCandidate.actualDate < lot.expiry).map(lot =>
                      <option style={selectOptionStyle} key={lot.lineage} value={lot.lineage}>
                        {lotLabel[lot.kind] || "Existing review"} ·
                        {" "}{lot.release} through {coveredThrough(lot.expiry)}
                      </option>)}</select></label>}
                <label><span style={labelStyle}>Reason</span>
                  <input style={inputStyle} aria-label="Correction reason"
                  value={correctionForm.reason}
                  onChange={event => updateCorrection("reason",
                    event.target.value)} /></label>
                <label><span style={labelStyle}>Signed agreement reference</span>
                  <input style={inputStyle}
                  aria-label="Correction signed agreement reference"
                  value={correctionForm.signedAgreementReference}
                  onChange={event => updateCorrection(
                    "signedAgreementReference", event.target.value)} /></label>
                <label><span style={labelStyle}>Commercial approval reference</span>
                  <input style={inputStyle}
                  aria-label="Correction commercial approval reference"
                  value={correctionForm.commercialApprovalReference}
                  onChange={event => updateCorrection(
                    "commercialApprovalReference", event.target.value)} /></label>
                <Btn onClick={loadCorrectionPreview} disabled={!!busy ||
                  submissionBlocked || !correctionCandidate ||
                  !correctionForm.toLineage || context.mode === "off"}>
                  {busy === "correction-preview" ? "Preparing…" :
                    "Preview allocation correction"}</Btn>
                {correctionPreview && <section style={{ display:"grid", gap:8 }}>
                  <b>Review from {correctionPreview.originalServiceDate}</b>
                  <div>Usable reviews: {correctionPreview.before.availableUnspent}
                    {" → "}{correctionPreview.after.availableUnspent}.
                    Consumed: {correctionPreview.before.consumed}
                    {" → "}{correctionPreview.after.consumed}.
                    Forfeited: {correctionPreview.before.forfeited}
                    {" → "}{correctionPreview.after.forfeited}.</div>
                  <div>{correctionPreview.warning}</div>
                  <label><input type="checkbox"
                    checked={correctionAcknowledged}
                    onChange={event => setCorrectionAcknowledged(
                      event.target.checked)} />
                    I checked the signed record, commercial approval, and
                    exact review funding change shown above.</label>
                  <Btn pri onClick={confirmCorrection}
                    disabled={!correctionAcknowledged || !!busy || submissionBlocked ||
                      context.mode !== "write"}>
                    {busy === "correction-confirm" ? "Recording…" :
                      "Confirm allocation correction"}</Btn>
                </section>}
              </div>
            </details>}
          </>}
          {(context.agreementHistory || []).length > 1 &&
            <details><summary>Record a late review from an earlier term</summary>
              <div style={{ display:"grid", gap:10, marginTop:10 }}>
                <div>Use this for a completed review from an earlier signed
                  term that was missing from the governed allocation. The preview checks the full
                  carried review history. An uncertain source stays on hold for
                  an individual reconciliation.</div>
                {context.pendingPredecessorFact ? <div>
                  Recorded {context.pendingPredecessorFact.reviewType} review
                  on {context.pendingPredecessorFact.originalServiceDate} needs
                  a funded decision. Its factual record stays unchanged.
                </div> : <>
                <label><span style={labelStyle}>Original review date</span>
                  <input style={inputStyle} type="date"
                  aria-label="Historical review date"
                  value={predecessorForm.originalServiceDate}
                  onChange={event => updatePredecessor(
                    "originalServiceDate", event.target.value)} /></label>
                <label><span style={labelStyle}>Review outcome</span>
                  <select style={inputStyle} aria-label="Historical review outcome"
                  value={predecessorForm.reviewType}
                  onChange={event => updatePredecessor(
                    "reviewType", event.target.value)}>
                  <option style={selectOptionStyle} value="scheduled">Scheduled review</option>
                  <option style={selectOptionStyle} value="re-review">Re-review</option>
                  <option style={selectOptionStyle} value="off-cycle">Off-cycle review</option>
                  <option style={selectOptionStyle} value="no-show">No-show, no new booking link</option>
                  <option style={selectOptionStyle} value="skipped">Customer-requested skip</option>
                </select></label>
                <label><span style={labelStyle}>Review record note</span>
                  <input style={inputStyle} aria-label="Historical review note"
                  value={predecessorForm.note}
                  onChange={event => updatePredecessor("note",
                    event.target.value)} /></label>
                </>}
                <label><span style={labelStyle}>Original approved review source</span>
                  <select style={inputStyle}
                  aria-label="Historical review source"
                  value={predecessorForm.lineage}
                  onChange={event => updatePredecessor("lineage",
                    event.target.value)}>
                  <option style={selectOptionStyle} value="">Choose a carried review source</option>
                  {(context.currentLots || []).map(lot =>
                    <option style={selectOptionStyle} key={lot.lineage} value={lot.lineage}>
                      {lotLabel[lot.kind] || "Existing review"} ·
                      {" "}{lot.release} through {coveredThrough(lot.expiry)}
                    </option>)}</select></label>
                <label><span style={labelStyle}>If this unit already funded a later review, select it</span>
                  <select style={inputStyle} aria-label="Later review funded by this source"
                    value={predecessorForm.successorCompletionId}
                    onChange={event => updatePredecessor(
                      "successorCompletionId", event.target.value)}>
                    <option style={selectOptionStyle} value="">No later review used this unit</option>
                    {(context.correctionCandidates || []).filter(item =>
                      item.allocatedLineage === predecessorForm.lineage).map(
                        (item, index) => <option style={selectOptionStyle} key={item.completionId}
                          value={item.completionId}>
                          {item.actualDate} · Later review {index + 1}
                        </option>)}</select></label>
                <label><span style={labelStyle}>Reason</span>
                  <input style={inputStyle} aria-label="Historical review reason"
                  value={predecessorForm.reason}
                  onChange={event => updatePredecessor("reason",
                    event.target.value)} /></label>
                <label><span style={labelStyle}>Signed agreement reference</span>
                  <input style={inputStyle}
                  aria-label="Historical review signed agreement reference"
                  value={predecessorForm.signedAgreementReference}
                  onChange={event => updatePredecessor(
                    "signedAgreementReference", event.target.value)} /></label>
                <label><span style={labelStyle}>Commercial approval reference</span>
                  <input style={inputStyle}
                  aria-label="Historical review commercial approval reference"
                  value={predecessorForm.commercialApprovalReference}
                  onChange={event => updatePredecessor(
                    "commercialApprovalReference", event.target.value)} /></label>
                <Btn onClick={loadPredecessorPreview} disabled={!!busy ||
                  submissionBlocked || !predecessorForm.originalServiceDate ||
                  !predecessorForm.lineage || context.mode === "off"}>
                  {busy === "predecessor-preview" ? "Preparing…" :
                    "Preview historical review"}</Btn>
                {predecessorPreview && <section style={{ display:"grid", gap:8 }}>
                  <b>Review on {predecessorPreview.originalServiceDate}</b>
                  <div>Usable reviews: {predecessorPreview.before.availableUnspent}
                    {" → "}{predecessorPreview.after.availableUnspent}.
                    Consumed: {predecessorPreview.before.consumed}
                    {" → "}{predecessorPreview.after.consumed}.</div>
                  {predecessorPreview.fulfillmentHold && <strong
                    style={{ color:T.yellow }}>This review unit already funded
                    a later completion. Recording this fact holds all new
                    delivery until its separate obligation is resolved.</strong>}
                  <div>{predecessorPreview.warning}</div>
                  <label><input type="checkbox"
                    checked={predecessorAcknowledged}
                    onChange={event => setPredecessorAcknowledged(
                      event.target.checked)} />
                    I checked the original review, both signed terms, the
                    commercial approval, the carried source, and any later
                    delivery obligation shown above.</label>
                  <Btn pri onClick={confirmPredecessor}
                    disabled={!predecessorAcknowledged || !!busy || submissionBlocked ||
                      context.mode !== "write"}>
                    {busy === "predecessor-confirm" ? "Recording…" :
                      "Confirm historical review"}</Btn>
                </section>}
              </div>
            </details>}
          <details><summary>Completed review history and open bookings</summary>
            <div>{(context.completedHistory || []).map(item =>
              <div key={item.id}>{item.actualDate}: {completionLabel[item.reviewType]
                || "Review"},
                {" "}{item.id === context.pendingPredecessorFact?.sourceCompletionId
                  ? "funding decision pending"
                  : item.countsTowardAllowance ? "counted" : "not counted"}</div>)}</div>
            <div>{(context.openBookings || []).map(item =>
              <div key={item.id}>Booking {bookingLabel[item.status] || "open"}:
                {" "}{item.scheduledStart || "date pending"}
                {item.needsProviderReconciliation &&
                  " — Provider booking needs staff reconciliation"}</div>)}</div>
          </details>
        </>}
      </div>
    </div>, document.body);
};

const RenewalPreviewModal = ({ row, onClose, onChanged }) => {
  const [preview, setPreview] = useState(null);
  const [lifecycleAction, setLifecycleAction] = useState(
    renewalLifecycleFromRow(row));
  const [form, setForm] = useState({
    newTermStartDate: "",
    durationMonths: "",
    reviewsPerYear: "4",
    proposedTier: "",
  });
  const [busy, setBusy] = useState(false);
  const [actionBusy, setActionBusy] = useState("");
  const [actionMessage, setActionMessage] = useState("");
  const [voidReason, setVoidReason] = useState("");
  const [rescindForm, setRescindForm] = useState({
    cancellationEffectiveDate: "",
    reason: "",
    note: "",
  });
  const [activationReviewed, setActivationReviewed] = useState(false);
  const [rescindReviewed, setRescindReviewed] = useState(false);
  const [error, setError] = useState(null);
  const loadSeq = useRef(0);
  const modalGeneration = useRef({ seq:0, slug:"" });

  const loadPreview = useCallback(async (params = {}) => {
    if (!row?.slug) return;
    const seq = loadSeq.current + 1;
    loadSeq.current = seq;
    setBusy(true);
    setError(null);
    try {
      const data = await fetchRenewalPreview(row.slug, params);
      if (loadSeq.current !== seq) return;
      const loadedLifecycle = data?.lifecycle_action
        || params.lifecycleAction
        || "renewal";
      setPreview(data);
      setActivationReviewed(false);
      setRescindReviewed(false);
      setLifecycleAction(loadedLifecycle);
      if (loadedLifecycle === "non_renewal") {
        setForm({
          newTermStartDate: "",
          durationMonths: "",
          reviewsPerYear: "4",
          proposedTier: "",
        });
      } else {
        setForm({
          newTermStartDate: data?.proposed_term?.new_term_start_date || "",
          durationMonths: String(data?.proposed_term?.duration_months || ""),
          reviewsPerYear: String(data?.proposed_term?.reviews_per_year || "4"),
          proposedTier: hasValue(data?.proposed_term?.tier?.value)
            ? String(data.proposed_term.tier.value)
            : "",
        });
      }
    } catch (e) {
      if (loadSeq.current !== seq) return;
      setPreview(null);
      setError(e?.message || "Couldn't load the renewal preview.");
    } finally {
      if (loadSeq.current === seq) setBusy(false);
    }
  }, [row?.slug]);

  useEffect(() => {
    modalGeneration.current = {
      seq: modalGeneration.current.seq + 1,
      slug: row?.slug || "",
    };
    loadSeq.current += 1;
    if (!row) {
      setPreview(null);
      setError(null);
      setActionBusy("");
      setActionMessage("");
      setVoidReason("");
      setRescindForm({ cancellationEffectiveDate:"", reason:"", note:"" });
      setActivationReviewed(false);
      setRescindReviewed(false);
      setBusy(false);
      return undefined;
    }
    setPreview(null);
    setError(null);
    setActionMessage("");
    setVoidReason("");
    setRescindForm({ cancellationEffectiveDate:"", reason:"", note:"" });
    setActivationReviewed(false);
    setRescindReviewed(false);
    setLifecycleAction(renewalLifecycleFromRow(row));
    setForm({
      newTermStartDate: "",
      durationMonths: "",
      reviewsPerYear: "4",
      proposedTier: "",
    });
    loadPreview(renewalLifecycleParam(renewalLifecycleFromRow(row)));
    return undefined;
  }, [row, loadPreview]);

  if (!row) return null;

  const inputStyle = {
    width:"100%", background:"rgba(255,255,255,0.05)",
    border:`1px solid ${T.border}`, borderRadius:7, color:T.text,
    fontSize:12, padding:"7px 9px", fontFamily:"inherit", outline:"none",
    colorScheme:"dark",
  };
  const selectOptionStyle = {
    background:"#0b1f3a", color:T.text,
  };
  const labelStyle = {
    display:"block", fontSize:11, color:T.muted, marginBottom:5,
    fontWeight:700, textTransform:"uppercase", letterSpacing:".04em",
  };
  const sectionStyle = {
    border:`1px solid ${T.border}`, borderRadius:10, padding:12,
    background:"rgba(255,255,255,0.03)",
  };
  const writeThStyle = {
    padding:"8px 7px", borderBottom:`1px solid ${T.border}`,
    textAlign:"left", fontSize:11, color:T.muted, fontWeight:700,
    textTransform:"uppercase", letterSpacing:".04em",
  };
  const writeTdStyle = {
    padding:"8px 7px", borderBottom:`1px solid ${T.border}`, fontSize:12,
    color:T.text,
  };
  const hasValue = (value) =>
    value !== null && value !== undefined && value !== "";
  const fact = (label, value) => (
    <div>
      <div style={{ fontSize:11, color:T.muted, marginBottom:3 }}>{label}</div>
      <div style={{ fontSize:13, color:T.text, fontWeight:600, wordBreak:"break-word" }}>
        {hasValue(value) ? value : "—"}
      </div>
    </div>
  );
  const selectedLifecycle = preview?.lifecycle_action || lifecycleAction;
  const isNonRenewal = selectedLifecycle === "non_renewal";
  const submitPreview = () => loadPreview(isNonRenewal
    ? renewalLifecycleParam(selectedLifecycle)
    : {
        newTermStartDate: form.newTermStartDate,
        durationMonths: form.durationMonths,
        reviewsPerYear: form.reviewsPerYear,
        proposedTier: form.proposedTier,
      });
  const actionParams = () => (isNonRenewal
    ? renewalLifecycleParam(selectedLifecycle)
    : {
        newTermStartDate: form.newTermStartDate,
        durationMonths: form.durationMonths,
        reviewsPerYear: form.reviewsPerYear,
        proposedTier: form.proposedTier,
      });
  const activationParams = () => (isNonRenewal
    ? renewalLifecycleParam(selectedLifecycle)
    : {
        newTermStartDate: form.newTermStartDate,
        durationMonths: form.durationMonths,
        reviewsPerYear: form.reviewsPerYear,
      });
  const handleLifecycleChange = (nextAction) => {
    if (proposalLocked) return;
    setLifecycleAction(nextAction);
    loadPreview(renewalLifecycleParam(nextAction));
  };
  const actionGuard = () => ({ ...modalGeneration.current });
  const actionIsCurrent = (guard) => (
    !!guard.slug
    && modalGeneration.current.seq === guard.seq
    && modalGeneration.current.slug === guard.slug
  );
  const reloadAfterAction = async (guard) => {
    if (!actionIsCurrent(guard)) return;
    await loadPreview(actionParams());
  };
  const current = preview?.current_term || {};
  const allowance = preview?.current_allowance || {};
  const proposed = preview?.proposed_term || {};
  const blocker = preview?.open_booking_blocker || {};
  const eventState = preview?.renewal_event_state || {};
  const activationBlocker = eventState.activation_blocker || {};
  const scheduledEvent = eventState.scheduled_event || {};
  const activatedEvent = eventState.activated_event || {};
  const activationDrift = eventState.activation_drift || {};
  const rescindPreview = preview?.rescind_preview || {};
  const rescindActivityBlocker = (
    rescindPreview.renewed_term_activity_blocker || {}
  );
  const rescindBlockers = Array.isArray(rescindPreview.blockers)
    ? rescindPreview.blockers
    : [];
  const writeRows = Object.entries(preview?.write_preview || {});
  const scheduleWriteRows = Object.entries(preview?.schedule_write_preview || {});
  const rescindWriteRows = Object.entries(rescindPreview.write_preview || {});
  const tierOptions = Array.isArray(preview?.meta?.tier_options)
    ? preview.meta.tier_options
    : [];
  const actionDisabled = busy || !!actionBusy;
  const canSchedule = !!eventState.can_schedule;
  const canVoid = !!eventState.can_void && scheduledEvent.event_id;
  const canActivate = !!eventState.can_activate && scheduledEvent.event_id;
  const canRescind = !!eventState.can_rescind && !!rescindPreview.activated_event_id;
  const proposalLocked = !!scheduledEvent.event_id;
  const activateBlockedByBooking = canActivate && !!blocker.has_open_booking;
  const activateDisabled = actionDisabled || activateBlockedByBooking
    || !activationReviewed;
  const rescindPreviewMatchesDate = (
    !!rescindForm.cancellationEffectiveDate
    && rescindPreview.cancellation_effective_date
      === rescindForm.cancellationEffectiveDate
  );
  const rescindDisabled = actionDisabled || !canRescind
    || !rescindPreview.can_rescind
    || !rescindPreviewMatchesDate
    || !rescindForm.reason.trim()
    || !rescindReviewed
    || !preview?.concurrency_token;
  const rescindActivityCounts = rescindActivityBlocker.counts || {};
  const rescindActivityTotal = (
    Number(rescindActivityCounts.bookings || 0)
    + Number(rescindActivityCounts.completions || 0)
    + Number(rescindActivityCounts.adjustments || 0)
    + Number(rescindActivityCounts.consumed_allowance || 0)
    + Number(rescindActivityCounts.unplaceable_bookings || 0)
    + Number(rescindActivityCounts.unplaceable_completions || 0)
    + Number(rescindActivityCounts.unplaceable_adjustments || 0)
  );
  const proposalInputStyle = proposalLocked
    ? { ...inputStyle, opacity:0.72, cursor:"not-allowed" }
    : inputStyle;
  const proposalSelectStyle = { ...proposalInputStyle, colorScheme:"dark" };
  const actionStatus = actionBusy === "schedule"
    ? "Scheduling..."
    : actionBusy === "activate"
      ? "Activating..."
      : actionBusy === "void"
        ? "Voiding..."
        : actionBusy === "rescind"
          ? "Rescinding..."
          : "";
  const handleSchedule = async () => {
    const guard = actionGuard();
    setActionBusy("schedule");
    setActionMessage("");
    setError(null);
    try {
      await scheduleRenewal(guard.slug, {
        ...actionParams(),
        ...(isNonRenewal ? { concurrencyToken: preview?.concurrency_token } : {}),
        idempotencyKey: renewalActionKey("schedule"),
      });
      if (!actionIsCurrent(guard)) return;
      setActionMessage(isNonRenewal ? "Non-renewal scheduled." : "Renewal scheduled.");
      await reloadAfterAction(guard);
    } catch (e) {
      if (actionIsCurrent(guard)) {
        setError(e?.message || (isNonRenewal
          ? "Couldn't schedule the non-renewal."
          : "Couldn't schedule the renewal."));
      }
    } finally {
      if (actionIsCurrent(guard)) setActionBusy("");
    }
  };
  const handleActivate = async () => {
    const guard = actionGuard();
    setActionBusy("activate");
    setActionMessage("");
    setError(null);
    try {
      await activateRenewal(guard.slug, {
        ...activationParams(),
        scheduledEventId: scheduledEvent.event_id,
        concurrencyToken: preview?.concurrency_token,
        idempotencyKey: renewalActionKey("activate"),
      });
      await onChanged?.();
      if (!actionIsCurrent(guard)) return;
      setActionMessage(isNonRenewal ? "Non-renewal activated." : "Renewal activated.");
      await reloadAfterAction(guard);
    } catch (e) {
      if (actionIsCurrent(guard)) {
        setError(e?.message || (isNonRenewal
          ? "Couldn't activate the non-renewal."
          : "Couldn't activate the renewal."));
      }
    } finally {
      if (actionIsCurrent(guard)) setActionBusy("");
    }
  };
  const handleVoid = async () => {
    if (!voidReason.trim()) {
      setError(isNonRenewal
        ? "Reason is required to void a scheduled non-renewal."
        : "Reason is required to void a scheduled renewal.");
      return;
    }
    const guard = actionGuard();
    setActionBusy("void");
    setActionMessage("");
    setError(null);
    try {
      await voidRenewal(guard.slug, {
        ...renewalLifecycleParam(selectedLifecycle),
        scheduledEventId: scheduledEvent.event_id,
        ...(isNonRenewal ? { concurrencyToken: preview?.concurrency_token } : {}),
        idempotencyKey: renewalActionKey("void"),
        reason: voidReason,
      });
      if (!actionIsCurrent(guard)) return;
      setVoidReason("");
      setActionMessage(isNonRenewal
        ? "Scheduled non-renewal voided."
        : "Scheduled renewal voided.");
      await reloadAfterAction(guard);
    } catch (e) {
      if (actionIsCurrent(guard)) {
        setError(e?.message || (isNonRenewal
          ? "Couldn't void the scheduled non-renewal."
          : "Couldn't void the scheduled renewal."));
      }
    } finally {
      if (actionIsCurrent(guard)) setActionBusy("");
    }
  };
  const submitRescindPreview = () => {
    loadPreview({
      rescindCancellationEffectiveDate: rescindForm.cancellationEffectiveDate,
    });
  };
  const handleRescind = async () => {
    if (!rescindForm.cancellationEffectiveDate) {
      setError("Cancellation effective date is required to rescind a renewal.");
      return;
    }
    if (!rescindForm.reason.trim()) {
      setError("Reason is required to rescind a renewal.");
      return;
    }
    if (!rescindReviewed) {
      setError("Current facts must be reviewed before rescinding a renewal.");
      return;
    }
    const guard = actionGuard();
    setActionBusy("rescind");
    setActionMessage("");
    setError(null);
    try {
      await rescindRenewal(guard.slug, {
        activatedEventId: rescindPreview.activated_event_id,
        cancellationEffectiveDate: rescindForm.cancellationEffectiveDate,
        concurrencyToken: preview?.concurrency_token,
        idempotencyKey: renewalActionKey("rescind"),
        reason: rescindForm.reason,
        ...(rescindForm.note.trim() ? { note: rescindForm.note.trim() } : {}),
      });
      await onChanged?.();
      if (!actionIsCurrent(guard)) return;
      const outcomeCode = rescindPreview.outcome?.code;
      setRescindReviewed(false);
      setActionMessage(outcomeCode === "active_through_original_term"
        ? "Renewal rescinded. Customer remains active through the restored original term. Choose Schedule Non-Renewal if service should end there, or Schedule Renewal if service will continue."
        : "Renewal rescinded. Customer marked Expired / Lost.");
      await loadPreview();
    } catch (e) {
      if (actionIsCurrent(guard)) {
        setError(e?.message || "Couldn't rescind the activated renewal.");
      }
    } finally {
      if (actionIsCurrent(guard)) setActionBusy("");
    }
  };

  return createPortal(
    <div onClick={onClose} style={{ position:"fixed", inset:0, background:"rgba(0,0,0,0.55)", zIndex:1000, display:"flex", justifyContent:"center", alignItems:"center", padding:18 }}>
      <div role="dialog" aria-modal="true" onClick={e => e.stopPropagation()}
        style={{ background:T.panel, border:`1px solid ${T.border}`, borderRadius:14, padding:22, maxWidth:920, width:"96%", maxHeight:"88vh", overflowY:"auto", boxShadow:"0 12px 40px rgba(0,0,0,0.45)" }}>
        <div style={{ display:"flex", justifyContent:"space-between", gap:16, alignItems:"flex-start", marginBottom:12 }}>
          <div>
            <h3 style={{ fontSize:17, fontWeight:700, margin:0 }}>
              Record Renewal — {preview?.customer?.customer_name || row.customer_name || row.slug}
            </h3>
            <div style={{ fontSize:12, color:T.muted, marginTop:5 }}>
              {isNonRenewal
                ? "End-of-term non-renewal uses the current contract boundary."
                : "Schedule first. Activation updates CRM only after the effective date."}
            </div>
          </div>
          <button onClick={onClose} aria-label="Close record renewal"
            style={{ background:"rgba(255,255,255,0.05)", border:`1px solid ${T.border}`, color:T.text, borderRadius:7, width:32, height:32, cursor:"pointer", fontSize:18, lineHeight:"18px" }}>
            ×
          </button>
        </div>

        {error && (
          <div style={{ ...sectionStyle, borderColor:"rgba(225,77,87,0.45)", color:T.red, marginBottom:12 }}>
            {error}
          </div>
        )}
        {actionMessage && (
          <div style={{ ...sectionStyle, borderColor:"rgba(53,194,121,0.45)", color:T.green, marginBottom:12 }}>
            {actionMessage}
          </div>
        )}
        {!preview && busy ? (
          <Skeleton height={220} borderRadius={10} />
        ) : preview ? (
          <>
            <div style={{ ...sectionStyle, marginBottom:12 }}>
              <div style={labelStyle}>Contract Action</div>
              <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit, minmax(210px, 1fr))", gap:12, alignItems:"end" }}>
                <label>
                  <span style={labelStyle}>Action Type</span>
                  <select
                    disabled={proposalLocked}
                    value={selectedLifecycle}
                    onChange={e => handleLifecycleChange(e.target.value)}
                    style={proposalSelectStyle}
                  >
                    <option value="renewal" style={selectOptionStyle}>Renewal</option>
                    <option value="non_renewal" style={selectOptionStyle}>Non-Renewal</option>
                  </select>
                </label>
                <div style={{ fontSize:12, color:T.muted, lineHeight:1.45 }}>
                  {isNonRenewal
                    ? "Customer stays active through the current term. Activation is manual after the boundary date."
                    : "Schedule first. Activation updates CRM only after the effective date."}
                </div>
              </div>
            </div>

            <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit, minmax(210px, 1fr))", gap:12, marginBottom:12 }}>
              <div style={sectionStyle}>
                <div style={labelStyle}>Current Term</div>
                <div style={{ display:"grid", gap:10 }}>
                  {fact("Start", fmtDateOnly(current.term_start_date))}
                  {fact("End Exclusive", fmtDateOnly(current.term_end_exclusive))}
                  {fact("Duration", hasValue(current.duration_months) ? `${current.duration_months} months` : null)}
                  {fact("Reviews Per Year", current.reviews_per_year)}
                  {fact("Current Tier", current.tier?.label || row.tier)}
                  {fact("Model", current.allowance_model)}
                  {fact("Cycle Position", hasValue(current.contract_year) && hasValue(current.review_number)
                    ? `Y${current.contract_year} · R${current.review_number}` : null)}
                </div>
              </div>
              <div style={sectionStyle}>
                <div style={labelStyle}>Current Allowance</div>
                <div style={{ display:"grid", gap:10 }}>
                  {fact("Available Now", allowance.available_now)}
                  {fact("Remaining In Term", allowance.remaining_term_units)}
                  {fact("Adjustments In Term", allowance.adjustments
                    ? `${allowance.adjustments.term_units} units across ${allowance.adjustments.row_count} rows` : null)}
                  {allowance.banked && fact(
                    "Current Window",
                    `${fmtDateOnly(allowance.banked.window_start)} to ${fmtDateOnly(allowance.banked.window_end_excl)}`
                  )}
                  {allowance.banked && fact("Forfeited So Far", allowance.banked.forfeited)}
                </div>
              </div>
              <div style={{
                ...sectionStyle,
                borderColor:blocker.has_open_booking
                  ? "rgba(243,181,63,0.45)" : T.border,
              }}>
                <div style={labelStyle}>Booking Ledger</div>
                {blocker.has_open_booking ? (
                  <div style={{ color:T.yellow, fontSize:13, lineHeight:1.5 }}>
                    {blocker.reason}
                    <div style={{ marginTop:8 }}>
                      {blocker.count} active booking{blocker.count === 1 ? "" : "s"} found.
                    </div>
                  </div>
                ) : (
                  <div style={{ color:T.green, fontSize:13 }}>
                    No active requested or booked review blocks activation.
                  </div>
                )}
              </div>
            </div>

            <div style={{ ...sectionStyle, marginBottom:12 }}>
              <div style={labelStyle}>Renewal Event</div>
              <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit, minmax(170px, 1fr))", gap:10 }}>
                {fact("State", renewalStateLabel(eventState.status, selectedLifecycle))}
                {scheduledEvent.event_id && fact("Scheduled Event", scheduledEvent.event_id)}
                {activatedEvent.event_id && fact("Activated Event", activatedEvent.event_id)}
                {scheduledEvent.effective_date && fact("Effective Date", fmtDateOnly(scheduledEvent.effective_date))}
                {activatedEvent.effective_date && fact("Effective Date", fmtDateOnly(activatedEvent.effective_date))}
                {scheduledEvent.operator && fact("Operator", scheduledEvent.operator)}
                {activatedEvent.operator && fact("Operator", activatedEvent.operator)}
              </div>
              {activationDrift.has_drift && (
                <div style={{ marginTop:12, borderTop:`1px solid ${T.border}`, paddingTop:10 }}>
                  <div style={{ fontSize:12, color:T.yellow, fontWeight:700, marginBottom:8 }}>
                    Current facts changed since this action was scheduled.
                  </div>
                  <TableScroll>
                    <table style={{ width:"100%", borderCollapse:"collapse" }}>
                      <thead><tr>
                        <th style={writeThStyle}>Field</th>
                        <th style={writeThStyle}>Scheduled</th>
                        <th style={writeThStyle}>Current</th>
                      </tr></thead>
                      <tbody>
                        {[...(activationDrift.tracking_fields || []), ...(activationDrift.proposal_fields || [])].map((item, i) => (
                          <tr key={`${item.field}-${i}`}>
                            <td style={writeTdStyle}>{renewalWriteFieldLabel(item.field)}</td>
                            <td style={writeTdStyle}>{renewalWriteValueLabel(item.field, item.scheduled_value)}</td>
                            <td style={writeTdStyle}>{renewalWriteValueLabel(item.field, item.current_value)}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </TableScroll>
                </div>
              )}
            </div>

            {canRescind && (
              <div style={{ ...sectionStyle, marginBottom:12 }}>
                <div style={labelStyle}>Rescind Activated Renewal</div>
                <div style={{ fontSize:12, color:T.muted, lineHeight:1.45, marginBottom:12 }}>
                  This restores the term facts from the activated renewal before-image.
                  Historical activity rows are not deleted or moved.
                </div>
                <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit, minmax(170px, 1fr))", gap:10, marginBottom:12 }}>
                  {fact("Original Start", fmtDateOnly(rescindPreview.original_term?.term_start_date))}
                  {fact("Original End", fmtDateOnly(rescindPreview.original_term?.term_end_date))}
                  {fact("Renewed Start", fmtDateOnly(rescindPreview.renewed_term?.term_start_date))}
                  {fact("Renewed End", fmtDateOnly(rescindPreview.renewed_term?.term_end_date))}
                  {fact("Server Date", fmtDateOnly(rescindPreview.server_execution_day))}
                  {fact("Activity Rows", rescindActivityTotal)}
                </div>
                {rescindActivityBlocker.has_blocker && (
                  <div style={{ color:T.yellow, fontSize:12, lineHeight:1.45, marginBottom:12 }}>
                    {rescindActivityBlocker.reason}
                  </div>
                )}
                {rescindBlockers.length > 0 && (
                  <div style={{ color:T.yellow, fontSize:12, lineHeight:1.45, marginBottom:12 }}>
                    {rescindBlockers[0].message}
                  </div>
                )}
                <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit, minmax(190px, 1fr))", gap:10, alignItems:"end" }}>
                  <label>
                    <span style={labelStyle}>Cancellation Effective Date</span>
                    <input
                      type="date"
                      value={rescindForm.cancellationEffectiveDate}
                      onChange={e => setRescindForm(f => ({
                        ...f,
                        cancellationEffectiveDate:e.target.value,
                      }))}
                      style={inputStyle}
                    />
                  </label>
                  <label>
                    <span style={labelStyle}>Reason</span>
                    <input
                      type="text"
                      maxLength={100}
                      value={rescindForm.reason}
                      onChange={e => setRescindForm(f => ({
                        ...f,
                        reason:e.target.value,
                      }))}
                      style={inputStyle}
                    />
                  </label>
                  <label>
                    <span style={labelStyle}>Note</span>
                    <textarea
                      maxLength={2000}
                      value={rescindForm.note}
                      onChange={e => setRescindForm(f => ({
                        ...f,
                        note:e.target.value,
                      }))}
                      style={{ ...inputStyle, minHeight:34, resize:"vertical" }}
                    />
                  </label>
                  <Btn
                    pri
                    onClick={submitRescindPreview}
                    disabled={actionDisabled || !rescindForm.cancellationEffectiveDate}
                    style={{ height:34 }}
                  >
                    Preview rescind
                  </Btn>
                </div>
                {rescindPreview.outcome?.message && (
                  <div style={{ color:T.text, fontSize:12, lineHeight:1.45, marginTop:12 }}>
                    {rescindPreview.outcome.message}
                  </div>
                )}
                {rescindWriteRows.length > 0 && (
                  <div style={{ marginTop:12 }}>
                    <div style={{ fontSize:12, color:T.muted, fontWeight:700, marginBottom:6 }}>
                      Rescind write preview
                    </div>
                    <TableScroll>
                      <table style={{ width:"100%", borderCollapse:"collapse" }}>
                        <thead><tr>
                          <th style={writeThStyle}>Field</th>
                          <th style={writeThStyle}>Value</th>
                        </tr></thead>
                        <tbody>
                          {rescindWriteRows.map(([field, value]) => (
                            <tr key={field}>
                              <td style={writeTdStyle}>{renewalWriteFieldLabel(field)}</td>
                              <td style={writeTdStyle}>{renewalWriteValueLabel(field, value)}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </TableScroll>
                  </div>
                )}
                <label style={{
                  display:"flex", alignItems:"center", gap:8, marginTop:12,
                  fontSize:12, color:T.text,
                }}>
                  <input
                    type="checkbox"
                    checked={rescindReviewed}
                    onChange={e => setRescindReviewed(e.target.checked)}
                  />
                  <span>Current facts reviewed for rescind</span>
                </label>
              </div>
            )}

            {isNonRenewal ? (
              <div style={{ ...sectionStyle, marginBottom:12 }}>
                <div style={labelStyle}>End-of-Term Non-Renewal</div>
                <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit, minmax(170px, 1fr))", gap:10 }}>
                  {fact("Effective Boundary", fmtDateOnly(preview.non_renewal?.effective_date))}
                  {fact("Last Covered Day", fmtDateOnly(preview.non_renewal?.last_covered_date))}
                  {fact("Auto Renew Now", renewalWriteValueLabel("pc_autorenew", current.auto_renew))}
                  {fact("Auto Renew After Schedule", renewalWriteValueLabel("pc_autorenew", false))}
                  {fact("Contract Status On Activation", renewalWriteValueLabel("pc_contractstatus", preview.write_preview?.pc_contractstatus))}
                  {fact("Opportunity Status On Activation", renewalWriteValueLabel("pc_secureshieldstatus", preview.write_preview?.pc_secureshieldstatus))}
                </div>
              </div>
            ) : (
              <div style={{ ...sectionStyle, marginBottom:12 }}>
                <div style={labelStyle}>Proposed New Term</div>
                <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit, minmax(170px, 1fr))", gap:10, alignItems:"end" }}>
                  <label>
                    <span style={labelStyle}>New Term Start Date</span>
                    <input
                      type="date"
                      disabled={proposalLocked}
                      value={form.newTermStartDate}
                      onChange={e => setForm(f => ({ ...f, newTermStartDate:e.target.value }))}
                      style={proposalInputStyle}
                    />
                  </label>
                  <label>
                    <span style={labelStyle}>Duration Months</span>
                    <input
                      type="number"
                      min="1"
                      step="1"
                      disabled={proposalLocked}
                      value={form.durationMonths}
                      onChange={e => setForm(f => ({ ...f, durationMonths:e.target.value }))}
                      style={proposalInputStyle}
                    />
                  </label>
                  <label>
                    <span style={labelStyle}>Reviews Per Year</span>
                    <select
                      disabled={proposalLocked}
                      value={form.reviewsPerYear}
                      onChange={e => setForm(f => ({ ...f, reviewsPerYear:e.target.value }))}
                      style={proposalSelectStyle}
                    >
                      <option value="4" style={selectOptionStyle}>4</option>
                      <option value="5" style={selectOptionStyle}>5</option>
                      <option value="6" style={selectOptionStyle}>6</option>
                    </select>
                  </label>
                  <label>
                    <span style={labelStyle}>Proposed Renewal Tier</span>
                    <select
                      disabled={proposalLocked}
                      value={form.proposedTier}
                      onChange={e => setForm(f => ({ ...f, proposedTier:e.target.value }))}
                      style={proposalSelectStyle}
                    >
                      <option value="" style={selectOptionStyle}>Choose tier</option>
                      {tierOptions.map(option => (
                        <option
                          key={option.value}
                          value={String(option.value)}
                          style={selectOptionStyle}
                        >
                          {option.label}
                        </option>
                      ))}
                    </select>
                  </label>
                  <div>
                    <span style={labelStyle}>Model</span>
                    <div style={{ fontSize:13, fontWeight:700, color:T.text, padding:"7px 0" }}>
                      Banked
                    </div>
                  </div>
                  <Btn pri onClick={submitPreview} disabled={busy || proposalLocked} style={{ height:34 }}>
                    {busy ? "Updating…" : "Update preview"}
                  </Btn>
                </div>
                <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit, minmax(170px, 1fr))", gap:10, marginTop:12 }}>
                  {fact("Derived Term Start Year", proposed.term_start_year)}
                  {fact("Derived End Exclusive", fmtDateOnly(proposed.term_end_exclusive))}
                  {fact("Stored Term End Date", fmtDateOnly(proposed.term_end_date))}
                  {fact("Proposed Tier", proposed.tier?.label)}
                  {fact("Cycle Position", hasValue(proposed.contract_year) && hasValue(proposed.review_number)
                    ? `Y${proposed.contract_year} · R${proposed.review_number}` : null)}
                </div>
              </div>
            )}

            <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit, minmax(260px, 1fr))", gap:12 }}>
              {!isNonRenewal && (
                <div style={sectionStyle}>
                  <div style={labelStyle}>Dates To Clear</div>
                  {(preview.dates_to_clear || []).map(item => (
                    <div key={item.field} style={{ display:"flex", justifyContent:"space-between", gap:10, fontSize:13, marginTop:8 }}>
                      <span style={{ color:T.muted }}>{item.label}</span>
                      <span style={{ color:T.text, fontWeight:600 }}>
                        {fmtDateOnly(item.current_value)} → Clear
                      </span>
                    </div>
                  ))}
                  <div style={{ fontSize:11.5, color:T.muted, marginTop:10, lineHeight:1.45 }}>
                    Actual appointments remain authoritative in the booking ledger.
                  </div>
                </div>
              )}
              <div style={sectionStyle}>
                <div style={labelStyle}>
                  {isNonRenewal ? "Units Expiring At Term End" : "Units Expiring At Renewal"}
                </div>
                <div style={{ display:"grid", gap:10 }}>
                  {fact("Available Now", preview.units_expiring_at_renewal?.available_now)}
                  {fact("Remaining In Term", preview.units_expiring_at_renewal?.remaining_term_units)}
                </div>
                <div style={{ fontSize:11.5, color:T.muted, marginTop:10, lineHeight:1.45 }}>
                  {preview.units_expiring_at_renewal?.note}
                </div>
              </div>
            </div>

            <div style={{ ...sectionStyle, marginTop:12 }}>
              <div style={labelStyle}>Write Preview</div>
              {isNonRenewal && scheduleWriteRows.length > 0 && (
                <>
                  <div style={{ fontSize:12, color:T.muted, fontWeight:700, marginBottom:6 }}>
                    Schedule now
                  </div>
                  <TableScroll>
                    <table style={{ width:"100%", borderCollapse:"collapse", marginBottom:10 }}>
                      <thead><tr>
                        <th style={writeThStyle}>Field</th>
                        <th style={writeThStyle}>Value</th>
                      </tr></thead>
                      <tbody>
                        {scheduleWriteRows.map(([field, value]) => (
                          <tr key={field}>
                            <td style={writeTdStyle}>{renewalWriteFieldLabel(field)}</td>
                            <td style={writeTdStyle}>{renewalWriteValueLabel(field, value)}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </TableScroll>
                  <div style={{ fontSize:12, color:T.muted, fontWeight:700, marginBottom:6 }}>
                    Activate at boundary
                  </div>
                </>
              )}
              <TableScroll>
                <table style={{ width:"100%", borderCollapse:"collapse" }}>
                  <thead><tr>
                    <th style={writeThStyle}>Field</th>
                    <th style={writeThStyle}>Value</th>
                  </tr></thead>
                  <tbody>
                    {writeRows.map(([field, value]) => (
                      <tr key={field}>
                        <td style={writeTdStyle}>{renewalWriteFieldLabel(field)}</td>
                        <td style={writeTdStyle}>{renewalWriteValueLabel(field, value)}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </TableScroll>
            </div>
          </>
        ) : null}

        {preview && (
          <div style={{ ...sectionStyle, marginTop:12 }}>
            <div style={labelStyle}>Action</div>
            {canVoid && (
              <label style={{ display:"block", marginBottom:10 }}>
                <span style={labelStyle}>Void Reason</span>
                <input
                  type="text"
                  maxLength={100}
                  value={voidReason}
                  onChange={e => setVoidReason(e.target.value)}
                  style={inputStyle}
                />
              </label>
            )}
            {canActivate && (
              <label style={{
                display:"flex", alignItems:"center", gap:8, marginBottom:10,
                fontSize:12, color:T.text,
              }}>
                <input
                  type="checkbox"
                  checked={activationReviewed}
                  onChange={e => setActivationReviewed(e.target.checked)}
                />
                <span>Current facts reviewed</span>
              </label>
            )}
            {actionStatus && (
              <div style={{ fontSize:12, color:T.muted, marginBottom:10 }}>
                {actionStatus}
              </div>
            )}
            {activationBlocker.message && (
              <div style={{ fontSize:12, color:T.warn, marginBottom:10 }}>
                {activationBlocker.message}
              </div>
            )}
            <div style={{ display:"flex", gap:8, justifyContent:"flex-end", flexWrap:"wrap" }}>
              {canSchedule && (
                <Btn pri onClick={handleSchedule} disabled={actionDisabled}>
                  {isNonRenewal ? "Schedule Non-Renewal" : "Schedule Renewal"}
                </Btn>
              )}
              {canActivate && (
                <Btn
                  pri
                  onClick={handleActivate}
                  disabled={activateDisabled}
                  title={
                    activateBlockedByBooking
                      ? blocker.reason
                      : (!activationReviewed ? "Current facts must be reviewed first" : undefined)
                  }
                >
                  {isNonRenewal ? "Activate Non-Renewal" : "Activate Renewal"}
                </Btn>
              )}
              {canVoid && (
                <Btn onClick={handleVoid} disabled={actionDisabled}>
                  {isNonRenewal ? "Void Scheduled Non-Renewal" : "Void Scheduled Renewal"}
                </Btn>
              )}
              {canRescind && (
                <Btn
                  pri
                  onClick={handleRescind}
                  disabled={rescindDisabled}
                  title={
                    !rescindPreviewMatchesDate
                      ? "Preview this cancellation date first"
                      : (!rescindReviewed
                          ? "Current facts must be reviewed first"
                          : undefined)
                  }
                >
                  Rescind Renewal
                </Btn>
              )}
            </div>
          </div>
        )}

        <div style={{ display:"flex", justifyContent:"flex-end", marginTop:16 }}>
          <Btn onClick={onClose}>Close</Btn>
        </div>
      </div>
    </div>,
    document.body,
  );
};

const allowanceActionKey = () => {
  if (window.crypto?.randomUUID) return window.crypto.randomUUID();
  const bytes = new Uint8Array(16);
  if (window.crypto?.getRandomValues) {
    window.crypto.getRandomValues(bytes);
  } else {
    for (let i = 0; i < bytes.length; i += 1) {
      bytes[i] = Math.floor(Math.random() * 256);
    }
  }
  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;
  const hex = Array.from(bytes, b => b.toString(16).padStart(2, "0"));
  return [
    hex.slice(0, 4).join(""),
    hex.slice(4, 6).join(""),
    hex.slice(6, 8).join(""),
    hex.slice(8, 10).join(""),
    hex.slice(10, 16).join(""),
  ].join("-");
};

const allowanceFormFromCard = (card) => ({
  amount: "1",
  reason: "purchased",
  effectiveDate: card?.meta?.server_today || "",
  note: "",
});

const allowanceMetricValue = (value) => (
  value === null || value === undefined || value === "" ? "—" : String(value)
);

const AllowanceAdjustmentModal = ({ row, onClose, onChanged }) => {
  const [card, setCard] = useState(null);
  const [form, setForm] = useState(allowanceFormFromCard(null));
  const [preview, setPreview] = useState(null);
  const [idempotencyKey, setIdempotencyKey] = useState("");
  const [loading, setLoading] = useState(false);
  const [actionBusy, setActionBusy] = useState("");
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");
  const loadSeq = useRef(0);

  const reasonOptions = Array.isArray(card?.meta?.reason_options)
    ? card.meta.reason_options
    : [
        { key:"purchased", label:"Purchased" },
        { key:"gifted", label:"Gifted" },
        { key:"migration_seed", label:"Migration Seed" },
        { key:"other", label:"Other" },
      ];
  const selectedReason = reasonOptions.find(o => o.key === form.reason);
  const migrationSeed = form.reason === "migration_seed";
  const term = card?.tracking || {};
  const amountBounds = card?.meta?.amount || { min:1, max:50 };
  const noteMax = card?.meta?.note_max_length || 200;

  useEffect(() => {
    const seq = loadSeq.current + 1;
    loadSeq.current = seq;
    if (!row?.slug) {
      setCard(null);
      setPreview(null);
      setError("");
      setMessage("");
      setLoading(false);
      return undefined;
    }
    setCard(null);
    setPreview(null);
    setError("");
    setMessage("");
    setIdempotencyKey(allowanceActionKey());
    setForm(allowanceFormFromCard(null));
    setLoading(true);
    fetchAllowanceAdjustments(row.slug)
      .then(data => {
        if (loadSeq.current !== seq) return;
        setCard(data);
        setForm(allowanceFormFromCard(data));
      })
      .catch(e => {
        if (loadSeq.current !== seq) return;
        setError(e?.body?.error || e?.message || "Couldn't load allowance adjustments.");
      })
      .finally(() => {
        if (loadSeq.current === seq) setLoading(false);
      });
    return () => { loadSeq.current += 1; };
  }, [row]);

  if (!row) return null;

  const inputStyle = {
    width:"100%", background:"rgba(255,255,255,0.05)",
    border:`1px solid ${T.border}`, borderRadius:7, color:T.text,
    fontSize:12, padding:"7px 9px", fontFamily:"inherit", outline:"none",
    colorScheme:"dark",
  };
  const selectOptionStyle = { background:"#0b1f3a", color:T.text };
  const labelStyle = {
    display:"block", fontSize:11, color:T.muted, marginBottom:5,
    fontWeight:700, textTransform:"uppercase", letterSpacing:".04em",
  };
  const sectionStyle = {
    border:`1px solid ${T.border}`, borderRadius:10, padding:12,
    background:"rgba(255,255,255,0.03)",
  };
  const th = {
    padding:"8px 7px", borderBottom:`1px solid ${T.border}`,
    textAlign:"left", fontSize:11, color:T.muted, fontWeight:700,
    textTransform:"uppercase", letterSpacing:".04em",
  };
  const td = {
    padding:"8px 7px", borderBottom:`1px solid ${T.border}`,
    fontSize:12, color:T.text, verticalAlign:"top",
  };
  const fact = (label, value) => (
    <div>
      <div style={{ fontSize:11, color:T.muted, marginBottom:3 }}>{label}</div>
      <div style={{ fontSize:18, color:T.text, fontWeight:700 }}>
        {allowanceMetricValue(value)}
      </div>
    </div>
  );
  const setField = (patch) => {
    setForm(prev => {
      const next = { ...prev, ...patch };
      if (patch.reason && patch.reason !== "migration_seed") {
        next.effectiveDate = card?.meta?.server_today || "";
      }
      return next;
    });
    setPreview(null);
    setMessage("");
    setError("");
  };
  const previewPayload = () => ({
    amount: form.amount,
    reason: form.reason,
    effectiveDate: form.effectiveDate,
    note: form.note,
  });
  const handlePreview = async () => {
    setActionBusy("preview");
    setError("");
    setMessage("");
    try {
      const data = await previewAllowanceAdjustment(row.slug, previewPayload());
      setPreview(data?.preview || data);
    } catch (e) {
      setError(e?.body?.error || e?.message || "Couldn't preview this adjustment.");
    } finally {
      setActionBusy("");
    }
  };
  const handleCreate = async () => {
    if (!preview?.preview_hash) return;
    setActionBusy("create");
    setError("");
    setMessage("");
    try {
      const result = await createAllowanceAdjustment(row.slug, {
        ...previewPayload(),
        idempotencyKey,
        acknowledgedPreviewHash: preview.preview_hash,
      });
      setCard(result?.card || card);
      setPreview(null);
      const nextCard = result?.card || card;
      setForm(allowanceFormFromCard(nextCard));
      setIdempotencyKey(allowanceActionKey());
      setMessage(result?.action === "existing"
        ? "Allowance adjustment already recorded."
        : "Allowance adjustment added.");
      await onChanged?.();
    } catch (e) {
      setError(e?.body?.error || e?.message || "Couldn't add this adjustment.");
    } finally {
      setActionBusy("");
    }
  };
  const history = Array.isArray(card?.history) ? card.history : [];
  const adjustments = card?.allowance?.adjustments || {};
  const before = preview?.before || {};
  const after = preview?.after || {};

  return createPortal(
    <div onClick={onClose} style={{ position:"fixed", inset:0, background:"rgba(0,0,0,0.55)", zIndex:1000, display:"flex", justifyContent:"center", alignItems:"center", padding:18 }}>
      <div
        role="dialog"
        aria-modal="true"
        aria-label="Allowance Adjustment"
        data-testid="allowance-adjustment-modal"
        onClick={e => e.stopPropagation()}
        style={{ background:T.panel, border:`1px solid ${T.border}`, borderRadius:14, padding:22, maxWidth:840, width:"96%", maxHeight:"88vh", overflowY:"auto", boxShadow:"0 12px 40px rgba(0,0,0,0.45)" }}
      >
        <div style={{ display:"flex", justifyContent:"space-between", gap:16, alignItems:"flex-start", marginBottom:12 }}>
          <div>
            <h3 style={{ fontSize:17, fontWeight:700, margin:0, color:T.text }}>
              Allowance Adjustment — {card?.customer?.customer_name || row.customer_name || row.slug}
            </h3>
            <div style={{ fontSize:12, color:T.muted, marginTop:5 }}>
              Patriot-only append of purchased, gifted, migration seed, or other review units.
            </div>
          </div>
          <button onClick={onClose} aria-label="Close allowance adjustment"
            style={{ background:"rgba(255,255,255,0.05)", border:`1px solid ${T.border}`, color:T.text, borderRadius:7, width:32, height:32, cursor:"pointer", fontSize:18, lineHeight:"18px" }}>
            ×
          </button>
        </div>

        {error && (
          <div style={{ ...sectionStyle, borderColor:"rgba(225,77,87,0.45)", color:T.red, marginBottom:12 }}>
            {error}
          </div>
        )}
        {message && (
          <div style={{ ...sectionStyle, borderColor:"rgba(53,194,121,0.45)", color:T.green, marginBottom:12 }}>
            {message}
          </div>
        )}

        {loading ? (
          <Skeleton height={220} borderRadius={10} />
        ) : card ? (
          <>
            <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit, minmax(130px, 1fr))", gap:12, marginBottom:12 }}>
              <div style={sectionStyle}>
                {fact("Included reviews", card.allowance?.included_reviews)}
              </div>
              <div style={sectionStyle}>
                {fact("Purchased", adjustments.purchased || 0)}
              </div>
              <div style={sectionStyle}>
                {fact("Gifted", adjustments.gifted || 0)}
              </div>
              <div style={sectionStyle}>
                {fact("Available now", card.allowance?.available_now)}
              </div>
              <div style={sectionStyle}>
                {fact("Remaining in term", card.allowance?.remaining_in_term)}
              </div>
            </div>

            <div style={{ ...sectionStyle, marginBottom:12 }}>
              <div style={labelStyle}>Active term</div>
              <div style={{ fontSize:13, color:T.text }}>
                {fmtDateOnly(term.term_start_date)} to {fmtDateOnly(term.term_end_exclusive)}
              </div>
            </div>

            <div style={{ ...sectionStyle, marginBottom:12 }}>
              <div style={labelStyle}>Adjustment history</div>
              {history.length === 0 ? (
                <div style={{ fontSize:12, color:T.muted }}>
                  No adjustment rows in this term.
                </div>
              ) : (
                <TableScroll>
                  <table style={{ width:"100%", borderCollapse:"collapse" }}>
                    <thead><tr>
                      <th style={th}>Date</th>
                      <th style={th}>Reason</th>
                      <th style={th}>Amount</th>
                      <th style={th}>Note</th>
                    </tr></thead>
                    <tbody>
                      {history.map(item => (
                        <tr key={item.adjustment_id || `${item.effective_date}-${item.reason?.key}`}>
                          <td style={td}>{fmtDateOnly(item.effective_date)}</td>
                          <td style={td}>{item.reason?.label || "Unknown"}</td>
                          <td style={td}>{allowanceMetricValue(item.amount)}</td>
                          <td style={{ ...td, color:T.muted }}>{item.note || "—"}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </TableScroll>
              )}
            </div>

            <div style={{ ...sectionStyle, marginBottom:12 }}>
              <div style={labelStyle}>Add Reviews</div>
              <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit, minmax(170px, 1fr))", gap:10, alignItems:"end" }}>
                <label>
                  <span style={labelStyle}>Amount</span>
                  <input
                    type="number"
                    min={amountBounds.min}
                    max={amountBounds.max}
                    step="1"
                    value={form.amount}
                    onChange={e => setField({ amount:e.target.value })}
                    style={inputStyle}
                  />
                </label>
                <label>
                  <span style={labelStyle}>Reason</span>
                  <select
                    value={form.reason}
                    onChange={e => setField({ reason:e.target.value })}
                    style={inputStyle}
                  >
                    {reasonOptions.map(option => (
                      <option key={option.key} value={option.key} style={selectOptionStyle}>
                        {option.label}
                      </option>
                    ))}
                  </select>
                </label>
                <label>
                  <span style={labelStyle}>Effective date</span>
                  <input
                    type="date"
                    value={form.effectiveDate}
                    disabled={!migrationSeed}
                    min={term.term_start_date || undefined}
                    max={card.meta?.server_today || undefined}
                    onChange={e => setField({ effectiveDate:e.target.value })}
                    style={{
                      ...inputStyle,
                      opacity: migrationSeed ? 1 : 0.72,
                      cursor: migrationSeed ? "text" : "not-allowed",
                    }}
                  />
                </label>
                <label>
                  <span style={labelStyle}>Note</span>
                  <textarea
                    maxLength={noteMax}
                    value={form.note}
                    onChange={e => setField({ note:e.target.value })}
                    style={{ ...inputStyle, minHeight:34, resize:"vertical" }}
                  />
                </label>
                <Btn
                  pri
                  onClick={handlePreview}
                  disabled={!!actionBusy}
                  style={{ height:34 }}
                >
                  {actionBusy === "preview" ? "Previewing…" : "Preview"}
                </Btn>
              </div>
              {!migrationSeed && (
                <div style={{ fontSize:11.5, color:T.muted, lineHeight:1.45, marginTop:8 }}>
                  {selectedReason?.label || "This reason"} uses the server date. Backdating is only for Migration Seed.
                </div>
              )}
            </div>

            {preview && (
              <div style={{ ...sectionStyle, borderColor:"rgba(68,166,255,.35)", marginBottom:12 }}>
                <div style={labelStyle}>Confirmation preview</div>
                <div style={{ fontSize:12.5, color:T.text, lineHeight:1.55 }}>
                  This appends {preview.normalized?.amount} {preview.normalized?.reason?.label}
                  {" "}review{Number(preview.normalized?.amount) === 1 ? "" : "s"}
                  {" "}effective {fmtDateOnly(preview.normalized?.effective_date)}.
                  The added units are available immediately, remain through the active term, and expire at term end.
                </div>
                <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit, minmax(130px, 1fr))", gap:10, marginTop:10 }}>
                  {fact("Available now", `${allowanceMetricValue(before.available_now)} → ${allowanceMetricValue(after.available_now)}`)}
                  {fact("Remaining in term", `${allowanceMetricValue(before.remaining_in_term)} → ${allowanceMetricValue(after.remaining_in_term)}`)}
                </div>
                <div style={{ fontSize:11.5, color:T.muted, lineHeight:1.45, marginTop:10 }}>
                  Customer-facing surfaces receive only the resulting allowance. Reason, note, history, and this UUID stay Patriot-only.
                </div>
              </div>
            )}

            <div style={{ display:"flex", justifyContent:"flex-end", gap:8, flexWrap:"wrap" }}>
              <Btn onClick={onClose}>Close</Btn>
              <Btn
                pri
                onClick={handleCreate}
                disabled={!!actionBusy || !preview?.preview_hash}
              >
                {actionBusy === "create" ? "Adding…" : "Add Reviews"}
              </Btn>
            </div>
          </>
        ) : (
          <div style={{ fontSize:13, color:T.muted }}>
            No allowance data loaded.
          </div>
        )}
      </div>
    </div>,
    document.body,
  );
};

const canOpenBankedTransition = (row) => (
  row?.contract_status === "Ongoing" && row?.allowance_model === "legacy"
);

const AllowanceTransitionModal = ({ row, onClose, onChanged }) => {
  const [card, setCard] = useState(null);
  const [preflight, setPreflight] = useState(null);
  const [note, setNote] = useState("");
  const [preview, setPreview] = useState(null);
  const [loading, setLoading] = useState(false);
  const [actionBusy, setActionBusy] = useState("");
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");
  const loadSeq = useRef(0);

  useEffect(() => {
    const seq = loadSeq.current + 1;
    loadSeq.current = seq;
    if (!row?.slug) {
      setCard(null);
      setPreflight(null);
      setPreview(null);
      setError("");
      setMessage("");
      setLoading(false);
      return undefined;
    }
    setCard(null);
    setPreflight(null);
    setPreview(null);
    setNote("");
    setError("");
    setMessage("");
    setLoading(true);
    fetchAllowanceTransition(row.slug)
      .then(data => {
        if (loadSeq.current !== seq) return;
        setCard(data?.card || null);
        setPreflight(data?.preflight || null);
      })
      .catch(e => {
        if (loadSeq.current !== seq) return;
        setError(e?.body?.error || e?.message || "Couldn't load Banked transition.");
      })
      .finally(() => {
        if (loadSeq.current === seq) setLoading(false);
      });
    return () => { loadSeq.current += 1; };
  }, [row]);

  if (!row) return null;

  const inputStyle = {
    width:"100%", background:"rgba(255,255,255,0.05)",
    border:`1px solid ${T.border}`, borderRadius:7, color:T.text,
    fontSize:12, padding:"7px 9px", fontFamily:"inherit", outline:"none",
    colorScheme:"dark",
  };
  const labelStyle = {
    display:"block", fontSize:11, color:T.muted, marginBottom:5,
    fontWeight:700, textTransform:"uppercase", letterSpacing:".04em",
  };
  const sectionStyle = {
    border:`1px solid ${T.border}`, borderRadius:10, padding:12,
    background:"rgba(255,255,255,0.03)",
  };
  const th = {
    padding:"8px 7px", borderBottom:`1px solid ${T.border}`,
    textAlign:"left", fontSize:11, color:T.muted, fontWeight:700,
    textTransform:"uppercase", letterSpacing:".04em",
  };
  const td = {
    padding:"8px 7px", borderBottom:`1px solid ${T.border}`,
    fontSize:12, color:T.text, verticalAlign:"top",
  };
  const fact = (label, value) => (
    <div>
      <div style={{ fontSize:11, color:T.muted, marginBottom:3 }}>{label}</div>
      <div style={{ fontSize:18, color:T.text, fontWeight:700 }}>
        {allowanceMetricValue(value)}
      </div>
    </div>
  );

  const source = preview?.source || preflight?.source || {};
  const allowance = preview?.allowance || {
    standard_remaining: source.standard_remaining,
    transition_gift: source.transition_gift,
    opening_balance: source.opening_balance,
  };
  const blockers = preview?.blockers || preflight?.blockers || [];
  const completions = preview?.completions || preflight?.completions || [];
  const tracking = card?.tracking || {};
  const noteMax = card?.meta?.note_max_length || 2000;
  const noteReady = note.trim().length > 0;

  const handlePreview = async () => {
    if (!noteReady) {
      setPreview(null);
      setError("A required note is needed before previewing this transition.");
      setMessage("");
      return;
    }
    setActionBusy("preview");
    setError("");
    setMessage("");
    try {
      const data = await previewAllowanceTransition(row.slug, { note });
      setPreview(data?.preview || data);
    } catch (e) {
      const blockedPreview = e?.body?.preview;
      if (blockedPreview) setPreview(blockedPreview);
      setError(e?.body?.error || e?.message || "Couldn't preview this transition.");
    } finally {
      setActionBusy("");
    }
  };

  const handleCreate = async () => {
    if (!preview?.preview_hash || !preview?.transition_id) return;
    setActionBusy("create");
    setError("");
    setMessage("");
    try {
      const result = await createAllowanceTransition(row.slug, {
        transitionId: preview.transition_id,
        note,
        acknowledgedPreviewHash: preview.preview_hash,
      });
      setCard(result?.card || card);
      setPreview(null);
      setMessage(result?.action === "existing"
        ? "Banked transition already recorded."
        : "Banked transition recorded.");
      await onChanged?.();
    } catch (e) {
      setError(e?.body?.error || e?.message || "Couldn't record this Banked transition.");
    } finally {
      setActionBusy("");
    }
  };

  return createPortal(
    <div onClick={onClose} style={{ position:"fixed", inset:0, background:"rgba(0,0,0,0.55)", zIndex:1000, display:"flex", justifyContent:"center", alignItems:"center", padding:18 }}>
      <div
        role="dialog"
        aria-modal="true"
        aria-label="Banked Transition"
        data-testid="allowance-transition-modal"
        onClick={e => e.stopPropagation()}
        style={{ background:T.panel, border:`1px solid ${T.border}`, borderRadius:14, padding:22, maxWidth:860, width:"96%", maxHeight:"88vh", overflowY:"auto", boxShadow:"0 12px 40px rgba(0,0,0,0.45)" }}
      >
        <div style={{ display:"flex", justifyContent:"space-between", gap:16, alignItems:"flex-start", marginBottom:12 }}>
          <div>
            <h3 style={{ fontSize:17, fontWeight:700, margin:0 }}>
              Banked Transition — {card?.customer?.customer_name || row.customer_name || row.slug}
            </h3>
            <div style={{ fontSize:12, color:T.muted, marginTop:5 }}>
              Patriot-only opening-balance seed for a Legacy-to-Banked conversion.
            </div>
          </div>
          <button onClick={onClose} aria-label="Close Banked transition"
            style={{ background:"rgba(255,255,255,0.05)", border:`1px solid ${T.border}`, color:T.text, borderRadius:7, width:32, height:32, cursor:"pointer", fontSize:18, lineHeight:"18px" }}>
            ×
          </button>
        </div>

        {error && (
          <div style={{ ...sectionStyle, borderColor:"rgba(225,77,87,0.45)", color:T.red, marginBottom:12 }}>
            {error}
          </div>
        )}
        {message && (
          <div style={{ ...sectionStyle, borderColor:"rgba(53,194,121,0.45)", color:T.green, marginBottom:12 }}>
            {message}
          </div>
        )}

        {loading ? (
          <Skeleton height={220} borderRadius={10} />
        ) : card ? (
          <>
            <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit, minmax(130px, 1fr))", gap:12, marginBottom:12 }}>
              <div style={sectionStyle}>
                {fact("Source T/Y/R", `${allowanceMetricValue(source.source_term_start_year)}/${allowanceMetricValue(source.source_contract_year)}/${allowanceMetricValue(source.source_review_number)}`)}
              </div>
              <div style={sectionStyle}>
                {fact("Reviews/year", source.reviews_per_year)}
              </div>
              <div style={sectionStyle}>
                {fact("Standard remaining", allowance.standard_remaining)}
              </div>
              <div style={sectionStyle}>
                {fact("Transition gift", allowance.transition_gift)}
              </div>
              <div style={sectionStyle}>
                {fact("Opening balance", allowance.opening_balance)}
              </div>
            </div>

            <div style={{ ...sectionStyle, marginBottom:12 }}>
              <div style={labelStyle}>Active term and cadence dates</div>
              <div style={{ fontSize:13, color:T.text, lineHeight:1.55 }}>
                Term: {fmtDateOnly(tracking.term_start_date)} to {fmtDateOnly(tracking.term_end_date || tracking.term_end_exclusive)}
                <br />
                Next review date: {fmtDateOnly(tracking.next_audit_date)}
                {" · "}
                Credentials request date: {fmtDateOnly(tracking.request_creds_date)}
              </div>
              <div style={{ fontSize:11.5, color:T.muted, lineHeight:1.45, marginTop:8 }}>
                Activation preserves these dates. Review Complete remains the only review-consumption path.
              </div>
            </div>

            {blockers.length > 0 && (
              <div style={{ ...sectionStyle, borderColor:"rgba(225,77,87,0.45)", marginBottom:12 }}>
                <div style={labelStyle}>Blocked</div>
                <ul style={{ margin:"0 0 0 18px", padding:0, color:T.red, fontSize:12.5, lineHeight:1.55 }}>
                  {blockers.map(item => (
                    <li key={item.code || item.message}>{item.message || item.code}</li>
                  ))}
                </ul>
              </div>
            )}

            <div style={{ ...sectionStyle, marginBottom:12 }}>
              <div style={labelStyle}>Relevant countable completions</div>
              {completions.length === 0 ? (
                <div style={{ fontSize:12, color:T.muted }}>
                  No allowance-counting completions are in this preview.
                </div>
              ) : (
                <TableScroll>
                  <table style={{ width:"100%", borderCollapse:"collapse" }}>
                    <thead><tr>
                      <th style={th}>Date</th>
                      <th style={th}>Backfilled</th>
                      <th style={th}>Counts</th>
                    </tr></thead>
                    <tbody>
                      {completions.map(item => (
                        <tr key={item.completion_id || item.review_date}>
                          <td style={td}>{fmtDateOnly(item.review_date)}</td>
                          <td style={td}>{item.backfilled ? "Yes" : "No"}</td>
                          <td style={td}>{item.counts_toward_allowance ? "Yes" : "No"}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </TableScroll>
              )}
            </div>

            <div style={{ ...sectionStyle, marginBottom:12 }}>
              <label>
                <span style={labelStyle}>Required note</span>
                <textarea
                  maxLength={noteMax}
                  value={note}
                  onChange={e => {
                    setNote(e.target.value);
                    setPreview(null);
                    setMessage("");
                    setError("");
                  }}
                  style={{ ...inputStyle, minHeight:66, resize:"vertical" }}
                />
              </label>
              <div style={{ display:"flex", justifyContent:"flex-end", marginTop:10 }}>
                <Btn
                  pri
                  onClick={handlePreview}
                  disabled={!!actionBusy || !noteReady}
                >
                  {actionBusy === "preview" ? "Previewing…" : "Preview transition"}
                </Btn>
              </div>
            </div>

            {preview?.can_commit && (
              <div style={{ ...sectionStyle, borderColor:"rgba(68,166,255,.35)", marginBottom:12 }}>
                <div style={labelStyle}>Confirmation preview</div>
                <div style={{ fontSize:12.5, color:T.text, lineHeight:1.55 }}>
                  This creates one immutable transition seed with an opening balance of {allowanceMetricValue(allowance.opening_balance)}
                  {" "}and flips only Allowance Model to Banked.
                </div>
                <div style={{ fontSize:11.5, color:T.muted, lineHeight:1.45, marginTop:10 }}>
                  It preserves Next Review Date and Credentials Request Date, creates no Review Completion or Review Booking row, and exposes no transition metadata to customer-facing payloads.
                </div>
              </div>
            )}

            <div style={{ display:"flex", justifyContent:"flex-end", gap:8, flexWrap:"wrap" }}>
              <Btn onClick={onClose}>Close</Btn>
              <Btn
                pri
                onClick={handleCreate}
                disabled={!!actionBusy || !preview?.can_commit || !preview?.preview_hash}
              >
                {actionBusy === "create" ? "Recording…" : "Record Banked Transition"}
              </Btn>
            </div>
          </>
        ) : (
          <div style={{ fontSize:13, color:T.muted }}>
            No transition data loaded.
          </div>
        )}
      </div>
    </div>,
    document.body,
  );
};

const CustomerOperationsNotesDrawer = ({ target, onClose, onChanged }) => {
  const [result, setResult] = useState(null);
  const [noteText, setNoteText] = useState("");
  const [busy, setBusy] = useState(false);
  const busyRef = useRef(false);
  const [error, setError] = useState("");

  const normalize = (payload) => {
    if (!payload || typeof payload !== "object" || Array.isArray(payload)) return null;
    if (Object.keys(payload).sort().join(",") !== "notes,state") return null;
    if (!Array.isArray(payload.notes)) return null;
    if (payload.state === "empty" && payload.notes.length === 0) return payload;
    if (payload.state === "unavailable" && payload.notes.length === 0) return payload;
    if (payload.state !== "available" || payload.notes.length === 0) return null;
    const notesAreValid = payload.notes.every(note => {
      if (!note || typeof note !== "object" || Array.isArray(note)) return false;
      const keys = Object.keys(note).sort().join(",");
      const ordinary = keys === "added_by,created_on,kind,text" && note.kind === "ordinary";
      const action = keys === "added_by,created_on,handled_by,handled_on,kind,ref,resolved,text"
        && note.kind === "action" && typeof note.resolved === "boolean"
        && typeof note.ref === "string" && /^[0-9a-f]{64}$/.test(note.ref);
      if (!ordinary && !action) return false;
      if (action && ((note.resolved && (typeof note.handled_by !== "string" || !note.handled_by.trim()
          || typeof note.handled_on !== "string" || !note.handled_on.trim()
          || Number.isNaN(new Date(note.handled_on).getTime())))
          || (!note.resolved && (note.handled_by !== null || note.handled_on !== null)))) return false;
      return typeof note.text === "string" && !!note.text.trim()
        && typeof note.added_by === "string" && !!note.added_by.trim()
        && typeof note.created_on === "string" && !!note.created_on.trim()
        && !Number.isNaN(new Date(note.created_on).getTime());
    });
    return notesAreValid ? payload : null;
  };

  const load = useCallback(async () => {
    if (!target?.trackingId) return;
    setResult(null);
    setError("");
    try {
      const payload = normalize(await fetchCustomerOperationsNotes(target.trackingId));
      setResult(payload || { state:"unavailable", notes:[] });
    } catch (_) {
      setResult({ state:"unavailable", notes:[] });
    }
  }, [target?.trackingId]);

  useEffect(() => {
    if (target?.trackingId) load();
  }, [target?.trackingId, load]);

  if (!target) return null;
  const unavailable = result?.state === "unavailable";
  // History must be known-good before an append: while the initial request is
  // pending, a blank `result` is unknown rather than safely empty. This keeps
  // the client aligned with the server's fresh-read create gate.
  const notesReady = result?.state === "available" || result?.state === "empty";
  const canCreate = !!noteText.trim() && !busy && !unavailable && notesReady;
  const submit = async () => {
    if (!canCreate || busyRef.current) return;
    busyRef.current = true;
    setBusy(true);
    setError("");
    try {
      const created = await createCustomerOperationsNote(
        target.trackingId, noteText.trim());
      if (!created || created.action !== "created"
          || Object.keys(created).sort().join(",") !== "action") {
        throw new Error("Customer Operations Note creation was unavailable");
      }
      setNoteText("");
      await load();
      await onChanged?.();
    } catch (submitError) {
      setError(submitError?.message || "Could not add the note.");
    } finally {
      busyRef.current = false;
      setBusy(false);
    }
  };
  const handle = async (note) => {
    if (!note || note.kind !== "action" || note.resolved || busyRef.current) return;
    busyRef.current = true;
    setBusy(true); setError("");
    try {
      const outcome = await markCustomerOperationsNoteHandled(target.trackingId, note.ref);
      if (!outcome || !["handled", "already_handled"].includes(outcome.action)) throw new Error("Could not mark the note handled.");
      await load();
      await onChanged?.();
    } catch (handleError) { setError(handleError?.message || "Could not mark the note handled."); }
    finally { busyRef.current = false; setBusy(false); }
  };

  return (
    <div
      data-testid="customer-operations-notes-drawer-backdrop"
      onClick={() => { if (!busy) onClose(); }}
      style={{ position:"fixed", inset:0, zIndex:1000, background:"rgba(0,0,0,.36)" }}
    >
      <aside
        role="dialog"
        aria-modal="true"
        aria-label="Customer Operations Notes"
        data-testid="customer-operations-notes-drawer"
        onClick={event => event.stopPropagation()}
        style={{ position:"absolute", right:0, top:0, bottom:0, width:"min(460px, 94vw)",
                 overflowY:"auto", background:T.panel, borderLeft:`1px solid ${T.border}`,
                 boxShadow:"-12px 0 40px rgba(0,0,0,.35)", padding:24 }}
      >
        <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", gap:12 }}>
          <div>
            <h2 style={{ fontSize:18, margin:0 }}>Customer Operations Notes</h2>
            <div style={{ color:T.muted, fontSize:12, marginTop:4 }}>{target.customerName}</div>
          </div>
          <button
            type="button"
            aria-label="Close Customer Operations Notes"
            disabled={busy}
            onClick={onClose}
            style={{ border:"none", background:"none", color:T.text, cursor:"pointer", fontSize:22 }}
          >×</button>
        </div>

        <div style={{ marginTop:22, paddingBottom:18, borderBottom:`1px solid ${T.border}` }}>
          <label htmlFor="customer-operations-note-text" style={{ display:"block", fontSize:13, fontWeight:600, marginBottom:7 }}>
            Add Note
          </label>
          <textarea
            id="customer-operations-note-text"
            value={noteText}
            disabled={busy || unavailable || !notesReady}
            onChange={event => setNoteText(event.target.value)}
            maxLength={4000}
            rows={4}
            style={{ width:"100%", boxSizing:"border-box", resize:"vertical", padding:9,
                     borderRadius:8, border:`1px solid ${T.border}`, background:"rgba(0,0,0,.2)",
                     color:T.text, fontFamily:"inherit" }}
          />
          <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", marginTop:8, gap:10 }}>
            <span style={{ color:T.muted, fontSize:11 }}>{noteText.trim().length}/4000</span>
            <Btn pri onClick={submit} disabled={!canCreate}>{busy ? "Adding…" : "Add Note"}</Btn>
          </div>
          {unavailable && <div style={{ color:T.red, fontSize:12, marginTop:8 }}>Notes are unavailable. Refresh before adding a note.</div>}
          {error && <div role="alert" style={{ color:T.red, fontSize:12, marginTop:8 }}>{error}</div>}
        </div>

        <div style={{ marginTop:18 }}>
          {result === null ? <div style={{ color:T.muted, fontSize:13 }}>Loading notes…</div>
            : result.state === "empty" ? <div style={{ color:T.muted, fontSize:13 }}>No notes yet.</div>
              : result.state === "available" ? result.notes.map((note, index) => (
                <article key={`${note.created_on}-${index}`} data-testid="customer-operations-note" style={{ padding:"0 0 16px", marginBottom:16, borderBottom:`1px solid ${T.border}` }}>
                  <div style={{ whiteSpace:"pre-wrap", overflowWrap:"anywhere", fontSize:13 }}>{note.text}</div>
                  <div style={{ color:T.muted, fontSize:11, marginTop:8 }}>
                    Added by {note.added_by} · {fmtInstant(note.created_on)}
                  </div>
                  {note.kind === "action" && (note.resolved ? (
                    <div style={{ color:T.muted, fontSize:11, marginTop:8 }}>Handled by {note.handled_by} · {fmtInstant(note.handled_on)}</div>
                  ) : <Btn onClick={() => handle(note)} disabled={busy}>Mark handled</Btn>)}
                </article>
              )) : <div style={{ color:T.red, fontSize:13 }}>Notes are unavailable.</div>}
        </div>
      </aside>
    </div>
  );
};

// EXPORTED FOR TESTS — do not remove the export as "unused".
// AdminPage has no other importer by design (PortalShell renders it from
// this same module), but src/components/AdminPage.smoke.test.js mounts it
// per tab to prove each one RENDERS. That suite exists because a blank
// Reviews tab reached production in #494 and the same class of error
// nearly shipped again in #496: an identifier defined in the wrong
// component scope compiles cleanly, passes every unit test, and throws
// only at render. A build proves the file parses; it proves nothing
// about whether a name resolves. One export is the price of catching it.
export const AdminPage = ({ initialTab = null, initialView = null }) => {
  // In-page tabs. Deep-linkable via #/admin/{tab}: a valid initialTab (parsed
  // from the hash by the caller) lands directly on that tab; missing/invalid
  // falls back to the default. Selecting a tab rewrites the hash with
  // replaceState (no history spam) so the link is copyable.
  const [adminTab, setAdminTabState] = useState(
    initialTab && ADMIN_TABS.has(initialTab) ? initialTab : ADMIN_DEFAULT_TAB
  );
  // The inner view carries a THIRD hash segment (2026-08-11) so the
  // Assessments sub-views are bookmarkable. adminView is the CURRENT inner
  // view for whichever tab is open; the writer below appends it only when
  // the tab has inner views AND the value is not the section default, so
  // #/admin/reviews stays the canonical URL for the default and existing
  // bookmarks are never rewritten into something longer.
  const adminViewRef = useRef(initialView);
  const writeAdminHash = useCallback((tab, view) => {
    if (!ADMIN_TABS.has(tab)) return;
    // THE VIEW IS VALIDATED TOO (2026-08-11). This used to append whatever
    // string it was handed, so the dead section-toggle buttons in #531 wrote
    // #/admin/reviews/backlog — a shareable URL for a view that renders
    // nothing. An unknown view DROPS to the bare tab URL rather than
    // aborting the write: the tab part is still correct and still worth
    // making copyable, and the reader coerces the missing segment to the
    // section default anyway.
    const suffix = isValidAdminView(tab, view) ? `/${view}` : "";
    const url = `${window.location.pathname}${window.location.search}#/admin/${tab}${suffix}`;
    window.history.replaceState(window.history.state, "", url);
  }, []);
  const setAdminTab = useCallback((tab) => {
    // Guarded like the hash writer above and like the state initialiser at
    // :6481 — an unknown tab has no render branch, so setting it would blank
    // the page exactly the way an unknown VIEW did. Unreachable from the
    // PillToggle, whose eight option values are all in ADMIN_TABS; guarded
    // because "unreachable today" is what the section toggle was too.
    if (!ADMIN_TABS.has(tab)) return;
    setAdminTabState(tab);
    // Switching tabs drops any inner view — it belonged to the old tab. Still
    // correct with only two review views: the dropped value is replaced by
    // the reader's coercion to the section default, not carried across.
    adminViewRef.current = null;
    writeAdminHash(tab, null);
  }, [writeAdminHash]);

  // ── SecureScan365 — hosted scan engine proxy (Patriot-only) ──
  const [scanSlug, setScanSlug] = useState("");
  const scanSelectionRef = useRef({ slug: "", generation: 0 });
  const currentScanSelection = () => ({ ...scanSelectionRef.current });
  const isCurrentScanSelection = selection =>
    scanSelectionRef.current.slug === selection.slug
    && scanSelectionRef.current.generation === selection.generation;
  const showSelectedJourney = (selection, data) => {
    if (isCurrentScanSelection(selection)) {
      setSelectedJourney(data ? { ...data, _selection: selection } : null);
      if (data) setSelectedJourneyError(null);
    }
  };
  const showSelectedJourneyError = (selection, message) => {
    if (isCurrentScanSelection(selection))
      setSelectedJourneyError(message ? { ...selection, message } : null);
  };
  // 503 scan_engine_not_configured from the backend: engine credentials
  // (SA_V2_* app settings) aren't wired up yet. Renders the pending
  // placeholder instead of the picker/table; polling stays quiet.
  const [scanEngineNotConfigured, setScanEngineNotConfigured] = useState(false);
  const [scanUsers, setScanUsers] = useState(null);       // null = not searched yet
  const [scanUsersLoading, setScanUsersLoading] = useState(false);
  const [scanUsersError, setScanUsersError] = useState(false);
  const [scanUpn, setScanUpn] = useState("");
  const [scanStarting, setScanStarting] = useState(false);
  const [scanStartMsg, setScanStartMsg] = useState(null); // null | {ok, text}
  const [selectedJourney, setSelectedJourney] = useState(null);
  const [selectedJourneyError, setSelectedJourneyError] = useState(null);
  const [recoveryPreview, setRecoveryPreview] = useState(null);
  const [recoveryReason, setRecoveryReason] = useState("");
  const [recoveryOperation, setRecoveryOperation] = useState(null);
  const [recoveryBusy, setRecoveryBusy] = useState(false);
  const [recoveryMessage, setRecoveryMessage] = useState("");
  const visibleSelectedJourney = selectedJourney?._selection?.slug === scanSlug
    && selectedJourney?._selection?.generation === scanSelectionRef.current.generation
    ? selectedJourney : null;
  const visibleSelectedJourneyError = selectedJourneyError?.slug === scanSlug
    && selectedJourneyError?.generation === scanSelectionRef.current.generation
    ? selectedJourneyError.message : "";
  const visibleRecoveryPreview = recoveryPreview?._selection?.slug === scanSlug
    && recoveryPreview?._selection?.generation === scanSelectionRef.current.generation
    ? recoveryPreview : null;
  const visibleRecoveryOperation = recoveryOperation?.slug === scanSlug
    && recoveryOperation?._selection?.generation === scanSelectionRef.current.generation
    ? recoveryOperation : null;
  // Start Assessment popup: the pipeline choice. autoSend defaults TRUE —
  // auto-send is the intended path and the manual one is the exception.
  const [startModal, setStartModal] = useState(false);
  const [startPreflight, setStartPreflight] = useState(null);
  const [startPreflightLoading, setStartPreflightLoading] = useState(false);
  const [startPreflightError, setStartPreflightError] = useState("");
  const [startAutoSend, setStartAutoSend] = useState(true);
  const [startManualArmed, setStartManualArmed] = useState(false);
  // Orphans a stale preflight response if the operator closes and reopens.
  const startPreflightSeq = useRef(0);
  // Prerequisites check — start → poll status → fetch result, display only
  // (nothing persists to Dataverse). prereqPhase doubles as the busy flag.
  const [prereqPhase, setPrereqPhase] = useState("");     // "" | "starting" | "waiting" | "loading"
  const [prereqResult, setPrereqResult] = useState(null); // normalized payload from the backend
  const [prereqError, setPrereqError] = useState("");
  const [prereqUpn, setPrereqUpn] = useState("");         // UPN the shown result belongs to
  // Monotonic sequence: bumping it orphans any in-flight poll chain (slug
  // change, re-check, unmount) so a stale run can't write state.
  const prereqSeq = useRef(0);
  const [scanRuns, setScanRuns] = useState(null);         // null = loading
  const [scanRunsError, setScanRunsError] = useState(false);
  const [scanRunsRefresh, setScanRunsRefresh] = useState(0);
  // Paging: the engine's cursor is opaque and round-trips verbatim.
  // scanRunsCursor is the cursor for the NEXT page (null = end of history,
  // or nobody has paged yet and the first page said there is no more).
  const [scanRunsCursor, setScanRunsCursor] = useState(null);
  const [scanRunsLoadingMore, setScanRunsLoadingMore] = useState(false);
  const [scanRunsMoreError, setScanRunsMoreError] = useState(false);
  // Run-kind filter: "all" | assessment | check | unclassified.
  const [scanRunKindFilter, setScanRunKindFilter] = useState("all");
  const [scanResultBusy, setScanResultBusy] = useState(""); // run_id being downloaded
  const [scanResultError, setScanResultError] = useState("");
  // Weekly management report download (Assessments header).
  const [weeklyReportBusy, setWeeklyReportBusy] = useState(false);
  const [weeklyReportError, setWeeklyReportError] = useState(false);
  const [groupDiscovery, setGroupDiscovery] = useState(null);
  const [groupDiscoveryBusy, setGroupDiscoveryBusy] = useState(false);
  const [groupDiscoveryError, setGroupDiscoveryError] = useState(false);
  const groupDiscoveryPolls = useRef(0);
  // Send-to-scoring per-row state, keyed by run_id:
  //   sendState[runId] = "confirm" | "sending" | {sent:true, slug} | {error}
  const [sendState, setSendState] = useState({});
  const [incomingQueued, setIncomingQueued] = useState({}); // { slug: count } — transient "queued for ingest"
  // Interval callbacks read the latest runs through a ref so the poll
  // effect doesn't have to re-subscribe (and reset its timer) every fetch.
  const scanRunsRef = useRef(null);
  // True once the operator has loaded a page beyond the first — the 15s
  // poll stands down rather than replacing their history with page 1.
  const scanRunsPagedRef = useRef(false);

  useEffect(() => {
    let active = true;
    fetchFreshserviceGroupDiscovery()
      .then(status => { if (active) { setGroupDiscovery(status); setGroupDiscoveryError(false); } })
      .catch(() => { if (active) setGroupDiscovery({ state:"unavailable", downloadable:false }); });
    return () => { active = false; };
  }, []);

  useEffect(() => {
    if (!["waiting", "preparing"].includes(groupDiscovery?.state)) return undefined;
    let active = true;
    let inFlight = false;
    const interval = window.setInterval(() => {
      if (inFlight) return;
      if (groupDiscoveryPolls.current >= 240) {
        setGroupDiscovery({ state:"unavailable", downloadable:false });
        return;
      }
      groupDiscoveryPolls.current += 1;
      inFlight = true;
      fetchFreshserviceGroupDiscovery()
        .then(status => { if (active) { setGroupDiscovery(status); setGroupDiscoveryError(false); } })
        .catch(() => { if (active) setGroupDiscoveryError(true); })
        .finally(() => { inFlight = false; });
    }, 30000);
    return () => { active = false; window.clearInterval(interval); };
  }, [groupDiscovery?.state]);

  // ── Publishing (Review Queue) ──
  const [queue, setQueue] = useState(null);          // pending[] from /review-queue
  // Bumped after a successful Publish/Reject from a queue row. A publish
  // also clears the customer's SUPERSEDED holds server-side (ADR-0088
  // D-a), so dropping only the clicked row would leave siblings on
  // screen that no longer exist. Refetching is the only client-side
  // answer that cannot drift from the server's supersession rule —
  // re-deriving which siblings died would mean a second copy of that
  // rule in JS, which is exactly what ADR-0088 works to avoid.
  const [queueRefreshKey, setQueueRefreshKey] = useState(0);
  const [clientsById, setClientsById] = useState({}); // customer_id (= slug) → name

  // ── Licensing tab state — per-customer stored snapshot, fetched on
  //    selection (no fleet fan-out; that is PR3's problem) ──
  const [licSlug, setLicSlug] = useState("");
  const [licData, setLicData] = useState(null);
  const [licLoading, setLicLoading] = useState(false);
  const [licError, setLicError] = useState("");
  const [licSort, setLicSort] = useState({ key: "assigned", dir: "desc" });

  const loadLicenseInventory = async (slug) => {
    setLicSlug(slug);
    setLicData(null); setLicError("");
    if (!slug) return;
    setLicLoading(true);
    try {
      const data = await fetchLicenseInventory(slug);
      setLicData(data);
    } catch (e) {
      setLicError(`Couldn't load the license inventory. Please try again.${e?.body?.error ? ` (${e.body.error})` : ""}`);
    } finally {
      setLicLoading(false);
    }
  };

  const licSortBy = (key) => {
    setLicSort(s => s.key === key
      ? { key, dir: s.dir === "desc" ? "asc" : "desc" }
      // Numeric columns land descending first, text columns ascending.
      : { key, dir: (key === "product" || key === "status") ? "asc" : "desc" });
  };
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  // ── Logins — per-customer summary, expandable roster ──
  const [summary, setSummary] = useState(null);       // null = loading
  const [summaryError, setSummaryError] = useState(false);
  const [loginSort, setLoginSort] = useState("newest");
  const [loginSearch, setLoginSearch] = useState(""); // client-side filter; this tab only
  // Scope toggle: default = customers the portal serves (backend
  // scope=entitled, which keeps lapsed-with-active customers visible);
  // "all" = the full pc_customers universe — the escape hatch.
  const [loginShowAll, setLoginShowAll] = useState(false);
  // "entitled" | "all" | "all_fallback" from the payload — all_fallback
  // means the entitlement read failed and the backend failed OPEN.
  const [loginScopeApplied, setLoginScopeApplied] = useState(null);
  // Expanded roster row: reuses fetchAccessList(slug) on demand, one
  // expansion at a time. last_login is on every access_list response;
  // login_count is Patriot-only, and this page sits behind the Admin gate.
  const [rosterSlug, setRosterSlug] = useState("");
  const [roster, setRoster] = useState(null);          // null = loading (when a row is expanded)
  const [rosterError, setRosterError] = useState(false);

  // ── Access — pending requests with Approve/Deny actions. The backend
  // runs Graph FIRST (invite if absent → group add) and flips the
  // Dataverse row LAST, so a status flip can never land before the Entra
  // group add — the ordering constraint that kept v1 view-only. ──
  const [pendingAccess, setPendingAccess] = useState(null); // null = loading
  const [pendingAccessError, setPendingAccessError] = useState(false);
  const [pendingAccessRefresh, setPendingAccessRefresh] = useState(0);
  // Confirm-then-act (roster Disable idiom): {row, action:"approve"|"deny"}
  const [decisionTarget, setDecisionTarget] = useState(null);
  // Row ids with a decision in flight — per-row busy, other rows stay live.
  const [decisionBusyIds, setDecisionBusyIds] = useState(() => new Set());
  // Session log of decisions, newest first: {key, email, ok, label}
  const [decisionLog, setDecisionLog] = useState([]);
  // Deny reason — required, customer-visible (lands in pc_statusreason,
  // max 500). Reset every time the deny modal opens.
  const [denyReason, setDenyReason] = useState("");
  const [denyReasonError, setDenyReasonError] = useState(false);

  // ── Access — lifecycle history (all statuses, below the Pending
  // queue). Fetch is independent of the pending fetch so a lifecycle
  // error never breaks the queue. ──
  const [accessLifecycle, setAccessLifecycle] = useState(null); // null = loading
  const [accessLifecycleError, setAccessLifecycleError] = useState(false);
  const [accessStatusFilter, setAccessStatusFilter] = useState("active"); // stable status_key or "all"
  const [accessSearch, setAccessSearch] = useState("");
  const [accessSort, setAccessSort] = useState("requested"); // requested | decided | customer
  const [accessShowAll, setAccessShowAll] = useState(false);

  // ── Scanning — fleet scan-ops rollout list + per-row edit layer ──
  const [scanSummary, setScanSummary] = useState(null);   // null = not loaded yet
  const [scanSummaryError, setScanSummaryError] = useState(false);
  const [scanToolFilter, setScanToolFilter] = useState("all");
  const [scanElevatedFilter, setScanElevatedFilter] = useState("all"); // all | fabric | hybrid | both | neither
  const [scanSearch, setScanSearch] = useState("");       // client-side filter; this tab only
  const [scanEditTarget, setScanEditTarget] = useState(null);
  const [scanEditToolKey, setScanEditToolKey] = useState("");
  const [scanEditAuthKey, setScanEditAuthKey] = useState("");
  const [scanEditMigDate, setScanEditMigDate] = useState("");
  const [scanEditFabric, setScanEditFabric] = useState(false);
  const [scanEditHybrid, setScanEditHybrid] = useState(false);
  const [scanEditNotesBody, setScanEditNotesBody] = useState("");
  const [scanEditNotesLoading, setScanEditNotesLoading] = useState(false);
  const [scanEditNote, setScanEditNote] = useState("");
  const [scanEditBusyId, setScanEditBusyId] = useState("");
  const [scanEditError, setScanEditError] = useState("");

  // ── Reviews (Admin Ops) — READ-ONLY Phase A of SPEC-admin-ops-review-view.
  // Four views over data that already exists: backlog, approaching,
  // completed-by-engineer, volume. Nothing on this tab writes: no status
  // change, no date edit, no action. Status WRITING and the date behaviour
  // that must accompany it are Phase B and ship together or not at all. ──
  const [reviewOps, setReviewOps] = useState(null);   // null = not loaded yet
  const [reviewOpsError, setReviewOpsError] = useState(false);
  const [reviewOpsLoading, setReviewOpsLoading] = useState(false);
  // Scheduling All only. The server revalidates this opaque Tracking id
  // against its own Review Ops fleet before the drawer may read or create.
  const [customerOperationsNoteTarget, setCustomerOperationsNoteTarget] = useState(null);
  // ── Customer Management (its own tab since 2026-08-14) — READ-ONLY ──
  // Its own state because its own endpoint: the default universe is current
  // clients only, with a separate inactive/history opt-in. The rows carry term
  // fields the review-ops read does not select. The row action opens Record
  // Renewal: preview first, then the PR3 Schedule/Activate/Void controls.
  const [custMgmt, setCustMgmt] = useState(null);     // null = not loaded yet
  const [custMgmtError, setCustMgmtError] = useState(false);
  const [mgmtLens, setMgmtLens] = useState("contract");
  const [requestManagementBusy, setRequestManagementBusy] = useState(false);
  const requestManagementCount = useAutoRenewManagementCount(adminTab === "management");
  const [reviewCadence, setReviewCadence] = useState(null);
  const [reviewCadenceError, setReviewCadenceError] = useState(false);
  // ── Customer detail drawer (docs/plans/customer-detail-view.md) ──
  // { slug, navSlugs, fallbackName, origin } or null. navSlugs is the slug
  // list of the table it was opened from (null for a deep link) — slugs, not
  // rows, so a quiet refresh cannot reorder a list mid-step. A ?customer=
  // deep link is read ONCE here; AdminPage is internal-only, so no customer
  // session ever reads it.
  const [customerDrawer, setCustomerDrawerState] = useState(() => {
    const slug = new URLSearchParams(window.location.search).get("customer");
    return slug ? { slug, navSlugs:null, fallbackName:null, origin:"deeplink" } : null;
  });
  // The drawer's OWN load states, never custMgmtError / reviewCadenceError:
  // the Customer Data lens has no retry path, so a drawer failure written
  // there would blank the tab until reload. "idle" | "loading" | "error".
  const [drawerMgmtLoad, setDrawerMgmtLoad] = useState("idle");
  const [drawerCadenceLoad, setDrawerCadenceLoad] = useState("idle");
  // Inactive-scope payloads for a slug the default scope does not carry (a
  // Pending customer opened from Scheduling). Drawer-local, never written to
  // tab state, so the tab's checkbox scope stays true.
  const [wideMgmt, setWideMgmt] = useState({ status:"idle", data:null });
  const [wideCadence, setWideCadence] = useState({ status:"idle", data:null });
  const drawerTriggerRef = useRef(null);
  // Bumped on every new drawer session. An inactive-scope read captures it
  // at start and drops its result — success or failure — if the session has
  // moved on, the allowance-history loadSeq guard applied to the fallback.
  const drawerSessionRef = useRef(0);
  // Every open, step and close goes through here. The URL is written BEFORE
  // state, so no render after a close sees a stale ?customer= — the
  // dashboard hrefs elsewhere on the page copy every param. history.state
  // is preserved so the page→history ssPage entry survives.
  const setDrawer = useCallback((next) => {
    const url = new URL(window.location.href);
    if (next) url.searchParams.set("customer", next.slug);
    else url.searchParams.delete("customer");
    window.history.replaceState(window.history.state, "",
      `${url.pathname}${url.search}${url.hash}`);
    setCustomerDrawerState(next);
  }, []);
  const resetDrawerSession = () => {
    drawerSessionRef.current += 1;
    setDrawerMgmtLoad("idle");
    setDrawerCadenceLoad("idle");
    setWideMgmt({ status:"idle", data:null });
    setWideCadence({ status:"idle", data:null });
  };
  const openCustomerDrawer = (slug, navSlugs, fallbackName, origin, trigger) => {
    if (!customerDrawer) resetDrawerSession();
    drawerTriggerRef.current = trigger || null;
    setDrawer({ slug, navSlugs, fallbackName:fallbackName || null, origin });
  };
  const closeCustomerDrawer = useCallback(() => {
    setDrawer(null);
  }, [setDrawer]);
  // A PLAIN primary click opens the drawer. Cmd/ctrl/shift/alt/middle click
  // falls through to the anchor's native new tab on the dashboard, exactly
  // as before, and Enter on a focused link fires a button-0 click.
  const handleCustomerNameClick = (e, slug, fallbackName, navSlugs, origin) => {
    if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey
        || e.defaultPrevented) return;
    e.preventDefault();
    openCustomerDrawer(slug, navSlugs, fallbackName, origin, e.currentTarget);
  };
  // reviewRowTable's onOpenCustomer: the table hands back its own rows, so
  // prev/next follow exactly the filtered, sorted list on screen.
  const openSchedulingCustomer = (e, r, rows) => handleCustomerNameClick(
    e, r.slug, r.customer_name, rows.map(x => x.slug), "scheduling");
  const [renewalPreviewRow, setRenewalPreviewRow] = useState(null);
  const [contractChangeRow, setContractChangeRow] = useState(null);
  const [allowanceAdjustmentRow, setAllowanceAdjustmentRow] = useState(null);
  const [allowanceTransitionRow, setAllowanceTransitionRow] = useState(null);
  const [cadenceStateFilter, setCadenceStateFilter] = useState("all");
  const [mgmtSearch, setMgmtSearch] = useState("");
  const [mgmtShowInactive, setMgmtShowInactive] = useState(false);
  // The badge's click-through: show only the rows that need fixing.
  const [mgmtProblemsOnly, setMgmtProblemsOnly] = useState(false);
  const [mgmtContractAction, setMgmtContractAction] = useState("");
  const [mgmtFiltersOpen, setMgmtFiltersOpen] = useState(false);
  const [mgmtAboutOpen, setMgmtAboutOpen] = useState(false);
  const [mgmtActionsOpenSlug, setMgmtActionsOpenSlug] = useState("");
  const mgmtActionTriggerRefs = useRef(new Map());
  const closeMgmtActions = (restoreFocus = false) => {
    const slug = mgmtActionsOpenSlug;
    setMgmtActionsOpenSlug("");
    if (restoreFocus) mgmtActionTriggerRefs.current.get(slug)?.focus();
  };
  const mgmtFiltersTriggerRef = React.useRef(null);
  const mgmtFiltersPanelRef = React.useRef(null);
  const toggleMgmtContractAction = (value) => setMgmtContractAction(prev => (
    prev === value ? "" : value
  ));
  // Facet cards — at most ONE active value per group, and the groups
  // compose into an intersection (Gold ∩ Ongoing ∩ auto-renew-blank). One
  // object rather than three states so "clear everything" is one write and
  // the memo has one dependency.
  const [mgmtFacets, setMgmtFacets] = useState({});
  const toggleMgmtFacet = (group, value) => setMgmtFacets(prev => (
    prev?.[group] === value
      ? { ...prev, [group]: null }        // clicking the active card clears it
      : { ...prev, [group]: value }
  ));
  // Sort, persisted through the same best-effort helper as the Scheduling
  // row sort and COERCED on read (#532's lesson: a stored value is
  // user-writable and outlives the release that wrote it). "" is the
  // server's triage order and stays the default.
  const [mgmtSort, setMgmtSortState] = useState(
    () => coerceManagementSort(loadRowSort(MGMT_SORT_VIEW)),
  );
  const setMgmtSort = (raw) => {
    const value = coerceManagementSort(raw);
    saveRowSort(MGMT_SORT_VIEW, value);   // the COERCED value is what persists
    setMgmtSortState(value);
  };
  // Seeded from the third hash segment when there is one, so
  // #/admin/reviews/recorded lands on Delivery. An absent or unrecognised
  // segment falls back to the default — never a blank panel.
  //
  // The validity rule was inlined here and NOWHERE ELSE, which is how #531
  // shipped a writer that set values this reader would have rejected. It is
  // now coerceReviewView, used by the reader AND the setter below, and
  // exported so the tests check the same set the component does.
  const [reviewView, setReviewViewState] = useState(
    () => coerceReviewView(initialView));   // scheduling|recorded
  const setReviewView = (rawView) => {
    const view = coerceReviewView(rawView);
    setReviewViewState(view);
    adminViewRef.current = view;
    // "scheduling" is the section default, so it is written as the bare
    // #/admin/reviews — the URL an existing bookmark already holds.
    writeAdminHash("reviews", view === "scheduling" ? null : view);
  };
  // Which Scan Queue pill is open — Prereq issues / In progress / Held for
  // review. LOCAL STATE, NOT ROUTED: the pills are a filter inside the
  // scanqueue view, not a fourth hash segment, so #/admin/reviews/scanqueue
  // stays the deep link and adminTabFromHash is untouched (design §6 / R2).
  // Defaults to "prereq" — the first pill and the top of the engineers' day.
  const [scanQueuePill, setScanQueuePill] = useState("prereq");
  // Scheduling filter (2026-08-11). Backlog + Approaching merged into one
  // view; this replaces the two tabs. DEFAULTS TO BACKLOG so the landing
  // experience is identical to the old Backlog tab — "all" is opt-in,
  // because it is 177 rows and the two tabs it replaces already showed
  // exactly those rows between them. Persisted per user via the same
  // best-effort localStorage helper as the row sort.
  //
  // COERCED, both on the way in and on the way out (2026-08-11), the same
  // shape of fix as coerceReviewView. The stored value is user-writable
  // (localStorage survives restarts, and a stale key outlives the release
  // that wrote it), and SCHEDULING_FILTERS has been the exported list of
  // valid keys since the merge with nothing reading it.
  //
  // This one FAILED SOFT, not blank: an unrecognised key falls past
  // filterScheduling's backlog and approaching cases into the combined
  // branch, so the panel silently showed the whole default universe with no
  // pill appearing selected. Characterized before the change in
  // AdminPage.reviewViews.test.js.
  const coerceSchedulingFilter = (value) =>
    SCHEDULING_FILTERS.includes(value) ? value : SCHEDULING_DEFAULT_FILTER;
  const [schedulingFilter, setSchedulingFilterState] = useState(
    () => coerceSchedulingFilter(loadRowSort("schedulingFilter")),
  );
  const setSchedulingFilter = (rawValue) => {
    const value = coerceSchedulingFilter(rawValue);
    // The COERCED value is what gets persisted, so a bad value cannot
    // survive in storage to be re-read on the next mount.
    saveRowSort("schedulingFilter", value);
    setSchedulingFilterState(value);
  };
  // "Include On Hold" — a convenience on the ALL view only, widening that
  // view's universe to carry On Hold + Pending rows inline. The separate
  // "On Hold + Pending" pill is untouched; this is a second way in, not a
  // replacement. Persisted through the same best-effort localStorage helper
  // as the sort and the filter, and COERCED on read (#532's lesson): a
  // stored value is user-writable and outlives the release that wrote it,
  // so it is read as a strict "true" string and never trusted as a seed.
  const [includeOnHold, setIncludeOnHoldState] = useState(
    () => loadRowSort("schedulingIncludeOnHold") === "true",
  );
  const setIncludeOnHold = (value) => {
    const next = !!value;
    saveRowSort("schedulingIncludeOnHold", next ? "true" : "");
    setIncludeOnHoldState(next);
  };
  // The widening applies to the All view ALONE, so every count and list on
  // the page derives it from one place rather than each repeating the rule.
  // The BOOLEAN is what the memo dependency arrays key on — the options
  // object is a fresh reference every render and would defeat them.
  const includeOnHoldActive = schedulingFilter === "all" && includeOnHold;
  const schedulingOpts = { includeOnHold: includeOnHoldActive };
  // This is deliberately ephemeral. Leaving All pauses the filter without
  // throwing away an operator's checked state if they return during this mount.
  const [unresolvedNotesOnly, setUnresolvedNotesOnly] = useState(false);
  const unresolvedNotesOnlyActive = reviewView === "scheduling"
    && schedulingFilter === "all" && unresolvedNotesOnly;
  const [reviewSearch, setReviewSearch] = useState("");
  const reviewSearchInputRef = useRef(null);
  // Booking readiness filter — applies to Backlog, Approaching AND the
  // grace section (one state so the three cannot disagree).
  const [readyOnly, setReadyOnly] = useState(false);
  // Readiness / scan-method / allowance-model filter chips (Amber,
  // 2026-08-13; allowance added 2026-08-30). DISPLAY ONLY:
  // they narrow the main Scheduling list and change no count, no badge and
  // no other view. Restored from localStorage through the same best-effort
  // helper as the sort and the bucket filter, and COERCED on read — a stored
  // value is user-writable and outlives the release that wrote it.
  const [schedulingChips, setSchedulingChipsState] = useState(
    () => loadSchedulingChips(),
  );
  const setSchedulingChips = (next) => {
    saveSchedulingChips(next);
    setSchedulingChipsState(next);
  };
  const toggleChip = (group, key) =>
    setSchedulingChips(toggleSchedulingChip(schedulingChips, group, key));
  const clearChips = () => {
    setSchedulingChips(EMPTY_SCHEDULING_CHIPS);
    setBookingChips([]);
    setUnresolvedNotesOnly(false);
  };
  // BOOKING-LEDGER CHIPS (booking-allowance-model §9), kept as their OWN
  // state rather than folded into schedulingChips. They are a request-status
  // attention surface, not a stable row facet like readiness/method/allowance;
  // deliberately NOT persisted in v1 — an attention surface that silently
  // starts filtered on the next page load is how a missed request stays
  // missed.
  const [bookingChips, setBookingChips] = useState([]);
  const toggleBookingChip = (key) => setBookingChips(
    bookingChips.includes(key)
      ? bookingChips.filter(k => k !== key)
      : [...bookingChips, key],
  );
  const chipsActive = anySchedulingChipActive(schedulingChips)
    || bookingChips.length > 0;
  const schedulingFiltersActive = chipsActive || unresolvedNotesOnlyActive;
  // Expired-but-entitled banner's click-to-filter (same three lists).
  const [expiredOnly, setExpiredOnly] = useState(false);
  // Unrecorded-review banner's click-to-filter (same three lists).
  const [unrecordedOnly, setUnrecordedOnly] = useState(false);
  // Row sort per tab (2026-08-10), restored from localStorage so the
  // choice survives a reload. "" = the server order, unchanged default.
  const [rowSortByView, setRowSortByView] = useState(() => ({
    backlog: loadRowSort("backlog"),
    approaching: loadRowSort("approaching"),
  }));
  // The bucket the Scheduling filter is focused on, or null for the
  // combined "all" and status views.
  //
  // WHERE THE BACKLOG/APPROACHING DISTINCTION LIVES, since it moved once and
  // the old comment here described the move rather than the result:
  // reviewView holds ONLY "scheduling" or "recorded" — which SECTION is
  // open. Which bucket the Scheduling section is focused on is
  // schedulingFilter, and this derived value is the answer for the things
  // that need a single focused bucket: the cards, the grace section and the
  // overdue column belong to a bucket, not to a view.
  const schedulingBucket =
    reviewView !== "scheduling" ? null
      : (schedulingFilter === "backlog" || schedulingFilter === "approaching")
        ? schedulingFilter
        : null;
  // Row sort still keys on the BUCKET, so a Backlog sort and an Approaching
  // sort stay independent exactly as they were before the merge.
  const rowSortKey = schedulingBucket || reviewView;
  const rowSort = rowSortByView[rowSortKey] || "";
  const setRowSort = (value) => {
    saveRowSort(rowSortKey, value);
    setRowSortByView(m => ({ ...m, [rowSortKey]: value }));
  };
  // Backlog severity band ("" = Total, no band filter) and the
  // approaching horizon card selection. Both are card-driven filters,
  // the same interaction as the engineer cards on Recorded.
  const [reviewBand, setReviewBand] = useState("");
  // Phase A.5 status write. `statusEdit` is the row currently being
  // edited ({slug, statusValue, date}); `statusConfirm` is the pending
  // change awaiting confirmation (null when the status moves no date —
  // those write immediately, because a confirm on a harmless change
  // trains her to click through the two that matter).
  const [statusEdit, setStatusEdit] = useState(null);
  const [statusConfirm, setStatusConfirm] = useState(null);
  const [statusBusySlug, setStatusBusySlug] = useState("");
  const [statusError, setStatusError] = useState(null);
  // ── "Run prereq check" per row (2026-08-14) ──
  // slug -> {phase: "checking"|"done", outcome, error}. Keyed by SLUG so
  // several rows can be checking at once and one row's result never lands
  // on another's — the same per-row-busy-key idiom the status write uses.
  // Transient by design: nothing here is persisted, and the authoritative
  // answer is the workflow status the automation writes, which arrives on
  // the next fleet read.
  const [rowPrereq, setRowPrereq] = useState({});
  const rowPrereqSeq = useRef({});
  // Customer-requested skip. `skipTarget` is the row whose dialog is
  // open; context + access list are fetched on demand when it opens.
  const [skipTarget, setSkipTarget] = useState(null);
  const [skipContext, setSkipContext] = useState(null);
  const [skipAccess, setSkipAccess] = useState(null);
  const [skipSelection, setSkipSelection] = useState("");
  const [skipOtherText, setSkipOtherText] = useState("");
  const [skipBusy, setSkipBusy] = useState(false);
  const [skipError, setSkipError] = useState(null);
  const [skipResult, setSkipResult] = useState(null);
  const [skipPendingDate, setSkipPendingDate] = useState(null);
  const [skipPendingError, setSkipPendingError] = useState(null);
  // Recorded LIST only — the engineer cards exclude skips server-side,
  // absolutely, so no UI state can make a card dishonest.
  const [includeSkips, setIncludeSkips] = useState(false);
  const [reviewHorizon, setReviewHorizon] = useState("all");
  // Recorded-reviews list: reviewer filter, free text, and column sort.
  // null sort = the server order (review date desc) — "what happened this
  // week", the default question the view answers.
  const [reviewReviewer, setReviewReviewer] = useState("");
  const [reviewListSearch, setReviewListSearch] = useState("");
  const [reviewSort, setReviewSort] = useState(null);
  // Range for the engineer/volume views. Empty = the backend default (the
  // last 7 days ending today); the fields fill in from the response so the
  // operator always sees the dates actually in force.
  const [reviewStart, setReviewStart] = useState("");
  const [reviewEnd, setReviewEnd] = useState("");
  // Bumped by "Apply" — the ONLY thing that re-issues the range query, so
  // typing a date does not fire a request per keystroke.
  const [reviewRangeNonce, setReviewRangeNonce] = useState(0);
  const openCustomerOperationsNotes = (row) => {
    if (!row || typeof row.tracking_id !== "string" || !row.tracking_id.trim()) return;
    setCustomerOperationsNoteTarget({
      trackingId: row.tracking_id,
      customerName: row.customer_name || row.slug || "Customer",
      slug: row.slug,
    });
  };
  // The event listeners below intentionally subscribe only once per tab
  // visit. Keep every decision they make current without re-subscribing on
  // typing, dialog state, or a row write.
  const reviewOpsRefreshContextRef = useRef({});
  const reviewOpsRefreshInFlightRef = useRef(0);
  const reviewOpsRefreshRequestRef = useRef(0);
  const reviewOpsRefreshGenerationRef = useRef(0);
  const reviewOpsRefreshLastAtRef = useRef(0);
  const reviewOpsAppliedRangeRef = useRef({ start: undefined, end: undefined, nonce: 0 });
  reviewOpsRefreshContextRef.current = {
    adminTab,
    reviewOps,
    reviewOpsLoading,
    statusEdit,
    statusConfirm,
    statusBusySlug,
  };

  // A quiet read is only allowed to settle in the Assessments visit and
  // interaction state that started it. Primary loads, tab exits, and status
  // interactions take ownership of the rows from any earlier quiet request.
  const invalidateReviewOpsQuietRefresh = useCallback(() => {
    reviewOpsRefreshGenerationRef.current += 1;
    reviewOpsRefreshInFlightRef.current = 0;
    reviewOpsRefreshLastAtRef.current = 0;
  }, []);

  const refreshReviewOpsOnReturn = useCallback(() => {
    const context = reviewOpsRefreshContextRef.current;
    if (
      context.adminTab !== "reviews"
      || !context.reviewOps
      || context.reviewOpsLoading
      || context.statusEdit
      || context.statusConfirm
      || context.statusBusySlug
      || reviewOpsRefreshInFlightRef.current
    ) return;

    const now = Date.now();
    if (now - reviewOpsRefreshLastAtRef.current < REVIEW_OPS_RETURN_REFRESH_MIN_INTERVAL_MS) return;

    const requestedRange = reviewOpsAppliedRangeRef.current;
    const generation = reviewOpsRefreshGenerationRef.current;
    const requestId = ++reviewOpsRefreshRequestRef.current;
    reviewOpsRefreshInFlightRef.current = requestId;
    reviewOpsRefreshLastAtRef.current = now;
    fetchReviewOps({ start: requestedRange.start, end: requestedRange.end })
      .then(d => {
        const latest = reviewOpsRefreshContextRef.current;
        // An Apply, a new Assessments visit, or an active status interaction
        // takes precedence over a quiet read that started before it.
        if (
          reviewOpsRefreshGenerationRef.current !== generation
          || reviewOpsRefreshInFlightRef.current !== requestId
          || reviewOpsAppliedRangeRef.current.nonce !== requestedRange.nonce
          || latest.adminTab !== "reviews"
          || !latest.reviewOps
          || latest.reviewOpsLoading
          || latest.statusEdit
          || latest.statusConfirm
          || latest.statusBusySlug
        ) return;
        setReviewOps(prev => {
          if (!prev) return prev;
          const next = {
            ...prev,
            customers: Array.isArray(d?.customers) ? d.customers : prev.customers,
          };
          if (d?.meta) next.meta = d.meta;
          return next;
        });
      })
      .catch(() => {
        // This is a display-only catch-up. Preserve the visible rows and let
        // the next return event retry rather than presenting a false alarm.
        if (reviewOpsRefreshInFlightRef.current === requestId) {
          reviewOpsRefreshLastAtRef.current = 0;
        }
      })
      .finally(() => {
        if (reviewOpsRefreshInFlightRef.current === requestId) {
          reviewOpsRefreshInFlightRef.current = 0;
        }
      });
  }, []);

  // ── Primary Contacts — one row per active customer, derived from the
  // lifecycle rows (primary/status/last_login) joined against the client
  // list (so zero-roster customers appear as gaps). ──
  const [clientList, setClientList] = useState(null); // full /clients rows
  // Entitled-customer universe (tracking-status rule): slugs from the
  // lifecycle payload. null = unavailable (older backend / tracking-read
  // hiccup) → the view falls back to the unfiltered customer list rather
  // than rendering empty.
  const [entitledSlugs, setEntitledSlugs] = useState(null);
  // Customers with Active portal users but no portal service — the
  // lapsed-with-active gap class (zero measured 2026-08-01; this is the
  // insurance that a future lapse stays visible instead of vanishing
  // from the entitled-scoped views). null = unavailable.
  const [lapsedActiveSlugs, setLapsedActiveSlugs] = useState(null);
  const [contactSearch, setContactSearch] = useState("");
  // Three-way view, defaulting to the rows James actually mails — the
  // gap pile (hundreds until the customer-status rule lands) stays one
  // click away instead of being the landing view.
  const [contactFilter, setContactFilter] = useState("technical"); // technical | executive | gaps | all
  // null = default order (customer name); else {key, dir}
  const [contactSort, setContactSort] = useState(null);
  const [contactCopied, setContactCopied] = useState(false);
  // Inline contact set: "slug:kind" in flight + last error.
  const [contactBusy, setContactBusy] = useState(null);
  const [contactError, setContactError] = useState(null);

  // Gap labels. Base gaps are customer-level (they gate both contact
  // kinds); kind gaps name the kind so the two never blur (2026-08-03
  // two-contact rework — visual distinction is the separate columns plus
  // these labels).
  const CONTACT_BASE_GAP_LABEL = {
    lapsed_active: "SS365 lapsed — users still Active",
    no_users:      "No portal users yet",
  };
  const CONTACT_KIND_LABEL = { technical: "Technical", executive: "Executive" };
  const contactKindGapLabel = (kind, gap) => ({
    unset:    `No ${CONTACT_KIND_LABEL[kind].toLowerCase()} contact set`,
    inactive: `${CONTACT_KIND_LABEL[kind]} contact not Active`,
    multiple: `More than one ${CONTACT_KIND_LABEL[kind].toLowerCase()} contact`,
  }[gap]);
  // Derivations live in utils/adminContacts.js so the 2026-08-03
  // numeric-customer_id crash class is pinned by a direct unit test:
  // these run top-level on EVERY AdminPage render once the lifecycle
  // fetch lands, so a single throwing row unmounts every admin tab.
  const contactRows = useMemo(
    () => deriveContactRows(
      accessLifecycle, clientList, entitledSlugs, lapsedActiveSlugs,
    ),
    [accessLifecycle, clientList, entitledSlugs, lapsedActiveSlugs],
  );

  const contactCounts = useMemo(
    () => computeContactCounts(contactRows), [contactRows],
  );

  const visibleContactRows = useMemo(
    () => filterSortContactRows(contactRows, {
      contactFilter, contactSearch, contactSort,
    }),
    [contactRows, contactSearch, contactFilter, contactSort],
  );

  // Copy-all follows the ACTIVE VIEW (per-view, operator decision
  // 2026-08-03): technical → technical emails, executive → executive,
  // all → deduped union (one person holding both flags appears once),
  // gaps → nothing. Gap rows never contribute an address.
  const usableContactEmails = useMemo(
    () => computeUsableEmails(visibleContactRows, contactFilter),
    [visibleContactRows, contactFilter],
  );

  const handleContactSort = (key) => {
    setContactSort(s => (
      !s || s.key !== key ? { key, dir: "asc" }
        : s.dir === "asc" ? { key, dir: "desc" }
        : null  // third click restores the customer-name default
    ));
  };

  // Inline contact set (the view's main interaction), one handler for
  // both kinds. Optimistic local update, then a fresh=1 refetch past
  // the 120s lifecycle cache (approve/deny idiom) to confirm; a failed
  // POST rolls the rows back and surfaces the error instead of silently
  // reverting. kind: "technical" | "executive"; the lifecycle row flag
  // fields keep their column-derived names (primary / executive).
  const handleContactSet = async (row, kind, newId) => {
    const flagField = kind === "technical" ? "primary" : "executive";
    if (!newId || newId === row[kind].id || contactBusy) return;
    setContactBusy(`${row.slug}:${kind}`); setContactError(null);
    const before = accessLifecycle;
    setAccessLifecycle(ls => (ls || []).map(r =>
      r.slug === row.slug ? { ...r, [flagField]: r.id === newId } : r
    ));
    let ok = false;
    try {
      await (kind === "technical" ? setAccessPrimary : setAccessExecutive)(
        row.slug, newId,
      );
      ok = true;
    } catch (e) {
      setAccessLifecycle(before);
      setContactError(
        `Couldn't set the ${kind} contact for ${row.customer} — ` +
        (e.status === 409
          ? "that member is no longer Active. Reload and try again."
          : "please try again, or use the customer's Company Profile.")
      );
    }
    if (ok) {
      try {
        const d = await fetchAdminAccessLifecycle({ fresh: true });
        if (Array.isArray(d?.rows)) setAccessLifecycle(d.rows);
        if (Array.isArray(d?.entitled_slugs)) setEntitledSlugs(d.entitled_slugs);
      } catch { /* POST succeeded — the optimistic state is already correct */ }
    }
    setContactBusy(null);
  };

  const handleCopyContactEmails = async () => {
    try {
      await navigator.clipboard.writeText(usableContactEmails.join("; "));
      setContactCopied(true);
      setTimeout(() => setContactCopied(false), 2000);
    } catch { /* clipboard denied — the CSV button is the fallback */ }
  };

  // CSV mirrors the active view (filter + search + sort), one row per
  // customer with both contacts.
  const handleContactCsv = () => {
    const esc = v => `"${String(v ?? "").replace(/"/g, '""')}"`;
    const gapText = (r, kind) =>
      r.base_gap ? CONTACT_BASE_GAP_LABEL[r.base_gap]
        : r[kind].gap ? contactKindGapLabel(kind, r[kind].gap) : "";
    const lines = [
      ["customer", "technical_contact", "technical_email", "technical_gap",
       "executive_contact", "executive_email", "executive_gap",
       "last_login", "date_added"].join(","),
      ...(visibleContactRows || []).map(r => [
        esc(r.customer),
        esc(r.technical.name), esc(r.technical.email), esc(gapText(r, "technical")),
        esc(r.executive.name), esc(r.executive.email), esc(gapText(r, "executive")),
        esc(r.technical.last_login || ""), esc(r.technical.created_on || ""),
      ].join(",")),
    ];
    const blob = new Blob([lines.join("\n")], { type: "text/csv" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url; a.download = "contacts.csv"; a.click();
    URL.revokeObjectURL(url);
  };

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError(false);
    Promise.all([
      fetchReviewQueue(),
      // scope:"all" on purpose — this list feeds Publishing-tab name
      // resolution (blob slugs can belong to any customer) and the
      // Primary Contacts universes (entitled + lapsed sidecars pick the
      // view; the base list must not pre-shrink them).
      fetchClients({ scope: "all" }).catch(() => []),  // name resolution is best-effort; don't fail the page on it
    ])
      .then(([rq, clients]) => {
        if (cancelled) return;
        const map = {};
        (Array.isArray(clients) ? clients : []).forEach(c => {
          if (c && c.customer_id) {
            map[c.customer_id] = c.customer_name || c.customer_id;
          }
        });
        setClientsById(map);
        setClientList(Array.isArray(clients) ? clients : []);
        setQueue(Array.isArray(rq?.pending) ? rq.pending : []);
        setLoading(false);
      })
      .catch(() => { if (!cancelled) { setError(true); setLoading(false); } });
    return () => { cancelled = true; };
  }, [queueRefreshKey]);

  useEffect(() => {
    let cancelled = false;
    setSummary(null); // toggle refetch shows Loading, not the stale scope
    setSummaryError(false);
    fetchAdminLoginSummary(loginShowAll ? { scope: "all" } : {})
      .then(d => {
        if (cancelled) return;
        setSummary(Array.isArray(d?.customers) ? d.customers : []);
        setLoginScopeApplied(d?.scope_applied || null);
      })
      .catch(() => { if (!cancelled) setSummaryError(true); });
    return () => { cancelled = true; };
  }, [loginShowAll]);

  useEffect(() => {
    let cancelled = false;
    fetchAdminPendingAccess()
      .then(d => { if (!cancelled) setPendingAccess(Array.isArray(d?.pending) ? d.pending : []); })
      .catch(() => { if (!cancelled) setPendingAccessError(true); });
    return () => { cancelled = true; };
  }, [pendingAccessRefresh]);

  // Lifecycle history fetch — gated on the tab, re-run on
  // pendingAccessRefresh so a just-decided row moves into history. Two
  // run kinds: a decision-triggered run (pendingAccessRefresh moved past
  // the ref) passes { fresh: true } to bypass the 120s server cache AND
  // keeps the old rows rendered (no Loading flash); an initial/tab-open
  // run rides the cache and may show Loading.
  const accessRefreshSeen = useRef(pendingAccessRefresh);
  useEffect(() => {
    // The Primary Contacts tab derives from the same lifecycle rows.
    if (adminTab !== "access" && adminTab !== "contacts") return;
    let cancelled = false;
    const isDecisionRefresh = pendingAccessRefresh !== accessRefreshSeen.current;
    accessRefreshSeen.current = pendingAccessRefresh;
    if (!isDecisionRefresh) setAccessLifecycle(null); // Loading only on tab open, never on a decision refetch
    setAccessLifecycleError(false);
    fetchAdminAccessLifecycle({ fresh: isDecisionRefresh })
      .then(d => {
        if (cancelled) return;
        setAccessLifecycle(Array.isArray(d?.rows) ? d.rows : []);
        setEntitledSlugs(Array.isArray(d?.entitled_slugs) ? d.entitled_slugs : null);
        setLapsedActiveSlugs(Array.isArray(d?.lapsed_active_slugs) ? d.lapsed_active_slugs : null);
      })
      .catch(() => { if (!cancelled) setAccessLifecycleError(true); });
    return () => { cancelled = true; };
  }, [adminTab, pendingAccessRefresh]);

  // Approve/deny a pending request. Confirm already happened (modal); the
  // row id is the busy key so other rows stay actionable. On any outcome
  // the list refreshes — success removes the row server-side; a 409 means
  // someone else decided it first and the refresh reconciles.
  const handleAccessDecision = async () => {
    if (!decisionTarget) return;
    const { row, action } = decisionTarget;
    if (decisionBusyIds.has(row.id)) return;
    // Deny requires the customer-visible reason — block submit, keep the
    // modal open with the inline hint rather than closing on invalid input.
    const reason = denyReason.trim();
    if (action === "deny" && !reason) {
      setDenyReasonError(true);
      return;
    }
    setDecisionTarget(null);
    setDecisionBusyIds(ids => new Set(ids).add(row.id));
    const logEntry = (ok, label) => setDecisionLog(log =>
      [{ key: `${row.id}-${Date.now()}`, email: row.email, ok, label }, ...log].slice(0, 8));
    try {
      if (action === "approve") {
        const r = await approveAccessRequest(row.slug, row.id);
        logEntry(true, r.invited
          ? "Invited + added to group"
          : (r.already_member ? "Already a guest and group member — roster activated"
                              : "Already a guest — added to group"));
      } else {
        await denyAccessRequest(row.slug, row.id, reason);
        logEntry(true, "Denied");
      }
      setPendingAccessRefresh(k => k + 1);
    } catch (e) {
      if (e.status === 409) {
        logEntry(false, "Already decided by someone else — list refreshed.");
        setPendingAccessRefresh(k => k + 1);
      } else if (e.body?.step) {
        logEntry(false, `Approve failed at step "${e.body.step}" — every step is idempotent, retry is safe. ${e.body.graph_error_code ? `(Graph: ${e.body.graph_error_code})` : ""}`);
      } else {
        logEntry(false, `${action === "approve" ? "Approve" : "Deny"} failed — please retry.`);
      }
    } finally {
      setDecisionBusyIds(ids => {
        const next = new Set(ids);
        next.delete(row.id);
        return next;
      });
    }
  };

  // Scanning summary — loads once, when the tab first opens (backend caches
  // ~120s; a stale list here is cosmetic, matching the Logins tab).
  useEffect(() => {
    if (adminTab !== "scanning" || scanSummary !== null || scanSummaryError) return;
    let cancelled = false;
    fetchAdminScanSummary()
      .then(d => { if (!cancelled) setScanSummary(Array.isArray(d?.customers) ? d.customers : []); })
      .catch(() => { if (!cancelled) setScanSummaryError(true); });
    return () => { cancelled = true; };
  }, [adminTab, scanSummary, scanSummaryError]);

  // Reviews rollup — loads when the tab opens, and again on Apply (the
  // range nonce). The customer half is served from a ~120s backend cache;
  // only the date-range half is recomputed, so re-fetching is cheap.
  // `today` rides along as the OPERATOR's local date (fetchReviewOps) —
  // every count on this tab is a day count, and after ~18:00 US-Central the
  // server's UTC date is already tomorrow.
  useEffect(() => {
    if (adminTab !== "reviews") return;
    let cancelled = false;
    invalidateReviewOpsQuietRefresh();
    const requestedRange = {
      start: reviewStart || undefined,
      end: reviewEnd || undefined,
      nonce: reviewRangeNonce,
    };
    reviewOpsAppliedRangeRef.current = requestedRange;
    setReviewOpsLoading(true);
    setReviewOpsError(false);
    fetchReviewOps({ start: requestedRange.start, end: requestedRange.end })
      .then(d => {
        if (cancelled) return;
        // An empty initial request receives the backend's default range.
        // Later return events must keep querying that applied range, not a
        // date the operator has merely typed without pressing Apply.
        reviewOpsAppliedRangeRef.current = {
          ...requestedRange,
          start: requestedRange.start || d?.range?.start || undefined,
          end: requestedRange.end || d?.range?.end || undefined,
        };
        setReviewOps(d);
        // Reflect the range actually applied, so the empty fields stop
        // being a guess after the first load.
        if (d?.range?.start) setReviewStart(s => s || d.range.start);
        if (d?.range?.end) setReviewEnd(e => e || d.range.end);
      })
      .catch(() => { if (!cancelled) setReviewOpsError(true); })
      .finally(() => { if (!cancelled) setReviewOpsLoading(false); });
    return () => { cancelled = true; };
    // reviewStart/reviewEnd are deliberately NOT dependencies — the nonce is,
    // so typing in a date field never fires a request. The effect reads the
    // current values through its closure at the render the nonce changed on.
  }, [adminTab, reviewRangeNonce, invalidateReviewOpsQuietRefresh]);

  // Calendly changes arrive through a signed webhook, outside this page's
  // local state. Re-read on a real return to Assessments, quietly and once.
  useEffect(() => {
    if (adminTab !== "reviews") return undefined;
    const refreshOnVisible = () => {
      if (document.visibilityState === "visible") refreshReviewOpsOnReturn();
    };
    document.addEventListener("visibilitychange", refreshOnVisible);
    window.addEventListener("focus", refreshOnVisible);
    return () => {
      document.removeEventListener("visibilitychange", refreshOnVisible);
      window.removeEventListener("focus", refreshOnVisible);
      invalidateReviewOpsQuietRefresh();
    };
  }, [adminTab, invalidateReviewOpsQuietRefresh, refreshReviewOpsOnReturn]);

  // Customer Management — loads ONCE when ITS OWN tab opens (2026-08-14).
  //
  // It used to load when the Assessments tab opened, because the badge sat
  // on that section's toggle and the number had to exist before anyone
  // clicked in. The badge is now on the tab itself, so this is the tab's own
  // fetch and fires with it. THE ALTERNATIVE WAS FETCHING ON EVERY ADMIN
  // MOUNT so the badge is populated from any tab: rejected because it buys a
  // fleet read for every operator who opens Publishing, and because the
  // Assessments badge beside it already behaves exactly this way — a
  // top-tab badge rides data its own tab fetched and stays absent until the
  // tab has loaded once. Absent, never zero: PillToggle omits a falsy badge.
  //
  // Served from its own ~120s backend cache, so a tab bounce costs a cached
  // response (the Scanning-tab load-once idiom; range-independent, no nonce).
  useEffect(() => {
    if (adminTab !== "management" || custMgmt !== null || custMgmtError) return;
    let cancelled = false;
    fetchCustomerManagement({ includeInactive: mgmtShowInactive })
      .then(d => { if (!cancelled) setCustMgmt(d); })
      .catch(() => { if (!cancelled) setCustMgmtError(true); });
    return () => { cancelled = true; };
  }, [adminTab, custMgmt, custMgmtError, mgmtShowInactive]);

  // Review cadence deliberately does NOT ride the default Customer
  // Management fetch. It is a second fleet read of dated ledger facts and
  // starts only when an operator asks for this lens.
  useEffect(() => {
    if (adminTab !== "management" || mgmtLens !== "cadence"
        || reviewCadence !== null || reviewCadenceError) return;
    let cancelled = false;
    fetchReviewCadence({ includeInactive: mgmtShowInactive })
      .then(d => { if (!cancelled) setReviewCadence(d); })
      .catch(() => { if (!cancelled) setReviewCadenceError(true); });
    return () => { cancelled = true; };
  }, [adminTab, mgmtLens, reviewCadence, reviewCadenceError, mgmtShowInactive]);

  const retryReviewCadence = () => {
    setReviewCadence(null);
    setReviewCadenceError(false);
  };
  const refreshManagementAfterRenewal = useCallback(async () => {
    setCustMgmtError(false);
    try {
      const data = await fetchCustomerManagement({ includeInactive: mgmtShowInactive });
      setCustMgmt(data);
    } catch (_) {
      setCustMgmtError(true);
    }
    if (reviewCadence !== null || reviewCadenceError) {
      setReviewCadenceError(false);
      try {
        const data = await fetchReviewCadence({ includeInactive: mgmtShowInactive });
        setReviewCadence(data);
      } catch (_) {
        setReviewCadenceError(true);
      }
    }
  }, [mgmtShowInactive, reviewCadence, reviewCadenceError]);
  const changeMgmtInactiveScope = (checked) => {
    setMgmtShowInactive(checked);
    setCustMgmt(null);
    setCustMgmtError(false);
    setReviewCadence(null);
    setReviewCadenceError(false);
  };

  // ── Customer detail drawer loader (design §4.4) ──
  // The drawer reads only when it opens — never at admin mount. It reuses a
  // loaded payload, or fetches the tab's own default scope once and writes
  // a success into the SHARED state, so the tab's own effect then skips its
  // fetch. The write is functional and scope-checked: it lands only on a
  // still-empty cache for the scope that was asked for. No in-flight dedupe
  // with the tab effect; both land on the ~120s backend cache.
  const drawerOpen = customerDrawer !== null;
  const mgmtScopeRef = useRef(mgmtShowInactive);
  mgmtScopeRef.current = mgmtShowInactive;
  useEffect(() => {
    if (!drawerOpen || custMgmt !== null || drawerMgmtLoad !== "idle") return;
    const requestedScope = mgmtShowInactive;
    setDrawerMgmtLoad("loading");
    fetchCustomerManagement({ includeInactive: requestedScope })
      .then(d => {
        setCustMgmt(prev => (
          prev === null && mgmtScopeRef.current === requestedScope ? d : prev));
        setDrawerMgmtLoad("idle");
      })
      .catch(() => {
        setDrawerMgmtLoad(mgmtScopeRef.current === requestedScope ? "error" : "idle");
      });
  }, [drawerOpen, custMgmt, drawerMgmtLoad, mgmtShowInactive]);
  useEffect(() => {
    if (!drawerOpen || reviewCadence !== null || drawerCadenceLoad !== "idle") return;
    const requestedScope = mgmtShowInactive;
    setDrawerCadenceLoad("loading");
    fetchReviewCadence({ includeInactive: requestedScope })
      .then(d => {
        setReviewCadence(prev => (
          prev === null && mgmtScopeRef.current === requestedScope ? d : prev));
        setDrawerCadenceLoad("idle");
      })
      .catch(() => {
        setDrawerCadenceLoad(mgmtScopeRef.current === requestedScope ? "error" : "idle");
      });
  }, [drawerOpen, reviewCadence, drawerCadenceLoad, mgmtShowInactive]);

  // Miss fallback. The default Customer Data universe is Ongoing / On Hold /
  // Open; Scheduling also works Pending. A slug the default payload does not
  // carry, opened from Scheduling or a deep link, gets ONE inactive-scope
  // read per payload type per drawer session. Only on a miss, so an
  // ordinary open costs at most the two fleet reads above.
  const drawerSlug = customerDrawer?.slug || null;
  const drawerAllowsWide = customerDrawer?.origin === "scheduling"
    || customerDrawer?.origin === "deeplink";
  const payloadMisses = (payload) => drawerSlug !== null && payload !== null
    && !mgmtShowInactive
    && !(payload.customers || []).some(r => r.slug === drawerSlug);
  const mgmtMissesDrawerSlug = payloadMisses(custMgmt);
  const cadenceMissesDrawerSlug = payloadMisses(reviewCadence);
  useEffect(() => {
    if (!drawerAllowsWide || !mgmtMissesDrawerSlug || wideMgmt.status !== "idle") return;
    const session = drawerSessionRef.current;
    setWideMgmt({ status:"loading", data:null });
    fetchCustomerManagement({ includeInactive: true })
      .then(d => {
        if (drawerSessionRef.current === session) setWideMgmt({ status:"ready", data:d });
      })
      .catch(() => {
        if (drawerSessionRef.current === session) setWideMgmt({ status:"error", data:null });
      });
  }, [drawerAllowsWide, mgmtMissesDrawerSlug, wideMgmt.status]);
  useEffect(() => {
    if (!drawerAllowsWide || !cadenceMissesDrawerSlug || wideCadence.status !== "idle") return;
    const session = drawerSessionRef.current;
    setWideCadence({ status:"loading", data:null });
    fetchReviewCadence({ includeInactive: true })
      .then(d => {
        if (drawerSessionRef.current === session) setWideCadence({ status:"ready", data:d });
      })
      .catch(() => {
        if (drawerSessionRef.current === session) setWideCadence({ status:"error", data:null });
      });
  }, [drawerAllowsWide, cadenceMissesDrawerSlug, wideCadence.status]);
  const retryDrawerMgmt = () => {
    setDrawerMgmtLoad("idle");
    if (wideMgmt.status === "error") setWideMgmt({ status:"idle", data:null });
  };
  const retryDrawerCadence = () => {
    setDrawerCadenceLoad("idle");
    if (wideCadence.status === "error") setWideCadence({ status:"idle", data:null });
  };

  // The FULL payload — every contract status the server returned, with no
  // universe filter applied. The Ongoing + Open split is client-side, in
  // filterSchedulingUniverse; read the hazard note there before making
  // fetchReviewOps filter status server-side.
  const reviewCustomers = reviewOps?.customers || [];

  // ── Customer detail drawer: resolve by slug on EVERY render (§4.2) ──
  // Never a snapshot, so a background refresh after a renewal write shows up
  // in an open drawer. meta travels with whichever payload supplied the row.
  const resolveDrawerSide = (payload, load, wide) => {
    const find = (p) => (p?.customers || []).find(r => r.slug === drawerSlug) || null;
    const row = find(payload);
    if (row) {
      return { row, meta:payload.meta, fromWide:false, state:"ready",
               list:payload.customers };
    }
    if (payload === null) return { row:null, state: load === "error" ? "error" : "loading" };
    if (!drawerAllowsWide || mgmtShowInactive) return { row:null, state:"absent" };
    if (wide.status === "ready") {
      const wideRow = find(wide.data);
      return wideRow
        ? { row:wideRow, meta:wide.data?.meta, fromWide:true, state:"ready" }
        : { row:null, state:"absent" };
    }
    return { row:null, state: wide.status === "error" ? "error" : "loading" };
  };
  const drawerMgmt = customerDrawer
    ? resolveDrawerSide(custMgmt, drawerMgmtLoad, wideMgmt) : null;
  const drawerCadence = customerDrawer
    ? resolveDrawerSide(reviewCadence, drawerCadenceLoad, wideCadence) : null;
  // Prev/next walk the slugs of the list the drawer was opened from, in its
  // visible order. A deep link has no list, so it walks the resolved
  // payload in server order; a row that came only from the inactive scope
  // has no list to walk.
  const drawerNavList = !customerDrawer ? []
    : customerDrawer.navSlugs
      || (drawerMgmt.row && !drawerMgmt.fromWide ? drawerMgmt.list.map(r => r.slug)
        : drawerCadence.row && !drawerCadence.fromWide
          ? drawerCadence.list.map(r => r.slug) : []);
  const drawerNavIndex = drawerSlug === null ? -1 : drawerNavList.indexOf(drawerSlug);
  const drawerHasPrev = drawerNavIndex > 0;
  const drawerHasNext = drawerNavIndex !== -1 && drawerNavIndex < drawerNavList.length - 1;
  const stepCustomerDrawer = (delta) => {
    const next = drawerNavList[drawerNavIndex + delta];
    if (!customerDrawer || !next) return;
    const known = reviewCustomers.find(r => r.slug === next);
    setDrawer({ ...customerDrawer, slug:next, fallbackName:known?.customer_name || null });
  };
  // Close on an admin tab or Assessments view change — the Recs page's
  // close-on-page-change idiom. Skips the first run so a deep-linked
  // drawer survives mount.
  const drawerCloseKey = `${adminTab}|${reviewView}`;
  const drawerCloseKeyRef = useRef(drawerCloseKey);
  useEffect(() => {
    if (drawerCloseKeyRef.current === drawerCloseKey) return;
    drawerCloseKeyRef.current = drawerCloseKey;
    if (customerDrawer) setDrawer(null);
  }, [drawerCloseKey, customerDrawer, setDrawer]);
  // The focused Backlog card for Just past due counts the same default
  // Scheduling universe its section opens: Ongoing/Open, explicit Banked
  // excluded, missing/invalid allowance_model values kept visible.
  const reviewGraceCount = useMemo(
    () => filterByBucket(
      filterSchedulingUniverse(reviewCustomers, "backlog"),
      JUST_PAST_DUE,
    ).length,
    [reviewCustomers],
  );
  // THE ROWS THE CHIPS DESCRIBE — after the bucket, the universe, search,
  // Ready-only and both banners, BEFORE any chip filter and before the sort.
  // Both the chip counts and the chip filter run off this ONE list, which is
  // what makes every chip's number equal the list it opens (#532/#534, the
  // mgmtScopedRows pattern). A second derivation anywhere breaks that.
  const schedulingScopedRows = useMemo(() => {
    if (reviewView !== "scheduling") return [];
    // Selecting the Just past due card switches the BUCKET, not the
    // band — grace rows are not backlog and carry no severity.
    if (schedulingBucket === "backlog" && reviewBand === JUST_PAST_DUE) return [];
    const bucket = filterScheduling(reviewCustomers, schedulingFilter, {
      // The 7-day cut is the "Within 7 days" CARD — there is no second
      // checkbox for it. One filter, one control.
      dueSoonOnly: schedulingBucket === "approaching" && reviewHorizon === "d7",
      severityBand: schedulingBucket === "backlog" ? reviewBand : "",
      includeOnHold: includeOnHoldActive,
    // SUPPRESSED ROWS LEAVE THE MAIN TABLE (2026-08-11) so the list matches
    // the "showing N of M" denominator, which is now the ACTIONABLE count.
    // They are not lost: the section beneath the table lists them with their
    // own count, so the split is on one screen.
    }).filter(r => !isBlockingSuppressed(r));
    const scoped = filterUnrecorded(filterContractExpired(
      filterReadyOnly(searchReviewRows(bucket, reviewSearch), readyOnly),
      expiredOnly), unrecordedOnly);
    return unresolvedNotesOnlyActive
      ? scoped.filter(r => normalizeOperationsNotesIcon(r.operations_notes_icon).state === "pink")
      : scoped;
  }, [reviewCustomers, reviewView, schedulingFilter, schedulingBucket, reviewHorizon, reviewBand, reviewSearch, readyOnly, expiredOnly, unrecordedOnly, includeOnHoldActive, unresolvedNotesOnlyActive]);

  // The chip counts, over exactly those rows — so a chip narrows what is
  // already on screen and can never resurrect a suppressed or out-of-universe
  // row. Recomputed when the scope changes, NOT when a chip is clicked: the
  // numbers on the chips must not move as she selects them, or the row she is
  // reading changes under her hand.
  const schedulingChipCountMap = useMemo(
    () => schedulingChipCounts(schedulingScopedRows), [schedulingScopedRows],
  );
  // The chips to render, per group — which keys, in what order, with what
  // count and whether they are selected. Built once rather than at each of
  // the render sites that needs them, so the row's visibility condition and
  // the row itself cannot disagree about what is in it.
  const readinessChips = useMemo(
    () => schedulingChipCards(CHIP_GROUP_READINESS, schedulingChipCountMap,
                              schedulingChips[CHIP_GROUP_READINESS]),
    [schedulingChipCountMap, schedulingChips],
  );
  const methodChips = useMemo(
    () => schedulingChipCards(CHIP_GROUP_METHOD, schedulingChipCountMap,
                              schedulingChips[CHIP_GROUP_METHOD]),
    [schedulingChipCountMap, schedulingChips],
  );
  const allowanceChips = useMemo(
    () => schedulingChipCards(CHIP_GROUP_ALLOWANCE, schedulingChipCountMap,
                              schedulingChips[CHIP_GROUP_ALLOWANCE]),
    [schedulingChipCountMap, schedulingChips],
  );
  // The booking chips, over the SAME scoped rows — so their counts obey the
  // same rule every other count on this tab does: the number equals the
  // length of the list the click produces (#557 / #532).
  const bookingChipRow = useMemo(
    () => bookingChipCards(schedulingScopedRows), [schedulingScopedRows],
  );
  const visibleReviewRows = useMemo(() => {
    let filtered = filterSchedulingChips(schedulingScopedRows, schedulingChips);
    // Booking chips OR within themselves and AND against the groups above,
    // the same semantics the Scheduling chip groups already use.
    if (bookingChips.length > 0) {
      const matched = new Set();
      for (const key of bookingChips) {
        for (const row of filterBookingChip(filtered, key)) matched.add(row);
      }
      filtered = filtered.filter(r => matched.has(r));
    }
    // On a COMBINED view the server order is wrong for a human reading
    // top-down — it ranks just-past-due below approaching, so a 3-day
    // overdue row sits under one due in 29 days. Sort by urgency across
    // the buckets instead, unless the reader has chosen a sort.
    if (schedulingFilter === "banked" && !rowSort) {
      return sortBankedOutreach(filtered);
    }
    if (!schedulingBucket && !rowSort) return sortSchedulingUrgency(filtered);
    return sortReviewRows(filtered, rowSort);
  }, [schedulingScopedRows, schedulingChips, bookingChips, schedulingBucket,
      schedulingFilter, rowSort]);

  // Rows held back by a blocking touchpoint scheduled in the future
  // (SPEC-blocking-touchpoint-suppression). Their own section beneath the
  // backlog table, NOT a filter: a filter you have to think to click
  // recreates the invisibility this feature exists to remove. Same search /
  // readiness / expired treatment as the main list so the two cannot show
  // contradictory slices, and the same sort.
  const visibleSuppressedRows = useMemo(() => {
    if (reviewView !== "scheduling") return [];
    const rows = filterSuppressed(reviewCustomers, schedulingFilter, schedulingOpts);
    const filtered = filterUnrecorded(filterContractExpired(
      filterReadyOnly(searchReviewRows(rows, reviewSearch), readyOnly),
      expiredOnly), unrecordedOnly);
    const notesFiltered = unresolvedNotesOnlyActive
      ? filtered.filter(r => normalizeOperationsNotesIcon(r.operations_notes_icon).state === "pink")
      : filtered;
    if (schedulingFilter === "banked" && !rowSort) {
      return sortBankedOutreach(notesFiltered);
    }
    return sortReviewRows(notesFiltered, rowSort);
  }, [reviewCustomers, reviewView, schedulingFilter, reviewSearch, readyOnly,
      expiredOnly, unrecordedOnly, rowSort, includeOnHoldActive, unresolvedNotesOnlyActive]);

  // ── Customer Management rows ──────────────────────────────────────
  // The payload as the server ordered it: problem rows pinned to the top in
  // severity order, clean rows below by renewal proximity
  // (customer_management.sort_key). THERE IS NO CLIENT SORT, deliberately —
  // the order encodes the severity ranking, and a second statement of that
  // ranking here is the drift class this whole view exists to expose.
  //
  // Search reuses searchReviewRows so one query string means the same thing
  // in every view of the section. The problems-only filter is the badge's
  // click-through and reads the same helper the badge counts with.
  const mgmtCustomers = custMgmt?.customers || [];
  const mgmtProblemCount = useMemo(
    () => problemRowCount(mgmtCustomers), [mgmtCustomers]);
  // THE ROWS THE CARDS DESCRIBE — after search and needs-fixing. Action-card
  // counts also honor active facet filters, because clicking one opens that
  // same intersection (#532/#534). The reciprocal facet cards count after the
  // active action filter, so each card family describes the list it can open.
  const mgmtBaseRows = useMemo(
    () => filterProblemRows(
      searchReviewRows(mgmtCustomers, mgmtSearch), mgmtProblemsOnly),
    [mgmtCustomers, mgmtSearch, mgmtProblemsOnly],
  );
  const mgmtActionCountRows = useMemo(
    () => filterManagementFacets(mgmtBaseRows, mgmtFacets),
    [mgmtBaseRows, mgmtFacets],
  );
  const mgmtContractActionCounts = useMemo(
    () => contractActionCounts(mgmtActionCountRows), [mgmtActionCountRows],
  );
  const mgmtContractActionCards = useMemo(
    () => contractActionCards(mgmtContractActionCounts, mgmtContractAction),
    [mgmtContractActionCounts, mgmtContractAction],
  );
  const mgmtScopedRows = useMemo(
    () => filterContractActionRows(mgmtBaseRows, mgmtContractAction),
    [mgmtBaseRows, mgmtContractAction],
  );
  const mgmtFacetCounts = useMemo(
    () => managementFacetCounts(mgmtScopedRows), [mgmtScopedRows],
  );
  const visibleMgmtRows = useMemo(() => {
    // Keyed on the TAB since 2026-08-14, not on the section's inner view —
    // the same guard, one level up, so the sort still runs only for the
    // surface that renders it.
    if (adminTab !== "management") return [];
    return sortManagementRows(
      filterManagementFacets(mgmtScopedRows, mgmtFacets), mgmtSort);
  }, [mgmtScopedRows, mgmtFacets, mgmtSort, adminTab]);
  useEffect(() => {
    if (mgmtLens !== "contract"
        || !visibleMgmtRows.some(row => row.slug === mgmtActionsOpenSlug)) {
      setMgmtActionsOpenSlug("");
    }
  }, [mgmtLens, mgmtActionsOpenSlug, visibleMgmtRows]);

  const cadenceCustomers = reviewCadence?.customers || [];
  const visibleCadenceRows = useMemo(() => {
    if (adminTab !== "management" || mgmtLens !== "cadence") return [];
    const searched = searchReviewRows(cadenceCustomers, mgmtSearch);
    return cadenceStateFilter === "all"
      ? searched
      : searched.filter(row => row.action_state === cadenceStateFilter);
  }, [adminTab, mgmtLens, cadenceCustomers, mgmtSearch, cadenceStateFilter]);

  // "Just past due" — past due but inside the grace window, so NOT
  // backlog. Its own section at the BOTTOM of the backlog list, never
  // interleaved: the backlog sorts longest-overdue-first, and dropping
  // 3-day-old rows into that sequence destroys what the order means.
  //
  // Hidden when a severity band is selected — the reader asked for a
  // band, and these carry none. Shown alone when the card itself is
  // selected; shown beneath the backlog otherwise.
  const visibleGraceRows = useMemo(() => {
    // Only under the focused Backlog filter, exactly as it was only on the
    // Backlog TAB before the merge. "all" already carries grace rows inline.
    if (schedulingBucket !== "backlog") return [];
    const band = reviewBand;
    if (band && band !== JUST_PAST_DUE) return [];
    // Sorted with the SAME key but as its own list — the two sections
    // are never concatenated, so a sort can never merge Just past due
    // into the backlog above it.
    return sortReviewRows(filterUnrecorded(filterContractExpired(filterReadyOnly(searchReviewRows(
      filterByBucket(filterSchedulingUniverse(reviewCustomers, schedulingFilter),
                     JUST_PAST_DUE), reviewSearch), readyOnly),
      expiredOnly), unrecordedOnly), rowSort);
  }, [reviewCustomers, schedulingBucket, schedulingFilter, reviewBand, reviewSearch, readyOnly, expiredOnly, unrecordedOnly, rowSort]);

  // Severity cards count ACTIONABLE rows (2026-08-11), through the same
  // helper the badges use — never a third statement of the rule.
  //
  // They previously iterated the raw payload filtering only on
  // bucket === "backlog": no universe filter, no suppression filter. So the
  // Total card read 50 while every badge and the list read 45, and clicking a
  // band card that said 2 opened a list of 1, because filterScheduling DOES
  // apply the universe. That is the defect #532 fixed for the badges,
  // surviving in the cards.
  //
  // `universeTotal` is the fuller number for the Total card's sub-line — the
  // rows a reader would otherwise think had vanished. Suppressed only; rows
  // outside the default universe are NOT folded in, because they are reachable
  // under their own filter and have their own count there.
  const reviewSeverityCounts = useMemo(() => {
    const counts = { critical: 0, high: 0, medium: 0, total: 0,
                     suppressed: 0, universeTotal: 0 };
    for (const r of filterActionable(reviewCustomers, "backlog")) {
      if (!r || r.bucket !== "backlog") continue;
      counts.total += 1;
      if (r.severity in counts) counts[r.severity] += 1;
    }
    counts.suppressed = filterSuppressed(reviewCustomers, "backlog")
      .filter(r => r?.bucket === "backlog").length;
    counts.universeTotal = counts.total + counts.suppressed;
    return counts;
  }, [reviewCustomers]);

  const reviewHorizonCards = useMemo(
    () => horizonCards(
      filterSchedulingUniverse(reviewCustomers, "approaching"),
      reviewOps?.meta,
    ),
    [reviewCustomers, reviewOps],
  );

  // Navigate to a customer: ?client={slug}#/overview — the same
  // ?client param the Publishing tab's "Review →" link uses (PortalShell
  // reads it on mount and ClientPicker restores the selection), but with
  // the hash set EXPLICITLY. clientUrl() preserves the current hash,
  // which from here would be #/admin/reviews — it would switch customer
  // and leave you on the admin page, going nowhere.
  //
  // Overview, not Recommendations or Company Profile: it is the
  // customer's landing page and the one place their current state reads
  // at a glance (score, next session, whether data is published), which
  // is "go look at them". Both onward actions are then one click —
  // Recommendations to record a review, Company Profile to fix contacts
  // — whereas landing on either directly would suit one cause of being
  // overdue and misdirect the other two.
  // ── Phase A.5 status write ──
  // The commit path. Everything the write needs has already been decided
  // by review_ops.STATUS_DATE_RULE (shipped in meta.status_options) —
  // this only sends it and splices the server's answer back.
  const commitStatus = async ({ slug, statusValue, date }) => {
    invalidateReviewOpsQuietRefresh();
    setStatusBusySlug(slug);
    setStatusError(null);
    try {
      const result = await setReviewStatus({
        slug, statusValue, date, today: localDateString(),
      });
      // Update from the SERVER's recomputed row, never a local guess —
      // the bucket and severity it returns are the same computation the
      // list itself uses.
      setReviewOps(prev => (prev ? {
        ...prev, customers: applyStatusWrite(prev.customers, result),
      } : prev));
      setStatusEdit(null);
      setStatusConfirm(null);
    } catch (e) {
      setStatusError({ slug, message: e.body?.error || e.message });
    } finally {
      setStatusBusySlug("");
    }
  };

  // Picking a status. Four of the seven move no date and write straight
  // away; the other three either stamp today (confirm, because she never
  // typed the date) or need one (reveal the field, then confirm).
  const handleStatusPick = (rowData, rawValue) => {
    setStatusError(null);
    if (!rawValue) { setStatusEdit(null); return; }
    const statusValue = Number(rawValue);
    // REQUIRE_DATE gates in the row before the confirm appears.
    // DEFAULT_TODAY does NOT: it goes straight to the confirm with the
    // date prefilled to today, so the routine press is the same number
    // of clicks it has always been and the override is an edit inside a
    // dialog the recorder was going to see anyway.
    if (statusNeedsDate(reviewOps?.meta, statusValue)) {
      // Re-picking the same status keeps the date already typed (see
      // statusPickUpdate) — resetting it was half of the "cannot save"
      // loop.
      invalidateReviewOpsQuietRefresh();
      setStatusEdit(prev => statusPickUpdate(prev, rowData.slug, statusValue));
      return;
    }
    const preview = statusChangePreview({
      meta: reviewOps?.meta, row: rowData, statusValue,
      today: localDateString(),
    });
    if (preview) {
      invalidateReviewOpsQuietRefresh();
      setStatusConfirm({
        ...preview, slug: rowData.slug, statusValue, row: rowData,
        // Editable inside the confirm when the status takes a date.
        date: statusTakesDate(reviewOps?.meta, statusValue)
          ? preview.newDate : undefined,
      });
    } else {
      commitStatus({ slug: rowData.slug, statusValue });
    }
  };

  // The date picked for a require_date status — confirm, never write
  // straight from the field.
  const handleStatusDateSubmit = (rowData) => {
    const preview = statusChangePreview({
      meta: reviewOps?.meta, row: rowData,
      statusValue: statusEdit.statusValue, suppliedDate: statusEdit.date,
      today: localDateString(),
    });
    if (preview) {
      setStatusConfirm({
        // `row` was MISSING here (found 2026-08-11 while tracing the Access
        // Meeting bug). The confirm re-previews against statusConfirm.row on
        // every keystroke so its consequence lines stay live; with no row it
        // re-previewed against nothing, so anything derived from the row went
        // quiet — the lost-appointment warning on this path, and the
        // "still <date>" detail on the blocking copy. The sibling
        // handleStatusPick has always passed it; the inline-editor path
        // simply forgot. Restores intent rather than changing a rule.
        ...preview, slug: rowData.slug, row: rowData,
        statusValue: statusEdit.statusValue, date: statusEdit.date,
      });
    }
  };

  // ── Customer-requested skip ──
  const openSkip = (rowData) => {
    setSkipTarget(rowData);
    setSkipContext(null); setSkipAccess(null);
    setSkipSelection(""); setSkipOtherText("");
    setSkipError(null); setSkipResult(null);
    try {
      setSkipPendingDate(getPendingReviewCompletionDate(rowData.slug));
      setSkipPendingError(null);
    } catch (error) {
      setSkipPendingDate(null);
      setSkipPendingError(error.message);
    }
    // Two on-demand reads, both existing endpoints: the allowance/cycle
    // context (whose `cycle` field is the on-cycle signal the confirm
    // copy branches on) and the roster for the requester dropdown.
    fetchReviewCompletionContext(rowData.slug)
      .then(setSkipContext)
      .catch(() => setSkipError("Couldn't load this customer's review context."));
    fetchAccessList(rowData.slug)
      .then(rows => setSkipAccess(Array.isArray(rows) ? rows : []))
      .catch(() => setSkipAccess([]));
  };

  const closeSkip = () => {
    if (skipBusy) return;
    setSkipTarget(null); setSkipContext(null); setSkipAccess(null);
    setSkipSelection(""); setSkipOtherText("");
    setSkipError(null); setSkipResult(null);
    setSkipPendingDate(null); setSkipPendingError(null);
  };

  const submitSkip = async () => {
    const options = skipRequesterOptions(skipAccess);
    const requestedBy = skipRequesterValue({
      selection: skipSelection, otherText: skipOtherText, options,
    });
    setSkipBusy(true); setSkipError(null);
    try {
      // review_date === click_date: no review happened, so there is no
      // earlier date and no backdating case (the server refuses a
      // differing review_date rather than overriding it).
      const storedDate = getPendingReviewCompletionDate(skipTarget.slug);
      if (skipPendingDate && storedDate !== skipPendingDate) {
        throw new Error("The unresolved review request changed. Close this dialog and reconcile it before retrying.");
      }
      const today = storedDate || localDateString();
      const result = await recordReviewCompletion(skipTarget.slug, {
        reviewDate: today, reviewType: "skipped", clickDate: today,
        skipRequestedBy: requestedBy,
      });
      // The result screen shows the date the SERVER produced — the
      // confirm never computes one, because duplicating review_cycle's
      // distribution arithmetic client-side would let the two drift.
      setSkipResult(result);
      // Splice the SERVER's reclassified row — bucket, day counts,
      // severity and the cleared workflow status all recomputed there
      // with review_ops.classify/severity. Never reclassified here: a
      // second implementation of the bucket rule is how BACKLOG_GRACE_DAYS
      // drifts between the two.
      //
      // Absent when nothing moved (a not-on-cycle customer, or a failed
      // tracking PATCH), and then the row is correctly left alone.
      if (result?.row) {
        setReviewOps(prev => (prev ? {
          ...prev, customers: applyStatusWrite(prev.customers, result.row),
        } : prev));
      }
    } catch (e) {
      setSkipError(e.body?.error || e.message);
    } finally {
      setSkipBusy(false);
    }
  };

  const reviewCustomerUrl = (slug) => {
    const params = new URLSearchParams(window.location.search);
    params.set("client", slug);
    return `${window.location.pathname}?${params.toString()}#/overview`;
  };
  // The customer drawer's dashboard link: reviewCustomerUrl's target minus
  // the drawer's own ?customer= param, which is in the URL while the drawer
  // is open and would otherwise ride into the dashboard link.
  const customerDashboardUrl = (slug) => {
    const params = new URLSearchParams(window.location.search);
    params.delete("customer");
    params.set("client", slug);
    return `${window.location.pathname}?${params.toString()}#/overview`;
  };

  // Unsent surveys above sent ones, applied AFTER the existing sort so the
  // within-group order is exactly what it always was (2026-08-11). Rows are
  // NEVER removed — James reads this list for team performance, so a sent row
  // is notated and sinks.
  const visibleCompletions = useMemo(
    () => surveySentFirst(sortCompletions(
      filterCompletions(
        applySkipVisibility(reviewOps?.completions, includeSkips),
        { reviewer: reviewReviewer, query: reviewListSearch },
      ),
      reviewSort,
    )),
    [reviewOps, reviewReviewer, reviewListSearch, reviewSort, includeSkips],
  );

  // The survey write. Splices the SERVER's answer, never a local guess — the
  // applyStatusWrite idiom, and the reason #536 exists.
  const [surveyBusyId, setSurveyBusyId] = useState("");
  const [surveyError, setSurveyError] = useState(null);
  // The inline date editor for ONE row (2026-08-11). {id, date} or null —
  // a single slot, so opening another row's editor closes the first, exactly
  // as statusEdit behaves in the status column. Two people cannot be halfway
  // through two different dates on one screen.
  const [surveyEdit, setSurveyEdit] = useState(null);

  // Clicking "Survey sent" REVEALS the editor rather than writing.
  // Prefilled with today so the common case is click -> Set: two clicks and
  // no date interaction. Amber sent some surveys yesterday and earlier, and
  // the one-click write gave her no way to say so.
  const openSurveyEdit = (completion) => {
    if (!completion?.id || surveyBusyId) return;
    setSurveyError(null);
    setSurveyEdit({ id: completion.id, date: localDateString() });
  };

  const writeSurvey = async (completion, { date, clear } = {}) => {
    if (!completion?.id || surveyBusyId) return;
    setSurveyBusyId(completion.id);
    setSurveyError(null);
    try {
      const result = await setSurveySent({
        completionId: completion.id,
        // Two explicit operations, never a toggle on the wire: the server is
        // told the direction rather than asked to infer it.
        ...(clear ? { clear: true } : { date }),
        today: localDateString(),
      });
      setReviewOps(prev => (prev ? {
        ...prev, completions: applySurveyWrite(prev.completions, result),
      } : prev));
      setSurveyEdit(null);
    } catch (e) {
      setSurveyError({ id: completion.id, message: e.body?.error || e.message });
    } finally {
      setSurveyBusyId("");
    }
  };

  // Third click clears back to the server order, the Contacts-tab idiom.
  const handleReviewSort = (key) => {
    setReviewSort(s => (
      !s || s.key !== key ? { key, dir: "asc" }
        : s.dir === "asc" ? { key, dir: "desc" }
        : null
    ));
  };

  const openScanEdit = (row) => {
    setScanEditTarget(row);
    setScanEditToolKey(row.scan_tool_key || "");
    setScanEditAuthKey(row.auth_method_key || "");
    setScanEditMigDate(row.migration_date || "");
    setScanEditFabric(!!row.fabric_admin);
    setScanEditHybrid(!!row.hybrid_admin);
    setScanEditNotesBody("");
    setScanEditNotesLoading(true);
    setScanEditNote("");
    setScanEditError("");
    fetchScanTrackingNotes(row.tracking_id)
      .then(data => setScanEditNotesBody(data.notes || ""))
      .catch(() => setScanEditError("Couldn't load the existing scan notes."))
      .finally(() => setScanEditNotesLoading(false));
  };

  const closeScanEdit = () => {
    if (scanEditBusyId) return;
    setScanEditTarget(null);
    setScanEditNotesBody("");
    setScanEditNotesLoading(false);
    setScanEditError("");
  };

  const handleScanEditToolChange = (nextToolKey) => {
    const previousToolKey = scanEditToolKey;
    setScanEditToolKey(nextToolKey);
    if (nextToolKey === "legacy") {
      setScanEditAuthKey("");
    } else if (
      previousToolKey === "legacy"
      && nextToolKey === "securescan365"
      && !scanEditMigDate
    ) {
      setScanEditMigDate(localDateString());
    }
  };

  const scanEditChanged = !!scanEditTarget && (
    scanEditToolKey !== (scanEditTarget.scan_tool_key || "")
    || scanEditAuthKey !== (scanEditTarget.auth_method_key || "")
    || scanEditMigDate !== (scanEditTarget.migration_date || "")
    || scanEditFabric !== !!scanEditTarget.fabric_admin
    || scanEditHybrid !== !!scanEditTarget.hybrid_admin
    || scanEditNote.trim().length > 0
  );

  const handleScanEdit = async () => {
    if (!scanEditTarget || !scanEditChanged || scanEditBusyId) return;
    const trackingId = scanEditTarget.tracking_id;
    setScanEditBusyId(trackingId);
    setScanEditError("");
    try {
      await updateScanTracking(trackingId, {
        scanToolKey: scanEditToolKey || null,
        authMethodKey: scanEditAuthKey || null,
        migrationDate: scanEditMigDate || null,
        fabricAdmin: scanEditFabric,
        hybridAdmin: scanEditHybrid,
        note: scanEditNote,
      });
      setScanEditTarget(null);
      setScanSummaryError(false);
      setScanSummary(null); // backend cache was invalidated; refetch server truth
    } catch (e) {
      setScanEditError(e.body?.error || "Couldn't save this scan-fleet edit. Please try again.");
    } finally {
      setScanEditBusyId("");
    }
  };

  useEffect(() => {
    let cancelled = false;
    if (!rosterSlug) { setRoster(null); setRosterError(false); return; }
    setRoster(null); setRosterError(false);
    fetchAccessList(rosterSlug)
      .then(d => { if (!cancelled) setRoster(Array.isArray(d) ? d : []); })
      .catch(() => { if (!cancelled) setRosterError(true); });
    return () => { cancelled = true; };
  }, [rosterSlug]);

  // SecureScan365 runs list — loads when the tab opens (Publishing tab's
  // cancelled-flag idiom), then re-polls every 15s ONLY while a run is
  // still active, so an idle tab doesn't hammer the engine. Manual
  // refresh bumps scanRunsRefresh to re-run the whole effect. A 503
  // scan_engine_not_configured flips the pending placeholder on and — with
  // scanRuns left null — the interval never re-fetches; re-opening the tab
  // retries once, so a later credential drop is picked up.
  useEffect(() => {
    if (adminTab !== "scans") return;
    let cancelled = false;
    const load = () => {
      fetchScanRuns({ top: 25 })
        .then(d => {
          if (cancelled) return;
          const runs = Array.isArray(d?.runs) ? d.runs : [];
          scanRunsRef.current = runs;
          setScanRuns(runs);
          // The poll re-fetches page 1 only. Resetting the cursor here is
          // deliberate: pages already loaded are replaced by a fresh page 1,
          // so keeping a cursor from the old sequence would append rows that
          // no longer follow what is on screen.
          setScanRunsCursor(d?.has_more ? (d?.next_cursor || null) : null);
          setScanRunsMoreError(false);
          setScanRunsError(false);
          setScanEngineNotConfigured(false);
        })
        .catch(e => {
          if (cancelled) return;
          if (e?.body?.error === "scan_engine_not_configured") {
            setScanEngineNotConfigured(true);
          } else {
            setScanRunsError(true);
          }
        });
      fetchScanIncomingStatus()
        .then(d => { if (!cancelled) setIncomingQueued(d?.queued || {}); })
        .catch(() => { if (!cancelled) setIncomingQueued({}); });
    };
    scanRunsPagedRef.current = false;
    load();
    const id = setInterval(() => {
      // The poll re-fetches page 1 and REPLACES the list. Once the operator
      // has paged into older history, doing that would silently throw their
      // loaded pages away every 15 seconds, so the auto-refresh stands down
      // and Refresh (which resets paging explicitly) becomes the way back.
      if (scanRunsPagedRef.current) return;
      const cur = scanRunsRef.current;
      if (cur && cur.some(r => (r.state && !SCAN_TERMINAL_STATES.has(r.state))
        || r.refresh_pending === true)) load();
    }, 15000);
    return () => { cancelled = true; clearInterval(id); };
  }, [adminTab, scanRunsRefresh]);

  // Append the next page. The cursor is opaque — it goes back to the engine
  // exactly as it arrived. Rows are appended, never merged: the engine pages
  // a stable newest-first index, so a run cannot arrive twice in one
  // sequence, and a de-dupe here would only mask it if one ever did.
  const loadMoreScanRuns = () => {
    if (!scanRunsCursor || scanRunsLoadingMore) return;
    setScanRunsLoadingMore(true);
    setScanRunsMoreError(false);
    fetchScanRuns({ top: 25, cursor: scanRunsCursor })
      .then(d => {
        const more = Array.isArray(d?.runs) ? d.runs : [];
        const merged = [...(scanRunsRef.current || []), ...more];
        scanRunsRef.current = merged;
        scanRunsPagedRef.current = true;
        setScanRuns(merged);
        setScanRunsCursor(d?.has_more ? (d?.next_cursor || null) : null);
      })
      .catch(() => setScanRunsMoreError(true))
      .finally(() => setScanRunsLoadingMore(false));
  };

  const findScanPasskeys = () => {
    if (!scanSlug || scanUsersLoading) return;
    setScanUsersLoading(true);
    setScanUsersError(false);
    setScanUsers(null);
    setScanUpn("");
    setScanStartMsg(null);
    fetchScanPasskeys(scanSlug)
      .then(d => {
        const users = Array.isArray(d?.users) ? d.users : [];
        setScanUsers(users);
        // One stored user is the overwhelmingly common case — preselect it.
        if (users.length === 1) setScanUpn(users[0].user_principal_name);
        setScanUsersLoading(false);
      })
      .catch(() => { setScanUsersError(true); setScanUsersLoading(false); });
  };

  // Start Assessment now opens the pipeline-choice popup instead of
  // starting immediately. The preflight is fetched on open so the cap,
  // in-flight and setup state on screen come from the backend rather than
  // from anything this component works out for itself.
  const openStartModal = () => {
    if (!scanSlug || scanStarting) return;
    const selection = currentScanSelection();
    const seq = ++startPreflightSeq.current;
    setStartModal(true);
    setStartPreflight(null);
    setStartPreflightError("");
    setStartPreflightLoading(true);
    setStartAutoSend(true);
    setStartManualArmed(false);
    setScanStartMsg(null);
    fetchScanStartPreflight(selection.slug)
      .then(d => {
        if (startPreflightSeq.current !== seq || !isCurrentScanSelection(selection)) return;
        setStartPreflight(d);
        showSelectedJourney(selection, d?.journey || null);
        setStartPreflightLoading(false);
      })
      .catch(e => {
        if (startPreflightSeq.current !== seq || !isCurrentScanSelection(selection)) return;
        setStartPreflightError(e?.body?.error || e?.message || "Preflight failed.");
        setStartPreflightLoading(false);
      });
  };

  const closeStartModal = () => {
    startPreflightSeq.current += 1;
    setStartModal(false);
    setStartPreflight(null);
    setStartPreflightError("");
    setStartManualArmed(false);
  };

  const viewStartJourney = () => {
    closeStartModal();
    document.getElementById("selected-admin-scan-journey")?.scrollIntoView?.({
      behavior: "smooth", block: "center",
    });
  };

  useEffect(() => {
    let current = true;
    const selection = currentScanSelection();
    setSelectedJourney(null);
    setSelectedJourneyError(null);
    setRecoveryPreview(null);
    setRecoveryMessage("");
    setRecoveryReason("");
    try {
      const saved = selection.slug
        ? JSON.parse(sessionStorage.getItem(`scan-recovery:${selection.slug}`) || "null")
        : null;
      setRecoveryOperation(saved?.slug === selection.slug
        ? { ...saved, _selection: selection } : null);
    } catch { setRecoveryOperation(null); }
    if (selection.slug) fetchAdminScanJourney(selection.slug)
      .then(data => { if (current) showSelectedJourney(selection, data); })
      .catch(() => { if (current) showSelectedJourneyError(selection, "Saved journey unavailable."); });
    return () => { current = false; };
  }, [scanSlug]);

  const refreshSelectedJourney = (origin = currentScanSelection()) => {
    if (!origin.slug || !isCurrentScanSelection(origin)) return;
    fetchAdminScanJourney(origin.slug)
      .then(data => { if (isCurrentScanSelection(origin)) { showSelectedJourney(origin, data); showSelectedJourneyError(origin, ""); } })
      .catch(() => { if (isCurrentScanSelection(origin)) { showSelectedJourney(origin, { status: "unavailable" }); showSelectedJourneyError(origin, "Saved journey unavailable."); } });
  };

  const previewJourneyRecovery = () => {
    const selection = currentScanSelection();
    if (!selection.slug || visibleRecoveryOperation) return;
    setRecoveryBusy(true);
    setRecoveryMessage("");
    previewAdminScanJourneyRecovery(selection.slug)
      .then(data => { if (isCurrentScanSelection(selection)) setRecoveryPreview({ ...data, _selection: selection }); })
      .catch(() => { if (isCurrentScanSelection(selection)) setRecoveryMessage("Recovery evidence is unavailable. Investigate the journey."); })
      .finally(() => { if (isCurrentScanSelection(selection)) { setRecoveryBusy(false); refreshSelectedJourney(selection); } });
  };

  const runJourneyRecovery = () => {
    const selection = currentScanSelection();
    const request = visibleRecoveryOperation
      ? { slug: visibleRecoveryOperation.slug, action: visibleRecoveryOperation.action,
          operation_id: visibleRecoveryOperation.operation_id,
          expected_version: visibleRecoveryOperation.expected_version,
          reason: visibleRecoveryOperation.reason }
      : (visibleRecoveryPreview?.action && visibleRecoveryPreview?.recovery_enabled
      ? { slug: selection.slug, action: visibleRecoveryPreview.action,
          operation_id: visibleRecoveryPreview.operation_id,
          expected_version: visibleRecoveryPreview.expected_version,
          reason: visibleRecoveryPreview.action === "close_expired_ready_claimed"
            ? visibleRecoveryPreview.approved_reason : recoveryReason.trim() }
      : null);
    if (!request || request.slug !== selection.slug || recoveryBusy || !request.reason || request.reason.length > 500) return;
    setRecoveryOperation({ ...request, _selection: selection });
    sessionStorage.setItem(`scan-recovery:${request.slug}`, JSON.stringify(request));
    setRecoveryBusy(true);
    setRecoveryMessage("");
    executeAdminScanJourneyRecovery(request)
      .then(data => {
        if (data.status === "applied") {
          sessionStorage.removeItem(`scan-recovery:${request.slug}`);
          if (isCurrentScanSelection(selection)) {
            setRecoveryMessage(request.action === "reconcile_settled"
              ? "Journey synced to the current published or held outcome."
              : "Expired unstarted journey closed. A separate new request can now run normal checks.");
            setRecoveryOperation(null);
            setRecoveryPreview(null);
          }
        } else {
          if (isCurrentScanSelection(selection)) setRecoveryMessage("Recovery audit is unresolved. No new operation should replace this one. Check this same operation only after investigation.");
        }
      })
      .catch(() => { if (isCurrentScanSelection(selection)) setRecoveryMessage("Recovery outcome is uncertain. Keep this operation ID and investigate before checking it again."); })
      .finally(() => { if (isCurrentScanSelection(selection)) { setRecoveryBusy(false); refreshSelectedJourney(selection); } });
  };

  // Arming the manual path UNCHECKS auto-send on screen. The two paths
  // produce different artifacts — marker vs no marker, swept vs invisible
  // — so an operator must never be able to walk away thinking they got
  // the sweep when they took the manual route.
  const armManualStart = () => {
    setStartAutoSend(false);
    setStartManualArmed(true);
  };

  const confirmStartScan = () => {
    if (!scanSlug || scanStarting || !startPreflight) return;
    const selection = currentScanSelection();
    const modalSeq = startPreflightSeq.current;
    const isCurrentRequest = () => isCurrentScanSelection(selection);
    const isCurrentModalRequest = () => isCurrentRequest() && startPreflightSeq.current === modalSeq;
    const cap = startPreflight?.cap;
    const journeyStatus = startPreflight?.journey?.status;
    const autoSendBlocked = !!cap?.capped
      || !!startPreflight?.in_flight
      || !!startPreflight?.auto_send_block
      || !["idle", "settled", "blocked", "not_evaluated", "capped", "expired_unstarted", "abandoned"].includes(journeyStatus);
    const autoSendUsable = startAutoSend && !autoSendBlocked;
    // Mirrors ScanStartModal's manualChosen exactly — unchecking with
    // auto-send available IS the choice; arming is only for the blocked
    // case where the box is disabled.
    const manualChosen = (!startAutoSend && !autoSendBlocked) || startManualArmed;
    if (!autoSendUsable && !manualChosen) return;
    // Belt and braces with the modal's own disable: the manual path needs
    // an account, and an in-flight tenant takes no new run either way.
    if (!autoSendUsable && (!scanUpn || startPreflight?.in_flight)) return;

    setScanStarting(true);
    setScanStartMsg(null);

    // The automatic path is the durable request. Manual diagnostics retain
    // their existing route and never stand in for a failed durable request.
    const request = autoSendUsable
      ? requestCustomerScan(selection.slug, { asCustomer: true })
      : startScanAssessment(selection.slug, scanUpn);

    request
      .then(d => {
        if (!isCurrentRequest()) return;
        const successfulDurableState = ["prerequisite", "assessment"].includes(d?.state)
          || (d?.state === "adjudication"
            && ["processing", "held", "published"].includes(d?.phase));
        setScanStartMsg({
          ok: !autoSendUsable || successfulDurableState,
          text: autoSendUsable
            ? scanRequestMessage(d)
            : `Assessment queued — run ${d.run_id || "accepted"}. Manual run: send it to scoring from Recent Runs when you're ready.`,
        });
        setScanStarting(false);
        setScanRunsRefresh(k => k + 1);
        if (autoSendUsable) fetchAdminScanJourney(selection.slug)
          .then(data => showSelectedJourney(selection, data))
          .catch(() => showSelectedJourney(selection, { status: "unavailable" }));
        if (isCurrentModalRequest()) closeStartModal();
      })
      .catch(e => {
        if (!isCurrentRequest()) return;
        setScanStarting(false);
        const body = e?.body || {};
        // The 429 is AUTHORITATIVE over anything the preflight said — a
        // sibling customer or another operator can consume the window in
        // the seconds between the two calls. Re-render the modal from the
        // real answer; never retry, and never silently fall back.
        if (e?.status === 429 && body.error === "scan_daily_cap") {
          if (isCurrentModalRequest()) setStartPreflight(prev => ({
            ...(prev || {}),
            cap: {
              capped: true,
              last_completed_utc: prev?.cap?.last_completed_utc || null,
              next_available_utc: body.next_available_utc || null,
              source: "engine_index",
            },
          }));
          if (isCurrentModalRequest()) {
            setStartAutoSend(false);
            setStartManualArmed(false);
          }
          setScanStartMsg({ ok: false, text: scanRequestMessage({ ...body, state: "cap" }) });
          return;
        }
        if (e?.status === 409 && body.error === "scan_in_flight"
            && body.kind === "scan" && body.run_id) {
          if (isCurrentModalRequest()) setStartPreflight(prev => ({
            ...(prev || {}),
            in_flight: { run_id: body.run_id, kind: "scan" },
          }));
          setScanStartMsg({ ok: false, text: "A scan is already running for this tenant." });
          return;
        }
        if (autoSendUsable && (e?.status === 409 || e?.status === 429)) {
          if (isCurrentModalRequest()) fetchScanStartPreflight(selection.slug)
            .then(fresh => { if (isCurrentModalRequest()) { setStartPreflight(fresh); showSelectedJourney(selection, fresh?.journey || null); } })
            .catch(() => { if (isCurrentModalRequest()) setStartPreflightError("Couldn’t refresh the saved journey."); });
          setScanStartMsg({ ok: false, text: "The saved state changed. Review it before deciding what to do next." });
          return;
        }
        setScanStartMsg({
          ok: false,
          text: body.error || "Couldn’t start the assessment. Please try again.",
        });
        if (isCurrentModalRequest()) closeStartModal();
      });
  };

  // Orphan any in-flight prerequisites poll on unmount.
  useEffect(() => () => { prereqSeq.current += 1; }, []);

  const clearPrereq = () => {
    prereqSeq.current += 1;
    setPrereqPhase("");
    setPrereqResult(null);
    setPrereqError("");
    setPrereqUpn("");
  };

  const selectScanSlug = slug => {
    if (slug === scanSelectionRef.current.slug) return;
    scanSelectionRef.current = {
      slug, generation: scanSelectionRef.current.generation + 1,
    };
    startPreflightSeq.current += 1;
    setScanSlug(slug);
    setScanUsers(null);
    setScanUsersError(false);
    setScanUpn("");
    setScanStarting(false);
    setScanStartMsg(null);
    setStartModal(false);
    setStartPreflight(null);
    setStartPreflightLoading(false);
    setStartPreflightError("");
    setRecoveryBusy(false);
    setRecoveryPreview(null);
    setRecoveryOperation(null);
    setRecoveryMessage("");
    setRecoveryReason("");
    clearPrereq();
  };

  // Poll the run's status every 3s to a terminal state, then fetch the
  // result. The check is queue-backed engine-side: status blobs exist from
  // the 202 onward, but the RESULT endpoint 404s until the worker publishes
  // it at completion — and the worker writes the result blob BEFORE the
  // terminal status flips (verified in RunPrerequisiteConnectivityWorker,
  // both success and failure paths). Gating the result fetch on terminal
  // state is what keeps a queued 404 from ever reading as failure. Bounded
  // at ~2 minutes so an engine hang can't spin the tab forever.
  const pollPrereqStatus = (runId, seq, ticks = 0) => {
    if (prereqSeq.current !== seq) {
      console.debug("[prereq] poll superseded — stopping", { runId, ticks });
      return;
    }
    fetchScanStatus(runId)
      .then(s => {
        if (prereqSeq.current !== seq) return;
        const state = s?.state || "";
        console.debug("[prereq] status tick", { runId, state: state || "(none)", ticks });
        if (PREREQ_TERMINAL_STATES.has(state)) {
          if (state === "Cancelled") {
            console.debug("[prereq] BRANCH cancelled");
            setPrereqPhase("");
            setPrereqError("The prerequisites check was cancelled — see Recent runs for details.");
            return;
          }
          // Completed, Stale (result 404s; backend maps it to
          // couldNotEvaluate), AND Failed all have a readable verdict — a
          // failed probe still publishes a full Prerequisites object with
          // Outcome couldNotEvaluate plus Issues/Retryable (contract §1).
          // Always fetch; generic error copy only if the fetch itself fails.
          console.debug("[prereq] BRANCH terminal — fetching result", { state });
          setPrereqPhase("loading");
          fetchScanPrereqResult(runId)
            .then(d => {
              if (prereqSeq.current !== seq) return;
              console.debug("[prereq] BRANCH result-loaded", { outcome: d?.outcome, coverage: d?.coverage, issues: (d?.issues || []).length });
              setPrereqResult(d);
              setPrereqPhase("");
            })
            .catch(e => {
              if (prereqSeq.current !== seq) return;
              console.error("[prereq] result fetch failed", e);
              const detail = e?.body?.error || e?.message || "";
              setPrereqPhase("");
              setPrereqError(state === "Failed"
                ? `The prerequisites check failed and its result couldn’t be read — see Recent runs for details.${detail ? ` (${detail})` : ""}`
                : `Couldn’t load the prerequisites result. Please try again.${detail ? ` (${detail})` : ""}`);
            });
          return;
        }
        if (ticks >= 40) {
          console.debug("[prereq] BRANCH poll-timeout", { runId, lastState: state || "(none)" });
          setPrereqPhase("");
          setPrereqError("The prerequisites check didn’t finish in time — check Recent runs and try again.");
          return;
        }
        setTimeout(() => pollPrereqStatus(runId, seq, ticks + 1), 3000);
      })
      .catch(e => {
        if (prereqSeq.current !== seq) return;
        // Transient status-read failure: keep polling inside the same
        // tick budget rather than failing the whole check.
        console.debug("[prereq] status tick failed — will retry", { runId, ticks, status: e?.status, message: e?.message });
        if (ticks >= 40) {
          console.error("[prereq] poll errors exhausted", e);
          const detail = e?.body?.error || e?.message || "";
          setPrereqPhase("");
          setPrereqError(`Couldn’t poll the prerequisites check. Please try again.${detail ? ` (${detail})` : ""}`);
          return;
        }
        setTimeout(() => pollPrereqStatus(runId, seq, ticks + 1), 3000);
      });
  };

  const startPrereqCheck = () => {
    if (!scanSlug || !scanUpn || prereqPhase || scanStarting) return;
    const seq = ++prereqSeq.current;
    setPrereqPhase("starting");
    setPrereqResult(null);
    setPrereqError("");
    setPrereqUpn(scanUpn);
    startScanPrereqCheck(scanSlug, scanUpn)
      .then(d => {
        if (prereqSeq.current !== seq) {
          console.debug("[prereq] ack arrived for a superseded check — ignoring");
          return;
        }
        // Backend ack contract: {runId, runLookupPath, statusLookupPath,
        // queued}. resolvePrereqAckRunId tolerates every shape that has
        // ever shipped (camelCase / PascalCase / snake_case / bare string
        // / paths-only via STRING PARSE — the lookup paths are engine-
        // relative diagnostics and are never fetched from the browser).
        // All polling goes through the portal proxies keyed on the runId.
        const runId = resolvePrereqAckRunId(d);
        console.debug("[prereq] ack received", {
          shape: d && typeof d === "object" ? Object.keys(d) : typeof d,
          resolvedRunId: runId || "(none)",
        });
        if (!runId) {
          console.debug("[prereq] BRANCH no-runId: ack carried no usable run reference — not polling", d);
          setPrereqPhase("");
          setPrereqError("The check was accepted but the acknowledgment carried no usable run reference — check Recent runs, then try again.");
          return;
        }
        console.debug("[prereq] BRANCH poll-start", { runId });
        setPrereqPhase("waiting");
        setScanRunsRefresh(k => k + 1); // the check shows up in Recent runs
        pollPrereqStatus(runId, seq);
      })
      .catch(e => {
        if (prereqSeq.current !== seq) return;
        // Surface the real cause beside the friendly copy — a swallowed
        // cause turns a one-line diagnosis into an evening of taps.
        console.error("[prereq] start failed", e);
        const detail = e?.body?.error || e?.message || "";
        setPrereqPhase("");
        setPrereqError(`Couldn’t start the prerequisites check. Please try again.${detail ? ` (${detail})` : ""}`);
      });
  };

  // Result download: authed fetch → Blob → synthetic <a download> click.
  // A plain href can't carry the Authorization header, so the link is a
  // button that fetches then saves.
  const downloadScanResult = (runId) => {
    if (scanResultBusy) return;
    setScanResultBusy(runId);
    setScanResultError("");
    fetchScanResult(runId)
      .then(data => {
        const blob = new Blob([JSON.stringify(data, null, 2)], { type: "application/json" });
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `scan-result-${runId}.json`;
        document.body.appendChild(a);
        a.click();
        a.remove();
        URL.revokeObjectURL(url);
      })
      .catch(() => setScanResultError(runId))
      .finally(() => setScanResultBusy(""));
  };

  // Weekly management report download. The endpoint needs the app's Bearer
  // token, so a browser tab pointed at it just 401s — this does the authed
  // fetch the app can already do and hands the operator a file.
  //
  // Same save idiom as downloadScanResult above (Blob -> object URL ->
  // synthetic anchor -> revoke). The filename's date is today's LOCAL date
  // from utils/dates.localDateString — never a local formatter, per the
  // date-authority rule; the report's own generated_at (UTC) is inside the
  // payload, so the two are never confused.
  const downloadWeeklyReport = () => {
    if (weeklyReportBusy) return;
    setWeeklyReportBusy(true);
    setWeeklyReportError(false);
    fetchWeeklyReport()
      .then(data => {
        const blob = new Blob([JSON.stringify(data, null, 2)], { type: "application/json" });
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `weekly-report-${localDateString()}.json`;
        document.body.appendChild(a);
        a.click();
        a.remove();
        URL.revokeObjectURL(url);
      })
      .catch(() => setWeeklyReportError(true))
      .finally(() => setWeeklyReportBusy(false));
  };

  const requestGroupDiscovery = () => {
    if (groupDiscoveryBusy || groupDiscovery?.state !== "not_requested") return;
    setGroupDiscoveryBusy(true);
    setGroupDiscoveryError(false);
    requestFreshserviceGroupDiscovery()
      .then(setGroupDiscovery)
      .catch(() => setGroupDiscoveryError(true))
      .finally(() => setGroupDiscoveryBusy(false));
  };

  const downloadGroupDiscovery = () => {
    if (groupDiscoveryBusy || !groupDiscovery?.downloadable) return;
    setGroupDiscoveryBusy(true);
    setGroupDiscoveryError(false);
    downloadFreshserviceGroupDiscovery()
      .then(blob => {
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "freshservice-groups.json";
        document.body.appendChild(a);
        a.click();
        a.remove();
        URL.revokeObjectURL(url);
      })
      .catch(() => setGroupDiscoveryError(true))
      .finally(() => setGroupDiscoveryBusy(false));
  };

  // Send-to-scoring: two-step (arm confirm dialog, then send). The confirm
  // dialog names the resolved customer; the row-level result copy lives in
  // sendState[runId]. 409/422/502 detail renders inline on the row.
  const setSend = (runId, v) => setSendState(prev => ({ ...prev, [runId]: v }));
  const confirmSendToScoring = (r) => {
    if (typeof sendState[r.run_id] === "object" && sendState[r.run_id]?.sent) return;
    // Already recorded as sent (claim-backed, survives reloads) — the arm
    // step is unreachable through the UI, and the backend's claim would
    // reject it anyway with already_sent.
    if (r.sent_utc) return;
    setSend(r.run_id, "confirm");
  };
  const cancelSendToScoring = (runId) => setSend(runId, undefined);
  const doSendToScoring = (r) => {
    setSend(r.run_id, "sending");
    sendScanToScoring(r.run_id)
      .then(res => setSend(r.run_id, { sent: true, slug: res.slug }))
      .catch(e => setSend(r.run_id, { error: e?.body?.error || e?.message || "Send failed. Please try again." }));
  };

  // The Send-to-Scoring control for one completed assessment row. Renders
  // the current sendState[run_id] step: idle link → confirm dialog naming
  // the customer → sending → sent ✓ (or inline error, retryable).
  // One-line Send-to-Scoring control — a compact bordered button (blue,
  // NOT green: green is Publishing's publish color and this action isn't
  // publish). Confirm/sending swap in place on the same line; the sent
  // state is a soft-green pill; the red error detail renders below the
  // actions row at the CELL level so it never stretches the row.
  const sendScoringCell = (r) => {
    const st = sendState[r.run_id];
    const miniLink = {
      background:"none", border:"none", padding:0, fontFamily:"inherit",
      fontSize:11, fontWeight:700, cursor:"pointer", whiteSpace:"nowrap",
    };
    // PERSISTENT sent state, from the send claim the backend already keeps
    // for both paths. This outranks sendState: sendState is one browser's
    // memory of one click and dies with the page, whereas r.sent_utc is the
    // recorded fact and is the same for every operator who opens the tab.
    if (r.sent_utc) {
      const who = r.sent_auto ? "auto" : (r.sent_by || "unknown");
      const why =
        `Sent to scoring ${fmtWhen(r.sent_utc)} by ${r.sent_auto ? "the auto-send sweep" : (r.sent_by || "an unrecorded actor")}. `
        + "Recorded on the run itself, so it survives a reload and every operator sees it. "
        + "Review in Publishing after scoring.";
      return (
        <span style={{ display:"inline-flex", alignItems:"center", gap:8, whiteSpace:"nowrap" }} title={why}>
          <span style={{ fontSize:11, color:T.muted, overflow:"hidden", textOverflow:"ellipsis", maxWidth:170 }}>
            Sent to scoring · {fmtWhen(r.sent_utc)} · {who}
          </span>
          {/* Disabled rather than absent: an absent button reads as "this
              row does not support sending" and leaves an operator wondering
              whether a re-send is available somewhere else. */}
          <button
            disabled
            title={why}
            style={{
              padding:"4px 10px", borderRadius:8, fontSize:11, fontWeight:600, fontFamily:"inherit",
              border:`1px solid ${T.border}`, background:"transparent",
              color:T.muted, cursor:"not-allowed", opacity:0.55, whiteSpace:"nowrap",
            }}
          >Sent</button>
        </span>
      );
    }
    if (st && st.sent) {
      return (
        <span title="Review in Publishing after scoring">
          <Badge type="green" weight="soft">Sent ✓</Badge>
        </span>
      );
    }
    if (st === "sending") {
      return (
        <span style={{
          padding:"4px 10px", borderRadius:8, fontSize:11, fontWeight:600,
          border:`1px solid ${T.border}`, color:T.muted, whiteSpace:"nowrap",
          opacity:0.55, cursor:"wait",
        }}>Sending…</span>
      );
    }
    if (st === "confirm") {
      const who = r.customer_name || "this customer";
      return (
        <span
          style={{ display:"inline-flex", alignItems:"center", gap:8, whiteSpace:"nowrap" }}
          title={`Send this run for ${who} to the scoring pipeline? It will appear in the Publishing queue for review after scoring.`}
        >
          <span style={{ display:"inline-block", fontSize:11, color:T.text, maxWidth:110, overflow:"hidden", textOverflow:"ellipsis" }}>
            Send for {who}?
          </span>
          <button onClick={() => doSendToScoring(r)} style={{ ...miniLink, color:T.blue }}>Send</button>
          <button onClick={() => cancelSendToScoring(r.run_id)} style={{ ...miniLink, color:T.muted, fontWeight:600 }}>Cancel</button>
        </span>
      );
    }
    // Idle, or a prior error — clicking re-arms the confirm step.
    const hasError = !!(st && st.error);
    const isQueued = !st && r.customer_slug && incomingQueued[r.customer_slug];
    return (
      <span style={{ display:"inline-flex", alignItems:"center", gap:8, whiteSpace:"nowrap" }}>
        {isQueued && (
          <span title="A scan drop for this customer is in incoming/, waiting for the ingest pipeline to pick it up. It normally clears within minutes once ingest runs — check Publishing for the held scan after scoring. A badge that persists for a long time can indicate a stuck ingest.">
            <Badge type="yellow" weight="soft">Queued for ingest</Badge>
          </span>
        )}
        <button
          onClick={() => confirmSendToScoring(r)}
          onMouseEnter={e => { e.currentTarget.style.background = "rgba(255,255,255,0.05)"; }}
          onMouseLeave={e => { e.currentTarget.style.background = "transparent"; }}
          style={{
            padding:"4px 10px", borderRadius:8, fontSize:11, fontWeight:600, fontFamily:"inherit",
            border:`1px solid ${hasError ? "rgba(225,77,87,.5)" : T.border}`, background:"transparent",
            color: hasError ? T.red : T.blue, cursor:"pointer", whiteSpace:"nowrap", transition:".15s",
          }}
        >{hasError ? "Retry send" : "Send to Scoring"}</button>
      </span>
    );
  };

  // Result download as a compact icon button — muted glyph, blue on hover,
  // so the read-only download doesn't compete with the pipeline-mutating
  // send action for visual weight.
  const downloadIconButton = (r) => {
    const busy = scanResultBusy === r.run_id;
    const err = scanResultError === r.run_id;
    return (
      <button
        onClick={() => downloadScanResult(r.run_id)}
        disabled={!!scanResultBusy}
        title={err ? "Download failed — click to retry" : "Download result"}
        onMouseEnter={e => { if (!scanResultBusy) e.currentTarget.style.color = T.blue; }}
        onMouseLeave={e => { e.currentTarget.style.color = err ? T.red : T.muted; }}
        style={{
          background:"none", border:"none", padding:2, fontFamily:"inherit", lineHeight:0,
          color: err ? T.red : T.muted, display:"inline-flex", alignItems:"center",
          cursor: scanResultBusy ? "wait" : "pointer", opacity: busy ? 0.5 : 1, transition:".15s",
        }}
      >
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
          <polyline points="7 10 12 15 17 10" />
          <line x1="12" y1="15" x2="12" y2="3" />
        </svg>
      </button>
    );
  };

  // Login stamps and request timestamps — INSTANTS.
  const fmtDate = (iso) => fmtInstant(iso, { month:"long", day:"numeric", year:"numeric" });

  // Request age as "3d 4h" (hours only under a day); stale once past 48h.
  const ageOf = (iso) => {
    if (!iso) return null;
    const t = new Date(iso).getTime();
    if (isNaN(t)) return null;
    const hours = Math.max(0, Math.floor((Date.now() - t) / 3600000));
    const label = hours >= 24 ? `${Math.floor(hours / 24)}d ${hours % 24}h` : `${hours}h`;
    return { label, stale: hours > 48 };
  };

  // Scans tab helpers. Engine index datetimes arrive as
  // "07/09/2026 00:00:59" — no zone marker, not ISO. They ARE UTC
  // instants, but new Date() would read that shape as LOCAL time, so
  // parse explicitly as UTC before handing off to the fmtInstant
  // authority (dates.js: INSTANTs render in the viewer's local zone).
  // Zone-less ISO gets the same treatment; zoned ISO (the local-dev mock
  // backend emits "+00:00") passes through untouched. Runs can share a
  // calendar day, so timestamps keep the time (unlike fmtDate).
  const parseEngineUtc = (value) => {
    if (!value) return null;
    const us = /^(\d{2})\/(\d{2})\/(\d{4})[ T](\d{2}):(\d{2}):(\d{2})$/.exec(value);
    if (us) return new Date(Date.UTC(+us[3], +us[1] - 1, +us[2], +us[4], +us[5], +us[6]));
    const isoNoZone = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?$/.test(value);
    if (isoNoZone) return new Date(`${value}Z`);
    const d = new Date(value);
    return isNaN(d.getTime()) ? null : d;
  };
  const fmtWhen = (value) => fmtInstant(parseEngineUtc(value), { month:"short", day:"numeric", hour:"numeric", minute:"2-digit" });
  const fmtDuration = (seconds) => {
    const s = Number(seconds);
    if (!isFinite(s) || s <= 0) return "—";
    const m = Math.floor(s / 60);
    return m >= 1 ? `${m}m ${Math.round(s % 60)}s` : `${Math.round(s)}s`;
  };

  // Customer picker options — reuses the /api/clients map already loaded
  // for the Publishing tab's name resolution.
  const scanClientOptions = Object.entries(clientsById)
    .map(([id, name]) => ({ id, name }))
    .sort((a, b) => (a.name || "").localeCompare(b.name || ""));

  // Link to ?client={customer_id}, preserving other params (mirrors PortalShell's
  // writeClientParam). Full navigation: PortalShell reads ?client on mount and
  // ClientPicker restores the selection. review-queue slug === client customer_id.
  const clientUrl = (customerId) => {
    const params = new URLSearchParams(window.location.search);
    params.set("client", customerId);
    return `${window.location.pathname}?${params.toString()}${window.location.hash}`;
  };

  // Logins tab derivations: customers who have logged in, sorted by the
  // toggle; never-logged-in customers ALWAYS group at the bottom (that
  // group is the onboarding follow-up list), alphabetical. Search is a
  // client-side substring filter on name/slug applied to BOTH groups —
  // it narrows, never reorders (the whole payload is already loaded).
  const loginQuery = loginSearch.trim().toLowerCase();
  const matchesLoginSearch = (s) => !loginQuery
    || (s.customer_name || "").toLowerCase().includes(loginQuery)
    || (s.slug || "").toLowerCase().includes(loginQuery);
  const loggedIn = (summary || [])
    .filter(s => s.most_recent_login)
    .filter(matchesLoginSearch)
    .sort((a, b) => loginSort === "newest"
      ? (b.most_recent_login || "").localeCompare(a.most_recent_login || "")
      : (a.most_recent_login || "").localeCompare(b.most_recent_login || ""));
  const neverLoggedIn = (summary || [])
    .filter(s => !s.most_recent_login)
    .filter(matchesLoginSearch)
    .sort((a, b) => (a.customer_name || "").localeCompare(b.customer_name || ""));

  // Scanning tab derivations. The tab re-sorts client-side (see scanRows);
  // the backend's Unclassified-first order is the API contract, not the
  // display order.
  const scanQuery = scanSearch.trim().toLowerCase();
  const matchesScanSearch = (s) => !scanQuery
    || (s.customer_name || "").toLowerCase().includes(scanQuery)
    || (s.slug || "").toLowerCase().includes(scanQuery)
    || (s.domains || "").toLowerCase().includes(scanQuery);
  // Elevated-roles match — INCLUSIVE semantics: Fabric = everyone with
  // fabric_admin (including both), Hybrid = everyone with hybrid_admin
  // (including both). Both and Neither are exact. Fabric + Hybrid tiles
  // therefore overlap by the Both count and do NOT sum to the fleet total.
  const matchesElevated = (s, key) => {
    const fab = !!s.fabric_admin, hyb = !!s.hybrid_admin;
    if (key === "fabric") return fab;
    if (key === "hybrid") return hyb;
    if (key === "both") return fab && hyb;
    if (key === "neither") return !fab && !hyb;
    return true; // "all"
  };
  const scanRows = (scanSummary || [])
    .filter(s => scanToolFilter === "all"
      || (scanToolFilter === "unclassified" ? !s.scan_tool : s.scan_tool === scanToolFilter))
    .filter(s => matchesElevated(s, scanElevatedFilter))
    .filter(matchesScanSearch)
    // Default sort: Scan Migration Date, newest first. Only a sliver of
    // the fleet has migrated, so blanks (including every Unclassified row)
    // sort LAST — nulls-first would bury the useful rows. ISO date strings
    // compare lexicographically; ties fall back to customer name.
    .sort((a, b) => {
      const am = a.migration_date || "", bm = b.migration_date || "";
      if (!!am !== !!bm) return am ? -1 : 1;
      if (am !== bm) return am > bm ? -1 : 1;
      return (a.customer_name || "").localeCompare(b.customer_name || "");
    });
  const scanCounts = (scanSummary || []).reduce((acc, s) => {
    if (s.scan_tool === "Legacy") acc.legacy += 1;
    // Its own count, not folded into Legacy: the two are one family but
    // separate members, and a fleet number that silently merged them would
    // hide how much of the legacy estate is auditor-run.
    else if (s.scan_tool === "Legacy - Auditor") acc.legacyAuditor += 1;
    else if (s.scan_tool === "SecureScan365") acc.ss365 += 1;
    else acc.unclassified += 1;
    if (s.auth_method === "TAP (Temporary Access Pass)") acc.tap += 1;
    if (s.fabric_admin) acc.fabric += 1;
    if (s.hybrid_admin) acc.hybrid += 1;
    if (s.fabric_admin && s.hybrid_admin) acc.both += 1;
    if (!s.fabric_admin && !s.hybrid_admin) acc.neither += 1;
    return acc;
  }, { legacy: 0, legacyAuditor: 0, ss365: 0, unclassified: 0, tap: 0, fabric: 0, hybrid: 0, both: 0, neither: 0 });

  // Access lifecycle derivations (client-side, Scan Fleet idiom). Pending
  // rows are excluded — the queue section above owns them.
  const accessQuery = accessSearch.trim().toLowerCase();
  const accessRows = (accessLifecycle || [])
    .filter(r => r.status_key && r.status_key !== "pending")
    .filter(r => accessShowAll ? true : r.status_key === "active")
    .filter(r => accessStatusFilter === "all" ? true : r.status_key === accessStatusFilter)
    .filter(r => !accessQuery
      || (r.name || "").toLowerCase().includes(accessQuery)
      || (r.email || "").toLowerCase().includes(accessQuery)
      || (r.customer_name || "").toLowerCase().includes(accessQuery))
    .sort((a, b) => {
      if (accessSort === "customer") return (a.customer_name || "").localeCompare(b.customer_name || "");
      if (accessSort === "decided")  return (b.decided_on || "").localeCompare(a.decided_on || "");
      return (b.requested_on || b.created_on || "").localeCompare(a.requested_on || a.created_on || ""); // requested, newest first
    });

  const toggleExpand = (slug) => {
    setRosterSlug(cur => (cur === slug ? "" : slug));
  };

  const thStyle = { padding:"10px 8px", borderBottom:`1px solid ${T.border}`, textAlign:"left", fontSize:12, color:T.muted, fontWeight:600, textTransform:"uppercase", letterSpacing:".04em" };
  const tdStyle = { padding:"10px 8px", borderBottom:`1px solid ${T.border}`, fontSize:13 };

  /* The ops row table, used by BOTH the backlog list and the "Just past
     due" section below it. One renderer, so the two cannot drift: the
     grace rows get the same status dropdown, the same Record skip
     action and the same diagnostic columns as the rows above them. A
     customer four days past their date is exactly who Amber wants to
     send a booking link to, so rendering them read-only would mean
     seeing them and then having to find them somewhere else. */
  // timingMode: "overdue" | "due" | "mixed". The first two are the focused
  // filters, unchanged. "mixed" is the combined views, where a boolean
  // cannot work: the API populates exactly one of days_overdue/days_until
  // per row, so whichever field a boolean picks renders null for the other
  // two buckets. Mixed asks the row what it is (schedulingTiming).
  // "none" is the row with no next audit date at all, which the All view
  // carries as of 2026-08-11. Muted deliberately: it is a state to notice,
  // not a deadline to act on today, and it must not compete with the red
  // and amber that mean "this one is late".
  const TIMING_TONES = { overdue: T.red, grace: T.yellow, due: T.text, none: T.muted };
  // Workflow-status register (operator decision 2026-08-11). Families, not
  // one colour per value — reviewOps.workflowTone owns the mapping and the
  // reasoning; this is only the paint.
  //
  //   resting    slate soft    Not Started
  //   inmotion   Navy soft     Booking Sent + the three live legacy steps
  //   confirmed  Navy SOLID    a date is on a calendar
  //   blocked    amber solid   waiting on something outside our control
  //   terminal   muted grey    Completed / Void — nobody selects these
  //
  // Patriot Navy #1E3A5C. Patriot Red #8B1A1C is deliberately absent: it
  // stays the contract-expired pill's alone.
  //
  // The soft/solid split inside Navy is doing real work. Booking Sent means
  // we have ASKED; the confirmed three mean it is ON A CALENDAR. Amber sits
  // outside the progression entirely because blocked is not a step forward.
  const WORKFLOW_TONES = {
    resting:   { bg:"rgba(148,163,184,0.14)", c:"#94A3B8", bd:"rgba(148,163,184,0.40)" },
    inmotion:  { bg:"rgba(30,58,92,0.45)",    c:"#AFC7E4", bd:"rgba(59,98,147,0.70)" },
    confirmed: { bg:"#1E3A5C",                c:"#DCE9F7", bd:"#3B6293" },
    blocked:   { bg:"#6B4405",                c:"#FDE68A", bd:"#F59E0B" },
    terminal:  { bg:"transparent",            c:T.muted,   bd:"rgba(148,163,184,0.25)" },
    unset:     { bg:"rgba(0,0,0,0.25)",       c:T.muted,   bd:T.border },
  };
  /* THE CLOSED CONTROL KEEPS ITS TONE; THE OPEN LIST IS PLAIN.
   *
   * Amber's screen share 2026-08-13: opening the Workflow status dropdown on
   * a "Not set" or "Not Started" row produced a nearly unreadable option
   * list — pale text on a pale background — while rows sitting on Meeting
   * Scheduled or an issue status opened fine.
   *
   * A native popup paints its option list from the SELECT's own colour and
   * background unless the options say otherwise, and four of the six tones
   * above are translucent or transparent (unset, resting, terminal,
   * inmotion). Those composite over the UA's light popup base, so the muted
   * text landed on near-white. The two SOLID tones (confirmed, blocked)
   * handed the popup a dark background and were legible by accident — which
   * is exactly why only some rows broke.
   *
   * So the paint splits by state. The closed control stays tone-coloured:
   * it is load-bearing, it is how the column reads at a glance, and it is
   * shipped and liked. Every option gets an EXPLICIT solid background and
   * light text, so the open list reads identically whatever the row's status
   * is. Existing tokens only — T.panel is the panel these tables sit on,
   * T.text its body colour. No new colour enters the palette.
   *
   * ONE STATEMENT, because the popup must not depend on which table the row
   * is in: reviewRowTable draws Scheduling (all sections) and both Scan
   * Queue sections, and this is the only workflow-status select in the app.
   *
   * NATIVE PAINT IS NOT DOM. macOS Chrome and Safari render this popup as a
   * system menu and ignore most author styling — they were already legible;
   * the DOM assertions in AdminPage.statusOptionContrast.test.js are the
   * proxy, and a real browser is the check. colorScheme on the select is the
   * same idiom the date inputs in this file use: it asks the UA to paint the
   * chrome we cannot style (arrow, scrollbar, popup base) dark rather than
   * light, so it stops fighting the parts we can. */
  const WORKFLOW_OPTION_STYLE = { background: T.panel, color: T.text };
  /** The "with engineers" chip, or null.
   *
   *  BOTH NUMBERS, NEVER ONE — the blockingLabel rule, and the reason this
   *  is a line BESIDE the day count rather than a replacement for it. A row
   *  sitting with the engineers is still 49 days overdue, and Amber needs
   *  both facts at once: the number tells her how bad it is, the chip tells
   *  her who to bug.
   *
   *  THE AGE ARRIVED 2026-08-13. #554 shipped this chip bare because no
   *  column recorded when a status was set — the four places checked are in
   *  that PR's Known gap section. pc_workflowstatusseton is that column
   *  now: every writer of pc_addtoengineerstracker stamps it in the same
   *  patch, and the backend serves the age as workflow_status_age_days
   *  computed against the caller's today.
   *
   *  THE AGE IS READ, NEVER COMPUTED HERE (date-authority rule). This
   *  component does no date arithmetic; workflowAgeLabel formats a number
   *  the server produced.
   *
   *  BARE WHEN THE AGE IS NULL, which is EVERY ROW until somebody sets a
   *  status after the deploy — the stamp accrues forward and nothing was
   *  backfilled. The chip degrades to exactly what #554 shipped rather than
   *  rendering "— undefined" or a fabricated zero.
   *
   *  Muted, existing palette, no new colour: it is an annotation, not a
   *  state. The Workflow status column is already saying WHICH of the two
   *  statuses this row is in. */
  const withEngineersLine = (r) => {
    if (!isWithEngineers(r)) return null;
    const age = workflowAgeLabel(r);
    return (
      <div style={{ fontSize:10.5, fontWeight:400, marginTop:3,
                    whiteSpace:"nowrap", color:T.muted }}>
        {age ? `${WITH_ENGINEERS_LABEL} — ${age}` : WITH_ENGINEERS_LABEL}
      </div>
    );
  };

  /** The queue's own age line: the same number, without the "with
   *  engineers" prefix that would be true of every row there.
   *
   *  "waiting 6d" / "waiting today" — the noun the section headings are
   *  already built around ("N customers" waiting on the engineers), so it
   *  needs no legend. Null renders nothing at all rather than a placeholder:
   *  an absent age is a fact about the row, and a dash in a column of real
   *  numbers reads as a rendering failure. */
  const waitingAgeLine = (r) => {
    const age = workflowAgeLabel(r);
    return age ? (
      <div style={{ fontSize:10.5, fontWeight:400, marginTop:3,
                    whiteSpace:"nowrap", color:T.muted }}>
        waiting {age}
      </div>
    ) : null;
  };

  /** The In-progress pill's refusal line: why the auto-run this passed-prereq
   *  row was waiting on did NOT start.
   *
   *  ONLY ON A `refused` auto_scan (autoScanRefusalLabel gates it) — a row
   *  with no auto_scan fact, or a claim still claimed/started, renders
   *  exactly as a queue row does now, with no second line. The words are the
   *  frontend's, from the closed code set; an unknown code yields null and no
   *  line, never a raw string.
   *
   *  `refused` IS TERMINAL per prereq outcome (REVIEW AR-3): the auto path
   *  does not retry it, so this reads as a settled state the reviewer acts on
   *  (fix access / start manually), NOT as a scan still in flight. Amber tone
   *  because it is a blockage the reader must see beside the waiting age, the
   *  same weight the "with engineers" annotations carry — no new colour. */
  const autoScanReasonLine = (r) => {
    const label = autoScanRefusalLabel(r);
    return label ? (
      <div style={{ fontSize:10.5, fontWeight:400, marginTop:3,
                    whiteSpace:"normal", color:T.yellow }}>
        {label}
      </div>
    ) : null;
  };

  /* ── "Run prereq check" — Amber's button, on the row she is looking at.
     ONE COMPONENT, BOTH SURFACES (operator placement ruling 2026-08-14).
     She runs the FIRST check on approaching customers from the Scheduling
     screen she already works in, and that outcome is what routes the row
     INTO the Scan Queue — a queue-only button could never start that
     cycle. On the queue it is the "Fix access" re-check and the
     "Run & publish" pre-run sanity check.

     SECURESCAN365 ROWS ONLY: a legacy-collection customer has no engine
     pre-flight to run, so the button is absent rather than disabled —
     there is nothing they could do to make it work.

     MINIMAL RESULT, deliberately (operator, 2026-08-13 call: "you
     wouldn't get all this other garbage"). Pass or fail, one word. The
     items, issues and remediation stay on the SecureScan365 tab, which is
     where somebody acts on them. The row's real answer is its Workflow
     status, which the automation writes and the next fleet read shows.

     REUSES THE SHIPPED ENDPOINTS: startScanPrereqCheck (no UPN — the
     backend resolves the scan account) then the same status poll the
     SecureScan365 tab uses. No new engine capability. */
  /** Re-read the fleet and splice ONE row's server state back in.
   *
   *  WHY A FLEET READ FOR ONE ROW, and why this shape rather than the two
   *  alternatives:
   *
   *   * NOT a client-side status write. The write is the backend's, made
   *     inside the result request; this is display catching up to it. The
   *     frontend calling a status API here would be a second statement of
   *     an automation rule that deliberately lives in one place.
   *   * NOT the applyStatusWrite merge idiom, which is the right tool when
   *     a write route hands back a RECOMPUTED ROW (bucket, severity,
   *     next_audit_date, day counts). The prereq route has none of those
   *     to give — it knows the status integer it wrote and nothing else —
   *     so feeding applyStatusWrite a partial would blank real fields.
   *
   *  Splicing one row rather than replacing the payload keeps the rest of
   *  the view exactly where she left it: other rows' `just_moved` notices,
   *  any in-flight checks, and the list order all survive. The row's own
   *  three confirmations — the Workflow status cell, the "with engineers"
   *  chip and the Scan Queue tab badge — all derive from
   *  workflow_status_value on this row, so one splice moves all three.
   *
   *  Silent by design: no loading flag, no error surface. It is a display
   *  refresh of a write that already succeeded, and a failed refresh means
   *  the operator sees the pre-2026-08-14 behaviour (reload to see it),
   *  never a wrong value and never a false alarm. */
  const refreshRowFromFleet = (slug) => {
    if (!slug) return;
    fetchReviewOps({ start: reviewStart || undefined, end: reviewEnd || undefined })
      .then(d => {
        const fresh = (d?.customers || []).find(c => c?.slug === slug);
        if (!fresh) return;
        setReviewOps(prev => (prev ? {
          ...prev,
          customers: (prev.customers || []).map(
            c => (c?.slug === slug ? { ...c, ...fresh } : c)),
        } : prev));
      })
      .catch(() => { /* display-only catch-up; the next load has the truth */ });
  };

  const runRowPrereq = (r) => {
    const slug = r?.slug;
    if (!slug || rowPrereq[slug]?.phase === "checking") return;
    const seq = (rowPrereqSeq.current[slug] || 0) + 1;
    rowPrereqSeq.current[slug] = seq;
    const live = () => rowPrereqSeq.current[slug] === seq;
    const settle = (patch) => { if (live()) setRowPrereq(m => ({ ...m, [slug]: patch })); };
    setRowPrereq(m => ({ ...m, [slug]: { phase: "checking" } }));

    const poll = (runId, ticks = 0) => {
      if (!live()) return;
      fetchScanStatus(runId)
        .then(s => {
          if (!live()) return;
          const state = s?.state || "";
          if (PREREQ_TERMINAL_STATES.has(state)) {
            if (state === "Cancelled") {
              settle({ phase: "done", error: "Cancelled" });
              return;
            }
            // Fetching the RESULT is what triggers the server-side status
            // write for a Patriot caller, so this call is load-bearing —
            // it is not merely how the button learns the answer. The sweep
            // is the backstop if this never happens.
            fetchScanPrereqResult(runId)
              .then(d => {
                settle({ phase: "done", outcome: d?.outcome });
                // READ AFTER WRITE (2026-08-14). The status write happened
                // INSIDE the request that just resolved, so the row on
                // screen is already stale — Amber used to see "Passed" on
                // this button and the old status beside it until she
                // reloaded. `workflow_status_applied` is the SERVER's
                // report of what it wrote: non-null means a write
                // happened, which is a stricter and more honest trigger
                // than re-deriving the outcome→status mapping here (that
                // mapping is the backend's, and a copy of it would drift).
                // Null covers every no-write case at once — a diagnostic
                // check, an out-of-domain row, a repeat verdict,
                // couldNotEvaluate — and an older backend that does not
                // send the field simply behaves as it did before.
                if (d?.workflow_status_applied != null) refreshRowFromFleet(slug);
              })
              .catch(() => settle({ phase: "done", error: "Couldn’t read the result" }));
            return;
          }
          if (ticks >= 40) {
            settle({ phase: "done", error: "Timed out" });
            return;
          }
          setTimeout(() => poll(runId, ticks + 1), 3000);
        })
        .catch(() => {
          if (!live()) return;
          if (ticks >= 40) { settle({ phase: "done", error: "Couldn’t poll" }); return; }
          setTimeout(() => poll(runId, ticks + 1), 3000);
        });
    };

    // WORKFLOW INTENT DECLARED HERE (2026-08-14), and only here. This
    // button is a workflow act on every surface it appears: on Scheduling
    // its outcome is what routes the row INTO the queue, and on the queue
    // the Fix-access re-check and the Run & publish pre-run check are how
    // a row leaves it — a queue re-check that could not move the row would
    // break the Fix access -> pass -> Run & publish loop. The SecureScan365
    // tab's own Check Prerequisites button sends nothing and is untouched.
    startScanPrereqCheck(slug, undefined, { workflow: true })
      .then(d => {
        if (!live()) return;
        const runId = resolvePrereqAckRunId(d);
        if (!runId) { settle({ phase: "done", error: "No run id" }); return; }
        poll(runId);
      })
      .catch(e => {
        // The setup-gap codes (NO_PASSKEY_REGISTERED, SCAN_ACCOUNT_STALE,
        // SCAN_ACCOUNT_AMBIGUOUS) are Patriot-only and say exactly which
        // gap stopped it — surfaced verbatim rather than flattened to
        // "failed", because each one has a different fix.
        settle({ phase: "done", error: e?.body?.error || e?.message || "Failed" });
      });
  };

  /** The button plus its transient state, or null on a non-SecureScan365
   *  row. Pass/fail only; the status column carries the durable answer.
   *
   *  RENDERED INSIDE THE SCAN METHOD CELL (2026-08-14), beneath the pill —
   *  hence the top margin here rather than at the call site: the spacing
   *  belongs to this control, and the cell should not have to know it. */
  const prereqCell = (r) => {
    if (r?.scan_tool_key !== "securescan365") return null;
    const state = rowPrereq[r.slug];
    if (state?.phase === "checking") {
      return (
        <div style={{ fontSize:11, color:T.muted, marginTop:5 }}>Checking…</div>
      );
    }
    const label = state?.phase === "done"
      ? (state.error ? state.error
        : state.outcome === "ready" ? "Passed"
        : state.outcome === "blocked" ? "Issue found"
        // couldNotEvaluate and anything the engine adds later: the check
        // ran and reached no verdict. NOT rendered as a failure — the
        // automation writes nothing for it and neither does this cell.
        : "No verdict")
      : null;
    return (
      <div style={{ display:"flex", flexDirection:"column", gap:3,
                    alignItems:"flex-start", marginTop:5 }}>
        <button
          onClick={() => runRowPrereq(r)}
          title="Run the SecureScan365 prerequisites check for this customer"
          style={{
            padding:"3px 8px", fontSize:11, borderRadius:6, cursor:"pointer",
            fontFamily:"inherit", whiteSpace:"nowrap",
            border:`1px solid ${T.border}`,
            background:"rgba(255,255,255,.05)", color:T.blue,
          }}
        >Run prereq check</button>
        {label && (
          <span style={{ fontSize:10.5, color: state.error ? T.muted : T.text,
                         whiteSpace:"nowrap" }}>{label}</span>
        )}
      </div>
    );
  };

  const reviewRowTable = (rows, {
    overdueColumn, dayTone, timingMode,
    // Default ON: every Scheduling call site wants it, and the Scan Queue —
    // where the chip would be true of every row and therefore say nothing —
    // is the single site that turns it off. The queue substitutes
    // `waitingAge`, which carries the same number without the prefix.
    withEngineersChip = true,
    waitingAge = false,
    // The In-progress pill turns this on: a passed-prereq row whose auto-run
    // was REFUSED gets a second line naming why (design §5d/§7c). Off
    // everywhere else — no other list carries the auto_scan fact.
    autoScanReason = false,
    // Scheduling only. This table also renders Scan Queue rows, where the
    // outreach model is noise beside the engineer-owned work state.
    showAllowanceModel = false,
    // Banked-filter only. Keeps the outreach contract out of every shared
    // renderer consumer (focused Scheduling views, Scan Queue and Delivery).
    bankedOutreach = false,
    // All-only. The combined universe contains explicit Banked rows, which
    // must use their server-owned outreach projection instead of the Legacy
    // next-audit/day facts the shared timing branch normally renders.
    modelAwareOutreach = false,
    // Scheduling only: a plain click on the customer name opens the
    // customer drawer, stepping through this table's rows. OFF by default
    // so the Scan Queue, which draws the same row, keeps its dashboard link.
    onOpenCustomer = undefined,
  } = {}) => (
                  <TableScroll>
                  <table style={{ width:"100%", borderCollapse:"collapse" }}>
                    <thead><tr>
                      <th style={thStyle}>Customer</th>
                      {modelAwareOutreach && (
                        <th data-testid="all-outreach-header"
                            style={{ ...thStyle, width:180 }}>
                          Outreach
                        </th>
                      )}
                      {!bankedOutreach && !modelAwareOutreach && (
                        <>
                          <th style={{ ...thStyle, width:110, textAlign:"right" }}>
                            {timingMode === "mixed" ? "Timing"
                              : overdueColumn ? "Days overdue" : "Due in"}
                          </th>
                          <th style={{ ...thStyle, width:130 }}>Next audit</th>
                        </>
                      )}
                      {!bankedOutreach && (
                        <th style={{ ...thStyle, width:80 }}>Cycle</th>
                      )}
                      {bankedOutreach && (
                        <th data-testid="banked-annual-header"
                            style={{ ...thStyle, width:140 }}>
                          Allowance
                        </th>
                      )}
                      {bankedOutreach && (
                        <th data-testid="banked-timing-header"
                            style={{ ...thStyle, width:170 }}>
                          Outreach timing
                        </th>
                      )}
                      {bankedOutreach && (
                        <th data-testid="banked-scheduled-header"
                            style={{ ...thStyle, width:130 }}>
                          Scheduled review
                        </th>
                      )}
                      {/* Tier came off on 2026-08-09 to make room for
                          Readiness: it drives reviews-per-year, which
                          already surfaces in the dialogs where it is
                          used, and from this list it neither triggers
                          an action nor explains a blockage — every
                          other column does one or the other (operator
                          decision). It lives on in the customer-name
                          tooltip and stays in the payload. */}
                      <th style={{ ...thStyle, width:140 }}>
                        {modelAwareOutreach ? "Booking Readiness" : "Readiness"}
                      </th>
                      <th style={{ ...thStyle, width:150 }}>
                        {modelAwareOutreach ? "Workflow Status" : "Workflow status"}
                      </th>
                      {/* Scan method stays: the delivery engineers work
                          this list to plan their day and need to see at
                          a glance who they can scan and how. Contacts
                          and Signed in came off on 2026-08-08 — not what
                          a person acts on from here, and the row was
                          eleven columns wide. That data is RELOCATING to
                          a Customer Engagement page; the helpers and the
                          payload fields are retained. */}
                      {/* Widened 130 -> 150 on 2026-08-14: the prereq
                          button moved INTO this cell, under the pill. */}
                      <th style={{ ...thStyle, width:150 }}>
                        {modelAwareOutreach ? "Scan Method" : "Scan method"}
                      </th>
                      {!bankedOutreach && (
                        <th style={thStyle}>
                          {modelAwareOutreach ? "Last Review" : "Last review"}
                        </th>
                      )}
                      {modelAwareOutreach && (
                        <th data-testid="all-latest-note-header"
                            style={{ ...thStyle, width:52, textAlign:"center" }}>
                          Notes
                        </th>
                      )}
                      {!bankedOutreach && (
                        <th style={{ ...thStyle, width:100 }}>Contract</th>
                      )}
                      <th style={{ ...thStyle, width:100 }}>
                        {bankedOutreach ? "Action" : ""}
                      </th>
                    </tr></thead>
                    <tbody>
                      {rows.map((r) => {
                        const cycle = cycleLabel(r);
                        const workflow = workflowLabel(r);
                        const wfTone = WORKFLOW_TONES[workflowTone(r)]
                          || WORKFLOW_TONES.unset;
                        const hasLast = !!r.last_review?.review_date;
                        // Readiness pill, with the booking-workflow override
                        // applied (2026-08-11). Computed here rather than in
                        // the cell because the TOOLTIP needs it too: when the
                        // workflow speaks for the pill, the scan's own state
                        // has to stay reachable somewhere.
                        const readyPill = readinessPillForRow(r);
                        const operationsNotesIcon = normalizeOperationsNotesIcon(
                          r.operations_notes_icon,
                        );
                        const bankedContractException = r.contract_expired
                          ? { label:"Contract expired", type:"red" }
                          : ["On Hold", "Pending", "Open"].includes(r.contract_status)
                            ? {
                                label:contractDisplayLabel(r.contract_status),
                                type:r.contract_status === "On Hold" ? "amber"
                                  : r.contract_status === "Pending" ? "indigo"
                                    : "slate",
                              }
                            : null;
                        return (
                          <tr key={r.slug}>
                            {/* See-who-is-overdue then go-look-at-them:
                                ?client={slug}#/overview, the same
                                ?client param the Publishing tab uses. */}
                            <td style={{ ...tdStyle, fontWeight:600 }}>
                              <a
                                href={reviewCustomerUrl(r.slug)}
                                onClick={onOpenCustomer
                                  ? (e) => onOpenCustomer(e, r, rows) : undefined}
                                style={{ color:T.blue, textDecoration:"none" }}
                                title={`Open ${r.customer_name || r.slug}`
                                  + (r.tier ? ` · ${r.tier}` : "")}
                              >
                                {r.customer_name || r.slug}
                              </a>
                              {showAllowanceModel && !bankedOutreach && (() => {
                                const tag = allowanceModelTag(r.allowance_model);
                                return (
                                  <div style={{ marginTop:5 }}>
                                    <span
                                      data-testid="allowance-model-tag"
                                      style={{
                                        display:"inline-block", padding:"1px 7px",
                                        fontSize:10.5, fontWeight:600,
                                        borderRadius:999, whiteSpace:"nowrap",
                                        ...tag.style,
                                      }}
                                    >
                                      {tag.label}
                                    </span>
                                  </div>
                                );
                              })()}
                              {bankedOutreach && bankedContractException && (
                                <div data-testid="banked-contract-exception"
                                     style={{ marginTop:5 }}
                                     title={r.contract_expired
                                       ? contractCellTitle(r) : undefined}>
                                  <Badge type={bankedContractException.type} weight="soft">
                                    {bankedContractException.label}
                                  </Badge>
                                </div>
                              )}
                            </td>
                            {!bankedOutreach && (modelAwareOutreach
                              && r.allowance_model === "banked" ? (() => {
                              const timing = r.banked_outreach?.timing;
                              const reviewTimingStates = ["green", "amber", "red"];
                              const timingValid = (
                                reviewTimingStates.includes(timing?.state)
                                && ["last_review", "next_audit"].includes(timing?.basis)
                              ) || (
                                timing?.state === "unavailable"
                                && timing?.basis === "unavailable"
                              );
                              const timingState = timingValid ? timing.state : "unavailable";
                              const colors = {
                                red:T.red, amber:T.yellow,
                                unavailable:T.muted, green:T.green,
                              };
                              const timingAvailable = timingValid && timingState !== "unavailable";
                              const primary = !timingValid
                                ? "Outreach unavailable"
                                : timingState === "unavailable"
                                  ? (timing?.text || "Outreach unavailable")
                                  : timingAvailable
                                ? (timing?.basis === "last_review"
                                  ? (timing?.text || "—")
                                  : "No completed review")
                                : "Outreach unavailable";
                              const scheduled = r.banked_outreach?.scheduled_review;
                              const isScheduled = timingValid
                                && scheduled?.state === "scheduled"
                                && !!scheduled?.date;
                              return (
                                <td data-testid="all-banked-outreach-cell"
                                    data-timing-state={timingState}
                                    data-scheduled-state={timingValid
                                      ? (scheduled?.state || "unavailable") : "unavailable"}
                                    style={{ ...tdStyle, color:colors[timingState],
                                             fontWeight:timingState === "red" ? 600 : 400,
                                             textAlign:"left",
                                             whiteSpace:"nowrap" }}>
                                  {primary}
                                  {timingAvailable && timing?.detail_text && (
                                    <div style={{ fontSize:10.5, color:T.muted,
                                                  fontWeight:400, marginTop:3 }}>
                                      {timing.detail_text}
                                    </div>
                                  )}
                                  {isScheduled && (
                                    <div style={{ fontSize:10.5, color:T.muted,
                                                  fontWeight:400, marginTop:3 }}>
                                      Scheduled {fmtDateOnly(scheduled.date)}
                                    </div>
                                  )}
                                </td>
                              );
                            })() : (timingMode === "mixed" ? (() => {
                              const t = schedulingTiming(r);
                              return (
                                <td data-testid={modelAwareOutreach
                                      ? "all-legacy-outreach-cell" : undefined}
                                    style={{
                                  ...tdStyle,
                                  textAlign:modelAwareOutreach ? "left" : "right",
                                  whiteSpace:"nowrap",
                                  color: TIMING_TONES[t.tone] || T.text,
                                  // Bold is for urgency. "due" and the
                                  // dateless "none" both stay regular.
                                  fontWeight: (t.tone === "due" || t.tone === "none") ? 400 : 600,
                                }} title={dayCountTitle(r, reviewOps?.meta)}>
                                  {t.text}
                                  {t.note && (
                                    <div style={{ fontSize:10.5, color:T.muted,
                                                  fontWeight:400, marginTop:3 }}>
                                      {t.note}
                                    </div>
                                  )}
                                  {/* THE SAME LINE THE FOCUSED BRANCH DRAWS
                                      (bug fixed 2026-08-12, reproduced by
                                      Amber on the call: Rotary's access
                                      meeting showed on Backlog and not on
                                      All). blockingLabel was added to the
                                      focused-bucket cell only, and the All /
                                      On Hold views take this mixed branch —
                                      so the annotation vanished on exactly
                                      the views that mix buckets. Same copy,
                                      same styling, same lift colour switch;
                                      the timing text above is untouched,
                                      because a suppressed row is still as
                                      overdue as it was. */}
                                  {blockingLabel(r, fmtDateOnly) && (
                                    <div style={{ fontSize:10.5, fontWeight:400,
                                                  marginTop:3, whiteSpace:"nowrap",
                                                  color: r.blocking_lifted ? T.blue : T.muted }}>
                                      {blockingLabel(r, fmtDateOnly)}
                                    </div>
                                  )}
                                  {rebookLabel(r) && (
                                    <div style={{ fontSize:10.5, fontWeight:400,
                                                  marginTop:3, whiteSpace:"nowrap",
                                                  color: T.muted }}>
                                      {rebookLabel(r)}
                                    </div>
                                  )}
                                  {/* BOTH BRANCHES, ALWAYS — the 2026-08-12
                                      lesson again. This is the branch the
                                      All and On Hold views take, and the
                                      one the Scan Queue takes. */}
                                  {withEngineersChip && withEngineersLine(r)}
                                  {waitingAge && waitingAgeLine(r)}
                                  {autoScanReason && autoScanReasonLine(r)}
                                  {modelAwareOutreach && (
                                    <div style={{ fontSize:10.5, color:T.muted,
                                                  fontWeight:400, marginTop:3 }}>
                                      Next audit {fmtDateOnly(r.next_audit_date)}
                                    </div>
                                  )}
                                </td>
                              );
                            })() : (
                            <td style={{
                              ...tdStyle, textAlign:"right", whiteSpace:"nowrap",
                              color: overdueColumn ? (dayTone || T.red) : T.text,
                              fontWeight: overdueColumn ? 600 : 400,
                            }} title={overdueColumn ? dayCountTitle(r, reviewOps?.meta) : undefined}>
                              {overdueColumn
                                ? `${r.days_overdue} d`
                                : (r.days_until === 0 ? "Today" : `${r.days_until} d`)}
                              {/* The follow-up window, named on the ROW —
                                  the calendar number above stays the one
                                  unit in this column (and the sort key);
                                  this line says which window governs it. */}
                              {overdueColumn && followUpProgressLabel(r, reviewOps?.meta) && (
                                <div style={{ fontSize:10.5, color:T.muted,
                                              fontWeight:400, marginTop:3 }}>
                                  {followUpProgressLabel(r, reviewOps?.meta)}
                                </div>
                              )}
                              {/* BOTH NUMBERS, NEVER ONE. The day count above
                                  is unchanged — a suppressed row is still 94
                                  days overdue — and this says what is holding
                                  it. Once the date passes, the same line
                                  becomes the lift marker instead. */}
                              {blockingLabel(r, fmtDateOnly) && (
                                <div style={{ fontSize:10.5, fontWeight:400,
                                              marginTop:3, whiteSpace:"nowrap",
                                              color: r.blocking_lifted ? T.blue : T.muted }}>
                                  {blockingLabel(r, fmtDateOnly)}
                                </div>
                              )}
                              {/* BOTH BRANCHES, ALWAYS — the 2026-08-12
                                  lesson: an annotation added to one
                                  timing cell vanishes on exactly the
                                  views that mix buckets. */}
                              {rebookLabel(r) && (
                                <div style={{ fontSize:10.5, fontWeight:400,
                                              marginTop:3, whiteSpace:"nowrap",
                                              color: T.muted }}>
                                  {rebookLabel(r)}
                                </div>
                              )}
                              {withEngineersChip && withEngineersLine(r)}
                              {waitingAge && waitingAgeLine(r)}
                              {autoScanReason && autoScanReasonLine(r)}
                            </td>
                            )))}
                            {!bankedOutreach && !modelAwareOutreach && (
                              <td style={{ ...tdStyle, color:T.muted, whiteSpace:"nowrap" }}>
                                {fmtDateOnly(r.next_audit_date)}
                              </td>
                            )}
                            {!bankedOutreach && (
                              <td style={{ ...tdStyle, color: cycle ? T.text : T.muted,
                                           whiteSpace:"nowrap" }}>
                                {cycle || "Off cycle"}
                              </td>
                            )}
                            {bankedOutreach && (() => {
                              const annual = r.banked_outreach?.annual;
                              const available = Number.isInteger(annual?.included)
                                && Number.isInteger(annual?.used);
                              const year = Number.isInteger(r.contract_year)
                                && r.contract_year > 0 ? r.contract_year : null;
                              return (
                                <td data-testid="banked-annual-cell"
                                    style={{ ...tdStyle, color:available ? T.text : T.muted,
                                             whiteSpace:"nowrap" }}>
                                  {available
                                    ? `${annual.used} of ${annual.included} used`
                                    : "Unavailable"}
                                  {available && year && (
                                    <div style={{ fontSize:10.5, color:T.muted,
                                                  fontWeight:400, marginTop:3 }}>
                                      Year {year}
                                    </div>
                                  )}
                                </td>
                              );
                            })()}
                            {bankedOutreach && (() => {
                              const timing = r.banked_outreach?.timing;
                              const colors = {
                                red:T.red, amber:T.yellow,
                                unavailable:T.muted, green:T.green,
                              };
                              const reviewDetail = [
                                timing?.review_date
                                  ? fmtDateOnly(timing.review_date) : null,
                                timing?.reviewer_name,
                              ].filter(Boolean).join(" · ");
                              const detail = timing?.detail_text || reviewDetail;
                              return (
                                <td data-testid="banked-timing-cell"
                                    data-timing-state={timing?.state || "unavailable"}
                                    style={{ ...tdStyle,
                                             color:colors[timing?.state] || T.muted,
                                             fontWeight:timing?.state === "red" ? 600 : 400,
                                             whiteSpace:"nowrap" }}>
                                  {timing?.basis === "last_review"
                                    ? (timing?.text || "—")
                                    : "No completed review"}
                                  {detail && (
                                    <div style={{ fontSize:10.5, color:T.muted,
                                                  fontWeight:400, marginTop:3 }}>
                                      {detail}
                                    </div>
                                  )}
                                </td>
                              );
                            })()}
                            {bankedOutreach && (() => {
                              const scheduled = r.banked_outreach?.scheduled_review;
                              const state = scheduled?.state;
                              const text = state === "scheduled" && scheduled?.date
                                ? fmtDateOnly(scheduled.date)
                                : state === "missing_date" ? "Date missing"
                                  : state === "unscheduled" ? "Unscheduled" : "—";
                              return (
                                <td data-testid="banked-scheduled-cell"
                                    data-scheduled-state={state || "unavailable"}
                                    style={{ ...tdStyle,
                                             color:state === "missing_date"
                                               ? T.red : state ? T.text : T.muted,
                                             fontWeight:state === "missing_date" ? 600 : 400,
                                             whiteSpace:"nowrap" }}>
                                  {text}
                                </td>
                              );
                            })()}
                            {/* The conclusion, not a date (spec): the
                                pill answers "can I book this customer"
                                without comparing columns. The scan date
                                renders on EVERY ready row (and rescan
                                rows) so the first amber row has a
                                reference point; threshold copy in the
                                title comes from meta, never a literal. */}
                            {/* The tooltip LEADS with the scan's own state
                                whenever the booking workflow has overridden
                                the pill. Without it the override could hide a
                                state outright: readinessTitle may only have
                                supporting facts for a retired/unknown state,
                                so a skewed row reading "Booked" still keeps
                                the scan-side answer available. */}
                            <td style={tdStyle} title={[
                              readyPill.overriddenFrom
                                && `Scan readiness: ${readyPill.overriddenFrom}`,
                              readinessTitle(r.readiness, fmtDateOnly, reviewOps?.meta, r),
                            ].filter(Boolean).join(" · ")}>
                              {(() => {
                                /* READINESS_TONE_COLOR (module scope) is the
                                   one statement of this map — the filter
                                   chips' dots read the same object. Customer
                                   booked is the one presentation-only
                                   exception: it keeps the muted booked tone
                                   and shared key, while this cell adds the
                                   James-approved slate fill to show source. */
                                const c = readinessToneColor(readyPill.tone);
                                const isCustomerBooked = readyPill.presentation === "filled_slate";
                                const scanDate = readinessScanDate(r.readiness, fmtDateOnly);
                                return (
                                  <>
                                    <span style={{
                                      display:"inline-block", padding:"2px 8px",
                                      fontSize:11, fontWeight:600, borderRadius:999,
                                      whiteSpace:"nowrap",
                                      color: isCustomerBooked ? T.text : c,
                                      border: isCustomerBooked ? "1px solid rgba(168,189,220,.65)" : `1px solid ${c}55`,
                                      background: isCustomerBooked ? "#55657A" : `${c}1a`,
                                    }}>
                                      {readyPill.label}
                                    </span>
                                    {scanDate && (
                                      <div style={{ fontSize:11, color:T.muted,
                                                    marginTop:3, whiteSpace:"nowrap" }}>
                                        {scanDate}
                                      </div>
                                    )}
                                  </>
                                );
                              })()}
                            </td>
                            {/* Inline status write (Phase A.5). She sets
                                state; the system stamps dates. The date
                                field appears ONLY for the statuses whose
                                rule is require_date, and that list comes
                                from the same table the backend validates
                                against, so form and write cannot disagree.
                                "Not set" is still a real state (183 of 385
                                rows), never a blank. */}
                            <td style={tdStyle}>
                              <select
                                /* The PENDING pick, not a permanent ""
                                   placeholder: the old value snapped back
                                   to the saved status on the re-render the
                                   pick itself caused, so the dropdown
                                   contradicted the editor open beneath it
                                   (bugfix 2026-08-10). */
                                value={pendingStatusValue(r.slug, statusEdit, statusConfirm)}
                                disabled={statusBusySlug === r.slug}
                                onChange={(e) => handleStatusPick(r, e.target.value)}
                                style={{
                                  width:"100%", padding:"4px 6px", fontSize:12,
                                  borderRadius:6, fontFamily:"inherit",
                                  border:`1px solid ${wfTone.bd}`,
                                  background:wfTone.bg,
                                  color: workflow === "Not set" || workflow === "—"
                                    ? T.muted : wfTone.c,
                                  fontWeight: workflowTone(r) === "confirmed" ? 600 : 400,
                                  cursor: statusBusySlug === r.slug ? "wait" : "pointer",
                                  colorScheme:"dark",
                                }}
                              >
                                {/* The placeholder is styled TOO: it is the
                                    first line of the open list, not only the
                                    closed control's label. */}
                                <option value="" style={WORKFLOW_OPTION_STYLE}>
                                  {statusBusySlug === r.slug ? "Saving…" : workflow}
                                </option>
                                {statusOptions(reviewOps.meta).map(o => (
                                  <option key={o.value} value={o.value}
                                          style={WORKFLOW_OPTION_STYLE}>{o.label}</option>
                                ))}
                              </select>
                              {(() => {
                                const line = workflowDateLine(r, fmtDateOnly);
                                const duplicateScheduled = r.workflow_status_value === 125470011
                                  && r.allowance_model !== "banked"
                                  && !!blockingLabel(r, fmtDateOnly) && !r.blocking_lifted;
                                return line && !duplicateScheduled ? (
                                  <div style={{ fontSize:10.5, color:T.muted, fontWeight:400, marginTop:3 }}>{line}</div>
                                ) : null;
                              })()}
                              {statusEdit?.slug === r.slug && (
                                <div style={{ display:"flex", gap:6, marginTop:6, alignItems:"center" }}>
                                  <input
                                    type="date"
                                    value={statusEdit.date}
                                    autoFocus
                                    onChange={(e) => setStatusEdit(st => ({ ...st, date:e.target.value }))}
                                    style={{ padding:"4px 6px", fontSize:12, borderRadius:6,
                                             border:`1px solid ${T.border}`, background:"rgba(0,0,0,0.25)",
                                             color:T.text, colorScheme:"dark" }}
                                  />
                                  <button
                                    onClick={() => handleStatusDateSubmit(r)}
                                    disabled={!statusEdit.date}
                                    style={{ padding:"4px 10px", fontSize:12, borderRadius:6,
                                             fontFamily:"inherit", cursor: statusEdit.date ? "pointer" : "not-allowed",
                                             border:`1px solid ${T.border}`,
                                             background:"rgba(255,255,255,.06)", color:T.text }}
                                  >Set</button>
                                  <button
                                    onClick={() => setStatusEdit(null)}
                                    style={{ padding:"4px 8px", fontSize:12, borderRadius:6,
                                             fontFamily:"inherit", cursor:"pointer", border:"none",
                                             background:"none", color:T.muted }}
                                  >Cancel</button>
                                </div>
                              )}
                              {/* The row STAYS put and says where it went —
                                  a row vanishing on click is
                                  indistinguishable from a failure. */}
                              {r.just_moved && (
                                <div style={{ fontSize:11, color:T.blue, marginTop:5 }}>
                                  Moved to {BUCKET_LABELS[r.just_moved] || r.just_moved}
                                </div>
                              )}
                              {hasOpenRequest(r) && (
                                <div
                                  data-testid="review-request-row-marker"
                                  title="Customer requested a Recommendations Review from the portal"
                                  style={{
                                    display:"inline-block", marginTop:5,
                                    padding:"1px 7px", fontSize:11,
                                    fontWeight:600, borderRadius:999,
                                    whiteSpace:"nowrap", color:T.yellow,
                                    border:`1px solid ${T.yellow}55`,
                                    background:`${T.yellow}1a`,
                                  }}
                                >
                                  Review requested
                                </div>
                              )}
                              {statusError?.slug === r.slug && (
                                <div style={{ fontSize:11, color:T.red, marginTop:5 }}>
                                  {statusError.message}
                                </div>
                              )}
                              {/* Unrecorded-review badge: the meeting
                                  date passed the grace with the status
                                  still Meeting Scheduled — the review
                                  almost certainly happened. The fix is
                                  a Review Complete press, which lives
                                  on the customer page the link opens.
                                  Renders ALONGSIDE any contract-expired
                                  annotation — different actions for
                                  different people. */}
                              {unrecordedBadge(r) && (
                                <a
                                  href={reviewCustomerUrl(r.slug)}
                                  title={unrecordedTitle(r, reviewOps?.meta)}
                                  style={{
                                    display:"inline-block", marginTop:5,
                                    padding:"1px 7px", fontSize:11,
                                    fontWeight:600, borderRadius:999,
                                    whiteSpace:"nowrap", color:T.blue,
                                    border:`1px solid ${T.blue}55`,
                                    background:`${T.blue}1a`,
                                    textDecoration:"none",
                                  }}
                                >
                                  {unrecordedBadge(r)}
                                </a>
                              )}
                            </td>
                            {/* ScanMethodPill, not ScanMethodChip: the
                                pill states a customer's CURRENT tool
                                from scan_tool_key, which is this column.
                                The chip is per-SCAN ("Collected with …")
                                and its own header calls that distinction
                                deliberate. Null → "Unclassified". */}
                            {/* THE PREREQ BUTTON LIVES HERE (2026-08-14),
                                directly under the pill it depends on.
                                It had its own unlabelled column over on
                                the right, beside the row action — and the
                                operator report is that it went unnoticed
                                in practice: the button exists BECAUSE of
                                what this column says (SecureScan365 rows
                                only), so the far-right placement separated
                                the control from its own reason. Same
                                gating, same component, same transient
                                verdict text; only the cell changed. */}
                            <td style={tdStyle}>
                              <ScanMethodPill scanToolKey={r.scan_tool_key} compact />
                              {prereqCell(r)}
                            </td>
                            {!bankedOutreach && (
                              <>
                                <td style={{ ...tdStyle, color: hasLast ? T.text : T.muted }}>
                                  {lastReviewLabel(r, { fmtDate: fmtDateOnly })}
                                </td>
                            {modelAwareOutreach && (
                              <td data-testid="all-latest-note-cell"
                                  data-note-state={operationsNotesIcon.state}
                                  style={{ ...tdStyle, width:52, textAlign:"center" }}>
                                <button
                                  type="button"
                                  data-testid="all-latest-note-open"
                                  onClick={() => openCustomerOperationsNotes(r)}
                                  style={{ border:"none", padding:4, background:"none", cursor:"pointer",
                                           opacity:operationsNotesIcon.state === "unavailable" ? .55 : 1,
                                           color:operationsNotesIcon.state === "pink" ? T.pink : T.muted }}
                                  aria-label={`Customer Operations Notes for ${r.customer_name || r.slug || "customer"} — ${operationsNotesIcon.state === "pink" ? `${operationsNotesIcon.unresolved_count} unresolved` : operationsNotesIcon.state === "gray" ? "no active notes" : "unavailable"}`}
                                  title={`Customer Operations Notes for ${r.customer_name || r.slug || "customer"} — ${operationsNotesIcon.state === "pink" ? `${operationsNotesIcon.unresolved_count} unresolved` : operationsNotesIcon.state === "gray" ? "no active notes" : "unavailable"}`}
                                >
                                  <svg aria-hidden="true" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M4 5h16v11H7l-3 3V5z" /><path d="M8 9h8M8 12h5" /></svg>
                                </button>
                              </td>
                            )}
                            {/* Contract-state anomalies live HERE — the
                                same argument that kept this column in
                                the readiness trade: On Hold's value is
                                inverse to its frequency, and expired-
                                but-entitled is rarer and higher-stakes
                                still. Annotates, never hides. */}
                            {/* ENGAGEMENT TYPE DOES NOT COMPETE ON COLOUR.
                                Colour in this column means contract HEALTH
                                — red is an expired-but-entitled row, the
                                rare high-stakes anomaly this column was
                                kept for. A One Time engagement is a normal,
                                healthy state, so it reads as the muted
                                slate soft tag (the Skipped-tag chassis from
                                Delivery) and leaves the red channel alone.
                                The expired case still wins the cell
                                outright, label and all. */}
                                <td style={{ ...tdStyle,
                                             color: r.contract_expired ? T.red : T.muted,
                                             fontWeight: r.contract_expired ? 600 : 400 }}
                                    title={contractCellTitle(r)}>
                                  {contractCellLabel(r, fmtDateOnly)
                                    || (contractDisplayLabel(r.contract_status)
                                      ? <Badge type="slate" weight="soft">
                                          {contractDisplayLabel(r.contract_status)}
                                        </Badge>
                                      : "—")}
                                </td>
                              </>
                            )}
                            {/* Row action — Amber records skips from her
                                queue, not from a customer's
                                Recommendations page. The Review Complete
                                dialog stays about reviews an auditor
                                delivered. */}
                            <td style={{ ...tdStyle, textAlign:"right" }}>
                              <button
                                onClick={() => openSkip(r)}
                                style={{
                                  padding:"4px 10px", fontSize:11, borderRadius:6,
                                  fontFamily:"inherit", cursor:"pointer", whiteSpace:"nowrap",
                                  border:`1px solid ${T.border}`,
                                  background:"rgba(255,255,255,.04)", color:T.muted,
                                }}
                              >Record skip</button>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                  </TableScroll>
  );

  // One customer row (+ its expanded roster row) for the Logins table.
  const loginRow = (s) => {
    const expanded = rosterSlug === s.slug;
    return (
      <React.Fragment key={s.slug}>
        <tr onClick={() => toggleExpand(s.slug)} style={{ cursor:"pointer" }}>
          <td style={{ ...tdStyle, fontWeight:600, color:T.text }}>
            <span style={{ display:"inline-block", width:14, color:T.muted, fontSize:10 }}>{expanded ? "▼" : "▶"}</span>
            {s.customer_name || s.slug}
          </td>
          <td style={{ ...tdStyle, color: s.most_recent_login ? T.text : T.muted }}>
            {s.most_recent_login ? fmtDate(s.most_recent_login) : "Never"}
          </td>
          <td style={{ ...tdStyle, textAlign:"right", color:T.muted }}>{s.active_user_count ?? 0}</td>
        </tr>
        {expanded && (
          <tr>
            <td colSpan={3} style={{ ...tdStyle, padding:"4px 8px 14px 22px", background:"rgba(255,255,255,0.02)" }}>
              {rosterError && (
                <div style={{ fontSize:13, color:T.red, padding:"8px 0" }}>Couldn’t load the roster for this customer. Please try again.</div>
              )}
              {!rosterError && roster === null && (
                <div style={{ fontSize:13, color:T.muted, padding:"8px 0" }}>Loading…</div>
              )}
              {!rosterError && roster && roster.length === 0 && (
                <div style={{ fontSize:13, color:T.muted, padding:"8px 0" }}>No portal access rows for this customer.</div>
              )}
              {!rosterError && roster && roster.length > 0 && (
                <TableScroll>
                <table style={{ width:"100%", borderCollapse:"collapse" }}>
                  <thead><tr>
                    <th style={thStyle}>Name</th>
                    <th style={thStyle}>Email</th>
                    <th style={{ ...thStyle, width:110 }}>Status</th>
                    <th style={{ ...thStyle, width:150 }}>Last login</th>
                    <th style={{ ...thStyle, width:80, textAlign:"right" }}>Logins</th>
                  </tr></thead>
                  <tbody>
                    {roster.map(m => (
                      <tr key={m.id}>
                        <td style={{ ...tdStyle, fontWeight:600, color:T.text }}>{m.name || "—"}</td>
                        <td style={{ ...tdStyle, color:T.muted }}><UpnCell value={m.email} /></td>
                        <td style={tdStyle}>
                          <Badge type={ACCESS_STATUS_BADGE[m.status] || "slate"} weight="soft">{m.status || "—"}</Badge>
                          {m.status_reason && (
                            <div style={{ fontSize:11, color:T.muted, marginTop:4 }}>{m.status_reason}</div>
                          )}
                          {/* pc_approvedby/-on stamp BOTH outcomes (approve
                              and deny), so the label is Decided, not Approved. */}
                          {(m.approved_by || m.approved_on) && (
                            <div style={{ fontSize:11, color:T.muted, marginTop:4 }}>
                              Decided by {m.approved_by || "—"}{m.approved_on ? ` · ${fmtDate(m.approved_on)}` : ""}
                            </div>
                          )}
                        </td>
                        <td style={{ ...tdStyle, color: m.last_login ? T.text : T.muted }}>
                          {m.last_login ? fmtDate(m.last_login) : "Never"}
                        </td>
                        <td style={{ ...tdStyle, textAlign:"right", color:T.muted }}>{m.login_count ?? 0}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                </TableScroll>
              )}
            </td>
          </tr>
        )}
      </React.Fragment>
    );
  };

  return (
    <div>
      <div style={{ marginBottom:16 }}>
        <PillToggle
          options={[
            /* Badges ride data the page already fetches on mount (review
               queue + pending access) — no new requests. */
            /* NO BADGE any more: the held-scan queue this counted moved to
               Assessments → Scan Queue (prereq-auto-scan PR 2), where its
               count now rides the Scan Queue tab badge. Leaving the review-
               queue length here would advertise the same quantity twice, on
               a tab that no longer lists it (#532). */
            { value:"publishing", label:"Publishing" },
            { value:"logins",     label:"Logins" },
            { value:"access",     label:"Access", badge:(pendingAccess || []).length },
            { value:"contacts",   label:"Contacts" },
            { value:"scans",      label:"SecureScan365" },
            { value:"scanning",   label:"Scan Fleet" },
            { value:"licensing",  label:"Licensing" },
            /* Badge = the backlog count, the number Amber opens this tab
               for. It rides data the tab already fetched — no extra
               request, and it stays absent until the tab has loaded once.

               schedulingTotal, NOT reviewCounts.backlog: the same quantity
               has to read the same on the tab, on the section toggle and in
               the "showing N of M" line. reviewCounts is the raw bucket
               count over every contract status, which is 3 rows larger than
               the list this badge is advertising. */
            /* LABEL ONLY — value:"reviews" is load-bearing: ADMIN_TABS,
               the #/admin/{sub} hash route and RETIRED_ADMIN_TABS all key
               on it, and a live #/admin/reviews bookmark resolves through
               it. Same house rule as the "recorded"/"Delivery" sibling
               below. Renamed to Assessments 2026-08-11: the section holds
               Scheduling, Scan Queue and Delivery, and "Reviews" named
               only the first of the three. */
            { value:"reviews",    label:"Assessments", badge:schedulingTotal(reviewCustomers, "backlog") || undefined },
            /* PROMOTED OUT OF ASSESSMENTS 2026-08-14, and it sits directly
               after it: Katelyn's surface (contract-data integrity, renewal
               proximity), not a sub-view of Amber's scheduling world. The
               view renders exactly what it rendered as an inner view — this
               is a routing move, not a redesign.

               THE BADGE CAME WITH IT, onto this tab rather than staying
               inside the view. It is still mgmtProblemCount over the SAME
               payload the list renders, so the number on the control is
               still the size of the group the control opens (#532); putting
               it inside the view would have made it a count of the list
               you are already looking at, which decorates rather than
               tells. Absent until the tab has loaded once — the same
               behaviour as the Assessments badge beside it, which likewise
               rides data its own tab fetched. */
            { value:"management", label:"Customer Management", badge:mgmtProblemCount || undefined },
          ]}
          value={adminTab}
          onChange={setAdminTab}
        />
      </div>

      {/* ── TAB: Publishing — the held-scan Review Queue MOVED to Assessments
             → Scan Queue on 2026-08-19 (prereq-auto-scan PR 2, F2). This tab
             STAYS LIVE (James's ruling R2): #/admin/publishing is a real
             bookmark, so retiring or redirecting it would strand the archive
             / restore / un-publish operations — which are reached from the
             customer report view — behind a dead link. Instead it keeps the
             bookmark meaningful by EXPLANATION: a permanent pointer to where
             the queue went.

             THE POINTER LINE IS PERMANENT, not a migration banner: no
             dismiss, no date, no expiry. The queue is not coming back, so a
             reader arriving in six months needs the same sentence a reader
             arriving tomorrow needs. Its link targets the three-segment hash
             #/admin/reviews/scanqueue, which is already valid — no routing
             table changes, adminTabFromHash untouched (R2 obligations 2). ── */}
      {adminTab === "publishing" && (
      <Card>
        <h3 style={{ margin:"0 0 4px", fontSize:15, fontWeight:700, color:"#fff" }}>Publishing</h3>
        <div style={{ fontSize:12, color:T.muted, marginBottom:14 }}>
          Publish or reject held scans, archive a report, or restore an archived one.
        </div>
        <div style={{
          fontSize:13, color:T.text, padding:"12px 14px", borderRadius:8,
          background:"rgba(68,166,255,.07)", border:`1px solid rgba(68,166,255,.25)`,
          lineHeight:1.6,
        }}>
          Held scans moved to Assessments →{" "}
          {/* The href is the real, bookmarkable deep link (a fresh load of
              it resolves through adminTabFromHash to the scanqueue view). The
              onClick does the SAME-DOCUMENT switch, because the SPA router
              re-derives the admin sub-tab on popstate, not on a bare hash
              change — so a plain anchor would move the URL without moving the
              view. setAdminTab + setReviewView are the same calls the toggles
              make, and they write the identical hash.

              AND IT OPENS THE HELD PILL, not the scanqueue default. The pill
              is local state seeded to "prereq", so tab+view alone landed this
              link on Prereq issues — a different queue from the one the
              sentence just promised. setScanQueuePill("held") makes the
              destination match the advertisement; the pill is unrouted, so
              this is the only way to say it (external review N-4). A fresh
              load of the bare href still lands on "prereq", which is correct:
              the deep link promises the view, this line promises the queue. */}
          <a href="#/admin/reviews/scanqueue"
             onClick={(e) => {
               e.preventDefault();
               setAdminTab("reviews");
               setReviewView("scanqueue");
               setScanQueuePill("held");
             }}
             style={{ color:T.blue, fontWeight:600, textDecoration:"none" }}>
            Scan Queue
          </a>
          . Publish and reject a held scan there. Archive, restore and
          un-publish stay on each customer’s report.
        </div>
      </Card>
      )}

      {/* ── TAB: Logins — list-first, all customers, expandable rosters ── */}
      {adminTab === "logins" && (
      <Card>
        <div style={{ display:"flex", alignItems:"flex-start", justifyContent:"space-between", gap:12, marginBottom:14 }}>
          <div>
            <h3 style={{ margin:"0 0 4px", fontSize:15, fontWeight:700, color:"#fff" }}>Portal Logins</h3>
            <div style={{ fontSize:12, color:T.muted }}>
              Who is actually using the portal. Last login stamps once per day per user; internal users are never counted. Click a customer to see their roster.
            </div>
            {loginScopeApplied === "all_fallback" && !loginShowAll && (
              <div style={{ fontSize:12, color:"#f3b53f", marginTop:4 }}>
                Showing all customers — entitlement read unavailable.
              </div>
            )}
          </div>
          <div style={{ display:"flex", alignItems:"center", gap:8, flexWrap:"wrap", justifyContent:"flex-end" }}>
            {/* Universe toggle — SecureShield365 = customers the portal
                serves (plus any lapsed customer still holding Active
                users); All = every customer record. */}
            <PillToggle
              options={[
                { value:"entitled", label:"SecureShield365" },
                { value:"all",      label:"All customers" },
              ]}
              value={loginShowAll ? "all" : "entitled"}
              onChange={(v) => setLoginShowAll(v === "all")}
            />
            <PillToggle
              options={[
                { value:"newest", label:"Newest first" },
                { value:"oldest", label:"Oldest first" },
              ]}
              value={loginSort}
              onChange={setLoginSort}
            />
          </div>
        </div>

        {/* Search — house filter-bar idiom (RecsPage search box). */}
        <div style={{ position:"relative", display:"inline-flex", alignItems:"center", marginBottom:12 }}>
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke={T.muted} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ position:"absolute", left:10, pointerEvents:"none" }}><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
          <input
            type="text"
            value={loginSearch}
            onChange={(e) => setLoginSearch(e.target.value)}
            placeholder="Search customers…"
            style={{
              padding:"6px 28px 6px 30px", borderRadius:8, width:240, maxWidth:"48vw",
              border:`1px solid ${loginSearch ? "rgba(68,166,255,.5)" : T.border}`,
              background:"rgba(255,255,255,.04)", color:T.text, fontFamily:"inherit", fontSize:12, outline:"none",
            }}
          />
          {loginSearch && (
            <button onClick={() => setLoginSearch("")} aria-label="Clear search" style={{
              position:"absolute", right:6, background:"none", border:"none", color:T.muted,
              cursor:"pointer", fontSize:14, lineHeight:1, fontFamily:"inherit", padding:2,
            }}>×</button>
          )}
        </div>

        {summaryError && (
          <div style={{ fontSize:13, color:T.red, padding:"12px 0" }}>Couldn’t load the login summary. Please try again.</div>
        )}
        {!summaryError && summary === null && (
          <div style={{ fontSize:13, color:T.muted, padding:"12px 0" }}>Loading…</div>
        )}
        {!summaryError && summary && summary.length === 0 && (
          <div style={{ fontSize:13, color:T.muted, padding:"24px 0", textAlign:"center" }}>No customers found.</div>
        )}
        {!summaryError && summary && summary.length > 0 && (
          loggedIn.length === 0 && neverLoggedIn.length === 0 ? (
            <div style={{ fontSize:13, color:T.muted, padding:"24px 0", textAlign:"center" }}>No customers match.</div>
          ) : (
          <TableScroll>
          <table style={{ width:"100%", borderCollapse:"collapse" }}>
            <thead><tr>
              <th style={thStyle}>Customer</th>
              <th style={{ ...thStyle, width:190 }}>Most recent login</th>
              <th style={{ ...thStyle, width:110, textAlign:"right" }}>Active users</th>
            </tr></thead>
            <tbody>
              {loggedIn.map(loginRow)}
              {neverLoggedIn.length > 0 && (
                <tr>
                  <td colSpan={3} style={{ ...tdStyle, paddingTop:18, color:T.muted, fontSize:11, fontWeight:600, textTransform:"uppercase", letterSpacing:".04em" }}>
                    Never logged in — onboarding follow-up
                  </td>
                </tr>
              )}
              {neverLoggedIn.map(loginRow)}
            </tbody>
          </table>
          </TableScroll>
          )
        )}
      </Card>
      )}

      {/* ── TAB: Access — pending requests with Approve/Deny ── */}
      {adminTab === "access" && (
      <Card>
        <h3 style={{ margin:"0 0 4px", fontSize:15, fontWeight:700, color:"#fff" }}>Pending Access Requests</h3>
        <div style={{ fontSize:12, color:T.muted, marginBottom:14 }}>
          Portal-access requests awaiting review, all customers, oldest first. Approve sends a guest invitation if needed, adds the person to the portal group, and activates their roster row; Deny marks the request rejected.
        </div>

        {decisionLog.length > 0 && (
          <div style={{ marginBottom:12 }}>
            {decisionLog.map(d => (
              <div key={d.key} style={{ fontSize:12, color: d.ok ? T.green : T.red, padding:"2px 0" }}>
                {d.ok ? "✓" : "✕"} {d.email} — {d.label}
              </div>
            ))}
          </div>
        )}

        {pendingAccessError && (
          <div style={{ fontSize:13, color:T.red, padding:"12px 0" }}>Couldn’t load pending requests. Please try again.</div>
        )}
        {!pendingAccessError && pendingAccess === null && (
          <div style={{ fontSize:13, color:T.muted, padding:"12px 0" }}>Loading…</div>
        )}
        {!pendingAccessError && pendingAccess && pendingAccess.length === 0 && (
          <div style={{ fontSize:13, color:T.muted, padding:"24px 0", textAlign:"center" }}>No pending requests.</div>
        )}
        {!pendingAccessError && pendingAccess && pendingAccess.length > 0 && (
          <TableScroll>
          <table style={{ width:"100%", borderCollapse:"collapse" }}>
            <thead><tr>
              <th style={thStyle}>Customer</th>
              <th style={thStyle}>Name</th>
              <th style={thStyle}>Email</th>
              <th style={thStyle}>Requested by</th>
              <th style={{ ...thStyle, width:90 }}>Age</th>
              <th style={{ ...thStyle, width:230, textAlign:"right" }}></th>
            </tr></thead>
            <tbody>
              {pendingAccess.map(p => {
                const age = ageOf(p.requested_on || p.created_on);
                const busy = decisionBusyIds.has(p.id);
                return (
                  <tr key={p.id}>
                    <td style={{ ...tdStyle, fontWeight:600, color:T.text }}>{p.customer_name || "—"}</td>
                    <td style={tdStyle}>{p.name || "—"}</td>
                    <td style={{ ...tdStyle, color:T.muted }}><UpnCell value={p.email} /></td>
                    <td style={{ ...tdStyle, color:T.muted }}><UpnCell value={p.requested_by} /></td>
                    <td style={{ ...tdStyle, color: age ? (age.stale ? T.red : T.text) : T.muted, fontWeight: age?.stale ? 600 : 400, whiteSpace:"nowrap" }}>
                      {age ? age.label : "—"}
                    </td>
                    <td style={{ ...tdStyle, textAlign:"right", whiteSpace:"nowrap" }}>
                      {/* Buttons need the slug for the route; slug-less rows
                          (customer no longer active) keep only the deep link. */}
                      {p.slug && (
                        <>
                          <Btn pri disabled={busy}
                            onClick={() => setDecisionTarget({ row: p, action: "approve" })}
                            style={{ padding:"5px 10px", marginRight:6 }}>
                            {busy ? "Working…" : "Approve"}
                          </Btn>
                          <Btn del disabled={busy}
                            onClick={() => { setDenyReason(""); setDenyReasonError(false); setDecisionTarget({ row: p, action: "deny" }); }}
                            style={{ padding:"5px 10px", marginRight:10 }}>
                            Deny
                          </Btn>
                        </>
                      )}
                      {p.record_url ? (
                        <a href={p.record_url} target="_blank" rel="noopener noreferrer" style={{ fontSize:12, fontWeight:600, color:T.blue, textDecoration:"none", whiteSpace:"nowrap" }}>Open →</a>
                      ) : (
                        !p.slug && <span style={{ color:T.muted }}>—</span>
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
          </TableScroll>
        )}

        <Modal
          show={!!decisionTarget}
          title={decisionTarget?.action === "approve" ? "Approve portal access" : "Deny access request"}
          onClose={() => setDecisionTarget(null)}
          onSubmit={handleAccessDecision}
          submitLabel={decisionTarget?.action === "approve" ? "Approve" : "Deny"}
        >
          {decisionTarget?.action === "approve" ? (
            <>
              Approve {decisionTarget?.row?.name || decisionTarget?.row?.email} for{" "}
              {decisionTarget?.row?.customer_name || "this customer"}? If they aren't
              already a guest, a real invitation email will be sent to{" "}
              {decisionTarget?.row?.email}; they'll be added to the portal group and
              their roster row becomes Active.
            </>
          ) : (
            <>
              Deny the request for {decisionTarget?.row?.name || decisionTarget?.row?.email}?
              The row is marked Rejected — no invitation is sent and nothing changes
              in Entra. A rejected request stays on file; contact the team if it
              should be re-opened later.
              <div style={{ marginTop:12 }}>
                <label style={{ display:"block", fontSize:12, color:T.muted, marginBottom:6, fontWeight:600 }}>
                  Reason (visible to the customer)
                </label>
                <input
                  value={denyReason}
                  onChange={e => { setDenyReason(e.target.value); if (denyReasonError) setDenyReasonError(false); }}
                  maxLength={500}
                  placeholder="e.g. Please have your IT lead submit this request"
                  style={{
                    width:"100%", background:"rgba(255,255,255,0.05)", border:`1px solid ${denyReasonError ? "rgba(225,77,87,0.6)" : T.border}`,
                    borderRadius:8, color:T.text, fontSize:13, padding:"9px 12px", fontFamily:"inherit", outline:"none",
                  }}
                />
                {denyReasonError && (
                  <div style={{ fontSize:12, color:T.red, marginTop:6 }}>A reason is required — the customer sees it under the request's status.</div>
                )}
              </div>
            </>
          )}
        </Modal>

        {/* ── History — full lifecycle below the untouched Pending queue
            (access-automation PR 4). Independent fetch + error state: a
            failure here must never hide or break the queue above. ── */}
        <div style={{ marginTop:18, paddingTop:16, borderTop:`1px solid ${T.border}` }}>
          <h3 style={{ margin:"0 0 4px", fontSize:15, fontWeight:700, color:"#fff" }}>Access History</h3>
          <div style={{ fontSize:12, color:T.muted, marginBottom:14 }}>
            Every roster row across all customers with its decision trail. Pending requests stay in the queue above; this section is read-only.
          </div>

          <div style={{ display:"flex", gap:12, flexWrap:"wrap", alignItems:"center", marginBottom:12 }}>
            {/* Status pills exist only in Show-all mode — off means
                Active-only, so an "All" pill would be incoherent
                (review round 1, correction 2). */}
            {accessShowAll && (
              <PillToggle
                options={[
                  { value:"all",               label:"All" },
                  { value:"active",            label:"Active" },
                  { value:"removal_requested", label:"Removal Requested" },
                  { value:"rejected",          label:"Rejected" },
                  { value:"removed",           label:"Removed" },
                ]}
                value={accessStatusFilter}
                onChange={setAccessStatusFilter}
              />
            )}
            {/* Search — house filter-bar idiom (RecsPage search box). */}
            <div style={{ position:"relative", display:"inline-flex", alignItems:"center" }}>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke={T.muted} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ position:"absolute", left:10, pointerEvents:"none" }}><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
              <input
                type="text"
                value={accessSearch}
                onChange={(e) => setAccessSearch(e.target.value)}
                placeholder="Search name, email, or customer…"
                style={{
                  padding:"6px 28px 6px 30px", borderRadius:8, width:240, maxWidth:"48vw",
                  border:`1px solid ${accessSearch ? "rgba(68,166,255,.5)" : T.border}`,
                  background:"rgba(255,255,255,.04)", color:T.text, fontFamily:"inherit", fontSize:12, outline:"none",
                }}
              />
              {accessSearch && (
                <button onClick={() => setAccessSearch("")} aria-label="Clear search" style={{
                  position:"absolute", right:6, background:"none", border:"none", color:T.muted,
                  cursor:"pointer", fontSize:14, lineHeight:1, fontFamily:"inherit", padding:2,
                }}>×</button>
              )}
            </div>
            <PillToggle
              options={[
                { value:"requested", label:"Requested" },
                { value:"decided",   label:"Decided" },
                { value:"customer",  label:"Customer" },
              ]}
              value={accessSort}
              onChange={setAccessSort}
            />
            <label style={{ display:"inline-flex", alignItems:"center", gap:6, fontSize:12, color:T.muted, cursor:"pointer", userSelect:"none" }}>
              <input
                type="checkbox"
                checked={accessShowAll}
                onChange={(e) => {
                  const on = e.target.checked;
                  setAccessShowAll(on);
                  // Reset on toggle-off so a hidden pill filter can never
                  // remain silently applied (review round 1, correction 2).
                  if (!on) setAccessStatusFilter("active");
                }}
              />
              Show all statuses
            </label>
          </div>

          {accessLifecycleError && (
            <div style={{ fontSize:13, color:T.red, padding:"12px 0" }}>Couldn’t load access history. Please try again.</div>
          )}
          {!accessLifecycleError && accessLifecycle === null && (
            <div style={{ fontSize:13, color:T.muted, padding:"12px 0" }}>Loading…</div>
          )}
          {!accessLifecycleError && accessLifecycle && accessRows.length === 0 && (
            <div style={{ fontSize:13, color:T.muted, padding:"24px 0", textAlign:"center" }}>No rows match.</div>
          )}
          {!accessLifecycleError && accessLifecycle && accessRows.length > 0 && (
            <TableScroll>
            <table style={{ width:"100%", borderCollapse:"collapse" }}>
              <thead><tr>
                <th style={thStyle}>Customer</th>
                <th style={thStyle}>Name</th>
                <th style={thStyle}>Email</th>
                <th style={{ ...thStyle, width:170 }}>Status</th>
                <th style={thStyle}>Decided</th>
                <th style={{ ...thStyle, width:70, textAlign:"right" }}></th>
              </tr></thead>
              <tbody>
                {accessRows.map(r => (
                  <tr key={r.id}>
                    <td style={{ ...tdStyle, fontWeight:600, color:T.text }}>{r.customer_name || "—"}</td>
                    <td style={tdStyle}>{r.name || "—"}</td>
                    <td style={{ ...tdStyle, color:T.muted }}><UpnCell value={r.email} /></td>
                    <td style={tdStyle}>
                      <Badge type={ACCESS_LIFECYCLE_BADGE[r.status_key] || "slate"} weight="soft">{r.status || "—"}</Badge>
                      {r.status_reason && (
                        <div style={{ fontSize:11, color:T.muted, marginTop:4 }}>{r.status_reason}</div>
                      )}
                    </td>
                    <td style={{ ...tdStyle, color:T.muted, fontSize:12 }}>
                      {/* pc_approvedby/-on stamp BOTH outcomes — the label
                          is Decided, never Approved. decided_by is a UPN —
                          an unbreakable token — so the cell is capped like
                          the email columns, full text in the title. */}
                      {(r.decided_by || r.decided_on)
                        ? <UpnCell max={260} value={`Decided by ${r.decided_by || "—"}${r.decided_on ? ` · ${fmtWhen(r.decided_on)}` : ""}`} />
                        : "—"}
                    </td>
                    <td style={{ ...tdStyle, textAlign:"right" }}>
                      {r.record_url ? (
                        <a href={r.record_url} target="_blank" rel="noopener noreferrer" style={{ fontSize:12, fontWeight:600, color:T.blue, textDecoration:"none", whiteSpace:"nowrap" }}>Open →</a>
                      ) : (
                        <span style={{ color:T.muted }}>—</span>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            </TableScroll>
          )}
        </div>
      </Card>
      )}

      {/* ── TAB: Contacts — one row per served customer, BOTH mailing
          designations set inline (technical + executive, 2026-08-03
          two-contact rework). Gaps render inline, flagged per kind. ── */}
      {adminTab === "contacts" && (
      <Card>
        <h3 style={{ margin:"0 0 4px", fontSize:15, fontWeight:700, color:"#fff" }}>Contacts</h3>
        <div style={{ fontSize:12, color:T.muted, marginBottom:14 }}>
          One technical contact and one executive contact per customer — who we email about technical matters and business matters respectively. Copy and CSV include Active contacts only; a tombstoned or missing contact shows as a gap, never as a mailing target.
        </div>
        {/* Fail-open signal: the entitled universe couldn't be read, so
            the table below is the FULL customer list, labeled as such —
            never silently widened. */}
        {entitledSlugs === null && !accessLifecycleError && contactRows !== null && (
          <div style={{ fontSize:12, color:"#f3b53f", marginBottom:12 }}>
            Showing all customers — entitlement read unavailable.
          </div>
        )}

        {accessLifecycleError ? (
          <div style={{ fontSize:13, color:T.red, padding:"12px 0" }}>Couldn't load the roster. Please try again.</div>
        ) : contactRows === null ? (
          <Skeleton height={160} />
        ) : (
          <>
            <div style={{ display:"flex", alignItems:"center", gap:12, marginBottom:12, flexWrap:"wrap" }}>
              <PillToggle
                options={[
                  { value:"technical", label:`Technical (${contactCounts.technical})` },
                  { value:"executive", label:`Executive (${contactCounts.executive})` },
                  { value:"gaps",      label:`Gaps (${contactCounts.gaps})` },
                  { value:"all",       label:`All (${contactCounts.all})` },
                ]}
                value={contactFilter}
                onChange={setContactFilter}
              />
              <div style={{ flex:1 }} />
              <input
                value={contactSearch}
                onChange={e => setContactSearch(e.target.value)}
                placeholder="Search customer, name, or email"
                style={{ background:"rgba(255,255,255,0.05)", border:`1px solid ${T.border}`, borderRadius:8, color:T.text, fontSize:13, padding:"7px 12px", fontFamily:"inherit", outline:"none", minWidth:220 }}
              />
              <Btn onClick={handleCopyContactEmails} disabled={!usableContactEmails.length} style={{ padding:"6px 12px" }}>
                {contactCopied ? "Copied ✓" : `Copy emails (${usableContactEmails.length})`}
              </Btn>
              <Btn onClick={handleContactCsv} style={{ padding:"6px 12px" }}>Download CSV</Btn>
            </div>

            {contactError && (
              <div style={{ padding:10, marginBottom:12, background:"rgba(225,77,87,0.1)", borderRadius:10, border:"1px solid rgba(225,77,87,0.3)" }}>
                <p style={{ color:T.red, fontSize:13 }}>{contactError}</p>
              </div>
            )}

            <TableScroll>
            <table style={{ width:"100%", borderCollapse:"collapse" }}>
              <thead><tr>
                {[["customer","Customer"],["technical","Technical contact"],["executive","Executive contact"],["last_login","Last login"],["created","Date added"]].map(([key, label]) => (
                  <th key={key} style={{ ...thStyle, cursor:"pointer", userSelect:"none" }} onClick={() => handleContactSort(key)}>
                    {label}{contactSort?.key === key ? (contactSort.dir === "asc" ? " ▲" : " ▼") : ""}
                  </th>
                ))}
              </tr></thead>
              <tbody>
                {visibleContactRows.length === 0 ? (
                  <tr><td colSpan={5} style={{ ...tdStyle, textAlign:"center", color:T.muted, padding:"22px 8px" }}>
                    {contactFilter === "gaps" ? "No gaps — every customer has both contacts." : "No customers match."}
                  </td></tr>
                ) : visibleContactRows.map(r => {
                  // One dropdown per contact kind, same inline behavior:
                  // options are the customer's ACTIVE roster rows (data
                  // the page already loaded — no per-row fetch). Value is
                  // the current usable holder; every gap state renders
                  // the placeholder so fixing it is one explicit pick.
                  const contactCell = (kind) => {
                    const facts = r[kind];
                    const busyKey = `${r.slug}:${kind}`;
                    if (r.active_options.length === 0) {
                      return (
                        <Badge type="amber" weight="soft">
                          {CONTACT_BASE_GAP_LABEL[r.base_gap] || "No Active members"}
                        </Badge>
                      );
                    }
                    const gapped = r.base_gap || facts.gap;
                    return (
                      <>
                        <select
                          value={gapped ? "" : facts.id}
                          disabled={contactBusy === busyKey}
                          onChange={e => handleContactSet(r, kind, e.target.value)}
                          style={{ background:"rgba(255,255,255,0.05)", border:`1px solid ${T.border}`, borderRadius:8, color:T.text, fontSize:12, padding:"6px 8px", fontFamily:"inherit", outline:"none", maxWidth:240, cursor:"pointer", opacity: contactBusy === busyKey ? .6 : 1 }}
                        >
                          {(gapped || !facts.id) && (
                            <option value="" style={{ background:T.panel }}>
                              {kind === "technical" ? "— set technical contact —" : "— set executive contact —"}
                            </option>
                          )}
                          {r.active_options.map(o => (
                            <option key={o.id} value={o.id} style={{ background:T.panel }}>
                              {(o.name || o.email)}{o.email && o.name ? ` — ${o.email}` : ""}
                            </option>
                          ))}
                        </select>
                        {!gapped && facts.email && (
                          <div style={{ fontSize:11, color:T.muted, marginTop:4, maxWidth:240, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }} title={facts.email}>{facts.email}</div>
                        )}
                        {facts.gap && !r.base_gap && (
                          <div style={{ marginTop:4 }}>
                            <Badge type="amber" weight="soft">{contactKindGapLabel(kind, facts.gap)}</Badge>
                          </div>
                        )}
                      </>
                    );
                  };
                  return (
                  <tr key={r.slug} style={rowHasAnyGap(r) ? { background:"rgba(240,180,60,0.05)" } : undefined}>
                    <td style={{ ...tdStyle, fontWeight:600 }}>
                      {/* Full reload on purpose: the client picker restores
                          from ?client= on mount, and #/profile lands on the
                          Company Profile where the full roster lives. */}
                      <a
                        href={`${window.location.pathname}?client=${encodeURIComponent(r.slug)}#/profile`}
                        style={{ color:T.text, textDecoration:"underline", textUnderlineOffset:3 }}
                      >
                        {r.customer}
                      </a>
                      {r.base_gap && r.active_options.length > 0 && (
                        <div style={{ marginTop:4 }}>
                          <Badge type="amber" weight="soft">{CONTACT_BASE_GAP_LABEL[r.base_gap]}</Badge>
                        </div>
                      )}
                    </td>
                    <td style={tdStyle}>{contactCell("technical")}</td>
                    <td style={tdStyle}>{contactCell("executive")}</td>
                    <td style={{ ...tdStyle, color:T.muted }}>{r.technical.last_login ? fmtTicketDate(r.technical.last_login) : "—"}</td>
                    <td style={{ ...tdStyle, color:T.muted }}>{r.technical.created_on ? fmtTicketDate(r.technical.created_on) : "—"}</td>
                  </tr>
                  );
                })}
              </tbody>
            </table>
            </TableScroll>
          </>
        )}
      </Card>
      )}

      {adminTab === "scans" && (
      <Card>
        <h3 style={{ margin:"0 0 4px", fontSize:15, fontWeight:700, color:"#fff" }}>SecureScan365</h3>
        <div style={{ fontSize:12, color:T.muted, marginBottom:14 }}>
          Run the SecureScan365 engine against a customer tenant using its stored passkey. Internal only — results land in SecureScan365, not the customer dashboard (the ingest bridge is separate work).
        </div>

        {scanEngineNotConfigured ? (
          <div style={{ border:`1px dashed ${T.border}`, borderRadius:10, padding:"32px 16px", textAlign:"center", fontSize:13, color:T.muted }}>
            SecureScan365 connection pending — awaiting engine credentials.
          </div>
        ) : (
        <>
        {/* Step 1 — customer + stored passkeys */}
        <div style={{ display:"flex", alignItems:"center", gap:10, flexWrap:"wrap", marginBottom:12 }}>
          <select
            value={scanSlug}
            onChange={(e) => selectScanSlug(e.target.value)}
            style={{
              padding:"7px 10px", borderRadius:8, minWidth:240, maxWidth:"48vw",
              border:`1px solid ${scanSlug ? "rgba(68,166,255,.5)" : T.border}`,
              background:"rgba(255,255,255,.04)", color: scanSlug ? T.text : T.muted,
              fontFamily:"inherit", fontSize:12, outline:"none",
            }}
          >
            <option value="">Choose a customer…</option>
            {scanClientOptions.map(c => (
              <option key={c.id} value={c.id} style={{ color:"#111" }}>{c.name}</option>
            ))}
          </select>
          <button
            onClick={findScanPasskeys}
            disabled={!scanSlug || scanUsersLoading}
            style={{
              padding:"7px 14px", borderRadius:8, fontSize:12, fontWeight:600, fontFamily:"inherit",
              border:`1px solid ${T.border}`, background:"rgba(68,166,255,.14)",
              color: (!scanSlug || scanUsersLoading) ? T.muted : T.blue,
              cursor: (!scanSlug || scanUsersLoading) ? "default" : "pointer",
            }}
          >{scanUsersLoading ? "Searching…" : "Find Stored Passkeys"}</button>
        </div>

        {scanUsersError && (
          <div style={{ fontSize:13, color:T.red, marginBottom:12 }}>Couldn’t reach the SecureScan365 engine for stored passkeys. Please try again.</div>
        )}
        {scanUsers && scanUsers.length === 0 && (
          <div style={{ fontSize:13, color:T.muted, marginBottom:12 }}>No stored passkeys for this customer’s tenant — register one in SecureScan365 first.</div>
        )}

        <button
          onClick={openStartModal}
          disabled={!scanSlug || scanStarting}
          style={{
            padding:"7px 16px", borderRadius:8, fontSize:12, fontWeight:700,
            fontFamily:"inherit", marginBottom:14,
            border:"1px solid rgba(83,196,109,.5)", background:"rgba(83,196,109,.16)",
            color: (!scanSlug || scanStarting) ? T.muted : T.green,
            cursor: (!scanSlug || scanStarting) ? "default" : "pointer",
          }}
        >{scanStarting ? "Starting…" : "Start Assessment"}</button>

        {/* Manual diagnostics use the operator-selected identity. */}
        {scanUsers && scanUsers.length > 0 && (
          <div style={{ border:`1px solid ${T.border}`, borderRadius:10, padding:"10px 14px", marginBottom:14 }}>
            <div style={{ fontSize:11, color:T.muted, fontWeight:600, textTransform:"uppercase", letterSpacing:".04em", marginBottom:8 }}>Run assessment as</div>
            {scanUsers.map(u => (
              <label key={u.user_principal_name} style={{ display:"flex", alignItems:"center", gap:8, padding:"4px 0", fontSize:13, color:T.text, cursor:"pointer" }}>
                <input
                  type="radio"
                  name="scan-upn"
                  checked={scanUpn === u.user_principal_name}
                  onChange={() => setScanUpn(u.user_principal_name)}
                />
                <span style={{ fontWeight:600 }}>{u.display_name || u.user_principal_name}</span>
                <span style={{ color:T.muted }}>{u.user_principal_name}</span>
              </label>
            ))}
            <div style={{ marginTop:10, display:"flex", gap:10, alignItems:"center", flexWrap:"wrap" }}>
              {/* Pre-flight read — blue, not green: green is the start/publish
                  color and this action runs nothing against the tenant. */}
              <button
                onClick={startPrereqCheck}
                disabled={!scanUpn || !!prereqPhase || scanStarting}
                style={{
                  padding:"7px 16px", borderRadius:8, fontSize:12, fontWeight:700, fontFamily:"inherit",
                  border:"1px solid rgba(68,166,255,.5)", background:"rgba(68,166,255,.14)",
                  color: (!scanUpn || prereqPhase || scanStarting) ? T.muted : T.blue,
                  cursor: (!scanUpn || prereqPhase || scanStarting) ? "default" : "pointer",
                }}
              >{prereqPhase === "loading" ? "Loading result…" : prereqPhase ? "Checking…" : "Check Prerequisites"}</button>
            </div>
          </div>
        )}

        <ScanStartModal
          show={startModal}
          slug={scanSlug}
          customerLabel={clientsById[scanSlug] || scanSlug}
          preflight={startPreflight}
          loading={startPreflightLoading}
          error={startPreflightError}
          selectedUpn={scanUpn}
          autoSend={startAutoSend}
          onToggleAutoSend={() => setStartAutoSend(v => !v)}
          manualArmed={startManualArmed}
          onArmManual={armManualStart}
          starting={scanStarting}
          onStart={confirmStartScan}
          onClose={closeStartModal}
          onViewJourney={viewStartJourney}
        />

        {scanStartMsg && (
          <div style={{ fontSize:13, color: scanStartMsg.ok ? T.green : T.red, marginBottom:14 }}>{scanStartMsg.text}</div>
        )}

        {scanSlug && (
          <div id="selected-admin-scan-journey" style={{ border:`1px solid ${T.border}`, borderRadius:10, padding:"12px 14px", marginBottom:16 }}>
            <div style={{ display:"flex", justifyContent:"space-between", gap:10, alignItems:"center" }}>
              <strong style={{ fontSize:12, color:T.text }}>Selected customer journey</strong>
              <button onClick={() => refreshSelectedJourney()} style={{ fontSize:11, color:T.blue, background:"none", border:"none", cursor:"pointer" }}>Refresh</button>
            </div>
            <div style={{ fontSize:12, color:visibleSelectedJourneyError ? T.red : T.text, marginTop:6 }}>
              {visibleSelectedJourneyError || (visibleSelectedJourney ? scanJourneyLabel(visibleSelectedJourney) : "Loading saved journey…")}
            </div>
            {visibleSelectedJourney?.phase && <div style={{ fontSize:11, color:T.muted, marginTop:4 }}>Phase: {visibleSelectedJourney.phase}</div>}
            {visibleSelectedJourney?.initiated_by && <div style={{ fontSize:11, color:T.muted, marginTop:4 }}>Original request: {visibleSelectedJourney.initiated_by === "customer" ? "customer" : "Patriot as customer"}</div>}
            {visibleSelectedJourney?.run_id && <div style={{ fontSize:11, color:T.muted, marginTop:4 }}>Known run: {visibleSelectedJourney.run_id}</div>}
            {visibleSelectedJourney?.created_utc && <div style={{ fontSize:11, color:T.muted, marginTop:4 }}>Created {fmtInstant(visibleSelectedJourney.created_utc)} · updated {fmtInstant(visibleSelectedJourney.updated_utc)}</div>}
            {visibleSelectedJourney?.status === "slug_mismatch" && <div style={{ fontSize:11, color:T.yellow, marginTop:6 }}>The saved journey belongs to another customer slug on this tenant. This selection cannot attach to it.</div>}
            {visibleSelectedJourney?.status === "recovery_pending" && <div style={{ fontSize:11, color:T.yellow, marginTop:6 }}>An unresolved recovery receipt blocks a new automatic request.</div>}
            {(visibleSelectedJourney?.status === "stalled" ||
              visibleSelectedJourney?.phase === "ready_claimed") && !visibleRecoveryOperation && (
              <button onClick={previewJourneyRecovery} disabled={recoveryBusy} style={{ marginTop:10, fontSize:11, color:T.blue, border:`1px solid ${T.border}`, background:"transparent", borderRadius:7, padding:"5px 10px", cursor:"pointer" }}>
                {recoveryBusy ? "Checking…" : visibleSelectedJourney?.phase === "ready_claimed"
                  ? "Preview request closure" : "Preview recovery evidence"}
              </button>
            )}
            {visibleRecoveryPreview && !visibleRecoveryOperation && (
              <div style={{ fontSize:11, marginTop:8, color:T.text }}>
                <div>Available action: {visibleRecoveryPreview.action || "none"}. {visibleRecoveryPreview.evidence?.reason || ""}</div>
                {visibleRecoveryPreview.action === "close_expired_ready_claimed" && <div style={{ marginTop:4 }}>
                  Scope: this original expired request only. Approved operation: {visibleRecoveryPreview.operation_id}. Reason: {visibleRecoveryPreview.approved_reason}.
                </div>}
                {!visibleRecoveryPreview.recovery_enabled && <div style={{ color:T.yellow, marginTop:4 }}>Execution is off. This preview made no change.</div>}
                {visibleRecoveryPreview.action && visibleRecoveryPreview.recovery_enabled && (
                  <>
                    <div style={{ marginTop:5 }}>{visibleRecoveryPreview.action === "close_expired_ready_claimed"
                      ? "This closes only the original request. A fresh scan requires a separate request and normal checks."
                      : "This updates journey bookkeeping only. It does not start, send, score, or publish a run."}</div>
                    {visibleRecoveryPreview.action !== "close_expired_ready_claimed" &&
                      <input value={recoveryReason} onChange={e => setRecoveryReason(e.target.value)} maxLength={500} placeholder="Reason for this recovery (no sensitive data)" style={{ marginTop:8, width:"100%", padding:7, borderRadius:6, border:`1px solid ${T.border}`, background:T.panel, color:T.text }} />}
                    <button onClick={runJourneyRecovery} disabled={recoveryBusy || (visibleRecoveryPreview.action === "close_expired_ready_claimed"
                      ? !visibleRecoveryPreview.abandonment_manifest_bound || !visibleRecoveryPreview.approved_reason
                      : !recoveryReason.trim())} style={{ marginTop:8, fontSize:11, color:T.yellow, border:`1px solid ${T.border}`, background:"transparent", borderRadius:7, padding:"5px 10px", cursor:"pointer" }}>
                      {visibleRecoveryPreview.action === "close_expired_ready_claimed" ? "Close this expired request" : "Apply this recovery"}
                    </button>
                  </>
                )}
              </div>
            )}
            {visibleRecoveryOperation && (
              <div style={{ marginTop:8, fontSize:11, color:T.yellow }}>
                Operation {visibleRecoveryOperation.operation_id} is retained for this tab.
                <button onClick={runJourneyRecovery} disabled={recoveryBusy} style={{ marginLeft:8, fontSize:11, color:T.blue, border:`1px solid ${T.border}`, background:"transparent", borderRadius:7, padding:"5px 10px", cursor:"pointer" }}>
                  {recoveryBusy ? "Checking…" : "Check same operation"}
                </button>
              </div>
            )}
            {recoveryMessage && <div style={{ marginTop:8, fontSize:11, color:T.yellow }}>{recoveryMessage}</div>}
          </div>
        )}

        {prereqError && (
          <div style={{ fontSize:13, color:T.red, marginBottom:14 }}>{prereqError}</div>
        )}
        {prereqResult && (() => {
          const outcomeKey = prereqResult.outcome || "couldNotEvaluate";
          const outcome = PREREQ_OUTCOME_BADGE[outcomeKey] || { type:"slate", label:String(outcomeKey) };
          const coverage = prereqResult.coverage;
          const items = prereqResult.items || [];
          const issues = prereqResult.issues || [];
          // v1.2 sibling blocks — null on pre-1.2 payloads and stale runs.
          const licInv = prereqResult.license_inventory || null;
          const testSel = prereqResult.test_selection_recommendation || null;
          const connPlan = prereqResult.connectivity_plan || null;
          const reasonByCheck = {};
          (prereqResult.unevaluated || []).forEach(u => {
            if (u.check_id) reasonByCheck[u.check_id] = u.reason_code || "no reason given";
          });
          // Contract discipline: behavior keys on Code only — Title,
          // TechnicalSummary and friends are display text, never matched.
          const roleIssue = issues.find(i => i.code === "RoleOverPrivileged");
          const customerIssues = issues.filter(i => i.audience === "TenantAdmin");
          // PlatformAdmin AND User audiences are Patriot-side — User-audience
          // steps must never be presented as customer instructions.
          const internalIssues = issues.filter(i => i.audience !== "TenantAdmin");
          const issueRow = (i, k) => (
            <div key={i.code || k} style={{ padding:"8px 0", borderTop:`1px solid ${T.border}` }}>
              <div style={{ display:"flex", alignItems:"center", gap:8, flexWrap:"wrap" }}>
                <Badge type={i.severity === "Warning" ? "yellow" : i.severity === "Error" ? "red" : "slate"}>{i.severity || "—"}</Badge>
                <span style={{ fontSize:12, fontWeight:700, color:T.text }}>{i.title || i.code || "—"}</span>
                <span style={{ fontSize:11, color:T.muted, fontFamily:"ui-monospace, SFMono-Regular, Menlo, monospace" }}>{i.code}</span>
                {i.retryable === true && (
                  <span title="Safe to re-run after fixing" style={{ fontSize:10, fontWeight:700, padding:"1px 6px", borderRadius:4, color:T.muted, border:`1px solid ${T.border}` }}>retryable</span>
                )}
              </div>
              {i.user_message && <div style={{ fontSize:12, color:T.text, marginTop:4 }}>{i.user_message}</div>}
              {(() => {
                // Remediation entries are {Type, Label, Value, Audience}
                // objects (contract §5), and PowerShell serializes empty
                // arrays as [null] — null-filter before rendering.
                const steps = (Array.isArray(i.remediation) ? i.remediation : []).filter(Boolean);
                if (!steps.length) return null;
                return (
                  <ul style={{ margin:"4px 0 0", paddingLeft:18, fontSize:12, color:T.muted }}>
                    {steps.map((r, n) => {
                      const type = r.Type || r.type;
                      const label = r.Label || r.label;
                      const value = r.Value || r.value;
                      return (
                        <li key={n} style={{ marginTop:2 }}>
                          {type === "Link" && value ? (
                            <a href={value} target="_blank" rel="noreferrer" style={{ color:T.blue }}>{label || value}</a>
                          ) : type === "CopyCommand" && value ? (
                            <>
                              {label && <div>{label}</div>}
                              <pre style={{ margin:"4px 0 0", padding:"6px 8px", borderRadius:6, background:"rgba(255,255,255,.05)", border:`1px solid ${T.border}`, fontSize:11, overflowX:"auto", whiteSpace:"pre-wrap", wordBreak:"break-word", fontFamily:"ui-monospace, SFMono-Regular, Menlo, monospace" }}>{value}</pre>
                            </>
                          ) : (
                            /* ActivateRole and any future types: label text for now */
                            <span>{label || value || "—"}</span>
                          )}
                        </li>
                      );
                    })}
                  </ul>
                );
              })()}
            </div>
          );
          return (
            <div style={{ border:`1px solid ${T.border}`, borderRadius:10, padding:"12px 14px", marginBottom:14 }}>
              <div style={{ display:"flex", alignItems:"center", gap:10, flexWrap:"wrap", marginBottom:10 }}>
                <span style={{ fontSize:12, fontWeight:700, color:T.text }}>Prerequisites — {prereqUpn}</span>
                {/* Outcome and Coverage are independent axes — ready + partial
                    is a legitimate state, so they get separate pills. */}
                <Badge type={outcome.type}>{outcome.label}</Badge>
                {coverage && (
                  <Badge type={coverage === "complete" ? "green" : "yellow"}>{`Coverage: ${coverage}`}</Badge>
                )}
                <button onClick={clearPrereq} aria-label="Dismiss prerequisites result" style={{ marginLeft:"auto", background:"none", border:"none", color:T.muted, cursor:"pointer", fontSize:14, lineHeight:1, fontFamily:"inherit", padding:2 }}>×</button>
              </div>
              {prereqResult.result_available === false && (
                <div style={{ fontSize:12, color:T.muted }}>
                  The engine no longer has a result for this check (stale run) — run it again.
                </div>
              )}
              {roleIssue && (
                <div style={{ border:"1px solid rgba(243,181,63,.55)", background:"rgba(243,181,63,.10)", borderRadius:8, padding:"8px 12px", marginBottom:10, fontSize:12, color:T.text }}>
                  <strong>Scan account is over-privileged.</strong> This tenant granted Global
                  Administrator to the Patriot scan account. Non-blocking for the scan, but it
                  contradicts our read-only posture — ask the customer to scope the account down.
                </div>
              )}
              {items.length > 0 && (
                <div style={{ marginBottom: issues.length ? 12 : 0 }}>
                  <div style={{ fontSize:11, color:T.muted, fontWeight:600, textTransform:"uppercase", letterSpacing:".04em", marginBottom:6 }}>Checks — only Failed blocks</div>
                  {items.map((it, k) => (
                    <div key={it.check_id || k} style={{ display:"flex", alignItems:"center", gap:8, padding:"3px 0", fontSize:12 }}>
                      <Badge type={PREREQ_ITEM_BADGE[it.status] || "slate"}>{it.status || "—"}</Badge>
                      <span style={{ color:T.text, fontFamily:"ui-monospace, SFMono-Regular, Menlo, monospace" }}>{it.check_id || "—"}</span>
                      {it.status === "Unknown" && (
                        <span style={{ color:T.muted }}>not evaluated — {reasonByCheck[it.check_id] || "no reason given"}</span>
                      )}
                    </div>
                  ))}
                </div>
              )}
              {customerIssues.length > 0 && (
                <div style={{ marginBottom: internalIssues.length ? 12 : 0 }}>
                  <div style={{ fontSize:11, color:T.muted, fontWeight:600, textTransform:"uppercase", letterSpacing:".04em" }}>Customer actionable (tenant admin)</div>
                  {customerIssues.map(issueRow)}
                </div>
              )}
              {internalIssues.length > 0 && (
                <div>
                  <div style={{ fontSize:11, color:T.muted, fontWeight:600, textTransform:"uppercase", letterSpacing:".04em" }}>Patriot-side — internal only</div>
                  {internalIssues.map(issueRow)}
                </div>
              )}
              {/* v1.2 sibling blocks — Patriot-side only (the customer
                  projection never carries them). Each is null when the
                  engine predates contract 1.2 or the result is stale. */}
              {licInv && (
                <div style={{ marginTop:12, paddingTop:10, borderTop:`1px solid ${T.border}` }}>
                  <div style={{ fontSize:11, color:T.muted, fontWeight:600, textTransform:"uppercase", letterSpacing:".04em", marginBottom:4 }}>License inventory — tenant SKUs</div>
                  <div style={{ fontSize:11, color:T.muted, marginBottom:6 }}>
                    {licInv.state || "—"}
                    {licInv.source ? ` · source: ${licInv.source}` : ""}
                    {licInv.collected_utc ? ` · collected ${String(licInv.collected_utc).slice(0, 10)}` : ""}
                  </div>
                  {(licInv.products || []).map((p, k) => (
                    <div key={p.sku_id || k} style={{ display:"flex", alignItems:"baseline", gap:8, padding:"3px 0", fontSize:12, flexWrap:"wrap" }}>
                      {/* product_display_name is null for an unrecognized SKU
                          BY CONTRACT (never a copy of the part number) — the
                          part number is the fallback label. */}
                      <span style={{ color:T.text, fontWeight:600 }}>{p.product_display_name || p.sku_part_number || "—"}</span>
                      <span style={{ color:T.muted, fontFamily:"ui-monospace, SFMono-Regular, Menlo, monospace", fontSize:11 }}>{p.sku_part_number}</span>
                      <span style={{ color:T.muted }}>
                        {p.assigned_units ?? "—"} assigned / {p.enabled_units ?? "—"} enabled
                        {/* LockedOutUnits is not reported by the AdminCenter
                            source (always 0 there) — only the Graph path's
                            value means anything, so only it is shown. */}
                        {licInv.source === "Graph" && p.locked_out_units > 0 ? ` · ${p.locked_out_units} locked out` : ""}
                      </span>
                      {/* RAW engine value ON PURPOSE — do not route this
                          through licenseStatusLabel. This panel is a
                          Patriot DIAGNOSTIC view of the live prerequisite
                          result, where everything renders raw (SKU part
                          numbers, Source, contract versions) so what the
                          engine actually returned is legible. The
                          admin-center vocabulary mapping (Suspended ->
                          "Disabled") is for the CUSTOMER-facing
                          Licensing surfaces and deliberately does NOT
                          apply here; the two reading differently is the
                          decision, not a bug to fix. */}
                      {p.capability_status && p.capability_status !== "Enabled" && (
                        <Badge type="yellow">{p.capability_status}</Badge>
                      )}
                      {!p.product_display_name && (
                        <span title="SKU not in the engine's licensing map" style={{ fontSize:10, fontWeight:700, padding:"1px 6px", borderRadius:4, color:T.muted, border:`1px solid ${T.border}` }}>unrecognized</span>
                      )}
                    </div>
                  ))}
                </div>
              )}
              {testSel && (
                <div style={{ marginTop:12, paddingTop:10, borderTop:`1px solid ${T.border}` }}>
                  <div style={{ fontSize:11, color:T.muted, fontWeight:600, textTransform:"uppercase", letterSpacing:".04em", marginBottom:4 }}>Test selection recommendation</div>
                  <div style={{ display:"flex", alignItems:"center", gap:8, flexWrap:"wrap", fontSize:12 }}>
                    <Badge type={testSel.state === "Ready" && testSel.safe_to_apply === true ? "green" : "yellow"}>
                      {testSel.state === "Ready" && testSel.safe_to_apply === true ? "Ready" : "Not applicable — run full catalog"}
                    </Badge>
                    {testSel.decision_mode && (
                      <span style={{ color:T.muted, fontFamily:"ui-monospace, SFMono-Regular, Menlo, monospace", fontSize:11 }}>{testSel.decision_mode}</span>
                    )}
                    <span style={{ color:T.text }}>
                      recommends {testSel.recommended_test_count ?? "—"} of {testSel.catalog_test_count ?? "—"} catalog tests
                      {(testSel.would_exclude_test_ids || []).length > 0 ? ` · would exclude ${testSel.would_exclude_test_ids.length} if enforced` : ""}
                    </span>
                  </div>
                  {(testSel.unrecognized_active_sku_ids || []).length > 0 && (
                    <div style={{ fontSize:12, color:T.yellow || T.muted, marginTop:4 }}>
                      {testSel.unrecognized_active_sku_ids.length} active SKU{testSel.unrecognized_active_sku_ids.length === 1 ? "" : "s"} not in the licensing map — enforcement would fail open to the full catalog.
                    </div>
                  )}
                  {testSel.summary && <div style={{ fontSize:12, color:T.muted, marginTop:4 }}>{testSel.summary}</div>}
                </div>
              )}
              {connPlan && (
                <div style={{ marginTop:12, paddingTop:10, borderTop:`1px solid ${T.border}` }}>
                  <div style={{ fontSize:11, color:T.muted, fontWeight:600, textTransform:"uppercase", letterSpacing:".04em", marginBottom:4 }}>Connectivity plan</div>
                  <div style={{ display:"flex", alignItems:"center", gap:8, flexWrap:"wrap", fontSize:12 }}>
                    {connPlan.is_fallback === true && (
                      <Badge type="yellow">fallback plan</Badge>
                    )}
                    <span style={{ color:T.text, fontFamily:"ui-monospace, SFMono-Regular, Menlo, monospace", fontSize:11 }}>
                      {(connPlan.selected_channels || []).join(", ") || "—"}
                    </span>
                  </div>
                  {connPlan.is_fallback === true && connPlan.reason && (
                    <div style={{ fontSize:12, color:T.muted, marginTop:4 }}>{connPlan.reason}</div>
                  )}
                </div>
              )}
            </div>
          );
        })()}

        <AdminScanJourneysPanel onSelect={selectScanSlug} selectedCustomer={scanSlug} customers={clientsById} onDownloadResult={downloadScanResult} getCustomerDashboardHref={customerDashboardUrl} />

        {/* Runs — auto-refreshes every 15s while a run is active, and stands
            down once older pages are loaded (see loadMoreScanRuns) */}
        <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", gap:12, marginBottom:6 }}>
          <div style={{ fontSize:11, color:T.muted, fontWeight:600, textTransform:"uppercase", letterSpacing:".04em" }}>Recent runs</div>
          <button
            onClick={() => setScanRunsRefresh(k => k + 1)}
            style={{ padding:"4px 10px", borderRadius:8, fontSize:11, fontWeight:600, fontFamily:"inherit", border:`1px solid ${T.border}`, background:"transparent", color:T.muted, cursor:"pointer" }}
          >Refresh</button>
        </div>

        {/* Run-kind filter. Every count is over the runs LOADED, which is
            exactly the list its chip opens — with cursor paging there is no
            honest way to count the whole engine history without walking it
            (#532: one quantity, one number). The three buckets partition the
            list, so they always sum to All. */}
        {!scanRunsError && scanRuns && scanRuns.length > 0 && (() => {
          const counts = countScanRunKinds(scanRuns);
          const chips = [
            { key: "all", label: "All", n: counts.all, hint: "Every run loaded, whatever its kind." },
            ...Object.values(SCAN_RUN_KIND).map(k => ({
              key: k, label: SCAN_RUN_KIND_LABELS[k], n: counts[k],
              hint: SCAN_RUN_KIND_HINTS[k],
            })),
          ];
          return (
            <div style={{ display:"flex", alignItems:"center", gap:6, flexWrap:"wrap", marginBottom:8 }}>
              {chips.map(c => {
                const active = scanRunKindFilter === c.key;
                return (
                  <button
                    key={c.key}
                    onClick={() => setScanRunKindFilter(c.key)}
                    title={c.hint}
                    style={{
                      padding:"3px 9px", borderRadius:999, fontSize:11, fontWeight:600,
                      fontFamily:"inherit", cursor:"pointer", transition:".15s",
                      border:`1px solid ${active ? T.blue : T.border}`,
                      background: active ? "rgba(90,150,255,.12)" : "transparent",
                      color: active ? T.blue : T.muted,
                    }}
                  >{c.label} ({c.n})</button>
                );
              })}
            </div>
          );
        })()}

        {scanRunsError && (
          <div style={{ fontSize:13, color:T.red, padding:"12px 0" }}>Couldn’t load runs from the SecureScan365 engine. Please try again.</div>
        )}
        {!scanRunsError && scanRuns === null && (
          <div style={{ fontSize:13, color:T.muted, padding:"12px 0" }}>Loading…</div>
        )}
        {!scanRunsError && scanRuns && scanRuns.length === 0 && (
          <div style={{ fontSize:13, color:T.muted, padding:"24px 0", textAlign:"center" }}>No runs yet.</div>
        )}
        {!scanRunsError && scanRuns && scanRuns.length > 0 && (
          <TableScroll>
          <table style={{ width:"100%", borderCollapse:"collapse" }}>
            <thead><tr>
              <th style={{ ...thStyle, width:80 }}>Run</th>
              <th style={thStyle}>Customer</th>
              <th style={thStyle}>User</th>
              <th style={{ ...thStyle, width:105 }}>State</th>
              <th style={{ ...thStyle, width:140 }}>Started</th>
              <th style={{ ...thStyle, width:80 }}>Duration</th>
              <th style={{ ...thStyle, width:70, textAlign:"right" }}>Passed</th>
              <th style={{ ...thStyle, width:70, textAlign:"right" }}>Failed</th>
              <th style={{ ...thStyle, width:70, textAlign:"right" }}>Errors</th>
              <th style={{ ...thStyle, width:170, textAlign:"right" }}>Actions</th>
            </tr></thead>
            <tbody>
              {filterScanRunsByKind(scanRuns, scanRunKindFilter).map(r => {
                // display_state comes from the backend (raw state, or
                // derived from timestamps while the engine's null-state
                // regression is live); local fallback keeps old cached
                // payloads rendering. scanRunDisplayState applies the same
                // fallback, so the badge and the classifier cannot disagree.
                const displayState = scanRunDisplayState(r);
                // Kind decides what goes in the counts columns. A run with
                // no test catalog has no counts to show whichever kind it
                // turns out to be, so both non-assessment buckets collapse
                // those three columns into one badge naming the bucket.
                const kind = scanRunKind(r);
                const isCheck = kind !== SCAN_RUN_KIND.ASSESSMENT;
                // A row the PORTAL recorded (a prereq claim), not one the
                // engine index reported. It knows who started the check
                // and when, and nothing else: no completion, no duration,
                // no counts, and no verdict — the ready/blocked answer
                // lives in the engine's result blob, and this table does
                // not guess at it.
                const isClaimRow = r.source === "claim";
                const num = (v) => (v == null ? "—" : v);
                const claimStateHint = isClaimRow
                  ? (PREREQ_CLAIM_STATE_HINTS[displayState]
                     || PREREQ_CLAIM_STATE_HINT_DEFAULT)
                  : undefined;
                const rowTitle = [
                  r.completed_utc ? `Completed ${fmtWhen(r.completed_utc)}` : null,
                  !SCAN_TERMINAL_STATES.has(displayState) && r.completed_tests != null && r.total_tests != null
                    ? `In progress ${r.completed_tests}/${r.total_tests}` : null,
                  r.skipped_count != null ? `Skipped ${r.skipped_count}` : null,
                ].filter(Boolean).join(" · ") || undefined;
                return (
                  <tr key={r.run_id} title={rowTitle}>
                    <td style={{ ...tdStyle, fontFamily:"monospace", fontSize:12, color:T.muted }}>{(r.run_id || "").slice(0, 8) || "—"}</td>
                    {/* The slug is a real answer when the tenant doesn't
                        resolve to a customer name — a claim names the
                        customer even when pc_customers no longer does. */}
                    <td style={{ ...tdStyle, fontWeight:600, color: r.customer_name ? T.text : T.muted }}>{r.customer_name || r.customer_slug || "—"}</td>
                    <td style={{ ...tdStyle, color:T.muted }}>
                      {isClaimRow ? (
                        // A DIFFERENT FACT from the column's usual one: the
                        // engine account a check ran as is never recorded
                        // on the claim, so this is the Patriot or customer
                        // user who pressed the button. Said in the tooltip
                        // rather than left to look like a scan account.
                        <span title="The portal user who started this check. The account the check ran as is not recorded on the portal's record of it.">
                          <UpnCell value={r.started_by} />
                        </span>
                      ) : (
                        <UpnCell value={r.username} />
                      )}
                    </td>
                    <td style={tdStyle}>
                      <span title={claimStateHint}>
                        <Badge type={SCAN_STATE_BADGE[displayState] || "slate"} weight="soft">{displayState}</Badge>
                      </span>
                    </td>
                    <td style={{ ...tdStyle, color:T.muted, whiteSpace:"nowrap" }}>{fmtWhen(r.started_utc)}</td>
                    <td style={{ ...tdStyle, color:T.muted, whiteSpace:"nowrap" }}>{fmtDuration(r.duration_seconds)}</td>
                    {isCheck ? (
                      <td colSpan={3} style={{ ...tdStyle, textAlign:"center" }}>
                        <span title={SCAN_RUN_KIND_HINTS[kind]}>
                          {/* ONE Badge, TWO meanings — so the type is
                              conditional too. A prereq check is a known
                              kind and wears the in-motion blue;
                              "Unclassified" is the heuristic saying it
                              CANNOT tell, and painting that with a
                              confident tone would be the opposite of what
                              it means. Recolouring both was the live trap
                              here: nothing fails when it happens. */}
                          <Badge
                            type={kind === SCAN_RUN_KIND.CHECK ? "blue" : "slate"}
                            weight="soft"
                          >
                            {kind === SCAN_RUN_KIND.CHECK ? "Prereq check" : "Unclassified"}
                          </Badge>
                        </span>
                      </td>
                    ) : (
                      <>
                        <td style={{ ...tdStyle, textAlign:"right", color: r.passed_count != null ? T.green : T.muted }}>{num(r.passed_count)}</td>
                        <td style={{ ...tdStyle, textAlign:"right", color: r.failed_count ? T.red : T.muted }}>{num(r.failed_count)}</td>
                        <td style={{ ...tdStyle, textAlign:"right", color: r.error_count ? T.orange : T.muted }}>{num(r.error_count)}</td>
                      </>
                    )}
                    <td style={{ ...tdStyle, textAlign:"right" }}>
                      {displayState === "Completed" ? (
                        <>
                          {/* One horizontal line: Send to Scoring (completed
                              assessments only — not Check runs), then the
                              download icon. */}
                          <div style={{ display:"flex", alignItems:"center", justifyContent:"flex-end", gap:8 }}>
                            {!isCheck && sendScoringCell(r)}
                            {downloadIconButton(r)}
                          </div>
                          {!isCheck && sendState[r.run_id]?.error && (
                            <div style={{ fontSize:10, color:T.red, textAlign:"right", whiteSpace:"normal", lineHeight:1.35, marginTop:3 }}>
                              {sendState[r.run_id].error}
                            </div>
                          )}
                        </>
                      ) : (
                        <span style={{ color:T.muted }}>—</span>
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
          </TableScroll>
        )}

        {/* Paging + the retention statement. The 90 days is the ENGINE's
            window, not the portal's: a blob lifecycle policy expires result
            blobs at 90 days and purge-secureaudit-run-data.yml sweeps the
            run index and run state on the same clock. Saying so plainly
            stops "Load more stopped" from reading as lost records. */}
        {!scanRunsError && scanRuns && scanRuns.length > 0 && (
          <div style={{ display:"flex", alignItems:"center", justifyContent:"center", gap:12, flexWrap:"wrap", padding:"12px 0 2px" }}>
            {scanRunsCursor && (
              <button
                onClick={loadMoreScanRuns}
                disabled={scanRunsLoadingMore}
                style={{
                  padding:"5px 14px", borderRadius:8, fontSize:12, fontWeight:600, fontFamily:"inherit",
                  border:`1px solid ${T.border}`, background:"transparent",
                  color: scanRunsLoadingMore ? T.muted : T.blue,
                  cursor: scanRunsLoadingMore ? "wait" : "pointer",
                }}
              >{scanRunsLoadingMore ? "Loading…" : "Load more"}</button>
            )}
            <span style={{ fontSize:11, color:T.muted }}>
              {scanRunsCursor
                ? `${scanRuns.length} loaded · engine retains 90 days`
                : `${scanRuns.length} loaded · end of the engine's history (engine retains 90 days)`}
            </span>
            {/* Two sources, two windows, and the shorter one has to be
                said out loud. Prereq checks are not in the engine's run
                index at all — these rows come from the portal's own record
                of each check, which only began covering Patriot-started
                checks on 2026-08-14. A check run before that date cannot
                appear here and never will; without this line its absence
                reads as a bug. */}
            <span style={{ fontSize:11, color:T.muted }} title="Check rows come from the portal's record of each check, written when it starts. Patriot-started checks began writing that record on August 14, 2026.">
              Prereq checks: portal records, from Aug 14, 2026
            </span>
          </div>
        )}
        {scanRunsMoreError && (
          <div style={{ fontSize:12, color:T.red, textAlign:"center", paddingBottom:8 }}>
            Couldn’t load more runs. The runs already listed are unaffected — try again.
          </div>
        )}
        </>
        )}
      </Card>
      )}

      {/* ── TAB: Scan Fleet — fleet scan-ops rollout list (read-only v1; edit UI is PR 2).
          Scan Tool / Auth Method come from SecureShield Tracking via the entitlements
          precedence, so this tab always agrees with entitlements & next-audit-date. ── */}
      {adminTab === "scanning" && (
      <Card>
        <h3 style={{ margin:"0 0 4px", fontSize:15, fontWeight:700, color:"#fff" }}>Scan Fleet</h3>
        <div style={{ fontSize:12, color:T.muted, marginBottom:14 }}>
          Which scan tool each customer is on. Sorted by Scan Migration Date, newest first — customers without one (including the Unclassified worklist) sort last.
        </div>

        {/* Counts row */}
        {scanSummary && (
          <div style={{ display:"flex", gap:10, flexWrap:"wrap", marginBottom:14 }}>
            {[
              { label:"Legacy",        n:scanCounts.legacy,       c:T.muted },
              { label:"Legacy - Auditor", n:scanCounts.legacyAuditor, c:T.muted },
              { label:"SecureScan365", n:scanCounts.ss365,        c:T.green },
              { label:"Unclassified",  n:scanCounts.unclassified, c:T.yellow },
              { label:"TAP",           n:scanCounts.tap,          c:T.blue },
              /* Elevated-roles tiles — INCLUSIVE: Fabric/Hybrid include the
                 Both overlap, so these four don't sum to the fleet total. */
              { label:"Fabric",        n:scanCounts.fabric,       c:T.blue,   tip:"includes customers with both" },
              { label:"Hybrid",        n:scanCounts.hybrid,       c:T.orange, tip:"includes customers with both" },
              { label:"Both",          n:scanCounts.both,         c:T.green },
              { label:"Neither",       n:scanCounts.neither,      c:T.muted },
            ].map(x => (
              <div key={x.label} title={x.tip} style={{ flex:"0 0 auto", minWidth:110, background:"rgba(255,255,255,.03)", border:`1px solid ${T.border}`, borderRadius:10, padding:"8px 12px" }}>
                <div style={{ fontSize:18, fontWeight:800, lineHeight:1, color:x.c }}>{x.n}</div>
                <div style={{ fontSize:10, color:T.muted, marginTop:3 }}>{x.label}</div>
              </div>
            ))}
          </div>
        )}

        <div style={{ display:"flex", gap:12, flexWrap:"wrap", alignItems:"center", marginBottom:12 }}>
          <PillToggle
            options={[
              { value:"all",           label:"All" },
              { value:"Legacy",        label:"Legacy" },
              /* Without this option a Legacy - Auditor row matches NO
                 filter once it carries a label — not Legacy, not
                 SecureScan365, and not Unclassified (which tests for an
                 ABSENT scan_tool). Adding the label without the filter
                 would make those rows unreachable. */
              { value:"Legacy - Auditor", label:"Legacy - Auditor" },
              { value:"SecureScan365", label:"SecureScan365" },
              { value:"unclassified",  label:"Unclassified" },
            ]}
            value={scanToolFilter}
            onChange={setScanToolFilter}
          />
          {/* Elevated-roles filter — client-side like the search; exclusive
              buckets matching the counts tiles. */}
          <PillToggle
            options={[
              { value:"all",     label:"All roles" },
              { value:"fabric",  label:"Fabric" },
              { value:"hybrid",  label:"Hybrid" },
              { value:"both",    label:"Both" },
              { value:"neither", label:"Neither" },
            ]}
            value={scanElevatedFilter}
            onChange={setScanElevatedFilter}
          />
          {/* Search — house filter-bar idiom (RecsPage search box). */}
          <div style={{ position:"relative", display:"inline-flex", alignItems:"center" }}>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke={T.muted} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ position:"absolute", left:10, pointerEvents:"none" }}><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
            <input
              type="text"
              value={scanSearch}
              onChange={(e) => setScanSearch(e.target.value)}
              placeholder="Search name, slug, or domain…"
              style={{
                padding:"6px 28px 6px 30px", borderRadius:8, width:240, maxWidth:"48vw",
                border:`1px solid ${scanSearch ? "rgba(68,166,255,.5)" : T.border}`,
                background:"rgba(255,255,255,.04)", color:T.text, fontFamily:"inherit", fontSize:12, outline:"none",
              }}
            />
            {scanSearch && (
              <button onClick={() => setScanSearch("")} aria-label="Clear search" style={{
                position:"absolute", right:6, background:"none", border:"none", color:T.muted,
                cursor:"pointer", fontSize:14, lineHeight:1, fontFamily:"inherit", padding:2,
              }}>×</button>
            )}
          </div>
        </div>

        {scanSummaryError && (
          <div style={{ fontSize:13, color:T.red, padding:"12px 0" }}>Couldn’t load the scan summary. Please try again.</div>
        )}
        {!scanSummaryError && scanSummary === null && (
          <div style={{ fontSize:13, color:T.muted, padding:"12px 0" }}>Loading…</div>
        )}
        {!scanSummaryError && scanSummary && scanRows.length === 0 && (
          <div style={{ fontSize:13, color:T.muted, padding:"24px 0", textAlign:"center" }}>No customers match.</div>
        )}
        {!scanSummaryError && scanSummary && scanRows.length > 0 && (
          <TableScroll>
          <table style={{ width:"100%", borderCollapse:"collapse" }}>
            <thead><tr>
              <th style={thStyle}>Customer</th>
              <th style={{ ...thStyle, width:130 }}>Scan Tool</th>
              <th style={{ ...thStyle, width:190 }}>Auth Method</th>
              <th style={{ ...thStyle, width:130 }}>Migrated</th>
              <th style={{ ...thStyle, width:60 }}>Notes</th>
              <th style={{ ...thStyle, width:110 }}>Tenant ID</th>
              <th style={thStyle}>Domains</th>
              <th style={{ ...thStyle, width:70 }}>Actions</th>
            </tr></thead>
            <tbody>
              {/* Key includes the index — duplicate slugs exist by design (#327 demo pair). */}
              {scanRows.map((s, i) => {
                const toolPill = s.scan_tool === "SecureScan365"
                  ? { bg:"rgba(83,196,109,.12)",  bd:"rgba(83,196,109,.35)",  c:T.green,  text:"SecureScan365" }
                  : s.scan_tool === "Legacy"
                  ? { bg:"rgba(255,255,255,.06)", bd:T.border,                c:T.muted,  text:"Legacy" }
                  : { bg:"rgba(243,181,63,.12)",  bd:"rgba(243,181,63,.35)",  c:T.yellow, text:"Unclassified" };
                return (
                  <tr key={`${s.slug || s.customer_name}-${i}`}>
                    <td style={{ ...tdStyle, fontWeight:600, color:T.text }} title={s.slug}>{s.customer_name || s.slug || "—"}</td>
                    <td style={tdStyle}>
                      <span style={{ fontSize:11, padding:"2px 8px", borderRadius:999, whiteSpace:"nowrap", background:toolPill.bg, border:`1px solid ${toolPill.bd}`, color:toolPill.c }}>{toolPill.text}</span>
                    </td>
                    <td style={{ ...tdStyle, color: s.auth_method ? T.text : T.muted }}>
                      <div style={{ display:"flex", alignItems:"center", gap:6, flexWrap:"wrap" }}>
                        <span>{s.auth_method || "—"}</span>
                        {/* Elevated-role chips — subtle/muted; no chip when neither. */}
                        {s.fabric_admin && (
                          <span title="Fabric admin" style={{ fontSize:9, fontWeight:700, padding:"1px 5px", borderRadius:4, color:T.muted, border:`1px solid ${T.border}`, background:"rgba(255,255,255,.05)" }}>F</span>
                        )}
                        {s.hybrid_admin && (
                          <span title="Hybrid admin" style={{ fontSize:9, fontWeight:700, padding:"1px 5px", borderRadius:4, color:T.muted, border:`1px solid ${T.border}`, background:"rgba(255,255,255,.05)" }}>H</span>
                        )}
                      </div>
                    </td>
                    <td style={{ ...tdStyle, color: s.migration_date ? T.text : T.muted, whiteSpace:"nowrap" }}>{fmtDateOnly(s.migration_date)}</td>
                    <td style={{ ...tdStyle, textAlign:"center" }}>
                      {s.has_notes
                        ? <span title="Has scan notes" style={{ color:T.blue, fontSize:14, lineHeight:1 }}>●</span>
                        : <span style={{ color:T.muted }}>—</span>}
                    </td>
                    <td style={{ ...tdStyle, color:T.muted, whiteSpace:"nowrap" }}>
                      {s.tenant_id
                        ? <span title={s.tenant_id} style={{ cursor:"default" }}>{s.tenant_id.slice(0, 8)}…</span>
                        : "—"}
                    </td>
                    <td style={{ ...tdStyle, color:T.muted, maxWidth:220, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }} title={s.domains || ""}>{s.domains || "—"}</td>
                    <td style={{ ...tdStyle, textAlign:"right" }}>
                      {s.tracking_id && (
                        <button
                          onClick={() => openScanEdit(s)}
                          style={{ background:"none", border:"none", padding:0, color:T.blue, fontSize:12, fontFamily:"inherit", cursor:"pointer", textDecoration:"underline", textUnderlineOffset:3 }}
                        >
                          Edit
                        </button>
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
          </TableScroll>
        )}

        <Modal
          show={!!scanEditTarget}
          title={`Edit Scan Fleet — ${scanEditTarget?.customer_name || scanEditTarget?.slug || "Customer"}`}
          onClose={closeScanEdit}
          onSubmit={handleScanEdit}
          submitLabel={scanEditBusyId ? "Saving…" : "Save"}
          submitDisabled={!scanEditChanged || !!scanEditBusyId}
        >
          <div style={{ display:"grid", gap:12 }}>
            <label style={{ display:"grid", gap:6, color:T.muted, fontSize:12, fontWeight:600 }}>
              Scan tool
              <select
                value={scanEditToolKey}
                onChange={(e) => handleScanEditToolChange(e.target.value)}
                disabled={!!scanEditBusyId}
                style={{ background:T.panel2, border:`1px solid ${T.border}`, borderRadius:8, color:T.text, padding:"9px 10px", fontFamily:"inherit", fontSize:13 }}
              >
                <option value="" disabled>Select scan tool</option>
                <option value="legacy">Legacy</option>
                <option value="securescan365">SecureScan365</option>
              </select>
            </label>
            <label style={{ display:"grid", gap:6, color:T.muted, fontSize:12, fontWeight:600 }}>
              Auth method
              <select
                value={scanEditAuthKey}
                onChange={(e) => setScanEditAuthKey(e.target.value)}
                disabled={scanEditToolKey !== "securescan365" || !!scanEditBusyId}
                style={{ background:T.panel2, border:`1px solid ${T.border}`, borderRadius:8, color:T.text, padding:"9px 10px", fontFamily:"inherit", fontSize:13, opacity:scanEditToolKey === "securescan365" ? 1 : .55 }}
              >
                <option value="">Not set</option>
                <option value="passkey">Passkey</option>
                <option value="tap">TAP (Temporary Access Pass)</option>
              </select>
            </label>
            <label style={{ display:"grid", gap:6, color:T.muted, fontSize:12, fontWeight:600 }}>
              Migration date
              <input
                type="date"
                value={scanEditMigDate}
                onChange={(e) => setScanEditMigDate(e.target.value)}
                disabled={!!scanEditBusyId}
                style={{ background:T.panel2, border:`1px solid ${T.border}`, borderRadius:8, color:T.text, padding:"9px 10px", fontFamily:"inherit", fontSize:13 }}
              />
              <span style={{ fontSize:10, fontWeight:400, color:T.muted }}>
                {scanEditMigDate ? fmtDateOnly(scanEditMigDate) : "Not set"}
              </span>
            </label>
            <div style={{ display:"grid", gridTemplateColumns:"repeat(2, minmax(0, 1fr))", gap:10 }}>
              {[
                ["Fabric Admin", scanEditFabric, setScanEditFabric],
                ["Hybrid Identity Admin", scanEditHybrid, setScanEditHybrid],
              ].map(([label, checked, setter]) => (
                <label key={label} style={{ display:"flex", alignItems:"center", gap:8, color:T.muted, fontSize:12, fontWeight:600, padding:"9px 10px", border:`1px solid ${T.border}`, borderRadius:8, opacity:scanEditToolKey === "securescan365" ? 1 : .55 }}>
                  <input
                    type="checkbox"
                    checked={checked}
                    onChange={(e) => setter(e.target.checked)}
                    disabled={scanEditToolKey !== "securescan365" || !!scanEditBusyId}
                  />
                  {label}
                </label>
              ))}
            </div>
            <div style={{ display:"grid", gap:6, color:T.muted, fontSize:12, fontWeight:600 }}>
              Existing notes
              <div style={{ minHeight:70, maxHeight:150, overflowY:"auto", whiteSpace:"pre-wrap", background:"rgba(255,255,255,.025)", border:`1px solid ${T.border}`, borderRadius:8, color:T.text, padding:"9px 10px", fontSize:12, fontWeight:400, lineHeight:1.45 }}>
                {scanEditNotesLoading ? "Loading…" : (scanEditNotesBody || "No notes yet")}
              </div>
            </div>
            <label style={{ display:"grid", gap:6, color:T.muted, fontSize:12, fontWeight:600 }}>
              Migration note (append-only)
              <textarea
                value={scanEditNote}
                onChange={(e) => setScanEditNote(e.target.value)}
                disabled={!!scanEditBusyId}
                rows={4}
                placeholder="Add context for this migration…"
                style={{ background:T.panel2, border:`1px solid ${T.border}`, borderRadius:8, color:T.text, padding:"9px 10px", fontFamily:"inherit", fontSize:13, resize:"vertical" }}
              />
            </label>
            {scanEditError && (
              <div style={{ color:T.red, fontSize:12 }}>{scanEditError}</div>
            )}
          </div>
        </Modal>
      </Card>
      )}

      {/* ── TAB: Licensing — one customer's stored Microsoft license
          inventory (PR2). Portal chrome, admin-center vocabulary. Reads
          the snapshot the prereq path writes; never a live engine call,
          so it loads instantly or says plainly that nothing has been
          collected yet — the EXPECTED state for most customers until
          their next prerequisites check. ── */}
      {adminTab === "licensing" && (
      <Card title="Licensing">
        <div style={{ display:"flex", alignItems:"center", gap:10, marginBottom:14, flexWrap:"wrap" }}>
          <label htmlFor="lic-customer" style={{ fontSize:12, color:T.muted, fontWeight:600 }}>Customer</label>
          <select
            id="lic-customer"
            value={licSlug}
            onChange={e => loadLicenseInventory(e.target.value)}
            style={{ padding:"6px 10px", borderRadius:8, fontSize:13, fontFamily:"inherit", background:"transparent", color:T.text, border:`1px solid ${T.border}`, maxWidth:360 }}
          >
            <option value="">Select a customer…</option>
            {Object.entries(clientsById)
              .sort((a, b) => String(a[1]).localeCompare(String(b[1])))
              .map(([slug, name]) => (
                <option key={slug} value={slug}>{name || slug}</option>
              ))}
          </select>
        </div>

        {licLoading && <div style={{ fontSize:13, color:T.muted }}>Loading…</div>}
        {licError && <div style={{ fontSize:13, color:T.red }}>{licError}</div>}

        {licData && licData.available === false && (
          <div style={{ border:`1px solid ${T.border}`, borderRadius:10, padding:"14px 16px", fontSize:13, color:T.text }}>
            <div style={{ fontWeight:700, marginBottom:4 }}>No license inventory collected yet</div>
            <div style={{ color:T.muted }}>
              {/* #510 shipped this pointing at Scan Fleet; Check
                  Prerequisites lives on the SecureScan365 tab ("scans"). */}
              Expected for most customers right now: the inventory is captured automatically
              whenever a prerequisites check runs, and this customer hasn't had one since
              collection began. Run <strong>Check Prerequisites</strong> on the SecureScan365 tab to
              collect it — the result appears here immediately afterwards.
            </div>
            <button
              onClick={() => setAdminTab("scans")}
              style={{ marginTop:10, padding:"6px 14px", borderRadius:8, fontSize:12, fontWeight:700, fontFamily:"inherit", border:`1px solid ${T.border}`, background:"transparent", color:T.blue, cursor:"pointer" }}
            >Go to SecureScan365</button>
          </div>
        )}

        {licData && licData.available === true && (() => {
          const inv = licData.inventory || {};
          const staleness = licData.staleness;
          const meta = licData.meta || {};
          const products = sortLicenseProducts(inv.products, licSort.key, licSort.dir);
          const stalePill = staleness === "fresh" ? { type:"green", label:"Fresh" }
            : staleness === "aging" ? { type:"yellow", label:"Aging" }
            : staleness === "rescan_needed" ? { type:"red", label:"Re-check needed" }
            : null;
          const arrow = (key) => licSort.key === key ? (licSort.dir === "desc" ? " ↓" : " ↑") : "";
          const TH = ({ colKey, align, children }) => (
            <th style={{ textAlign: align || "left", padding:"6px 10px", fontSize:11, color:T.muted, textTransform:"uppercase", letterSpacing:".04em", whiteSpace:"nowrap" }}>
              <button
                onClick={() => licSortBy(colKey)}
                style={{ background:"none", border:"none", color:"inherit", font:"inherit", cursor:"pointer", padding:0, textTransform:"inherit", letterSpacing:"inherit" }}
              >{children}{arrow(colKey)}</button>
            </th>
          );
          return (
            <div>
              <div style={{ display:"flex", alignItems:"center", gap:10, flexWrap:"wrap", marginBottom:10, fontSize:12, color:T.muted }}>
                {stalePill && (
                  <span title={`Fresh under ${meta.aging_days} days; re-check needed past ${meta.rescan_needed_days} days`}>
                    <Badge type={stalePill.type}>{stalePill.label}</Badge>
                  </span>
                )}
                <span>
                  Collected {licData.collected_utc ? String(licData.collected_utc).slice(0, 10) : "—"}
                  {" · "}Source: {inv.source || "—"}
                  {" · "}{inv.product_count ?? (inv.products || []).length} products
                  {/* Patriot-side facts, same class as Source. A stored
                      inventory can now be Partial (the writer's allowlist),
                      so the state is worth naming whenever it isn't
                      Complete — and the invalid count rides with it even
                      at 0, because "Partial with 0 invalid" says the
                      partiality came from something else. */}
                  {inv.state && inv.state !== "Complete" && (
                    <span style={{ color:T.yellow }}>{` · collection: ${inv.state}`}</span>
                  )}
                  {(Number(inv.invalid_record_count) > 0 || (inv.state && inv.state !== "Complete"))
                    ? ` · ${inv.invalid_record_count ?? 0} invalid records`
                    : ""}
                </span>
                {/* PR3: the customer view SUPPRESSES on this; Patriot sees
                    it as a fact to carry into the review conversation. */}
                {licData.tenant_shared === true && (
                  <Badge type="yellow">Shared Entra tenant — this inventory spans more than one customer</Badge>
                )}
              </div>
              <TableScroll>
                <table style={{ borderCollapse:"collapse", width:"100%", minWidth:560 }}>
                  <thead>
                    <tr style={{ borderBottom:`1px solid ${T.border}` }}>
                      <TH colKey="product">Product</TH>
                      <TH colKey="available" align="right">Available</TH>
                      <TH colKey="assigned">Assigned</TH>
                      <TH colKey="status">Status</TH>
                    </tr>
                  </thead>
                  <tbody>
                    {products.map((p, i) => {
                      const pct = licenseBarPct(p.assigned_units, p.enabled_units);
                      return (
                        <tr key={p.sku_id || i} style={{ borderBottom:`1px solid ${T.border}` }}>
                          <td style={{ padding:"8px 10px", fontSize:13, color:T.text }}>
                            {/* product_display_name is null for an unrecognized
                                SKU BY CONTRACT — part number is the fallback. */}
                            {p.product_display_name || p.sku_part_number || "—"}
                            {!p.product_display_name && (
                              <span title="SKU not in Microsoft's licensing map" style={{ marginLeft:8, fontSize:10, fontWeight:700, padding:"1px 6px", borderRadius:4, color:T.muted, border:`1px solid ${T.border}` }}>unrecognized</span>
                            )}
                          </td>
                          <td style={{ padding:"8px 10px", fontSize:13, color:T.text, textAlign:"right", fontVariantNumeric:"tabular-nums" }}>
                            {p.available_units ?? "—"}
                          </td>
                          <td style={{ padding:"8px 10px", fontSize:12, color:T.text, minWidth:180 }}>
                            <div style={{ display:"flex", alignItems:"center", gap:8 }}>
                              <div style={{ flex:"0 0 90px", height:6, borderRadius:3, background:"rgba(148,163,184,.25)", overflow:"hidden" }}>
                                <div style={{ width:`${pct}%`, height:"100%", borderRadius:3, background:T.blue }} />
                              </div>
                              <span style={{ whiteSpace:"nowrap", fontVariantNumeric:"tabular-nums" }}>
                                {p.assigned_units ?? "—"} / {p.enabled_units ?? "—"}
                              </span>
                            </div>
                          </td>
                          <td style={{ padding:"8px 10px" }}>
                            <Badge type={p.capability_status === "Enabled" ? "green" : p.capability_status === "Suspended" ? "red" : p.capability_status ? "yellow" : "slate"}>
                              {licenseStatusLabel(p.capability_status) || "—"}
                            </Badge>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </TableScroll>
            </div>
          );
        })()}
      </Card>
      )}

      {/* ── TAB: Reviews — Admin Ops, Phase A of SPEC-admin-ops-review-view.
          READ-ONLY. Four views over data that already exists; nothing here
          writes. The workflow-status column in particular is display only —
          status writing and the date behaviour that must accompany it are
          Phase B and cannot ship apart (see shared/review_ops.py). ── */}
      {adminTab === "reviews" && (
      <Card>
        <h3 style={{ margin:"0 0 4px", fontSize:15, fontWeight:700, color:"#fff" }}>Assessments</h3>
        {/* The download sits on the SUBTITLE line, right-aligned, rather
            than in the view PillToggle below or beside the heading. In the
            PillToggle it would read as a fifth view — a thing that changes
            what the page shows — which it is not. Beside the heading it
            would compete with the section title for weight. On this line it
            reads as what it is (a utility for the read-only data the
            sentence just described) and costs no vertical space, because
            the subtitle row already existed. */}
        <div style={{
          display:"flex", alignItems:"baseline", justifyContent:"space-between",
          gap:12, flexWrap:"wrap", marginBottom:14,
        }}>
          <div style={{ fontSize:12, color:T.muted }}>
            Who is overdue, who is coming up, and what the team has recorded. Read-only.
          </div>
          <div style={{ display:"flex", alignItems:"center", gap:8, flexWrap:"wrap", minWidth:0, maxWidth:"100%" }}>
            {weeklyReportError && (
              <span style={{ fontSize:11, color:T.red }}>
                Couldn’t download the report data. Please try again.
              </span>
            )}
            <span data-testid="freshservice-group-discovery-status" style={{ fontSize:11, color:T.muted }}>
              Group mapping: {{ not_configured:"not configured", not_requested:"not requested", waiting:"waiting", preparing:"preparing", ready:"ready", rate_limited:"rate limited", expired:"unavailable", request_cap_exhausted:"unavailable", unavailable:"unavailable" }[groupDiscovery?.state] || "checking"}
            </span>
            {groupDiscovery?.state === "not_requested" && (
              <button onClick={requestGroupDiscovery} disabled={groupDiscoveryBusy} title="Request one group-directory discovery" style={{ fontSize:11 }}>Prepare group mapping</button>
            )}
            {groupDiscovery?.downloadable && (
              <button onClick={downloadGroupDiscovery} disabled={groupDiscoveryBusy} title="Download sealed group candidate" style={{ fontSize:11 }}>Download groups</button>
            )}
            {groupDiscoveryError && <span style={{ fontSize:11, color:T.red }}>Group mapping action unavailable.</span>}
            <button
              onClick={downloadWeeklyReport}
              disabled={weeklyReportBusy}
              title="Download this week's management report data as JSON — the same numbers this tab and Customer Management show."
              style={{
                padding:"4px 10px", borderRadius:8, fontSize:11, fontWeight:600,
                fontFamily:"inherit", border:`1px solid ${T.border}`,
                background:"transparent",
                color: weeklyReportBusy ? T.muted : T.blue,
                cursor: weeklyReportBusy ? "wait" : "pointer",
                whiteSpace:"nowrap",
              }}
            >{weeklyReportBusy ? "Preparing…" : "Download report data"}</button>
            <FreshserviceExportControl theme={T} />
          </div>
        </div>

        <div style={{ marginBottom:14 }}>
          <PillToggle
            options={[
              /* ONE option per render branch, which is the whole fix here.
                 #531 merged Backlog and Approaching into the Scheduling
                 view but left this array offering the two pre-merge values;
                 neither has a `reviewView === ...` branch, so both buttons
                 blanked the panel in production. The bucket choice now
                 lives one level down, in the Scheduling filter.

                 BADGE = schedulingTotal(…, "backlog"), never
                 reviewCounts.backlog. The raw bucket count includes rows
                 outside the default universe (On Hold + Pending), so the
                 two disagree — this badge read 50 while the filter badge
                 and the "showing N of M" line below read 47 for the same
                 quantity. One quantity, one number. Backlog specifically
                 because Backlog is where the section lands. */
              { value:"scheduling",  label:"Scheduling", badge:schedulingTotal(reviewCustomers, "backlog") || undefined },
              /* The engineers' view. BADGE = scanQueueBadgeTotal over the
                 SAME payload the three pills render (the fleet rows AND the
                 held-scan list), from the one scanQueueBuckets call — the
                 tab number is the sum of the three pill numbers by
                 construction rather than by a second count agreeing with
                 the first (#532/#557). It reads higher than the old
                 scanQueueTotal did, because Held for review counts held
                 scans at any workflow status (design §7b). Absent (not
                 zero) when nothing is waiting; PillToggle omits a falsy
                 badge, and an empty queue needs no decoration. */
              { value:"scanqueue",   label:"Scan Queue", badge:scanQueueBadgeTotal(reviewCustomers, queue) || undefined },
              /* Display label only — the id stays "recorded". Nothing
                 depends on it and renaming it would touch the memo, both
                 reviewView branches and rowCount for no gain. "Delivery"
                 is what the team says: "how many deliveries did you have
                 this week". */
              { value:"recorded",    label:"Delivery" },
              /* Customer Management was a fourth option here until
                 2026-08-14, when it became a top-level tab. Removed in the
                 same commit as its render branch moved: an option whose
                 value is no longer in REVIEW_VIEWS writes a hash the reader
                 coerces away, which is #531's dead button exactly. */
            ]}
            value={reviewView}
            onChange={setReviewView}
          />
        </div>

        {/* Every view in this section reads the review-ops payload, so the
            load and failure states belong to the whole section again. The
            `reviewView !== "management"` guard that used to sit on both
            lines left with Customer Management on 2026-08-14 — that view had
            its own payload, its own load state and its own failure, and it
            still does, one tab over. */}
        {reviewOpsError && (
          <div style={{ fontSize:13, color:T.red, padding:"12px 0" }}>Couldn’t load the review data. Please try again.</div>
        )}
        {!reviewOpsError && reviewOps === null && (
          <div style={{ fontSize:13, color:T.muted, padding:"12px 0" }}>Loading…</div>
        )}

        {!reviewOpsError && reviewOps && (
          <>
            {/* ── Backlog / Approaching — same row shape ── */}
            {reviewView === "scheduling" && (
              <>
                {/* The filter that replaced the two tabs. Backlog is the
                    DEFAULT and reproduces the old Backlog tab exactly —
                    same rows, same cards, same grace section beneath.
                    "All" is the combined list (backlog + just-past-due +
                    approaching) and carries no cards, because the cards
                    belong to a focused bucket. "On Hold + Pending" keeps
                    the six rows outside the default universe reachable
                    rather than letting them rot. */}
                <div style={{ marginBottom:12 }}>
                  <PillToggle
                    options={[
                      /* All four carry counts — the reader has to see what
                         they are clicking into, and on the two combined
                         filters this is the information the cards would
                         otherwise have carried. Every count is the size of
                         that filter's own universe, so they agree with the
                         "showing N of M" line below. */
                      { value:"backlog",     label:"Backlog",     badge:schedulingTotal(reviewCustomers, "backlog") || undefined },
                      { value:"approaching", label:"Approaching", badge:schedulingTotal(reviewCustomers, "approaching") || undefined },
                      /* Amber's focused working list — Backlog ∪ Approaching,
                         no grace. Its badge is the size of that union, which
                         equals the two badges above summed because `bucket` is
                         one scalar per row (the rows are disjoint). No cards,
                         so the badge carries the count the cards otherwise
                         would. */
                      { value:"backlogapproaching", label:"Backlog + Approaching", badge:schedulingTotal(reviewCustomers, "backlogapproaching") || undefined },
                      /* Outreach view, not a backlog claim. Every explicit
                         normalized Banked row in the active fleet belongs
                         here, including On Hold/Pending and suppressed rows.
                         Its badge counts both visible sections because the
                         pill opens both; the main-table denominator below
                         remains the actionable half of that identity. */
                      { value:"banked",      label:"Banked",      badge:schedulingUniverseTotal(reviewCustomers, "banked") || undefined },
                      /* The All badge follows the checkbox — it is the size
                         of the universe that pill actually opens, ticked or
                         not, so the number on the control never disagrees
                         with the list beneath it (#532). */
                      { value:"all",         label:"All",         badge:schedulingTotal(reviewCustomers, "all", { includeOnHold }) || undefined },
                      { value:"onhold",      label:"On Hold + Pending", badge:schedulingTotal(reviewCustomers, "onhold") || undefined },
                    ]}
                    value={schedulingFilter}
                    onChange={setSchedulingFilter}
                  />
                </div>
                <div style={{ fontSize:12, color:T.muted, marginBottom:12, lineHeight:1.6 }}>
                  {schedulingBucket === "backlog" ? (
                    <>
                      More than {reviewOps.meta?.backlog_grace_days ?? 10} days past the
                      next-audit date. That date is advanced at every step of the booking
                      workflow, so a customer who has already booked carries their meeting
                      date and does not appear here.
                    </>
                  ) : schedulingFilter === "backlogapproaching" ? (
                    /* The combined tab has no `schedulingBucket` of its own,
                       so without this branch it fell through to the
                       Approaching sentence above a list that is mostly
                       overdue rows. Describe what the tab actually opens. */
                    <>
                      Backlog and Approaching in one working list — overdue rows and
                      reviews due within {reviewOps.meta?.approaching_days ?? 14} days,
                      without the just-past-due grace rows. Most urgent first.
                    </>
                  ) : schedulingFilter === "banked" ? (
                    <>
                      Banked outreach timing across every active Banked row —
                      including On Hold and Pending. This is an outreach view,
                      not a backlog claim.
                    </>
                  ) : (
                    <>
                      Next audit due within {reviewOps.meta?.approaching_days ?? 14} days.
                      The last reviewer is shown so you can see who ran the previous one
                      before deciding who picks this up.
                    </>
                  )}
                </div>

                {/* ── Cards. Backlog gets SEVERITY bands in the existing
                    severity palette (Badge: critical purple, high red,
                    medium orange — the same ones the customer overview
                    uses; no new colour values). Approaching gets HORIZON
                    cards, deliberately uncoloured: a review coming up is
                    not a warning, and painting it like one trains the
                    reader to ignore the colours that are. Clicking
                    filters the list, same interaction as the engineer
                    cards on Recorded. ── */}
                {schedulingBucket === "backlog" && (
                  <div style={{ display:"flex", gap:10, flexWrap:"wrap", marginBottom:14 }}>
                    {[{ key:"", label:"Total backlog", type:null,
                        count:reviewSeverityCounts.total,
                        // THE BIG NUMBER IS ACTIONABLE; the fuller picture
                        // rides the existing sub slot, and ONLY when the two
                        // differ — so the common case stays exactly as clean
                        // as it was. "incl." keeps it to a card sub-line.
                        sub: reviewSeverityCounts.suppressed > 0
                          ? `over ${reviewOps.meta?.backlog_grace_days ?? 10} days · `
                            + `${reviewSeverityCounts.universeTotal} incl. scheduled meetings`
                          : `over ${reviewOps.meta?.backlog_grace_days ?? 10} days` },
                      ...SEVERITY_BANDS.map(b => ({
                        key:b.key, label:b.label, type:b.type,
                        count:reviewSeverityCounts[b.key],
                        sub:bandRangeLabel(b.key, reviewOps.meta),
                      })),
                      /* Beside the bands, NOT one of them — those are
                         severity bands OF THE BACKLOG, and folding a
                         non-backlog pill into Medium would make that
                         card's number mean two things. Soft weight
                         against the bands' heavy is the first-order
                         signal that this is a different kind of thing;
                         the hue difference is secondary. */
                      { key:JUST_PAST_DUE, label:JUST_PAST_DUE_LABEL,
                        type:"yellow", soft:true, spacerBefore:true,
                        count:reviewGraceCount,
                        sub:justPastDueRangeLabel(reviewOps.meta) },
                    ].map((card) => {
                      const on = reviewBand === card.key;
                      return (
                        <button
                          key={card.key || "total"}
                          onClick={() => setReviewBand(card.key)}
                          /* A gap before it so the eye groups the three
                             bands together and this separately. */
                          data-spacer={card.spacerBefore ? "1" : undefined}
                          aria-pressed={on}
                          title={card.key ? `Show only ${card.label}` : "Show the whole backlog"}
                          style={{
                            flex:"1 1 150px", minWidth:140, textAlign:"left", cursor:"pointer",
                            padding:"12px 14px", borderRadius:10, fontFamily:"inherit",
                            marginLeft: card.spacerBefore ? 14 : 0,
                            border:`1px solid ${on ? "rgba(68,166,255,.6)" : T.border}`,
                            background: on ? "rgba(68,166,255,.10)" : "rgba(255,255,255,.04)",
                          }}
                        >
                          <div style={{ marginBottom:7 }}>
                            {card.type
                              ? <Badge type={card.type} weight={card.soft ? "soft" : "heavy"}>{card.label}</Badge>
                              : <span style={{ fontSize:11, fontWeight:600, color:T.muted, letterSpacing:".02em" }}>{card.label}</span>}
                          </div>
                          <div style={{ fontSize:24, fontWeight:700, color:T.text, lineHeight:1 }}>
                            {card.count}
                          </div>
                          <div style={{ fontSize:11, color:T.muted, marginTop:5 }}>{card.sub}</div>
                        </button>
                      );
                    })}
                  </div>
                )}

                {schedulingBucket === "approaching" && (
                  <div style={{ display:"flex", gap:10, flexWrap:"wrap", marginBottom:14 }}>
                    {reviewHorizonCards.map((card) => {
                      const on = reviewHorizon === card.key;
                      return (
                        <button
                          key={card.key}
                          onClick={() => setReviewHorizon(card.key)}
                          aria-pressed={on}
                          style={{
                            flex:"1 1 150px", minWidth:140, textAlign:"left", cursor:"pointer",
                            padding:"12px 14px", borderRadius:10, fontFamily:"inherit",
                            border:`1px solid ${on ? "rgba(68,166,255,.6)" : T.border}`,
                            background: on ? "rgba(68,166,255,.10)" : "rgba(255,255,255,.04)",
                          }}
                        >
                          <div style={{ fontSize:11, fontWeight:600, color: on ? T.blue : T.muted, marginBottom:7, letterSpacing:".02em" }}>
                            {card.label}
                          </div>
                          <div style={{ fontSize:24, fontWeight:700, color:T.text, lineHeight:1 }}>
                            {card.count}
                          </div>
                          <div style={{ fontSize:11, color:T.muted, marginTop:5 }}>{card.sub}</div>
                        </button>
                      );
                    })}
                  </div>
                )}

                {/* Expired-but-entitled: fleet-wide count (all rows,
                    not the visible slice — the population is the
                    point), rendered only when non-zero, backlog view
                    only (the tab's landing). The action is a CRM
                    correction — account side, not Amber, not the
                    engineers. Annotates; never hides rows. */}
                {schedulingBucket === "backlog" && contractExpiredCount(reviewCustomers) > 0 && (
                  <div style={{
                    marginBottom: 12, padding: "9px 12px", borderRadius: 10,
                    background: "rgba(225,77,87,.08)",
                    border: "1px solid rgba(225,77,87,.35)",
                    fontSize: 12.5, color: T.text,
                    display: "flex", gap: 10, alignItems: "center", flexWrap: "wrap",
                  }}>
                    <span>
                      <b>{contractExpiredCount(reviewCustomers)}</b>
                      {contractExpiredCount(reviewCustomers) === 1
                        ? " customer shows an expired contract but still reads entitled"
                        : " customers show an expired contract but still read entitled"}
                      {" — verify renewal in CRM."}
                    </span>
                    <button
                      onClick={() => setExpiredOnly(v => !v)}
                      style={{
                        padding: "3px 10px", fontSize: 12, borderRadius: 8,
                        fontFamily: "inherit", cursor: "pointer",
                        border: `1px solid ${expiredOnly ? T.red : T.border}`,
                        background: expiredOnly ? "rgba(225,77,87,.18)" : "rgba(255,255,255,.05)",
                        color: T.text,
                      }}
                    >
                      {expiredOnly ? "Show all rows" : "Show only these"}
                    </button>
                  </div>
                )}

                {/* Unrecorded-review banner: same chassis as the
                    expired-contract banner above; the two STACK when
                    both fire, and the verbs stay distinct — "chase the
                    engineer" here, "verify renewal in CRM" there — so
                    they cannot blur. Blue, not red: a process nudge,
                    not wrong data. */}
                {schedulingBucket === "backlog" && unrecordedCount(reviewCustomers) > 0 && (
                  <div style={{
                    marginBottom: 12, padding: "9px 12px", borderRadius: 10,
                    background: "rgba(68,166,255,.08)",
                    border: "1px solid rgba(68,166,255,.35)",
                    fontSize: 12.5, color: T.text,
                    display: "flex", gap: 10, alignItems: "center", flexWrap: "wrap",
                  }}>
                    <span>
                      <b>{unrecordedCount(reviewCustomers)}</b>
                      {unrecordedCount(reviewCustomers) === 1
                        ? " review likely delivered but not recorded"
                        : " reviews likely delivered but not recorded"}
                      {" — chase the engineer, not the customer."}
                    </span>
                    <button
                      onClick={() => setUnrecordedOnly(v => !v)}
                      style={{
                        padding: "3px 10px", fontSize: 12, borderRadius: 8,
                        fontFamily: "inherit", cursor: "pointer",
                        border: `1px solid ${unrecordedOnly ? T.blue : T.border}`,
                        background: unrecordedOnly ? "rgba(68,166,255,.18)" : "rgba(255,255,255,.05)",
                        color: T.text,
                      }}
                    >
                      {unrecordedOnly ? "Show all rows" : "Show only these"}
                    </button>
                  </div>
                )}

                {/* ── Readiness / scan-method / allowance-model chips (Amber,
                    2026-08-13; allowance added 2026-08-30):
                    "can I have a filter where I can filter the readiness…
                    all of the green that are ready to book, so I know who
                    I can send booking links to", and "readiness and then
                    also the scan method?".

                    DISPLAY ONLY. They narrow THIS list; no count, badge,
                    banner or other view moves. Within a group the chips OR;
                    the groups AND. Nothing selected is today's view,
                    byte for byte.

                    Counts come from schedulingChipCountMap, computed over
                    the same scoped rows this list is built from, so a
                    chip's number equals the list its click produces. The
                    dot is the tone the rows behind it are ALREADY wearing
                    — read off readinessPillForRow, coloured through the one
                    map the Readiness cell uses. There is no chip palette. ── */}
                {((readinessChips.length > 0 || methodChips.length > 0
                   || allowanceChips.length > 0) || chipsActive) && (
                  <div style={{ display:"flex", gap:14, alignItems:"center",
                                flexWrap:"wrap", marginBottom:12 }}>
                    <div style={{ display:"flex", gap:6, alignItems:"center", flexWrap:"wrap" }}>
                      <span style={{ fontSize:10, fontWeight:700, color:T.muted,
                                     letterSpacing:".04em", textTransform:"uppercase",
                                     marginRight:2 }}>
                        Readiness
                      </span>
                      {readinessChips.map(chip => {
                        const label = readinessChipLabel(chip.key);
                        return (
                          <FilterChip
                            key={chip.key}
                            color={chip.tone ? readinessToneColor(chip.tone) : null}
                            label={label}
                            count={chip.count}
                            active={chip.active}
                            title={chip.count === 0
                              ? "No rows in this view are in this state right now"
                              : `Show only rows reading “${label}”`}
                            onClick={() => toggleChip(CHIP_GROUP_READINESS, chip.key)}
                          />
                        );
                      })}
                    </div>
                    {/* A second, smaller group BESIDE the readiness one, not
                        folded into it: they answer different questions and
                        AND together. The divider is the search bar's own
                        idiom, so the groups read as one control. */}
                    <span style={{ width:1, height:20, background:T.border,
                                   alignSelf:"center" }} />
                    <div style={{ display:"flex", gap:6, alignItems:"center", flexWrap:"wrap" }}>
                      <span style={{ fontSize:10, fontWeight:700, color:T.muted,
                                     letterSpacing:".04em", textTransform:"uppercase",
                                     marginRight:2 }}>
                        Scan method
                      </span>
                      {methodChips.map(chip => {
                        const badge = scanMethodBadge(chip.key);
                        return (
                          <FilterChip
                            key={chip.key}
                            /* The colour the Scan method COLUMN is showing for
                               this tool — the badge's own border, fallback
                               included, never a second mapping. */
                            color={chip.count === 0 ? null
                              : badgeColors(badge.type, badge.weight).border}
                            label={badge.label}
                            count={chip.count}
                            active={chip.active}
                            title={chip.count === 0
                              ? "No rows in this view use this scan method right now"
                              : `Show only ${badge.label} rows`}
                            onClick={() => toggleChip(CHIP_GROUP_METHOD, chip.key)}
                          />
                        );
                      })}
                    </div>
                    {/* The allowance-model group is Scheduling-only and uses
                        the normalized `allowance_model` payload. Blank raw
                        Dataverse values have already been normalized by the
                        backend; missing/invalid API values render as
                        Unavailable instead of being guessed. */}
                    <span style={{ width:1, height:20, background:T.border,
                                   alignSelf:"center" }} />
                    <div style={{ display:"flex", gap:6, alignItems:"center", flexWrap:"wrap" }}>
                      <span style={{ fontSize:10, fontWeight:700, color:T.muted,
                                     letterSpacing:".04em", textTransform:"uppercase",
                                     marginRight:2 }}>
                        Allowance
                      </span>
                      {allowanceChips.map(chip => {
                        const tag = allowanceModelTag(chip.key);
                        const label = allowanceModelChipLabel(chip.key);
                        return (
                          <FilterChip
                            key={chip.key}
                            color={chip.count === 0 ? null : tag.chipColor}
                            label={label}
                            count={chip.count}
                            active={chip.active}
                            title={chip.count === 0
                              ? "No rows in this view use this allowance model right now"
                              : `Show only ${label} allowance rows`}
                            onClick={() => toggleChip(CHIP_GROUP_ALLOWANCE, chip.key)}
                          />
                        );
                      })}
                    </div>
                    {/* ── BOOKING LEDGER (booking-allowance-model §9) ──
                        Separate group, same idiom. Patriot-only: every value
                        behind these chips comes from row.booking, which no
                        customer response carries (§8e).

                        ALWAYS RENDERED, including at count 0 — "nobody is
                        waiting on a review request" is a real answer and a
                        vanishing chip cannot give it. That also makes the
                        loudness safety net honest: a stale request cannot
                        hide behind an absent control.

                        weight="soft" on every amber chip, because heavy
                        amber is absent from the heavy palette and renders
                        BLUE — a colour no row on this tab wears. */}
                    <span style={{ width:1, height:20, background:T.border,
                                   alignSelf:"center" }} />
                    <div style={{ display:"flex", gap:6, alignItems:"center", flexWrap:"wrap" }}>
                      <span style={{ fontSize:10, fontWeight:700, color:T.muted,
                                     letterSpacing:".04em", textTransform:"uppercase",
                                     marginRight:2 }}>
                        Booking
                      </span>
                      {bookingChipRow.map(chip => (
                        <FilterChip
                          key={chip.key}
                          color={chip.count === 0 ? null
                            : badgeColors(chip.tone, chip.weight).border}
                          label={chip.label}
                          count={chip.count}
                          active={bookingChips.includes(chip.key)}
                          title={chip.count === 0
                            ? "No rows in this view are in this state right now"
                            : `Show only rows reading “${chip.label}”`}
                          onClick={() => toggleBookingChip(chip.key)}
                        />
                      ))}
                    </div>
                    {/* One click back to the unfiltered view. Rendered ONLY
                        when something is selected — a permanent Clear on an
                        unfiltered list is a control that does nothing, and
                        this row is already busy. */}
                    {schedulingFiltersActive && (
                      <button
                        onClick={clearChips}
                        style={{
                          padding:"4px 10px", fontSize:11.5, borderRadius:999,
                          fontFamily:"inherit", cursor:"pointer", fontWeight:600,
                          border:`1px solid ${T.border}`,
                          background:"rgba(255,255,255,.04)", color:T.text,
                        }}
                      >
                        Clear filters
                      </button>
                    )}
                  </div>
                )}

                <div style={{ display:"flex", gap:10, alignItems:"center", flexWrap:"wrap", marginBottom:12 }}>
                  <div style={{ position:"relative", flex:"1 1 260px", minWidth:0 }}>
                    <input
                      ref={reviewSearchInputRef}
                      value={reviewSearch}
                      onChange={(e) => setReviewSearch(e.target.value)}
                      placeholder="Filter by customer, tier, status or last reviewer…"
                      style={{
                        width:"100%", boxSizing:"border-box", padding:"7px 34px 7px 10px", fontSize:12,
                        borderRadius:8, fontFamily:"inherit", outline:"none",
                        border:`1px solid ${reviewSearch ? "rgba(68,166,255,.5)" : T.border}`,
                        background:"rgba(255,255,255,.04)", color:T.text,
                      }}
                    />
                    {reviewSearch && (
                      <button
                        type="button"
                        aria-label="Clear search"
                        title="Clear search"
                        onClick={() => {
                          setReviewSearch("");
                          reviewSearchInputRef.current?.focus();
                        }}
                        style={{
                          position:"absolute", right:6, top:"50%", transform:"translateY(-50%)",
                          width:22, height:22, padding:0, border:0, borderRadius:4,
                          background:"transparent", color:T.muted, cursor:"pointer", fontFamily:"inherit",
                          fontSize:18, lineHeight:1,
                        }}
                      >
                        {"\u00d7"}
                      </button>
                    )}
                  </div>
                  {/* One state, both sections: the checkbox filters the
                      backlog AND the grace rows below it — a ready row
                      four days past due is exactly who Amber books.
                      Expect this near-empty while FORCE_REVIEW_ALL
                      holds every Patriot scan; it inverts at flag-flip. */}
                  <label style={{ display:"flex", alignItems:"center", gap:6,
                                  fontSize:12, color:T.text, cursor:"pointer",
                                  whiteSpace:"nowrap" }}>
                    <input
                      type="checkbox"
                      checked={readyOnly}
                      onChange={(e) => setReadyOnly(e.target.checked)}
                    />
                    Ready to book only
                  </label>
                  {/* ALL ONLY. A convenience on the whole-universe view —
                      it widens THIS view to carry On Hold + Pending rows
                      inline, so a reader scanning the fleet does not have
                      to remember a second pill exists. That pill is
                      deliberately untouched: it stays the focused triage
                      list for exactly those statuses, and this is a second
                      way in rather than a replacement. Off by default, so
                      the landing universe is unchanged. */}
                  {schedulingFilter === "all" && (
                    <label style={{ display:"flex", alignItems:"center", gap:6,
                                    fontSize:12, color:T.text, cursor:"pointer",
                                    whiteSpace:"nowrap" }}
                           title="Show On Hold and Pending customers in this list too">
                      <input
                        type="checkbox"
                        checked={includeOnHold}
                        onChange={(e) => setIncludeOnHold(e.target.checked)}
                      />
                      Include On Hold
                    </label>
                  )}
                  {schedulingFilter === "all" && (
                    <label style={{ display:"flex", alignItems:"center", gap:6,
                                    fontSize:12, color:T.text, cursor:"pointer",
                                    whiteSpace:"nowrap" }}
                           title="Show only customers with unresolved action notes">
                      <input
                        type="checkbox"
                        checked={unresolvedNotesOnly}
                        onChange={(e) => setUnresolvedNotesOnly(e.target.checked)}
                      />
                      Unresolved notes only
                    </label>
                  )}
                  {/* Sort applies within each section; Just past due
                      below sorts as its own list. */}
                  <label style={{ display:"flex", alignItems:"center", gap:6,
                                  fontSize:12, color:T.muted, whiteSpace:"nowrap" }}>
                    Sort
                    <select
                      value={rowSort}
                      onChange={(e) => setRowSort(e.target.value)}
                      style={{
                        padding:"5px 8px", fontSize:12, borderRadius:6,
                        fontFamily:"inherit", border:`1px solid ${T.border}`,
                        background:"rgba(0,0,0,0.25)", color:T.text,
                      }}
                    >
                      {rowSortOptions(schedulingBucket || schedulingFilter).map(o => (
                        <option key={o.value} value={o.value}>{o.label}</option>
                      ))}
                    </select>
                  </label>
                  <span style={{ fontSize:12, color:T.muted, whiteSpace:"nowrap" }}>
                    {visibleReviewRows.length} of {schedulingTotal(reviewCustomers, schedulingFilter, schedulingOpts)}
                  </span>
                </div>

                {visibleReviewRows.length === 0 ? (
                  /* Suppressed entirely when the reader has selected the
                     Just past due card — they asked for that section, so
                     an empty-backlog notice above it is noise. */
                  reviewBand !== JUST_PAST_DUE && (
                    schedulingFiltersActive ? (
                      /* THE CHIPS' OWN EMPTY STATE. A blank table under a row
                         of chips reads as "there are no customers", which is
                         the one thing it never means here — the chips are a
                         narrowing of a list that still exists. It names the
                         cause and offers the way out in the same line. */
                      <div style={{ fontSize:13, color:T.muted, padding:"24px 0",
                                    textAlign:"center", display:"flex", gap:10,
                                    alignItems:"center", justifyContent:"center",
                                    flexWrap:"wrap" }}>
                        <span>No rows match these filters.</span>
                        <button
                          onClick={clearChips}
                          style={{
                            padding:"4px 10px", fontSize:12, borderRadius:999,
                            fontFamily:"inherit", cursor:"pointer", fontWeight:600,
                            border:`1px solid ${T.border}`,
                            background:"rgba(255,255,255,.04)", color:T.text,
                          }}
                        >
                          Clear filters
                        </button>
                      </div>
                    ) :
                    <div style={{ fontSize:13, color:T.muted, padding:"24px 0", textAlign:"center" }}>
                      {schedulingTotal(reviewCustomers, schedulingFilter, schedulingOpts) !== 0
                        ? "No customers match that filter."
                        : schedulingFilter === "banked" && visibleSuppressedRows.length > 0
                          ? "Banked rows waiting on scheduled customer meetings are listed below."
                        : schedulingBucket !== "backlog"
                          ? "No customers are coming up in this window."
                          /* Precise when a populated Just past due
                             section sits directly below: a bare "no
                             customers are overdue" would read as
                             contradicting it. */
                          : visibleGraceRows.length > 0
                            ? `No customers are more than ${reviewOps.meta?.backlog_grace_days ?? 10} days overdue.`
                            : "No customers are overdue."}
                    </div>
                  )
                ) : reviewRowTable(visibleReviewRows, {
                    overdueColumn: schedulingBucket === "backlog",
                    // Combined views get the per-row timing column; the
                    // focused ones keep the single-bucket column they had.
                    timingMode: schedulingBucket ? undefined : "mixed",
                    showAllowanceModel: true,
                    bankedOutreach: schedulingFilter === "banked",
                    modelAwareOutreach: schedulingFilter === "all",
                    onOpenCustomer: openSchedulingCustomer,
                  })}

                {/* ── Just past due — past due but inside the grace
                    window, so NOT backlog and carrying no severity.
                    Rendered BELOW a divider with its own header, never
                    interleaved: the backlog sorts longest-overdue-first
                    and dropping 3-day-old rows into that sequence
                    destroys what the order means.

                    Rendered INDEPENDENTLY of whether the backlog above
                    has rows — a section that surfaces previously hidden
                    customers must not itself be hidden behind "No
                    customers are overdue". ── */}
                {schedulingBucket === "backlog" && visibleGraceRows.length > 0 && (
                  <div style={{ marginTop:22 }}>
                    <div style={{
                      borderTop:`1px solid ${T.border}`, paddingTop:14,
                      display:"flex", alignItems:"center", gap:10, flexWrap:"wrap",
                      marginBottom:10,
                    }}>
                      <Badge type="yellow" weight="soft">{JUST_PAST_DUE_LABEL}</Badge>
                      <span style={{ fontSize:12, color:T.muted }}>
                        {visibleGraceRows.length} customer{visibleGraceRows.length === 1 ? "" : "s"} ·
                        {" "}{justPastDueRangeLabel(reviewOps.meta)} past the next-audit date
                      </span>
                    </div>
                    {reviewRowTable(visibleGraceRows, {
                      overdueColumn: true, dayTone: T.yellow,
                      showAllowanceModel: true,
                      onOpenCustomer: openSchedulingCustomer,
                    })}
                  </div>
                )}

                {/* ── Waiting on a customer meeting — rows suppressed by a
                    blocking touchpoint scheduled in the future.

                    A SECTION, NOT A FILTER (spec): a filter you have to
                    think to click recreates the invisibility this feature
                    exists to remove. Management sees the split on one screen
                    and no number is lying.

                    Rendered INDEPENDENTLY of whether the table above has
                    rows, exactly like Just past due — the whole point is
                    that these customers stop being hidden, so the section
                    must not itself hide behind "No customers are overdue".

                    Every row here keeps its true age and severity: the
                    tables are identical, only the population differs. ── */}
                {visibleSuppressedRows.length > 0 && (
                  <div style={{ marginTop:22 }}>
                    <div style={{
                      borderTop:`1px solid ${T.border}`, paddingTop:14,
                      display:"flex", alignItems:"center", gap:10, flexWrap:"wrap",
                      marginBottom:10,
                    }}>
                      <Badge type="slate" weight="soft">Waiting on a customer meeting</Badge>
                      <span style={{ fontSize:12, color:T.muted }}>
                        {visibleSuppressedRows.length} customer{visibleSuppressedRows.length === 1 ? "" : "s"} ·
                        {" "}{schedulingFilter === "banked"
                          ? "waiting on the scheduled customer meeting before outreach follow-up"
                          : "still overdue, and not chaseable until the meeting happens"}
                      </span>
                    </div>
                    {reviewRowTable(visibleSuppressedRows, {
                      overdueColumn: schedulingBucket === "backlog",
                      timingMode: schedulingBucket ? undefined : "mixed",
                      showAllowanceModel: true,
                      bankedOutreach: schedulingFilter === "banked",
                      modelAwareOutreach: schedulingFilter === "all",
                      onOpenCustomer: openSchedulingCustomer,
                    })}
                  </div>
                )}
              </>
            )}

            {/* ── Scan Queue — every customer waiting on the delivery
                engineers, now in THREE FILTER PILLS named by the state:
                Prereq issues / In progress / Held for review.

                A SECTION PER STATUS, NOT A FILTER — REVERSED 2026-08-19
                (prereq-auto-scan PR 2, James's ruling), the way #590 reversed
                the "WHY ALL INCLUDES GRACE" note: recorded, not deleted. The
                ORIGINAL rationale, kept verbatim because it is still true
                about stacked sections: "The two are different jobs — chase an
                access problem, or run a scan — and they belong to the same
                person on the same morning. A filter would make each half
                invisible while the other is open, which is the shape this
                queue exists to remove." What changed: Held for Review moved
                OUT of Publishing into this queue (F2), making three lists on
                one surface, and three stacked sections is a scroll, not a
                glance. THE MITIGATION that answers the original objection —
                all three counts ride the pills at ALL times, so nothing is
                invisible as a QUANTITY, only as a list, and one click opens
                any of them.

                MIXED TIMING ALWAYS on the two fleet-row pills: a row may be
                overdue, approaching, future or unscheduled, so it takes the
                same branch the All view takes.

                NO CHIP ON THESE ROWS (withEngineersChip: false). Every fleet
                row here is with the engineers by definition; a chip on all of
                them is decoration.

                COUNTS AND TAB BADGE BY CONSTRUCTION: scanQueueBuckets is
                called ONCE; each pill's badge is its own list's length, and
                the tab badge (scanQueueBadgeTotal) is the three summed — no
                count is a second derivation of the same quantity (#532/#557),
                and switching pills changes which list renders, never a count.

                NO PILL WEARS A COLOUR NO ROW WEARS: Prereq issues = amber and
                In progress = blue are the tones WORKFLOW_TONES already gives
                125470003 and 125470015 in the row's own status control; Held
                for review = yellow is the tone the held-scan pills already
                wear on the (departed) Publishing queue. weight="soft"
                everywhere, as the old section badges were. ── */}
            {reviewView === "scanqueue" && (() => {
              // ONE derivation of the universe, before any pill is chosen.
              const buckets = scanQueueBuckets(reviewCustomers, queue || []);
              const PILLS = [
                { value:"prereq",     label:"Prereq issues",   tone:"amber",
                  rows:buckets.prereqIssues,
                  empty:"No access issues waiting" },
                { value:"inprogress", label:"In progress",     tone:"blue",
                  rows:buckets.inProgress,
                  // An empty queue is GOOD NEWS and has to read that way.
                  empty:"No scans running" },
                { value:"held",       label:"Held for review", tone:"yellow",
                  rows:buckets.heldForReview,
                  empty:"No dashboards awaiting review" },
              ];
              const active = PILLS.find(p => p.value === scanQueuePill) || PILLS[0];
              return (
              <>
                <div style={{ fontSize:12, color:T.muted, marginBottom:14, lineHeight:1.6 }}>
                  Customers whose next step belongs to the delivery team, plus
                  the scans held for a Patriot to publish. A fleet row leaves
                  the first two pills the moment its workflow status changes —
                  nothing there is stored separately.
                </div>
                <div style={{ marginBottom:14 }}>
                  <PillToggle
                    options={PILLS.map(p => ({
                      value:p.value, label:p.label,
                      // Pill count = the length of the list this pill opens.
                      // Falsy → PillToggle omits it, so an empty pill carries
                      // no decoration (absent, not "0").
                      badge:p.rows.length || undefined,
                    }))}
                    value={active.value}
                    onChange={setScanQueuePill}
                  />
                </div>
                {/* The tone lives on the heading badge (matching the rows),
                    LABEL ONLY — the count is on the pill above, so this is not
                    a second count of the same quantity (#532). */}
                <div style={{ display:"flex", alignItems:"center", gap:10,
                              flexWrap:"wrap", marginBottom:10 }}>
                  <Badge type={active.tone} weight="soft">{active.label}</Badge>
                </div>

                {active.value === "held" ? (
                  /* Held for Review — MOVED here from Publishing (F2). Same
                     one-row-per-held-scan table, same per-row Publish/Reject
                     acting on its OWN pending_id, same ADR-0088 D-c aging
                     notice travelling with it. No new fetch — `queue` is the
                     /review-queue list already in scope (V19), and its own
                     load/error state (the same one the Publishing tab used)
                     travels with it. */
                  loading ? (
                    <div style={{ fontSize:13, color:T.muted, padding:"12px 0" }}>Loading…</div>
                  ) : error ? (
                    <div style={{ fontSize:13, color:T.red, padding:"12px 0" }}>Couldn’t load the review queue. Please try again.</div>
                  ) : active.rows.length === 0 ? (
                    <div style={{ fontSize:13, color:T.muted, padding:"24px 0", textAlign:"center" }}>
                      {active.empty}
                    </div>
                  ) : (
                    <>
                      <QueueAgingNotice queue={active.rows} />
                      <TableScroll>
                      <table style={{ width:"100%", borderCollapse:"collapse" }}>
                        <thead><tr>
                          <th style={thStyle}>Client</th>
                          <th style={{ ...thStyle, width:160 }}>Scan date</th>
                          <th style={thStyle}>Hold reasons</th>
                          <th style={{ ...thStyle, width:280, textAlign:"right" }}></th>
                        </tr></thead>
                        <tbody>
                          {active.rows.map((p) => {
                            const name = clientsById[p.slug] || p.slug;
                            const when = fmtDate(p.executed_at || p.scored_at);
                            const reasons = Array.isArray(p.hold_reasons)
                              ? p.hold_reasons
                              : (p.hold_reasons ? [p.hold_reasons] : []);
                            return (
                              // KEY IS SLUG + PENDING ID (ADR-0088), as on the
                              // former Publishing table — the slug alone
                              // collides once a customer can hold N scans.
                              <tr key={`${p.slug}:${p.pending_id || "latest"}`}>
                                <td style={{ ...tdStyle, fontWeight:600, color:T.text }}>{name}</td>
                                <td style={{ ...tdStyle, color:T.muted }}>{when}</td>
                                <td style={tdStyle}>
                                  {reasons.length === 0 ? (
                                    <span style={{ color:T.muted }}>—</span>
                                  ) : (
                                    <div style={{ display:"flex", gap:6, flexWrap:"wrap" }}>
                                      {reasons.map((r, i) => (
                                        <span key={i} style={{
                                          fontSize:11, padding:"2px 8px", borderRadius:999,
                                          background:"rgba(243,181,63,.12)", border:`1px solid rgba(243,181,63,.35)`,
                                          color:T.yellow, whiteSpace:"nowrap",
                                        }}>{r}</span>
                                      ))}
                                    </div>
                                  )}
                                </td>
                                <td style={{ ...tdStyle, textAlign:"right" }}>
                                  <QueueRowActions
                                    row={p}
                                    clientUrl={clientUrl}
                                    onResolved={() => setQueueRefreshKey(k => k + 1)}
                                  />
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                      </TableScroll>
                    </>
                  )
                ) : (
                  /* Prereq issues / In progress — the fleet-row lists. */
                  active.rows.length === 0 ? (
                    <div style={{ fontSize:13, color:T.muted, padding:"18px 0" }}>
                      {active.empty}
                    </div>
                  ) : reviewRowTable(active.rows, {
                    timingMode: "mixed", withEngineersChip: false,
                    // The age, without the "with engineers" prefix that is
                    // true of every row here. Rows arrive oldest-first.
                    waitingAge: true,
                    // In progress ONLY: a row whose auto-run was REFUSED shows
                    // why, from the fleet payload's auto_scan fact (§5d/§7c).
                    // Off on Prereq issues — that list carries no auto_scan.
                    autoScanReason: active.value === "inprogress",
                  })
                )}
              </>
              );
            })()}

            {/* ── Customer-requested skip. Two steps, always: who asked,
                then a confirm stating the COST and the caution.

                The confirm shows NO next-audit date — computing one
                client-side would duplicate review_cycle.py's
                distribution arithmetic and the two would drift. The
                confirm states the cost; the result screen below shows
                the date the server actually produced. ── */}
            <Modal
              show={!!skipTarget}
              title={skipResult
                ? "Skip recorded"
                : `Record a skip — ${skipTarget?.customer_name || skipTarget?.slug || ""}`}
              onClose={closeSkip}
              submitLabel={skipResult ? "Done"
                : (skipBusy ? "Recording…" : "Record skip")}
              submitDisabled={!skipResult && (
                skipBusy || !skipContext
                || !!skipPendingError || !!skipSubmitBlocked({
                  selection: skipSelection, otherText: skipOtherText,
                  options: skipRequesterOptions(skipAccess),
                  // An unresolved original operation can only be retried with
                  // its saved identity and facts. The API rejects any changed
                  // request before sending it; the server checks the receipt
                  // before considering a new allowance-consuming write.
                  context: skipPendingDate && skipContext?.cycle?.mode === "contract_state"
                    && skipContext.writes_enabled === true
                    ? { ...skipContext, scheduled_locked: false } : skipContext,
                })
              )}
              onSubmit={skipResult ? closeSkip : submitSkip}
            >
              {skipTarget && (() => {
                if (skipResult) {
                  const cycle = skipResult.new_cycle;
                  return (
                    <div style={{ lineHeight:1.7 }}>
                      <div>The skip is recorded against {skipTarget.customer_name}.</div>
                      {/* The server's date, not a local computation. */}
                      {cycle ? (
                        <div style={{ marginTop:10, color:T.text }}>
                          Next audit date is now <strong>{fmtDateOnly(cycle.next_audit_date)}</strong>,
                          at Y{cycle.contract_year} R{cycle.review_number}.
                        </div>
                      ) : (
                        <div style={{ marginTop:10, color:T.muted }}>
                          No cycle position changed — this customer is not on a
                          tracked review cycle.
                        </div>
                      )}
                      {cycleWarnings(skipResult).map((w, i) => (
                        <div key={w.kind || i} style={{ marginTop:10, color:T.yellow }}>
                          {w.message}
                        </div>
                      ))}
                      {skipResult.tracking_updated === false && (
                        <div style={{ marginTop:10, color:T.red }}>
                          The completion was recorded but the tracking row was not
                          updated — fix it in CRM. {skipResult.tracking_error}
                        </div>
                      )}
                    </div>
                  );
                }
                if (skipError && !skipContext) {
                  return <div style={{ color:T.red }}>{skipError}</div>;
                }
                if (!skipContext) return <div>Loading…</div>;

                const options = skipRequesterOptions(skipAccess);
                const copy = skipCostCopy(skipContext);
                const blocked = skipSubmitBlocked({
                  selection: skipSelection, otherText: skipOtherText,
                  options, context: skipPendingDate
                    && skipContext?.cycle?.mode === "contract_state"
                    && skipContext.writes_enabled === true
                    ? { ...skipContext, scheduled_locked: false } : skipContext,
                });
                const overLong = skipOtherText.length > SKIP_REQUESTED_BY_MAX;
                return (
                  <div style={{ lineHeight:1.7 }}>
                    {skipPendingDate && (
                      <div style={{ marginBottom:12, color:T.yellow }}>
                        A review result from {skipPendingDate} is unresolved. Re-enter
                        the original requester to retry that skip, or ask staff to reconcile it.
                      </div>
                    )}
                    {skipPendingError && (
                      <div style={{ marginBottom:12, color:T.red }}>{skipPendingError}</div>
                    )}
                    {/* A skip consumes allowance exactly as a delivered
                        review does, so a full year blocks it for the
                        same reason the Review Complete dialog locks
                        Scheduled. */}
                    {skipContext.scheduled_locked && (
                      <div style={{
                        marginBottom:12, padding:"10px 12px", borderRadius:8,
                        border:`1px solid rgba(243,181,63,.35)`,
                        background:"rgba(243,181,63,.10)", color:T.yellow,
                      }}>
                        {yearFullReason(skipContext, fmtDateOnly)} {skipPendingDate
                          && skipContext?.cycle?.mode === "contract_state"
                          && skipContext.writes_enabled === true
                          ? "Only the unresolved original request can be retried; a new skip remains blocked."
                          : "A skip cannot be recorded against a year with nothing left."}
                      </div>
                    )}

                    <div style={{ fontWeight:600, color:T.text, marginBottom:6 }}>
                      Who requested this skip?
                    </div>
                    <select
                      value={skipSelection}
                      onChange={(e) => setSkipSelection(e.target.value)}
                      disabled={skipBusy}
                      style={{
                        width:"100%", padding:"7px 9px", fontSize:13, borderRadius:8,
                        fontFamily:"inherit", border:`1px solid ${T.border}`,
                        background:"rgba(0,0,0,0.25)", color:T.text,
                      }}
                    >
                      <option value="">Select a contact…</option>
                      {options.map(o => (
                        <option key={o.id} value={o.id}>{o.label}</option>
                      ))}
                      {/* The person who emails is often not a portal user. */}
                      <option value={SKIP_OTHER}>Other…</option>
                    </select>
                    {skipSelection === SKIP_OTHER && (
                      <div style={{ marginTop:8 }}>
                        <input
                          value={skipOtherText}
                          autoFocus
                          maxLength={SKIP_REQUESTED_BY_MAX}
                          onChange={(e) => setSkipOtherText(e.target.value)}
                          placeholder="Name, and how they asked"
                          style={{
                            width:"100%", padding:"7px 9px", fontSize:13, borderRadius:8,
                            fontFamily:"inherit", outline:"none",
                            border:`1px solid ${overLong ? T.red : T.border}`,
                            background:"rgba(255,255,255,.04)", color:T.text,
                          }}
                        />
                        <div style={{
                          fontSize:11, marginTop:4,
                          color: overLong ? T.red : T.muted, textAlign:"right",
                        }}>
                          {skipOtherText.length}/{SKIP_REQUESTED_BY_MAX}
                        </div>
                      </div>
                    )}

                    {/* Branches on the SERVER's cycle field — the same
                        signal the write branches on. A null-cycle
                        customer is never told a cost that is not being
                        charged. */}
                    {copy && (
                      <div style={{
                        marginTop:14, padding:"10px 12px", borderRadius:8,
                        border:`1px solid ${T.border}`,
                        background:"rgba(255,255,255,.03)",
                        color: copy.onCycle ? T.text : T.muted,
                      }}>
                        {copy.cost}
                      </div>
                    )}

                    {/* Present in BOTH branches — this is about the
                        customer relationship, not the accounting. */}
                    <div style={{ marginTop:12, color:T.yellow }}>{SKIP_CAUTION}</div>

                    {blocked === "no_requester" && (
                      <div style={{ marginTop:10, fontSize:12, color:T.muted }}>
                        Choose who asked before recording the skip.
                      </div>
                    )}
                    {blocked === "requester_too_long" && (
                      <div style={{ marginTop:10, fontSize:12, color:T.red }}>
                        Keep the requester under {SKIP_REQUESTED_BY_MAX} characters.
                      </div>
                    )}
                    {skipError && (
                      <div style={{ marginTop:10, color:T.red }}>{skipError}</div>
                    )}
                  </div>
                );
              })()}
            </Modal>

            {/* ── Status-change confirm. Appears whenever a date MOVES,
                and never when one does not — a confirm on a harmless
                change trains her to click through the two that matter.
                When a future appointment is being replaced it names the
                specific date being destroyed: it exists nowhere else
                once overwritten, and a generic are-you-sure would not
                tell her what she is about to lose. ── */}
            <Modal
              show={!!statusConfirm}
              title={statusConfirm ? `${statusConfirm.label} — ${statusConfirm.customerName}` : ""}
              onClose={() => { setStatusConfirm(null); setStatusEdit(null); }}
              submitLabel={statusBusySlug ? "Saving…" : "Set status"}
              submitDisabled={!!statusBusySlug}
              onSubmit={() => statusConfirm && commitStatus({
                slug: statusConfirm.slug,
                statusValue: statusConfirm.statusValue,
                date: statusConfirm.date,
              })}
            >
              {statusConfirm && (() => {
                // Re-preview against the date currently in the field, so
                // editing it updates every consequence line live.
                const live = statusChangePreview({
                  meta: reviewOps?.meta, row: statusConfirm.row,
                  statusValue: statusConfirm.statusValue,
                  suppliedDate: statusConfirm.date,
                  today: localDateString(),
                }) || statusConfirm;
                const editable = statusConfirm.date !== undefined
                  && live.rule === "default_today";
                return (
                <div style={{ lineHeight:1.7 }}>
                  {/* WHICH DATE IS MOVING. A blocking status records its own
                      date and leaves pc_nextauditdate alone, so the copy must
                      not claim the audit was rescheduled — that was the
                      second half of the 2026-08-11 bug, and it would have
                      told the recorder the opposite of the truth. The row
                      keeps its age and its severity, and the confirm says
                      so. */}
                  {live.movesNextAuditDate === false ? (
                    <>
                      <div>
                        This records the access meeting date as{" "}
                        <strong style={{ color:T.text }}>{fmtDateOnly(live.newDate)}</strong>.
                      </div>
                      <div style={{ marginTop:10, color:T.muted }}>
                        The next audit date is <strong style={{ color:T.text }}>unchanged</strong>
                        {live.nextAuditDate
                          ? <> — still {fmtDateOnly(live.nextAuditDate)}</>
                          : null}
                        {Number.isInteger(live.daysOverdue) && live.daysOverdue > 0
                          ? <>, so this customer stays {live.daysOverdue} days overdue.</>
                          : "."}
                        {" "}They drop out of the actionable backlog count until the
                        meeting date passes, and reappear at their true age afterwards.
                      </div>
                    </>
                  ) : (
                  <div>
                    This sets the next audit date to{" "}
                    <strong style={{ color:T.text }}>{fmtDateOnly(live.newDate)}</strong>
                    {live.newDate === localDateString() ? " (today)." : "."}
                  </div>
                  )}

                  {/* Optional override. Revealed, never required —
                      prefilled with today, so clicking straight through
                      is exactly the old behaviour. Capped at today: a
                      booking link cannot have been sent tomorrow (the
                      server refuses it too). */}
                  {editable && (
                    <div style={{ marginTop:10, display:"flex", gap:8, alignItems:"center", flexWrap:"wrap" }}>
                      <label style={{ fontSize:12, color:T.muted }}>Sent on</label>
                      <input
                        type="date"
                        value={statusConfirm.date || ""}
                        max={localDateString()}
                        onChange={(e) => setStatusConfirm(c => ({ ...c, date:e.target.value }))}
                        style={{ padding:"5px 9px", fontSize:12, borderRadius:6,
                                 border:`1px solid ${T.border}`, background:"rgba(0,0,0,0.25)",
                                 color:T.text, colorScheme:"dark" }}
                      />
                      {live.isBackdated && (
                        <span style={{ fontSize:11, color:T.muted }}>
                          {live.daysBack} day{live.daysBack === 1 ? "" : "s"} ago
                        </span>
                      )}
                    </div>
                  )}

                  {/* Shown on EVERY Booking Sent press, not only the
                      backdated one — learning the rule on the routine
                      press is what stops it surprising anyone later. */}
                  {followUpWindowCopy(live, fmtDateOnly) && (
                    <div style={{ marginTop:10, color:T.muted }}>
                      {followUpWindowCopy(live, fmtDateOnly)}
                    </div>
                  )}

                  {/* A DIFFERENT fact from the lost-date warning below,
                      and the two can co-occur — kept as separate blocks
                      rather than merged. Not styled as an error: moving
                      into Backlog is the correct outcome here. */}
                  {live.entersBacklog && (
                    <div style={{
                      marginTop:10, padding:"10px 12px", borderRadius:8,
                      border:`1px solid ${T.border}`,
                      background:"rgba(255,255,255,.03)", color:T.text,
                    }}>
                      That is more than {live.graceDays} days ago, so this customer
                      moves into <strong>Backlog</strong> straight away.
                    </div>
                  )}

                  {live.lostDate ? (
                    <div style={{
                      marginTop:12, padding:"10px 12px", borderRadius:8,
                      border:`1px solid rgba(243,181,63,.35)`,
                      background:"rgba(243,181,63,.10)", color:T.yellow,
                    }}>
                      This replaces <strong>{fmtDateOnly(live.lostDate)}</strong> — that
                      appointment date will be lost. It is not recorded anywhere else.
                    </div>
                  ) : live.currentDate && (
                    <div style={{ marginTop:8, color:T.muted }}>
                      Currently {fmtDateOnly(live.currentDate)}.
                    </div>
                  )}
                  {statusError && (
                    <div style={{ marginTop:10, color:T.red }}>{statusError.message}</div>
                  )}
                </div>
                );
              })()}
            </Modal>

            {/* ── By engineer / Volume — both scoped by the same range ── */}
            {reviewView === "recorded" && (
              <>
                <div style={{ display:"flex", gap:8, alignItems:"center", flexWrap:"wrap", marginBottom:14 }}>
                  <label style={{ fontSize:12, color:T.muted }}>From</label>
                  <input
                    type="date" value={reviewStart}
                    onChange={(e) => setReviewStart(e.target.value)}
                    style={{ padding:"5px 9px", fontSize:12, borderRadius:6, border:`1px solid ${T.border}`, background:"rgba(0,0,0,0.25)", color:T.text, colorScheme:"dark" }}
                  />
                  <label style={{ fontSize:12, color:T.muted }}>to</label>
                  <input
                    type="date" value={reviewEnd}
                    onChange={(e) => setReviewEnd(e.target.value)}
                    style={{ padding:"5px 9px", fontSize:12, borderRadius:6, border:`1px solid ${T.border}`, background:"rgba(0,0,0,0.25)", color:T.text, colorScheme:"dark" }}
                  />
                  <button
                    onClick={() => setReviewRangeNonce(n => n + 1)}
                    disabled={reviewOpsLoading || !reviewStart || !reviewEnd || reviewStart > reviewEnd}
                    style={{
                      padding:"7px 14px", fontSize:13, borderRadius:8, cursor:"pointer",
                      border:`1px solid ${T.border}`, background:"rgba(255,255,255,.04)", color:T.text,
                    }}
                  >
                    {reviewOpsLoading ? "Loading…" : "Apply"}
                  </button>
                  {reviewStart && reviewEnd && reviewStart > reviewEnd && (
                    <span style={{ fontSize:12, color:T.red }}>Start must be on or before end.</span>
                  )}
                </div>

                {(() => {
                  const engineers = reviewOps.by_engineer || [];
                  const volume = reviewOps.volume || {};
                  // The UNFILTERED count — a filter that matches nothing is
                  // "no rows match", never "nothing was recorded in this
                  // range". The three empty states stay about the DATA.
                  const rowCount = (reviewOps.completions || []).length;
                  const state = rangeEmptyState({
                    anyCompletionsRecorded: !!reviewOps.meta?.any_completions_recorded,
                    rowCount,
                  });

                  /* Three DISTINCT empty states. A bare 0 here would read as
                     "the team delivered nothing", which on day one is not what
                     it means — no reviews have been RECORDED yet. */
                  if (state === "dayOne") {
                    return (
                      <div style={{ fontSize:13, color:T.muted, padding:"24px 16px", textAlign:"center", lineHeight:1.7 }}>
                        No reviews have been recorded through the portal yet.<br />
                        This fills in as engineers record them with the Review Complete
                        button — it is not a count of zero delivered reviews.
                      </div>
                    );
                  }
                  if (state === "emptyRange") {
                    return (
                      <div style={{ fontSize:13, color:T.muted, padding:"24px 16px", textAlign:"center" }}>
                        No reviews recorded between {fmtDateOnly(reviewOps.range?.start)} and {fmtDateOnly(reviewOps.range?.end)}.
                      </div>
                    );
                  }

                  if (reviewView === "recorded") {
                    /* The reviews THEMSELVES, newest first. The per-engineer
                       counts are the summary line above, not the view — a
                       three-row count table says nothing about which
                       customers, when, or what kind. */
                    const cards = engineerCards(engineers);
                    return (
                      <>
                        {/* Only reviewers with completed work in this range
                            get cards. Clicking a card filters the list below:
                            the cards ARE the filter control, not a second
                            display. */}
                        {cards.length > 0 && (
                          <div style={{ display:"flex", gap:10, flexWrap:"wrap", marginBottom:14 }}>
                            {cards.map((c) => {
                              const on = reviewReviewer === c.name;
                              return (
                                <button
                                  key={c.id || c.name}
                                  onClick={() => setReviewReviewer(on ? "" : c.name)}
                                  aria-pressed={on}
                                  title={on ? "Show all reviewers" : `Show only ${c.name}`}
                                  style={{
                                    flex:"1 1 150px", minWidth:140, textAlign:"left", cursor:"pointer",
                                    padding:"12px 14px", borderRadius:10, fontFamily:"inherit",
                                    border:`1px solid ${on ? "rgba(68,166,255,.6)" : T.border}`,
                                    background: on ? "rgba(68,166,255,.10)" : "rgba(255,255,255,.04)",
                                  }}
                                >
                                  <div style={{
                                    fontSize:12, fontWeight:600, marginBottom:6,
                                    color: on ? T.blue : T.muted,
                                    overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap",
                                  }}>
                                    {c.name}
                                  </div>
                                  <div style={{ display:"flex", alignItems:"baseline", gap:8 }}>
                                    <span style={{ fontSize:24, fontWeight:700, color:T.text, lineHeight:1 }}>
                                      {c.delivered}
                                    </span>
                                    <span style={{ fontSize:11, color:T.muted }}>delivered</span>
                                  </div>
                                  {/* No-shows are the smaller secondary
                                      figure — delivered effort AND a
                                      service gap; one number hides both. */}
                                  <div style={{ fontSize:11, marginTop:5, color: c.noShows ? T.yellow : T.muted }}>
                                    {c.noShows} no-show{c.noShows === 1 ? "" : "s"}
                                  </div>
                                  {/* Skips beside `delivered`, never
                                      inside it, and shown only when
                                      non-zero. Server-side exclusion —
                                      the Include-skips checkbox cannot
                                      change this number. */}
                                  {c.skips > 0 && (
                                    <div style={{ fontSize:11, marginTop:3, color:T.muted }}>
                                      {c.skips} skip{c.skips === 1 ? "" : "s"} recorded
                                    </div>
                                  )}
                                </button>
                              );
                            })}
                          </div>
                        )}

                        {/* Type breakdown — WITH the cards, not above the
                            list, because it shares their scope: both
                            describe the whole selected RANGE, while the
                            list below is filter-scoped. Grouping it here
                            answers "why does this say Skipped 1 when no
                            skip row is showing?" before anyone asks, and
                            needs no caption to do it.

                            An inline strip rather than a table: four or
                            five numbers, mostly zeros, and a table gives
                            them more weight than they earn. Derived from
                            the payload's own keys — no local type list
                            left to fall out of step (see typeBreakdown). */}
                        <div style={{
                          display:"flex", gap:14, flexWrap:"wrap", alignItems:"baseline",
                          padding:"8px 12px", marginBottom:12, borderRadius:8,
                          border:`1px solid ${T.border}`, background:"rgba(255,255,255,.02)",
                          fontSize:12,
                        }}>
                          {typeBreakdown(volume.by_type).map(t => (
                            <span key={t.key} style={{ whiteSpace:"nowrap" }}>
                              <span style={{ color: t.count ? T.text : T.muted }}>{t.label}</span>
                              {" "}
                              <strong style={{
                                color: t.count
                                  ? (t.key === "no-show" ? T.yellow : T.text)
                                  : T.muted,
                              }}>{t.count}</strong>
                            </span>
                          ))}
                          {/* Sums to this number, always — the strip is
                              range-scoped and skips are included. */}
                          <span style={{ marginLeft:"auto", color:T.muted, whiteSpace:"nowrap" }}>
                            {volume.total_rows ?? 0} recorded in range
                          </span>
                        </div>

                        <div style={{ display:"flex", gap:10, alignItems:"center", flexWrap:"wrap", marginBottom:12 }}>
                          {reviewReviewer && (
                            <button
                              onClick={() => setReviewReviewer("")}
                              style={{
                                padding:"6px 12px", fontSize:12, borderRadius:8, cursor:"pointer",
                                fontFamily:"inherit", border:`1px solid rgba(68,166,255,.5)`,
                                background:"rgba(68,166,255,.10)", color:T.blue, whiteSpace:"nowrap",
                              }}
                            >
                              {reviewReviewer} ✕
                            </button>
                          )}
                          <input
                            value={reviewListSearch}
                            onChange={(e) => setReviewListSearch(e.target.value)}
                            placeholder="Filter by customer, reviewer, type or notes…"
                            style={{
                              flex:"1 1 240px", minWidth:0, padding:"7px 10px", fontSize:12,
                              borderRadius:8, fontFamily:"inherit", outline:"none",
                              border:`1px solid ${reviewListSearch ? "rgba(68,166,255,.5)" : T.border}`,
                              background:"rgba(255,255,255,.04)", color:T.text,
                            }}
                          />
                          {/* Governs this LIST only. The cards above
                              exclude skips server-side, absolutely. */}
                          <label style={{ display:"flex", alignItems:"center", gap:6, fontSize:12, color:T.muted, whiteSpace:"nowrap" }}>
                            <input
                              type="checkbox"
                              checked={includeSkips}
                              onChange={(e) => setIncludeSkips(e.target.checked)}
                            />
                            Include skips
                          </label>
                          {/* HOW MUCH IS LEFT, so she knows she is done
                              without scanning the list. Counted over the rows
                              ACTUALLY SHOWN, so it agrees with the screen
                              under a reviewer filter or a search — one
                              quantity, one number (#532).

                              SILENT AT ZERO: absence IS the finished state,
                              and "0 awaiting survey" is a line to read on
                              every future visit for no information. */}
                          {awaitingSurveyCount(visibleCompletions) > 0 && (
                            <span style={{ fontSize:12, color:T.text, fontWeight:600, whiteSpace:"nowrap" }}>
                              {awaitingSurveyCount(visibleCompletions)} awaiting survey
                            </span>
                          )}
                          <span style={{ fontSize:12, color:T.muted, whiteSpace:"nowrap" }}>
                            {visibleCompletions.length} of {rowCount}
                          </span>
                        </div>

                        {visibleCompletions.length === 0 ? (
                          <div style={{ fontSize:13, color:T.muted, padding:"24px 0", textAlign:"center" }}>
                            No reviews match that filter.
                          </div>
                        ) : (
                          <TableScroll>
                          <table style={{ width:"100%", borderCollapse:"collapse" }}>
                            <thead><tr>
                              {[
                                { key:"review_date",   label:"Review date", width:130 },
                                { key:"customer_name", label:"Customer" },
                                /* WHICH POSITION THIS REVIEW CONSUMED
                                   (2026-08-12 team call). contract_year and
                                   review_number already ride every completion
                                   row, so this is display only — no backend
                                   change. After Customer because it is a fact
                                   ABOUT that customer's contract, and the eye
                                   reads name-then-position.

                                   Y#R#, NEVER Y#Q# (operator ruling,
                                   Katelyn): quarters drift when reviews slip,
                                   so the review number is the honest counter.
                                   cycleLabel is the one statement of that
                                   format and of the on_cycle rule.

                                   Sortable like its neighbours — a reader
                                   scanning "who is on R4" wants them
                                   together — and it sorts on the DISPLAYED
                                   text, so off-cycle rows group instead of
                                   scattering. */
                                { key:"cycle",         label:"Cycle",       width:90 },
                                { key:"reviewer_name", label:"Reviewer",    width:200 },
                                { key:"review_type",   label:"Type",        width:130 },
                              ].map(col => (
                                <th
                                  key={col.key}
                                  onClick={() => handleReviewSort(col.key)}
                                  style={{ ...thStyle, width:col.width, cursor:"pointer", userSelect:"none" }}
                                  title="Sort by this column"
                                >
                                  {col.label}
                                  {reviewSort?.key === col.key
                                    ? (reviewSort.dir === "asc" ? " ▲" : " ▼")
                                    : ""}
                                </th>
                              ))}
                              <th style={{ ...thStyle, width:260 }}>Notes</th>
                              {/* Not sortable, deliberately: the survey state
                                  already drives the row ORDER (unsent first),
                                  so a sort on it would fight the ordering the
                                  operator asked for. */}
                              <th style={{ ...thStyle, width:190 }}>Survey</th>
                            </tr></thead>
                            <tbody>
                              {visibleCompletions.map((c, i) => {
                                const sent = isSurveySent(c);
                                const note = typeof c.note === "string"
                                  ? c.note.trim() : "";
                                // A no-show has no session to survey (and a
                                // skip has no meeting) — reviewOps.
                                // NO_SURVEY_REVIEW_TYPES is the one list, read
                                // by the count, the sort and this cell.
                                const noSurvey = !takesSurvey(c);
                                // MUTED, NEVER HIDDEN, and now muted for
                                // EITHER reason it is handled (2026-08-11):
                                // the survey went out, or none is owed. A
                                // handled row stays fully readable —
                                // team-performance reading is a stated
                                // requirement, and a no-show is delivered
                                // effort from the engineer's side — it simply
                                // stops competing for attention. Opacity on
                                // the row rather than a per-cell colour, so
                                // every column recedes together and no new
                                // colour value enters.
                                const rowStyle = needsSurveyAction(c)
                                  ? undefined : { opacity:0.55 };
                                return (
                                <tr key={c.id || `${c.review_date}-${i}`} style={rowStyle}>
                                  <td style={{ ...tdStyle, color:T.muted, whiteSpace:"nowrap" }}>{fmtDateOnly(c.review_date)}</td>
                                  <td style={{ ...tdStyle, fontWeight:600, color:T.text }}>{c.customer_name || "Unknown customer"}</td>
                                  {/* THE SAME cycleLabel the Scheduling rows
                                      use: both position fields or nothing,
                                      because half a position is not a
                                      position (review_cycle.on_cycle). A skip
                                      or an off-cycle review may carry none,
                                      and the cell says so rather than
                                      inventing a Y or an R. */}
                                  <td style={{ ...tdStyle, whiteSpace:"nowrap",
                                               color: cycleLabel(c) ? T.text : T.muted }}>
                                    {cycleLabel(c) || "—"}
                                  </td>
                                  <td style={{ ...tdStyle, color: c.reviewer_name ? T.text : T.muted }}>{c.reviewer_name || "Unknown reviewer"}</td>
                                  <td style={{
                                    ...tdStyle,
                                    color: c.review_type_key === "no-show" ? T.yellow
                                      : c.review_type_key === "skipped" ? T.blue : T.muted,
                                  }}>
                                    {/* Visibly distinct, never merged
                                        into the delivered count. */}
                                    {/* "Scheduled" READS "Completed"
                                        (2026-08-12): on a list of finished
                                        work the Dataverse label reads as
                                        future tense — Amber thought the rows
                                        were still on the calendar. Display
                                        only; the stored value is untouched. */}
                                    {c.review_type_key === "skipped"
                                      ? <Badge type="slate" weight="soft">{completionTypeLabel(c) || "Skipped"}</Badge>
                                      : (completionTypeLabel(c) || "—")}
                                  </td>
                                  <td style={{
                                    ...tdStyle, width:260, maxWidth:320,
                                    color: note ? T.text : T.muted,
                                    whiteSpace:"normal", verticalAlign:"top",
                                    overflowWrap:"anywhere",
                                  }}>
                                    {note ? (
                                      <div
                                        title={note}
                                        style={{
                                          lineHeight:1.45, overflow:"hidden",
                                          display:"-webkit-box", WebkitLineClamp:3,
                                          WebkitBoxOrient:"vertical",
                                        }}
                                      >
                                        {note}
                                      </div>
                                    ) : "—"}
                                  </td>
                                  <td style={{ ...tdStyle, whiteSpace:"nowrap" }}>
                                    {sent ? (
                                      <span style={{ display:"inline-flex", alignItems:"center", gap:6 }}>
                                        <span style={{ fontSize:12, color:T.muted }}>
                                          Survey sent {fmtDateOnly(c.survey_sent_date)}
                                        </span>
                                        {/* The undo. Asks nothing: it is one
                                            click, reversible by one more, and
                                            a confirm on a cheap reversible
                                            action trains people to click
                                            through the ones that matter. */}
                                        <button
                                          onClick={() => writeSurvey(c, { clear: true })}
                                          disabled={surveyBusyId === c.id}
                                          title="Not sent after all — clear the date"
                                          aria-label="Clear survey sent"
                                          style={{ padding:"1px 6px", fontSize:12, borderRadius:6,
                                                   fontFamily:"inherit", lineHeight:1.3,
                                                   cursor: surveyBusyId === c.id ? "wait" : "pointer",
                                                   border:`1px solid ${T.border}`,
                                                   background:"rgba(255,255,255,.04)", color:T.muted }}
                                        >×</button>
                                      </span>
                                    ) : noSurvey ? (
                                      /* NO CONTROL — the cell states a fact.
                                         Checked AFTER `sent`, deliberately:
                                         a no-show marked by mistake keeps its
                                         date and its undo above, so the
                                         mistake stays correctable, and only
                                         once cleared does it read this. */
                                      <span style={{ fontSize:12, color:T.muted }}>
                                        No survey needed
                                      </span>
                                    ) : surveyEdit?.id === c.id ? (
                                      /* The inline date editor, following the
                                         status column's statusEdit idiom —
                                         same input styling, same Set / cancel
                                         pair. PREFILLED WITH TODAY, so the
                                         common case is click then Set: two
                                         clicks and no date interaction.

                                         max=today because the server refuses
                                         a future send date; the cap means the
                                         error can never appear, the same
                                         reason the Booking Sent "Sent on"
                                         field carries one. */
                                      <span style={{ display:"inline-flex", alignItems:"center", gap:6 }}>
                                        <input
                                          type="date"
                                          value={surveyEdit.date}
                                          max={localDateString()}
                                          autoFocus
                                          onChange={(e) => setSurveyEdit(st => ({ ...st, date:e.target.value }))}
                                          style={{ padding:"4px 6px", fontSize:12, borderRadius:6,
                                                   border:`1px solid ${T.border}`, background:"rgba(0,0,0,0.25)",
                                                   color:T.text, colorScheme:"dark" }}
                                        />
                                        <button
                                          onClick={() => writeSurvey(c, { date: surveyEdit.date })}
                                          disabled={!surveyEdit.date || surveyBusyId === c.id}
                                          style={{ padding:"4px 10px", fontSize:12, borderRadius:6,
                                                   fontFamily:"inherit",
                                                   cursor: (surveyEdit.date && surveyBusyId !== c.id)
                                                     ? "pointer" : "not-allowed",
                                                   border:`1px solid ${T.border}`,
                                                   background:"rgba(255,255,255,.06)", color:T.text }}
                                        >{surveyBusyId === c.id ? "Saving…" : "Set"}</button>
                                        <button
                                          onClick={() => setSurveyEdit(null)}
                                          aria-label="Cancel survey date"
                                          style={{ padding:"4px 8px", fontSize:12, borderRadius:6,
                                                   fontFamily:"inherit", cursor:"pointer", border:"none",
                                                   background:"transparent", color:T.muted }}
                                        >×</button>
                                      </span>
                                    ) : (
                                      <button
                                        onClick={() => openSurveyEdit(c)}
                                        disabled={surveyBusyId === c.id}
                                        style={{ padding:"3px 10px", fontSize:12, borderRadius:6,
                                                 fontFamily:"inherit",
                                                 cursor: surveyBusyId === c.id ? "wait" : "pointer",
                                                 border:`1px solid ${T.border}`,
                                                 background:"rgba(255,255,255,.06)", color:T.text }}
                                      >
                                        {surveyBusyId === c.id ? "Saving…" : "Survey sent"}
                                      </button>
                                    )}
                                    {surveyError?.id === c.id && (
                                      <div style={{ fontSize:11, color:T.red, marginTop:3 }}>
                                        {surveyError.message}
                                      </div>
                                    )}
                                  </td>
                                </tr>
                                );
                              })}
                            </tbody>
                          </table>
                          </TableScroll>
                        )}
                      </>
                    );
                  }

                })()}
              </>
            )}
          </>
        )}
      </Card>
      )}

      {/* ── TAB: Customer Management — READ-ONLY ────────────────────
          "This row needs fixing." Current clients show by default; the
          inactive/history checkbox intentionally widens the same read-only
          lens. Every problem named here is fixed in CRM; nothing on this tab
          writes. The row action opens Record Renewal; scheduling writes only
          the append-only renewal ledger, and activation owns the term update.

          PROMOTED OUT OF THE ASSESSMENTS SECTION 2026-08-14, to sit
          directly after it in the tab row. It outgrew being a sub-view of
          scheduling: what it answers is contract-data integrity and
          renewal proximity, which belong to whoever owns the contracts
          rather than to whoever books the reviews. THE BODY MOVED
          VERBATIM — same rows, same facets, same counts, same tags, same
          endpoint — so its own suite re-targeted where it mounts and
          changed no assertion about what it shows.

          THE DEFAULT ORDER IS THE SERVER'S: problem rows pinned to the
          top in severity order, clean rows below by renewal proximity.
          That ranking is never restated here — the Sort control offers
          alternatives the READER asks for (name, tier, soonest term
          end) and "" means the server's order untouched, so the triage
          order can only be left deliberately. ── */}
      {adminTab === "management" && (
      <Card>
        <h3 style={{ margin:"0 0 4px", fontSize:15, fontWeight:700, color:"#fff" }}>Customer Management</h3>
        <div role="tablist" aria-label="Customer Management view"
             style={{ display:"flex", flexWrap:"wrap", gap:6, margin:"12px 0" }}>
          {[
            ["contract", "Customer Data"],
            ["cadence", "Review cadence"],
            ["requests", requestCountLabel(requestManagementCount.count)],
          ].map(([value, label]) => {
            const selected = mgmtLens === value;
            return <button key={value} role="tab" aria-selected={selected} disabled={requestManagementBusy}
              onClick={() => setMgmtLens(value)}
              style={{ padding:"6px 10px", borderRadius:6, cursor:"pointer",
                       fontFamily:"inherit", fontSize:12, fontWeight:600,
                       color:selected ? T.text : T.muted,
                       border:`1px solid ${selected ? "rgba(68,166,255,.6)" : T.border}`,
                       background:selected ? "rgba(68,166,255,.14)" : "rgba(255,255,255,.03)" }}>
              {label}
            </button>;
          })}
        </div>
        {mgmtLens === "requests" && <AutoRenewRequestManagement theme={T}
          onCount={requestManagementCount.receive} onCountUnavailable={requestManagementCount.unavailable}
          onBusyChange={setRequestManagementBusy} />}
        {mgmtLens === "contract" && (custMgmtError ? (
          <div style={{ fontSize:13, color:T.red, padding:"12px 0" }}>
            Couldn’t load the contract data. Please try again.
          </div>
        ) : custMgmt === null ? (
          <div style={{ fontSize:13, color:T.muted, padding:"12px 0" }}>Loading…</div>
        ) : (
          <>
            <div style={{ fontSize:12, color:T.muted, marginBottom:12, lineHeight:1.6 }}>
              Customer data from CRM. Rows needing attention appear first by default.
            </div>

            <details style={{ marginBottom:12 }} open={mgmtAboutOpen}
              onToggle={(e) => setMgmtAboutOpen(e.currentTarget.open)}>
              <summary style={{ color:T.blue, cursor:"pointer", fontSize:12,
                width:"fit-content", outlineOffset:3 }}>About this view</summary>
              <div style={{ fontSize:12, color:T.muted, marginTop:8, lineHeight:1.6 }}>
                Customer Data as recorded in CRM. Current clients show by default;
                use Show inactive/history for expired, closed, or unclassified
                rows. Rows needing attention are pinned to the top with a tag
                naming what to fix; hover a tag for the fix. Read-only: nothing
                on this view changes a record until an explicit row action opens a
                guarded modal. Renewal amber inside {custMgmt.meta?.renewal_approaching_days ?? 90} days.
              </div>
            </details>

            <div style={{ display:"flex", gap:10, alignItems:"center", flexWrap:"wrap", marginBottom:12 }}>
              {/* The placeholder says what it matches — the manager match
                  is invisible otherwise, and "Search customer…" reads as
                  a promise that it matches ONLY customers. */}
              <input
                value={mgmtSearch}
                onChange={(e) => setMgmtSearch(e.target.value)}
                placeholder={`Search customer or ${CUSTOMER_MANAGER_LABEL}…`}
                style={{
                  padding:"6px 10px", fontSize:12, borderRadius:6, minWidth:200,
                  border:`1px solid ${T.border}`, background:"rgba(0,0,0,0.25)",
                  color:T.text, fontFamily:"inherit",
                }}
              />
              {/* THE BADGE'S CLICK-THROUGH, reading the SAME count the
                  badge shows (mgmtProblemCount) — one quantity, one
                  number, wherever it appears. */}
              <label style={{ fontSize:12, color:T.muted, display:"flex", alignItems:"center", gap:6, cursor:"pointer" }}>
                <input
                  type="checkbox"
                  checked={mgmtProblemsOnly}
                  onChange={(e) => setMgmtProblemsOnly(e.target.checked)}
                  style={{ width:14, height:14, accentColor:T.blue, cursor:"pointer" }}
                />
                Needs fixing only ({mgmtProblemCount})
              </label>
              <label style={{ fontSize:12, color:T.muted, display:"flex", alignItems:"center", gap:6, cursor:"pointer" }}>
                <input
                  type="checkbox"
                  checked={mgmtShowInactive}
                  onChange={(e) => changeMgmtInactiveScope(e.target.checked)}
                  style={{ width:14, height:14, accentColor:T.blue, cursor:"pointer" }}
                />
                Show inactive/history
              </label>
              <span style={{ fontSize:12, color:T.muted, whiteSpace:"nowrap" }}>
                {visibleMgmtRows.length} of {mgmtCustomers.length}
              </span>
              {/* The amber threshold comes from the BACKEND (meta), so
                  the copy can never claim a window the server is not
                  using. */}
              <label style={{ fontSize:12, color:T.muted, display:"flex", alignItems:"center", gap:6, marginLeft:"auto" }}>
                Sort
                <select
                  value={mgmtSort}
                  onChange={(e) => setMgmtSort(e.target.value)}
                  style={{
                    padding:"5px 8px", fontSize:12, borderRadius:6,
                    fontFamily:"inherit", border:`1px solid ${T.border}`,
                    background:"rgba(0,0,0,0.25)", color:T.text,
                  }}
                >
                  {managementSortOptions().map(o => (
                    <option key={o.value || "default"} value={o.value}>{o.label}</option>
                  ))}
                </select>
              </label>
            </div>

            <div style={{ marginBottom:8 }}>
              <div style={{ fontSize:11, color:T.muted, fontWeight:600,
                            textTransform:"uppercase", letterSpacing:".04em",
                            marginBottom:6 }}>
                Contract Actions
              </div>
              <div style={{ display:"flex", gap:6, flexWrap:"wrap" }}>
                {mgmtContractActionCards.map((card) => {
                  const on = mgmtContractAction === card.value;
                  return (
                    <button
                      key={card.value}
                      onClick={() => toggleMgmtContractAction(card.value)}
                      aria-pressed={on}
                      title={on ? "Show every contract action"
                        : `Show only ${card.label}`}
                      style={{
                        flex:"0 1 auto", minWidth:0, textAlign:"left",
                        cursor:"pointer", padding:"6px 9px", borderRadius:7,
                        fontFamily:"inherit",
                        border:`1px solid ${on ? "rgba(68,166,255,.6)" : T.border}`,
                        background:on ? "rgba(68,166,255,.10)" : "rgba(255,255,255,.04)",
                      }}
                    >
                      <span style={{ display:"inline-flex", alignItems:"center", gap:5 }}>
                        <Badge type={card.tone} weight={card.weight}>{card.label}</Badge>
                        {on && <span aria-hidden="true" style={{ fontWeight:800, color:T.blue }}>✓</span>}
                      </span>
                      <span aria-hidden="true" style={{ color:T.muted }}> · </span>
                      <span style={{ fontSize:12, fontWeight:700, color:T.text }}>{card.count}</span>
                    </button>
                  );
                })}
              </div>
            </div>

            <div style={{ display:"flex", gap:8, alignItems:"center", flexWrap:"wrap", marginBottom:8 }}>
              <button type="button" ref={mgmtFiltersTriggerRef}
                aria-expanded={mgmtFiltersOpen} aria-controls="mgmt-secondary-filters"
                onClick={() => {
                  if (mgmtFiltersOpen && mgmtFiltersPanelRef.current?.contains(document.activeElement)) {
                    mgmtFiltersTriggerRef.current?.focus();
                  }
                  setMgmtFiltersOpen(open => !open);
                }}
                style={{ cursor:"pointer", padding:"5px 9px", borderRadius:6,
                  fontFamily:"inherit", fontSize:12, color:T.text,
                  border:`1px solid ${T.border}`, background:"rgba(255,255,255,.04)" }}>
                More filters{Object.values(mgmtFacets || {}).filter(Boolean).length
                  ? ` (${Object.values(mgmtFacets || {}).filter(Boolean).length})` : ""}
              </button>
              {mgmtContractAction && (() => {
                const selected = mgmtContractActionCards.find(card => card.value === mgmtContractAction);
                return selected ? <button type="button" aria-label={`Remove Contract Action: ${selected.label} (${selected.count})`}
                  onClick={() => setMgmtContractAction("")}
                  style={{ cursor:"pointer", padding:"4px 8px", borderRadius:14,
                    fontFamily:"inherit", fontSize:12, color:T.text,
                    border:`1px solid rgba(68,166,255,.6)`, background:"rgba(68,166,255,.10)" }}>
                  ✓ Contract Action: {selected.label} · {selected.count} ×
                </button> : null;
              })()}
              {[
                { group:MGMT_FACET_PHASE, heading:"Lifecycle phase" },
                { group:MGMT_FACET_STATUS, heading:"Contract status" },
                { group:MGMT_FACET_TIER, heading:"Tier" },
                { group:MGMT_FACET_AUTORENEW, heading:"Auto renew" },
              ].map(({ group, heading }) => {
                const value = mgmtFacets?.[group];
                if (!value) return null;
                const currentCounts = mgmtFacetCounts?.[group] || {};
                const selectedCounts = {
                  ...mgmtFacetCounts,
                  [group]: { ...currentCounts, [value]: currentCounts[value] || 0 },
                };
                const selected = managementFacetCards(group, selectedCounts, value)
                  .find(card => card.value === value);
                if (!selected) return null;
                return <button key={group} type="button"
                  aria-label={`Remove ${heading}: ${selected.label} (${selected.count})`}
                  onClick={() => toggleMgmtFacet(group, value)}
                  style={{ cursor:"pointer", padding:"4px 8px", borderRadius:14,
                    fontFamily:"inherit", fontSize:12, color:T.text,
                    border:`1px solid rgba(68,166,255,.6)`, background:"rgba(68,166,255,.10)" }}>
                  ✓ {heading}: {selected.label} · {selected.count} ×
                </button>;
              })}
              {(mgmtContractAction || Object.values(mgmtFacets || {}).some(Boolean)) && (
                <button type="button" onClick={() => { setMgmtContractAction(""); setMgmtFacets({}); }}
                  style={{ cursor:"pointer", border:0, background:"transparent", color:T.blue,
                    fontFamily:"inherit", fontSize:12, textDecoration:"underline" }}>
                  Clear filters
                </button>
              )}
            </div>

            {/* Hidden secondary facets are removed from keyboard navigation; selected chips above remain visible. */}
            <div id="mgmt-secondary-filters" ref={mgmtFiltersPanelRef}
              hidden={!mgmtFiltersOpen}>
            {[
              { group:MGMT_FACET_PHASE, heading:"Lifecycle phase" },
              { group:MGMT_FACET_STATUS, heading:"Contract status" },
              { group:MGMT_FACET_TIER, heading:"Tier" },
              { group:MGMT_FACET_AUTORENEW, heading:"Auto renew" },
            ].map(({ group, heading }) => {
              const cards = managementFacetCards(
                group, mgmtFacetCounts, mgmtFacets?.[group]);
              if (cards.length === 0) return null;
              return (
                <div key={group} style={{ marginBottom:12 }}>
                  <div style={{ fontSize:11, color:T.muted, fontWeight:600,
                                textTransform:"uppercase", letterSpacing:".04em",
                                marginBottom:6 }}>
                    {heading}
                  </div>
                  <div style={{ display:"flex", gap:6, flexWrap:"wrap" }}>
                    {cards.map((card) => {
                      const on = mgmtFacets?.[group] === card.value;
                      return (
                        <button
                          key={card.value}
                          onClick={() => toggleMgmtFacet(group, card.value)}
                          aria-pressed={on}
                          title={on ? `Show every ${heading.toLowerCase()}`
                            : `Show only ${card.label}`}
                          style={{
                            flex:"0 1 auto", minWidth:0, textAlign:"left",
                            cursor:"pointer", padding:"5px 8px", borderRadius:6,
                            fontFamily:"inherit",
                            border:`1px solid ${on ? "rgba(68,166,255,.6)" : T.border}`,
                            background: on ? "rgba(68,166,255,.10)" : "rgba(255,255,255,.04)",
                          }}
                        >
                          <span style={{ marginRight:5 }}>
                            {/* Status cards wear the SAME chip tone as
                                the column, so the card and the rows it
                                opens are recognisably the same thing. */}
                            {card.tone
                              ? <Badge type={card.tone} weight="soft">{card.label}</Badge>
                              : <span style={{ fontSize:11, fontWeight:600, color:T.muted, letterSpacing:".02em" }}>{card.label}</span>}
                            {on && <span aria-hidden="true" style={{ fontWeight:800, color:T.blue, marginLeft:4 }}>✓</span>}
                          </span>
                          <span style={{ fontSize:12, fontWeight:700, color:T.text, lineHeight:1 }}>
                            {card.count}
                          </span>
                          {/* The one sub-line worth the space: this card
                              IS the worklist — nobody has asked these
                              customers whether they auto-renew. */}
                          {group === MGMT_FACET_AUTORENEW && card.value === "__unset__" && (
                            <div style={{ fontSize:11, color:T.muted, marginTop:5 }}>
                              nobody has asked
                            </div>
                          )}
                        </button>
                      );
                    })}
                  </div>
                </div>
              );
            })}
            </div>

            <div className="customer-mgmt-scroll" style={{ overflowX:"auto", containerType:"inline-size" }}>
            <style>{`
              .customer-mgmt-table { width:100%; border-collapse:collapse; table-layout:fixed; }
              .customer-mgmt-table th, .customer-mgmt-table td { overflow-wrap:anywhere; }
              .customer-mgmt-actions { display:flex; flex-direction:column; gap:6px; min-width:0; }
              .customer-mgmt-actions > button { width:100%; min-width:0; white-space:normal; overflow-wrap:anywhere; text-align:left; }
              .customer-mgmt-action-panel { box-sizing:border-box; width:100%; min-width:0; margin-top:5px; padding:7px; border:1px solid ${T.border}; border-radius:7px; background:rgba(0,0,0,.22); }
              .customer-mgmt-work-button { display:block; width:100%; max-width:100%; text-align:left; }
              .customer-mgmt-work-button > span { display:block; max-width:100%; box-sizing:border-box; white-space:normal !important; overflow-wrap:anywhere; }
              .customer-mgmt-contract-details { display:block; margin-top:5px; }
              .customer-mgmt-tags { display:flex; gap:5px; flex-wrap:wrap; }
              .customer-mgmt-tags > span { display:block; min-width:0; max-width:100%; }
              .customer-mgmt-tags > span > span { display:block; max-width:100%; box-sizing:border-box; white-space:normal !important; overflow-wrap:anywhere; }
              .customer-mgmt-action-trigger { white-space:nowrap; }
              .customer-mgmt-scroll button:focus-visible, .customer-mgmt-scroll summary:focus-visible { outline:2px solid ${T.blue}; outline-offset:2px; }
              @container (max-width: 1280px) {
                .customer-mgmt-table .cm-contract-detail-column { display:none; }
              }
              @container (max-width: 680px) {
                .customer-mgmt-table, .customer-mgmt-table tbody { display:block; width:100%; }
                .customer-mgmt-table thead { position:absolute; width:1px; height:1px; padding:0; margin:-1px; overflow:hidden; clip:rect(0,0,0,0); white-space:nowrap; border:0; }
                .customer-mgmt-table tbody tr { display:grid; grid-template-columns:minmax(0,1fr) minmax(0,1fr); gap:0 10px; margin:0 0 10px; padding:7px; border:1px solid ${T.border}; border-radius:8px; }
                .customer-mgmt-table tbody td { display:block; min-width:0; padding:6px 3px; border-bottom:0; }
                .customer-mgmt-table tbody td::before { content:attr(data-label); display:block; margin-bottom:3px; color:${T.muted}; font-size:10px; font-weight:600; letter-spacing:.035em; text-transform:uppercase; }
                .customer-mgmt-table tbody td.cm-primary-cell { grid-column:1 / -1; }
                .customer-mgmt-table tbody td.cm-empty-cell { grid-column:1 / -1; }
                .customer-mgmt-table tbody td.cm-contract-detail-column { display:none; }
                .customer-mgmt-table tbody td.cm-stored-date-cell { grid-column:1 / -1; }
                .customer-mgmt-table tbody td.cm-renewal-cell, .customer-mgmt-table tbody td.cm-fixing-cell { grid-column:1 / -1; }
                .customer-mgmt-table tbody td.cm-action-cell { grid-column:1 / -1; }
                .customer-mgmt-actions { display:block; }
                .customer-mgmt-actions > button { width:100%; text-align:left; }
              }
            `}</style>
            <table className="customer-mgmt-table" role="table">
              <thead role="rowgroup"><tr role="row">
                <th scope="col" role="columnheader" style={{ ...thStyle, width:"18%" }}>Customer</th>
                <th scope="col" role="columnheader" className="cm-contract-detail-column" style={{ ...thStyle, width:"8%" }}>Contract</th>
                <th scope="col" role="columnheader" className="cm-contract-detail-column" style={{ ...thStyle, width:"6%" }}>Tier</th>
                {/* DERIVED, and labelled so: term start + duration. The
                    mismatch tag is meaningless if a reader cannot tell
                    this column from the stored one two along. */}
                <th scope="col" role="columnheader" className="cm-contract-detail-column" style={{ ...thStyle, width:"12%" }}>Term (derived)</th>
                {/* CY and RN MERGED, Term # moved out (2026-08-11): the
                    table cut off on the right at normal widths. Two
                    columns of one number each answered one question —
                    where in the contract is this customer — so they are
                    one "Y3 · 2/4" cell now, and Term Start Year moved into
                    the Term tooltip, where it is an input to the
                    derivation that tooltip already explains. */}
                <th scope="col" role="columnheader" className="cm-contract-detail-column" style={{ ...thStyle, width:"7%" }}>Cycle</th>
                {/* The STORED column, under the operator's CRM display
                    name. Flagged red when it disagrees with the derived
                    term under both fleet conventions. */}
                <th scope="col" role="columnheader" style={{ ...thStyle, width:"9%" }}>Term End Date</th>
                <th scope="col" role="columnheader" className="cm-contract-detail-column" style={{ ...thStyle, width:"6%" }}>Auto renew</th>
                <th scope="col" role="columnheader" style={{ ...thStyle, width:"13%" }}>Renewal</th>
                <th scope="col" role="columnheader" style={{ ...thStyle, width:"13%" }}>Needs fixing</th>
                <th scope="col" role="columnheader" style={{ ...thStyle, width:"8%" }}>Actions</th>
              </tr></thead>
              <tbody role="rowgroup">
                {visibleMgmtRows.length === 0 ? (
                  <tr role="row">
                    <td role="cell" className="cm-empty-cell" colSpan={10} style={{ ...tdStyle, textAlign:"center", color:T.muted, padding:"24px 8px" }}>
                      {mgmtCustomers.length === 0
                        ? "No contract data to show."
                        : mgmtProblemsOnly
                          ? "Nothing needs fixing."
                          : mgmtContractAction === "activation_due"
                            ? "No activations are due."
                            : mgmtContractAction === "non_renewal_due"
                              ? "No non-renewals are due."
                            : mgmtContractAction === "scheduled"
                              ? "No scheduled renewals."
                              : mgmtContractAction === "non_renewal_scheduled"
                                ? "No scheduled non-renewals."
                          : "No customers match that search."}
                    </td>
                  </tr>
                ) : visibleMgmtRows.map((r) => {
                  const pill = renewalPill(r);
                  const work = renewalWorkItem(r, fmtDateOnly);
                  // meta carries the mismatch grace, which the tag's
                  // guidance states — never a hardcoded window.
                  const tags = problemTags(r, custMgmt.meta);
                  const term = termRangeLabel(r, fmtDateOnly);
                  return (
                    <tr key={r.slug} role="row">
                      <td role="cell" className="cm-primary-cell" data-label="Customer"
                          style={{ ...tdStyle, fontWeight:600 }}>
                        <a
                          href={reviewCustomerUrl(r.slug)}
                          onClick={(e) => handleCustomerNameClick(
                            e, r.slug, r.customer_name,
                            visibleMgmtRows.map(x => x.slug), "management")}
                          style={{ color:T.blue, textDecoration:"none" }}
                          title={`Open ${r.customer_name || r.slug}`
                            + (r.customer_record_name
                                && r.customer_record_name !== r.customer_name
                              ? ` · CRM record: ${r.customer_record_name}` : "")
                            + (r.next_audit_date
                              ? ` · next audit ${fmtDateOnly(r.next_audit_date)}` : "")}
                        >
                          {r.customer_name || r.slug}
                        </a>
                        {r.contract_change_enrolled && (
                          <div style={{ fontSize:10.5, color:r.governed_unavailable ? T.red : T.muted,
                                        fontWeight:400, marginTop:3 }}>
                            {r.governed_unavailable
                              ? "Contract state unavailable — investigate"
                              : `${r.governed_balance?.available_now ?? "—"} reviews bookable now`
                            }
                          </div>
                        )}
                        <details className="customer-mgmt-contract-details">
                          <summary style={{ cursor:"pointer", color:T.blue, fontSize:11,
                                            fontWeight:500, marginTop:5 }}>
                            Contract details
                          </summary>
                          <dl style={{ display:"grid", gridTemplateColumns:"max-content minmax(0,1fr)",
                                       gap:"3px 8px", margin:"6px 0 0", fontSize:11, fontWeight:400 }}>
                            {r.customer_manager && <><dt>{CUSTOMER_MANAGER_LABEL}</dt><dd style={{ margin:0 }}>{r.customer_manager}</dd></>}
                            <dt>Contract</dt><dd style={{ margin:0 }}>{contractDisplayLabel(r.contract_status) || "—"}</dd>
                            <dt>Tier</dt><dd style={{ margin:0 }}>{r.tier || "—"}</dd>
                            <dt>Term (derived)</dt><dd style={{ margin:0 }} title={termTitle(r, fmtDateOnly)}>{term || "—"}</dd>
                            <dt>Cycle</dt><dd style={{ margin:0 }} title={managementCycleTitle(r, custMgmt.meta)}>{managementCycleLabel(r) || "—"}</dd>
                            <dt>Auto renew</dt><dd style={{ margin:0 }}>{autoRenewLabel(r)}</dd>
                          </dl>
                        </details>
                      </td>
                      {/* One Time reads "One Time", never "Open" —
                          contractDisplayLabel is the single statement of
                          that rename. An unset status renders "—" rather
                          than a guess. */}
                      <td role="cell" className="cm-contract-detail-column" data-label="Contract" style={tdStyle}>
                        {contractDisplayLabel(r.contract_status)
                          ? <Badge type={contractStatusTone(r)} weight="soft">
                              {contractDisplayLabel(r.contract_status)}
                            </Badge>
                          : "—"}
                      </td>
                      <td role="cell" className="cm-contract-detail-column" data-label="Tier" style={tdStyle}>
                        <span style={{ color:T.muted }}>{r.tier || "—"}</span>
                      </td>
                      <td role="cell" className="cm-contract-detail-column" data-label="Term (derived)" style={{ ...tdStyle, overflowWrap:"anywhere" }}
                          title={termTitle(r, fmtDateOnly)}>
                        {term || "—"}
                      </td>
                      <td role="cell" className="cm-contract-detail-column" data-label="Cycle" style={{ ...tdStyle, overflowWrap:"anywhere" }}
                          title={managementCycleTitle(r, custMgmt.meta)}>
                        {managementCycleLabel(r) || "—"}
                      </td>
                      <td role="cell" className="cm-stored-date-cell" data-label="Term End Date" style={{
                        ...tdStyle, whiteSpace:"nowrap",
                        color: r.expiration_mismatch ? T.red : T.muted,
                        fontWeight: r.expiration_mismatch ? 600 : 400,
                      }} title={r.expiration_mismatch
                        ? `Stored ${fmtDateOnly(r.expiration_date)} against a term `
                          + `deriving ${fmtDateOnly(r.term_end_display)} (or `
                          + `${fmtDateOnly(r.term_end)} on the anniversary `
                          + "convention) — a different day under both."
                        : undefined}>
                        {r.expiration_date ? fmtDateOnly(r.expiration_date) : "—"}
                      </td>
                      <td role="cell" className="cm-contract-detail-column" data-label="Auto renew" style={{ ...tdStyle, color:T.muted }}>{autoRenewLabel(r)}</td>
                      <td role="cell" className="cm-renewal-cell" data-label="Renewal" style={{ ...tdStyle, padding:"7px 6px" }} title={work?.title || renewalTitle(r, custMgmt.meta, fmtDateOnly)}>
                        {work ? (
                          <>
                            <button
                              className="customer-mgmt-work-button"
                              onClick={() => r.contract_change_enrolled
                                ? setContractChangeRow({ ...r, initialAction:"renew" })
                                : setRenewalPreviewRow(r)}
                              style={{
                                padding:0, margin:0, border:0, background:"transparent",
                                fontFamily:"inherit", cursor:"pointer",
                              }}
                              title={work.title}
                            >
                              <Badge type={work.type} weight={work.weight}>{work.label}</Badge>
                            </button>
                            <div style={{ marginTop:2 }}
                                 title={renewalTitle(r, custMgmt.meta, fmtDateOnly)}>
                              {pill.kind === "pill" ? (
                                <Badge type={pill.type} weight={pill.weight}>{pill.label}</Badge>
                              ) : (
                                <span style={{ color:T.muted }}>{pill.label}</span>
                              )}
                            </div>
                          </>
                        ) : pill.kind === "pill" ? (
                          <Badge type={pill.type} weight={pill.weight}>{pill.label}</Badge>
                        ) : (
                          <span style={{ color:T.muted }}>{pill.label}</span>
                        )}
                      </td>
                      {/* THE TAG IS THE INSTRUCTION — Katelyn fixes rows
                          in CRM from this list, so the words say what is
                          wrong and the tooltip says what to do. */}
                      <td role="cell" className="cm-fixing-cell" data-label="Needs fixing" style={{ ...tdStyle, padding:"7px 6px" }}>
                        {tags.length === 0 ? (
                          <span style={{ color:T.muted }}>—</span>
                        ) : (
                          <span className="customer-mgmt-tags">
                            {tags.map((t, i) => (
                              <span key={t.name} title={t.fix}>
                                <Badge type={problemTagTone(t.name, i === 0)} weight="soft">
                                  {t.tag}
                                </Badge>
                              </span>
                            ))}
                          </span>
                        )}
                      </td>
                      <td role="cell" className="cm-action-cell" data-label="Actions" style={tdStyle}>
                        <button
                          ref={node => {
                            if (node) mgmtActionTriggerRefs.current.set(r.slug, node);
                            else mgmtActionTriggerRefs.current.delete(r.slug);
                          }}
                          type="button"
                          className="customer-mgmt-action-trigger"
                          aria-label={`Actions for ${r.customer_name || r.slug}`}
                          aria-expanded={mgmtActionsOpenSlug === r.slug}
                          aria-controls={`customer-mgmt-actions-${r.slug}`}
                          onClick={() => setMgmtActionsOpenSlug(open => open === r.slug ? "" : r.slug)}
                          onKeyDown={event => {
                            if (event.key === "Escape" && mgmtActionsOpenSlug === r.slug) {
                              event.preventDefault();
                              closeMgmtActions(true);
                            }
                          }}
                          style={{ cursor:"pointer", padding:"5px 8px", borderRadius:6,
                            fontFamily:"inherit", fontSize:12, color:T.text,
                            border:`1px solid ${T.border}`, background:"rgba(255,255,255,.04)" }}
                        >
                          Actions <span aria-hidden="true">{mgmtActionsOpenSlug === r.slug ? "▴" : "▾"}</span>
                        </button>
                        <div id={`customer-mgmt-actions-${r.slug}`}
                             className="customer-mgmt-action-panel"
                             hidden={mgmtActionsOpenSlug !== r.slug}
                             onKeyDown={event => {
                               if (event.key === "Escape") {
                                 event.preventDefault();
                                 closeMgmtActions(true);
                               }
                             }}>
                          <div className="customer-mgmt-actions">
                            <Btn
                              onClick={() => { closeMgmtActions(true); r.contract_change_enrolled
                                ? setContractChangeRow({ ...r, initialAction:"renew" })
                                : setRenewalPreviewRow(r); }}
                              style={{ padding:"5px 8px", borderRadius:6 }}
                            >Record Renewal</Btn>
                            <Btn
                              onClick={() => { closeMgmtActions(true); setContractChangeRow(r); }}
                              style={{ padding:"5px 8px", borderRadius:6 }}
                            >Contract Change</Btn>
                            <Btn
                              onClick={() => { closeMgmtActions(true); setContractChangeRow({ ...r, initialAction:"cancel" }); }}
                              style={{ padding:"5px 8px", borderRadius:6 }}
                            >Cancel contract</Btn>
                            {r.allowance_model === "banked" && (
                              <Btn
                                onClick={() => { closeMgmtActions(true); r.contract_change_enrolled
                                  ? setContractChangeRow({ ...r, initialAction:"adjustment" })
                                  : setAllowanceAdjustmentRow(r); }}
                                style={{ padding:"5px 8px", borderRadius:6 }}
                              >Allowance</Btn>
                            )}
                            {canOpenBankedTransition(r) && (
                              <Btn
                                onClick={() => { closeMgmtActions(true); setAllowanceTransitionRow(r); }}
                                style={{ padding:"5px 8px", borderRadius:6 }}
                              >Bank Transition</Btn>
                            )}
                          </div>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            </div>
          </>
        ))}
        {mgmtLens === "cadence" && (
          <ReviewCadencePanel
            error={reviewCadenceError}
            data={reviewCadence}
            search={mgmtSearch}
            onSearch={setMgmtSearch}
            stateFilter={cadenceStateFilter}
            onStateFilter={setCadenceStateFilter}
            rows={visibleCadenceRows}
            getCustomerHref={reviewCustomerUrl}
            getCustomerOnClick={(row) => (e) => handleCustomerNameClick(
              e, row.slug, row.customer_name,
              visibleCadenceRows.map(x => x.slug), "cadence")}
            onRetry={retryReviewCadence}
            showInactive={mgmtShowInactive}
            onShowInactive={changeMgmtInactiveScope}
          />
        )}
      </Card>
      )}
      <RenewalPreviewModal
        row={renewalPreviewRow}
        onClose={() => setRenewalPreviewRow(null)}
        onChanged={refreshManagementAfterRenewal}
      />
      <ContractChangeModal
        row={contractChangeRow}
        initialAction={contractChangeRow?.initialAction || "amend"}
        onClose={() => setContractChangeRow(null)}
        onChanged={refreshManagementAfterRenewal}
      />
      <AllowanceAdjustmentModal
        row={allowanceAdjustmentRow}
        onClose={() => setAllowanceAdjustmentRow(null)}
        onChanged={refreshManagementAfterRenewal}
      />
      <AllowanceTransitionModal
        row={allowanceTransitionRow}
        onClose={() => setAllowanceTransitionRow(null)}
        onChanged={refreshManagementAfterRenewal}
      />
      <CustomerOperationsNotesDrawer
        target={customerOperationsNoteTarget}
        onClose={() => setCustomerOperationsNoteTarget(null)}
        onChanged={() => refreshRowFromFleet(customerOperationsNoteTarget?.slug)}
      />
      {customerDrawer && (
        <CustomerDetailDrawer
          slug={customerDrawer.slug}
          name={customerDrawer.fallbackName}
          wideNote={!!(drawerMgmt.fromWide || drawerCadence.fromWide)}
          mgmtRow={drawerMgmt.row}
          mgmtMeta={drawerMgmt.meta}
          mgmtState={drawerMgmt.state}
          onRetryMgmt={retryDrawerMgmt}
          cadenceRow={drawerCadence.row}
          cadenceState={drawerCadence.state}
          onRetryCadence={retryDrawerCadence}
          dashboardHref={customerDashboardUrl(customerDrawer.slug)}
          hasPrev={drawerHasPrev}
          hasNext={drawerHasNext}
          onPrev={() => stepCustomerDrawer(-1)}
          onNext={() => stepCustomerDrawer(1)}
          onClose={closeCustomerDrawer}
          returnFocusTo={drawerTriggerRef.current}
        />
      )}
    </div>
  );
};

// ── Customer self-scan card (Company Profile "Security Scan") ─────────
// Internal-gated behind SHOW_SCAN_CARD_TO_CUSTOMERS (the wizard's flag
// pattern) — flipping that one line launches it to customers. NOT a
// wizard step: the wizard is a one-time migration flow, this card is a
// recurring action that outlives it.
//
// Talks to the portal_scan_* proxies in CUSTOMER view. Internal users
// pass as_customer so the backend runs the exact customer path —
// server-side scan-account resolution (no UPN ever reaches this code),
// in-flight lock (409 carries the run to attach to), admission pre-gate,
// projected results (Issues only, TenantAdmin audience — never Items),
// and the 24h scan cap (backend-enforced; the card mirrors it for
// display from the customer's own runs).

const SCAN_CARD_PREREQ_POLL_MS = 3000;   // prereq checks finish in ~seconds
const SCAN_CARD_PREREQ_MAX_TICKS = 40;   // ~2 min budget (admin-tab bound)
// ADR-0085: N consecutive identical-status poll failures = deterministic,
// not transient. At the 3 s prereq cadence this is ~15 s — a true signal
// fast, versus the old 2-min fake timeout that masked the ownership 404.
const POLL_DETERMINISTIC_LIMIT = 5;
const SCAN_CARD_SCAN_POLL_MS = 10000;    // assessments take minutes
const SCAN_CARD_SCAN_MAX_TICKS = 180;    // ~30 min budget
const SCAN_CAP_MS = 24 * 3600 * 1000;
// Post-scan adjudication poll (ADR-0082 D2 wait experience). ~20 min
// budget: normal auto-publish resolves in ~2-4 min (2-min sweep +
// ingest/scoring seconds), and one full dead-claimant lease-recovery
// cycle is ~17-19 min — the budget outlasts it. On exhaustion (or a
// server-side stalled flag) the card gives up HONESTLY (see
// SCAN_WAIT_COPY.stalled) instead of promising "a few minutes" forever.
const SCAN_CARD_ADJUDICATION_POLL_MS = 30000;
const SCAN_CARD_ADJUDICATION_MAX_TICKS = 40;

// Post-completion wait copy, keyed by adjudication phase (approved
// 2026-08-02). Exported so tests pin the approved strings. Deliberate
// absences: no specific minute counts (cadence is tunable; numbers go
// stale) and NO "try again" anywhere — re-running a scan can't fix a
// stuck pipeline and burns the customer's daily cap.
export const SCAN_WAIT_COPY = {
  processing: "Your scan is complete and your results are being processed. Your dashboard will update in a few minutes.",
  held: "Your scan is complete. Someone on our team is reviewing the results before they go live — we'll follow up with you. Nothing more you need to do.",
  published: "Your results are live — open your dashboard to see them.",
  stalled: "This is taking longer than expected. Our team has been notified and is looking into it — we'll follow up with you. Nothing more you need to do.",
};

const DURABLE_ACTIVE_SCAN_STATES = new Set(["prerequisite", "assessment"]);
const DURABLE_ADJUDICATION_PHASES = new Set(["processing", "held", "published"]);

function normalizeDurablePrereqResult(value) {
  if (!value || typeof value !== "object" || Array.isArray(value)) return null;
  const issues = Array.isArray(value.issues)
    ? value.issues.filter(issue => issue && typeof issue === "object").map(issue => ({
      code: typeof issue.code === "string" ? issue.code : "",
      title: typeof issue.title === "string" ? issue.title : "",
      user_message: typeof issue.user_message === "string" ? issue.user_message : "",
      severity: typeof issue.severity === "string" ? issue.severity : "",
      remediation: Array.isArray(issue.remediation)
        ? issue.remediation.filter(step => step && typeof step === "object").map(step => ({
          Type: typeof step.Type === "string" ? step.Type : "",
          Label: typeof step.Label === "string" ? step.Label : "",
          Value: typeof step.Value === "string" ? step.Value : "",
        }))
        : [],
    }))
    : [];
  return {
    outcome: typeof value.outcome === "string" ? value.outcome : "",
    issues,
  };
}

// The durable route is a closed, customer-safe projection. Keep only the
// state-specific fields the card already renders; unknown response data
// never becomes component state or customer-visible content.
function normalizeCustomerScanState(value) {
  if (!value || typeof value !== "object" || Array.isArray(value)) return null;
  const state = value.state;
  if (state === "idle" || state === "blocked" || state === "not_evaluated" || state === "stalled" || state === "abandoned") {
    return { state };
  }
  if (state === "prerequisite") {
    return {
      state,
      runId: typeof value.run_id === "string" ? value.run_id : "",
      result: normalizeDurablePrereqResult(value.result),
    };
  }
  if (state === "assessment") {
    return {
      state,
      runId: typeof value.run_id === "string" ? value.run_id : "",
      engineState: typeof value.engine_state === "string" ? value.engine_state : "",
      stage: typeof value.stage === "string" ? value.stage : "",
    };
  }
  if (state === "adjudication") {
    const phase = DURABLE_ADJUDICATION_PHASES.has(value.phase) ? value.phase : "processing";
    return {
      state,
      runId: typeof value.run_id === "string" ? value.run_id : "",
      phase,
      stalled: value.stalled === true,
    };
  }
  if (state === "cap" && typeof value.next_available_utc === "string") {
    return { state, nextAvailableUtc: value.next_available_utc };
  }
  return null;
}

function isDurableJourneyActive(journey) {
  return !!journey && (DURABLE_ACTIVE_SCAN_STATES.has(journey.state)
    || (journey.state === "adjudication" && !journey.stalled && journey.phase === "processing"));
}

function isDurableJourneyStalled(journey) {
  return !!journey && (journey.state === "stalled"
    || (journey.state === "adjudication" && journey.stalled === true));
}

// One remediation step, rendered by Type per the engine contract:
// Link → anchor (new tab); CopyCommand → labeled code block with a copy
// button; anything else (including future types) → its label as text.
function ScanRemediationStep({ step }) {
  const [copied, setCopied] = useState(false);
  if (!step || typeof step !== "object") return null;
  const label = step.Label || step.Type || "Step";
  if (step.Type === "Link" && step.Value) {
    return (
      <div style={{ marginTop: 6 }}>
        <a href={step.Value} target="_blank" rel="noreferrer" style={{ color: T.blue, fontSize: 13 }}>
          {label} ↗
        </a>
      </div>
    );
  }
  if (step.Type === "CopyCommand" && step.Value) {
    const copy = () => {
      const done = () => { setCopied(true); setTimeout(() => setCopied(false), 2000); };
      if (navigator.clipboard?.writeText) {
        navigator.clipboard.writeText(step.Value).then(done).catch(() => {});
      }
    };
    return (
      <div style={{ marginTop: 8 }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 4 }}>
          <span style={{ fontSize: 12, color: T.muted }}>{label}</span>
          <button onClick={copy} style={{ border: `1px solid ${T.border}`, borderRadius: 6, padding: "3px 10px", background: "rgba(255,255,255,.05)", color: copied ? T.green : T.text, fontFamily: "inherit", fontSize: 11, cursor: "pointer" }}>
            {copied ? "Copied" : "Copy"}
          </button>
        </div>
        <pre style={{ margin: 0, padding: 10, borderRadius: 8, background: "rgba(0,0,0,.35)", border: `1px solid ${T.border}`, fontSize: 12, whiteSpace: "pre-wrap", wordBreak: "break-word", color: T.text }}>
          {step.Value}
        </pre>
      </div>
    );
  }
  return <div style={{ marginTop: 6, fontSize: 13, color: T.muted }}>{label}</div>;
}

const SCAN_ISSUE_SEVERITY_BADGE = { Error: "amber", Warning: "yellow" };

function ScanIssueRow({ issue }) {
  const steps = (issue.remediation || []).filter(Boolean);
  return (
    <div style={{ padding: "12px 0", borderTop: `1px solid ${T.border}` }}>
      <div style={{ display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap" }}>
        <span style={{ fontWeight: 700, fontSize: 13 }}>{issue.title || issue.code || "Setup issue"}</span>
        {issue.severity && (
          <Badge type={SCAN_ISSUE_SEVERITY_BADGE[issue.severity] || "slate"} weight="soft">
            {issue.severity}
          </Badge>
        )}
      </div>
      {issue.user_message && (
        <div style={{ fontSize: 13, color: T.muted, marginTop: 4 }}>{issue.user_message}</div>
      )}
      {steps.map((step, i) => <ScanRemediationStep key={i} step={step} />)}
    </div>
  );
}

export const CustomerScanCard = ({ slug, clientName, embedded = false, onProductAnalyticsAction }) => {
  const { user } = useUserContext();
  // Delivery-mode suppression REMOVED for this surface (operator
  // decision 2026-08-05): it dated from the internal-only preview, and a
  // customer call is precisely when Patriot walks someone through the
  // scan. Other presentation-mode suppressions are untouched.
  const show = !!(user?.isInternal || SHOW_SCAN_CARD_TO_CUSTOMERS);
  // Internal users opt into the backend's customer path; for customers
  // the flag is a server-side no-op, so sending it is always correct.
  const asCustomer = !!user?.isInternal;

  const seqRef = useRef(0);
  const [busy, setBusy] = useState("");         // "" | "check" | "precheck" | "scan"
  const [stage, setStage] = useState("");       // progress line while busy
  const [result, setResult] = useState(null);   // customer projection
  const [resultAge, setResultAge] = useState(null); // seconds, cached serves only
  const [error, setError] = useState("");
  const [setupMsg, setSetupMsg] = useState(""); // 409 scan_setup_incomplete, verbatim
  const [scanRun, setScanRun] = useState(null); // {runId, state, stage, startedMs}
  const [scanComplete, setScanComplete] = useState(false);
  // Post-completion adjudication phase: "processing" | "held" |
  // "published" | "stalled" — drives which SCAN_WAIT_COPY renders.
  const [scanPhase, setScanPhase] = useState("processing");
  const [scanFailed, setScanFailed] = useState("");
  const [capUntil, setCapUntil] = useState(""); // ISO instant Run scan re-enables
  // Run scan starts a real assessment against this customer's tenant and
  // consumes their 24h cap — visible to Patriot on EVERY customer's
  // profile, so a browsing misclick hits a live customer. Confirm first,
  // naming the customer. Check setup is read-only and stays one click.
  const [confirmScan, setConfirmScan] = useState(false);
  const [confirmTicket, setConfirmTicket] = useState(false);
  const [ticketBusy, setTicketBusy] = useState(false);
  const [ticketNotice, setTicketNotice] = useState("");
  // Migration gate: a legacy tenant cannot successfully run either
  // action, so the card renders visibly LOCKED (never hidden — the scan
  // is the incentive) until scan_tool_key flips to securescan365.
  // "loading" keeps the buttons inert without the lock message; a status
  // read failure fails OPEN (today's behavior) rather than blocking a
  // migrated customer on a transient error.
  const [migration, setMigration] = useState("loading"); // loading|locked|migrated
  // A card starts by proving whether the durable backend is present. Only
  // the initial 404/405 probe may select the legacy compatibility flow.
  const [durableMode, setDurableMode] = useState("probing");
  const [durableJourney, setDurableJourney] = useState(null);

  const applyDurableJourney = useCallback((journey, seq) => {
    if (seqRef.current !== seq) return;
    setDurableJourney(journey);
    setBusy(""); setStage(""); setResult(null); setResultAge(null);
    setError(""); setSetupMsg(""); setScanRun(null); setScanComplete(false);
    setScanFailed(""); setScanPhase("processing");
    if (journey.state === "prerequisite") {
      setBusy("check");
      setStage("Checking your environment… (this usually takes under two minutes)");
      setResult(journey.result);
    } else if (journey.state === "assessment") {
      setBusy("scan");
      setScanRun({
        runId: journey.runId,
        state: journey.engineState || "In progress",
        stage: journey.stage,
        startedMs: Date.now(),
      });
    } else if (journey.state === "adjudication") {
      setScanComplete(true);
      setScanPhase(journey.stalled ? "stalled" : journey.phase);
    } else if (journey.state === "cap") {
      setCapUntil(journey.nextAvailableUtc);
    } else if (journey.state === "blocked" || journey.state === "not_evaluated") {
      setScanFailed(journey.state);
    } else if (journey.state === "stalled") {
      setScanComplete(true);
      setScanPhase("stalled");
    }
  }, []);

  const rehydrateDurableJourney = useCallback(async (seq) => {
    try {
      const journey = normalizeCustomerScanState(
        await fetchCustomerScanState(slug, { asCustomer })
      );
      if (seqRef.current !== seq) return null;
      if (!journey) throw new Error("invalid durable scan state");
      const durableSeq = ++seqRef.current;
      setDurableMode("durable");
      applyDurableJourney(journey, durableSeq);
      return journey;
    } catch (_) {
      if (seqRef.current === seq) setDurableMode("unavailable");
      return null;
    }
  }, [applyDurableJourney, asCustomer, slug]);

  // Reset on customer switch; derive the cap display from the customer's
  // own runs (backend stays authoritative — it re-derives on every start).
  useEffect(() => {
    const seq = ++seqRef.current;
    setBusy(""); setStage(""); setResult(null); setResultAge(null);
    setError(""); setSetupMsg(""); setScanRun(null); setScanComplete(false);
    setScanFailed(""); setScanPhase("processing"); setCapUntil(""); setTicketNotice(""); setConfirmTicket(false);
    setConfirmScan(false);
    setMigration("loading");
    setDurableMode("probing");
    setDurableJourney(null);
    if (!show || !slug) return undefined;
    let cancelled = false;
    fetchUpgradeStatus(slug)
      .then(data => {
        if (cancelled || seqRef.current !== seq) return;
        setMigration(
          data?.scan_tool_key === "securescan365" ? "migrated" : "locked"
        );
      })
      .catch(() => { if (!cancelled && seqRef.current === seq) setMigration("migrated"); });
    fetchCustomerScanState(slug, { asCustomer })
      .then(raw => {
        if (cancelled || seqRef.current !== seq) return;
        const journey = normalizeCustomerScanState(raw);
        if (!journey) { setDurableMode("unavailable"); return; }
        setDurableMode("durable");
        applyDurableJourney(journey, seq);
      })
      .catch(error => {
        if (cancelled || seqRef.current !== seq) return;
        if (error?.status === 404 || error?.status === 405) {
          setDurableMode("legacy");
        } else {
          setDurableMode("unavailable");
        }
      });
    return () => { cancelled = true; };
  }, [applyDurableJourney, asCustomer, show, slug]);

  // The display-only cap read remains available for both backend generations.
  // Server-side admission remains authoritative; this list never decides
  // workflow state.
  useEffect(() => {
    if (!show || !slug || (durableMode !== "durable" && durableMode !== "legacy")) return undefined;
    let cancelled = false;
    fetchCustomerScanRuns({ slug, asCustomer })
      .then(page => {
        if (cancelled) return;
        const latest = latestCompletedAssessmentUtc(page?.runs);
        if (latest) {
          const nextMs = Date.parse(latest) + SCAN_CAP_MS;
          if (nextMs > Date.now()) setCapUntil(new Date(nextMs).toISOString());
        }
      })
      .catch(() => { /* display-only; the backend enforces the cap */ });
    return () => { cancelled = true; };
  }, [asCustomer, durableMode, show, slug]);

  // Poll the durable projection only while the server describes an active
  // journey. A later route failure is never a fallback signal.
  useEffect(() => {
    if (durableMode !== "durable" || !isDurableJourneyActive(durableJourney)) return undefined;
    const seq = ++seqRef.current;
    let cancelled = false;
    let timer;
    let ticks = 0;
    const config = durableJourney.state === "prerequisite"
      ? { intervalMs: SCAN_CARD_PREREQ_POLL_MS, maxTicks: SCAN_CARD_PREREQ_MAX_TICKS }
      : durableJourney.state === "assessment"
        ? { intervalMs: SCAN_CARD_SCAN_POLL_MS, maxTicks: SCAN_CARD_SCAN_MAX_TICKS }
        : { intervalMs: SCAN_CARD_ADJUDICATION_POLL_MS, maxTicks: SCAN_CARD_ADJUDICATION_MAX_TICKS };
    const poll = () => {
      fetchCustomerScanState(slug, { asCustomer })
        .then(raw => {
          if (cancelled || seqRef.current !== seq) return;
          const journey = normalizeCustomerScanState(raw);
          if (!journey) {
            setDurableMode("unavailable");
            applyDurableJourney({ state: "stalled" }, seq);
            return;
          }
          applyDurableJourney(journey, seq);
          if (!isDurableJourneyActive(journey)) return;
          ticks += 1;
          if (ticks >= config.maxTicks) {
            applyDurableJourney({ state: "stalled" }, seq);
            return;
          }
          timer = setTimeout(poll, config.intervalMs);
        })
        .catch(() => {
          if (cancelled || seqRef.current !== seq) return;
          setDurableMode("unavailable");
          applyDurableJourney({ state: "stalled" }, seq);
        });
    };
    timer = setTimeout(poll, config.intervalMs);
    return () => { cancelled = true; clearTimeout(timer); };
  }, [applyDurableJourney, asCustomer, durableJourney?.phase, durableJourney?.stalled, durableJourney?.state, durableMode, slug]);

  // Orphan any in-flight poll on unmount (admin-tab idiom).
  useEffect(() => () => { seqRef.current += 1; }, []);

  if (!show) return null;

  const customerLabel = clientName || slug;
  const capped = !!capUntil && Date.parse(capUntil) > Date.now();

  // Poll one run's status to a terminal state. Resolves the final status
  // payload; rejects on budget exhaustion OR on a DETERMINISTIC failure.
  //
  // ADR-0085: a persistent identical HTTP failure is not transient — the
  // customer-principal ownership 404 repeated 40 times is what wore a
  // timeout costume through two investigations. After
  // POLL_DETERMINISTIC_LIMIT consecutive failures with the SAME status
  // code, stop early and reject with a deterministic marker. The count
  // resets on any success. e.status now rides the error (api.js) so this
  // can branch on it; the CALLER's copy stays status-code-blind so it
  // discloses nothing a foreign caller could use.
  const pollRunStatus = (runId, seq, { terminalStates, intervalMs, maxTicks, onTick }) =>
    new Promise((resolve, reject) => {
      let sameFailStatus = null;
      let sameFailCount = 0;
      const tick = (ticks) => {
        if (seqRef.current !== seq) return; // superseded — abandon silently
        fetchScanStatus(runId)
          .then(s => {
            if (seqRef.current !== seq) return;
            sameFailStatus = null; sameFailCount = 0; // any success resets
            if (onTick) onTick(s);
            const state = s?.state || "";
            if (terminalStates.has(state)) { resolve(s); return; }
            if (ticks >= maxTicks) { reject(new Error("poll budget exhausted")); return; }
            setTimeout(() => tick(ticks + 1), intervalMs);
          })
          .catch(e => {
            if (seqRef.current !== seq) return;
            const status = e?.status ?? null;
            if (status !== null && status === sameFailStatus) {
              sameFailCount += 1;
            } else {
              sameFailStatus = status; sameFailCount = 1;
            }
            if (status !== null && sameFailCount >= POLL_DETERMINISTIC_LIMIT) {
              const det = new Error("poll failed deterministically");
              det.deterministic = true; det.status = status;
              reject(det);
              return;
            }
            if (ticks >= maxTicks) { reject(e); return; }
            setTimeout(() => tick(ticks + 1), intervalMs);
          });
      };
      tick(0);
    });

  // Run the setup check and render its projection. Returns the projection
  // when one was obtained, else null (the blocking state is already on
  // screen). Shared by both buttons — "Run scan" gates on its outcome.
  const runSetupCheck = async (seq) => {
    setError(""); setSetupMsg(""); setResult(null); setResultAge(null);
    setScanComplete(false); setScanFailed(""); setScanPhase("processing");
    let ack;
    try {
      ack = await startCustomerPrereqCheck(slug, { asCustomer });
    } catch (e) {
      if (seqRef.current !== seq) return null;
      const body = e?.body || {};
      if (e.status === 409 && body.error === "prereq_in_flight" && body.runId) {
        ack = { runId: body.runId, queued: true }; // attach, don't error
      } else if (e.status === 409 && body.error === "scan_continuation_active") {
        // A rolling frontend can reach a new durable backend through the
        // old diagnostic start. One state read rehydrates it; no second
        // legacy start and no fallback may follow this conflict.
        await rehydrateDurableJourney(seq);
        return null;
      } else if (e.status === 409 && body.error === "scan_setup_incomplete") {
        setSetupMsg(body.message || ""); // render verbatim — no invented copy
        return null;
      } else {
        setError(`We couldn't start the setup check. Please try again.${body.error ? ` (${body.error})` : ""}`);
        return null;
      }
    }
    if (seqRef.current !== seq) return null;
    if (ack?.cached) {
      // Backend served its short completed-result cache: the ack IS the
      // projection, with an age indicator instead of a re-run.
      setResult(ack);
      setResultAge(Number.isFinite(ack.age_seconds) ? ack.age_seconds : null);
      return ack;
    }
    const runId = resolvePrereqAckRunId(ack);
    if (!runId) {
      setError("The check was accepted but returned no run reference — please try again.");
      return null;
    }
    setStage("Checking your environment… (this usually takes under two minutes)");
    try {
      await pollRunStatus(runId, seq, {
        terminalStates: PREREQ_TERMINAL_STATES,
        intervalMs: SCAN_CARD_PREREQ_POLL_MS,
        maxTicks: SCAN_CARD_PREREQ_MAX_TICKS,
      });
    } catch (e) {
      if (seqRef.current === seq) {
        // Status-code-blind copy (ADR-0085): identical for a deterministic
        // ownership 404 and a genuine slow run, so it discloses nothing a
        // foreign caller could use. NEVER "please try again" — we still
        // hold runId, and that instruction is what launched the duplicate
        // run in #513; the check keeps running at the engine.
        setError(e?.deterministic
          ? "We can't read this check's progress right now — our team has been notified. Your setup check is still running; check back shortly."
          : "Your setup check is still running — it's taking longer than usual. Check back shortly; you don't need to start it again.");
      }
      return null;
    }
    if (seqRef.current !== seq) return null;
    setStage("Reading the results…");
    try {
      const projection = await fetchCustomerPrereqResult(runId, { asCustomer });
      if (seqRef.current !== seq) return null;
      setResult(projection);
      return projection;
    } catch (e) {
      if (seqRef.current === seq) setError("We couldn't read the check results. Please try again.");
      return null;
    }
  };

  const onCheckSetup = async () => {
    if (busy || durableMode === "probing" || durableMode === "unavailable"
        || isDurableJourneyActive(durableJourney)
        || isDurableJourneyStalled(durableJourney)) return;
    const seq = ++seqRef.current;
    setBusy("check");
    setStage("Starting the setup check…");
    await runSetupCheck(seq);
    if (seqRef.current === seq) { setBusy(""); setStage(""); }
  };

  const onRunScan = async () => {
    if (busy || capped || durableMode === "probing" || durableMode === "unavailable"
        || isDurableJourneyActive(durableJourney)
        || isDurableJourneyStalled(durableJourney)) return;
    const seq = ++seqRef.current;
    if (durableMode === "durable") {
      setBusy("scan");
      setStage("Starting your scan…");
      try {
        const journey = normalizeCustomerScanState(
          await requestCustomerScan(slug, { asCustomer })
        );
        if (seqRef.current !== seq) return;
        if (!journey) throw new Error("invalid durable scan response");
        applyDurableJourney(journey, seq);
      } catch (_) {
        if (seqRef.current === seq) {
          setBusy("");
          setStage("");
          setDurableMode("unavailable");
        }
      }
      return;
    }
    if (durableMode !== "legacy") return;
    // Prereq FIRST; the scan starts only on a ready outcome. Anything
    // else leaves the same result panel Check setup produces.
    setBusy("precheck");
    // No stage line here: the button label ("Confirming setup…") covers
    // the round trip, and a cached prereq result (backend 180s window)
    // returns in one hop — flashing "Confirming your environment…" for
    // that reads as re-doing a check that isn't being re-done. A real
    // re-check sets its own stage when polling starts inside
    // runSetupCheck.
    const projection = await runSetupCheck(seq);
    if (seqRef.current !== seq) return;
    if (!projection || projection.outcome !== "ready") {
      setBusy(""); setStage("");
      return;
    }
    setBusy("scan");
    setStage("Starting your scan…");
    let started;
    try {
      started = await startCustomerScan(slug, { asCustomer });
    } catch (e) {
      if (seqRef.current !== seq) return;
      const body = e?.body || {};
      if (e.status === 409 && body.error === "scan_in_flight"
          && body.kind === "scan" && body.run_id) {
        started = { run_id: body.run_id }; // attach to the in-flight scan
      } else if (e.status === 409 && body.error === "scan_continuation_active") {
        await rehydrateDurableJourney(seq);
        if (seqRef.current === seq) { setBusy(""); setStage(""); }
        return;
      } else if (e.status === 429 && body.error === "scan_daily_cap") {
        if (body.next_available_utc) setCapUntil(body.next_available_utc);
        setBusy(""); setStage("");
        return;
      } else if (e.status === 409 && body.error === "scan_setup_incomplete") {
        setSetupMsg(body.message || "");
        setBusy(""); setStage("");
        return;
      } else {
        setError(`We couldn't start the scan. Please try again.${body.error ? ` (${body.error})` : ""}`);
        setBusy(""); setStage("");
        return;
      }
    }
    if (seqRef.current !== seq) return;
    const runId = started?.run_id;
    if (!runId) {
      setError("The scan was accepted but returned no run reference — check back shortly.");
      setBusy(""); setStage("");
      return;
    }
    setStage("");
    setScanRun({ runId, state: "Queued", stage: "", startedMs: Date.now() });
    try {
      const final = await pollRunStatus(runId, seq, {
        terminalStates: SCAN_TERMINAL_STATES,
        intervalMs: SCAN_CARD_SCAN_POLL_MS,
        maxTicks: SCAN_CARD_SCAN_MAX_TICKS,
        onTick: (s) => setScanRun(prev => prev && ({
          ...prev, state: s?.state || prev.state, stage: s?.stage || "",
        })),
      });
      if (seqRef.current !== seq) return;
      if ((final?.state || "") === "Completed") {
        setScanComplete(true);
        setScanPhase("processing");
        // Display-only: the just-completed scan starts a new 24h window.
        setCapUntil(new Date(Date.now() + SCAN_CAP_MS).toISOString());
        // Adjudication poll: swap the wait copy to the truth as it
        // resolves (held / published), or give up honestly (stalled).
        pollAdjudication(runId, seq, 0);
      } else {
        setScanFailed(final?.state || "not completed");
      }
    } catch (e) {
      if (seqRef.current === seq) {
        setScanFailed("still running");
        setError("The scan is taking longer than expected. It continues in the background — check back later.");
      }
    }
    if (seqRef.current === seq) { setBusy(""); setScanRun(null); }
  };

  // Post-completion adjudication poll (seq-guarded like every poll on
  // this card). Terminal outcomes: "held" and "published" stop the poll
  // with the truth; a server-side stalled flag OR local budget
  // exhaustion stops it with the honest give-up copy — the card must
  // never sit on "a few minutes" forever. Transient fetch errors retry
  // inside the same budget. The backend logs SCAN_ADJUDICATION_STALLED
  // server-side, so a stuck run surfaces to Patriot even if this tab
  // closes.
  const pollAdjudication = (runId, seq, ticks) => {
    if (seqRef.current !== seq) return;
    const next = () => {
      if (ticks >= SCAN_CARD_ADJUDICATION_MAX_TICKS) { setScanPhase("stalled"); return; }
      setTimeout(() => pollAdjudication(runId, seq, ticks + 1), SCAN_CARD_ADJUDICATION_POLL_MS);
    };
    fetchScanAdjudication(runId)
      .then(a => {
        if (seqRef.current !== seq) return;
        const phase = a?.phase || "";
        if (phase === "held" || phase === "published") { setScanPhase(phase); return; }
        if (a?.stalled) { setScanPhase("stalled"); return; }
        next();
      })
      .catch(() => {
        if (seqRef.current !== seq) return;
        next();
      });
  };

  const fileSupportTicket = async () => {
    if (ticketBusy) return;
    setTicketBusy(true);
    setTicketNotice("");
    const codes = (result?.issues || []).filter(Boolean)
      .map(i => i.code).filter(Boolean).join(", ");
    const body = `
<h3>SecureScan365 scan — help requested from the Security Scan card</h3>
<table>
  <tr><td><b>Requested by:</b></td><td>${escapeHtmlLocal(user?.email || "")}</td></tr>
  ${codes ? `<tr><td><b>Setup check issue codes:</b></td><td>${escapeHtmlLocal(codes)}</td></tr>` : ""}
</table>
<hr>
<p><i>Submitted via the SecureShield365 Company Profile</i></p>`;
    try {
      await createTicket({
        client_id: slug,
        requester_email: user?.email || "",
        subject: "SecureScan365 scan — help requested",
        description: body,
        patriot_service: "Portal Support",
        priority: 2,
      });
      setTicketNotice("Support request submitted — we'll be in touch.");
    } catch (_) {
      setTicketNotice("We couldn't create the ticket. Please try again.");
    }
    setTicketBusy(false);
    setConfirmTicket(false);
  };

  const renderResultPanel = () => {
    if (!result) return null;
    const issues = (result.issues || []).filter(Boolean);
    const outcome = result.outcome || "";
    const ageLine = resultAge != null
      ? `Showing your check from ${Math.max(1, Math.round(resultAge / 60))} minute(s) ago — results this fresh don't need a re-run.`
      : "";
    if (outcome === "ready") {
      return (
        <div style={{ marginTop: 14, padding: 12, borderRadius: 10, background: "rgba(83,196,109,.10)", border: "1px solid rgba(83,196,109,.35)" }}>
          <div style={{ color: T.green, fontWeight: 700, fontSize: 13 }}>Your environment is ready to scan.</div>
          {ageLine && <div style={{ color: T.muted, fontSize: 12, marginTop: 4 }}>{ageLine}</div>}
        </div>
      );
    }
    const blocked = outcome === "blocked";
    return (
      <div style={{ marginTop: 14, padding: 12, borderRadius: 10, background: blocked ? "rgba(243,181,63,.08)" : "rgba(148,163,184,.08)", border: `1px solid ${blocked ? "rgba(243,181,63,.35)" : "rgba(148,163,184,.3)"}` }}>
        <div style={{ fontWeight: 700, fontSize: 13, color: blocked ? T.yellow : T.muted }}>
          {blocked
            ? "A few things need attention before a scan can run."
            : "We couldn't complete the check."}
        </div>
        {ageLine && <div style={{ color: T.muted, fontSize: 12, marginTop: 4 }}>{ageLine}</div>}
        {issues.length > 0 && (
          <div style={{ marginTop: 6 }}>
            {issues.map((issue, i) => <ScanIssueRow key={issue.code || i} issue={issue} />)}
          </div>
        )}
        <div style={{ marginTop: 12 }}>
          <Btn onClick={() => setConfirmTicket(true)} disabled={ticketBusy}>Contact support</Btn>
        </div>
      </div>
    );
  };

  const scanElapsedMin = scanRun ? Math.floor((Date.now() - scanRun.startedMs) / 60000) : 0;

  const locked = migration === "locked";
  const actionsInert = locked || migration === "loading" || durableMode === "probing"
    || durableMode === "unavailable" || isDurableJourneyActive(durableJourney)
    || isDurableJourneyStalled(durableJourney);

  const scanContent = (
    <div data-testid="customer-scan-panel">
      {/* Internal-preview banner removed 2026-08-05 with the customer
          launch — no preview strings render on this surface anymore. */}
      {/* Intro leads with the scan (2026-08-02 UX decision): the old "…or
          check that everything is set up first" read as a required first
          step, but Run scan already prechecks automatically. */}
      <p style={{ fontSize: 13, color: T.muted, margin: "0 0 12px" }}>
        Run a read-only security scan of your Microsoft 365 environment.
        Scans are limited to one per day.
      </p>

      {/* Same locked idiom as the wizard's E10/N12 cleanup step — the
          two locked states must read as the same idea. Visible on
          purpose: the scan is the incentive for finishing the setup. */}
      {locked && (
        <div style={{ marginBottom: 12, padding: "10px 12px", borderRadius: 10, background: "rgba(148,163,184,.10)", border: `1px solid ${T.border}`, color: T.muted, fontSize: 13 }}>
          🔒 Scanning becomes available after your first SecureScan365
          assessment completes. Completing the setup steps above is what
          gets you there.
        </div>
      )}

      {!locked && capped && (
        <div style={{ marginBottom: 12, padding: 10, borderRadius: 10, background: "rgba(68,166,255,.08)", border: "1px solid rgba(68,166,255,.3)", color: T.muted, fontSize: 13 }}>
          A scan completed recently. Your next scan is available{" "}
          <b style={{ color: T.text }}>
            {fmtInstant(capUntil, { month: "short", day: "numeric", hour: "numeric", minute: "2-digit" })}
          </b>{" "}
          (your local time). Check setup any time.
        </div>
      )}

      {/* Run scan is THE action; Check setup is a deliberately quiet
          link-style secondary — two equal buttons read as sequential
          steps, and the precheck inside Run scan makes the separate
          button optional (onboarding loop only). */}
      <div style={{ display: "flex", flexWrap: "wrap", gap: 10, alignItems: "center", opacity: locked ? .55 : 1 }}>
        <Btn pri onClick={() => { if (!actionsInert) setConfirmScan(true); }} disabled={actionsInert || !!busy || capped}>
          {busy === "precheck" ? "Confirming setup…" : busy === "scan" ? "Scanning…" : "Run scan"}
        </Btn>
        <Btn onClick={() => { if (!actionsInert) onCheckSetup(); }} disabled={actionsInert || !!busy} style={{ background: "transparent", border: "none", color: T.muted, textDecoration: "underline", padding: "8px 6px", cursor: actionsInert ? "not-allowed" : undefined }}>
          {busy === "check" ? "Checking…" : "Check setup"}
        </Btn>
      </div>
      <p style={{ fontSize: 12, color: T.muted, margin: "8px 0 0", maxWidth: 560, lineHeight: 1.5 }}>
        Run scan checks your setup automatically. Use Check setup on its own
        if you're still granting access and want to test without using your
        daily scan.
      </p>

      {busy && stage && (
        <div style={{ marginTop: 10, fontSize: 13, color: T.muted }}>{stage}</div>
      )}
      {error && <div style={{ marginTop: 10, fontSize: 13, color: T.red }}>{error}</div>}

      {setupMsg && (
        <div style={{ marginTop: 14, padding: 12, borderRadius: 10, background: "rgba(148,163,184,.08)", border: "1px solid rgba(148,163,184,.3)" }}>
          <div style={{ fontSize: 13, color: T.text }}>{setupMsg}</div>
          <div style={{ marginTop: 10 }}>
            <Btn onClick={() => setConfirmTicket(true)} disabled={ticketBusy}>Contact support</Btn>
          </div>
        </div>
      )}

      {renderResultPanel()}

      {scanRun && (
        <div style={{ marginTop: 14, padding: 12, borderRadius: 10, background: "rgba(68,166,255,.08)", border: "1px solid rgba(68,166,255,.3)" }}>
          <div style={{ fontSize: 13, fontWeight: 700, color: T.blue }}>
            Scan in progress — {scanRun.state}{scanRun.stage ? ` · ${scanRun.stage}` : ""}
          </div>
          <div style={{ fontSize: 12, color: T.muted, marginTop: 4 }}>
            {scanElapsedMin < 1 ? "Just started" : `Running for ${scanElapsedMin} min`} — a scan
            typically takes several minutes. You can leave this page; the scan continues on its own.
          </div>
        </div>
      )}

      {scanComplete && (() => {
        // Wait-state panel: color tracks the phase — green while things
        // are fine (processing/published), blue for a human-review hold,
        // amber for the honest give-up (with a support path, never a
        // "try again" — a re-run can't fix a stuck pipeline and burns
        // the daily cap).
        const stalled = scanPhase === "stalled";
        const held = scanPhase === "held";
        const tone = stalled
          ? { bg: "rgba(243,181,63,.08)", border: "rgba(243,181,63,.35)", color: T.yellow }
          : held
            ? { bg: "rgba(68,166,255,.08)", border: "rgba(68,166,255,.3)", color: T.blue }
            : { bg: "rgba(83,196,109,.10)", border: "rgba(83,196,109,.35)", color: T.green };
        return (
          <div style={{ marginTop: 14, padding: 12, borderRadius: 10, background: tone.bg, border: `1px solid ${tone.border}` }}>
            <div style={{ color: tone.color, fontWeight: 700, fontSize: 13 }}>
              {SCAN_WAIT_COPY[scanPhase] || SCAN_WAIT_COPY.processing}
            </div>
            {stalled && (
              <div style={{ marginTop: 10 }}>
                <Btn onClick={() => setConfirmTicket(true)} disabled={ticketBusy}>Contact support</Btn>
              </div>
            )}
          </div>
        );
      })()}

      {scanFailed && !scanComplete && (
        <div style={{ marginTop: 14, padding: 12, borderRadius: 10, background: "rgba(225,77,87,.08)", border: "1px solid rgba(225,77,87,.3)" }}>
          <div style={{ fontSize: 13, color: T.red, fontWeight: 700 }}>The scan didn't complete ({scanFailed}).</div>
          <div style={{ marginTop: 10 }}>
            <Btn onClick={() => setConfirmTicket(true)} disabled={ticketBusy}>Contact support</Btn>
          </div>
        </div>
      )}

      {durableJourney?.state === "abandoned" && (
        <div style={{ marginTop: 14, padding: 12, borderRadius: 10, background: "rgba(68,166,255,.08)", border: "1px solid rgba(68,166,255,.3)", color: T.text, fontSize: 13 }}>
          This request was closed by Patriot. You can request a new scan.
        </div>
      )}

      {ticketNotice && <div style={{ marginTop: 10, fontSize: 12, color: T.muted }}>{ticketNotice}</div>}

      <Modal
        show={confirmScan}
        title="Start a security scan?"
        onClose={() => setConfirmScan(false)}
        onSubmit={() => { observeProductAnalytics(onProductAnalyticsAction, "scan_requested"); setConfirmScan(false); onRunScan(); }}
        submitLabel="Start scan"
      >
        This will run a real security scan of{" "}
        <b style={{ color: T.text }}>{customerLabel}</b>&apos;s Microsoft 365
        environment. Scans are limited to one every 24 hours.
      </Modal>

      <TicketConfirmModal
        show={confirmTicket}
        customerLabel={customerLabel}
        busy={ticketBusy}
        onConfirm={fileSupportTicket}
        onClose={() => { if (!ticketBusy) setConfirmTicket(false); }}
      />
    </div>
  );

  if (embedded) {
    return (
      <div>
        <div style={{ fontSize:11, color:T.blue, fontWeight:800, textTransform:"uppercase", letterSpacing:".04em", marginBottom:8 }}>
          SecureScan365 scan
        </div>
        {scanContent}
      </div>
    );
  }

  return (
    <Card title="SecureScan365" style={{ marginTop: 16 }}>
      {scanContent}
    </Card>
  );
};

// ── Company Profile page — Portal Access roster + account placeholders ──
// Customer-visible. Any portal user at the customer can view the roster and
// request access for a teammate; rows are created Pending and reviewed by
// Patriot (approval transitions happen outside the portal, so this page only
// ever reads the list and creates requests).
const ACCESS_STATUS_BADGE = {
  "Active":            "green",
  "Pending":           "yellow",
  "Removal Requested": "amber",
  "Removed":           "slate",
  "Rejected":          "slate",
};

// Same tones keyed by the lifecycle endpoint's stable status_key (label
// strings can drift with Dataverse display-name edits; the key can't).
// Tones mirror ACCESS_STATUS_BADGE — the soft palette has no red, so
// rejected keeps the house slate rather than inventing a Badge type.
const ACCESS_LIFECYCLE_BADGE = {
  active:            "green",
  pending:           "yellow",
  removal_requested: "amber",
  removed:           "slate",
  rejected:          "slate",
};

// Scan-method pill for the upgrade-section header: which collection
// technology this customer's assessments run on today.
function scanToolLabel(scanToolKey) {
  if (scanToolKey === "securescan365") return "SecureScan365";
  if (scanToolKey === "legacy-auditor") return "Legacy - Auditor";
  if (scanToolKey === "legacy") return "Legacy";
  return "Unclassified";
}

/* THE ONE STATEMENT of the scan-method pill: which Badge each scan tool
 * wears, and what it says.
 *
 * Extracted from ScanMethodPill's if-chain on 2026-08-13 for the same reason
 * READINESS_TONE_COLOR was: the Scheduling filter chips need a dot in the
 * pill's colour and a word matching the pill's word, and a second copy of
 * either would drift. ScanMethodPill below renders from this table and adds
 * nothing of its own, so the chip and the cell cannot disagree.
 *
 * Legacy - Auditor is the SAME FAMILY as Legacy, one member along: both are
 * the old collection route, and the distinction is which side runs it. Same
 * amber, DEFAULT weight against Legacy's soft — two intensities of one
 * colour read as same-family-different-member, which is exactly the
 * relationship. A third colour would read as a third category.
 *
 * `compact` shortens ONLY the legacy labels, for dense admin tables where
 * "Legacy — being deprecated" is wider than the column needs. The default is
 * unchanged so the Company Profile upgrade section keeps the full wording,
 * which is doing persuasive work there that "Legacy" would not. */
const SCAN_METHOD_BADGE = {
  securescan365:    { type: "green", weight: "heavy", label: "SecureScan365" },
  "legacy-auditor": { type: "amber", weight: "heavy", label: "Legacy - Auditor",
                      long: "Legacy - Auditor — being deprecated" },
  legacy:           { type: "amber", weight: "soft",  label: "Legacy",
                      long: "Legacy — being deprecated" },
  // The blank scan_tool_key. A real population, not an absence — it is the
  // migration worklist, and reviewOps normalises it to the same key.
  [SCAN_METHOD_CHIP_UNCLASSIFIED]:
                    { type: "slate", weight: "soft",  label: "Unclassified" },
};

/** The badge spec for a scan tool key, blank included. */
function scanMethodBadge(scanToolKey) {
  return SCAN_METHOD_BADGE[scanToolKey || SCAN_METHOD_CHIP_UNCLASSIFIED]
    || SCAN_METHOD_BADGE[SCAN_METHOD_CHIP_UNCLASSIFIED];
}

function ScanMethodPill({ scanToolKey, compact = false }) {
  const b = scanMethodBadge(scanToolKey);
  return (
    <Badge type={b.type} weight={b.weight}>
      {compact ? b.label : (b.long || b.label)}
    </Badge>
  );
}

// The value story (VALUE_COPY, approved verbatim): what SecureScan365
// removes, what it gives today, and what's coming. "Coming soon" is
// visually distinct from current capability — muted, with a not-yet
// badge — so it can never read as available today.
function UpgradeValueBlock({ showComingSoon = true }) {
  const groupTitle = { fontSize: 12, fontWeight: 700, textTransform: "uppercase", letterSpacing: ".04em", marginBottom: 8 };
  const list = { margin: 0, paddingLeft: 18, display: "grid", gap: 5, fontSize: 13 };
  return (
    <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))", gap: 16, margin: "14px 0 4px" }}>
      <div>
        <div style={{ ...groupTitle, color: T.text }}>{VALUE_COPY.removes.title}</div>
        <ul style={{ ...list, color: T.muted }}>
          {VALUE_COPY.removes.items.map(item => <li key={item}>{item}</li>)}
        </ul>
      </div>
      <div>
        <div style={{ ...groupTitle, color: T.green }}>{VALUE_COPY.today.title}</div>
        <ul style={{ ...list, color: T.text }}>
          {VALUE_COPY.today.items.map(item => <li key={item}>{item}</li>)}
        </ul>
      </div>
      {/* "Coming soon to SecureScan365" renders on the LEGACY branch
          only — pitching futures to a migrated customer reads wrong. */}
      {showComingSoon && (
        <div style={{ opacity: .75 }}>
          <div style={{ ...groupTitle, color: T.muted, display: "flex", alignItems: "center", gap: 8 }}>
            {VALUE_COPY.comingSoon.title}
            <Badge type="slate" weight="soft">Not yet available</Badge>
          </div>
          <ul style={{ ...list, color: T.muted }}>
            {VALUE_COPY.comingSoon.items.map(item => <li key={item}>{item}</li>)}
          </ul>
          <div style={{ fontSize: 12, color: T.muted, fontStyle: "italic", marginTop: 8 }}>
            {VALUE_COPY.comingSoon.note}
          </div>
        </div>
      )}
    </div>
  );
}

function firstAllowedWizardStepIndex(pathKey, checklist = {}) {
  const steps = pathSteps(pathKey);
  if (!steps.length) return 0;
  const firstPending = steps.findIndex(
    key => !["done", "skipped"].includes(checklist?.[key])
  );
  return firstPending === -1 ? steps.length - 1 : firstPending;
}

// Copy-to-clipboard block for wizard step values (the Connect-MgGraph
// command, the Key Vault AAGUID). The value stays visible as text — the
// button is an addition, not a replacement — and the whole control is a
// graceful no-op when the clipboard API is unavailable.
function WizardCopyBlock({ label, value }) {
  const [copied, setCopied] = useState(false);
  const copy = () => {
    if (!navigator.clipboard?.writeText) return;
    navigator.clipboard.writeText(value).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }).catch(() => {});
  };
  return (
    <div style={{ margin: "4px 0 12px" }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 8, marginBottom: 4 }}>
        <span style={{ fontSize: 12, color: T.muted }}>{label}</span>
        <button onClick={copy} style={{ border: `1px solid ${T.border}`, borderRadius: 6, padding: "3px 10px", background: "rgba(255,255,255,.05)", color: copied ? T.green : T.text, fontFamily: "inherit", fontSize: 11, cursor: "pointer" }}>
          {copied ? "Copied" : "Copy"}
        </button>
      </div>
      <pre style={{ margin: 0, padding: 10, borderRadius: 8, background: "rgba(0,0,0,.35)", border: `1px solid ${T.border}`, fontSize: 12, whiteSpace: "pre-wrap", wordBreak: "break-word", color: T.text }}>
        {value}
      </pre>
    </div>
  );
}

export function UpgradeSection({
  slug,
  clientName = "",
  onboardingBookingUrl = ONBOARDING_ASSISTANCE_BOOKING_URL,
  onboardingBookingUrls = null,
}) {
  const { user } = useUserContext();
  // Delivery-mode suppression REMOVED for this surface (operator
  // decision 2026-08-05). The old #373-style non-render dated from the
  // internal-only, unreviewed preview; post-#453 the walkthrough is
  // customer-live and reviewed, and a customer call is precisely when
  // Patriot walks someone through the migration. Other presentation-mode
  // suppressions (archive-scan controls, Admin/Azure nav) are untouched.
  const showUpgrade = !!(user?.isInternal || SHOW_UPGRADE_TO_CUSTOMERS);
  const storageKey = `ss_upgrade_wizard_${slug}`;
  const uiStorageKey = `ss_upgrade_wizard_ui_${slug}`;
  const [upgradeStatus, setUpgradeStatus] = useState(undefined); // undefined=loading; null=hidden/error
  const [mode, setMode] = useState("entry");
  const [stepIndex, setStepIndex] = useState(0);
  // Which account path the customer chose at Step 0 — null until chosen.
  // Persisted with progress so a returning customer is not asked again.
  const [path, setPath] = useState(null);
  const [pathDraft, setPathDraft] = useState(null); // chooser selection pre-confirm
  const [designatedUpn, setDesignatedUpn] = useState("");
  const [upnUnsure, setUpnUnsure] = useState(false);
  const [checklist, setChecklist] = useState({});
  const [schedulePreference, setSchedulePreference] = useState("");
  // Completion booking satisfied for this path (persisted with progress).
  // Old customer-live `completionFiled: true` records mean a support ticket was
  // filed before this PR, not that Calendly booked a meeting. Only the new
  // versioned key below may suppress the onboarding booking CTA.
  const [completionBooked, setCompletionBooked] = useState(false);
  const [referencePanel, setReferencePanel] = useState(null); // null|"faq"|"troubleshooting"|"roles"
  const [entryFaqOpen, setEntryFaqOpen] = useState(false);
  const [collapsed, setCollapsed] = useState(true);
  const [uiHydrated, setUiHydrated] = useState(false);
  const [showStartOver, setShowStartOver] = useState(false);
  const [hintOpen, setHintOpen] = useState(false);
  // ONE help entry point. It now starts with a choice: support ticket or
  // booking assistance. The support form remains the ticket confirmation
  // step and names the customer inline.
  const [helpChoiceOpen, setHelpChoiceOpen] = useState(false);
  const [helpOpen, setHelpOpen] = useState(false);
  const [helpReason, setHelpReason] = useState(null);
  const [helpText, setHelpText] = useState("");
  const [ticketState, setTicketState] = useState(null); // null | loading | error
  const [ticketAction, setTicketAction] = useState(null);
  const [ticketNotice, setTicketNotice] = useState(null);
  // "completion" records only that a setup meeting was booked; the first
  // successful SecureScan365 scan remains the real completion signal.
  // "help" books the same meeting without altering progress at all.
  const [onboardingSchedulingOrigin, setOnboardingSchedulingOrigin] = useState(null);
  // Same per-open Calendly remount contract as Recommendations Review above.
  const [onboardingSchedulingSession, setOnboardingSchedulingSession] = useState(0);
  const [onboardingBookingSubmitted, setOnboardingBookingSubmitted] = useState(false);
  const [trackedOnboardingBookingUrl, setTrackedOnboardingBookingUrl] = useState("");
  const [trackedOnboardingRequestState, setTrackedOnboardingRequestState] = useState(null);

  useEffect(() => {
    setMode("entry");
    setStepIndex(0);
    setPath(null);
    setPathDraft(null);
    setDesignatedUpn("");
    setUpnUnsure(false);
    setChecklist({});
    setSchedulePreference("");
    setCompletionBooked(false);
    setReferencePanel(null);
    setEntryFaqOpen(false);
    setShowStartOver(false);
    setHintOpen(false);
    setHelpChoiceOpen(false);
    setHelpOpen(false);
    setHelpReason(null);
    setHelpText("");
    setTicketState(null);
    setTicketAction(null);
    setTicketNotice(null);
    setOnboardingSchedulingOrigin(null);
    setOnboardingSchedulingSession(0);
    setOnboardingBookingSubmitted(false);
    setTrackedOnboardingBookingUrl("");
    setTrackedOnboardingRequestState(null);
    setUiHydrated(false);

    try {
      const savedUi = JSON.parse(localStorage.getItem(uiStorageKey) || "null");
      setCollapsed(typeof savedUi?.collapsed === "boolean" ? savedUi.collapsed : true);
    } catch (_) {
      setCollapsed(true);
      localStorage.removeItem(uiStorageKey);
    }
    setUiHydrated(true);

    if (!showUpgrade || !slug) {
      setUpgradeStatus(null);
      return;
    }

    try {
      const saved = JSON.parse(localStorage.getItem(storageKey) || "null");
      // v3 saves key on PATH as well as step. Anything else — the old
      // flat-12 shape (no path key), or v2 blobs carrying a `decisions`
      // object — is discarded rather than remapped (internal-gated;
      // nobody is mid-wizard). A valid path is required to restore, and
      // the restored path means a returning customer is not asked the
      // Step-0 account question again.
      const savedPath = WIZARD_PATHS[saved?.path] ? saved.path : null;
      // A checklist referencing retired E5 predates this round's step
      // restructure — discard rather than remap (internal-only data).
      const referencesRetiredStep = !!saved?.checklist
        && Object.prototype.hasOwnProperty.call(saved.checklist, "E5");
      if (saved && savedPath && !saved.decisions && !referencesRetiredStep
          && Number.isInteger(saved.stepIndex)
          && saved.stepIndex >= 0
          && saved.stepIndex < pathSteps(savedPath).length) {
        const savedChecklist = emptyUpgradeChecklist(savedPath);
        const savedCompletionStep = WIZARD_PATHS[savedPath]?.completionStepId;
        for (const key of pathSteps(savedPath)) {
          if (key === savedCompletionStep) {
            savedChecklist[key] = "pending";
            continue;
          }
          if (["done", "skipped"].includes(saved.checklist?.[key])) {
            savedChecklist[key] = saved.checklist[key];
          }
        }
        setPath(savedPath);
        setDesignatedUpn(
          typeof saved.designatedUpn === "string" ? saved.designatedUpn : ""
        );
        setUpnUnsure(!!saved.upnUnsure);
        setStepIndex(Math.min(
          saved.stepIndex,
          firstAllowedWizardStepIndex(savedPath, savedChecklist)
        ));
        setChecklist(savedChecklist);
        setSchedulePreference(
          typeof saved.schedulePreference === "string" ? saved.schedulePreference : ""
        );
        setCompletionBooked(saved.completionBookedV1 === true);
        setMode("wizard");
      } else if (saved) {
        localStorage.removeItem(storageKey);
      }
    } catch (_) {
      // Corrupt browser-only progress should never block the page.
      localStorage.removeItem(storageKey);
    }

    let cancelled = false;
    setUpgradeStatus(undefined);
    fetchUpgradeStatus(slug)
      .then(data => { if (!cancelled) setUpgradeStatus(data); })
      .catch(() => { if (!cancelled) setUpgradeStatus(null); });
    return () => { cancelled = true; };
  }, [showUpgrade, slug, storageKey, uiStorageKey]);

  useEffect(() => {
    if (!showUpgrade || !slug) return undefined;
    let cancelled = false;
    const reconcile = () => {
      fetchOnboardingBooking(slug)
        .then(data => {
          if (!cancelled) setCompletionBooked(data?.state === "booked");
        })
        .catch(() => {
          // The tracked POST still fails visibly. A transient state-read
          // failure must not hide the rest of the onboarding walkthrough.
        });
    };
    reconcile();
    window.addEventListener("focus", reconcile);
    return () => {
      cancelled = true;
      window.removeEventListener("focus", reconcile);
    };
  }, [showUpgrade, slug]);

  useEffect(() => {
    if (!upgradeStatus || upgradeStatus.scan_tool_key) return;
    if (path !== "existing") return;
    const nextChecklist = emptyUpgradeChecklist("new");
    try {
      localStorage.setItem(storageKey, JSON.stringify({
        path: "new",
        designatedUpn: "",
        upnUnsure: false,
        stepIndex: 0,
        checklist: nextChecklist,
        schedulePreference: "",
        completionBookedV1: false,
      }));
    } catch (_) {
      // Persistence is best-effort; the in-memory reset is authoritative
      // for the current visit.
    }
    setPath("new");
    setPathDraft("new");
    setDesignatedUpn("");
    setUpnUnsure(false);
    setStepIndex(0);
    setChecklist(nextChecklist);
    setSchedulePreference("");
    setCompletionBooked(false);
    setMode("wizard");
    setCollapsed(false);
  }, [upgradeStatus, path, storageKey]);

  useEffect(() => {
    if (!showUpgrade || !slug || mode !== "wizard" || !path) return;
    try {
      localStorage.setItem(storageKey, JSON.stringify({
        path, designatedUpn, upnUnsure, stepIndex, checklist, schedulePreference,
        completionBookedV1: completionBooked,
      }));
    } catch (_) {
      // Persistence is a convenience; an unavailable storage API must not
      // interrupt the current walkthrough.
    }
  }, [showUpgrade, slug, storageKey, mode, path, designatedUpn, upnUnsure, stepIndex, checklist, schedulePreference, completionBooked]);

  useEffect(() => {
    if (!uiHydrated || !slug) return;
    try {
      localStorage.setItem(uiStorageKey, JSON.stringify({ collapsed }));
    } catch (_) {
      // UI preference persistence is best effort.
    }
  }, [uiHydrated, slug, uiStorageKey, collapsed]);

  useEffect(() => {
    setHintOpen(false);
    setReferencePanel(null);
    setTicketNotice(null);
  }, [stepIndex]);

  if (!showUpgrade) return null;
  if (upgradeStatus === undefined) {
    return (
      <Card title={SURFACE_TITLE} style={{ marginTop:16 }}>
        <Skeleton height={72} />
      </Card>
    );
  }
  // Per spec, Dataverse failures and customers without tracking rows both
  // hide the panel; the backend still logs/fails loudly for operators.
  if (!upgradeStatus?.has_tracking_row) return null;

  // Draft/preview banner plumbing removed 2026-08-05 (customer launch,
  // content sweep complete) — no "Internal preview" string renders on
  // this surface in any state.
  const steps = pathSteps(path);
  const pathInfo = path ? WIZARD_PATHS[path] : null;
  const currentStep = steps[stepIndex] || steps[0] || null;
  const currentStepId = currentStep || "";
  const currentChecklistState = currentStep ? checklist[currentStep] : null;
  const atFinalStep = !!currentStep && stepIndex >= steps.length - 1;
  // The completion CTA lives on the path's completion step (E6 / N9),
  // gated on every step before it — the steps after it happen with or
  // after Patriot (register, remove GA, keep active).
  const atCompletionStep = !!pathInfo && currentStep === pathInfo.completionStepId;
  const canAdvance = ["done", "skipped"].includes(currentChecklistState);
  const canComplete = completionReady(path, checklist);
  const firstAllowedStepIndex = firstAllowedWizardStepIndex(path, checklist);
  const stepLabel = currentStep ? STEP_CONTENT[currentStep].title : PATH_CHOICE_COPY.heading;
  const isBusy = ticketState === "loading";
  const onboardingBookingUrlForPath = (pathKey) => {
    if (!pathKey) return "";
    const configuredUrls = onboardingBookingUrls || {};
    if (configuredUrls[pathKey]) return configuredUrls[pathKey];
    if (pathKey === "existing") return onboardingBookingUrl;
    return ONBOARDING_ASSISTANCE_BOOKING_URLS[pathKey] || "";
  };

  const resetProgress = (nextMode = "entry") => {
    try { localStorage.removeItem(storageKey); } catch (_) { /* best effort */ }
    setStepIndex(0);
    // Start over is a FULL reset: the Step-0 account choice is asked
    // again (only a resumed session skips it).
    setPath(null);
    setPathDraft(null);
    setDesignatedUpn("");
    setUpnUnsure(false);
    setChecklist({});
    setSchedulePreference("");
    setCompletionBooked(false);
    setReferencePanel(null);
    setHelpChoiceOpen(false);
    setHelpOpen(false);
    setHelpReason(null);
    setHelpText("");
    setTicketState(null);
    setTicketAction(null);
    setTicketNotice(null);
    setOnboardingSchedulingOrigin(null);
    setOnboardingSchedulingSession(0);
    setOnboardingBookingSubmitted(false);
    setTrackedOnboardingBookingUrl("");
    setTrackedOnboardingRequestState(null);
    setMode(nextMode);
    setShowStartOver(false);
    if (nextMode === "wizard") setCollapsed(false);
  };

  const chooseWizardPath = (nextPath) => {
    setPath(nextPath);
    setPathDraft(nextPath);
    setChecklist(emptyUpgradeChecklist(nextPath));
    setStepIndex(0);
  };

  const startWizard = () => {
    setTicketState(null);
    setTicketNotice(null);
    if (!upgradeStatus.scan_tool_key) {
      chooseWizardPath("new");
    }
    setMode("wizard");
    setCollapsed(false);
  };

  // In-wizard context only — from the entry screens the user has no
  // current step, and the ticket says "Not started".
  const inWizard = mode === "wizard" && !!path && !!currentStep;

  const openNeedHelp = (presetReason = null) => {
    if (isBusy) return;
    setTicketState(null);
    setTicketNotice(null);
    setHelpText("");
    if (presetReason) {
      setHelpReason(presetReason);
      setHelpChoiceOpen(false);
      setHelpOpen(true);
    } else {
      setHelpReason(null);
      if (path) {
        setHelpChoiceOpen(true);
        setHelpOpen(false);
      } else {
        setHelpChoiceOpen(false);
        setHelpOpen(true);
      }
    }
  };

  const openHelpTicketForm = () => {
    if (isBusy) return;
    setHelpChoiceOpen(false);
    setHelpReason(null);
    setHelpText("");
    setHelpOpen(true);
  };

  const openOnboardingScheduling = (origin) => {
    if (isBusy) return;
    setHelpChoiceOpen(false);
    setHelpOpen(false);
    setTicketState(null);
    setTicketAction(null);
    setTicketNotice(null);
    setOnboardingBookingSubmitted(false);
    setOnboardingSchedulingSession(value => value + 1);
    setOnboardingSchedulingOrigin(origin);
  };

  const openTrackedOnboardingScheduling = async () => {
    if (isBusy || trackedOnboardingRequestState === "loading" || !path) return;
    setTrackedOnboardingRequestState("loading");
    setTrackedOnboardingBookingUrl("");
    try {
      const response = await requestOnboardingBooking(slug, path);
      if (!response?.scheduling_url) throw new Error("missing scheduling URL");
      setTrackedOnboardingBookingUrl(response.scheduling_url);
      setTrackedOnboardingRequestState(null);
      setOnboardingBookingSubmitted(false);
      setOnboardingSchedulingSession(value => value + 1);
      setOnboardingSchedulingOrigin("completion");
    } catch (_) {
      setTrackedOnboardingRequestState("error");
    }
  };

  const submitNeedHelp = async () => {
    if (isBusy || !helpReason) return;
    setTicketState("loading");
    setTicketAction("help");
    setTicketNotice(null);
    try {
      await createTicket({
        client_id: slug,
        requester_email: user?.email || "",
        subject: HELP_SUBJECT,
        description: needHelpTicketBody({
          reasonKey: helpReason,
          customerLabel: clientName || slug,
          contactEmail: user?.email || "",
          scanToolKey: upgradeStatus.scan_tool_key,
          stepId: inWizard ? currentStepId : null,
          stepLabel: inWizard ? stepLabel : null,
          pathKey: inWizard ? path : null,
          checklist,
          freeText: helpText,
        }),
        patriot_service: "Portal Support",
        // Structured reason — the backend derives priority and routing
        // from this server-side; the client never sends a priority here.
        wizard_help_reason: helpReason,
      });
      setHelpOpen(false);
      setHelpReason(null);
      setHelpText("");
      setTicketState(null);
      setTicketAction(null);
      setTicketNotice(WIZARD_COPY.needHelpConfirmation);
    } catch (_) {
      setTicketState("error");
    }
  };

  const handleOnboardingScheduled = () => {
    setOnboardingBookingSubmitted(true);
    if (onboardingSchedulingOrigin !== "completion" || !pathInfo?.completionStepId) {
      return;
    }
    setCompletionBooked(true);
  };

  const choiceButton = (selected, onClick, children) => (
    <Btn pri={selected} onClick={onClick} style={{ minWidth:110 }}>{children}</Btn>
  );

  // Scan-method pill: both entry branches show which collection
  // technology this customer runs on, in the card header row.
  const scanToolKey = upgradeStatus.scan_tool_key;
  const unclassified = !scanToolKey;
  const legacyOrAuditorScanTool =
    scanToolKey === "legacy" || scanToolKey === "legacy-auditor";
  const legacyLikeScanTool =
    unclassified || legacyOrAuditorScanTool;
  const eligiblePathKeys = unclassified ? ["new"] : (
    legacyOrAuditorScanTool ? ["existing", "new"] : []
  );
  const pathChoiceOptions = eligiblePathKeys.map(key => ({
    key,
    title: key === "existing" ? PATH_CHOICE_COPY.existing.label : PATH_CHOICE_COPY.fresh.label,
    tag: key === "existing" ? PATH_CHOICE_COPY.existing.tag : PATH_CHOICE_COPY.fresh.tag,
    body: key === "existing" ? PATH_CHOICE_COPY.existing.body : PATH_CHOICE_COPY.fresh.body,
  }));
  const scanMethodRow = (
    <div style={{ marginBottom:12 }}>
      <ScanMethodPill scanToolKey={scanToolKey} />
    </div>
  );

  if (scanToolKey === "securescan365") {
    // Already on SecureScan365: no action needed — the value block shows
    // what they have (no "coming soon" pitch to a migrated customer),
    // and the post-migration cleanup list renders HERE for real: the
    // wizard disappears once the scan tool flips, so this branch is the
    // cleanup content's actual audience.
    return (
      <Card title={SURFACE_TITLE} style={{ marginTop:16 }}>
        {scanMethodRow}
        <div style={{ color:T.green, fontWeight:700 }}>{ENTRY_COPY.onSecureScan365}</div>
        <UpgradeValueBlock showComingSoon={false} />
        <div style={{ marginTop:14, padding:12, borderRadius:10, background:"rgba(83,196,109,.06)", border:`1px solid ${T.border}` }}>
          <div style={{ fontWeight:700, fontSize:13, marginBottom:6 }}>{CLEANUP_COPY.title}</div>
          <div style={{ color:T.muted, fontSize:13, marginBottom:6 }}>{CLEANUP_COPY.introExisting}</div>
          <ul style={{ margin:0, paddingLeft:18, display:"grid", gap:5, fontSize:13, color:T.text }}>
            {CLEANUP_COPY.items.map(item => <li key={item}>{item}</li>)}
          </ul>
        </div>
      </Card>
    );
  }

  const helpChoiceModal = (
    <Modal
      show={helpChoiceOpen}
      title={WIZARD_COPY.needHelpChoiceTitle}
      onClose={() => { if (!isBusy) setHelpChoiceOpen(false); }}
      footer={(
        <div style={{ display:"flex", flexWrap:"wrap", gap:8, justifyContent:"flex-end" }}>
          <Btn onClick={() => setHelpChoiceOpen(false)} disabled={isBusy}>Cancel</Btn>
          <Btn onClick={openHelpTicketForm} disabled={isBusy}>
            {WIZARD_COPY.needHelpTicketAction}
          </Btn>
          <Btn pri onClick={() => openOnboardingScheduling("help")} disabled={isBusy}>
            {WIZARD_COPY.needHelpMeetingAction}
          </Btn>
        </div>
      )}
    >
      <span />
    </Modal>
  );

  const onboardingSchedulingModal = (
    <ReviewSchedulingModal
      key={`onboarding-scheduling-${onboardingSchedulingSession}`}
      url={onboardingSchedulingOrigin === "completion"
        ? trackedOnboardingBookingUrl
        : (onboardingSchedulingOrigin ? onboardingBookingUrlForPath(path) : "")}
      submitted={onboardingBookingSubmitted}
      onScheduled={handleOnboardingScheduled}
      onClose={() => {
        setOnboardingSchedulingOrigin(null);
        setOnboardingBookingSubmitted(false);
        setTrackedOnboardingBookingUrl("");
      }}
      title="Book assistance with SecureScan365 onboarding"
      ariaLabel="Book assistance with SecureScan365 onboarding"
      closeLabel="Close onboarding scheduling"
      modalTestId="onboarding-scheduling-modal"
      widgetTestId="onboarding-scheduling-widget"
      successTitle="Your SecureScan365 onboarding meeting is booked."
      successDetail=""
    />
  );

  // ONE help form for every entry point. The modal is itself the ticket
  // confirmation (names the customer inline, stuck-modal precedent).
  // Read-only context rows are what the ticket will carry — shown so the
  // customer sees exactly what Patriot receives.
  const helpContextRows = [
    ["Customer", clientName || slug],
    ["Contact", user?.email || ""],
    ["Current scan tool", scanToolLabel(upgradeStatus.scan_tool_key)],
    ["Step reached", inWizard ? `${currentStepId} — ${stepLabel}` : "Not started"],
  ];
  const needHelpModal = (
    <Modal
      show={helpOpen}
      title={WIZARD_COPY.needHelpLabel}
      onClose={() => { if (!isBusy) { setHelpOpen(false); setTicketState(null); } }}
      onSubmit={submitNeedHelp}
      submitLabel={ticketAction === "help" && isBusy ? "Submitting…" : "Send to Patriot"}
      submitDisabled={isBusy || !helpReason}
    >
      <div style={{ marginBottom:10, fontSize:12 }}>
        Submitting creates a support ticket for <b style={{ color:T.text }}>{clientName || slug}</b>.
      </div>
      <div style={{ display:"grid", gap:6, marginBottom:12 }}>
        {HELP_REASONS.map(reason => (
          <label key={reason.key} style={{ display:"flex", alignItems:"center", gap:8, fontSize:13, cursor:"pointer" }}>
            <input
              type="radio"
              name="need-help-reason"
              checked={helpReason === reason.key}
              onChange={() => setHelpReason(reason.key)}
            />
            {reason.label}
          </label>
        ))}
      </div>
      <textarea
        value={helpText}
        onChange={event => setHelpText(event.target.value)}
        maxLength={4000}
        placeholder="Tell us a bit more (optional)"
        style={{ width:"100%", minHeight:90, resize:"vertical", background:"rgba(255,255,255,.05)", border:`1px solid ${T.border}`, borderRadius:8, color:T.text, padding:"9px 12px", fontFamily:"inherit", fontSize:13 }}
      />
      <div style={{ marginTop:10, padding:10, borderRadius:8, background:"rgba(255,255,255,.03)", border:`1px solid ${T.border}` }}>
        <div style={{ fontSize:11, fontWeight:700, color:T.muted, marginBottom:6, textTransform:"uppercase", letterSpacing:".04em" }}>Included automatically</div>
        {helpContextRows.map(([label, value]) => (
          <div key={label} style={{ display:"flex", gap:8, fontSize:12, padding:"2px 0" }}>
            <span style={{ color:T.muted, minWidth:130 }}>{label}</span>
            <span style={{ color:T.text }}>{value}</span>
          </div>
        ))}
      </div>
      {ticketState === "error" && <div style={{ color:T.red, fontSize:12, marginTop:8 }}>We couldn't create the ticket. Please try again.</div>}
    </Modal>
  );

  if (!legacyLikeScanTool) {
    // Unknown nonblank scan-tool keys fail closed: do not treat them as the
    // Legacy route, and do not offer the walkthrough until Patriot confirms the
    // customer's assessment configuration.
    return (
      <>
        <Card title={SURFACE_TITLE} style={{ marginTop:16 }}>
          {scanMethodRow}
          <div style={{ color:T.muted, fontSize:13, marginBottom:12 }}>{ENTRY_COPY.unclassified}</div>
          {ticketState === "error" && <div style={{ color:T.red, fontSize:12, marginBottom:10 }}>We couldn't create the ticket. Please try again.</div>}
          {ticketNotice && <div style={{ color:T.green, fontSize:12, marginBottom:10 }}>{ticketNotice}</div>}
          <div style={{ display:"flex", flexWrap:"wrap", gap:8, marginTop:14 }}>
            <Btn onClick={() => openNeedHelp()} disabled={isBusy}>{WIZARD_COPY.needHelpLabel}</Btn>
          </div>
        </Card>
        {helpChoiceModal}
        {needHelpModal}
        {onboardingSchedulingModal}
      </>
    );
  }

  const entryHeader = (
    <Card title={SURFACE_TITLE} style={{ marginTop:16 }}>
      {scanMethodRow}
      {unclassified ? (
        <div style={{ color:T.muted, fontSize:13, marginBottom:12 }}>{ENTRY_COPY.unclassified}</div>
      ) : (
        <div style={{ padding:10, borderRadius:10, background:"rgba(243,181,63,.10)", border:"1px solid rgba(243,181,63,.3)", color:T.yellow, fontSize:13, marginBottom:12 }}>
          {ENTRY_COPY.legacyBanner}
        </div>
      )}
      <p style={{ fontSize:13, color:T.muted, marginBottom:8 }}>{WIZARD_COPY.intro} {WIZARD_COPY.noServicePrincipalLine}</p>
      {/* Per-path timing lives on the Step-0 choice cards — the access
          call exists only on the new-account path, so no global duration
          line here. */}
      <ul style={{ margin:"10px 0 0", paddingLeft:18, display:"grid", gap:6 }}>
        {ENTRY_COPY.securityBullets.map(bullet => (
          <li key={bullet.title} style={{ fontSize:13 }}>
            <b>{bullet.title}:</b> <span style={{ color:T.muted }}>{bullet.text}</span>
          </li>
        ))}
      </ul>
      {/* The value story is the reason; the wizard CTA below is the
          obvious next step. */}
      <UpgradeValueBlock />
      {/* The FAQ is reachable from the entry state, not just the wizard —
          several customers read only that page. */}
      <div style={{ marginTop:12 }}>
        <button onClick={() => setEntryFaqOpen(value => !value)} style={{ border:"none", background:"none", padding:0, color:T.blue, fontFamily:"inherit", fontSize:12, cursor:"pointer", textDecoration:"underline", textUnderlineOffset:3 }}>
          {ENTRY_COPY.faqLabel}
        </button>
        {entryFaqOpen && (
          <div style={{ marginTop:8 }}>
            <p style={{ color:T.muted, fontSize:13, marginBottom:4 }}>{SECURITY_FAQ_INTRO}</p>
            {SECURITY_FAQ.map(item => (
              <div key={item.q} style={{ padding:"10px 0", borderTop:`1px solid ${T.border}` }}>
                <div style={{ fontWeight:700, fontSize:13, marginBottom:4 }}>{item.q}</div>
                <div style={{ color:T.muted, fontSize:13 }}>{item.a}</div>
              </div>
            ))}
          </div>
        )}
      </div>
      {mode === "entry" && (
        <>
          {ticketState === "error" && <div style={{ color:T.red, fontSize:12, marginTop:10 }}>We couldn't create the ticket. Please try again.</div>}
          {ticketNotice && <div style={{ color:T.green, fontSize:12, marginTop:10 }}>{ticketNotice}</div>}
          <div style={{ display:"flex", flexWrap:"wrap", gap:8, marginTop:14 }}>
            <Btn pri onClick={startWizard}>{ENTRY_COPY.getStartedLabel}</Btn>
            <Btn onClick={() => openNeedHelp()} disabled={isBusy}>{WIZARD_COPY.needHelpLabel}</Btn>
          </div>
        </>
      )}
    </Card>
  );

  if (mode === "entry") {
    return <>{entryHeader}{helpChoiceModal}{needHelpModal}{onboardingSchedulingModal}</>;
  }

  const currentContent = currentStep ? STEP_CONTENT[currentStep] : null;
  // The cleanup step (E10/N12) is visible but LOCKED until the first
  // successful scan flips the scan tool. On this (legacy) branch the
  // flip hasn't happened yet, so the lock shows a motivational preview;
  // the migrated entry branch surfaces the same content unlocked.
  const cleanupLocked = !!currentContent?.lockedUntilScan
    && upgradeStatus?.scan_tool_key !== "securescan365";
  // Rows may carry an optional `image` field ({src, caption}) — rendered
  // as a full-width illustration row beneath the row's cells, never as a
  // column.
  const referenceTable = (columns, rows) => {
    const cellColumns = columns.filter(column => column !== "image");
    return (
      <table style={{ width:"100%", borderCollapse:"collapse", fontSize:12 }}>
        <thead><tr>{cellColumns.map(column => <th key={column} style={{ padding:8, textAlign:"left", borderBottom:`1px solid ${T.border}` }}>{column}</th>)}</tr></thead>
        <tbody>{rows.map((row, index) => (
          <React.Fragment key={index}>
            <tr>{cellColumns.map(column => <td key={column} style={{ padding:8, borderBottom: row.image ? "none" : `1px solid ${T.border}`, verticalAlign:"top" }}>{row[column]}</td>)}</tr>
            {row.image && (
              <tr>
                <td colSpan={cellColumns.length} style={{ padding:"0 8px 12px", borderBottom:`1px solid ${T.border}` }}>
                  <figure style={{ margin:0 }}>
                    <img src={row.image.src} alt={row.image.caption || "Illustration"} style={{ maxWidth:"100%", borderRadius:10, border:`1px solid ${T.border}` }} />
                    {row.image.caption && <figcaption style={{ fontSize:12, color:T.muted, marginTop:6 }}>{row.image.caption}</figcaption>}
                  </figure>
                </td>
              </tr>
            )}
          </React.Fragment>
        ))}</tbody>
      </table>
    );
  };
  // Shared reference content, reachable from every step: the FAQ is the
  // strongest asset in the source document — several customers will read
  // only that page.
  const faqList = (
    <div>
      <p style={{ color:T.muted, fontSize:13, marginBottom:8 }}>{SECURITY_FAQ_INTRO}</p>
      {SECURITY_FAQ.map(item => (
        <div key={item.q} style={{ padding:"10px 0", borderTop:`1px solid ${T.border}` }}>
          <div style={{ fontWeight:700, fontSize:13, marginBottom:4 }}>{item.q}</div>
          <div style={{ color:T.muted, fontSize:13 }}>{item.a}</div>
        </div>
      ))}
    </div>
  );
  const REFERENCE_PANELS = {
    faq: { title: WIZARD_COPY.referenceFaqLabel, body: faqList },
    troubleshooting: {
      title: WIZARD_COPY.referenceTroubleshootingLabel,
      body: referenceTable(
        Object.keys(TROUBLESHOOTING_TABLE[0]), TROUBLESHOOTING_TABLE
      ),
    },
    roles: {
      title: WIZARD_COPY.referenceRolesLabel,
      body: (
        <div>
          {referenceTable(Object.keys(ROLES_ACCESS_TABLE[0]), ROLES_ACCESS_TABLE)}
          <div style={{ fontSize:12, color:T.blue, marginTop:12 }}>Tip: {ROLES_ACCESS_PIM_NOTE}</div>
          {/* Second table: not who performs the setup, but what Patriot
              ends up holding — the anticipatory answer to the most
              common security-review questions. */}
          <h4 style={{ margin:"18px 0 10px", fontSize:14 }}>{PATRIOT_ACCESS_TABLE_TITLE}</h4>
          {referenceTable(Object.keys(PATRIOT_ACCESS_TABLE[0]), PATRIOT_ACCESS_TABLE)}
        </div>
      ),
    },
  };

  return (
    <>
      {entryHeader}
      <div style={{ marginTop:12, background:`linear-gradient(180deg,${T.panel},${T.panel2})`, border:`1px solid ${T.border}`, borderRadius:18, boxShadow:"0 18px 40px rgba(0,0,0,0.28)" }}>
        <div style={{ display:"flex", flexWrap:"wrap", alignItems:"center", justifyContent:"space-between", gap:10, padding:"13px 16px", borderBottom:collapsed ? "none" : `1px solid ${T.border}` }}>
          <button onClick={() => setCollapsed(value => !value)} aria-expanded={!collapsed} style={{ flex:1, minWidth:220, textAlign:"left", border:"none", background:"none", color:T.text, fontFamily:"inherit", cursor:"pointer", padding:0 }}>
            <span style={{ fontSize:13, fontWeight:800 }}>{WIZARD_COPY.surfaceName}</span>
            <span style={{ color:T.muted, fontSize:12 }}> — {path ? `${WIZARD_PATHS[path].label} — Step ${Math.min(stepIndex + 1, steps.length)} of ${steps.length}` : PATH_CHOICE_COPY.heading} — {collapsed ? WIZARD_COPY.resumeLabel : WIZARD_COPY.collapseLabel}</span>
          </button>
          <Btn onClick={() => setShowStartOver(true)} disabled={isBusy}>{WIZARD_COPY.startOverLabel}</Btn>
        </div>

        {!collapsed && (
          <div style={{ padding:20 }}>
            {/* No terminal "completed" branch — booking assistance keeps
                the customer on the Patriot-operated gate until the
                successful SecureScan365 scan flips the scan method. */}
            {referencePanel && REFERENCE_PANELS[referencePanel] ? (
              <div>
                <h3 style={{ margin:"0 0 12px", fontSize:16 }}>{REFERENCE_PANELS[referencePanel].title}</h3>
                {REFERENCE_PANELS[referencePanel].body}
                <Btn style={{ marginTop:14 }} onClick={() => setReferencePanel(null)}>{path ? `Back to Step ${Math.min(stepIndex + 1, steps.length)}` : "Back"}</Btn>
              </div>
            ) : !path ? (
              /* Step 0 — which account will we use? Asked once for Legacy
                 and Legacy - Auditor. Blank/Unclassified has one approved
                 path, so Get started chooses the new-account path directly. */
              <div>
                <h3 style={{ margin:"0 0 8px", fontSize:16 }}>{PATH_CHOICE_COPY.heading}</h3>
                <p style={{ color:T.muted, fontSize:13, marginBottom:14 }}>{PATH_CHOICE_COPY.intro}</p>
                <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit, minmax(260px, 1fr))", gap:12 }}>
                  {pathChoiceOptions.map(option => (
                    <button key={option.key} onClick={() => setPathDraft(option.key)} style={{ textAlign:"left", fontFamily:"inherit", cursor:"pointer", padding:14, borderRadius:12, background: pathDraft === option.key ? "rgba(68,166,255,.10)" : "rgba(255,255,255,.03)", border:`1px solid ${pathDraft === option.key ? T.blue : T.border}`, color:T.text }}>
                      <div style={{ display:"flex", gap:8, alignItems:"center", flexWrap:"wrap", marginBottom:6 }}>
                        <span style={{ fontWeight:700, fontSize:13 }}>{option.title}</span>
                        {/* Existing = green (recommended); new = the
                            caution tier — longer path, call required. */}
                        {option.tag && <Badge type={option.key === "existing" ? "green" : "amber"} weight="soft">{option.tag}</Badge>}
                      </div>
                      <div style={{ fontSize:12, color:T.muted }}>{option.body}</div>
                    </button>
                  ))}
                </div>
                {pathDraft === "existing" && (
                  <div style={{ marginTop:14 }}>
                    <label style={{ display:"block", fontSize:12, color:T.muted, marginBottom:6 }}>{PATH_CHOICE_COPY.existing.upnLabel}</label>
                    <input value={designatedUpn} onChange={event => setDesignatedUpn(event.target.value)} maxLength={320} disabled={upnUnsure} placeholder="account@yourdomain.com" style={{ width:"100%", maxWidth:420, background:"rgba(255,255,255,.05)", border:`1px solid ${T.border}`, borderRadius:8, color:T.text, padding:"9px 12px", fontFamily:"inherit", fontSize:13, opacity:upnUnsure ? .5 : 1 }} />
                    <div style={{ fontSize:12, color:T.muted, marginTop:6 }}>{PATH_CHOICE_COPY.existing.upnHelper}</div>
                    <label style={{ display:"flex", gap:8, alignItems:"center", fontSize:12, color:T.text, marginTop:8, cursor:"pointer" }}>
                      <input type="checkbox" checked={upnUnsure} onChange={event => setUpnUnsure(event.target.checked)} />
                      {PATH_CHOICE_COPY.existing.unsureLabel}
                    </label>
                  </div>
                )}
                <div style={{ marginTop:16 }}>
                  <Btn pri disabled={!pathDraft || (pathDraft === "existing" && !upnUnsure && !designatedUpn.trim())} onClick={() => {
                    chooseWizardPath(pathDraft);
                  }}>Continue</Btn>
                </div>
              </div>
            ) : (
              <div style={{ display:"grid", gridTemplateColumns:"minmax(160px, 220px) minmax(0, 1fr)", gap:20 }}>
                <div style={{ borderRight:`1px solid ${T.border}`, paddingRight:16 }}>
                  <div style={{ fontSize:11, color:T.muted, fontWeight:700, textTransform:"uppercase", letterSpacing:".05em", marginBottom:9 }}>{pathInfo.label} checklist</div>
                  {steps.map(key => {
                    const state = checklist[key];
                    const index = steps.indexOf(key);
                    const canVisitStep = index <= firstAllowedStepIndex;
                    return (
                      <button key={key} disabled={!canVisitStep || isBusy} onClick={() => { if (canVisitStep && !isBusy) setStepIndex(index); }} style={{ width:"100%", display:"flex", gap:8, alignItems:"center", padding:"5px 0", border:"none", background:"none", textAlign:"left", fontFamily:"inherit", cursor:canVisitStep && !isBusy ? "pointer" : "not-allowed", opacity:canVisitStep ? 1 : .55, fontSize:12, color:state === "pending" ? T.muted : T.text }}>
                        <span style={{ width:16, color:state === "done" ? T.green : state === "skipped" ? T.yellow : T.muted }}>{state === "done" ? "✓" : state === "skipped" ? "—" : "○"}</span>
                        {/* Titles only — step codes (E1/N12…) are internal
                            ids; non-sequential codes read as bugs. Codes
                            still travel in ticket bodies. */}
                        <span>{STEP_CONTENT[key].title}</span>
                      </button>
                    );
                  })}
                  {/* Offered only AFTER the path choice, and only the
                      guide matching this path — never both. */}
                  {GUIDE_PDFS[path] && (
                    <div style={{ marginTop:14, paddingTop:12, borderTop:`1px solid ${T.border}` }}>
                      <a href={GUIDE_PDFS[path].href} target="_blank" rel="noreferrer" style={{ color:T.blue, fontSize:12 }}>
                        {GUIDE_PDFS[path].label}
                      </a>
                      <div style={{ fontSize:11, color:T.muted, marginTop:4 }}>{GUIDE_PDF_NOTE}</div>
                    </div>
                  )}
                </div>

                <div>
                  <div style={{ fontSize:11, color:T.muted, marginBottom:5 }}>Step {stepIndex + 1} of {steps.length}</div>
                  <>
                      <h3 style={{ margin:"0 0 10px", fontSize:16 }}>{currentContent.title}</h3>
                      {currentContent.instructions.map((instruction, index) => {
                        // Strings are plain paragraphs; objects carry an
                        // optional text plus a copyable value block.
                        if (typeof instruction === "string") {
                          return <p key={index} style={{ color:T.muted, fontSize:13, marginBottom:9 }}>{instruction}</p>;
                        }
                        return (
                          <div key={index}>
                            {instruction.text && <p style={{ color:T.muted, fontSize:13, marginBottom:9 }}>{instruction.text}</p>}
                            {instruction.copy && <WizardCopyBlock label={instruction.copy.label} value={instruction.copy.value} />}
                          </div>
                        );
                      })}
                      {currentContent.tip && <div style={{ fontSize:12, color:T.blue, marginBottom:9 }}>Tip: {currentContent.tip}</div>}
                      {/* images three-state: null = none needed (nothing),
                          [] = pending (placeholder box), populated = figures. */}
                      {currentContent.images === null ? null : currentContent.images.length ? currentContent.images.map((image, index) => {
                        const src = typeof image === "string" ? image : image.src;
                        const caption = typeof image === "string" ? null : image.caption;
                        return (
                          <figure key={src || index} style={{ margin:"0 0 12px" }}>
                            <img src={src} alt={caption || `${currentStep} — ${currentContent.title}`} style={{ maxWidth:"100%", borderRadius:10, border:`1px solid ${T.border}` }} />
                            {caption && <figcaption style={{ fontSize:12, color:T.muted, marginTop:6 }}>{caption}</figcaption>}
                          </figure>
                        );
                      }) : <div style={{ padding:16, border:`1px dashed ${T.border}`, borderRadius:10, color:T.muted, fontSize:12, margin:"12px 0" }}>Screenshot placeholder — supplied by James</div>}
                      {cleanupLocked && (
                        <div style={{ padding:"10px 12px", borderRadius:10, background:"rgba(148,163,184,.10)", border:`1px solid ${T.border}`, color:T.muted, fontSize:13, marginBottom:12 }}>
                          🔒 {CLEANUP_COPY.lockedNote}
                        </div>
                      )}
                      {!atCompletionStep && (
                        <div style={{ display:"flex", gap:8, marginTop:12 }}>
                          {choiceButton(currentChecklistState === "done", () => { if (!cleanupLocked) setChecklist(value => ({ ...value, [currentStep]:"done" })); }, "Mark complete")}
                          {choiceButton(currentChecklistState === "skipped", () => { if (!cleanupLocked) setChecklist(value => ({ ...value, [currentStep]:"skipped" })); }, "Skip for now")}
                        </div>
                      )}
                      {atCompletionStep && (
                        <div style={{ marginTop:14, padding:12, borderRadius:10, background:"rgba(68,166,255,.06)", border:`1px solid ${T.border}` }}>
                          {completionBooked ? (
                            /* Inline confirmation only. The CTA is gone,
                               but the step remains pending so Next and
                               sidebar bypasses stay blocked. */
                            <div style={{ color:T.green, fontWeight:700, fontSize:13 }}>
                              ✓ {pathInfo.completionConfirmation}
                            </div>
                          ) : (
                            <>
                              <div style={{ display:"flex", flexWrap:"wrap", gap:8, marginTop:10, alignItems:"center" }}>
                                <Btn
                                  pri
                                  onClick={openTrackedOnboardingScheduling}
                                  disabled={!canComplete || isBusy || trackedOnboardingRequestState === "loading"}
                                >
                                  {pathInfo.completionLabel}
                                </Btn>
                              </div>
                              <div style={{ fontSize:12, color:T.muted, marginTop:8 }}>
                                {pathInfo.completionHelper}
                              </div>
                              {!canComplete && <div style={{ fontSize:12, color:T.yellow, marginTop:6 }}>Mark the steps above done or skipped first.</div>}
                              {trackedOnboardingRequestState === "error" && (
                                <div role="alert" style={{ fontSize:12, color:T.red, marginTop:6 }}>
                                  Scheduling is temporarily unavailable. Please try again.
                                </div>
                              )}
                            </>
                          )}
                        </div>
                      )}
                      {currentContent.troubleshooting && (
                        <div style={{ marginTop:14 }}>
                          <button onClick={() => setHintOpen(value => !value)} style={{ border:"none", background:"none", color:T.yellow, fontFamily:"inherit", fontSize:12, cursor:"pointer", padding:0 }}>If something goes wrong</button>
                          {hintOpen && (() => {
                            // The hint accepts a string or {text, images}
                            // — some captures belong to the hint itself,
                            // not the step's main image list.
                            const hint = typeof currentContent.troubleshooting === "string"
                              ? { text: currentContent.troubleshooting, images: [] }
                              : currentContent.troubleshooting;
                            return (
                              <div style={{ marginTop:7 }}>
                                <div style={{ color:T.muted, fontSize:12 }}>{hint.text}</div>
                                {(hint.images || []).map(image => (
                                  <figure key={image.src} style={{ margin:"10px 0 0" }}>
                                    <img src={image.src} alt={image.caption || "Troubleshooting illustration"} style={{ maxWidth:"100%", borderRadius:10, border:`1px solid ${T.border}` }} />
                                    {image.caption && <figcaption style={{ fontSize:12, color:T.muted, marginTop:6 }}>{image.caption}</figcaption>}
                                  </figure>
                                ))}
                              </div>
                            );
                          })()}
                        </div>
                      )}
                    </>

                  {ticketState === "error" && <div style={{ color:T.red, fontSize:12, marginTop:12 }}>We couldn't create the ticket. Please try again.</div>}
                  {ticketNotice && <div style={{ color:T.green, fontSize:12, marginTop:12 }}>{ticketNotice}</div>}
                  <div style={{ display:"flex", flexWrap:"wrap", justifyContent:"space-between", gap:10, marginTop:18, paddingTop:14, borderTop:`1px solid ${T.border}` }}>
                    <div style={{ display:"flex", flexWrap:"wrap", gap:8 }}>
                      <Btn onClick={() => setStepIndex(index => Math.max(0, index - 1))} disabled={stepIndex === 0 || isBusy}>Back</Btn>
                      {!atFinalStep && (
                        <Btn pri onClick={() => setStepIndex(index => Math.min(steps.length - 1, index + 1))} disabled={!canAdvance || isBusy}>Next</Btn>
                      )}
                    </div>
                    <div style={{ display:"flex", flexWrap:"wrap", gap:12, alignItems:"center" }}>
                      <button onClick={() => setReferencePanel("faq")} style={{ border:"none", background:"none", padding:0, color:T.blue, fontFamily:"inherit", fontSize:12, cursor:"pointer", textDecoration:"underline", textUnderlineOffset:3 }}>{WIZARD_COPY.referenceFaqLabel}</button>
                      <button onClick={() => setReferencePanel("troubleshooting")} style={{ border:"none", background:"none", padding:0, color:T.blue, fontFamily:"inherit", fontSize:12, cursor:"pointer", textDecoration:"underline", textUnderlineOffset:3 }}>{WIZARD_COPY.referenceTroubleshootingLabel}</button>
                      <button onClick={() => setReferencePanel("roles")} style={{ border:"none", background:"none", padding:0, color:T.blue, fontFamily:"inherit", fontSize:12, cursor:"pointer", textDecoration:"underline", textUnderlineOffset:3 }}>{WIZARD_COPY.referenceRolesLabel}</button>
                      {/* The ONE help entry point — a pill button, deliberately
                          not styled like the three reference links above. */}
                      <Btn onClick={() => openNeedHelp()} disabled={isBusy}>{WIZARD_COPY.needHelpLabel}</Btn>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        )}
      </div>

      <Modal show={showStartOver} title={WIZARD_COPY.startOverLabel} onClose={() => { if (!isBusy) setShowStartOver(false); }} onSubmit={() => resetProgress("entry")} submitLabel={WIZARD_COPY.startOverLabel} submitDisabled={isBusy}>
        {WIZARD_COPY.startOverMessage}
      </Modal>

      {needHelpModal}
      {helpChoiceModal}
      {onboardingSchedulingModal}
    </>
  );
}

// Exported for tests (same convention as CustomerScanCard /
// UpgradeSection) — the add form's Patriot-only controls need coverage.
/* ── Review Complete (Patriot-only) ─────────────────────────────────
 * Button + dialog on the Recommendations page (SPEC-review-complete-
 * button, PR 2; placement and gating settled 2026-08-08). The button
 * sits in the sticky filter bar so it is in reach the moment a review
 * call ends, wherever the walkthrough finished. Visibility is
 * isPatriot && !deliveryMode — rendered for Patriot users, hidden from
 * customers and in presentation mode, the same pattern as the other
 * Patriot-only surfaces. Deliberately NO presentation-mode-required
 * gate: anyone can enter presentation mode alone, so it would stop
 * nothing deliberate — the reviewer stamped on the completion record
 * is the real control, and the dialog's confirmations make an
 * accidental press unlikely (operator decision 2026-08-08). The
 * workflow: run the call in presentation mode, exit when the customer
 * drops, click.
 *
 * Nothing fetches until the dialog opens — the context GET costs four
 * uncached Dataverse queries plus a token round trip. Cycle position,
 * reviews used and the last review render INSIDE the dialog as
 * confirm-safety context; the reporting view is PR 3 on the admin ops
 * page. The reviewer is always the signed-in clicker — no picker; the
 * server stamps pc_reviewer from the caller's UPN (the portal's
 * service principal makes createdby useless for attribution).
 * Backdating is the real use case (call Friday, click Monday): the
 * date defaults to today and accepts earlier dates only.
 */
// LABELS ONLY — the wire keys are untouched (CONTENT-01). "Standard
// review" is the picker's word for the key "scheduled"; the Delivery list
// calls the same key "Completed" and CRM still stores "Scheduled". All
// three strings come from utils/reviewOps so they cannot drift.
const REVIEW_OUTCOMES = (onCycle, banked = false) => [
  { key: "scheduled", label: REVIEW_TYPE_STANDARD_LABEL,
    desc: banked
      ? "Counts toward the Banked allowance window; review dates and windows stay authoritative."
      : onCycle
      ? "Counts toward the allowance and advances the cycle — the next audit moves out on the distributed cadence."
      : "Records the review. This customer is not on a review cycle, so nothing advances." },
  // RE-REVIEW LEFT THE PICKER (Amber, 2026-08-13): she rejected the word,
  // and Off-cycle already carried an identical consequence — "records the
  // review; the cycle does not move" — so the two options asked the reader
  // to distinguish outcomes that behave the same. Nothing is migrated: the
  // wire key, the Dataverse option and the "Re-review" label all survive
  // for rows already recorded (TYPE_LABELS keeps them rendering).
  { key: "off-cycle", label: "Off-cycle review",
    desc: "Records the review; the cycle does not move." },
  // A FIFTH KIND, not a variation of the four (operator decision
  // 2026-08-13). The meeting happened and failed its purpose — stale
  // data, or the session went sideways — and the customer asked to rerun
  // it. Sits between Off-cycle and No-show because that is where it falls
  // on the scale the list already runs along: reviews that happened, then
  // the one that happened and has to happen again, then the one that
  // didn't. No checkbox and no sub-flow — the consequences are fixed.
  { key: "redo-requested", label: REVIEW_TYPE_RESCHEDULE_LABEL,
    desc: "The review happened but the data needs to be redone — records the review, consumes nothing, and flags a Reschedule so a new booking link goes out." },
  { key: "no-show", label: "No-show",
    desc: "The customer did not attend. The booking-link choice below decides whether this uses one of their reviews." },
];

// The booking-link sub-choice, which since ADR-0087 decides whether the
// no-show CONSUMES a review. Each option names its consequence: a choice
// that silently spends a customer's paid allowance is not a choice anyone
// can make correctly. Still a forced choice with no default (operator
// decision 2026-08-06, unchanged).
const BOOKING_LINK_OPTIONS = (onCycle, banked = false) => [
  { value: true,
    label: "Include a new booking link so they can reschedule",
    desc: banked
      ? "Does not use a Banked review — the current window stays where it is."
      : onCycle
      ? "Does not use a review — the cycle stays where it is and this review is still owed."
      : "Does not use a review. This customer is not on a review cycle, so nothing advances." },
  { value: false,
    label: "No booking link — they'll reply when ready to rebook",
    desc: banked
      ? "Uses one Banked review for the current window."
      : onCycle
      ? "Uses one of their reviews and advances the cycle as normal — the next audit moves out on the distributed cadence."
      : "This customer is not on a review cycle, so nothing advances." },
];

// Preselect Scheduled only when the cadence says a scheduled review is
// plausibly what just happened: more than 90 days since the last
// completion, or no completions at all (day one counts as more than
// 90 — operator decision 2026-08-08). Inside 90 days nothing is
// preselected and confirm waits: a recent completion makes the outcome
// genuinely ambiguous, and a wrong silent default writes wrong cycle
// state. Never preselect when Scheduled is locked (the year is full).
// 1st / 2nd / 3rd / 4th … — review numbers run 1–6, but handle the
// 11–13 exception anyway so the helper is correct if reused.
const ordinal = (n) => {
  const tens = n % 100;
  const ones = n % 10;
  const suffix = tens >= 11 && tens <= 13 ? "th"
    : ones === 1 ? "st" : ones === 2 ? "nd" : ones === 3 ? "rd" : "th";
  return `${n}${suffix}`;
};

const bankedRemainingAfterText = (context) => {
  const remaining = context?.reviews_remaining_after;
  if (typeof remaining !== "number") {
    return "The current window balance was not available in the preview.";
  }
  if (remaining === 0) {
    return "No Banked reviews remain available in the current window after this.";
  }
  if (remaining === 1) {
    return "1 Banked review remains available in the current window after this.";
  }
  return `${remaining} Banked reviews remain available in the current window after this.`;
};

const preselectScheduled = (context) => {
  if (!context) return false;
  if (context.scheduled_locked) return false;
  if (context.no_recorded_reviews) return true;
  const days = context.last_completion?.days_since;
  return typeof days === "number" && days > 90;
};

const RecordReviewModal = ({ show, slug, clientName, reviewerLabel, onClose }) => {
  const [context, setContext] = useState(null);
  const [contextError, setContextError] = useState(null);
  const [members, setMembers] = useState(null); // roster, for the no-show preview
  const [reviewType, setReviewType] = useState(null);
  const [reviewDate, setReviewDate] = useState(localDateString());
  const [note, setNote] = useState("");
  // Booking link is a forced choice, not a default: genuinely 50/50 and
  // unknowable from context, so neither radio is preselected and submit
  // waits until the operator decides (operator decision 2026-08-06).
  const [bookingChoice, setBookingChoice] = useState(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);
  const [result, setResult] = useState(null);

  // Everything loads when the dialog opens — nothing on page mount.
  // Fresh form every open; a no-show choice must never linger into the
  // next recording. The roster ride-along powers the enabled-mode no-show
  // recipient preview only (display truth — the server resolves recipients
  // itself); notice-off mode deliberately skips it.
  useEffect(() => {
    let cancelled = false;
    if (!show || !slug) return;
    setContext(null); setContextError(null); setMembers(null);
    setReviewType(null); setReviewDate(localDateString());
    setNote(""); setBookingChoice(null); setBusy(false);
    setError(null); setResult(null);
    fetchReviewCompletionContext(slug)
      .then(d => {
        if (cancelled) return;
        setContext(d);
        setReviewType(preselectScheduled(d) ? "scheduled" : null);
        if (d?.notice_mode === "off") {
          setMembers([]);
          return;
        }
        fetchAccessList(slug)
          .then(list => {
            if (!cancelled) setMembers(Array.isArray(list) ? list : []);
          })
          .catch(() => { if (!cancelled) setMembers([]); });
      })
      .catch(e => {
        if (cancelled) return;
        // 422 = no active tracking row: a CRM problem worth showing
        // verbatim, not a portal failure.
        setContextError(e.status === 422 ? e.message
          : "Couldn't load review status — please try again.");
      });
    return () => { cancelled = true; };
  }, [show, slug]);

  const bankedCycle = context?.cycle?.mode === "banked";
  const onCycle = !!context?.cycle;
  const noShow = reviewType === "no-show";
  const today = localDateString();
  let pendingCompletionDate = null;
  let pendingCompletionError = null;
  if (show && slug) {
    try { pendingCompletionDate = getPendingReviewCompletionDate(slug); }
    catch (caught) { pendingCompletionError = caught.message; }
  }
  // Bare YYYY-MM-DD comparison — DateOnly strings order lexicographically
  // (date-authority rule: zero timezone math on DateOnly fields).
  const dateOk = /^\d{4}-\d{2}-\d{2}$/.test(reviewDate) && reviewDate <= today;
  // Always true since the write gate came out (2026-08-07); kept as the
  // re-gating mechanism.
  const writesEnabled = context?.writes_enabled !== false;
  const governedReceiptRetry = !!pendingCompletionDate &&
    context?.cycle?.mode === "contract_state" &&
    context?.writes_enabled === true;
  const canSubmit = !busy && !!context && writesEnabled && !pendingCompletionError &&
    reviewType !== null && dateOk && note.length <= 2000 &&
    (!noShow || bookingChoice !== null);

  const contacts = Array.isArray(members)
    ? members.filter(m => m.status_value === 125470001 && (m.primary || m.executive))
    : null;
  const noShowNoticePaused = context?.notice_mode === "off";
  const perYear = context?.allowance?.per_year;
  const daysAgo = context?.last_completion?.days_since;

  const handleSubmit = async () => {
    if (!canSubmit) return;
    setBusy(true); setError(null);
    try {
      const resp = await recordReviewCompletion(slug, {
        reviewDate, reviewType,
        note: note.trim() || undefined,
        sendBookingLink: bookingChoice === true,
        // The click date, from the SAME clock as the review-date
        // default (localDateString — the operator's local date, bare
        // YYYY-MM-DD, zero timezone math per the date-authority rule).
        // The server anchors the next-audit schedule on it: history
        // uses the review date, scheduling uses the click date.
        clickDate: pendingCompletionDate || localDateString(),
      });
      setResult(resp);
    } catch (e) {
      // Server messages are written for humans (duplicate window,
      // unmatched reviewer, Y20 boundary) — surface them verbatim.
      setError(e.message || "Couldn't record the review — please try again.");
    } finally {
      setBusy(false);
    }
  };

  if (!show) return null;

  const labelStyle = { display:"block", fontSize:12, color:T.muted, marginBottom:6, fontWeight:600 };
  const inputStyle = {
    width:"100%", background:"rgba(255,255,255,0.05)", border:`1px solid ${T.border}`,
    borderRadius:8, color:T.text, fontSize:13, padding:"9px 12px", fontFamily:"inherit", outline:"none",
  };
  const amberBox = { padding:10, background:"rgba(243,181,63,0.12)", borderRadius:10, border:"1px solid rgba(243,181,63,0.35)", fontSize:13, color:T.yellow };
  const greenBox = { padding:10, background:"rgba(83,196,109,0.1)", borderRadius:10, border:"1px solid rgba(83,196,109,0.3)", fontSize:13, color:T.green };
  const redBox = { padding:10, background:"rgba(225,77,87,0.1)", borderRadius:10, border:"1px solid rgba(225,77,87,0.3)", fontSize:13, color:T.red };
  const neutralBox = { padding:10, background:"rgba(168,189,220,0.10)", borderRadius:10, border:"1px solid rgba(168,189,220,0.30)", fontSize:13, color:T.muted };

  // Portal to document.body (ServiceInquiryModal / IdleWarningModal
  // pattern): the trigger lives in the RecsPage sticky filter bar,
  // whose position:sticky + zIndex creates a stacking context — a
  // dialog rendered inside it can never paint above the dashboard
  // header, whatever z-index it carries (live finding 2026-08-08).
  return createPortal(
    <div onClick={() => { if (!busy) onClose(); }} style={{ position:"fixed", inset:0, background:"rgba(0,0,0,0.5)", zIndex:1000, display:"flex", justifyContent:"center", alignItems:"center" }}>
      <div role="dialog" aria-modal="true" onClick={e => e.stopPropagation()} style={{ background:T.panel, border:`1px solid ${T.border}`, borderRadius:18, padding:24, maxWidth:560, width:"92%", maxHeight:"86vh", overflowY:"auto", boxShadow:"0 12px 40px rgba(0,0,0,0.4)" }}>
        <h3 style={{ fontSize:16, fontWeight:700, marginBottom:12 }}>
          {result ? "Review recorded" : `Record review — ${clientName || slug}`}
        </h3>

        {result ? (
          <div>
            <div style={greenBox}>
              {result.completion?.name || "The review was recorded."}
            </div>
            {result.new_cycle && (
              <div style={{ fontSize:13, color:T.muted, marginTop:12 }}>
                Cycle advanced to Y{result.new_cycle.contract_year} R{result.new_cycle.review_number}.
                Next audit {fmtDateOnly(result.new_cycle.next_audit_date)}; credentials
                request {fmtDateOnly(result.new_cycle.request_creds_date)}.
              </div>
            )}
            {cycleWarnings(result).map((w, i) => (
              <div key={w.kind || i} style={{ ...amberBox, marginTop:12 }}>
                {w.message}
              </div>
            ))}
            {result.tracking_updated === false && (
              <div style={{ ...amberBox, marginTop:12 }}>
                The review was recorded, but the tracking row was not updated —
                fix it by hand in CRM. ({result.tracking_error || "no detail"})
              </div>
            )}
            {result.completion?.review_type === "no-show" && (
              result.notice_paused ? (
                <div style={{ ...neutralBox, marginTop:12 }}>
                  Automated email notices are paused right now. The no-show was
                  recorded, and the booking-link choice still controlled the
                  cycle and allowance result.
                </div>
              ) : result.notice_sent ? (
                <>
                  <div style={{ ...greenBox, marginTop:12 }}>
                    Notice sent to the customer's contacts, cc'ing the SecureShield365 team.
                  </div>
                  {result.notice_stamp_error && (
                    <div style={{ ...amberBox, marginTop:12 }}>
                      The notice went out, but recording the sent time failed —
                      the completion row shows no notice timestamp. ({result.notice_stamp_error})
                    </div>
                  )}
                </>
              ) : (
                <div style={{ ...amberBox, marginTop:12 }}>
                  The no-show was recorded, but the notice was NOT
                  sent: {result.notice_reason || "no detail"}. Follow up with the
                  customer manually.
                </div>
              )
            )}
            <div style={{ display:"flex", justifyContent:"flex-end", marginTop:16 }}>
              <Btn pri onClick={onClose}>Done</Btn>
            </div>
          </div>
        ) : contextError ? (
          <div>
            <div style={redBox}>{contextError}</div>
            <div style={{ display:"flex", justifyContent:"flex-end", marginTop:16 }}>
              <Btn onClick={onClose}>Close</Btn>
            </div>
          </div>
        ) : !context ? (
          <Skeleton height={140} />
        ) : (
          <div>
            {/* Confirm-safety context — says what pressing the button
                will DO, for the outcome currently selected, not a status
                dump. The customer name appears once (line 1); the title
                already carries it. The reporting view is PR 3 (admin
                ops). */}
            <div style={{ fontSize:13, color:T.muted, padding:"10px 12px", border:`1px solid ${T.border}`, borderRadius:10, marginBottom:14 }}>
              {bankedCycle ? (
                <>
                  <div>
                    Contract year {context.cycle.contract_year ?? "—"} — this records
                    {" "}{clientName || slug} against the Banked review allowance.
                  </div>
                  <div style={{ marginTop:4 }}>
                    {reviewType === "redo-requested"
                      ? "This does not use a Banked review, and a new booking link goes out."
                      : reviewType === "re-review" || reviewType === "off-cycle"
                      ? "This does not use a Banked review."
                      : reviewType === "no-show"
                        ? (bookingChoice === null
                          ? "Whether this uses a Banked review depends on the booking-link choice below."
                          : bookingChoice
                            ? "This does not use a Banked review, and the current window stays where it is."
                            : `This uses one Banked review for the current window. ${bankedRemainingAfterText(context)}`)
                        : `This uses one Banked review for the current window. ${bankedRemainingAfterText(context)}`}
                  </div>
                </>
              ) : onCycle ? (
                <>
                  <div>
                    Contract year {context.cycle.contract_year} — this completes
                    {" "}{clientName || slug}'s {ordinal(context.cycle.review_number)} review.
                  </div>
                  {/* This line describes the SELECTED review type. A
                      standard review counts and moves the cycle; a no-show
                      counts only when no booking link goes out (ADR-0087);
                      the rest record without touching the four.

                      The no-show line waits for the booking choice rather
                      than guessing: before that choice is made this press
                      genuinely has two different consequences, and naming
                      one of them would be a claim the dialog cannot yet
                      support. */}
                  <div style={{ marginTop:4 }}>
                    {reviewType === "redo-requested"
                      ? `This does not count toward the ${perYear}, and the next audit date stays where it is — send a new booking link.`
                      : reviewType === "re-review" || reviewType === "off-cycle"
                      ? `This does not count toward the ${perYear}.`
                      : reviewType === "no-show"
                        ? (bookingChoice === null
                          ? `Whether this counts toward the ${perYear} depends on the booking-link choice below.`
                          : bookingChoice
                            ? `This does not count toward the ${perYear}, and the next audit date stays where it is.`
                            : `This uses one of the ${perYear} and advances the cycle — that leaves ${perYear - context.cycle.review_number} of ${perYear} for the rest of the contract year.`)
                        : `That leaves ${perYear - context.cycle.review_number} of ${perYear} for the rest of the contract year.`}
                  </div>
                </>
              ) : (
                <div>Not on a review cycle — recording this will not change any dates.</div>
              )}
              {context.last_completion && (
                <div style={{ marginTop:4 }}>
                  Last review: {fmtDateOnly(context.last_completion.review_date)}
                  {context.last_completion.reviewer_name ? ` — ${context.last_completion.reviewer_name}` : ""}
                  {/* Past work, so the same rename applies here. */}
                  {context.last_completion.review_type
                    ? `, ${reviewTypeDisplayLabel(context.last_completion.review_type)}` : ""}
                  {daysAgo != null ? ` (${daysAgo === 0 ? "today" : daysAgo === 1 ? "1 day ago" : `${daysAgo} days ago`})` : ""}
                </div>
              )}
              {context.allowance?.fallback && (
                <div style={{ fontSize:11, color:T.yellow, marginTop:4 }}>
                  Reviews per year isn't set in CRM — assuming 4.
                </div>
              )}
            </div>

            {!writesEnabled && (
              <div style={{ ...amberBox, marginBottom:14 }}>
                Recording is currently unavailable for this customer —
                contact the SecureShield365 team.
              </div>
            )}

            <div style={{ marginBottom:14 }}>
              <label style={labelStyle}>{REVIEW_TYPE_PICKER_HEADING}</label>
              {REVIEW_OUTCOMES(onCycle, bankedCycle).map(o => {
                // Scheduled is locked when the year is full — the pending
                // next-audit date already belongs to a year that has not
                // started (server-computed scheduled_locked). Re-review
                // and Off-cycle stay available and unhighlighted; they
                // record the review and leave the cycle untouched, which
                // is the right entry for an extra review in a full year
                // (operator decision 2026-08-08).
                const locked = o.key === "scheduled" && !!context.scheduled_locked &&
                  !governedReceiptRetry;
                return (
                <label key={o.key} style={{ display:"flex", gap:8, alignItems:"flex-start", padding:"7px 0", cursor: locked ? "not-allowed" : "pointer", opacity: locked ? 0.5 : 1 }}>
                  <input
                    type="radio"
                    name="review-outcome"
                    checked={reviewType === o.key}
                    disabled={locked}
                    onChange={() => setReviewType(o.key)}
                    style={{ marginTop:2, cursor: locked ? "not-allowed" : "pointer" }}
                  />
                  <span style={{ fontSize:13, color:T.text }}>
                    {o.label}
                    <span style={{ display:"block", fontSize:11, color:T.muted, marginTop:2 }}>{o.desc}</span>
                  </span>
                </label>
                );
              })}
              {context.scheduled_locked && (
                <div style={{ fontSize:11, color:T.yellow, marginTop:4 }}>
                  This customer has used all {perYear} reviews for the contract
                  year, which runs until {fmtDateOnly(context.current_window_end)}.
                  {/* Names only options the picker still OFFERS. Said
                      "a re-review or off-cycle review" until 2026-08-13;
                      Re-review left the picker, so half that instruction
                      pointed at a control the reader could no longer see. */}
                  {governedReceiptRetry
                    ? "Only the unresolved original result can be retried; a new scheduled review remains blocked."
                    : "Record this as an off-cycle review."}
                </div>
              )}
              {reviewType === null && !context.scheduled_locked && (
                <div style={{ fontSize:11, color:T.muted, marginTop:4 }}>
                  The last review was recent — choose the outcome to continue.
                </div>
              )}
            </div>

            {noShow && (
              <div style={{ marginBottom:14, padding:12, border:`1px solid ${T.border}`, borderRadius:10 }}>
                {noShowNoticePaused ? (
                  <div style={{ ...neutralBox, marginBottom:10 }}>
                    Automated email notices are paused right now. This still records
                    the no-show, and the booking-link choice below still controls the
                    cycle and allowance result.
                  </div>
                ) : contacts === null ? (
                  <div style={{ fontSize:12, color:T.muted, marginBottom:10 }}>
                    A notice will be emailed to this customer's technical and
                    executive contacts, cc'ing the SecureShield365 team.
                  </div>
                ) : contacts.length > 0 ? (
                  <div style={{ fontSize:12, color:T.muted, marginBottom:10 }}>
                    The notice will be emailed
                    to {contacts.map(c => c.name || c.email).join(", ")}, cc'ing
                    the SecureShield365 team.
                  </div>
                ) : (
                  <div style={{ ...amberBox, marginBottom:10 }}>
                    No technical or executive contact is set on this customer's
                    profile — the notice will have nowhere to go. The no-show
                    still records; set a contact and follow up manually.
                  </div>
                )}
                <label style={labelStyle}>Booking link</label>
                {BOOKING_LINK_OPTIONS(onCycle, bankedCycle).map(opt => (
                  <label key={String(opt.value)} style={{ display:"flex", gap:8, alignItems:"flex-start", padding:"5px 0", cursor:"pointer" }}>
                    <input
                      type="radio"
                      name="booking-link"
                      checked={bookingChoice === opt.value}
                      onChange={() => setBookingChoice(opt.value)}
                      style={{ marginTop:2, cursor:"pointer" }}
                    />
                    <span style={{ fontSize:13, color:T.text }}>
                      {opt.label}
                      <span style={{ display:"block", fontSize:11, color:T.muted, marginTop:2 }}>{opt.desc}</span>
                    </span>
                  </label>
                ))}
                {bookingChoice === null && (
                  <div style={{ fontSize:11, color:T.yellow, marginTop:4 }}>
                    Choose whether to include a booking link.
                  </div>
                )}
              </div>
            )}

            <div style={{ marginBottom:14, maxWidth:220 }}>
              <label style={labelStyle}>Review date</label>
              <input
                type="date"
                value={reviewDate}
                max={today}
                onChange={e => setReviewDate(e.target.value)}
                style={{ ...inputStyle, colorScheme:"dark" }}
              />
              {!dateOk && reviewDate && (
                <div style={{ fontSize:11, color:T.red, marginTop:4 }}>
                  Reviews are recorded after they happen — the date can't be in the future.
                </div>
              )}
            </div>

            <div style={{ marginBottom:14 }}>
              <label style={labelStyle}>Note <span style={{ fontWeight:400 }}>(optional)</span></label>
              <input
                value={note}
                onChange={e => setNote(e.target.value)}
                style={inputStyle}
                placeholder="Anything worth remembering about this review"
                maxLength={2000}
              />
            </div>

            {pendingCompletionDate && (
              <div style={{ ...amberBox, marginBottom:12 }}>
                A review result from {pendingCompletionDate} is unresolved. Re-enter
                the original review details to retry it, or ask staff to reconcile it.
              </div>
            )}
            {pendingCompletionError && (
              <div style={{ ...redBox, marginBottom:12 }}>{pendingCompletionError}</div>
            )}
            {error && <div style={{ ...redBox, marginBottom:12 }}>{error}</div>}

            <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", gap:12 }}>
              <span style={{ fontSize:11, color:T.muted }}>Recorded as {reviewerLabel}</span>
              <div style={{ display:"flex", gap:8 }}>
                <Btn onClick={() => { if (!busy) onClose(); }}>Cancel</Btn>
                <Btn pri onClick={handleSubmit} disabled={!canSubmit}>
                  {busy ? "Recording…" : noShow ? "Record no-show" : "Record review"}
                </Btn>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>,
    document.body
  );
};

export const ReviewCompleteButton = ({ slug, clientName, isPatriot = false, deliveryMode = false }) => {
  const { user } = useUserContext();
  const [open, setOpen] = useState(false);
  // Same visibility pattern as the other Patriot-only surfaces —
  // hiding in presentation mode is what keeps it off the shared screen.
  if (!isPatriot || deliveryMode || !slug) return null;
  return (
    <>
      <Btn onClick={() => setOpen(true)}>Review complete</Btn>
      <RecordReviewModal
        show={open}
        slug={slug}
        clientName={clientName}
        reviewerLabel={user?.name || user?.email || "you"}
        onClose={() => setOpen(false)}
      />
    </>
  );
};

// customerManagerName / customerManagerEmail ride in from clientInfo (the
// /api/client/{slug} payload the shell already fetches) rather than being
// fetched here — the Account card must not add a request to a page that
// already makes several, and an absent name is a render decision, not a
// loading state.
export const CompanyProfilePage = ({ slug, portalDomains, clientName = "", deliveryMode = false, customerManagerName = "", customerManagerEmail = "", onNavSupport, onProductAnalyticsAction }) => {
  const { user } = useUserContext();
  const [reviewView, refetchReviewView] = useReviewBookingView(slug);
  const hasBankedReviewSurface = reviewView?.mode === "banked";
  const [members, setMembers] = useState(null); // null = loading
  const [loadError, setLoadError] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");         // free-text path (internal / fallback)
  const [localPart, setLocalPart] = useState(""); // domain-locked path (customer users)
  const [notes, setNotes] = useState("");
  // Patriot-only: skip the Microsoft invitation email so Patriot can
  // send its own welcome on its own schedule (operator decision
  // 2026-08-05). Default OFF; the server ignores it for customers.
  const [suppressInvite, setSuppressInvite] = useState(false);
  // Role picker: null = "follow the computed default" (below); a string
  // means the user explicitly chose. Reset to null after each submit so
  // the default re-applies for the next add.
  const [newRole, setNewRole] = useState(null);
  const [submitState, setSubmitState] = useState(null); // null | "loading" | {ok:true, added?|review?|manual?} | {error, fields?}
  // Disable flow: member pending confirmation, in-flight flag, last error.
  const [disableTarget, setDisableTarget] = useState(null);
  const [disabling, setDisabling] = useState(false);
  const [disableError, setDisableError] = useState(null);
  // Role-change flow: row id in flight + last error.
  const [roleBusy, setRoleBusy] = useState(null);
  const [roleError, setRoleError] = useState(null);
  // Primary-contact flow: row id in flight (reuses roleError for display).
  const [primaryBusy, setPrimaryBusy] = useState(null);

  // Server-resolved capability set (customer RBAC). Display truth only —
  // every management endpoint re-checks server-side. null = loading:
  // manage controls render NEUTRAL (nothing) until resolved, never the
  // members-only restriction copy. capsState distinguishes "you are a
  // Member" (resolved) from "role unavailable right now" (degraded —
  // metadata-cache window, Dataverse hiccup, or a failed /me): a real
  // Access Manager in a degraded window must never be told to go ask
  // their Access Manager. Internal users skip the fetch — require_patriot
  // gives them everything.
  const [caps, setCaps] = useState(null);
  const [capsState, setCapsState] = useState("resolved");
  useEffect(() => {
    let cancelled = false;
    if (user?.isInternal) { setCaps({ manageAccess: true }); setCapsState("resolved"); return; }
    setCaps(null); setCapsState("resolved");
    fetchMe()
      .then(d => {
        if (cancelled) return;
        setCaps(d?.capabilities || { manageAccess: false });
        setCapsState(d?.capabilities_state === "degraded" ? "degraded" : "resolved");
      })
      .catch(() => {
        if (cancelled) return;
        setCaps({ manageAccess: false });
        setCapsState("degraded"); // couldn't confirm — not a role verdict
      });
    return () => { cancelled = true; };
  }, [user?.isInternal]);
  const canManage = !!caps?.manageAccess;

  // Role-picker default, mirroring the roster gate's bootstrap predicate
  // (shared/auth.py) against the roster this page already loaded: no
  // Active rows AND no tombstones (pending-only counts as
  // never-provisioned) → Access Manager, else Member. For customer
  // managers this always lands on Member (they themselves are an Active
  // row); it only varies for Patriot seeding a customer's first user —
  // the exact case where a Member default would strand a customer with
  // zero Access Managers (the account-seeding gap, 2026-08-01). Unlike
  // the bootstrap, the human can override either way. status_value
  // ints, never labels (operator-verified 2026-07-02).
  const defaultRole = useMemo(() => {
    if (!Array.isArray(members)) return "member";
    const hasActive = members.some(m => m.status_value === 125470001);
    const hasTombstone = members.some(m =>
      [125470002, 125470003, 125470004].includes(m.status_value));
    return (!hasActive && !hasTombstone) ? "access_manager" : "member";
  }, [members]);
  const effectiveRole = newRole ?? defaultRole;

  // Dataverse-governed request domains (pc_customers.pc_portaldomains,
  // comma-separated). When seeded, these lock the suffix for BOTH customer
  // and internal users and take precedence over the fallbacks below.
  const dvDomains = useMemo(
    () => (portalDomains || "")
      .split(",")
      .map(d => d.trim().toLowerCase())
      .filter(Boolean),
    [portalDomains]
  );
  const [dvDomain, setDvDomain] = useState(""); // multi-domain pick
  useEffect(() => { setDvDomain(""); }, [slug]);

  // Fallback when pc_portaldomains is unseeded — customer users lock to
  // their own sign-in domain. No free text for customers, ever: if this
  // can't be derived either, the form blocks with a contact-Patriot notice.
  const userDomain = (user?.email || "").includes("@")
    ? (user.email.split("@").pop() || "").trim().toLowerCase()
    : "";
  const dvLocked = dvDomains.length > 0;
  const domainLocked = !dvLocked && !user?.isInternal && !!userDomain;

  // Internal fallback when pc_portaldomains is unseeded: the CUSTOMER's FS
  // domains (input hygiene against typo'd/wrong-domain emails — the
  // ticket_dashboard domain gate is the enforcement layer, so zero domains /
  // fetch failure fails OPEN to free text with a hint). null =
  // loading/unfetched, [] = none-or-failed, [..] = locked to the list.
  const [fsDomains, setFsDomains] = useState(null);
  const [internalDomain, setInternalDomain] = useState(""); // multi-domain pick
  useEffect(() => {
    let cancelled = false;
    if (!slug || !user?.isInternal) { setFsDomains(null); return; }
    setFsDomains(null); setInternalDomain("");
    fetchCompanyDomains(slug)
      .then(d => {
        if (cancelled) return;
        const domains = (Array.isArray(d?.domains) ? d.domains : [])
          .map(x => String(x).trim().toLowerCase()).filter(Boolean);
        setFsDomains(domains);
      })
      .catch(() => { if (!cancelled) setFsDomains([]); });
    return () => { cancelled = true; };
  }, [slug, user?.isInternal]);

  const internalLocked = !dvLocked && !!(user?.isInternal && Array.isArray(fsDomains) && fsDomains.length > 0);
  const lockedDomain = dvLocked ? (dvDomain || dvDomains[0])
    : domainLocked ? userDomain
    : internalLocked ? (internalDomain || fsDomains[0])
    : "";
  const locked = dvLocked || domainLocked || internalLocked;
  // Multi-domain pick: Dataverse list when seeded, else the FS list (internal).
  const lockedDomains = dvLocked ? dvDomains : internalLocked ? fsDomains : [];
  const onPickDomain = dvLocked ? setDvDomain : setInternalDomain;
  // Customer users with no Dataverse domains AND no derivable sign-in domain
  // get a blocked form, never free text.
  const customerBlocked = !user?.isInternal && !locked;

  const tdStyle = { padding:"10px 8px", borderBottom:`1px solid ${T.border}`, fontSize:13 };
  const thStyle = { padding:"10px 8px", borderBottom:`1px solid ${T.border}`, textAlign:"left", fontSize:12, color:T.muted, fontWeight:600, textTransform:"uppercase", letterSpacing:".04em" };
  const labelStyle = { display:"block", fontSize:12, color:T.muted, marginBottom:6, fontWeight:600 };
  const inputStyle = {
    width:"100%", background:"rgba(255,255,255,0.05)", border:`1px solid ${T.border}`,
    borderRadius:8, color:T.text, fontSize:13, padding:"9px 12px", fontFamily:"inherit", outline:"none",
  };

  // Self-fetch with the house cancelled-guard; refreshKey bumps re-fetch
  // after a successful request submission.
  useEffect(() => {
    let cancelled = false;
    if (!slug) return;
    setMembers(null); setLoadError(false);
    fetchAccessList(slug)
      .then(d => { if (!cancelled) setMembers(Array.isArray(d) ? d : []); })
      .catch(() => { if (!cancelled) setLoadError(true); });
    return () => { cancelled = true; };
  }, [slug, refreshKey]);

  const emailOk = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim());
  const localPartOk = /^[^\s@]+$/.test(localPart.trim());
  const effectiveEmail = locked ? `${localPart.trim()}@${lockedDomain}` : email.trim();
  const canSubmit = name.trim().length > 0 && !customerBlocked && (locked ? localPartOk : emailOk);

  const handleDisable = async () => {
    if (!disableTarget || disabling) return;
    setDisabling(true); setDisableError(null);
    try {
      const updated = await disableAccessMember(slug, disableTarget.id);
      // Patch the flipped row in place (server truth: status now Removed) —
      // no full refetch needed just to repaint one badge.
      setMembers(ms => (ms || []).map(m => (m.id === updated.id ? updated : m)));
      setDisableTarget(null);
    } catch (e) {
      if (e.status === 409) {
        // Someone else already flipped this row — our list is stale; re-sync.
        setDisableError("That member is no longer Active — the list has been refreshed.");
        setRefreshKey(k => k + 1);
      } else {
        setDisableError("Couldn't disable that member — please try again, or contact your Patriot team if this persists.");
      }
      setDisableTarget(null);
    } finally {
      setDisabling(false);
    }
  };

  // Promote/demote an Active member. The backend guards the last Access
  // Manager demoting themself; enforcement follows within ~2 minutes
  // (roster verdict TTL), same as disable.
  const handleRoleToggle = async (m) => {
    if (roleBusy) return;
    const next = m.role_key === "access_manager" ? "member" : "access_manager";
    setRoleBusy(m.id); setRoleError(null);
    try {
      const updated = await setAccessRole(slug, m.id, next);
      setMembers(ms => (ms || []).map(x => (x.id === updated.id ? updated : x)));
    } catch (e) {
      if (e.status === 409 && e.body && e.body.error === "last_access_manager") {
        setRoleError("You're the only Access Manager — make a teammate a manager before stepping down.");
      } else if (e.status === 409) {
        setRoleError("That member is no longer Active — the list has been refreshed.");
        setRefreshKey(k => k + 1);
      } else {
        setRoleError("Couldn't change that role — please try again, or contact your Patriot team if this persists.");
      }
    } finally {
      setRoleBusy(null);
    }
  };

  // ONE add path for customer managers AND Patriot (Option A decision,
  // 2026-08-01): both go through /add and the shared provisioning
  // pipeline. Patriot's old request→self-approve round trip was
  // self-review ceremony, and its approve backstop activated null-role
  // rows as Member — which skipped the bootstrap for seeded accounts
  // and could strand a customer with zero Access Managers.
  // Make a member the ONE technical or executive contact (who we email
  // about technical matters / business matters). One handler for both
  // kinds; the server clears the prior holder of that kind in the same
  // operation, so patch BOTH rows locally: set the target, clear
  // everyone else's same-kind flag. JSON field names keep their
  // column-derived literals (primary = technical).
  const handleMakeContact = async (m, kind) => {
    const flagField = kind === "technical" ? "primary" : "executive";
    if (primaryBusy) return;
    setPrimaryBusy(`${m.id}:${kind}`); setRoleError(null);
    try {
      const updated = await (kind === "technical"
        ? setAccessPrimary : setAccessExecutive)(slug, m.id);
      setMembers(ms => (ms || []).map(x =>
        x.id === updated.id ? updated
          : (x[flagField] ? { ...x, [flagField]: false } : x)
      ));
    } catch (e) {
      if (e.status === 409) {
        setRoleError("That member is no longer Active — the list has been refreshed.");
        setRefreshKey(k => k + 1);
      } else {
        setRoleError(`Couldn't update the ${kind} contact — please try again, or contact your Patriot team if this persists.`);
      }
    } finally {
      setPrimaryBusy(null);
    }
  };

  const handleSubmit = async () => {
    if (!canSubmit || submitState === "loading") return;
    setSubmitState("loading");
    try {
      const resp = await addAccessMember(slug, {
        name: name.trim(),
        email: effectiveEmail,
        role: effectiveRole,
        notes: notes.trim() || undefined,
        suppressInvite,
      });
      setName(""); setEmail(""); setLocalPart(""); setNotes(""); setNewRole(null);
      // Reset the suppression choice too — it must never carry silently
      // into the next person added.
      setSuppressInvite(false);
      // Server truth, never the checkbox: a request the server ignored
      // must not produce a "no email sent" message.
      if (resp.status === "active") setSubmitState({
        ok: true, added: true, suppressed: !!resp.invite_email_suppressed,
      });
      else if (resp.status === "pending_review") setSubmitState({ ok: true, review: true });
      else setSubmitState({ ok: true, manual: true });
      setRefreshKey(k => k + 1);
    } catch (e) {
      if (e.status === 409) {
        setSubmitState({ error: "That person already has portal access or a pending request." });
      } else if (e.status === 403) {
        setSubmitState({ error: "Only Access Managers can add members — the list has been refreshed." });
        setRefreshKey(k => k + 1);
      } else if (e.status === 400 && e.body && e.body.fields) {
        setSubmitState({ error: "Please correct the following:", fields: e.body.fields });
      } else {
        setSubmitState({ error: "Couldn't add that member — please try again, or contact your Patriot team if this persists." });
      }
    }
  };

  return (
    <div>
      <h2 style={{ margin:"0 0 16px", fontSize:18, fontWeight:800 }}>Company Profile</h2>

      {/* Self-book panel FIRST on Company Profile (James, 2026-08-21):
          the review entitlement is a primary paid value, not a utility
          widget below access management. Renders NOTHING for a Legacy or
          blank-mode customer, so their page shape stays the same. For
          Banked, the scan action is embedded here so booking and scan
          are one action surface rather than two separate cards. */}
      <ReviewBookingPanel
        slug={slug}
        view={reviewView}
        refetch={refetchReviewView}
        onNavSupport={onNavSupport}
        onProductAnalyticsAction={onProductAnalyticsAction}
      >
        <CustomerScanCard slug={slug} clientName={clientName} embedded onProductAnalyticsAction={onProductAnalyticsAction} />
      </ReviewBookingPanel>

      {/* ── SECTION 1 — Portal Access ── */}
      <Card title="Portal Access">
        {loadError ? (
          <div style={{ textAlign:"center", padding:"22px 8px" }}>
            <div style={{ fontSize:14, fontWeight:700, color:T.red, marginBottom:6 }}>Couldn't load the access list</div>
            <div style={{ fontSize:13, color:T.muted }}>Please refresh, or contact your Patriot team if this persists.</div>
          </div>
        ) : members === null ? (
          <Skeleton height={120} />
        ) : (
          <table style={{ width:"100%", borderCollapse:"collapse" }}>
            <thead><tr>{["Name","Email","Status","Role","Contacts","Last login","Requested",""].map((h, i) => <th key={i} style={thStyle}>{h}</th>)}</tr></thead>
            <tbody>
              {members.length === 0 ? (
                <tr>
                  <td colSpan={8} style={{ ...tdStyle, textAlign:"center", color:T.muted, padding:"22px 8px" }}>
                    {canManage
                      ? "No portal members listed yet — add your team below."
                      : "No portal members listed yet."}
                  </td>
                </tr>
              ) : members.map(m => {
                // Manage actions (disable, role change, make primary)
                // show only for Access Managers / internal users on
                // Active rows (status_value int, never the label string)
                // — the backend re-checks all of it, hiding is cosmetic.
                // Self-disable is refused server-side, so don't offer it.
                const isSelf = !!(user?.email) &&
                  (m.email || "").trim().toLowerCase() === user.email.trim().toLowerCase();
                const isActive = m.status_value === 125470001;
                const isManagerRow = m.role_key === "access_manager";
                const canDisable = canManage && isActive && !isSelf;
                const canToggleRole = canManage && isActive;
                const canMakeTechnical = canManage && isActive && !m.primary;
                const canMakeExecutive = canManage && isActive && !m.executive;
                const actionLinkStyle = { background:"none", border:"none", padding:0, color:T.muted, fontSize:12, fontFamily:"inherit", cursor:"pointer", textDecoration:"underline", textUnderlineOffset:3 };
                return (
                <tr key={m.id}>
                  <td style={{ ...tdStyle, fontWeight:600 }}>{m.name || "—"}</td>
                  <td style={{ ...tdStyle, color:T.muted }}>{m.email || "—"}</td>
                  <td style={tdStyle}>
                    <Badge type={ACCESS_STATUS_BADGE[m.status] || "slate"} weight="soft">{m.status || "—"}</Badge>
                    {m.status_reason && (
                      <div style={{ fontSize:11, color:T.muted, marginTop:4 }}>{m.status_reason}</div>
                    )}
                  </td>
                  <td style={{ ...tdStyle, color: isManagerRow ? T.text : T.muted, fontWeight: isManagerRow ? 600 : 400 }}>
                    {/* Stable role_key, never the Dataverse label; a null
                        role renders (and is enforced) as Member. */}
                    {isManagerRow ? "Access Manager" : "Member"}
                  </td>
                  <td style={tdStyle}>
                    {/* Contact designations, independent of role. Shown
                        on any row that carries them (a tombstoned
                        contact is a visible gap, not a mailing target).
                        UI says technical/executive; the data fields keep
                        their column-derived names. */}
                    {!m.primary && !m.executive && <span style={{ color:T.muted }}>—</span>}
                    {m.primary && <Badge type="green" weight="soft">Technical contact</Badge>}
                    {m.executive && (
                      <span style={{ marginLeft: m.primary ? 6 : 0 }}>
                        <Badge type="blue" weight="soft">Executive contact</Badge>
                      </span>
                    )}
                  </td>
                  <td style={{ ...tdStyle, color:T.muted }}>{m.last_login ? fmtTicketDate(m.last_login) : "Never"}</td>
                  <td style={{ ...tdStyle, color:T.muted }}>{fmtTicketDate(m.requested_on || m.created_on)}</td>
                  <td style={{ ...tdStyle, textAlign:"right", whiteSpace:"nowrap" }}>
                    {canMakeTechnical && (
                      <button
                        onClick={() => handleMakeContact(m, "technical")}
                        disabled={primaryBusy === `${m.id}:technical`}
                        style={{ ...actionLinkStyle, marginRight: 12, opacity: primaryBusy === `${m.id}:technical` ? .6 : 1 }}
                      >
                        {primaryBusy === `${m.id}:technical` ? "Saving…" : "Make technical contact"}
                      </button>
                    )}
                    {canMakeExecutive && (
                      <button
                        onClick={() => handleMakeContact(m, "executive")}
                        disabled={primaryBusy === `${m.id}:executive`}
                        style={{ ...actionLinkStyle, marginRight: (canToggleRole || canDisable) ? 12 : 0, opacity: primaryBusy === `${m.id}:executive` ? .6 : 1 }}
                      >
                        {primaryBusy === `${m.id}:executive` ? "Saving…" : "Make executive contact"}
                      </button>
                    )}
                    {canToggleRole && (
                      <button
                        onClick={() => handleRoleToggle(m)}
                        disabled={roleBusy === m.id}
                        style={{ ...actionLinkStyle, marginRight: canDisable ? 12 : 0, opacity: roleBusy === m.id ? .6 : 1 }}
                      >
                        {roleBusy === m.id ? "Saving…" : isManagerRow ? "Make member" : "Make manager"}
                      </button>
                    )}
                    {canDisable && (
                      <button
                        onClick={() => { setDisableError(null); setDisableTarget(m); }}
                        style={actionLinkStyle}
                      >
                        Disable
                      </button>
                    )}
                  </td>
                </tr>
                );
              })}
            </tbody>
          </table>
        )}

        {disableError && (
          <div style={{ padding:10, marginTop:12, background:"rgba(225,77,87,0.1)", borderRadius:10, border:"1px solid rgba(225,77,87,0.3)" }}>
            <p style={{ color:T.red, fontSize:13 }}>{disableError}</p>
          </div>
        )}
        {roleError && (
          <div style={{ padding:10, marginTop:12, background:"rgba(225,77,87,0.1)", borderRadius:10, border:"1px solid rgba(225,77,87,0.3)" }}>
            <p style={{ color:T.red, fontSize:13 }}>{roleError}</p>
          </div>
        )}

        <Modal
          show={!!disableTarget}
          title="Disable portal access"
          onClose={() => { if (!disabling) setDisableTarget(null); }}
          onSubmit={handleDisable}
          submitLabel={disabling ? "Disabling…" : "Disable"}
        >
          Disable {disableTarget?.name || disableTarget?.email || "this member"}?
          They will lose portal access within a few minutes. Contact your
          Patriot team if you need to restore it later.
        </Modal>

        {/* ── Add / request access — inline form (no modal). Visible only
            to Access Managers and internal users; the backend re-checks,
            hiding the form is cosmetic. Members get a pointer instead;
            nothing renders while capabilities are still loading
            (fail-closed cosmetically). ── */}
        {!canManage ? (caps === null ? null : (
          <div style={{ marginTop:18, paddingTop:16, borderTop:`1px solid ${T.border}`, fontSize:12, color:T.muted }}>
            {capsState === "degraded"
              ? "We couldn't confirm your role just now, so member management is temporarily unavailable — refresh in a minute or two, or contact your Patriot team if this persists."
              : "Adding or removing members is handled by your team's Access Managers — ask one of them, or contact your Patriot team."}
          </div>
        )) : (
        <div style={{ marginTop:18, paddingTop:16, borderTop:`1px solid ${T.border}` }}>
          <div style={{ fontSize:13, fontWeight:700, marginBottom:6 }}>Add a team member</div>
          <div style={{ fontSize:12, color:T.muted, marginBottom:12 }}>
            {user?.isInternal
              ? "Adds take effect immediately — you're acting on behalf of this customer. Shared-mailbox addresses (support@, info@, …) are held for review first."
              : "New members are set up right away and appear as Active. Shared-mailbox addresses (support@, info@, …) are held for a quick review first."}
          </div>
          <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:12, marginBottom:12 }}>
            <div>
              <label style={labelStyle}>Name</label>
              <input value={name} onChange={e => setName(e.target.value)} style={inputStyle} placeholder="Full name" maxLength={200} />
            </div>
            <div>
              <label style={labelStyle}>Email</label>
              {customerBlocked ? (
                <>
                  {/* Fail closed for customers: no Dataverse domains and no
                      derivable sign-in domain → no address can be composed. */}
                  <input value="" disabled readOnly style={{ ...inputStyle, opacity:.55, cursor:"not-allowed" }} placeholder="Contact Patriot to add users" />
                  <div style={{ fontSize:11, color:T.muted, marginTop:6 }}>
                    Contact Patriot to add users — we couldn't determine your company's email domain.
                  </div>
                </>
              ) : locked ? (
                <>
                  {/* One visual field: editable local part + locked domain
                      suffix (Dataverse portal domains when seeded — both user
                      types; else customer: their own domain; internal: the
                      customer's FS domains). A select when there's more
                      than one. */}
                  <div style={{ ...inputStyle, display:"flex", alignItems:"center", padding:0 }}>
                    <input
                      value={localPart}
                      onChange={e => setLocalPart(e.target.value.replace(/@/g, ""))}
                      style={{ flex:1, minWidth:0, background:"transparent", border:"none", outline:"none", color:T.text, fontSize:13, padding:"9px 2px 9px 12px", fontFamily:"inherit" }}
                      placeholder="name"
                      maxLength={200}
                    />
                    {lockedDomains.length > 1 ? (
                      <select
                        value={lockedDomain}
                        onChange={e => onPickDomain(e.target.value)}
                        style={{ background:"transparent", border:"none", outline:"none", color:T.muted, fontSize:13, padding:"0 12px 0 2px", fontFamily:"inherit", cursor:"pointer" }}
                      >
                        {lockedDomains.map(d => <option key={d} value={d} style={{ background:T.panel }}>@{d}</option>)}
                      </select>
                    ) : (
                      <span style={{ color:T.muted, fontSize:13, padding:"0 12px 0 2px", whiteSpace:"nowrap" }}>@{lockedDomain}</span>
                    )}
                  </div>
                  {!user?.isInternal && (
                    <div style={{ fontSize:11, color:T.muted, marginTop:6 }}>
                      Need to add someone with a different email domain? Contact your Patriot team.
                    </div>
                  )}
                </>
              ) : (
                <>
                  <input type="email" value={email} onChange={e => setEmail(e.target.value)} style={inputStyle} placeholder="name@company.com" maxLength={320} />
                  {user?.isInternal && Array.isArray(fsDomains) && fsDomains.length === 0 && (
                    <div style={{ fontSize:11, color:T.muted, marginTop:6 }}>
                      Use the person's company email domain. If your company's domain isn't shown here, contact your Patriot team to have it added.
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
          <div style={{ marginBottom:12, maxWidth:280 }}>
            <label style={labelStyle}>Role</label>
            <select
              value={effectiveRole}
              onChange={e => setNewRole(e.target.value)}
              style={{ ...inputStyle, cursor:"pointer" }}
            >
              <option value="member" style={{ background:T.panel }}>Member</option>
              <option value="access_manager" style={{ background:T.panel }}>Access Manager — can add and remove members</option>
            </select>
            {user?.isInternal && defaultRole === "access_manager" && (
              <div style={{ fontSize:11, color:T.muted, marginTop:6 }}>
                This customer has no Access Manager yet — the first person you add defaults to Access Manager.
              </div>
            )}
          </div>
          <div style={{ marginBottom:12 }}>
            <label style={labelStyle}>Notes <span style={{ fontWeight:400 }}>(optional)</span></label>
            <input value={notes} onChange={e => setNotes(e.target.value)} style={inputStyle} placeholder="Role or reason for access" maxLength={4000} />
          </div>

          {/* Patriot-only. The server enforces this too — a customer
              sending the flag is ignored — so this is a convenience,
              not the gate. */}
          {user?.isInternal && (
            <div style={{ marginBottom:12 }}>
              <label style={{ display:"flex", gap:8, alignItems:"flex-start", fontSize:13, color:T.text, cursor:"pointer" }}>
                <input
                  type="checkbox"
                  checked={suppressInvite}
                  onChange={e => setSuppressInvite(e.target.checked)}
                  style={{ marginTop:2, cursor:"pointer" }}
                />
                <span>
                  Don't send the Microsoft invitation email (we'll send our own welcome)
                  <span style={{ display:"block", fontSize:11, color:T.muted, marginTop:3 }}>
                    They'll still get portal access immediately — they just won't hear from Microsoft.
                  </span>
                </span>
              </label>
            </div>
          )}

          {submitState && submitState.ok && (
            <div style={{ padding:10, marginBottom:12, background:"rgba(83,196,109,0.1)", borderRadius:10, border:"1px solid rgba(83,196,109,0.3)" }}>
              <p style={{ color:T.green, fontSize:13 }}>
                {submitState.added ? (submitState.suppressed
                    ? "Member added — they're Active now. No Microsoft invitation email was sent, so remember to send your own welcome."
                    : "Member added — they're Active now. If they're new to the portal, an invitation email is on its way to them.")
                  : submitState.review ? "That address needs a quick review by the SecureShield365 team first — it will show as Pending until approved."
                  : submitState.manual ? "Almost there — we couldn't finish the setup automatically, so the SecureShield365 team will complete it. The member shows as Pending meanwhile."
                  : "Request submitted — our team will review it."}
              </p>
            </div>
          )}
          {submitState && submitState.error && (
            <div style={{ padding:10, marginBottom:12, background:"rgba(225,77,87,0.1)", borderRadius:10, border:"1px solid rgba(225,77,87,0.3)" }}>
              <p style={{ color:T.red, fontSize:13 }}>{submitState.error}</p>
              {submitState.fields && Object.entries(submitState.fields).map(([field, msg]) => (
                <p key={field} style={{ color:T.red, fontSize:12, marginTop:4 }}>{field}: {msg}</p>
              ))}
            </div>
          )}

          <div style={{ display:"flex", justifyContent:"flex-end" }}>
            <Btn pri onClick={handleSubmit} disabled={!canSubmit || submitState === "loading"}>
              {submitState === "loading" ? "Adding…" : "Add member"}
            </Btn>
          </div>
        </div>
        )}
      </Card>

      <UpgradeSection slug={slug} clientName={clientName} />

      {/* Recurring self-scan action — deliberately its own card, not a
          wizard step: the wizard is a one-time migration flow. */}
      {!hasBankedReviewSurface && <CustomerScanCard slug={slug} clientName={clientName} onProductAnalyticsAction={onProductAnalyticsAction} />}

      {/* ── SECTION 2 — Account ──────────────────────────────────────
          CUSTOMER-FACING, and the Customer Manager row is deliberately so:
          the person's name and a way to reach them is the one thing a
          customer most often wants off this card.

          The row is BUILT, not placeheld: when the CRM lookup is empty the
          row is absent entirely rather than rendering "Customer Manager: —".
          A customer reading a dash learns only that we lost track of who
          owns them. Statement of Work and SharePoint Resources are still
          honest placeholders, so the card keeps its shape either way. */}
      <Card title="Account" style={{ marginTop:16 }}>
        {[
          ...(customerManagerName ? [{
            label: CUSTOMER_MANAGER_LABEL,
            // mailto ONLY when the address actually resolved. The aaduser
            // read is fail-soft, so a name with no email is a normal state,
            // not an error — it renders as plain text.
            value: customerManagerEmail ? (
              <a href={`mailto:${customerManagerEmail}`}
                 style={{ color:T.blue, textDecoration:"none" }}
                 title={`Email ${customerManagerName} at ${customerManagerEmail}`}>
                {customerManagerName}
              </a>
            ) : customerManagerName,
          }] : []),
          { label: "Statement of Work", value: null },
          { label: "SharePoint Resources", value: null },
        ].map((row, i, arr) => (
          <div key={row.label} style={{
            display:"flex", justifyContent:"space-between", alignItems:"center",
            padding:"10px 0", fontSize:13,
            borderBottom: i < arr.length - 1 ? `1px solid ${T.border}` : "none",
          }}>
            <span style={{ color:T.muted }}>{row.label}</span>
            {row.value
              ? <span style={{ fontWeight:600 }}>{row.value}</span>
              : <span style={{ color:T.muted, fontStyle:"italic", fontSize:12, opacity:.7 }}>Coming soon</span>}
          </div>
        ))}
        {!!user && !deliveryMode && slug && (
          <AutoRenewCompletedRow key={`${slug}:${!!user.isInternal}`} slug={slug} isInternal={!!user.isInternal} />
        )}
      </Card>
    </div>
  );
};

/* ── Browser-history integration (issue: Back exits the portal) ──
   One history entry per PAGE, written as #/{page}. Admin sub-tabs, filter
   chips, drawers, modals, and the delivery-mode toggle create NO entries.
   The hash coexists with the query-param writers elsewhere (PortalShell's
   ?client= replaceState, the drawer's ?recommendation= replaceState) — all
   of them preserve the hash, and those replaceState calls wipe our history
   state object, so the hash is the durable fallback when state is missing. */
// ── Licensing page (PR3) — a customer's own Microsoft license inventory
//    from the stored snapshot. Copy strings are PINNED by tests (exact
//    operator wording, 2026-08-09): the not-migrated state names the
//    Company Profile "Get started" button verbatim
//    (upgradeWizardContent.getStartedLabel); the migrated state names
//    both actions without privileging the scan (a setup check does not
//    consume the one-per-day scan). The suppressed state renders the
//    SERVER's message verbatim — the no-disclosure copy lives in one
//    place, backend-side.
export const LICENSING_EMPTY_COPY = {
  not_migrated:
    "Your license information comes from SecureScan365. Once your tenant is set up, " +
    "your Microsoft 365 products and seat counts appear here, and we'll go through them " +
    "with you at your next review. Press Get started on your Company Profile.",
  never_collected:
    "No license information yet. Your Microsoft 365 products and seat counts appear " +
    "here after a setup check or a scan — both are on your Company Profile.",
};

export const LicensingPage = ({ slug, onNavProfile, cspOpportunity }) => {
  const [data, setData] = useState(null);          // portal_customer_licensing payload
  const [upgradeState, setUpgradeState] = useState({ slug: null, scanToolKey: null, loading: false });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const usingSharedCspState = cspOpportunity?.hasIdentity === true;
  const sharedSnapshot = cspOpportunity?.snapshot || null;
  const sharedLoading = !!cspOpportunity?.loading;
  const upgradeCurrent = upgradeState.slug === slug ? upgradeState : { scanToolKey: null, loading: true };
  const sharedNeverCollected = sharedSnapshot?.available === false && sharedSnapshot?.reason === "never_collected";
  const licensingData = usingSharedCspState ? sharedSnapshot : data;
  const licensingLoading = usingSharedCspState
    ? sharedLoading || (sharedNeverCollected && upgradeCurrent.loading)
    : loading;
  const licensingError = usingSharedCspState && cspOpportunity?.error
    ? "Couldn't load your license information. Please try again."
    : error;

  useEffect(() => {
    if (!slug) return;
    let alive = true;
    setUpgradeState({ slug, scanToolKey: null, loading: true });
    if (usingSharedCspState) {
      fetchUpgradeStatus(slug).catch(() => ({ scan_tool_key: "securescan365" }))
        .then((upgrade) => { if (alive) setUpgradeState({ slug, scanToolKey: upgrade?.scan_tool_key || null, loading: false }); });
      return () => { alive = false; };
    }
    setLoading(true); setError(""); setData(null);
    Promise.all([
      fetchCustomerLicensing(slug),
      // Same fail-open posture as the scan card: an upgrade-status read
      // failure must never block the page — worst case the migrated
      // empty-state copy shows and Company Profile itself gates.
      fetchUpgradeStatus(slug).catch(() => ({ scan_tool_key: "securescan365" })),
    ])
      .then(([licensing, upgrade]) => {
        if (!alive) return;
        setData(licensing);
        setUpgradeState({ slug, scanToolKey: upgrade?.scan_tool_key || null, loading: false });
      })
      .catch(() => {
        if (alive) setError("Couldn't load your license information. Please try again.");
      })
      .finally(() => { if (alive) setLoading(false); });
    return () => { alive = false; };
  }, [slug, usingSharedCspState]);

  return (
    <Card title="Licensing">
      {licensingLoading && <div style={{ fontSize:13, color:T.muted }}>Loading…</div>}
      {licensingError && <div style={{ fontSize:13, color:T.red }}>{licensingError}</div>}

      {licensingData && licensingData.available === false && licensingData.reason === "not_available" && (
        // Shared-tenant suppression: render the server's pinned message
        // verbatim; no local copy, no explanation, no profile link (the
        // message deliberately points at the review, not at actions).
        <div style={{ border:`1px solid ${T.border}`, borderRadius:10, padding:"14px 16px", fontSize:13, color:T.text }}>
          {licensingData.message}
        </div>
      )}

      {licensingData && licensingData.available === false && licensingData.reason === "never_collected" && !upgradeCurrent.loading && upgradeCurrent.scanToolKey !== "securescan365" && (
        // Migration-encouragement surface: the SAME visual language as the
        // Company Profile upgrade entry — ScanMethodPill's legacy pill and
        // the wizard banner's amber callout values (rgba(243,181,63,.10)
        // bg / .3 border), bullets in the UpgradeValueBlock idiom — so the
        // two pages read as one campaign. The pinned sentence is wrapped,
        // never edited (LicensingPage.test pins it verbatim).
        <div style={{ padding:"14px 16px", borderRadius:10, background:"rgba(243,181,63,.10)", border:"1px solid rgba(243,181,63,.3)", fontSize:13 }}>
          <div style={{ marginBottom:10 }}>
            <ScanMethodPill scanToolKey="legacy" />
          </div>
          <div style={{ color:T.text }}>{LICENSING_EMPTY_COPY.not_migrated}</div>
          <div style={{ fontSize:12, fontWeight:700, textTransform:"uppercase", letterSpacing:".04em", margin:"12px 0 8px", color:T.text }}>What you'll see here</div>
          <ul style={{ margin:0, paddingLeft:18, display:"grid", gap:5, fontSize:13, color:T.muted }}>
            <li>Every Microsoft 365 product on your tenant, with seat counts</li>
            <li>How many licenses are assigned and how many are available</li>
            <li>Refreshed every time a scan runs</li>
          </ul>
          <div style={{ marginTop:12 }}>
            <Btn pri onClick={onNavProfile}>Go to Company Profile</Btn>
          </div>
        </div>
      )}

      {licensingData && licensingData.available === false && licensingData.reason === "never_collected" && !upgradeCurrent.loading && upgradeCurrent.scanToolKey === "securescan365" && (
        // Already migrated: a nudge, not a pitch — the lighter green
        // confirmation treatment from the same profile section
        // (rgba(83,196,109,.06) on the standard border), green pill, no
        // bullet list. Pinned sentence verbatim.
        <div style={{ padding:12, borderRadius:10, background:"rgba(83,196,109,.06)", border:`1px solid ${T.border}`, fontSize:13 }}>
          <div style={{ marginBottom:10 }}>
            <ScanMethodPill scanToolKey="securescan365" />
          </div>
          <div style={{ color:T.muted }}>{LICENSING_EMPTY_COPY.never_collected}</div>
          <div style={{ marginTop:12 }}>
            <Btn onClick={onNavProfile}>Go to Company Profile</Btn>
          </div>
        </div>
      )}

      {licensingData && licensingData.available === true && <LicenseTable data={licensingData} cspPanel={cspOpportunity ? <CspLicensingPanel opportunity={cspOpportunity} /> : null} participatingSkus={cspOpportunity?.participatingSkus} />}
    </Card>
  );
};

const HISTORY_PAGES = new Set(["overview", "queue", "recs", "profile", "azure", "support", "admin", "licensing"]);

// Admin sub-tabs are deep-linkable as #/admin/{tab} so an external link (e.g. a
// Power Automate Teams notification) can land directly on a tab. The set is the
// single source of truth for which sub-segments are valid; values match
// AdminPage's adminTab state exactly (note scans = "SecureScan365",
// scanning = "Scan Fleet", reviews = "Assessments", management =
// "Customer Management").
const ADMIN_TABS = new Set(["publishing", "logins", "access", "contacts", "scans", "scanning", "reviews", "licensing", "management"]);

// ── Inner views: the THIRD hash segment, #/admin/{tab}/{view} ──────────
// ADMIN_TABS is the valid set for the tab; this is the valid set for the
// view, and it lives here for the same reason — one statement of what is
// valid, read by everything that reads or writes the hash.
//
// WHY THIS EXISTS AS A NAMED SET (2026-08-11). #531 shipped a section toggle
// offering two view values with no render branch, so clicking either blanked
// the panel and wrote a bookmarkable URL for a view that draws nothing. The
// state initialiser HAD a validity check, inline; the writers did not. An
// unvalidated writer beside a validated reader is how the two disagree.
//
// ONLY "reviews" HAS INNER VIEWS. A tab absent from this map has none, and
// writeAdminHash appends no segment for it.
const ADMIN_TAB_VIEWS = {
  // Frozen because REVIEW_VIEWS below is an ALIAS of this array, not a copy,
  // and it is exported — a caller pushing to it would be editing the routing
  // table.
  // Scheduling · Scan Queue · Delivery. THE ORDER IS THE ORDER THE TOGGLE
  // OFFERS THEM, and it is the pipeline order: Amber's work, then the guys'
  // work, then finished work. ("scanqueue" took the middle slot 2026-08-13
  // for that reason.)
  //
  // "management" LEFT this list 2026-08-14 — it is a top-level tab now, not
  // an inner view (see PROMOTED_ADMIN_VIEWS for what happened to its deep
  // link). Removed in the same commit that moved its render branch, its
  // badge and its fetch: #532's lesson runs both ways, and a value that
  // stops being a view while a toggle still offers it is the same blank
  // panel from the other end.
  reviews: Object.freeze(["scheduling", "scanqueue", "recorded"]),
};
const REVIEW_DEFAULT_VIEW = "scheduling";

/** EXPORTED FOR TESTS. The Assessments section's valid inner views, in the
 *  order the toggle offers them. */
export const REVIEW_VIEWS = ADMIN_TAB_VIEWS.reviews;

/** An inner view for the Assessments section, or the section default.
 *
 *  Coerces rather than rejects, deliberately: #/admin/reviews/nonsense is a
 *  SUPPORTED input — a stale bookmark, a hand-edited URL, a link from a
 *  chat message — and the answer to it is the default view, never a blank
 *  panel. Pinned by AdminPage.reviewViews.test.js. */
export function coerceReviewView(view) {
  return REVIEW_VIEWS.includes(view) ? view : REVIEW_DEFAULT_VIEW;
}

/** Is `view` a real inner view of `tab`? Used by the hash WRITER, which
 *  must not mint a URL for a view its tab does not have. */
function isValidAdminView(tab, view) {
  return (ADMIN_TAB_VIEWS[tab] || []).includes(view);
}

// ── Licensing tab helpers (exported for tests, like SCAN_WAIT_COPY) ──
// No product classification on purpose (decision, PR2): "consumption
// pool vs real product" is a fact about the SKU that is NOT in the
// payload — any heuristic is a stand-in for an open question with the
// engine owner. Default sort is Assigned descending; every column is
// sortable; the usage bar carries the meaning.
// CapabilityStatus -> the words the customer's OWN Microsoft 365 admin
// center uses for the same state. DISPLAY LAYER ONLY: the stored
// snapshot and both API payloads keep the raw engine value, so this can
// never change what is persisted or what an API returns.
//
// "Suspended" -> "Disabled" is the ONLY mapping. "Enabled" is
// deliberately NOT remapped (it already matches), and every other value
// Retired tabs → where their deep links now land. #/admin/delivery was a real
// bookmarkable route, so dropping it from ADMIN_TABS alone would silently land
// on the default tab. Redirecting keeps an existing bookmark meaningful, and
// because the page→history effect rebuilds the hash from adminTabFromHash(),
// the URL self-corrects to #/admin/reviews on arrival.
// Delivery Ops retired 2026-08-08 — see the comment on get_admin_delivery_queue.
const RETIRED_ADMIN_TABS = { delivery: "reviews" };

// Inner views that GRADUATED to a top-level tab → the tab they became.
// { retired-tab: view } is the shape one level down from RETIRED_ADMIN_TABS
// and exists for the identical reason.
//
// #/admin/reviews/management was a real bookmarkable deep link — in
// bookmarks, in chat messages and in muscle memory — and Customer Management
// left the Assessments section on 2026-08-14. Dropping "management" from
// REVIEW_VIEWS alone would send that link through coerceReviewView's default
// and land it on Scheduling with no explanation: #532's shape one level up, a
// URL that quietly goes somewhere else. Redirecting keeps the bookmark
// meaningful, and because the page→history effect rebuilds the hash from
// adminTabFromHash(), the URL self-corrects to #/admin/management on arrival.
const PROMOTED_ADMIN_VIEWS = { reviews: { management: "management" } };

const ADMIN_DEFAULT_TAB = "publishing";

// Parse the hash into { page, sub, view }. page is a valid HISTORY_PAGES id
// or null; sub is the optional second segment (only meaningful for admin);
// view is the optional THIRD segment — the inner view inside a section, added
// 2026-08-11 so the Assessments sub-views are bookmarkable.
//
// COMPATIBILITY IS THE POINT. #/admin/reviews is a live bookmark and both it
// and the two-segment form of every other tab must keep resolving exactly as
// before; the third group is optional and its absence yields view: null, which
// every caller reads as "use the section default". A two-segment hash takes
// the identical path it always did.
export const routeFromHash = () => {
  const m = /^#\/([a-z]+)(?:\/([a-z]+))?(?:\/([a-z]+))?\/?$/.exec(
    window.location.hash);
  if (!m || !HISTORY_PAGES.has(m[1])) {
    return { page: null, sub: null, view: null };
  }
  return { page: m[1], sub: m[2] || null, view: m[3] || null };
};

export const pageFromHash = () => routeFromHash().page;

// The admin sub-tab from the hash, validated — null when absent/invalid so the
// caller falls back to the default tab.
export const adminTabFromHash = () => {
  const { page, sub, view } = routeFromHash();
  if (page !== "admin" || !sub) return null;
  if (RETIRED_ADMIN_TABS[sub]) return RETIRED_ADMIN_TABS[sub];
  // A promoted view is checked BEFORE the tab set, for the same reason the
  // retired map is: `sub` is still a live tab here, so ADMIN_TABS.has would
  // answer "reviews" first and swallow the redirect. Three-segment links
  // only — #/admin/reviews on its own is untouched.
  const promoted = PROMOTED_ADMIN_VIEWS[sub]?.[view];
  if (promoted) return promoted;
  return ADMIN_TABS.has(sub) ? sub : null;
};

// The inner view for a section, validated against that section's own list.
// null whenever the segment is absent or unknown, so the caller falls back to
// the section default rather than rendering nothing — an unrecognised third
// segment must never produce a blank panel.
// DERIVED from ADMIN_TAB_VIEWS, not restated. It was a second literal list of
// the same set until 2026-08-11, which is the #532 drift shape exactly: adding
// a view to the routing table while the hash validator kept the old set would
// make the deep link resolve to null and the section silently open on its
// default — a bookmarkable URL that quietly goes somewhere else.
const ADMIN_INNER_VIEWS = Object.fromEntries(
  Object.entries(ADMIN_TAB_VIEWS).map(([tab, views]) => [tab, new Set(views)]),
);

export const adminViewFromHash = () => {
  const { view } = routeFromHash();
  const tab = adminTabFromHash();
  if (!tab || !view) return null;
  const allowed = ADMIN_INNER_VIEWS[tab];
  return allowed && allowed.has(view) ? view : null;
};

// Pages that are meaningless without a customer in context. When a Patriot
// user has no customer selected (slug null), these render disabled in the
// nav and the main panel shows the select-a-customer prompt instead. Admin
// and Azure SecureAudit are cross-client (AdminPage/AzurePage take no slug)
// and stay fully usable.
const CUSTOMER_SCOPED_PAGES = new Set(["overview", "queue", "recs", "profile", "support", "licensing"]);

/* ═══════════════════════════════════════════════════
   SelectCustomerPrompt — Shown to internal Patriot users
   in the main panel when no customer is selected yet.
   Intentional empty state (not an error) prompting use of
   the picker; the nav around it stays usable. (Moved from
   PortalShell so the nav can render without a customer.)
   ═══════════════════════════════════════════════════ */
const SelectCustomerPrompt = () => (
  <div style={{
    minHeight: "calc(100vh - 160px)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  }}>
    <div style={{ textAlign: "center", maxWidth: 420, padding: "0 24px" }}>
      <div style={{
        width: 64, height: 64, borderRadius: 16, margin: "0 auto 20px",
        background: "rgba(68,166,255,0.1)",
        border: "1px solid rgba(68,166,255,0.2)",
        display: "grid", placeItems: "center",
        fontSize: 28,
      }}>
        {"🔍"}
      </div>
      <h2 style={{ fontSize: 22, fontWeight: 800, margin: "0 0 8px", color: T.text }}>
        Select a customer to get started
      </h2>
      <p style={{ fontSize: 14, color: T.muted, lineHeight: 1.6, margin: 0 }}>
        Use the search box in the top-right to find a customer and load their
        security posture dashboard, or open Admin from the left nav.
      </p>
    </div>
  </div>
);

export { normalizeSettingRatings } from "./customerPresentation/projectRecommendations";

export default function SecureShield365({ slug, customerName, deliveryMode = false, onPageChange }) {
  const { user } = useUserContext();
  const cspOpportunity = useCspOpportunities({ tenantId: user?.tenantId, objectId: user?.objectId, slug });
  const currentUser = user?.email || user?.name || "Unknown User";
  // Whether this user may land on a page via hash/history. Mirrors the PAGES
  // nav gating below (azure/admin internal-only outside delivery mode;
  // support hidden only for a customer in delivery mode).
  const canViewPage = useCallback((id) => {
    if (id === "azure" || id === "admin") return !!user?.isInternal && !deliveryMode;
    if (id === "support") return !!user?.isInternal || !deliveryMode;
    return true;
  }, [user, deliveryMode]);
  // Deep link: a valid, permitted #/{page} on load lands there; anything
  // else (including MSAL's transient #code=... auth hash) falls to Overview.
  const [page, setPage] = useState(() => {
    const hashPage = pageFromHash();
    return hashPage && canViewPage(hashPage) ? hashPage : "overview";
  });
  // Let PortalShell apply page-specific header visibility before the browser
  // paints navigation or history changes.
  useLayoutEffect(() => {
    onPageChange?.(page);
  }, [page, onPageChange]);
  // If delivery mode turns on while the Admin page is open, bounce to Overview
  // so the cross-client review queue can't stay on screen during a client share.
  useEffect(() => {
    if (deliveryMode && page === "admin") setPage("overview");
  }, [deliveryMode, page]);

  // popNavPage: page changes driven by popstate must NOT re-push (that would
  // loop history). Holds the pop target and is compared — not a boolean — so
  // a pop to the already-current page (e.g. the initial-load popstate some
  // browsers fire with null state) can't leave a stale flag that swallows the
  // next real navigation's push.
  const popNavPage = useRef(null);
  const historyInitDone = useRef(false);

  // Sync page → history. First run REPLACES the landing entry (normalising
  // the URL to #/{page}) so one Back from the entry page exits the portal
  // instead of trapping the user; every later page change pushes one entry.
  useEffect(() => {
    if (popNavPage.current === page) { popNavPage.current = null; return; }
    popNavPage.current = null;
    // Preserve a valid admin sub-tab already in the hash (e.g. a deep link to
    // #/admin/access) so this page-level sync doesn't strip it back to #/admin.
    const sub = page === "admin" ? adminTabFromHash() : null;
    // Preserve a third segment the section wrote. Rebuilding the hash from
    // page+sub alone would silently drop #/admin/reviews/recorded back to
    // #/admin/reviews on any page-effect re-run.
    const view = sub ? adminViewFromHash() : null;
    const hash = `#/${page}${sub ? `/${sub}` : ""}${view ? `/${view}` : ""}`;
    const url = `${window.location.pathname}${window.location.search}${hash}`;
    if (historyInitDone.current) {
      window.history.pushState({ ssPage: page }, "", url);
    } else {
      historyInitDone.current = true;
      window.history.replaceState({ ssPage: page }, "", url);
    }
  }, [page]);

  // history → page. Restore from the entry's state, falling back to the hash
  // (replaceState callers elsewhere wipe state but keep the hash). Entries
  // the user may no longer view (e.g. #/admin popped after entering delivery
  // mode) render Overview instead.
  useEffect(() => {
    const onPop = (e) => {
      const stated = e.state && e.state.ssPage;
      const target =
        (HISTORY_PAGES.has(stated) ? stated : null) || pageFromHash() || "overview";
      const safe = canViewPage(target) ? target : "overview";
      popNavPage.current = safe;
      setPage(safe);
    };
    window.addEventListener("popstate", onPop);
    return () => window.removeEventListener("popstate", onPop);
  }, [canViewPage]);
  const [q] = useState(3);
  const [supRecs, setSupRecs] = useState(null); // single rec or array of recs
  const [ticketStatus, setTicketStatus] = useState(null);
  const [ticketNotes, setTicketNotes] = useState("");
  // Internal-only on-behalf for the Settings Support ticket modal (single
  // and grouped submits share it). email "" = file as yourself.
  const [supOnBehalf, setSupOnBehalf] = useState({ email: "", name: "" });
  const [recFilter, setRecFilter] = useState("all");
  const [recCatFilter, setRecCatFilter] = useState(null);        // Product (r.cat) filter
  const [recCategoryFilter, setRecCategoryFilter] = useState(null);  // Security Domain (r.category) filter
  const [recOverrideFilter, setRecOverrideFilter] = useState(null);
  const [recRegressedFilter, setRecRegressedFilter] = useState(false);
  const [recHighlightId, setRecHighlightId] = useState(null);
  // Exact transition navigation is scoped to the report that supplied it.
  // Keep the selection in the parent so ordinary navigation can clear it, but
  // derive the usable value during render so a changed customer/report cannot
  // briefly apply old IDs while an effect cleanup is pending.
  const [remediatedSelection, setRemediatedSelection] = useState(null);
  const [remediatedLandingKey, setRemediatedLandingKey] = useState(0);
  const [pairMode, setPairModeRaw] = useState("baseline");
  const [pairScanId, setPairScanIdRaw] = useState(null);
  const setPairMode = (mode) => { setRemediatedSelection(null); setPairScanIdRaw(null); setPairModeRaw(mode); };
  const setPairScanId = (selector) => { setRemediatedSelection(null); setPairScanIdRaw(selector); };
  // Cross-page intent: dashboard "Settings help" → open Recommendations already
  // in bulk-select mode. Mirrors the recFilter/highlightId prop-passing pattern;
  // RecsPage consumes it on mount and clears it via onBulkIntentConsumed.
  const [recBulkIntent, setRecBulkIntent] = useState(false);
  // Dashboard header height — measured so the filter bar can stick directly beneath it.
  const dashboardHeaderRef = useRef(null);
  const [dashboardHeaderHeight, setDashboardHeaderHeight] = useState(0);
  useEffect(() => {
    const el = dashboardHeaderRef.current;
    if (!el || typeof ResizeObserver === "undefined") return;
    const ro = new ResizeObserver(() => {
      setDashboardHeaderHeight(el.getBoundingClientRect().height);
    });
    ro.observe(el);
    setDashboardHeaderHeight(el.getBoundingClientRect().height);
    return () => ro.disconnect();
  }, []);
  // Inject the skeleton shimmer keyframes once. Done in JS because there's no
  // global stylesheet in this project and CSS-in-JS via inline styles can't
  // express @keyframes.
  useEffect(() => {
    const id = "ss365-skeleton-keyframes";
    if (document.getElementById(id)) return;
    const styleEl = document.createElement("style");
    styleEl.id = id;
    styleEl.textContent = "@keyframes ss365-skeleton-shimmer { 0% { background-position: 200% 0; } 100% { background-position: -200% 0; } }";
    document.head.appendChild(styleEl);
  }, []);
  const [panelRec, setPanelRec] = useState(null);
  // Filtered list captured at the moment the drawer opens — prev/next operate on this
  // so customers can step through only the settings they had visible (filtered by
  // severity, Hide Satisfied, etc.) instead of the full 810-setting list.
  const [panelList, setPanelList] = useState(null);
  const [settingDetails, setSettingDetails] = useState({});
  // Phase 2b — Session focus is backed by Dataverse via /api/clients/{slug}/session-focus
  const [sessionFocus, setSessionFocus] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [sessionFocusLoading, setSessionFocusLoading] = useState(true);
  const [sessionFocusError, setSessionFocusError] = useState(null);
  // PR 2a — Setting Reviews are backed by Dataverse via /api/clients/{slug}/reviews
  const [reviews, setReviews] = useState([]);
  // In-flight guards keyed by setting_id — drive both the re-entrancy guard in
  // the handlers and the disabled state on the Mark Reviewed / Add to Session
  // buttons. Optimistic provisional rows render immediately; these prevent a
  // rapid second click from firing a duplicate write before the row reconciles.
  const [pendingReview, setPendingReview] = useState(() => new Set());
  const [pendingQueue, setPendingQueue] = useState(() => new Set());
  // eslint-disable-next-line no-unused-vars
  const [reviewsLoading, setReviewsLoading] = useState(true);
  // eslint-disable-next-line no-unused-vars
  const [reviewsError, setReviewsError] = useState(null);
  const [reviewBanner, setReviewBanner] = useState(null);
  // Panel visibility for the Session Focus button on the Recs page.
  // "closed" → just the button; "expanded" → sticky card pinned above the recs table.
  const PANEL_STATE_STORAGE_KEY = slug ? `ss365_session_focus_panel:${slug}` : null;
  const [sessionFocusPanelState, setSessionFocusPanelStateRaw] = useState("closed");
  useEffect(() => {
    if (!PANEL_STATE_STORAGE_KEY) { setSessionFocusPanelStateRaw("closed"); return; }
    try {
      const stored = window.localStorage.getItem(PANEL_STATE_STORAGE_KEY);
      // Treat legacy "dropdown" value (from the old three-state UI) as "expanded".
      setSessionFocusPanelStateRaw(stored === "expanded" || stored === "dropdown" ? "expanded" : "closed");
    } catch {
      setSessionFocusPanelStateRaw("closed");
    }
  }, [PANEL_STATE_STORAGE_KEY]);
  const setSessionFocusPanelState = useCallback((v) => {
    setSessionFocusPanelStateRaw(v);
    if (PANEL_STATE_STORAGE_KEY) {
      try { window.localStorage.setItem(PANEL_STATE_STORAGE_KEY, v); } catch { /* ignore */ }
    }
  }, [PANEL_STATE_STORAGE_KEY]);
  // Top-of-page banner shown when add-to-queue hits the 10-item cap (409 queue_full).
  const [sessionFocusBanner, setSessionFocusBanner] = useState(null);
  const activeSessionFocus = useMemo(
    () => sessionFocus.filter(i => i.status === "Active"),
    [sessionFocus]
  );
  const queueIds = useMemo(
    () => new Set(activeSessionFocus.map(i => i.setting_id)),
    [activeSessionFocus]
  );
  const queueCount = activeSessionFocus.length;
  // Lookup: setting_id → reviews[] (sorted newest-first by reviewed_on)
  const reviewsBySettingId = useMemo(() => {
    const m = new Map();
    for (const r of reviews) {
      const list = m.get(r.setting_id) || [];
      list.push(r);
      m.set(r.setting_id, list);
    }
    for (const list of m.values()) {
      list.sort((a, b) => (b.reviewed_on || "").localeCompare(a.reviewed_on || ""));
    }
    return m;
  }, [reviews]);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [tooltip, setTooltip] = useState(null);
  // Real data fetch state — Phase 2 of dashboard wiring
  const [report, setReport] = useState(null);
  const [reportLoading, setReportLoading] = useState(true);
  const [reportError, setReportError] = useState(null);
  // Which no-data empty-state variant to show when the report 404s —
  // classifyNoDataScanState over the customer's own runs; null = generic copy.
  const [noDataScanState, setNoDataScanState] = useState(null);
  // Past scans: list from /api/clients/{slug}/scans + the currently-viewed scan
  const [loadedScans, setScans] = useState([]);
  const [scansPayload, setScansPayload] = useState(null);
  const scans = publicationScansMatch(report, scansPayload) ? loadedScans : [];
  const lastMismatchReload = useRef(null);
  useEffect(() => {
    if (!report || !scansPayload || publicationScansMatch(report, scansPayload)) return;
    const mismatchKey = `${slug}|${report._publication?.selector}|${report._publication?.state_generation}|${scansPayload.state_generation}`;
    if (lastMismatchReload.current === mismatchKey) return;
    lastMismatchReload.current = mismatchKey;
    setScans([]);
    setScansPayload(null);
    setPendingRefreshKey(value => value + 1);
  }, [slug, report, scansPayload]);
  const [scansLoading, setScansLoading] = useState(true);
  // eslint-disable-next-line no-unused-vars
  const [scansError, setScansError] = useState(null);
  // currentScanId = null means "show the published latest"
  // currentScanId = an opaque publication selector means historical view.
  const [currentScanId, setCurrentScanId] = useState(null);
  const [pendingRefreshKey, setPendingRefreshKey] = useState(0);
  // ADR-0088: the pending_id being previewed, or null. Was a boolean
  // while a customer could hold exactly one scan; with N, "preview the
  // held scan" no longer names one. Every consumer below reads it for
  // truthiness exactly as before — only the identity is new.
  const [previewPending, setPreviewPending] = useState(null);
  const reportSourcePath = report?._pending?.scored_path || (report?._publication
    ? `${report._publication.selector || report._publication.observation_key}|${report._publication.identity?.scored_path}|${report._publication.identity?.sha256}|${report._publication.state_generation}`
    : currentScanId || "published");
  const reportMatchesSelection = !reportLoading && !previewPending && publicationScansMatch(report, scansPayload)
    && (currentScanId != null ? report?._publication?.selector === currentScanId
      : scansPayload?.scans?.some(scan => scan.current === true
        && scan.scan_id === report?._publication?.selector
        && scan.identity?.scored_path === report?._publication?.identity?.scored_path
        && scan.identity?.sha256 === report?._publication?.identity?.sha256));
  const activeRemediatedSelection = remediatedSelection
    && reportMatchesSelection
    && remediatedSelection.slug === slug
    && remediatedSelection.scoredAt === report?.scored_at
    && remediatedSelection.sourcePath === reportSourcePath
    && (!remediatedSelection.pair || (remediatedSelection.mode === pairMode
      && remediatedSelection.pairScanId === pairScanId))
    ? remediatedSelection
    : null;
  const [publishedScoredAt, setPublishedScoredAt] = useState(null);
  const [archivedRefreshKey, setArchivedRefreshKey] = useState(0);
  // Customer metadata from /api/client/{slug} — currently used for next_audit_date.
  const [clientInfo, setClientInfo] = useState(null);
  // Notes (Phase 1 of issue #32) — read-only, keyed by setting_id
  const [notesBySettingId, setNotesBySettingId] = useState(new Map());
  // eslint-disable-next-line no-unused-vars
  const [notesLoading, setNotesLoading] = useState(true);
  // eslint-disable-next-line no-unused-vars
  const [notesError, setNotesError] = useState(null);

  // Reset all customer-scoped state when slug changes. Runs synchronously
  // before the fetch effect below so the previous customer's data doesn't
  // remain visible during the new customer's in-flight requests. Fixes the
  // customer-switch staleness reported by the Patriot client picker.
  useEffect(() => {
    setReport(null);
    setReportError(null);
    setNoDataScanState(null);
    setScans([]);
    setScansPayload(null);
    setScansError(null);
    setCurrentScanId(null);
    setPreviewPending(null);
    setPublishedScoredAt(null);
    setPendingRefreshKey(0);
    setArchivedRefreshKey(0);
    setScansLoading(true);
    setClientInfo(null);
    setSessionFocus([]);
    setSessionFocusError(null);
    setSessionFocusBanner(null);
    setReviews([]);
    setReviewsError(null);
    setReviewBanner(null);
    setNotesBySettingId(new Map());
    setNotesError(null);
    setSettingDetails({});
    setPanelRec(null);
    setPanelList(null);
    setSupRecs(null);
    setTicketStatus(null);
    setTicketNotes("");
    setRecFilter("all");
    setRecCatFilter(null);
    setRecCategoryFilter(null);
    setRecOverrideFilter(null);
    setRemediatedSelection(null);
    setPairModeRaw("baseline");
    setPairScanIdRaw(null);
    setRecHighlightId(null);
    setReportLoading(true);
    setSessionFocusLoading(true);
    setReviewsLoading(true);
    setNotesLoading(true);
  }, [slug]);

  useEffect(() => {
    setRemediatedSelection(selection => (
      selection
      && selection.slug === slug
      && selection.scoredAt === report?.scored_at
      && selection.sourcePath === reportSourcePath
        ? selection
        : null
    ));
  }, [slug, report?.scored_at, reportSourcePath]);

  // Monotonic request generation. Each fetch-effect fire captures `reqGen.current`
  // as its `myGen`; every async resolution drops itself when `myGen !== reqGen.current`.
  // Cleanup bumps the counter so an unmount also supersedes in-flight requests.
  // Replaces the prior closure-based `cancelled` flag — explicit ordering beats
  // relying on commit-phase timing of cleanup runs.
  const reqGen = useRef(0);

  // Fetch real scored report when slug is available
  useEffect(() => {
    if (!slug) {
      setReportLoading(false);
      setSessionFocusLoading(false);
      setReviewsLoading(false);
      setNotesLoading(false);
      return;
    }
    const myGen = reqGen.current;
    setReportLoading(true);
    setReportError(null);
    setScansLoading(true);
    setScansError(null);
    // Fetch report. In pending-preview mode (Patriot reviewing a held scan) we
    // load the held scan from pending/ instead of the published latest, so the
    // whole dashboard — scores, regression badges, findings — reflects the scan
    // under review. Otherwise currentScanId drives normal published/time-travel.
    const reportPromise = previewPending
      ? fetchPendingScan(slug, previewPending)
      : fetchLatestReport(slug, currentScanId);
    reportPromise
      .then((data) => {
        if (myGen !== reqGen.current) return;
        if (previewPending && !data) {
          // Pending scan vanished (e.g., published/rejected elsewhere). Drop preview.
          setPreviewPending(null);
          return;
        }
        setReport(data);
        if (!previewPending && currentScanId == null) {
          setPublishedScoredAt(data.scored_at || null);
        }
        setSettingDetails(data.overrides || {});
        setReportLoading(false);
      })
      .catch((err) => {
        if (myGen !== reqGen.current) return;
        setReport(null);
        setSettingDetails({});
        if (err.status === 403 && err.body?.error === "roster_inactive") {
          // Roster gate deny — the user's pc_portalaccess row isn't Active.
          // Page-level EmptyState copy; internal users bypass server-side.
          setReportError("roster_inactive");
        } else if (err.message && err.message.includes("404")) {
          // No published report. Classify the customer's own scan runs so
          // the empty state can point at the right next step (first scan /
          // running / awaiting publish). The skeleton stays up until the
          // classification settles; a failed runs read leaves the variant
          // null, which renders the generic no-data copy. Patriot viewers
          // take the backend's customer path via as_customer (their own
          // token has no customer tenant to resolve runs from).
          fetchCustomerScanRuns({ slug, asCustomer: !!user?.isInternal })
            .then((page) => {
              if (myGen !== reqGen.current) return;
              setNoDataScanState(classifyNoDataScanState(page?.runs));
            })
            .catch(() => { /* variant stays null -> generic copy */ })
            .finally(() => {
              if (myGen !== reqGen.current) return;
              setReportError("no_data");
              setReportLoading(false);
            });
          return;
        } else {
          setReportError(err.message || "Failed to load report");
        }
        setReportLoading(false);
      });
    // Fetch list of all scans for this customer (powers dropdown + trend chart)
    fetchScans(slug)
      .then((data) => {
        if (myGen !== reqGen.current) return;
        setScans(data.scans || []);
        setScansPayload(data);
        setScansLoading(false);
      })
      .catch((err) => {
        if (myGen !== reqGen.current) return;
        setScansError(err.message || "Failed to load scans");
        setScansLoading(false);
      });

    // Session focus loads alongside the report. Failure is non-blocking —
    // we just surface an error in the panel header so the user can retry.
    setSessionFocusLoading(true);
    setSessionFocusError(null);
    fetchSessionFocus(slug)
      .then((items) => {
        if (myGen !== reqGen.current) return;
        setSessionFocus(Array.isArray(items) ? items : []);
        setSessionFocusLoading(false);
      })
      .catch((err) => {
        if (myGen !== reqGen.current) return;
        setSessionFocus([]);
        setSessionFocusError(err.message || "Could not load session focus");
        setSessionFocusLoading(false);
      });

    // Setting reviews load alongside session focus. fetchReviews swallows
    // errors and returns [] on failure, but we still capture an error
    // message for surfacing a small banner if needed.
    setReviewsLoading(true);
    setReviewsError(null);
    fetchReviews(slug)
      .then((items) => {
        if (myGen !== reqGen.current) return;
        setReviews(Array.isArray(items) ? items : []);
        setReviewsLoading(false);
      })
      .catch((err) => {
        if (myGen !== reqGen.current) return;
        setReviews([]);
        setReviewsError(err.message || "Could not load reviews");
        setReviewsLoading(false);
      });

    // Customer metadata (next_audit_date, etc.) loads alongside the report.
    // Failure must not block the dashboard — just leave the pill hidden.
    fetchClientInfo(slug)
      .then((data) => {
        if (myGen !== reqGen.current) return;
        setClientInfo(data);
      })
      .catch(() => {
        if (myGen !== reqGen.current) return;
        setClientInfo(null);
      });

    // Notes load alongside the report — failure here must not block the dashboard.
    setNotesLoading(true);
    setNotesError(null);
    fetchNotes(slug)
      .then((data) => {
        if (myGen !== reqGen.current) return;
        const map = new Map();
        for (const note of (data && data.notes) || []) {
          const arr = map.get(note.setting_id) || [];
          arr.push(note);
          map.set(note.setting_id, arr);
        }
        setNotesBySettingId(map);
        setNotesLoading(false);
      })
      .catch((err) => {
        if (myGen !== reqGen.current) return;
        setNotesError(err.message || "Failed to load notes");
        setNotesBySettingId(new Map());
        setNotesLoading(false);
      });
    return () => {
      reqGen.current++;
    };
  }, [slug, currentScanId, pendingRefreshKey, previewPending]);

  // Map scored_settings from /api/report into the dashboard schema. Returns []
  // when the report is still loading; loading UI shows skeleton placeholders
  // (no mock fallback) so customers never see fake recommendation data.
  const recs = useMemo(() => projectReportRecommendations(report, scans), [report, scans]);

  // Phase E — Category breakdown for the donut charts.
  // Computes per-category point-loss for both Patriot Score (raw) and Adjusted
  // Score (overrides count as satisfied). Returns:
  //   { pct, adj, patriotSlices, adjustedSlices }
  // where slices = top 8 categories by gap + "Other" bucket aggregating the rest.
  // Risk-Adjusted composition + adjusted score. The math now lives in the shared
  // ./composition module (computeComposition) so the dashboard donut and the PDF
  // export consume an identical computation and can never drift. Pure refactor —
  // output shape and values are unchanged from the original inline categoryData.
  const categoryData = useMemo(
    () => computeComposition(recs, settingDetails, report?.totals),
    [recs, settingDetails, report]
  );

  // Phase 3e — URL deep linking for the drawer.
  // CRITICAL ordering: the open-effect must read the URL BEFORE the sync-effect strips it.
  // We use initialUrlSyncDone to skip the URL-write effect's first invocation so the
  // initial ?recommendation=N survives long enough for the open-effect to read it.
  const initialUrlSyncDone = useRef(false);

  // Open drawer when URL has ?recommendation=N and recs has loaded the matching item.
  // Re-runs as recs changes (initial mock → real data after fetchLatestReport resolves).
  useEffect(() => {
    if (!recs || recs.length === 0) return;
    const params = new URLSearchParams(window.location.search);
    const idParam = params.get("recommendation");
    if (idParam && !panelRec) {
      const target = recs.find(r => String(r.id) === idParam);
      if (target) {
        setPage("recs");
        setPanelRec(target);
        setPanelList(null);  // URL-opens have no filter context — fall back to full recs in nav
      }
    }
    // intentionally omitting panelRec from deps — re-firing on every drawer open would defeat the purpose
  }, [recs]); // eslint-disable-line

  // Sync URL to panelRec on every change (open, prev/next, close).
  // Skips first render so the initial ?recommendation=N param isn't stripped before the
  // open-effect can read it.
  useEffect(() => {
    if (!initialUrlSyncDone.current) {
      initialUrlSyncDone.current = true;
      return;
    }
    const url = new URL(window.location.href);
    if (panelRec) {
      url.searchParams.set("recommendation", String(panelRec.id));
    } else {
      url.searchParams.delete("recommendation");
    }
    window.history.replaceState({}, "", url.toString());
  }, [panelRec]);

  // Close the drawer whenever the user navigates between tabs.
  // Drawer is contextual to the page/row where it was opened.
  // Depend only on [page] — including panelRec would re-fire on every drawer open.
  useEffect(() => {
    if (panelRec) {
      setPanelRec(null);
      setPanelList(null);
    }
  }, [page]); // eslint-disable-line

  const tooltipTimer = useRef(null);

  const showTooltip = useCallback((id) => {
    clearTimeout(tooltipTimer.current);
    tooltipTimer.current = setTimeout(() => setTooltip(id), 300);
  }, []);
  const hideTooltip = useCallback(() => {
    clearTimeout(tooltipTimer.current);
    setTooltip(null);
  }, []);

  // d/prev are only consumed by the header score+change pills (and only when
  // report is loaded — the skeleton branch handles the !report case). The
  // QD blend exists because report.totals doesn't carry every field the pills
  // historically read; only `score` actually drives the pills today.
  // prev derives from the live scans list, NEVER report.previous_totals:
  // previous_totals is a scoring-time snapshot and survives deletion of the
  // prior scan (83-customer ghost audit, July 6 2026) — the live scans list
  // is the only trustworthy source for comparisons. While scans are still
  // loading, no pill (never a flash of a possibly-ghost value); with <= 1
  // scan, no pill (first-review baseline).
  const baseD = QD[q], basePrev = q > 0 ? QD[q - 1] : null;
  const d = report
    ? { ...baseD, score: Math.round(report.totals.score_pct * 10) / 10 }
    : baseD;
  const headerPrevScore = (() => {
    if (scansLoading || !Array.isArray(scans) || scans.length < 2) return null;
    const prior = exactScoringBaseline(report, scans);
    return prior && typeof prior.score_pct === "number"
      ? Math.round(prior.score_pct * 10) / 10
      : null;
  })();
  const prev = report && headerPrevScore != null
    ? { ...(basePrev || baseD), score: headerPrevScore }
    : null;

  const supRecsList = supRecs ? (Array.isArray(supRecs) ? supRecs : [supRecs]) : [];

  const isBulkTicket = supRecsList.length > 1;

  const handleSubmitTicket = useCallback(async () => {
    if (!supRecsList.length) return;
    setTicketStatus("loading");
    // On-behalf (internal only): the picked/typed email overrides the
    // requester on EVERY ticket this submit creates, and each description
    // carries the attribution line — roster name included when known.
    const behalf = user?.isInternal ? supOnBehalf.email.trim() : "";
    const behalfWho = behalf ? (supOnBehalf.name ? `${supOnBehalf.name} (${behalf})` : behalf) : "";
    const requesterEmail = behalf || user?.email || "";
    const attribution = behalf
      ? `Filed by ${user?.email || ""} (Patriot) on behalf of ${behalfWho} during a review session.`
      : "";
    try {
      if (supRecsList.length === 1) {
        // Single item — call real Freshservice via the backend. Pass the real
        // customer slug (used for tenancy access-check + client-name lookup),
        // the requester email, and any notes they typed. Override status comes
        // from settingDetails (not the rec): "{label} — {reason}".
        const sd = settingDetails?.[supRecsList[0].id];
        const overrideStatus = sd?.override
          ? [dispositionLabel(sd.override), sd.reason].filter(Boolean).join(" — ")
          : "";
        // Customer-authored setting notes only (strict author_type match —
        // unknown authorship is excluded rather than risking a Patriot-
        // internal note leaking into the ticket). Snapshot at filing time.
        const settingNotes = (notesBySettingId.get(supRecsList[0].id) || [])
          .filter(n => ((n.author_type || "") + "").toLowerCase() === "customer")
          .map(n => {
            const d = n.modified_on || n.created_on;
            const date = fmtInstant(d, undefined, "");
            return `[${date}] ${n.author_email || "customer"}: ${n.body || n.text || ""}`;
          })
          .join("\n");
        const result = await apiCreateTicket(supRecsList[0], slug, requesterEmail, ticketNotes, attribution, overrideStatus, settingNotes);
        setTicketStatus({ id: result.ticket_id, url: result.ticket_url, count: 1 });
      } else {
        // Multi-select — one REAL Freshservice ticket per PRODUCT group
        // (r.cat), each tagged patriot_service="SecureShield 365" so it rolls
        // up on the Settings gauge. No fabricated ids; fail-loud on partials.
        const groups = groupRecsByProduct(supRecsList);
        const results = await Promise.allSettled(groups.map(([product, group]) => {
          const settingsHtml = group.map(r =>
            `<li><strong>#${escapeHtmlLocal(r.id)}</strong> — ${escapeHtmlLocal(r.name)} (${escapeHtmlLocal(r.sev)})</li>`
          ).join("");
          const description = `
<h3>SS365 Settings Support — ${escapeHtmlLocal(product)}</h3>
<p>${group.length} setting${group.length === 1 ? "" : "s"} in this product group:</p>
<ul>${settingsHtml}</ul>
${ticketNotes ? `<h4>Customer notes</h4><p>${escapeHtmlLocal(ticketNotes)}</p>` : ""}
${attribution ? `<p><i>${escapeHtmlLocal(attribution)}</i></p>` : ""}
<hr>
<p><i>Submitted via the SecureShield 365 Dashboard</i></p>
`;
          return createTicket({
            client_id: slug,
            requester_email: requesterEmail,
            subject: `SS365 Settings — ${product} (${group.length} setting${group.length === 1 ? "" : "s"})`,
            description,
            patriot_service: "SecureShield 365",
            // severity (NOT priority) so the backend derives priority via its
            // existing PRIORITY_MAP — same contract as the single-rec path.
            severity: groupHighestSeverityLabel(group),
          }).then(res => ({ product, ticket_id: res.ticket_id, ticket_url: res.ticket_url }));
        }));

        const created = [];
        const failed = [];
        results.forEach((res, i) => {
          const product = groups[i][0];
          if (res.status === "fulfilled") created.push(res.value);
          else failed.push(product);
        });
        setTicketStatus({ bulk: true, created, failed });
      }
    } catch (err) {
      setTicketStatus({ error: err.message });
    }
  }, [supRecsList, ticketNotes, slug, user?.email, user?.isInternal, supOnBehalf, settingDetails, notesBySettingId]);

  const closeTicketModal = () => { setSupRecs(null); setTicketStatus(null); setTicketNotes(""); setSupOnBehalf({ email: "", name: "" }); };

  const navToRemediated = (ids) => {
    // The Overview capability guard has already proved these IDs against the
    // current report. Store report/customer/source identity with the set so a
    // later scope change cannot reuse it.
    setRemediatedSelection({
      ids: new Set(ids), slug, scoredAt: report?.scored_at, sourcePath: reportSourcePath,
    });
    setRemediatedLandingKey(key => key + 1);
    setPage("recs");
    setRecFilter("all");
    setRecCatFilter(null);
    setRecCategoryFilter(null);
    setRecOverrideFilter(null);
    setRecRegressedFilter(false);
    setRecHighlightId(null);
  };

  const navToPair = (pair, metric) => {
    if (!reportMatchesSelection || !isPairDrilldownCapable(pair, metric, report, recs)) return;
    const label = metric === "remediated" ? "Remediated" : "Regressed";
    setRemediatedSelection({
      ids: new Set(pair[metric].setting_ids), slug, scoredAt: report?.scored_at,
      sourcePath: reportSourcePath, pair: true, mode: pairMode, pairScanId,
      label: `${label} · ${pair.comparison.chronology} → ${pair.selected.chronology}`,
    });
    setRemediatedLandingKey(key => key + 1);
    setPage("recs");
    setRecFilter("all");
    setRecCatFilter(null);
    setRecCategoryFilter(null);
    setRecOverrideFilter(null);
    setRecRegressedFilter(false);
    setRecHighlightId(null);
  };

  const navToRecs = (filterKey, catName, overrideKey, categoryName, regressed) => {
    setRemediatedSelection(null);
    setPage("recs");
    if (regressed) {
      // Posture Movement "Regressed" tile — boolean dimension, not a key.
      setRecRegressedFilter(true);
      setRecFilter("all");
      setRecCatFilter(null);
      setRecOverrideFilter(null);
      setRecCategoryFilter(null);
    } else if (categoryName) {
      // Security Domain (r.category) navigation — highest priority.
      setRecCategoryFilter(categoryName);
      setRecCatFilter(null);
      setRecFilter("all");
      setRecOverrideFilter(null);
      setRecRegressedFilter(false);
    } else if (overrideKey) {
      setRecOverrideFilter(overrideKey);
      setRecFilter("all");
      setRecCatFilter(null);
      setRecCategoryFilter(null);
      setRecRegressedFilter(false);
    } else if (catName) {
      setRecCatFilter(catName);
      setRecFilter("all");
      setRecOverrideFilter(null);
      setRecCategoryFilter(null);
      setRecRegressedFilter(false);
    } else if (filterKey) {
      setRecFilter(filterKey);
      setRecCatFilter(null);
      setRecOverrideFilter(null);
      setRecCategoryFilter(null);
      setRecRegressedFilter(false);
    } else {
      // Clear all filters — entry from Overview "see all" or sidebar
      setRecFilter("all");
      setRecCatFilter(null);
      setRecOverrideFilter(null);
      setRecCategoryFilter(null);
      setRecRegressedFilter(false);
    }
    setRecHighlightId(null);
  };

  const handleSaveSettingDetail = useCallback(async (id, data) => {
    const prev = settingDetails[id];
    // Optimistic update — show change immediately
    setSettingDetails(curr => {
      if (!data.override) {
        const { [id]: _removed, ...rest } = curr;
        return rest;
      }
      return { ...curr, [id]: data };
    });

    try {
      if (data.override) {
        const result = await setOverride(slug, id, {
          override: data.override,
          reason: data.reason || "",
          updated_by: currentUser,
        });
        // Update local state with server-confirmed payload
        setSettingDetails(curr => ({ ...curr, [id]: result }));
      } else {
        await clearOverride(slug, id, { updated_by: currentUser });
        // Already removed optimistically — no-op on success
      }
    } catch (err) {
      console.error("Save override failed:", err);
      // Rollback optimistic update
      setSettingDetails(curr => {
        if (prev === undefined) {
          const { [id]: _removed, ...rest } = curr;
          return rest;
        }
        return { ...curr, [id]: prev };
      });
      // TODO: surface error toast/banner to user
      alert(`Failed to save override. Please try again.\n\n${err.message}`);
    }
  }, [slug, settingDetails, currentUser]);

  // Refresh overrides + report after a bulk package apply/remove. Mirrors the
  // report-load effect's success path (setReport + setSettingDetails from
  // data.overrides) so applied overrides immediately show on the dashboard.
  const reloadReportOverrides = useCallback(async () => {
    if (!slug) return;
    try {
      const data = previewPending
        ? await fetchPendingScan(slug, previewPending)
        : await fetchLatestReport(slug, currentScanId);
      if (!data) return;
      setReport(data);
      setSettingDetails(data.overrides || {});
    } catch (err) {
      console.error("Failed to refresh after package change:", err);
    }
  }, [slug, currentScanId, previewPending]);

  // ── Notes write handlers (Phase 4 of issue #32) ──
  // We wait for the server response before updating the Map, then prepend
  // the created note / replace the updated one / filter out the deleted one.
  // No optimistic UI: avoids rollback complexity on failure.
  const handleAddNote = useCallback(async (settingId, noteData) => {
    const created = await createNote(slug, { setting_id: settingId, ...noteData });
    setNotesBySettingId(prev => {
      const next = new Map(prev);
      const arr = next.get(settingId) || [];
      next.set(settingId, [created, ...arr]);
      return next;
    });
    return created;
  }, [slug]);

  const handleUpdateNote = useCallback(async (settingId, noteId, fields) => {
    const updated = await updateNote(slug, noteId, fields);
    setNotesBySettingId(prev => {
      const next = new Map(prev);
      const arr = (next.get(settingId) || []).map(n => n.id === noteId ? updated : n);
      next.set(settingId, arr);
      return next;
    });
    return updated;
  }, [slug]);

  const handleDeleteNote = useCallback(async (settingId, noteId) => {
    await deleteNote(slug, noteId);
    setNotesBySettingId(prev => {
      const next = new Map(prev);
      const arr = (next.get(settingId) || []).filter(n => n.id !== noteId);
      next.set(settingId, arr);
      return next;
    });
  }, [slug]);

  const handleAddToQueue = useCallback(async (r) => {
    if (!slug) return;
    // Capacity / duplicate guards run first \u2014 server is still the source of
    // truth (returns 409). The provisional row below makes queueIds.has(r.id)
    // self-block a rapid second click; pendingQueue covers the same window for
    // the disabled button state.
    if (queueCount >= MAX_QUEUE) {
      setSessionFocusBanner({ kind: "queue_full", text: `Session focus is at capacity (${MAX_QUEUE}/${MAX_QUEUE}). Complete or remove items to add more.` });
      return;
    }
    if (queueIds.has(r.id)) return;
    if (pendingQueue.has(r.id)) return;
    setPendingQueue(prev => new Set(prev).add(r.id));
    // Optimistic provisional item. Shape mirrors what the list UI / queueIds /
    // queueCount read: status "Active" (so it counts), setting_id, plus the
    // fields the rows render (session_type, order_index, author_email). Replaced
    // by the server row on success, removed on failure \u2014 matched by _tempId.
    const tempId = nextTempId();
    const provisional = {
      id: tempId,
      _tempId: tempId,
      setting_id: r.id,
      status: "Active",
      session_type: "Working",
      order_index: queueCount,
      author_email: currentUser,
    };
    setSessionFocus(prev => [...prev, provisional]);
    setSessionFocusBanner(null);
    try {
      const created = await createSessionFocusItem(slug, {
        setting_id: r.id,
      });
      // Reconcile: swap the provisional row for the server-created one.
      setSessionFocus(prev => prev.map(i => (i._tempId === tempId ? created : i)));
    } catch (err) {
      // Roll back the provisional row, then preserve the existing 409 handling.
      setSessionFocus(prev => prev.filter(i => i._tempId !== tempId));
      const code = err.body && err.body.error;
      if (err.status === 409 && code === "queue_full") {
        setSessionFocusBanner({ kind: "queue_full", text: `Session focus is at capacity (${MAX_QUEUE}/${MAX_QUEUE}). Complete or remove items to add more.` });
      } else if (err.status === 409 && code === "duplicate_setting") {
        // Race condition \u2014 UI already shows it. Refresh silently from server.
        try { const fresh = await fetchSessionFocus(slug); setSessionFocus(fresh); } catch { /* ignore */ }
      } else {
        setSessionFocusBanner({ kind: "error", text: "Could not add to session focus. Please try again." });
      }
    } finally {
      setPendingQueue(prev => { const next = new Set(prev); next.delete(r.id); return next; });
    }
  }, [slug, queueCount, queueIds, pendingQueue, currentUser]);

  // Removes by setting_id (the recs table calls with rec.id). Looks up the
  // matching active item to get its Dataverse row id, then DELETEs.
  const handleRemoveFromQueue = useCallback(async (settingId) => {
    if (!slug) return;
    const target = sessionFocus.find(i => i.setting_id === settingId && i.status === "Active");
    if (!target) return;
    // Optimistic update \u2014 drop locally first, revert if the call fails.
    const snapshot = sessionFocus;
    setSessionFocus(prev => prev.filter(i => i.id !== target.id));
    try {
      await deleteSessionFocusItem(slug, target.id);
    } catch {
      setSessionFocus(snapshot);
      setSessionFocusBanner({ kind: "error", text: "Could not remove item. Please try again." });
    }
  }, [slug, sessionFocus]);

  // Removes by Dataverse item id (queue UI calls with item.id directly).
  const handleRemoveSessionFocusItem = useCallback(async (itemId) => {
    if (!slug) return;
    const snapshot = sessionFocus;
    setSessionFocus(prev => prev.filter(i => i.id !== itemId));
    try {
      await deleteSessionFocusItem(slug, itemId);
    } catch {
      setSessionFocus(snapshot);
      setSessionFocusBanner({ kind: "error", text: "Could not remove item. Please try again." });
    }
  }, [slug, sessionFocus]);

  // Generic per-field PATCH (session_type, status, etc.). Optimistic with revert.
  const handleUpdateSessionFocusItem = useCallback(async (itemId, fields) => {
    if (!slug) return;
    const snapshot = sessionFocus;
    setSessionFocus(prev => prev.map(i => i.id === itemId ? { ...i, ...fields } : i));
    try {
      const updated = await updateSessionFocusItem(slug, itemId, fields);
      setSessionFocus(prev => prev.map(i => i.id === itemId ? updated : i));
    } catch {
      setSessionFocus(snapshot);
      setSessionFocusBanner({ kind: "error", text: "Could not save change. Please try again." });
    }
  }, [slug, sessionFocus]);

  const handleReorderSessionFocus = useCallback(async (newOrderedIds) => {
    if (!slug || !Array.isArray(newOrderedIds) || newOrderedIds.length === 0) return;
    const snapshot = sessionFocus;
    // Optimistic local reorder \u2014 re-arrange by id.
    setSessionFocus(prev => {
      const byId = new Map(prev.map(i => [i.id, i]));
      const reordered = newOrderedIds.map((id, idx) => {
        const item = byId.get(id);
        return item ? { ...item, order_index: idx } : null;
      }).filter(Boolean);
      // Items the caller didn't include keep their previous position appended.
      const omitted = prev.filter(i => !newOrderedIds.includes(i.id));
      return [...reordered, ...omitted];
    });
    try {
      const updated = await reorderSessionFocus(slug, newOrderedIds);
      if (Array.isArray(updated)) setSessionFocus(updated);
    } catch {
      setSessionFocus(snapshot);
      setSessionFocusBanner({ kind: "error", text: "Could not reorder items. Please try again." });
    }
  }, [slug, sessionFocus]);

  // PR 2a — Mark a setting as reviewed today. Soft-deduplicates same-day
  // reviews by the same user: caller can show a confirm modal and re-call
  // with force=true. Returns the created record, or { needsConfirm, existingDate }.
  const handleMarkReviewed = useCallback(async (settingId, force = false) => {
    if (!slug || !settingId) return null;
    const email = (user?.email || "").toLowerCase();
    // Local date (not toISOString/UTC) — single source of truth for the stamp
    // and the same-day dedup check below.
    const localDate = localDateString();
    if (!force && email) {
      const existing = (reviewsBySettingId.get(settingId) || []).find(r => {
        const rEmail = (r.reviewed_by_email || "").toLowerCase();
        const rDate = (r.reviewed_on || "").slice(0, 10);
        return rEmail === email && rDate === localDate;
      });
      if (existing) {
        return { needsConfirm: true, existingDate: existing.reviewed_on.slice(0, 10) };
      }
    }
    // In-flight guard — re-entrancy for the same setting (the disabled button
    // covers the same window). Runs after the same-day-confirm check so the
    // confirm flow's forced second call is never blocked.
    if (pendingReview.has(settingId)) return null;
    setPendingReview(prev => new Set(prev).add(settingId));
    // Optimistic provisional review. Shape mirrors what isReviewedToday and the
    // last-reviewed displays read: reviewed_by_email + reviewed_on (local
    // YYYY-MM-DD, same string the same-day dedup slices, so the button flips to
    // reviewed-today instantly and correctly across the local-midnight boundary)
    // + reviewed_by_type. Replaced by the server row on success, removed on
    // failure — matched by _tempId.
    const tempId = nextTempId();
    const provisional = {
      id: tempId,
      _tempId: tempId,
      setting_id: settingId,
      reviewed_by_email: email,
      reviewed_on: localDate,
      reviewed_by_type: user?.isInternal ? "Patriot" : "Customer",
    };
    setReviews(prev => [...prev, provisional]);
    setReviewBanner(null);
    try {
      const created = await createReview(slug, settingId, localDate);
      // Reconcile: swap the provisional row for the server-created one.
      setReviews(prev => prev.map(r => (r._tempId === tempId ? created : r)));
      return created;
    } catch (err) {
      // Roll back the provisional row, then surface the error banner.
      setReviews(prev => prev.filter(r => r._tempId !== tempId));
      setReviewBanner({ kind: "error", text: err.message || "Could not mark setting reviewed. Please try again." });
      return null;
    } finally {
      setPendingReview(prev => { const next = new Set(prev); next.delete(settingId); return next; });
    }
  }, [slug, user, reviewsBySettingId, pendingReview]);

  const handleDeleteReview = useCallback(async (reviewId) => {
    if (!slug || !reviewId) return;
    const snapshot = reviews;
    setReviews(prev => prev.filter(r => r.id !== reviewId));
    try {
      await deleteReview(slug, reviewId);
    } catch (err) {
      setReviews(snapshot);
      setReviewBanner({ kind: "error", text: err.message || "Could not undo review. Please try again." });
    }
  }, [slug, reviews]);

  const handleQueueItemClick = useCallback((item) => {
    const rec = recs.find(r => r.id === item.setting_id);
    if (!rec) {
      // Setting was retired or isn't in the current report \u2014 surface gently.
      setSessionFocusBanner({ kind: "error", text: `Setting #${item.setting_id} \u2014 details unavailable.` });
      return;
    }
    // Build the session nav list in displayed drag/drop order (active items, by
    // order_index ascending \u2014 same pattern as the SessionFocusCard/QueuePage views),
    // mapping each session item (keyed by setting_id) to its recs object (keyed by id)
    // so the flyout's findIndex(r => r.id === ...) works. Drop unresolvable items.
    const orderedSessionRecs = (sessionFocus || [])
      .filter(i => i.status === "Active")
      .sort((a, b) => (a.order_index || 0) - (b.order_index || 0))
      .map(i => recs.find(r => r.id === i.setting_id))
      .filter(Boolean);
    setPanelRec(rec);
    setPanelList(orderedSessionRecs.length > 0 ? orderedSessionRecs : null);
  }, [recs, sessionFocus]);

  const navToSetting = (id) => {
    setRemediatedSelection(null);
    setPage("recs");
    setRecFilter("all");
    setRecCatFilter(null);
    setRecCategoryFilter(null);
    setRecHighlightId(id);
  };

  // Patriot user with no customer selected: the shell mounts slug-less so the
  // Admin page stays reachable. The Azure nav entry waits for a customer;
  // direct Azure routes keep their established behavior. Never true
  // for customer users — their slug comes from /api/me, and a failed /me keeps
  // its existing behavior (isInternal is false on that path).
  const patriotNoCustomer = !!user?.isInternal && !slug;
  const { trackAction: trackProductAnalyticsAction } = useProductAnalytics({
    audience: user?.isInternal === true ? "staff" : user?.isInternal === false ? "customer" : null,
    section: patriotNoCustomer && CUSTOMER_SCOPED_PAGES.has(page) ? "customer_selection" : page,
  });

  // Plain page navigation (nav-menu controls only). Entering Recs this way starts
  // with a clean filter slate — otherwise a stale filter from a prior bar-click
  // leaks back in on remount. navToRecs/navToSetting deliberately do NOT route
  // through here: they set their filters explicitly and must keep doing so.
  const navToPage = (id) => {
    // Customer-scoped pages are inert until a customer is selected (their
    // buttons render disabled; this guard also covers any other caller).
    if (patriotNoCustomer && CUSTOMER_SCOPED_PAGES.has(id)) return;
    setRemediatedSelection(null);
    if (id === "recs") {
      setRecFilter("all");
      setRecCatFilter(null);
      setRecCategoryFilter(null);
      setRecOverrideFilter(null);
      setRecHighlightId(null);
    }
    setPage(id);
  };

  // Support & Hours is GA (2026-07-03): every authenticated customer sees
  // it. Internal users see it EVEN IN delivery mode — live on-behalf ticket
  // filing during customer presentations is a supported workflow
  // (OnBehalfPicker is already wired in both ticket modals). The only hidden
  // case is a customer in delivery mode, which shouldn't occur and fails
  // safe. Kept as a named flag for future re-gating. Azure SecureAudit and
  // Admin remain internal-only.
  const canSeeSupport = user?.isInternal || !deliveryMode;
  const showAzureNav = !!user?.isInternal && !deliveryMode && !!slug && page !== "admin";

  const PAGES = [
    { id:"overview", label:"Overview" },
    { id:"queue", label:`Next Session Focus (${queueCount}/${MAX_QUEUE})` },
    { id:"recs", label:"Recommendations" },
    { id:"licensing", label:"Licensing", badge: cspOpportunity.eligibility === "eligible" && !cspOpportunity.hidden && cspOpportunity.topics.length > 0 ? cspOpportunity.topics.length : 0 },
    { id:"profile", label:"Company Profile" },
    // Azure SecureAudit is for internal users with a customer context outside Admin.
    ...(showAzureNav ? [{ id:"azure", label:"Azure SecureAudit" }] : []),
    ...(canSeeSupport ? [{ id:"support", label:"Support & Hours" }] : []),
    ...(user?.isInternal && !deliveryMode ? [{ id:"admin", label:"Admin" }] : []),
  ].map(p => ({
    ...p,
    // Disabled (not hidden): a two-item nav reads as broken, and the disabled
    // state tells Patriot users that picking a customer unlocks the rest.
    disabled: patriotNoCustomer && CUSTOMER_SCOPED_PAGES.has(p.id),
  }));

  // Portal-facing name (issue #10): the Dataverse override
  // (pc_portaldisplayname) wins over the canonical pc_name that arrives via
  // customerName/report. Admin/ops surfaces and Freshservice ticket payloads
  // keep the canonical name — only customer-visible chrome uses this.
  const portalName = clientInfo?.pc_portaldisplayname || customerName;
  const displayName = portalName || report?.customer_name || "Client";

  return (
    // minHeight accounts for PortalShell's 52px in-flow header (same
    // convention as PlaceholderDashboard/DashboardLoading) — a bare 100vh
    // here made the document 100vh+52px tall, so a window-edge scrollbar
    // doubled up with <main>'s own scrollbar on every page.
    <div style={{ fontFamily:"'DM Sans',system-ui,sans-serif", color:T.text, minHeight:"calc(100vh - 52px)", display:"grid", gridTemplateColumns:"1fr" }}>
      <style>{`@import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700;800&display=swap');*{box-sizing:border-box;margin:0;padding:0}body{background:linear-gradient(180deg,#08182e,#0b1f3a)}`}</style>

      {/* ── ICON RAIL (collapsed sidebar) ── */}
      {!sidebarOpen && (
        <nav style={{
          position:"fixed", top:0, left:0, width:60, height:"100vh",
          background:"#071426", borderRight:`1px solid ${T.border}`,
          display:"flex", flexDirection:"column", alignItems:"center",
          padding:"12px 0", zIndex:1000, overflow:"visible",
        }}>
          {/* Logo */}
          <div style={{ width:40, height:40, marginBottom:8, display:"flex", alignItems:"center", justifyContent:"center" }}>
            <img src="/patriot-logo.png" alt="Patriot" style={{ width:36, height:36, objectFit:"contain" }} onError={e => { e.target.style.display = "none"; }} />
          </div>
          {/* Expand button */}
          <button
            onClick={() => setSidebarOpen(true)}
            aria-label="Expand navigation"
            style={{
              width:36, height:36, borderRadius:"50%", background:T.panel,
              border:`1px solid ${T.border}`, color:T.text, fontSize:16,
              cursor:"pointer", display:"flex", alignItems:"center", justifyContent:"center",
              marginBottom:12, flexShrink:0,
            }}
          >
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6" /></svg>
          </button>
          {/* Nav icons */}
          <div style={{ display:"flex", flexDirection:"column", gap:8, flex:1 }}>
            {[
              { id:"overview", label:"Overview", icon:<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="7" height="7" rx="1.5"/><rect x="14" y="3" width="7" height="7" rx="1.5"/><rect x="3" y="14" width="7" height="7" rx="1.5"/><rect x="14" y="14" width="7" height="7" rx="1.5"/></svg> },
              { id:"queue", label:`Next Session Focus (${queueCount}/${MAX_QUEUE})`, badge: queueCount, icon:<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><circle cx="12" cy="12" r="6"/><circle cx="12" cy="12" r="2"/></svg> },
              { id:"recs", label:"Recommendations", icon:<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="5" y="2" width="14" height="20" rx="2"/><line x1="9" y1="8" x2="15" y2="8"/><line x1="9" y1="12" x2="15" y2="12"/><line x1="9" y1="16" x2="13" y2="16"/></svg> },
              /* Certificate/award glyph on purpose — a key would collide
                 with Access's idea in this nav, a document with recs. */
              { id:"licensing", label:"Licensing", badge: cspOpportunity.eligibility === "eligible" && !cspOpportunity.hidden && cspOpportunity.topics.length > 0 ? cspOpportunity.topics.length : 0, icon:<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="8" r="6"/><path d="M15.477 12.89 17 22l-5-3-5 3 1.523-9.11"/></svg> },
              { id:"profile", label:"Company Profile", icon:<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg> },
              // Azure SecureAudit is for internal users with a customer context outside Admin.
              ...(showAzureNav ? [
                { id:"azure", label:"Azure SecureAudit", icon:<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 2l8 4.5v7c0 4.5-3.5 8.5-8 10-4.5-1.5-8-5.5-8-10v-7L12 2z"/></svg> },
              ] : []),
              // Support & Hours: admin + allowlisted test account (see canSeeSupport).
              ...(canSeeSupport ? [
                { id:"support", label:"Support & Hours", icon:<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"/></svg> },
              ] : []),
              ...(user?.isInternal && !deliveryMode ? [{ id:"admin", label:"Admin", icon:<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 2l8 4.5v7c0 4.5-3.5 8.5-8 10-4.5-1.5-8-5.5-8-10v-7L12 2z"/><polyline points="9 12 11 14 15 10"/></svg> }] : []),
            ].map(({ id, label, icon, badge }) => {
              const isActive = page === id;
              const isDisabled = patriotNoCustomer && CUSTOMER_SCOPED_PAGES.has(id);
              return (
                <div
                  key={id}
                  style={{ position:"relative" }}
                  onMouseEnter={() => showTooltip(id)}
                  onMouseLeave={hideTooltip}
                >
                  <button
                    onClick={() => navToPage(id)}
                    aria-label={label}
                    aria-disabled={isDisabled || undefined}
                    disabled={isDisabled}
                    style={{
                      width:44, height:44, borderRadius:12, border: isActive ? "1px solid rgba(68,166,255,0.4)" : "1px solid transparent",
                      background: isActive ? "rgba(68,166,255,0.15)" : "transparent",
                      color: isActive ? T.blue : T.muted, cursor: isDisabled ? "not-allowed" : "pointer",
                      opacity: isDisabled ? 0.4 : 1,
                      display:"flex", alignItems:"center", justifyContent:"center",
                      transition:"background 0.15s, border-color 0.15s",
                    }}
                    onMouseEnter={e => { if (!isActive && !isDisabled) e.currentTarget.style.background = "rgba(255,255,255,0.06)"; }}
                    onMouseLeave={e => { if (!isActive) e.currentTarget.style.background = "transparent"; }}
                  >{icon}</button>
                  {/* Session count badge */}
                  {badge > 0 && (
                    <span style={{
                      position:"absolute", top:-2, right:-2, minWidth:16, height:16,
                      borderRadius:8, background:"#53c46d", color:"#fff",
                      fontSize:9, fontWeight:800, display:"flex", alignItems:"center", justifyContent:"center",
                      padding:"0 4px", lineHeight:1, pointerEvents:"none",
                    }}>{badge}</span>
                  )}
                  {/* Tooltip */}
                  {tooltip === id && (
                    <div style={{
                      position:"absolute", left:64, top:"50%", transform:"translateY(-50%)",
                      background:"#0e2746", color:"#edf4ff", fontSize:12, fontWeight:600,
                      padding:"6px 12px", borderRadius:8, whiteSpace:"nowrap", zIndex:1001,
                      border:"1px solid rgba(255,255,255,0.12)",
                      boxShadow:"0 4px 12px rgba(0,0,0,0.3)", pointerEvents:"none",
                    }}>
                      {/* Left arrow */}
                      <div style={{
                        position:"absolute", left:-6, top:"50%", transform:"translateY(-50%)",
                        width:0, height:0,
                        borderTop:"6px solid transparent", borderBottom:"6px solid transparent",
                        borderRight:"6px solid #0e2746",
                      }}/>
                      {label}{isDisabled ? " — select a customer" : ""}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
          {/* Footer */}
          <div style={{ fontSize:8, color:T.muted, textAlign:"center", lineHeight:1.3, padding:"8px 4px 0", flexShrink:0, opacity:0.6 }}>
            SS365
          </div>
        </nav>
      )}

      {/* ── EXPANDED SIDEBAR ── */}
      <aside style={{
        background:"rgba(7,20,38,0.96)", borderRight:`1px solid ${T.border}`, padding:"22px 16px",
        position:"fixed", top:0, left:0, height:"100vh", width:260, backdropFilter:"blur(14px)",
        display:"flex", flexDirection:"column", overflowY:"auto",
        transform: sidebarOpen ? "translateX(0)" : "translateX(-100%)",
        transition:"transform 0.3s ease",
        zIndex:1000,
      }}>
        {/* Collapse button + branding */}
        <div style={{ display:"flex", alignItems:"center", gap:10, marginBottom:22 }}>
          <button
            onClick={() => setSidebarOpen(false)}
            aria-label="Collapse navigation"
            style={{
              width:32, height:32, borderRadius:"50%", background:T.panel,
              border:`1px solid ${T.border}`, color:T.text, fontSize:14,
              cursor:"pointer", display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0,
            }}
          >
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 18 9 12 15 6" /></svg>
          </button>
          <div style={{ fontSize:22, fontWeight:800, letterSpacing:.3 }}>Secure<span style={{ color:T.blue }}>Shield</span> 365</div>
        </div>
        <div style={{ background:`linear-gradient(180deg,${T.panel},#0e2746)`, border:`1px solid ${T.border}`, borderRadius:18, padding:16, boxShadow:"0 18px 40px rgba(0,0,0,0.28)", marginBottom:18 }}>
          <div style={{ color:T.muted, fontSize:11, textTransform:"uppercase", letterSpacing:".08em" }}>Client</div>
          <div style={{ fontSize:18, fontWeight:700, marginTop:6 }}>{portalName || (patriotNoCustomer ? "No customer selected" : "Client Dashboard")}</div>
        </div>
        <div style={{ color:T.muted, fontSize:11, textTransform:"uppercase", letterSpacing:".08em", marginBottom:6 }}>Pages</div>
        <div style={{ display:"grid", gap:8 }}>
          {PAGES.map(({ id, label, disabled, badge }) => (
            <button key={id} disabled={disabled} aria-disabled={disabled || undefined}
              title={disabled ? "Select a customer to open this page" : undefined}
              onClick={() => { if (disabled) return; navToPage(id); setSidebarOpen(false); }} style={{
              width:"100%", textAlign:"left", padding:"12px 14px", color:T.text,
              background: page === id ? "linear-gradient(180deg,rgba(68,166,255,0.18),rgba(68,166,255,0.08))" : "transparent",
              border: `1px solid ${page === id ? "rgba(68,166,255,0.45)" : T.border}`,
              borderRadius:12, cursor: disabled ? "not-allowed" : "pointer", opacity: disabled ? 0.4 : 1,
              fontSize:14, fontFamily:"inherit", transition:".2s",
            }}>{label}{badge > 0 ? ` (${badge})` : ""}</button>
          ))}
        </div>
      </aside>

      {/* ── MAIN ── */}
      <main style={{ paddingLeft:84, paddingRight:24, paddingBottom:24, overflowY:"auto", overflowX:"hidden", maxWidth:"100vw", background:"linear-gradient(180deg,#08182e,#0b1f3a)", height:"calc(100vh - 52px)" }}>
        {/* Sidebar overlay — inside main so it doesn't affect grid child count */}
        {sidebarOpen && (
          <div
            onClick={() => setSidebarOpen(false)}
            aria-hidden="true"
            style={{ position:"fixed", top:0, left:0, width:"100vw", height:"100vh", background:"rgba(0,0,0,0.5)", zIndex:999, cursor:"pointer" }}
          />
        )}
        {/* Held-scan review banner — hidden on the Admin page AND in delivery mode
            (don't show review/publish chrome while screen-sharing with a client). */}
        {page !== "admin" && !deliveryMode && (
          <PendingReviewBanner
            slug={slug}
            isPatriot={!!user?.isInternal}
            previewPending={previewPending}
            refreshKey={pendingRefreshKey}
            onPreview={(pendingId) => setPreviewPending(v => (v === pendingId ? null : pendingId))}
            onPublished={() => { setPreviewPending(null); setCurrentScanId(null); setPendingRefreshKey(k => k + 1); }}
            onRejected={() => { setPreviewPending(null); setPendingRefreshKey(k => k + 1); }}
          />
        )}
        {/* The customer's half of the same fact. Mutually exclusive with
            the Patriot banner above (isInternal), and suppressed in
            delivery mode for the same reason: no review chrome while
            screen-sharing. */}
        {page !== "admin" && !deliveryMode && (
          <CustomerPendingBanner slug={slug} show={!user?.isInternal} />
        )}
        {/* Customer header (name/score/scan picker/exports) — hidden on the
            cross-client Admin page and when no customer is selected (nothing
            in it is meaningful, and ScanLifecycleControls renders for Patriot
            users regardless of data). */}
        {page !== "admin" && !patriotNoCustomer && (
        <div ref={dashboardHeaderRef} style={{ display:"flex", justifyContent:"space-between", alignItems:"center", gap:12, flexWrap:"wrap", position:"sticky", top:0, zIndex:50, background:"#08182e", paddingTop:12, paddingBottom:10, marginBottom:4 }}>
          {/* ── Identity zone: customer logo · name ── */}
          <div style={{ display:"flex", alignItems:"center", gap:12, minWidth:0 }}>
            <CustomerLogo slug={slug} customerName={displayName} logoData={clientInfo?.pc_customerlogo} T={T} size={36} />
            <div title={displayName} style={{ fontSize:16, fontWeight:700, color:T.text, maxWidth:360, minWidth:0, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap", flexShrink:1 }}>{displayName}</div>
          </div>
          {/* ── Controls zone: score/change pills (non-overview) · consolidated scan picker ── */}
          <div style={{ display:"flex", alignItems:"center", gap:6, flexWrap:"wrap", justifyContent:"flex-end" }}>
            {page !== "overview" && (
              !report ? (
                <>
                  <Skeleton width={90} height={26} borderRadius={999} />
                  <Skeleton width={110} height={26} borderRadius={999} />
                </>
              ) : (
                <>
                  <div style={{ padding:"6px 12px", borderRadius:999, border:`1px solid ${T.border}`, background:"rgba(255,255,255,0.04)", fontSize:12, fontWeight:600 }}>Score: <strong>{d.score}%</strong></div>
                  <div style={{ padding:"6px 12px", borderRadius:999, border:`1px solid ${T.border}`, background:"rgba(255,255,255,0.04)", fontSize:12, fontWeight:600 }}>Change: <strong>{!prev ? "baseline" : d.score === prev.score ? "no change" : `${d.score > prev.score ? "+" : ""}${Math.round((d.score - prev.score) * 10) / 10}%`}</strong></div>
                </>
              )
            )}
            {/* ── Scan-status group: Last full scan picker ── */}
            {/* Consolidated past-scans picker — also serves as the "Last full scan" date indicator */}
            <PastScansDropdown
              scans={scans}
              currentScanId={currentScanId}
              onPickScan={setCurrentScanId}
              T={T}
              method={report?.collection_method}
            />
            {(
              <ScanLifecycleControls
                slug={slug}
                scans={scans}
                currentScanId={currentScanId}
                publishedScoredAt={publishedScoredAt}
                pendingReport={previewPending ? report : null}
                adjustedScore={categoryData?.adj}
                isPatriot={!!user?.isInternal}
                deliveryMode={deliveryMode}
                T={T}
                onChanged={() => {
                  setPreviewPending(null);
                  setCurrentScanId(null);
                  setPendingRefreshKey(key => key + 1);
                  setArchivedRefreshKey(key => key + 1);
                }}
              />
            )}
            {/* Divider — only when the scan-status group has content (avoids a stray
                divider when a customer has no scans, since the picker returns null). */}
            {scans && scans.length > 0 && (
              <span style={{ width:1, height:20, background:T.border, alignSelf:"center", margin:"0 4px" }} />
            )}
            {/* ── Report-action group: Download report · Export findings ── */}
            <DownloadReportButton
              customerName={displayName}
              slug={slug}
              report={report}
              scans={scans}
              settingDetails={settingDetails}
              composition={categoryData}
              T={T}
              onProductAnalyticsAction={trackProductAnalyticsAction}
            />
            <ExportFindingsButton
              customerName={displayName}
              slug={slug}
              report={report}
              scans={scans}
              settingDetails={settingDetails}
              T={T}
              onProductAnalyticsAction={trackProductAnalyticsAction}
            />
          </div>
        </div>
        )}

        {page !== "admin" && !previewPending && !patriotNoCustomer && (
          <ArchivedScansSection
            slug={slug}
            isPatriot={!!user?.isInternal}
            deliveryMode={deliveryMode}
            refreshKey={archivedRefreshKey}
            T={T}
            onRestored={() => setPendingRefreshKey(key => key + 1)}
          />
        )}

        {/* No customer selected (Patriot): customer-scoped pages give way to
            the select-a-customer prompt; Admin and Azure page rendering stay
            unchanged while the Azure nav entry remains hidden. */}
        {patriotNoCustomer && page !== "admin" && page !== "azure" && <SelectCustomerPrompt />}
        {/* Keep the established review reminder ahead of the CSP prompt while
            preserving OverviewPage's exact settled empty-state exclusions. */}
        {page === "overview" && !patriotNoCustomer && !(
          (!reportLoading && reportError === "roster_inactive") ||
          (!reportLoading && reportError === "no_data") ||
          (!reportLoading && !reportError && !report)
        ) && <ReviewCadenceBanner slug={slug} onNavProfile={() => setPage("profile")} />}
        {page === "overview" && !patriotNoCustomer && <CspOverviewPrompt opportunity={cspOpportunity} onExplore={() => setPage("licensing")} />}
        {page === "overview" && !!user && slug && !deliveryMode && (
          <AutoRenewOffer key={`${slug}:${!!user.isInternal}`} slug={slug} isInternal={!!user.isInternal} />
        )}
        {page === "overview" && !patriotNoCustomer && <OverviewPage
          q={q}
          slug={slug}
          onNavRecs={navToRecs}
          onNavRemediated={navToRemediated}
          onNavPair={navToPair}
          pairMode={pairMode}
          setPairMode={setPairMode}
          pairScanId={pairScanId}
          setPairScanId={setPairScanId}
          onNavSetting={navToSetting}
          recs={recs}
          settingDetails={settingDetails}
          categoryData={categoryData}
          report={report}
          sessionFocus={sessionFocus}
          sessionFocusLoading={sessionFocusLoading}
          reviewsBySettingId={reviewsBySettingId}
          nextAuditDate={clientInfo?.next_audit_date}
          canSeeSupport={canSeeSupport}
          onNavSupport={() => setPage("support")}
          onNavQueue={() => setPage("queue")}
          onItemClick={handleQueueItemClick}
          reportLoading={reportLoading}
          reportError={reportError}
          noDataScanState={noDataScanState}
          onNavProfile={() => setPage("profile")}
          scans={scans}
          scansPayload={scansPayload}
          currentScanId={currentScanId}
          previewPending={previewPending}
          setCurrentScanId={(next) => { setRemediatedSelection(null); setCurrentScanId(next); }}
        />}
        {page === "queue" && !patriotNoCustomer && <QueuePage
          sessionFocus={sessionFocus}
          sessionFocusLoading={sessionFocusLoading}
          reportLoading={reportLoading}
          reportError={reportError}
          noDataScanState={noDataScanState}
          onNavProfile={() => setPage("profile")}
          recs={recs}
          settingDetails={settingDetails}
          notesBySettingId={notesBySettingId}
          reviewsBySettingId={reviewsBySettingId}
          onMarkReviewed={handleMarkReviewed}
          pendingReview={pendingReview}
          currentUserEmail={user?.email || ""}
          onAddToQueue={handleAddToQueue}
          onItemClick={handleQueueItemClick}
          onRemove={handleRemoveSessionFocusItem}
          onUpdate={handleUpdateSessionFocusItem}
          onReorder={handleReorderSessionFocus}
          error={sessionFocusError}
          banner={sessionFocusBanner}
          onDismissBanner={() => setSessionFocusBanner(null)}
          isPatriot={!!user?.isInternal}
        />}
        {/* Benchmarks tab unhooked from nav (panel deferred); BenchmarksPage component left dormant. */}
        {page === "recs" && user?.isInternal && !patriotNoCustomer && (
          <CompensatingControlPackages
            slug={slug}
            isPatriot={!!user?.isInternal}
            onChanged={reloadReportOverrides}
          />
        )}
        {page === "recs" && !patriotNoCustomer && <RecsPage
          key={`recs-${remediatedLandingKey}`}
          reportLoading={reportLoading}
          reportError={reportError}
          noDataScanState={noDataScanState}
          onNavProfile={() => setPage("profile")}
          filter={recFilter} catFilter={recCatFilter} categoryFilter={recCategoryFilter} overrideFilter={recOverrideFilter} regressedFilter={recRegressedFilter}
          exactSelection={activeRemediatedSelection}
          onExactSelectionChange={setRemediatedSelection}
          dashboardHeaderHeight={dashboardHeaderHeight}
          onFilterChange={setRecFilter} onCatFilterChange={setRecCatFilter} onCategoryFilterChange={setRecCategoryFilter} onOverrideFilterChange={setRecOverrideFilter} onRegressedFilterChange={setRecRegressedFilter}
          highlightId={recHighlightId} onSupport={setSupRecs}
          bulkIntent={recBulkIntent} onBulkIntentConsumed={() => setRecBulkIntent(false)}
          onOpenPanel={(rec, list) => { setPanelRec(rec); setPanelList(list || null); }}
          settingDetails={settingDetails} onSavePanel={handleSaveSettingDetail}
          onAddToQueue={handleAddToQueue} onRemoveFromQueue={handleRemoveFromQueue}
          queueIds={queueIds} queueCount={queueCount}
          onNavQueue={() => setPage("queue")}
          recs={recs} notesBySettingId={notesBySettingId}
          sessionFocus={sessionFocus}
          sessionFocusError={sessionFocusError}
          sessionFocusBanner={sessionFocusBanner}
          onDismissSessionFocusBanner={() => setSessionFocusBanner(null)}
          sessionFocusPanelState={sessionFocusPanelState}
          onSessionFocusPanelStateChange={setSessionFocusPanelState}
          onSessionFocusItemClick={handleQueueItemClick}
          onRemoveSessionFocusItem={handleRemoveSessionFocusItem}
          onUpdateSessionFocusItem={handleUpdateSessionFocusItem}
          onReorderSessionFocus={handleReorderSessionFocus}
          reviewsBySettingId={reviewsBySettingId}
          onMarkReviewed={handleMarkReviewed}
          pendingReview={pendingReview}
          pendingQueue={pendingQueue}
          reviewBanner={reviewBanner}
          onDismissReviewBanner={() => setReviewBanner(null)}
          currentUserEmail={user?.email || ""}
          isPatriot={!!user?.isInternal}
          slug={slug}
          clientName={clientInfo?.pc_name || customerName}
          deliveryMode={deliveryMode}
        />}
        {page === "licensing" && !patriotNoCustomer && <LicensingPage slug={slug} onNavProfile={() => setPage("profile")} cspOpportunity={cspOpportunity} />}
        {page === "profile" && !patriotNoCustomer && <CompanyProfilePage slug={slug} portalDomains={clientInfo?.pc_portaldomains} clientName={clientInfo?.pc_name} deliveryMode={deliveryMode} customerManagerName={clientInfo?.customer_manager_name} customerManagerEmail={clientInfo?.customer_manager_email} onNavSupport={canSeeSupport ? () => setPage("support") : undefined} onProductAnalyticsAction={trackProductAnalyticsAction} />}
        {page === "azure" && user?.isInternal && !deliveryMode && <AzurePage />}
        {page === "support" && canSeeSupport && !patriotNoCustomer && <SupportPage slug={slug} currentUserEmail={user?.email || ""} onSettingsHelp={() => { setPage("recs"); setRecBulkIntent(true); }} onProductAnalyticsAction={trackProductAnalyticsAction} />}
        {page === "admin" && user?.isInternal && !deliveryMode && <AdminPage initialTab={adminTabFromHash()} initialView={adminViewFromHash()} />}
      </main>

      {/* ── SETTING DETAIL PANEL ── */}
      {panelRec && (() => {
        // Prev/next walks the panelList (filtered view at moment of open), falling
        // back to the full recs list if no panelList was provided (e.g., deep-link
        // open via ?recommendation=N where there's no parent filter context).
        const navList = panelList && panelList.length > 0 ? panelList : recs;
        const idx = navList.findIndex(r => r.id === panelRec.id);
        const closeDrawer = () => { setPanelRec(null); setPanelList(null); };
        return (
          <SettingDetailPanel
            rec={panelRec}
            onClose={closeDrawer}
            settingData={settingDetails[panelRec.id]}
            onSave={handleSaveSettingDetail}
            onAddToQueue={handleAddToQueue}
            queueIds={queueIds}
            queueCount={queueCount}
            onRemoveFromQueue={handleRemoveFromQueue}
            onMarkReviewed={handleMarkReviewed}
            onSupport={(r) => setSupRecs([r])}
            onPrev={() => idx > 0 && setPanelRec(navList[idx - 1])}
            onNext={() => idx >= 0 && idx < navList.length - 1 && setPanelRec(navList[idx + 1])}
            hasPrev={idx > 0}
            hasNext={idx >= 0 && idx < navList.length - 1}
            currentUser={currentUser}
            isPatriot={!!user?.isInternal}
            notes={notesBySettingId.get(panelRec.id) || []}
            slug={slug}
            onAddNote={handleAddNote}
            onUpdateNote={handleUpdateNote}
            onDeleteNote={handleDeleteNote}
            reviews={reviewsBySettingId.get(panelRec.id) || []}
            onDeleteReview={handleDeleteReview}
            currentUserEmail={user?.email || ""}
            markReviewPending={pendingReview.has(panelRec.id)}
            queuePending={pendingQueue.has(panelRec.id)}
          />
        );
      })()}

      {/* ── TICKET MODAL ── */}
      <Modal
        show={!!supRecs}
        title={isBulkTicket ? `Support Ticket — ${supRecsList.length} items` : supRecsList.length === 1 ? `Support Ticket — Setting #${supRecsList[0].id}` : "Support Ticket"}
        onClose={closeTicketModal}
        onSubmit={ticketStatus && (ticketStatus.id || ticketStatus.bulk) ? closeTicketModal : handleSubmitTicket}
        submitLabel={ticketStatus === "loading" ? "Submitting..." : ticketStatus && (ticketStatus.id || ticketStatus.bulk) ? "Done" : "Submit ticket"}
      >
        {supRecsList.length > 0 && (
          <div>
            {!ticketStatus && (
              <div>
                {/* ── Single item header ── */}
                {!isBulkTicket && (
                  <div style={{ marginBottom:14, padding:12, background:"rgba(68,166,255,0.08)", borderRadius:10, border:`1px solid ${T.border}` }}>
                    <div style={{ fontSize:14, fontWeight:700, color:T.text }}>#{supRecsList[0].id} — {supRecsList[0].name}</div>
                    <div style={{ fontSize:11, color:T.muted, marginTop:4 }}>Subject: SS365: Setting #{supRecsList[0].id} — {supRecsList[0].name}</div>
                  </div>
                )}
                {/* ── Bulk: grouping preview (one ticket per PRODUCT) ── */}
                {isBulkTicket && (() => {
                  const groups = groupRecsByProduct(supRecsList);
                  return (
                    <div style={{ marginBottom:14 }}>
                      <div style={{ fontSize:12, color:T.muted, marginBottom:8 }}>
                        This will create <strong style={{ color:T.text }}>{groups.length}</strong> ticket{groups.length === 1 ? "" : "s"}, one per product:
                      </div>
                      <div style={{ maxHeight:240, overflowY:"auto", borderRadius:10, border:`1px solid ${T.border}`, background:"rgba(255,255,255,0.03)" }}>
                        {groups.map(([product, group]) => (
                          <div key={product} style={{ padding:"8px 12px", borderBottom:`1px solid ${T.border}` }}>
                            <div style={{ fontSize:13, fontWeight:700, color:T.text }}>{product} — {group.length} setting{group.length === 1 ? "" : "s"}</div>
                            <div style={{ fontSize:11, color:T.muted, marginTop:3 }}>
                              {group.map(sr => `#${sr.id}`).join(", ")}
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  );
                })()}
                {/* ── Notes textarea ── */}
                <div style={{ marginBottom:12 }}>
                  <label style={{ display:"block", fontSize:12, color:T.muted, marginBottom:6, fontWeight:600 }}>Additional notes (optional)</label>
                  <textarea
                    value={ticketNotes}
                    onChange={e => setTicketNotes(e.target.value)}
                    placeholder="Add any context or instructions for the Patriot team..."
                    rows={3}
                    style={{
                      width:"100%", background:"rgba(255,255,255,0.05)", border:`1px solid ${T.border}`,
                      borderRadius:8, color:T.text, fontSize:13, padding:"10px 12px", resize:"vertical",
                      fontFamily:"inherit", outline:"none",
                    }}
                  />
                </div>
                {/* Internal-only: file the ticket(s) on behalf of a customer
                    contact — applies to every ticket this submit creates. */}
                {user?.isInternal && (
                  <OnBehalfPicker slug={slug} value={supOnBehalf} onChange={setSupOnBehalf} />
                )}
                <p style={{ color:T.muted, fontSize:11, marginTop:4 }}>
                  {isBulkTicket
                    ? "Each product group becomes its own ticket; its settings and severities are auto-included in the description."
                    : "Setting details, severity, and remediation guidance will be auto-included in the ticket."
                  } Your Patriot team will be notified.
                </p>
              </div>
            )}
            {ticketStatus === "loading" && (
              <div style={{ textAlign:"center", padding:20 }}>
                <div style={{ fontSize:14, color:T.blue }}>{isBulkTicket ? "Creating tickets, one per product..." : "Creating Freshservice ticket..."}</div>
              </div>
            )}
            {/* \u2500\u2500 Single-ticket success \u2500\u2500 */}
            {ticketStatus && ticketStatus.id && (
              <div style={{ textAlign:"center", padding:20 }}>
                <div style={{ fontSize:36, marginBottom:8 }}>{"\u2713"}</div>
                <div style={{ fontSize:16, fontWeight:700, color:T.green, marginBottom:8 }}>Ticket Created</div>
                <p style={{ fontSize:13, color:T.muted }}>Freshservice Ticket #{ticketStatus.id}</p>
                <p style={{ fontSize:11, color:T.muted, marginTop:6 }}>It may take a moment to appear in your ticket list.</p>
              </div>
            )}
            {/* \u2500\u2500 Bulk (per-product) result \u2014 REAL ids, fail-loud on partials \u2500\u2500 */}
            {ticketStatus && ticketStatus.bulk && (
              <div style={{ padding:"8px 4px" }}>
                {ticketStatus.created.length > 0 && (
                  <>
                    <div style={{ textAlign:"center", marginBottom:10 }}>
                      <div style={{ fontSize:30, marginBottom:4 }}>{"\u2713"}</div>
                      <div style={{ fontSize:16, fontWeight:700, color:T.green }}>
                        Created {ticketStatus.created.length} ticket{ticketStatus.created.length === 1 ? "" : "s"}
                      </div>
                    </div>
                    <div style={{ borderRadius:10, border:`1px solid ${T.border}`, background:"rgba(255,255,255,0.03)" }}>
                      {ticketStatus.created.map(c => (
                        <div key={c.product} style={{ padding:"8px 12px", borderBottom:`1px solid ${T.border}`, fontSize:13, color:T.text, display:"flex", justifyContent:"space-between", gap:10 }}>
                          <span>{c.product}</span>
                          <span style={{ color:T.blue, fontWeight:700 }}>#{c.ticket_id}</span>
                        </div>
                      ))}
                    </div>
                    <p style={{ fontSize:11, color:T.muted, textAlign:"center", marginTop:8 }}>New tickets may take a moment to appear in your ticket list.</p>
                  </>
                )}
                {ticketStatus.failed.length > 0 && (
                  <div style={{ marginTop:12, padding:10, background:"rgba(225,77,87,0.1)", borderRadius:10, border:"1px solid rgba(225,77,87,0.3)" }}>
                    <p style={{ color:T.red, fontSize:13, fontWeight:700 }}>
                      {ticketStatus.failed.length} product group{ticketStatus.failed.length === 1 ? "" : "s"} failed \u2014 NOT created:
                    </p>
                    <p style={{ color:T.red, fontSize:13, marginTop:4 }}>{ticketStatus.failed.join(", ")}</p>
                    <p style={{ color:T.muted, fontSize:11, marginTop:6 }}>Re-select those settings to retry, or contact your Patriot team directly.</p>
                  </div>
                )}
                {ticketStatus.created.length === 0 && ticketStatus.failed.length > 0 && (
                  <p style={{ color:T.muted, fontSize:11, textAlign:"center", marginTop:10 }}>No tickets were created.</p>
                )}
              </div>
            )}
            {ticketStatus && ticketStatus.error && (
              <div style={{ padding:10, background:"rgba(225,77,87,0.1)", borderRadius:10, border:"1px solid rgba(225,77,87,0.3)" }}>
                <p style={{ color:T.red, fontSize:13 }}>Failed to create ticket: {ticketStatus.error}</p>
                <p style={{ color:T.muted, fontSize:11, marginTop:6 }}>Please try again or contact your Patriot team directly.</p>
              </div>
            )}
          </div>
        )}
      </Modal>
    </div>
  );
}
